
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8b97"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8b97"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JYDX", function(module, exports) {
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});

});

parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});





var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return n(r, t, e, u, c);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return n(r, t, e, u, c, a);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return n(r, t, e, u, c, a, i);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, c) {
        return 5 === n.a ? n.f(r, t, e, u, c) : n(r)(t)(e)(u)(c);
    }
    function A6(n, r, t, e, u, c, a) {
        return 6 === n.a ? n.f(r, t, e, u, c, a) : n(r)(t)(e)(u)(c)(a);
    }
    function A7(n, r, t, e, u, c, a, i) {
        return 7 === n.a ? n.f(r, t, e, u, c, a, i) : n(r)(t)(e)(u)(c)(a)(i);
    }
    function t(n, r) {
        for(var t, u = [], c = e(n, r, 0, u); c && (t = u.pop()); c = e(t.a, t.b, 0, u));
        return c;
    }
    function e(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && y(5), !1;
        if (t > 100) return u.push(o(n, r)), !0;
        for(var c in 0 > n.$ && (n = Jr(n), r = Jr(r)), n)if (!e(n[c], r[c], t + 1, u)) return !1;
        return !0;
    }
    var u = F2(t), c = F2(function(n, r) {
        return !t(n, r);
    });
    function a(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = a(n.a, r.a)) || (t = a(n.b, r.b)) ? t : a(n.c, r.c);
        for(; n.b && r.b && !(t = a(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var i = F2(function(n, r) {
        var t = a(n, r);
        return 0 > t ? Kr : t ? qr : Rr;
    });
    function o(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function f(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function s(n) {
        return n;
    }
    function b(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = v(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = v(n.a, r);
        return t;
    }
    var l = {
        $: 0
    };
    function v(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(v);
    function g(n) {
        for(var r = l, t = n.length; t--;)r = v(n[t], r);
        return r;
    }
    function $(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var m = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return g(e);
    }), p = F2(function(n, r) {
        return g($(r).sort(function(r, t) {
            return a(n(r), n(t));
        }));
    }), w = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), _ = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, o(t, r);
    });
    function y(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var z = F2(function(n, r) {
        return n + r;
    }), M = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? y(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), k = Math.ceil, x = Math.floor, C = Math.round, H = Math.log, V = F2(function(n, r) {
        return n + r;
    }), A = F2(function(n, r) {
        return n + r;
    }), T = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], c = t.charCodeAt(e);
            56320 > c || c > 57343 || (u = t[--e] + u), r = A2(n, s(u), r);
        }
        return r;
    }), E = F2(function(n, r) {
        return r.split(n);
    }), O = F2(function(n, r) {
        return r.join(n);
    }), S = F3(function(n, r, t) {
        return t.slice(n, r);
    }), j = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(s(e))) return !1;
        }
        return !0;
    }), B = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), L = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), P = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return l;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return g(u);
    });
    function N(n) {
        return n + "";
    }
    function I(n) {
        return {
            $: 2,
            b: n
        };
    }
    var G = I(function(n) {
        return "number" != typeof n ? un("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? rt(n) : !isFinite(n) || n % 1 ? un("an INT", n) : rt(n);
    }), U = I(function(n) {
        return "boolean" == typeof n ? rt(n) : un("a BOOL", n);
    }), D = I(function(n) {
        return "number" == typeof n ? rt(n) : un("a FLOAT", n);
    }), F = I(function(n) {
        return rt(n);
    }), R = I(function(n) {
        return "string" == typeof n ? rt(n) : n instanceof String ? rt(n + "") : un("a STRING", n);
    }), q = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function K(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var Z = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), X = F2(function(n, r) {
        return K(n, [
            r
        ]);
    }), J = F3(function(n, r, t) {
        return K(n, [
            r,
            t
        ]);
    }), W = F4(function(n, r, t, e) {
        return K(n, [
            r,
            t,
            e
        ]);
    }), Y = F2(function(n, r) {
        try {
            return nn(n, JSON.parse(r));
        } catch (n) {
            return Wr(A2(Yr, "This is not valid JSON! " + n.message, r));
        }
    }), Q = F2(function(n, r) {
        return nn(n, r);
    });
    function nn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? rt(n.c) : un("null", r);
            case 3:
                return tn(r) ? rn(n.b, r, g) : un("a LIST", r);
            case 4:
                return tn(r) ? rn(n.b, r, en) : un("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return un("an OBJECT with a field named `" + t + "`", r);
                var e = nn(n.b, r[t]);
                return Jt(e) ? e : Wr(A2(Qr, t, e.a));
            case 7:
                var u = n.e;
                return tn(r) ? r.length > u ? (e = nn(n.b, r[u]), Jt(e) ? e : Wr(A2(nt, u, e.a))) : un("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : un("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || tn(r)) return un("an OBJECT", r);
                var c = l;
                for(var a in r)if (Object.prototype.hasOwnProperty.call(r, a)) {
                    if (e = nn(n.b, r[a]), !Jt(e)) return Wr(A2(Qr, a, e.a));
                    c = v(o(a, e.a), c);
                }
                return rt(zt(c));
            case 9:
                for(var i = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = nn(f[s], r), !Jt(e)) return e;
                    i = i(e.a);
                }
                return rt(i);
            case 10:
                return e = nn(n.b, r), Jt(e) ? nn(n.h(e.a), r) : e;
            case 11:
                for(var b = l, d = n.g; d.b; d = d.b){
                    if (e = nn(d.a, r), Jt(e)) return e;
                    b = v(e.a, b);
                }
                return Wr(tt(zt(b)));
            case 1:
                return Wr(A2(Yr, n.a, r));
            case 0:
                return rt(n.a);
        }
    }
    function rn(n, r, t) {
        for(var e = r.length, u = Array(e), c = 0; e > c; c++){
            var a = nn(n, r[c]);
            if (!Jt(a)) return Wr(A2(nt, c, a.a));
            u[c] = a.a;
        }
        return rt(t(u));
    }
    function tn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function en(n) {
        return A2(Xt, n.length, function(r) {
            return n[r];
        });
    }
    function un(n, r) {
        return Wr(A2(Yr, "Expecting " + n, r));
    }
    function cn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return cn(n.b, r.b);
            case 6:
                return n.d === r.d && cn(n.b, r.b);
            case 7:
                return n.e === r.e && cn(n.b, r.b);
            case 9:
                return n.f === r.f && an(n.g, r.g);
            case 10:
                return n.h === r.h && cn(n.b, r.b);
            case 11:
                return an(n.g, r.g);
        }
    }
    function an(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!cn(n[e], r[e])) return !1;
        return !0;
    }
    var on = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function fn(n) {
        return n;
    }
    function sn(n) {
        return n;
    }
    var bn = F3(function(n, r, t) {
        return "toJSON" === n && "function" == typeof r || (t[n] = r), t;
    });
    function dn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function ln(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var vn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), hn = 0;
    function gn(n) {
        var r = {
            $: 0,
            e: hn++,
            f: n,
            g: null,
            h: []
        };
        return yn(r), r;
    }
    function $n(n) {
        return ln(function(r) {
            r(dn(gn(n)));
        });
    }
    function mn(n, r) {
        n.h.push(r), yn(n);
    }
    var pn = F2(function(n, r) {
        return ln(function(t) {
            mn(n, r), t(dn(0));
        });
    }), wn = !1, _n = [];
    function yn(n) {
        if (_n.push(n), !wn) {
            for(wn = !0; n = _n.shift();)zn(n);
            wn = !1;
        }
    }
    function zn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, yn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Mn(n) {
        return ln(function(r) {
            var t = setTimeout(function() {
                r(dn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var kn = {};
    function xn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function Cn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, c = n.e, a = n.f;
        function i(n) {
            return A2(vn, i, {
                $: 5,
                b: function(r) {
                    var i = r.a;
                    return 0 === r.$ ? A3(u, t, i, n) : c && a ? A4(e, t, i.i, i.j, n) : A3(e, t, c ? i.i : i.j, n);
                }
            });
        }
        return t.h = gn(A2(vn, i, n.b));
    }
    var Hn = F2(function(n, r) {
        return ln(function(t) {
            n.g(r), t(dn(0));
        });
    }), Vn = F2(function(n, r) {
        return A2(pn, n.h, {
            $: 0,
            a: r
        });
    });
    function An(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Tn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var En = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), On = [], Sn = !1;
    function jn(n, r, t) {
        if (On.push({
            p: n,
            q: r,
            r: t
        }), !Sn) {
            Sn = !0;
            for(var e; e = On.shift();)Bn(e.p, e.q, e.r);
            Sn = !1;
        }
    }
    function Bn(n, r, t) {
        var e = {};
        for(var u in Ln(!0, r, e, null), Ln(!1, t, e, null), n)mn(n[u], {
            $: "fx",
            a: e[u] || {
                i: l,
                j: l
            }
        });
    }
    function Ln(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, c = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? kn[r].e : kn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: l,
                        j: l
                    }, n ? t.i = v(r, t.i) : t.j = v(r, t.j), t;
                }(n, c, t[u]));
            case 2:
                for(var a = r.m; a.b; a = a.b)Ln(n, a.a, t, e);
                return;
            case 3:
                return void Ln(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Pn(n) {
        kn[n] && y(3);
    }
    function Nn(n, r) {
        return Pn(n), kn[n] = {
            e: In,
            u: r,
            a: Gn
        }, An(n);
    }
    var In = F2(function(n, r) {
        return r;
    });
    function Gn(n) {
        var r = [], t = kn[n].u, e = Mn(0);
        return kn[n].b = e, kn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var c = r, a = sn(t(u.a)), i = 0; c.length > i; i++)c[i](a);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Un(n, r) {
        return Pn(n), kn[n] = {
            f: Fn,
            u: r,
            a: Rn
        }, An(n);
    }
    var Dn, Fn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function Rn(n, r) {
        var t = l, e = kn[n].u, u = dn(null);
        return kn[n].b = u, kn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(Q, e, n);
                Jt(u) || y(4);
                for(var c = u.a, a = t; a.b; a = a.b)r(a.a(c));
            }
        };
    }
    var qn = "undefined" != typeof document ? document : {};
    function Kn(n, r) {
        n.appendChild(r);
    }
    function Zn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Xn, Jn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], c = 0; e.b; e = e.b){
                var a = e.a;
                c += a.b || 0, u.push(a);
            }
            return c += u.length, {
                $: 1,
                c: r,
                d: ar(t),
                e: u,
                f: n,
                b: c
            };
        });
    }), Wn = Jn(void 0), Yn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], c = 0; e.b; e = e.b){
                var a = e.a;
                c += a.b.b || 0, u.push(a);
            }
            return c += u.length, {
                $: 2,
                c: r,
                d: ar(t),
                e: u,
                f: n,
                b: c
            };
        });
    })(void 0), Qn = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), nr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), rr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), tr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), er = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function ur(n) {
        return "script" == n ? "p" : n;
    }
    function cr(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    function ar(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, c = t.o;
            if ("a2" !== e) {
                var a = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? ir(a, u, c) : a[u] = c;
            } else "className" === u ? ir(r, u, sn(c)) : r[u] = sn(c);
        }
        return r;
    }
    function ir(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function or(n, r) {
        var t = n.$;
        if (5 === t) return or(n.k || (n.k = n.m()), r);
        if (0 === t) return qn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var c = {
                j: u,
                p: r
            };
            return (a = or(e, c)).elm_event_node_ref = c, a;
        }
        if (3 === t) return fr(a = n.h(n.g), r, n.d), a;
        var a = n.f ? qn.createElementNS(n.f, n.c) : qn.createElement(n.c);
        Dn && "a" == n.c && a.addEventListener("click", Dn(a)), fr(a, r, n.d);
        for(var i = n.e, o = 0; i.length > o; o++)Kn(a, or(1 === t ? i[o] : i[o].b, r));
        return a;
    }
    function fr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? sr(n, u) : "a0" === e ? lr(n, r, u) : "a3" === e ? br(n, u) : "a4" === e ? dr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function sr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function br(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function dr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, c = e.o;
            void 0 !== c ? n.setAttributeNS(u, t, c) : n.removeAttributeNS(u, t);
        }
    }
    function lr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var c = t[u], a = e[u];
            if (c) {
                if (a) {
                    if (a.q.$ === c.$) {
                        a.q = c;
                        continue;
                    }
                    n.removeEventListener(u, a);
                }
                a = vr(r, c), n.addEventListener(u, a, Xn && {
                    passive: 2 > ne(c)
                }), e[u] = a;
            } else n.removeEventListener(u, a), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Xn = !0;
            }
        }));
    } catch (n) {}
    function vr(n, r) {
        function t(r) {
            var e = t.q, u = nn(e.a, r);
            if (Jt(u)) {
                for(var c, a = ne(e), i = u.a, o = a ? 3 > a ? i.a : i.aD : i, f = 1 == a ? i.b : 3 == a && i.aH, s = (f && r.stopPropagation(), (2 == a ? i.b : 3 == a && i.aG) && r.preventDefault(), n); c = s.j;){
                    if ("function" == typeof c) o = c(o);
                    else for(var b = c.length; b--;)o = c[b](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function hr(n, r) {
        return n.$ == r.$ && cn(n.a, r.a);
    }
    function gr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function $r(n, r, t, e) {
        if (n !== r) {
            var u = n.$, c = r.$;
            if (u !== c) {
                if (1 !== u || 2 !== c) return void gr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), c = 1;
            }
            switch(c){
                case 5:
                    for(var a = n.l, i = r.l, o = a.length, f = o === i.length; f && o--;)f = a[o] === i[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return $r(n.k, r.k, s, 0), void (s.length > 0 && gr(t, 1, e, s));
                case 4:
                    for(var b = n.j, d = r.j, l = !1, v = n.k; 4 === v.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        v.j
                    ] : b.push(v.j), v = v.k;
                    for(var h = r.k; 4 === h.$;)l = !0, "object" != typeof d ? d = [
                        d,
                        h.j
                    ] : d.push(h.j), h = h.k;
                    return l && b.length !== d.length ? void gr(t, 0, e, r) : ((l ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, d) : b === d) || gr(t, 2, e, d), void $r(v, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && gr(t, 3, e, r.a));
                case 1:
                    return void mr(n, r, t, e, wr);
                case 2:
                    return void mr(n, r, t, e, _r);
                case 3:
                    if (n.h !== r.h) return void gr(t, 0, e, r);
                    var g = pr(n.d, r.d);
                    g && gr(t, 4, e, g);
                    var $ = r.i(n.g, r.g);
                    return void ($ && gr(t, 5, e, $));
            }
        }
    }
    function mr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var c = pr(n.d, r.d);
            c && gr(t, 4, e, c), u(n, r, t, e);
        } else gr(t, 0, e, r);
    }
    function pr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var c = n[u], a = r[u];
                c === a && "value" !== u && "checked" !== u || "a0" === t && hr(c, a) || ((e = e || {})[u] = a);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var i = pr(n[u], r[u] || {}, u);
            i && ((e = e || {})[u] = i);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function wr(n, r, t, e) {
        var u = n.e, c = r.e, a = u.length, i = c.length;
        a > i ? gr(t, 6, e, {
            v: i,
            i: a - i
        }) : i > a && gr(t, 7, e, {
            v: a,
            e: c
        });
        for(var o = i > a ? a : i, f = 0; o > f; f++){
            var s = u[f];
            $r(s, c[f], t, ++e), e += s.b || 0;
        }
    }
    function _r(n, r, t, e) {
        for(var u = [], c = {}, a = [], i = n.e, o = r.e, f = i.length, s = o.length, b = 0, d = 0, l = e; f > b && s > d;){
            var v = (x = i[b]).a, h = (C = o[d]).a, g = x.b, $ = C.b, m = void 0, p = void 0;
            if (v !== h) {
                var w = i[b + 1], _ = o[d + 1];
                if (w) {
                    var y = w.a, z = w.b;
                    p = h === y;
                }
                if (_) {
                    var M = _.a, k = _.b;
                    m = v === M;
                }
                if (m && p) $r(g, k, u, ++l), zr(c, u, v, $, d, a), l += g.b || 0, Mr(c, u, v, z, ++l), l += z.b || 0, b += 2, d += 2;
                else if (m) l++, zr(c, u, h, $, d, a), $r(g, k, u, l), l += g.b || 0, b += 1, d += 2;
                else if (p) Mr(c, u, v, g, ++l), l += g.b || 0, $r(z, $, u, ++l), l += z.b || 0, b += 2, d += 1;
                else {
                    if (!w || y !== M) break;
                    Mr(c, u, v, g, ++l), zr(c, u, h, $, d, a), l += g.b || 0, $r(z, k, u, ++l), l += z.b || 0, b += 2, d += 2;
                }
            } else $r(g, $, u, ++l), l += g.b || 0, b++, d++;
        }
        for(; f > b;){
            var x;
            l++, Mr(c, u, (x = i[b]).a, g = x.b, l), l += g.b || 0, b++;
        }
        for(; s > d;){
            var C, H = H || [];
            zr(c, u, (C = o[d]).a, C.b, void 0, H), d++;
        }
        (u.length > 0 || a.length > 0 || H) && gr(t, 8, e, {
            w: u,
            x: a,
            y: H
        });
    }
    var yr = "_elmW6BL";
    function zr(n, r, t, e, u, c) {
        var a = n[t];
        if (!a) return c.push({
            r: u,
            A: a = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = a);
        if (1 === a.c) {
            c.push({
                r: u,
                A: a
            }), a.c = 2;
            var i = [];
            return $r(a.z, e, i, a.r), a.r = u, void (a.s.s = {
                w: i,
                A: a
            });
        }
        zr(n, r, t + yr, e, u, c);
    }
    function Mr(n, r, t, e, u) {
        var c = n[t];
        if (c) {
            if (0 === c.c) {
                c.c = 2;
                var a = [];
                return $r(e, c.z, a, u), void gr(r, 9, u, {
                    w: a,
                    A: c
                });
            }
            Mr(n, r, t + yr, e, u);
        } else {
            var i = gr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: i
            };
        }
    }
    function kr(n, r, t, e) {
        xr(n, r, t, 0, 0, r.b, e);
    }
    function xr(n, r, t, e, u, c, a) {
        for(var i = t[e], o = i.r; o === u;){
            var f = i.$;
            if (1 === f) kr(n, r.k, i.s, a);
            else if (8 === f) i.t = n, i.u = a, (s = i.s.w).length > 0 && xr(n, r, s, 0, u, c, a);
            else if (9 === f) {
                i.t = n, i.u = a;
                var s, b = i.s;
                b && (b.A.s = n, (s = b.w).length > 0 && xr(n, r, s, 0, u, c, a));
            } else i.t = n, i.u = a;
            if (!(i = t[++e]) || (o = i.r) > c) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return xr(n, l, t, e, u + 1, c, n.elm_event_node_ref);
        }
        for(var v = r.e, h = n.childNodes, g = 0; v.length > g; g++){
            u++;
            var $ = 1 === d ? v[g] : v[g].b, m = u + ($.b || 0);
            if (!(u > o || o > m || (i = t[e = xr(h[g], $, t, e, u, m, a)]) && (o = i.r) <= c)) return e;
            u = m;
        }
        return e;
    }
    function Cr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, c = Hr(u, e);
            u === n && (n = c);
        }
        return n;
    }
    function Hr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = or(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return fr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Cr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, c = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(or(u[e], r.u), c);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var a = t.A;
                return void 0 !== a.r && n.parentNode.removeChild(n), a.s = Cr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = qn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                Kn(t, 2 === u.c ? u.s : or(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Cr(n, t.w);
                    for(var u = t.x, c = 0; u.length > c; c++){
                        var a = u[c], i = a.A, o = 2 === i.c ? i.s : or(i.z, r.u);
                        n.insertBefore(o, n.childNodes[a.r]);
                    }
                    return e && Kn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                y(10);
        }
    }
    function Vr(n) {
        if (3 === n.nodeType) return Zn(n.textContent);
        if (1 !== n.nodeType) return Zn("");
        for(var r = l, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = v(A2(er, u.name, u.value), r);
        }
        var c = n.tagName.toLowerCase(), a = l, i = n.childNodes;
        for(e = i.length; e--;)a = v(Vr(i[e]), a);
        return A3(Wn, c, r, a);
    }
    var Ar = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, c) {
            var a = A2(Q, n, r ? r.flags : void 0);
            Jt(a) || y(2);
            var i = {}, o = t(a.a), f = o.a, s = c(d, f), b = function(n, r) {
                var t;
                for(var e in kn){
                    var u = kn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Cn(u, r);
                }
                return t;
            }(i, d);
            function d(n, r) {
                var t = A2(e, n, f);
                s(f = t.a, r), jn(i, t.b, u(f));
            }
            return jn(i, o.b, u(f)), b ? {
                ports: b
            } : {};
        }(r, e, n.el, n.fz, n.fs, function(r, t) {
            var e = n.bp && n.bp(r), u = n.fA, c = qn.title, a = qn.body, i = Vr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Tr(e), r(n), 1);
                }
                return function(u, c) {
                    n = u, c ? (r(n), 2 === t && (t = 1)) : (0 === t && Tr(e), t = 2);
                };
            }(t, function(n) {
                Dn = e;
                var t = u(n), o = Wn("body")(l)(t.aN), f = function(n, r) {
                    var t = [];
                    return $r(n, r, t, 0), t;
                }(i, o);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (kr(n, r, t, e), Cr(n, t));
                }(a, i, f, r), i = o, Dn = 0, c !== t.fy && (qn.title = c = t.fy);
            });
        });
    }), Tr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function Er() {
        return ge(qn.location.href).a || y(1);
    }
    var Or = F2(function(n, r) {
        return A2(Ae, $e, ln(function() {
            history.pushState({}, "", r), n();
        }));
    }), Sr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, jr = "undefined" != typeof document ? document : Sr, Br = "undefined" != typeof window ? window : Sr;
    function Lr(n) {
        return ln(function(r) {
            Tr(function() {
                r(dn(n()));
            });
        });
    }
    var Pr = F2(function(n, r) {
        return Lr(function() {
            return Br.scroll(n, r), 0;
        });
    }), Nr = F3(function(n, r, t) {
        return ln(function(e) {
            function u(n) {
                e(r(t.aU.a(n)));
            }
            var c = new XMLHttpRequest;
            c.addEventListener("error", function() {
                u(Kf);
            }), c.addEventListener("timeout", function() {
                u(Jf);
            }), c.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? qf : Ff, function(n) {
                        return {
                            a7: n.responseURL,
                            fo: n.status,
                            fp: n.statusText,
                            aX: Ir(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.aU.b, c));
            }), Wf(t.a5) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || gn(A2(Yf, n, o(t, Xf({
                        fh: e.loaded,
                        dd: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || gn(A2(Yf, n, o(t, Zf({
                        e6: e.loaded,
                        dd: e.lengthComputable ? ut(e.total) : ct
                    }))));
                });
            }(n, c, t.a5.a);
            try {
                c.open(t.aZ, t.a7, !0);
            } catch (n) {
                return u(Rf(t.a7));
            }
            return function(n, r) {
                for(var t = r.aX; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.a4.a || 0, n.responseType = r.aU.d, n.withCredentials = r.dC;
            }(c, t), t.aN.a && c.setRequestHeader("Content-Type", t.aN.a), c.send(t.aN.b), function() {
                c.c = !0, c.abort();
            };
        });
    });
    function Ir(n) {
        if (!n) return Be;
        for(var r = Be, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], c = u.indexOf(": ");
            if (c > 0) {
                var a = u.substring(0, c), i = u.substring(c + 2);
                r = A3(as, a, function(n) {
                    return ut(Wf(n) ? i + ", " + n.a : i);
                }, r);
            }
        }
        return r;
    }
    var Gr = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Ur = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), Dr = F5(function(n, r, t, e, u) {
        for(var c = n.length, a = u.length >= r + c, i = 0; a && c > i;){
            var o = u.charCodeAt(r);
            a = n[i++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[i++] === u[r++] : 1));
        }
        return f(a ? r : -1, t, e);
    }), Fr = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), Rr = 1, qr = 2, Kr = 0, Zr = h, Xr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, c = A3(n, t.b, t.c, A3(Xr, n, r, t.e));
            n = u, r = c, t = e;
        }
    }), Jr = function(n) {
        return A3(Xr, F3(function(n, r, t) {
            return A2(Zr, o(n, r), t);
        }), l, n);
    }, Wr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Yr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Qr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), rt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, et = z, ut = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ct = {
        $: 1
    }, at = j, it = on, ot = N, ft = F2(function(n, r) {
        return A2(O, n, $(r));
    }), st = F2(function(n, r) {
        return g(A2(E, n, r));
    }), bt = function(n) {
        return A2(ft, "\n    ", A2(st, "\n", n));
    }, dt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, c = A2(n, t.a, r);
            n = u, r = c, t = e;
        }
    }), lt = function(n) {
        return A3(dt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, vt = m, ht = F3(function(n, r, t) {
        for(;;){
            if (a(n, r) >= 1) return t;
            var e = n, u = r - 1, c = A2(Zr, r, t);
            n = e, r = u, t = c;
        }
    }), gt = F2(function(n, r) {
        return A3(ht, n, r, l);
    }), $t = F2(function(n, r) {
        return A3(vt, n, A2(gt, 0, lt(r) - 1), r);
    }), mt = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, pt = function(n) {
        var r = mt(n);
        return r >= 97 && 122 >= r;
    }, wt = function(n) {
        var r = mt(n);
        return 90 >= r && r >= 65;
    }, _t = function(n) {
        var r = mt(n);
        return 57 >= r && r >= 48;
    }, yt = function(n) {
        return pt(n) || wt(n) || _t(n);
    }, zt = function(n) {
        return A3(dt, Zr, l, n);
    }, Mt = F2(function(n, r) {
        return "\n\n(" + ot(n + 1) + ") " + bt(kt(r));
    }), kt = function(n) {
        return A2(xt, n, l);
    }, xt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0), isNaN(r) ? ct : ut(55296 > r || r > 56319 ? o(n[0], n.slice(1)) : o(n[0] + n[1], n.slice(2))));
                    if (1 === e.$) return !1;
                    var u, c = e.a, a = c.b;
                    return (pt(u = c.a) || wt(u)) && A2(at, yt, a);
                }();
                n = e, r = A2(Zr, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var c = "[" + ot(n.a) + "]";
                n = e, r = A2(Zr, c, r);
                continue n;
            case 2:
                var a = n.a;
                if (a.b) {
                    if (a.b.b) {
                        var i = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(ft, "", zt(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + ot(lt(a)) + " ways:";
                        return A2(ft, "\n\n", A2(Zr, i, A2($t, Mt, a)));
                    }
                    n = e = a.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(ft, "", zt(r)) : "!";
                }();
            default:
                var f = n.a, s = n.b;
                return (i = function() {
                    return r.b ? "Problem with the value at json" + A2(ft, "", zt(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (bt(A2(it, 4, s)) + "\n\n") + f;
        }
    }), Ct = 32, Ht = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Vt = [], At = k, Tt = F2(function(n, r) {
        return H(r) / H(n);
    }), Et = At(A2(Tt, 2, Ct)), Ot = A4(Ht, 0, Et, Vt, Vt), St = w, jt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Bt = F2(function(n, r) {
        return n(r);
    }), Lt = F2(function(n, r) {
        return r(n);
    }), Pt = u, Nt = x, It = function(n) {
        return n.length;
    }, Gt = F2(function(n, r) {
        return a(n, r) > 0 ? n : r;
    }), Ut = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dt = _, Ft = F2(function(n, r) {
        for(;;){
            var t = A2(Dt, Ct, n), e = t.b, u = A2(Zr, Ut(t.a), r);
            if (!e.b) return zt(u);
            n = e, r = u;
        }
    }), Rt = function(n) {
        return n.a;
    }, qt = F2(function(n, r) {
        for(;;){
            var t = At(r / Ct);
            if (1 === t) return A2(Dt, Ct, n).a;
            n = A2(Ft, n, l), r = t;
        }
    }), Kt = F2(function(n, r) {
        if (r.l) {
            var t = r.l * Ct, e = Nt(A2(Tt, Ct, t - 1)), u = n ? zt(r.o) : r.o, c = A2(qt, u, r.l);
            return A4(Ht, It(r.n) + t, A2(Gt, 5, e * Et), c, r.n);
        }
        return A4(Ht, It(r.n), Et, Vt, r.n);
    }), Zt = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(Kt, !1, {
                o: e,
                l: t / Ct | 0,
                n: u
            });
            var c = jt(A3(St, Ct, r, n));
            r -= Ct, e = A2(Zr, c, e);
        }
    }), Xt = F2(function(n, r) {
        if (n > 0) {
            var t = n % Ct;
            return A5(Zt, r, n - t - Ct, n, l, A3(St, t, n - t, r));
        }
        return Ot;
    }), Jt = function(n) {
        return !n.$;
    }, Wt = X, Yt = J, Qt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ne = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, re = function(n) {
        return n;
    }, te = F6(function(n, r, t, e, u, c) {
        return {
            b9: c,
            cg: r,
            cP: e,
            cT: t,
            cX: n,
            cY: u
        };
    }), ee = B, ue = function(n) {
        return n.length;
    }, ce = S, ae = F2(function(n, r) {
        return 1 > n ? r : A3(ce, n, ue(r), r);
    }), ie = P, oe = function(n) {
        return "" === n;
    }, fe = F2(function(n, r) {
        return 1 > n ? "" : A3(ce, 0, n, r);
    }), se = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var c = n.charCodeAt(u);
            if (48 > c || c > 57) return ct;
            r = 10 * r + c - 48;
        }
        return u == e ? ct : ut(45 == t ? -r : r);
    }, be = F5(function(n, r, t, e, u) {
        if (oe(u) || A2(ee, "@", u)) return ct;
        var c = A2(ie, ":", u);
        if (c.b) {
            if (c.b.b) return ct;
            var a = c.a, i = se(A2(ae, a + 1, u));
            if (1 === i.$) return ct;
            var o = i;
            return ut(A6(te, n, A2(fe, a, u), o, r, t, e));
        }
        return ut(A6(te, n, u, ct, r, t, e));
    }), de = F4(function(n, r, t, e) {
        if (oe(e)) return ct;
        var u = A2(ie, "/", e);
        if (u.b) {
            var c = u.a;
            return A5(be, n, A2(ae, c, e), r, t, A2(fe, c, e));
        }
        return A5(be, n, "/", r, t, e);
    }), le = F3(function(n, r, t) {
        if (oe(t)) return ct;
        var e = A2(ie, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(de, n, ut(A2(ae, u + 1, t)), r, A2(fe, u, t));
        }
        return A4(de, n, ct, r, t);
    }), ve = F2(function(n, r) {
        if (oe(r)) return ct;
        var t = A2(ie, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(le, n, ut(A2(ae, e + 1, r)), A2(fe, e, r));
        }
        return A3(le, n, ct, r);
    }), he = L, ge = function(n) {
        return A2(he, "http://", n) ? A2(ve, 0, A2(ae, 7, n)) : A2(he, "https://", n) ? A2(ve, 1, A2(ae, 8, n)) : ct;
    }, $e = function() {
        for(;;);
    }, me = dn, pe = me(0), we = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, c = e.b;
            if (c.b) {
                var a = c.a, i = c.b;
                if (i.b) {
                    var o = i.a, f = i.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, a, A2(n, o, A2(n, f.a, t > 500 ? A3(dt, n, r, zt(s)) : A4(we, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, a, A2(n, o, r)));
                }
                return A2(n, u, A2(n, a, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), _e = F3(function(n, r, t) {
        return A4(we, n, r, 0, t);
    }), ye = F2(function(n, r) {
        return A3(_e, F2(function(r, t) {
            return A2(Zr, n(r), t);
        }), l, r);
    }), ze = vn, Me = F2(function(n, r) {
        return A2(ze, function(r) {
            return me(n(r));
        }, r);
    }), ke = F3(function(n, r, t) {
        return A2(ze, function(r) {
            return A2(ze, function(t) {
                return me(A2(n, r, t));
            }, t);
        }, r);
    }), xe = function(n) {
        return A3(_e, ke(Zr), me(l), n);
    }, Ce = Hn, He = F2(function(n, r) {
        var t = r;
        return $n(A2(ze, Ce(n), t));
    });
    kn.Task = xn(pe, F3(function(n, r) {
        return A2(Me, function() {
            return 0;
        }, xe(A2(ye, He(n), r)));
    }), F3(function() {
        return me(0);
    }), F2(function(n, r) {
        return A2(Me, n, r);
    }));
    var Ve = An("Task"), Ae = F2(function(n, r) {
        return Ve(A2(Me, n, r));
    }), Te = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ee = Tn, Oe = {
        $: 1
    }, Se = Q, je = {
        $: -2
    }, Be = je, Le = {
        aS: 0,
        fk: !1
    }, Pe = F5(function(n, r, t, e, u) {
        return {
            P: u,
            bY: t,
            cw: r,
            a3: e,
            dz: n
        };
    }), Ne = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ie = F2(function(n, r) {
        return {
            a8: r,
            D: n
        };
    }), Ge = F2(function(n, r) {
        return {
            bt: n,
            by: r
        };
    }), Ue = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), De = Ue, Fe = 2037, Re = function(n) {
        return n.b;
    }, qe = M, Ke = F2(function(n, r) {
        var t = A2(qe, 7, function(n) {
            return A2(qe, 7, n) || 7;
        }(r) + 7 - function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                default:
                    return 7;
            }
        }(n));
        return r - t;
    }), Ze = F2(function(n, r) {
        var e = A2(Ke, n, r);
        return t(r, e) ? r : e + 7;
    }), Xe = F2(function(n, r) {
        return r.b ? A3(_e, Zr, r, n) : n;
    }), Je = F2(function(n, r) {
        return A3(_e, Xe, l, A2(ye, n, r));
    }), We = c, Ye = function(n) {
        return !A2(qe, 4, n) && !!A2(qe, 100, n) || !A2(qe, 400, n);
    }, Qe = F2(function(n, r) {
        var t = Ye(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), nu = function(n) {
        var r = n - 1;
        return 365 * r + ((r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0));
    }, ru = F3(function(n, r, t) {
        return nu(n) + A2(Qe, n, r) + t;
    }), tu = F2(function(n, r) {
        return A3(_e, F2(function(r, t) {
            return n(r) ? A2(Zr, r, t) : t;
        }), l, r);
    }), eu = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return Ye(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), uu = F2(function(n, r) {
        return nu(n) + A2(Qe, n, r) + A2(eu, n, r);
    }), cu = function(n) {
        return 1440 * (n - 719163);
    }, au = p, iu = F2(function(n, r) {
        var t = r.S, e = r.t;
        switch(n){
            case 0:
                return 0;
            case 1:
                return 0 - t;
            default:
                return 0 - (t + e);
        }
    }), ou = F2(function(n, r) {
        var t, e;
        return e = (t = r).a3, cu(A3(ru, t.dz, t.cw, t.bY)) + e + A2(iu, r.P, n);
    }), fu = F5(function(n, r, t, e, u) {
        var c = A2(Je, function(n) {
            return A2(au, function(n) {
                return n.bu;
            }, A2(ye, function(r) {
                return {
                    P: r.P,
                    t: r.t,
                    bu: cu(function() {
                        var t = r.bY;
                        switch(t.$){
                            case 0:
                                return A3(ru, n, r.cw, t.a);
                            case 1:
                                return A2(Ze, t.a, A3(ru, n, r.cw, t.b));
                            case 2:
                                return A2(Ke, t.a, A3(ru, n, r.cw, t.b));
                            default:
                                return A2(Ke, t.a, A2(uu, n, r.cw));
                        }
                    }()) + r.a3
                };
            }, A2(tu, function(r) {
                return 1 > a(r.ca, n) && 1 > a(n, r.dq);
            }, u)));
        }, A2(gt, r.dz - 1, t.dz)), i = {
            t: 0,
            S: e
        }, f = {
            c: e,
            bu: A2(ou, n, r)
        }, s = A3(dt, F2(function(r, u) {
            var c = u.a, i = u.b, s = {
                t: r.t,
                S: e
            };
            return 1 > a(r.bu + A2(iu, r.P, n), f.bu) ? o(s, g([
                {
                    c: e + r.t,
                    bu: f.bu
                }
            ])) : 0 > a(r.bu + A2(iu, r.P, c), A2(ou, c, t)) ? o(s, A2(Zr, {
                c: e + r.t,
                bu: r.bu + A2(iu, r.P, c)
            }, i)) : o(c, i);
        }), o(i, g([
            f
        ])), c), b = s.a;
        return o(zt(s.b), b);
    }), su = F4(function(n, r, t, e) {
        var u = e.bt, c = e.by;
        if (c.$) return A5(fu, n, r, t, u, c.a);
        var a = c.a;
        return o(g([
            {
                c: u + a,
                bu: A2(ou, n, r)
            }
        ]), {
            t: a,
            S: u
        });
    }), bu = F4(function(n, r, e, u) {
        for(;;){
            if (!u.b) return zt(e);
            var c = u.a, a = u.b, i = n(c), o = t(r, i) ? e : A2(Zr, c, e);
            r = i, e = o, u = a;
        }
    }), du = F3(function(n, r, t) {
        var e = A3(dt, F2(function(n, r) {
            var t = n.b, e = r.b;
            return o(t, A2(Zr, f(r.a, n.a, t), e));
        }), o(n, l), t.D), u = e.b;
        return zt(A2(Zr, f(e.a, t.a8, r), u));
    }), lu = F3(function(n, r, t) {
        var e, u, c = (e = t.D).b ? e.a.a : t.a8, a = {
            t: (u = c.by, u.$ ? 0 : u.a),
            S: c.bt
        }, i = A4(bu, function(n) {
            return n.c;
        }, a.S + a.t, l, A3(dt, F2(function(n, r) {
            var t = r.b, e = A4(su, r.a, n.a, n.c, n.b);
            return o(e.b, d(t, e.a));
        }), o(a, l), A3(du, A5(Pe, n, 0, 1, 0, 0), A5(Pe, r + 1, 0, 1, 0, 0), t)).b), f = function(n) {
            for(;;){
                var r = n.a, t = n.b;
                if (!t.b) return o(r, l);
                var e = t.a, u = t.b;
                if (e.bu > 0) return o(r, t);
                n = o(e.c, u);
            }
        }(o(a.S + a.t, i)), s = f.a;
        return o(zt(f.b), s);
    }), vu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hu = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), gu = F7(function(n, r, t, e, u, c, a) {
        return {
            P: c,
            bY: e,
            ca: n,
            cw: t,
            t: a,
            a3: u,
            dq: r
        };
    }), $u = g([
        A7(gu, 1977, 1980, 3, A2(hu, 6, 1), 60, 0, 60),
        A7(gu, 1977, 1977, 8, vu(6), 60, 0, 0),
        A7(gu, 1978, 1978, 9, {
            $: 0,
            a: 1
        }, 60, 0, 0),
        A7(gu, 1979, 1995, 8, vu(6), 60, 0, 0),
        A7(gu, 1981, Fe, 2, vu(6), 60, 0, 60),
        A7(gu, 1996, Fe, 9, vu(6), 60, 0, 0)
    ]), mu = F2(function(n, r) {
        return {
            bq: n,
            fn: r
        };
    }), pu = U, wu = G, _u = Yt(Lt), yu = q, zu = F3(function(n, r, t) {
        return A2(_u, A2(yu, n, r), t);
    }), Mu = A3(zu, "startTime", wu, A3(zu, "showConsentBanner", pu, Qt(mu))), ku = o(0, l), xu = {
        aM: !0,
        V: !0,
        dT: ct,
        X: l,
        L: 0
    }, Cu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Hu = F2(function(n, r) {
        var t, e, u, c = A2(Cu, {
            bq: !0,
            fn: 0
        }, A2(Se, Mu, n));
        return {
            ai: xu,
            dO: Oe,
            ax: (t = c.bq, {
                Z: !1,
                bq: t,
                af: !1
            }),
            aA: ku,
            eu: ct,
            eG: r,
            aF: ct,
            fa: Oe,
            ad: Be,
            fj: Le,
            fn: c.fn,
            fx: (e = A2(Ie, g([
                o(A2(Ge, 60, Ne(0)), A5(Pe, 1980, 0, 1, 0, 2))
            ]), A2(Ge, 60, function(n) {
                return {
                    $: 1,
                    a: n
                };
            }($u))), A2(De, (u = A3(lu, 1970, Fe, e)).b, u.a))
        };
    }), Vu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Au = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Tu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Eu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ou = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Su = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ju = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Bu = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Lu = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Pu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nu = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Iu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Gu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Uu = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Du = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Fu = {
        $: 1
    }, Ru = i, qu = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return ct;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(Ru, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return ut(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Ku = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Zu = F2(function(n, r) {
        return A2(Ku, 0, A2(qu, n, r.ad));
    }), Xu = Ee(l), Ju = Pr, Wu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Yu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nc = F4(function(n, r, t, e) {
        return {
            a: e,
            fq: t,
            fu: r,
            fy: n
        };
    }), rc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ec = F7(function(n, r, t, e, u, c, a) {
        return {
            dN: a,
            bP: n,
            ba: r,
            d8: t,
            bk: e,
            e2: u,
            fa: c
        };
    }), uc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, cc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ac = function(n) {
        return {
            a: n
        };
    }, ic = function(n) {
        return {
            $: 7,
            a: n
        };
    }, oc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), fc = F3(function(n, r, t) {
        return {
            a: t,
            ef: n,
            em: r
        };
    }), sc = function(n) {
        return {
            $: 9,
            a: n
        };
    }, bc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), dc = function(n) {
        return {
            a: n
        };
    }, lc = function(n) {
        return {
            $: 12,
            a: n
        };
    }, vc = function(n) {
        return {
            $: 13,
            a: n
        };
    }, hc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gc = function(n) {
        return {
            a: n
        };
    }, $c = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mc = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    dH: a,
                                                    dI: c,
                                                    d1: o,
                                                    d2: i,
                                                    ch: t,
                                                    eg: r,
                                                    eq: u,
                                                    er: e,
                                                    ft: n,
                                                    fE: f,
                                                    fG: s
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, pc = function(n) {
        return {
            $: 15,
            a: n
        };
    }, wc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), _c = function(n) {
        return {
            a: n
        };
    }, yc = function(n) {
        return {
            $: 17,
            a: n
        };
    }, zc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Mc = F5(function(n, r, t, e, u) {
        return {
            a: u,
            ba: e,
            d9: t,
            ea: r,
            e5: n
        };
    }), kc = function(n) {
        return {
            $: 18,
            a: n
        };
    }, xc = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Cc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Hc = function(n) {
        return {
            a: n
        };
    }, Vc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ac = F7(function(n, r, t, e, u, c, a) {
        return {
            ba: t,
            ch: c,
            bg: n,
            bh: r,
            ew: a,
            e8: u,
            e9: e
        };
    }), Tc = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Ec = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Oc = function(n) {
        return {
            a: n
        };
    }, Sc = function(n) {
        return {
            $: 22,
            a: n
        };
    }, jc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Bc = F2(function(n, r) {
        return {
            a: r,
            fl: n
        };
    }), Lc = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Pc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Nc = function(n) {
        return {
            a: n
        };
    }, Ic = Z, Gc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Uc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Dc = F2(function(n, r) {
        return {
            d6: r,
            ek: n
        };
    }), Fc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Rc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qc = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Kc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zc = R, Xc = A2(Ic, function(n) {
        switch(n){
            case "imageToText":
                return Qt(1);
            case "textToImage":
                return Qt(0);
            case "textToText":
                return Qt(2);
            default:
                return Kc("unknown game style " + n);
        }
    }, A2(yu, "style", Zc)), Jc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Wc = A3(zu, "shared", pu, A3(zu, "name", Zc, A3(zu, "type", Zc, A3(zu, "id", wu, Qt(F4(function(n, r, t, e) {
        return {
            dQ: r,
            am: n,
            eE: t,
            fi: e
        };
    })))))), Yc = F5(function(n, r, t, e, u) {
        return {
            bc: r,
            bj: n,
            fc: u,
            $7: e,
            a7: t
        };
    }), Qc = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), na = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Qc, n, r, t, e, u);
            var c = e.d;
            return a = e.e, A5(Qc, 0, e.b, e.c, A5(Qc, 1, c.b, c.c, c.d, c.e), A5(Qc, 1, r, t, a, u));
        }
        var a, i = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Qc, n, i, o, A5(Qc, 0, r, t, e, f), s) : A5(Qc, 0, r, t, A5(Qc, 1, e.b, e.c, e.d, a = e.e), A5(Qc, 1, i, o, f, s));
    }), ra = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Qc, 0, n, r, je, je);
        var e = t.a, u = t.b, c = t.c, a = t.d, i = t.e;
        switch(A2(Ru, n, u)){
            case 0:
                return A5(na, e, u, c, A3(ra, n, r, a), i);
            case 1:
                return A5(Qc, e, u, r, a, i);
            default:
                return A5(na, e, u, c, a, A3(ra, n, r, i));
        }
    }), ta = F3(function(n, r, t) {
        var e = A3(ra, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Qc, 1, e.b, e.c, e.d, e.e);
    }), ea = function(n) {
        return A3(dt, F2(function(n, r) {
            return A3(ta, n.a, n.b, r);
        }), Be, n);
    }, ua = F2(function(n, r) {
        return A3(_e, yu, r, n);
    }), ca = function(n) {
        return {
            $: 11,
            g: n
        };
    }, aa = F, ia = F3(function(n, r, t) {
        var e = function(n) {
            var r;
            return ca(g([
                n,
                (r = t, {
                    $: 5,
                    c: r
                })
            ]));
        };
        return A2(Ic, function(u) {
            var c = A2(Se, A2(ua, n, aa), u);
            if (c.$) return Qt(t);
            var a = c.a, i = A2(Se, e(r), a);
            return i.$ ? A2(ua, n, e(r)) : Qt(i.a);
        }, aa);
    }), oa = F4(function(n, r, t, e) {
        return A2(_u, A3(ia, g([
            n
        ]), r, t), e);
    }), fa = A4(oa, "resized_images", A2(Wt, ea, {
        $: 8,
        b: Zc
    }), Be, A3(zu, "thumbnail", Zc, A3(zu, "url", Zc, A3(zu, "filesize", wu, A3(zu, "mime", Zc, Qt(Yc)))))), sa = A3(Yt, Jc, Wc, fa), ba = A2(_u, A2(Ic, function(n) {
        switch(n){
            case 0:
                return A3(zu, "image", sa, A3(zu, "associated_title", Zc, Qt(Rc)));
            case 1:
                return A3(zu, "title", Zc, A3(zu, "associated_image", sa, Qt(Fc)));
            default:
                return A3(zu, "title", Zc, A3(zu, "associated_title", Zc, Qt(qc)));
        }
    }, Xc), A4(oa, "info_text", A2(Wt, ut, Zc), ct, Qt(Dc))), da = A2(Wt, Gc, A3(Yt, Uc, Wc, ba)), la = function(n) {
        return {
            $: 29,
            a: n
        };
    }, va = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ha = F5(function(n, r, t, e, u) {
        return {
            bc: r,
            bj: n,
            ez: e,
            eA: u,
            a7: t
        };
    }), ga = A3(zu, "mp3_conversion", pu, A4(oa, "mp3", A2(Wt, ut, Zc), ct, A3(zu, "url", Zc, A3(zu, "filesize", wu, A3(zu, "mime", Zc, Qt(ha)))))), $a = A2(Wt, la, A3(Yt, va, Wc, ga)), ma = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pa = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), wa = W, _a = {
        bT: 1,
        bU: 1,
        bV: 1
    }, ya = A4(wa, pa, Wc, Qt(0), Qt(_a)), za = A2(Wt, ma, ya), Ma = F2(function(n, r) {
        return {
            dv: n,
            dw: r
        };
    }), ka = A3(zu, "value", Zc, A3(zu, "type", A2(Wt, function(n) {
        switch(n){
            case "Telefon":
                return 0;
            case "E-Mail":
                return 1;
            case "Website":
                return 2;
            default:
                return 3;
        }
    }, Zc), Qt(Ma))), xa = F3(function(n, r, t) {
        return {
            b3: n,
            dh: r,
            fy: t
        };
    }), Ca = A3(zu, "title", Zc, A3(zu, "starts_at", Zc, A4(oa, "ends_at", A2(Wt, ut, Zc), ct, Qt(xa)))), Ha = D, Va = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Aa = F5(function(n, r, t, e, u) {
        return {
            aP: e,
            b2: t,
            eE: n,
            cK: u,
            dg: r
        };
    }), Ta = F5(function(n, r, t, e, u) {
        return {
            aP: u,
            bN: t,
            bX: e,
            bZ: n,
            cL: r
        };
    }), Ea = A3(zu, "closed", pu, A4(oa, "date", A2(Wt, ut, Zc), ct, A3(zu, "closing_time", Zc, A3(zu, "opening_time", Zc, A3(zu, "day_of_week", wu, Qt(Ta)))))), Oa = A3(zu, "opening_hours", Va(Ea), A3(zu, "closed", pu, A4(oa, "end_date", A2(Wt, ut, Zc), ct, A4(oa, "start_date", A2(Wt, ut, Zc), ct, A3(zu, "name", Zc, Qt(Aa)))))), Sa = A4(oa, "zip_code", Zc, "", A4(oa, "thumbnail_url", A2(Wt, ut, Zc), ct, A4(oa, "street", Zc, "", A3(zu, "menu_levels", Va(wu), A4(oa, "picture_url", A2(Wt, ut, Zc), ct, A3(zu, "other_events", Va(Ca), A3(zu, "seasons", Va(Oa), A3(zu, "longitude", Ha, A3(zu, "latitude", Ha, A3(zu, "contact_items", Va(ka), A4(oa, "city", Zc, "", A3(zu, "church_service_soon", pu, A3(zu, "church_services", Va(Ca), A4(oa, "addition", Zc, "", Qt(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(b) {
                                                    return function(d) {
                                                        return function(l) {
                                                            return {
                                                                bA: n,
                                                                bK: r,
                                                                bL: t,
                                                                bM: e,
                                                                bQ: u,
                                                                bg: c,
                                                                bh: a,
                                                                cu: s,
                                                                cM: o,
                                                                cQ: f,
                                                                c8: i,
                                                                dj: b,
                                                                dp: d,
                                                                dA: l
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), ja = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Zr, e.a, t);
    }), Ba = F2(function(n, r) {
        return A3(_e, ja(n), l, r);
    }), La = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Pa = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Na = A4(oa, "outer_right_image", A2(Wt, ut, fa), ct, A4(oa, "outer_right_image_id", A2(Wt, ut, wu), ct, A4(oa, "outer_left_image", A2(Wt, ut, fa), ct, A4(oa, "outer_left_image_id", A2(Wt, ut, wu), ct, A4(oa, "inner_right_image", A2(Wt, ut, fa), ct, A4(oa, "inner_right_image_id", A2(Wt, ut, wu), ct, A4(oa, "inner_left_image", A2(Wt, ut, fa), ct, A4(oa, "inner_left_image_id", A2(Wt, ut, wu), ct, A4(oa, "center_image", A2(Wt, ut, fa), ct, A4(oa, "center_image_id", A2(Wt, ut, wu), ct, Qt(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                aO: r,
                                                bH: n,
                                                cl: e,
                                                en: t,
                                                cm: c,
                                                eo: u,
                                                cN: i,
                                                e0: a,
                                                cO: f,
                                                e1: o
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), Ia = A4(wa, Pa, Wc, Na, Qt({
        co: !1
    })), Ga = A2(Wt, La, Ia), Ua = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Da = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Fa = A2(Wt, Ua, A3(Yt, Da, Wc, A2(Wt, function(n) {
        return {
            ee: n
        };
    }, A2(yu, "html", Zc)))), Ra = function(n) {
        return {
            $: 30,
            a: n
        };
    }, qa = A2(Wt, Ra, sa), Ka = Qt({
        dU: 0
    }), Za = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Xa = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ja = {
        c$: l,
        da: l
    }, Wa = A4(wa, Xa, Wc, Qt(0), Qt(Ja)), Ya = A2(Wt, Za, Wa), Qa = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ni = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ri = A2(Wt, Qa, A3(Yt, ni, Wc, A2(Wt, function(n) {
        return {
            aQ: n
        };
    }, A2(yu, "config", aa)))), ti = function(n) {
        return A2(Ic, function(r) {
            return 1 === r.$ ? Qt(l) : A2(yu, "children", Va(n));
        }, function(n) {
            return ca(g([
                A2(Wt, ut, n),
                Qt(ct)
            ]));
        }(A2(yu, "children", Va(aa))));
    }, ei = {
        bS: ct,
        b6: !0,
        b7: !1
    }, ui = {
        bW: 0
    }, ci = function(n) {
        return {
            bF: l,
            bG: 1e3,
            aT: {
                dX: ct,
                fm: ct
            },
            b0: l,
            ci: n
        };
    }, ai = function(n) {
        return {
            $: 14,
            a: n
        };
    }, ii = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), oi = {
        aT: {
            eP: !1,
            e4: ct
        },
        cv: ct
    }, fi = A4(wa, ii, Wc, Qt(0), Qt(oi)), si = A2(Wt, ai, fi), bi = function(n) {
        return {
            $: 16,
            a: n
        };
    }, di = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), li = A3(zu, "correct", pu, A3(zu, "answer", Zc, Qt(F2(function(n, r) {
        return {
            dD: n,
            dS: r
        };
    })))), vi = A2(Wt, bi, A3(Yt, di, Wc, li)), hi = ea(g([
        o("bicycle", 0),
        o("church", 1),
        o("info", 2),
        o("none", 3)
    ])), gi = A2(Ic, function(n) {
        var r = A2(qu, n, hi);
        return r.$ ? Kc("unknown icon " + n) : Qt(r.a);
    }, A2(yu, "icon", Zc)), $i = function(n) {
        return {
            $: 21,
            a: n
        };
    }, mi = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), pi = A4(wa, mi, Wc, Qt(0), Qt(_a)), wi = A2(Wt, $i, pi), _i = function(n) {
        return {
            $: 23,
            a: n
        };
    }, yi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), zi = A2(Wt, _i, A3(Yt, yi, Wc, A2(Wt, function(n) {
        return {
            aQ: n
        };
    }, A2(yu, "config", aa)))), Mi = function(n) {
        return {
            $: 24,
            a: n
        };
    }, ki = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xi = A2(Wt, Mi, A3(Yt, ki, Wc, A2(Wt, function(n) {
        return {
            aQ: n
        };
    }, A2(yu, "config", aa)))), Ci = function(n) {
        return {
            $: 26,
            a: n
        };
    }, Hi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Vi = A3(zu, "image", sa, Qt(function(n) {
        return {
            bf: n
        };
    })), Ai = A2(Wt, Ci, A3(Yt, Hi, Wc, Vi)), Ti = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ei = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Oi = A4(oa, "opened_twice_outer_right_image", A2(Wt, ut, fa), ct, A4(oa, "opened_twice_outer_right_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_twice_outer_left_image", A2(Wt, ut, fa), ct, A4(oa, "opened_twice_outer_left_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_twice_inner_right_image", A2(Wt, ut, fa), ct, A4(oa, "opened_twice_inner_right_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_twice_inner_left_image", A2(Wt, ut, fa), ct, A4(oa, "opened_twice_inner_left_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_once_outer_right_image", A2(Wt, ut, fa), ct, A4(oa, "opened_once_outer_right_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_once_outer_left_image", A2(Wt, ut, fa), ct, A4(oa, "opened_once_outer_left_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_once_inner_right_image", A2(Wt, ut, fa), ct, A4(oa, "opened_once_inner_right_image_id", A2(Wt, ut, wu), ct, A4(oa, "opened_once_inner_left_image", A2(Wt, ut, fa), ct, A4(oa, "opened_once_inner_left_image_id", A2(Wt, ut, wu), ct, A4(oa, "center_image", A2(Wt, ut, fa), ct, A4(oa, "center_image_id", A2(Wt, ut, wu), ct, Qt(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(c) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(b) {
                                                    return function(d) {
                                                        return function(l) {
                                                            return function(v) {
                                                                return function(h) {
                                                                    return function(g) {
                                                                        return function($) {
                                                                            return {
                                                                                aO: r,
                                                                                bH: n,
                                                                                cC: e,
                                                                                eT: t,
                                                                                cD: c,
                                                                                eU: u,
                                                                                cE: i,
                                                                                eV: a,
                                                                                cF: f,
                                                                                eW: o,
                                                                                cG: b,
                                                                                eX: s,
                                                                                cH: l,
                                                                                eY: d,
                                                                                cI: h,
                                                                                eZ: v,
                                                                                cJ: $,
                                                                                e_: g
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), Si = A4(wa, Ei, Wc, Oi, Qt({
        di: 0,
        du: 3
    })), ji = A2(Wt, Ti, Si), Bi = F2(function(n, r) {
        if (r.b) {
            var t = r.b;
            return A2(Zr, r.a, A3(_e, F2(function(r, t) {
                return A2(Zr, n, A2(Zr, r, t));
            }), l, t));
        }
        return l;
    }), Li = F2(function(n, r) {
        return A3(_e, F2(function(n, r) {
            return d(r, n);
        }), "", A2(Bi, n, r));
    }), Pi = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Ni = F2(function(n, r) {
        return A2(Pi, function(r) {
            return t(r, n);
        }, r);
    }), Ii = F2(function(n, r) {
        return A2(Ic, function(t) {
            return A2(Ni, t, n) ? r : Kc('type is not "' + A2(Li, '" or "', n) + '"');
        }, A2(yu, "type", Zc));
    }), Gi = F2(function(n, r) {
        return A2(Ii, g([
            n
        ]), r);
    }), Ui = function(n) {
        return {
            $: 31,
            a: n
        };
    }, Di = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Fi = F7(function(n, r, t, e, u, c, a) {
        return {
            bc: r,
            bj: n,
            eB: c,
            eC: a,
            e3: u,
            $7: e,
            a7: t
        };
    }), Ri = A3(zu, "mp4_conversion", pu, A4(oa, "mp4", A2(Wt, ut, Zc), ct, A3(zu, "poster", Zc, A3(zu, "thumbnail", Zc, A3(zu, "url", Zc, A3(zu, "filesize", wu, A3(zu, "mime", Zc, Qt(Fi)))))))), qi = A2(Wt, Ui, A3(Yt, Di, Wc, Ri)), Ki = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Zi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Xi = F2(function(n, r) {
        return {
            bf: r,
            eh: n
        };
    }), Ji = A4(oa, "image", A2(Wt, ut, fa), ct, A4(oa, "image_id", A2(Wt, ut, wu), ct, Qt(Xi))), Wi = A2(Wt, Ki, A3(Yt, Zi, Wc, Ji)), Yi = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Qi = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), no = A4(wa, Qi, Wc, A2(Wt, function(n) {
        return {
            aQ: n
        };
    }, A2(yu, "config", aa)), Qt({
        ce: 0,
        cs: .5,
        c5: 1
    })), ro = A2(Wt, Yi, no), to = function(n) {
        return A2(Gi, n, Oo());
    };
    function eo() {
        return ea(g([
            o("association_game", uo()),
            o("association", da),
            o("church", ho()),
            o("content_root", wo()),
            o("costume_game", za),
            o("folding_altar", Ga),
            o("tfa", ji),
            o("generic_region_topic", so()),
            o("html", Fa),
            o("image_gallery", Ao()),
            o("levite_chair", Ya),
            o("map", ri),
            o("poi", Co()),
            o("poi_container", So()),
            o("present_game", si),
            o("quiz_container", Lo()),
            o("quiz_answer", vi),
            o("quiz_question", Io()),
            o("region", vo()),
            o("region_church_container", Do()),
            o("region_topic_container", qo()),
            o("schwahl_game", wi),
            o("static_page", io()),
            o("static_page_preview", io()),
            o("searching_game", zi),
            o("tangram", xi),
            o("tower_game", Mo()),
            o("tower_game_entry", Ai),
            o("widescreen_image", Wi),
            o("window_color", ro),
            o("audio", $a),
            o("image", qa),
            o("video", qi)
        ]));
    }
    function uo() {
        return A2(Wt, Yu, co());
    }
    function co() {
        return A3(Yt, Qu, Wc, ao());
    }
    function ao() {
        return A2(_u, ti(to("association")), A2(_u, Xc, A3(zu, "success_text", Zc, A3(zu, "title", Zc, Qt(nc)))));
    }
    function io() {
        return A2(Wt, Sc, oo());
    }
    function oo() {
        return A3(Yt, jc, Wc, fo());
    }
    function fo() {
        return A3(Yt, Bc, A2(yu, "slug", Zc), zo());
    }
    function so() {
        return A2(Wt, ic, bo());
    }
    function bo() {
        return A3(Yt, oc, Wc, lo());
    }
    function lo() {
        return A2(_u, zo(), A3(zu, "inline", pu, A2(_u, gi, Qt(fc))));
    }
    function vo() {
        return A2(Wt, kc, mo());
    }
    function ho() {
        return A2(Wt, rc, go());
    }
    function go() {
        return A3(Yt, tc, Wc, $o());
    }
    function $o() {
        return A4(oa, "church_image", A2(Wt, ut, to("image")), ct, A4(oa, "regions", Va(mo()), l, A4(oa, "poi_container", A2(Wt, ut, to("poi_container")), ct, A3(zu, "napi_data", Sa, A4(oa, "groundplan_image", A2(Wt, ut, to("image")), ct, A4(oa, "description", A2(Wt, ut, Oo()), ct, A3(zu, "complex_visible", pu, Qt(ec))))))));
    }
    function mo() {
        return A3(Yt, Vc, Wc, po());
    }
    function po() {
        return A3(zu, "menu_level", wu, A4(oa, "image_gallery", A2(Wt, ut, To()), ct, A4(oa, "region_church_container", A2(Wt, ut, Fo()), ct, A4(oa, "region_topic_container", A2(Wt, ut, Ko()), ct, A4(oa, "description", A2(Wt, ut, _o()), ct, A3(zu, "longitude", Ha, A3(zu, "latitude", Ha, Qt(Ac))))))));
    }
    function wo() {
        return A2(Wt, uc, _o());
    }
    function _o() {
        return A3(Yt, cc, Wc, yo());
    }
    function yo() {
        return A2(Wt, ac, zo());
    }
    function zo() {
        return ti(Oo());
    }
    function Mo() {
        return A2(Wt, Lc, ko());
    }
    function ko() {
        return A4(wa, Pc, Wc, Xo(), xo());
    }
    function xo() {
        return A2(zu, "children", A2(Wt, Ba(function(n) {
            return 26 === n.$ ? ut(n.a.b.bf.b.a7) : ct;
        }), Va(Oo())))(Qt(ci));
    }
    function Co() {
        return A2(Wt, lc, Ho());
    }
    function Ho() {
        return A3(Yt, $c, Wc, Vo());
    }
    function Vo() {
        return A4(oa, "y_coord", wu, 0, A4(oa, "x_coord", wu, 0, A4(oa, "experiencing", A2(Wt, ut, Oo()), ct, A3(zu, "experiencing_id", wu, A4(oa, "believing", A2(Wt, ut, Oo()), ct, A3(zu, "believing_id", wu, A4(oa, "knowing", A2(Wt, ut, Oo()), ct, A3(zu, "knowing_id", wu, A4(oa, "image_gallery", ti(sa), l, A3(zu, "image_gallery_id", wu, A3(zu, "subtext", Zc, Qt(mc))))))))))));
    }
    function Ao() {
        return A2(Wt, sc, To());
    }
    function To() {
        return A4(wa, bc, Wc, Eo(), Ka);
    }
    function Eo() {
        return A2(Wt, dc, ti(A2(Gi, "image", Oo())));
    }
    function Oo() {
        return A2(Ic, function(n) {
            var r = A2(qu, n, eo());
            return r.$ ? Kc("invalid content type " + n) : r.a;
        }, A2(yu, "type", Zc));
    }
    function So() {
        return A2(Wt, vc, jo());
    }
    function jo() {
        return A3(Yt, hc, Wc, Bo());
    }
    function Bo() {
        return A2(Wt, gc, ti(to("poi")));
    }
    function Lo() {
        return A2(Wt, pc, Po());
    }
    function Po() {
        return A4(wa, wc, Wc, No(), Qt(ui));
    }
    function No() {
        return A2(_u, ti(to("quiz_question")), Qt(_c));
    }
    function Io() {
        return A2(Wt, yc, Go());
    }
    function Go() {
        return A4(wa, zc, Wc, Uo(), Qt(ei));
    }
    function Uo() {
        return A2(_u, ti(to("quiz_answer")), A4(oa, "description", Zc, "", A4(oa, "header_image", A2(Wt, ut, fa), ct, A4(oa, "header_image_id", A2(Wt, ut, wu), ct, A3(zu, "question", Zc, Qt(Mc))))));
    }
    function Do() {
        return A2(Wt, xc, Fo());
    }
    function Fo() {
        return A3(Yt, Cc, Wc, Ro());
    }
    function Ro() {
        return A2(Wt, Hc, ti(to("church")));
    }
    function qo() {
        return A2(Wt, Tc, Ko());
    }
    function Ko() {
        return A3(Yt, Ec, Wc, Zo());
    }
    function Zo() {
        return A2(Wt, Oc, ti(to("generic_region_topic")));
    }
    function Xo() {
        return A2(Wt, Nc, ti(to("tower_game_entry")));
    }
    var Jo = eo();
    eo = function() {
        return Jo;
    };
    var Wo = uo();
    uo = function() {
        return Wo;
    };
    var Yo = co();
    co = function() {
        return Yo;
    };
    var Qo = ao();
    ao = function() {
        return Qo;
    };
    var nf = io();
    io = function() {
        return nf;
    };
    var rf = oo();
    oo = function() {
        return rf;
    };
    var tf = fo();
    fo = function() {
        return tf;
    };
    var ef = so();
    so = function() {
        return ef;
    };
    var uf = bo();
    bo = function() {
        return uf;
    };
    var cf = lo();
    lo = function() {
        return cf;
    };
    var af = vo();
    vo = function() {
        return af;
    };
    var of = ho();
    ho = function() {
        return of;
    };
    var ff = go();
    go = function() {
        return ff;
    };
    var sf = $o();
    $o = function() {
        return sf;
    };
    var bf = mo();
    mo = function() {
        return bf;
    };
    var df = po();
    po = function() {
        return df;
    };
    var lf = wo();
    wo = function() {
        return lf;
    };
    var vf = _o();
    _o = function() {
        return vf;
    };
    var hf = yo();
    yo = function() {
        return hf;
    };
    var gf = zo();
    zo = function() {
        return gf;
    };
    var $f = Mo();
    Mo = function() {
        return $f;
    };
    var mf = ko();
    ko = function() {
        return mf;
    };
    var pf = xo();
    xo = function() {
        return pf;
    };
    var wf = Co();
    Co = function() {
        return wf;
    };
    var _f = Ho();
    Ho = function() {
        return _f;
    };
    var yf = Vo();
    Vo = function() {
        return yf;
    };
    var zf = Ao();
    Ao = function() {
        return zf;
    };
    var Mf = To();
    To = function() {
        return Mf;
    };
    var kf = Eo();
    Eo = function() {
        return kf;
    };
    var xf = Oo();
    Oo = function() {
        return xf;
    };
    var Cf = So();
    So = function() {
        return Cf;
    };
    var Hf = jo();
    jo = function() {
        return Hf;
    };
    var Vf = Bo();
    Bo = function() {
        return Vf;
    };
    var Af = Lo();
    Lo = function() {
        return Af;
    };
    var Tf = Po();
    Po = function() {
        return Tf;
    };
    var Ef = No();
    No = function() {
        return Ef;
    };
    var Of = Io();
    Io = function() {
        return Of;
    };
    var Sf = Go();
    Go = function() {
        return Sf;
    };
    var jf = Uo();
    Uo = function() {
        return jf;
    };
    var Bf = Do();
    Do = function() {
        return Bf;
    };
    var Lf = Fo();
    Fo = function() {
        return Lf;
    };
    var Pf = Ro();
    Ro = function() {
        return Pf;
    };
    var Nf = qo();
    qo = function() {
        return Nf;
    };
    var If = Ko();
    Ko = function() {
        return If;
    };
    var Gf = Zo();
    Zo = function() {
        return Gf;
    };
    var Uf = Xo();
    Xo = function() {
        return Uf;
    };
    var Df = F3(function(n, r, t) {
        return r(n(t));
    }), Ff = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Rf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qf = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Kf = {
        $: 2
    }, Zf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Jf = {
        $: 1
    }, Wf = function(n) {
        return !n.$;
    }, Yf = Vn, Qf = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return a = t.b, i = t.c, e = t.d, s = t.e, A5(Qc, 1, n.b, n.c, A5(Qc, 0, r.b, r.c, r.d, r.e), A5(Qc, 0, a, i, e, s));
            }
            var e, u = n.d, c = n.e, a = c.b, i = c.c, o = (e = c.d).d, f = e.e, s = c.e;
            return A5(Qc, 0, e.b, e.c, A5(Qc, 1, n.b, n.c, A5(Qc, 0, u.b, u.c, u.d, u.e), o), A5(Qc, 1, a, i, f, s));
        }
        return n;
    }, ns = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, d = t.e, A5(Qc, 1, e = n.b, u = n.c, A5(Qc, 0, r.b, r.c, r.d, i = r.e), A5(Qc, 0, f, s, b, d));
            }
            var e = n.b, u = n.c, c = n.d, a = c.d, i = c.e, o = n.e, f = o.b, s = o.c, b = o.d, d = o.e;
            return A5(Qc, 0, c.b, c.c, A5(Qc, 1, a.b, a.c, a.d, a.e), A5(Qc, 1, e, u, i, A5(Qc, 0, f, s, b, d)));
        }
        return n;
    }, rs = F7(function(n, r, t, e, u, c, a) {
        if (-1 !== c.$ || c.a) {
            n: for(;;){
                if (-1 === a.$ && 1 === a.a) {
                    if (-1 === a.d.$) {
                        if (1 === a.d.a) return ns(r);
                        break n;
                    }
                    return ns(r);
                }
                break n;
            }
            return r;
        }
        return A5(Qc, t, c.b, c.c, c.d, A5(Qc, 0, e, u, c.e, a));
    }), ts = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, c = u.d, a = n.e;
            if (1 === u.a) {
                if (-1 !== c.$ || c.a) {
                    var i = Qf(n);
                    if (-1 === i.$) {
                        var o = i.e;
                        return A5(na, i.a, i.b, i.c, ts(i.d), o);
                    }
                    return je;
                }
                return A5(Qc, r, t, e, ts(u), a);
            }
            return A5(Qc, r, t, e, ts(u), a);
        }
        return je;
    }, es = F2(function(n, r) {
        if (-2 === r.$) return je;
        var t = r.a, e = r.b, u = r.c, c = r.d, i = r.e;
        if (0 > a(n, e)) {
            if (-1 === c.$ && 1 === c.a) {
                var o = c.d;
                if (-1 !== o.$ || o.a) {
                    var f = Qf(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(na, f.a, f.b, f.c, A2(es, n, f.d), s);
                    }
                    return je;
                }
                return A5(Qc, t, e, u, A2(es, n, c), i);
            }
            return A5(Qc, t, e, u, A2(es, n, c), i);
        }
        return A2(us, n, A7(rs, n, r, t, e, u, c, i));
    }), us = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, u = r.b, c = r.c, a = r.d, i = r.e;
            if (t(n, u)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(i);
                return -1 === o.$ ? A5(na, e, o.b, o.c, a, ts(i)) : je;
            }
            return A5(na, e, u, c, a, A2(es, n, i));
        }
        return je;
    }), cs = F2(function(n, r) {
        var t = A2(es, n, r);
        return -1 !== t.$ || t.a ? t : A5(Qc, 1, t.b, t.c, t.d, t.e);
    }), as = F3(function(n, r, t) {
        var e = r(A2(qu, n, t));
        return e.$ ? A2(cs, n, t) : A3(ta, n, e.a, t);
    }), is = {
        $: 0
    }, os = Y, fs = F2(function(n, r) {
        return A3(Gr, "", re, A2(Df, r, n));
    }), ss = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), bs = {
        $: 2
    }, ds = {
        $: 1
    }, ls = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Wr(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(r.a));
            case 1:
                return Wr(ds);
            case 2:
                return Wr(bs);
            case 3:
                return Wr(A2(ss, r.a.fo, r.b));
            default:
                return A2(n, r.a, r.b);
        }
    }), vs = F2(function(n, r) {
        return A2(fs, n, ls(F2(function(n, t) {
            var e = A2(os, r, t);
            return e.$ ? Wr(function(n) {
                return {
                    $: 4,
                    a: n
                };
            }(kt(e.a))) : rt(e.a);
        })));
    }), hs = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gs = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $s = function(n) {
        return 1 === n.$ ? hs(n.a) : gs(n.a);
    }, ms = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ps = F2(function(n, r) {
        return {
            c0: n,
            dm: r
        };
    }), ws = me(A2(ps, Be, l)), _s = function(n) {
        return ln(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(dn(0));
        });
    }, ys = $n, zs = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var c = e.a;
                    return A2(ze, function(r) {
                        var e = c.a5;
                        return A3(zs, n, u, 1 === e.$ ? t : A3(ta, e.a, r, t));
                    }, ys(A3(Nr, n, Ce(n), c)));
                }
                var a = e.a, i = A2(qu, a, t);
                if (1 === i.$) {
                    r = u;
                    continue n;
                }
                return A2(ze, function() {
                    return A3(zs, n, u, A2(cs, a, t));
                }, _s(i.a));
            }
            return me(t);
        }
    }), Ms = F4(function(n, r, t, e) {
        return A2(ze, function(n) {
            return me(A2(ps, n, t));
        }, A3(zs, n, r, e.c0));
    }), ks = F4(function(n, r, e, u) {
        var c = u.b;
        return t(r, u.a) ? ut(A2(Ce, n, c(e))) : ct;
    }), xs = F3(function(n, r, t) {
        return A2(ze, function() {
            return me(t);
        }, xe(A2(Ba, A3(ks, n, r.a, r.b), t.dm)));
    }), Cs = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return ms({
                dC: t.dC,
                aN: t.aN,
                aU: A2(Ur, n, t.aU),
                aX: t.aX,
                aZ: t.aZ,
                a4: t.a4,
                a5: t.a5,
                a7: t.a7
            });
        }
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(r.a);
    }), Hs = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    kn.Http = xn(ws, Ms, xs, Cs, F2(function(n, r) {
        return A2(Hs, r.a, A2(Df, r.b, n));
    }));
    var Vs, As, Ts, Es, Os, Ss, js, Bs, Ls, Ps = An("Http"), Ns = (An("Http"), function(n) {
        return n.a + "=" + n.b;
    }), Is = F2(function(n, r) {
        return "/" + (A2(ft, "/", n) + function(n) {
            return n.b ? "?" + A2(ft, "&", A2(ye, Ns, n)) : "";
        }(r));
    }), Gs = function(n) {
        var r = n.b;
        return A2(Is, A2(Zr, "api", n.a), r);
    }, Us = F4(function(n, r, t, e) {
        var u;
        return u = {
            aN: is,
            aU: A2(vs, A2(Df, $s, A2(Df, re, t)), e),
            aX: l,
            aZ: "GET",
            a4: ct,
            a5: ct,
            a7: Gs(r)
        }, Ps(ms({
            dC: !1,
            aN: u.aN,
            aU: u.aU,
            aX: u.aX,
            aZ: u.aZ,
            a4: u.a4,
            a5: u.a5,
            a7: u.a7
        }));
    }), Ds = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Fs = function(n) {
        return encodeURIComponent(n);
    }, Rs = F2(function(n, r) {
        return A2(Ds, Fs(n), Fs(r));
    }), qs = function(n) {
        return A2(ye, function(n) {
            return A2(Rs, n.a, n.b);
        }, A2(tu, function(n) {
            return "" !== n.b;
        }, n));
    }, Ks = F3(function(n, r, t) {
        return A4(Us, n, o(g([
            "churches",
            ot(r)
        ]), qs(g([
            o("preview", A2(Ku, "", t))
        ]))), Wu, A2(yu, "data", ff));
    }), Zs = F3(function(n, r, t) {
        return f({
            C: Oe,
            M: 0,
            d8: ct,
            am: r,
            ab: l,
            ao: ct,
            a_: t,
            B: n
        }, A3(Ks, n, r, t), Xu);
    }), Xs = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Js = F3(function(n, r, t) {
        return A4(Us, n, o(g([
            "pois",
            ot(r)
        ]), qs(g([
            o("preview", A2(Ku, "", t))
        ]))), Xs, A2(yu, "data", A2(Ii, g([
            "poi",
            "poi_preview"
        ]), _f)));
    }), Ws = F4(function(n, r, t, e) {
        return f({
            bJ: r,
            aR: 0,
            aj: 0,
            J: Oe,
            cS: t,
            a_: e,
            B: n
        }, A3(Js, n, t, e), Xu);
    }), Ys = {
        $: 0
    }, Qs = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nb = F3(function(n, r, t) {
        return A4(Us, n, o(g([
            "regions",
            ot(r)
        ]), qs(g([
            o("preview", A2(Ku, "", t))
        ]))), Qs, A2(yu, "data", bf));
    }), rb = F3(function(n, r, t) {
        return f({
            aR: 0,
            M: Ys,
            am: r,
            a_: t,
            F: Oe,
            B: n
        }, A3(nb, n, r, t), Xu);
    }), tb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eb = F3(function(n, r, t) {
        var e;
        return A4(Us, n, o(g([
            "static",
            r
        ]), qs(g([
            o("preview", A2(Ku, "", t))
        ]))), tb, A2(yu, "data", (e = g([
            "static_page",
            "static_page_preview"
        ]), A2(Ii, e, xf))));
    }), ub = F3(function(n, r, t) {
        return f({
            a_: t,
            B: n,
            fl: r,
            ae: Oe
        }, A3(eb, n, r, t), Xu);
    }), cb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ab = F3(function(n, r, t) {
        return A4(Us, n, o(g([
            "topics",
            ot(r)
        ]), qs(g([
            o("preview", A2(Ku, "", t))
        ]))), cb, A2(yu, "data", A2(Ii, g([
            "generic_region_topic",
            "generic_region_topic_preview"
        ]), uf)));
    }), ib = F4(function(n, r, t, e) {
        return f({
            a_: e,
            cZ: r,
            B: n,
            T: Oe,
            ds: t
        }, A3(ab, n, t, e), Xu);
    }), ob = null, fb = Nn("reload", function() {
        return ob;
    }), sb = function(n) {
        switch(n.$){
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 0:
                return n.a.B;
            default:
                return n.a;
        }
    }, bb = function(n) {
        return {
            $: 11,
            a: n
        };
    }, db = En, lb = F3(function(n, r, t) {
        var e = t.b, u = t.c;
        return o(n(t.a), Ee(g([
            A2(db, r, e),
            A2(db, bb, u)
        ])));
    }), vb = F2(function(n, r) {
        var t = sb(r);
        if (1 === n.$) return o(Nu(t), Xu);
        switch(n.a.$){
            case 0:
                return r.$ ? A3(lb, Pu, Ou, function(n) {
                    return f({
                        an: ct,
                        ap: ct,
                        B: n
                    }, Xu, Xu);
                }(t)) : o(r, Xu);
            case 1:
                return A3(lb, Vu, Tu, function(n) {
                    return f(n, A2(Ae, function() {
                        return Fu;
                    }, A2(Ju, 0, A2(Zu, "churchlist", n))), Xu);
                }(t));
            case 2:
                var e = n.a;
                return A3(lb, Au, Eu, A3(Zs, t, e.a, e.b));
            case 6:
                var u = n.a;
                return A3(lb, Iu, Su, A4(Ws, t, u.a, u.b, u.c));
            case 4:
                var c = n.a;
                return A3(lb, Du, Lu, A4(ib, t, c.a, c.b, c.c));
            case 5:
                var a = n.a;
                return A3(lb, Uu, Bu, A3(ub, t, a.a, a.b));
            case 3:
                var i = n.a;
                return A3(lb, Gu, ju, A3(rb, t, i.a, i.b));
            default:
                return o(r, fb(0));
        }
    }), hb = function(n) {
        return {
            $: 12,
            a: n
        };
    }, gb = function(n) {
        return A4(Us, n, o(g([
            "churches"
        ]), qs(l)), hb, A2(yu, "data", Va(ff)));
    }, $b = function(n) {
        return {
            $: 13,
            a: n
        };
    }, mb = function(n) {
        return A4(Us, n, o(g([
            "regions"
        ]), qs(l)), $b, A2(yu, "data", Va(bf)));
    }, pb = F5(function(n, r, t, e, u) {
        return {
            Y: e,
            aa: t,
            U: r,
            dw: u,
            ah: n
        };
    }), wb = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Zr, n.a, wb(n.b)) : l;
    }, _b = F2(function(n, r) {
        return ut(1 === r.$ ? g([
            n
        ]) : A2(Zr, n, r.a));
    }), yb = function(n) {
        try {
            return ut(decodeURIComponent(n));
        } catch (n) {
            return ct;
        }
    }, zb = F2(function(n, r) {
        var t = A2(st, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = yb(t.a);
            if (1 === u.$) return r;
            var c = u.a, a = yb(e);
            return 1 === a.$ ? r : A3(as, c, _b(a.a), r);
        }
        return r;
    }), Mb = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.U;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return ut(r.dw);
                    }
                    return ut(r.dw);
                }
                return ct;
            }
        }(n(A5(pb, l, function(n) {
            var r = A2(st, "/", n);
            return wb(r.b && "" === r.a ? r.b : r);
        }(r.cP), 1 === (t = r.cY).$ ? Be : A3(_e, zb, Be, A2(st, "&", t.a)), r.b9, re)));
    }), kb = {
        $: 1
    }, xb = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Cb = {
        $: 0
    }, Hb = F3(function(n, r, t) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t
        };
    }), Vb = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ab = {
        $: 7
    }, Tb = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Eb = F3(function(n, r, t) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t
        };
    }), Ob = F2(function(n, r) {
        return function(n) {
            var t = n.ah, e = n.U, u = n.aa, c = n.Y, a = n.dw;
            if (e.b) {
                var i = e.a, o = e.b, f = r(i);
                if (f.$) return l;
                var s = f.a;
                return g([
                    A5(pb, A2(Zr, i, t), o, u, c, a(s))
                ]);
            }
            return l;
        };
    }), Sb = A2(Ob, "NUMBER", se), jb = F2(function(n, r) {
        return A5(pb, r.ah, r.U, r.aa, r.Y, n(r.dw));
    }), Bb = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.ah, u = r.U, c = r.aa, a = r.Y;
            return A2(ye, jb(r.dw), t(A5(pb, e, u, c, a, n)));
        };
    }), Lb = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Je, e, t(n));
        };
    }), Pb = F2(function(n, r) {
        return A2(Lb, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.aa;
                return g([
                    A5(pb, n.ah, n.U, t, n.Y, (0, n.dw)(r(t)))
                ]);
            };
        }(r));
    }), Nb = function(n) {
        return function(r) {
            var e = r.ah, u = r.U, c = r.aa, a = r.Y, i = r.dw;
            if (u.b) {
                var o = u.a, f = u.b;
                return t(o, n) ? g([
                    A5(pb, A2(Zr, o, e), f, c, a, i)
                ]) : l;
            }
            return l;
        };
    }, Ib = A2(Ob, "STRING", ut), Gb = F2(function(n, r) {
        return function(t) {
            return r(A2(Ku, l, A2(qu, n, t)));
        };
    }), Ub = function(n) {
        return A2(Gb, n, function(n) {
            return n.b && !n.b.b ? ut(n.a) : ct;
        });
    }, Db = function(n) {
        return g([
            n
        ]);
    }, Fb = (Vs = g([
        A2(Bb, Cb, Db),
        A2(Bb, kb, Nb("churches")),
        A2(Bb, xb, A2(Lb, Nb("church"), A2(Pb, Sb, Ub("preview")))),
        A2(Bb, Tb, A2(Lb, Nb("info"), A2(Pb, Ib, Ub("preview")))),
        A2(Bb, Hb, A2(Lb, Nb("church"), A2(Lb, Sb, A2(Lb, Nb("pois"), A2(Pb, Sb, Ub("preview")))))),
        A2(Bb, Ab, Nb("reload")),
        A2(Bb, Vb, A2(Lb, Nb("region"), A2(Pb, Sb, Ub("preview")))),
        A2(Bb, Eb, A2(Lb, Nb("region"), A2(Lb, Sb, A2(Lb, Nb("topic"), A2(Pb, Sb, Ub("preview"))))))
    ]), function(n) {
        return A2(Je, function(r) {
            return r(n);
        }, Vs);
    }), Rb = function(n) {
        return A2(Mb, Fb, n);
    }, qb = Nn("refreshView", function() {
        return ob;
    }), Kb = F3(function(n, r, t) {
        var e = A2(Hu, n, t), u = A2(vb, Rb(r), Te(e)), c = u.b;
        return o(u.a, Ee(g([
            qb(0),
            c,
            gb(e),
            mb(e)
        ])));
    }), Zb = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Xb = F2(function(n) {
        return n;
    }), Jb = Tn, Wb = Un("consentAll", aa), Yb = {
        $: 1
    }, Qb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nd = Qb(Yb), rd = Un("consentNone", aa), td = Qb({
        $: 2
    }), ed = function(n) {
        return n.$ ? ct : ut(n.a);
    }, ud = function(n) {
        return function(n) {
            return {
                $: 15,
                a: n
            };
        }(ed(A2(Se, Ha, n)));
    }, cd = Un("gotPopstatePosition", aa), ad = function(n) {
        return {
            $: 4,
            a: n
        };
    }, id = Un("groundplanPoiSelected", aa), od = En, fd = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sd = Un("mapChurchSelected", aa), bd = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dd = Un("mapRegionSelected", aa), ld = Un("mapViewportChanged", aa), vd = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), hd = Lr(function() {
        var n, r;
        return {
            c7: (n = jr.body, r = jr.documentElement, {
                fC: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
                eb: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
            }),
            fB: {
                dy: Br.pageXOffset,
                fF: Br.pageYOffset,
                fC: jr.documentElement.clientWidth,
                eb: jr.documentElement.clientHeight
            }
        };
    }), gd = F4(function(n, r, t, e) {
        var u = n;
        if (3 === u.$) {
            var c = u.a;
            return f(r(u), t(c), e(c));
        }
        return f(r(u), Xu, Xu);
    }), $d = F2(function(n, r) {
        return A4(gd, n, r, function() {
            return Xu;
        }, function() {
            return Xu;
        });
    }), md = F2(function(n, r) {
        switch(n.$){
            case 2:
                return Au(b(n.a, {
                    B: r
                }));
            case 1:
                return Vu(r);
            case 3:
                return Iu(b(n.a, {
                    B: r
                }));
            case 4:
                return Gu(b(n.a, {
                    B: r
                }));
            case 5:
                return Du(b(n.a, {
                    B: r
                }));
            case 6:
                return Uu(b(n.a, {
                    B: r
                }));
            case 0:
                return Pu(b(n.a, {
                    B: r
                }));
            case 7:
                return Nu(r);
            default:
                return Te(r);
        }
    }), pd = Or, wd = function(n) {
        return "church-" + ot(n.am);
    }, _d = F3(function(n, r, t) {
        var e = t.aF;
        return b(t, 1 === e.$ ? {
            ad: A3(ta, n, r, t.ad)
        } : {
            aF: ct,
            ad: A3(ta, n, e.a, t.ad)
        });
    }), yd = F2(function(n, r) {
        var t = function(n) {
            switch(n.$){
                case 1:
                    return "churchlist";
                case 2:
                    return wd(n.a);
                default:
                    return "";
            }
        }(r);
        return A2(md, r, A3(_d, t, n, sb(r)));
    }), zd = F2(function(n, r) {
        return b(r, {
            dO: n
        });
    }), Md = F3(function(n, r, t) {
        return {
            bg: n,
            bh: r,
            fH: t
        };
    }), kd = F3(function(n, r, t) {
        return A2(_u, A2(ua, n, r), t);
    }), xd = A3(zu, "zoom", wu, A3(kd, g([
        "center",
        "lng"
    ]), Ha, A3(kd, g([
        "center",
        "lat"
    ]), Ha, Qt(Md)))), Cd = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), Hd = F2(function(n, r) {
        return b(r, {
            eu: A3(Cd, r.eu, ut, ed(A2(Se, xd, n)))
        });
    }), Vd = F2(function(n, r) {
        return b(r, {
            aF: n
        });
    }), Ad = F2(function(n, r) {
        return b(r, {
            fa: n
        });
    }), Td = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + ot(n.a);
    }), Ed = F3(function(n, r, t) {
        return 1 === r.$ ? t : d(t, d(n, r.a));
    }), Od = Nn("trackPageView", function() {
        return ob;
    }), Sd = function(n) {
        var r = function() {
            switch(n.$){
                case 0:
                    return l;
                case 1:
                    return g([
                        "churches"
                    ]);
                case 2:
                    var r = n.a;
                    if (1 === (u = n.b).$) return g([
                        "church",
                        ot(r)
                    ]);
                    var t = u.a;
                    return g([
                        "church",
                        ot(r) + "?preview=" + t
                    ]);
                case 6:
                    var e = n.a;
                    return r = n.b, 1 === (u = n.c).$ ? g([
                        "church",
                        ot(e),
                        "pois",
                        ot(r)
                    ]) : (t = u.a, g([
                        "church",
                        ot(e),
                        "pois",
                        ot(r) + "?preview=" + t
                    ]));
                case 3:
                    return r = n.a, 1 === (u = n.b).$ ? g([
                        "region",
                        ot(r)
                    ]) : (t = u.a, g([
                        "region",
                        ot(r) + "?preview=" + t
                    ]));
                case 4:
                    var u, c = n.a;
                    return r = n.b, 1 === (u = n.c).$ ? g([
                        "region",
                        ot(c),
                        "topic",
                        ot(r)
                    ]) : (t = u.a, g([
                        "region",
                        ot(c),
                        "topic",
                        ot(r) + "?preview=" + t
                    ]));
                case 5:
                    return g([
                        "info",
                        n.a
                    ]);
                default:
                    return g([
                        "reload"
                    ]);
            }
        }();
        return "/" + A2(ft, "/", r);
    }, jd = F2(function(n, r) {
        return A2(pd, n, Sd(r));
    }), Bd = F2(function(n, r) {
        return f(r, n.$ ? Xu : A2(jd, r.eG, A2(xb, n.a, ct)), Xu);
    }), Ld = {
        $: 8
    }, Pd = F2(function(n, r) {
        return r.$ ? ct : n(r.a);
    }), Nd = function(n) {
        switch(n.$){
            case 0:
                return {
                    a: l,
                    d: n.a.a,
                    f: ct
                };
            case 1:
                return {
                    a: (e = (r = n.a).b).a,
                    d: t = r.a,
                    f: ut(function(n) {
                        return Yu(A2(Qu, t, b(e, {
                            a: n(e.a)
                        })));
                    })
                };
            case 2:
            case 4:
            case 6:
            case 5:
            case 8:
            case 10:
            case 11:
            case 12:
            case 14:
            case 16:
            case 18:
            case 21:
            case 23:
            case 24:
            case 26:
            case 27:
            case 28:
            case 29:
            case 30:
            default:
                return function(n) {
                    return {
                        a: l,
                        d: n.a,
                        f: ct
                    };
                }(n.a);
            case 3:
                return function(n) {
                    var r = n.a, t = n.b;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return uc(A2(cc, r, b(t, {
                                a: n(t.a)
                            })));
                        })
                    };
                }(n.a);
            case 7:
                return function(n) {
                    var r = n.a, t = n.b;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return ic(A2(oc, r, b(t, {
                                a: n(t.a)
                            })));
                        })
                    };
                }(n.a);
            case 9:
                return function(n) {
                    var r = n.a, t = n.b, e = n.c;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return sc(A3(bc, r, b(t, {
                                a: n(t.a)
                            }), e));
                        })
                    };
                }(n.a);
            case 13:
                return function(n) {
                    var r = n.a, t = n.b;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return vc(A2(hc, r, b(t, {
                                a: n(t.a)
                            })));
                        })
                    };
                }(n.a);
            case 15:
                return function(n) {
                    var r = n.a, t = n.b, e = n.c;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return pc(A3(wc, r, b(t, {
                                a: n(t.a)
                            }), e));
                        })
                    };
                }(n.a);
            case 17:
                return function(n) {
                    var r = n.a, t = n.b, e = n.c;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return yc(A3(zc, r, b(t, {
                                a: n(t.a)
                            }), e));
                        })
                    };
                }(n.a);
            case 20:
                return function(n) {
                    var r = n.a, t = n.b;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return xc(A2(Cc, r, b(t, {
                                a: n(t.a)
                            })));
                        })
                    };
                }(n.a);
            case 19:
                return function(n) {
                    var r = n.a, t = n.b;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return Tc(A2(Ec, r, b(t, {
                                a: n(t.a)
                            })));
                        })
                    };
                }(n.a);
            case 22:
                return function(n) {
                    var r = n.a, t = n.b;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return Sc(A2(jc, r, b(t, {
                                a: n(t.a)
                            })));
                        })
                    };
                }(n.a);
            case 25:
                return function(n) {
                    var r = n.a, t = n.b, e = n.c;
                    return {
                        a: t.a,
                        d: r,
                        f: ut(function(n) {
                            return Lc(A3(Pc, r, b(t, {
                                a: n(t.a)
                            }), e));
                        })
                    };
                }(n.a);
        }
        var r, t, e;
    }, Id = A2(Df, Nd, function(n) {
        return n.a;
    }), Gd = F2(function(n, r) {
        return A2(Zr, n(r), A2(Je, Gd(n), Id(r)));
    }), Ud = fn, Dd = function(n) {
        return A3(dt, F2(function(n, r) {
            return A3(bn, n.a, n.b, r);
        }), {}, n);
    }, Fd = fn, Rd = F2(function(n, r) {
        var t = A2(Cd, Fd(""), function(n) {
            return Fd(n.a7);
        });
        return Dd(g([
            o("id", Ud(n.am)),
            o("centerImageUrl", t(r.aO)),
            o("innerLeftImageUrl", t(r.cl)),
            o("innerRightImageUrl", t(r.cm)),
            o("outerLeftImageUrl", t(r.cN)),
            o("outerRightImageUrl", t(r.cO))
        ]));
    }), qd = fn, Kd = F2(function(n, r) {
        var t = A2(Cd, Fd(""), function(n) {
            return Fd(n.a7);
        });
        return Dd(g([
            o("id", Ud(n.am)),
            o("centerImageUrl", t(r.aO)),
            o("openedOnceInnerLeftImageUrl", t(r.cC)),
            o("openedOnceInnerRightImageUrl", t(r.cD)),
            o("openedOnceOuterLeftImageUrl", t(r.cE)),
            o("openedOnceOuterRightImageUrl", t(r.cF)),
            o("openedTwiceInnerLeftImageUrl", t(r.cG)),
            o("openedTwiceInnerRightImageUrl", t(r.cH)),
            o("openedTwiceOuterLeftImageUrl", t(r.cI)),
            o("openedTwiceOuterRightImageUrl", t(r.cJ))
        ]));
    }), Zd = function(n) {
        switch(n){
            case 0:
                return "Closed";
            case 1:
                return "OpenedOnce";
            default:
                return "OpenedTwice";
        }
    }, Xd = function(n) {
        return Dd(g([
            o("state", Fd(Zd(n.di)))
        ]));
    }, Jd = function(n) {
        switch(n){
            case 0:
                return "ClosedToOpenedOnce";
            case 1:
                return "OpenedOnceToOpenedTwice";
            case 2:
                return "OpenedTwiceToOpenedOnce";
            case 3:
                return "OpenedOnceToClosed";
            default:
                return "None";
        }
    }, Wd = Nn("renderAltar", re), Yd = Nn("renderTripleAltar", re), Qd = function(n) {
        return Ee(A2(Gd, function(n) {
            switch(n.$){
                case 5:
                    var r = n.a, t = r.c;
                    return Wd(Dd(g([
                        o("data", A2(Rd, r.a, r.b)),
                        o("state", (a = t, Dd(g([
                            o("isOpen", qd(a.co))
                        ]))))
                    ])));
                case 6:
                    var e = n.a, u = e.c;
                    return Yd(Dd(g([
                        o("data", A2(Kd, e.a, e.b)),
                        o("state", Xd(u)),
                        o("transition", (c = u, Dd(g([
                            o("transition", Fd(Jd(c.du)))
                        ]))))
                    ])));
                default:
                    return Xu;
            }
            var c, a;
        }, n));
    }, nl = {
        $: 0
    }, rl = F2(function(n, r) {
        switch(r.$){
            case 3:
                return gs(n(r.a));
            case 1:
                return Oe;
            case 0:
                return nl;
            default:
                return hs(r.a);
        }
    }), tl = F2(function(n, r) {
        return 3 === r.$ ? r.a : n;
    }), el = A2(Df, rl(ut), tl(ct)), ul = function(n) {
        return A3(Cd, Xu, Qd, A2(Pd, function(n) {
            return n.b.ba;
        }, el(n)));
    }, cl = function(n) {
        switch(n){
            case 0:
                return "None";
            case 1:
                return "Description";
            case 2:
                return "Openings & Contact";
            case 3:
                return "Church Services";
            case 4:
                return "Other Events";
            default:
                return "Groundplan";
        }
    }, al = F2(function(n, r) {
        return A3(dt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), il = Nn("trackEvent", re), ol = F2(function(n, r) {
        return il(A2(al, Fd, g([
            "ContentDetailChanged",
            n,
            cl(r)
        ])));
    }), fl = F2(function(n, r) {
        return r.$ ? ct : ut(n(r.a));
    }), sl = F3(function(n, r, t) {
        return A2(Ku, Xu, A2(fl, function(t) {
            return il(A2(al, Fd, g([
                n,
                r + " | " + t.a.eE
            ])));
        }, t));
    }), bl = fn, dl = F2(function(n, r) {
        return Dd(g([
            o("latitude", bl(n)),
            o("longitude", bl(r))
        ]));
    }), ll = function(n) {
        return A2(Je, function(n) {
            return 29 === n.$ ? A2(Zr, n.a, ll(n)) : ll(n);
        }, Nd(n).a);
    }, vl = F2(function(n, r) {
        for(;;){
            if (!r.b) return ct;
            var t = r.a, e = r.b;
            if (n(t)) return ut(t);
            r = e;
        }
    }), hl = F3(function(n, r, t) {
        return 3 === t.$ ? r(t.a) : n;
    }), gl = function(n) {
        return A3(hl, "", function(n) {
            return n.a.eE;
        }, n.C);
    }, $l = F2(function(n, r) {
        var t, e, u = n.a, c = n.b, a = (t = c.e2).$ || 13 !== t.a.$ ? l : A2(Ba, function(n) {
            return 12 === n.$ ? ut(n.a) : ct;
        }, t.a.a.b.a), i = (e = c.d8).$ || 30 !== e.a.$ ? ct : ut(e.a.a.b);
        return b(r, {
            C: gs(A2(tc, u, c)),
            d8: i,
            ab: a
        });
    }), ml = F2(function(n, r) {
        return r(n);
    }), pl = Nn("openNavigation", re), wl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _l = A2(Ae, re, me({
        $: 1
    })), yl = A2(db, wl, _l), zl = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ml = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return ct;
            var e = t.b;
            if (r(t.a)) return ut(n);
            n += 1, t = e;
        }
    }), kl = Ml(0), xl = F2(function(n, r) {
        var t = A2(Ku, 0, A2(kl, Pt(r), n));
        return A2(Ae, re, me(A2(zl, n, t)));
    }), Cl = F2(function(n, r) {
        return A2(db, wl, A2(xl, n, r));
    }), Hl = Nn("renderGalleryGame", re), Vl = Nn("renderTowerGame", re), Al = F2(function(n, r) {
        return A2(tc, r.a, b(r.b, {
            ba: ut(n)
        }));
    }), Tl = F2(function(n, r) {
        switch(n.$){
            case 1:
                return f(r, A2(jd, r.B.eG, A3(Hb, r.am, n.a, r.a_)), Xu);
            case 2:
                return f(r, A2(jd, r.B.eG, A2(Vb, n.a, r.a_)), Xu);
            case 0:
                var e = n.a, u = A2(ol, gl(r), e);
                return f(b(r, {
                    M: e
                }), Ee(g([
                    u,
                    ul(r.C)
                ])), Xu);
            case 3:
                return A2(ml, n.a, function(n) {
                    if (3 === n.$) {
                        var t = n.a, e = A2(Ae, function() {
                            return Ld;
                        }, A2(Ju, 0, A2(Zu, wd(r), r.B)));
                        return f(A2($l, t, r), Ee(g([
                            ul(n),
                            e
                        ])), Xu);
                    }
                    return f(b(r, {
                        C: n,
                        d8: ct,
                        ab: l
                    }), Xu, Xu);
                });
            case 4:
                var c = A2(Pd, function(n) {
                    return A2(vl, function(r) {
                        return t(r.a.am, n);
                    }, r.ab);
                }, ed(A2(Se, wu, n.a)));
                return u = A3(sl, "PoiPopupOpened", gl(r), c), f(b(r, {
                    ao: c
                }), u, Xu);
            case 5:
                return u = A3(sl, "PoiPopupClosed", gl(r), r.ao), f(b(r, {
                    ao: ct
                }), u, Xu);
            case 6:
                var a = n.a;
                switch(a.$){
                    case 0:
                        var i = a.a;
                        return f(r, Xu, A2(Cl, function(n) {
                            return A2(Ku, l, A2(fl, ll, A2(Pd, function(n) {
                                return n.b.ba;
                            }, el(n.C))));
                        }(r), i));
                    case 1:
                        return f(r, Xu, yl);
                    case 2:
                        var o = a.a;
                        return f(b(r, {
                            C: A2(rl, Al(o), r.C)
                        }), Qd(o), Xu);
                    case 3:
                        return f(r, Hl(a.a), Xu);
                    default:
                        return f(r, Vl(A2(al, Fd, a.a)), Xu);
                }
            case 7:
                return f(r, pl(A2(dl, n.a, n.b)), Xu);
            default:
                return f(r, Xu, Xu);
        }
    }), El = F2(function(n, r) {
        return A2(Ku, Xu, A2(fl, function(r) {
            return il(A2(al, Fd, g([
                n,
                r.a.eE
            ])));
        }, r));
    }), Ol = F2(function(n, r) {
        return A2(Ku, Xu, A2(fl, function(r) {
            return il(A2(al, Fd, g([
                n,
                r.a.eE
            ])));
        }, r));
    }), Sl = F2(function(n, r) {
        switch(n.$){
            case 0:
                var e = n.a, u = A2(tl, l, r.B.dO), c = A2(Pd, function(n) {
                    return A2(vl, function(r) {
                        return t(r.a.am, n);
                    }, u);
                }, ed(A2(Se, wu, e))), a = A2(El, "ChurchPopupOpened", c);
                return f(b(r, {
                    an: c
                }), a, Xu);
            case 1:
                return a = A2(El, "ChurchPopupClosed", r.an), f(b(r, {
                    an: ct
                }), a, Xu);
            case 2:
                return f(r, A2(jd, r.B.eG, A2(xb, n.a, ct)), Xu);
            case 3:
                e = n.a;
                var i = A2(tl, l, r.B.fa), o = A2(Pd, function(n) {
                    return A2(vl, function(r) {
                        return t(r.a.am, n);
                    }, i);
                }, ed(A2(Se, wu, e)));
                return a = A2(Ol, "RegionPopupOpened", o), f(b(r, {
                    ap: o
                }), a, Xu);
            case 4:
                return a = A2(Ol, "RegionPopupClosed", r.ap), f(b(r, {
                    ap: ct
                }), a, Xu);
            default:
                return f(r, A2(jd, r.B.eG, A2(Vb, n.a, ct)), Xu);
        }
    }), jl = function(n) {
        return n.b;
    }, Bl = F2(function(n, r) {
        switch(n){
            case 0:
                return r.eq;
            case 1:
                return r.dH;
            default:
                return r.d1;
        }
    }), Ll = F2(function(n, r) {
        return A3(Cd, Xu, Qd, A2(Pd, Bl(r), A2(fl, jl, el(n))));
    }), Pl = function(n) {
        switch(n){
            case 0:
                return "Knowing";
            case 1:
                return "Believing";
            default:
                return "Experiencing";
        }
    }, Nl = F2(function(n, r) {
        return A2(tl, Xu, A2(rl, function(n) {
            return il(A2(al, Fd, g([
                "PoiTabShown",
                n.a.eE,
                Pl(r)
            ])));
        }, n));
    }), Il = F3(function(n, r, t) {
        var e = t.a, u = t.b;
        switch(n){
            case 0:
                return A2($c, e, b(u, {
                    eq: ut(r)
                }));
            case 1:
                return A2($c, e, b(u, {
                    dH: ut(r)
                }));
            default:
                return A2($c, e, b(u, {
                    d1: ut(r)
                }));
        }
    }), Gl = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(ml, n.a, function(n) {
                    var t = A2(Nl, n, 0), e = A2(Ll, n, 0);
                    return f(b(r, {
                        J: n
                    }), Ee(g([
                        t,
                        e
                    ])), Xu);
                });
            case 1:
                var t = n.a, e = A2(Nl, r.J, t), u = A2(Ll, r.J, t);
                return f(b(r, {
                    aj: t
                }), Ee(g([
                    e,
                    u
                ])), Xu);
            case 2:
                return f(b(r, {
                    aR: n.a
                }), Xu, Xu);
            default:
                var c = n.a;
                switch(c.$){
                    case 0:
                        var a = c.a;
                        return f(r, Xu, A2(Cl, function(n) {
                            return A3(Cd, l, ll, A2(Pd, Bl(n.aj), A2(fl, jl, el(n.J))));
                        }(r), a));
                    case 1:
                        return f(r, Xu, yl);
                    case 2:
                        var i = c.a;
                        return u = Qd(i), f(b(r, {
                            J: A2(rl, A2(Il, r.aj, i), r.J)
                        }), u, Xu);
                    case 3:
                        return f(r, Hl(c.a), Xu);
                    default:
                        return f(r, Vl(A2(al, Fd, c.a)), Xu);
                }
        }
    }), Ul = F2(function(n, r) {
        return n.$ ? r : A2(Zr, n.a, r);
    }), Dl = A2(_e, Ul, l), Fl = function(n) {
        return A3(Cd, Xu, Ee, A2(fl, ye(Qd), A2(fl, function(n) {
            var r = n.b;
            return Dl(g([
                A2(fl, uc, r.ba),
                A2(fl, Tc, r.e9),
                A2(fl, xc, r.e8)
            ]));
        }, el(n))));
    }, Rl = function(n) {
        switch(n.$){
            case 0:
                return "None";
            case 1:
                return "Description";
            case 2:
                return "Church Services";
            case 3:
                return "Other Events";
            default:
                return n.b;
        }
    }, ql = F2(function(n, r) {
        return il(A2(al, Fd, g([
            "RegionContentDetailChanged",
            n,
            Rl(r)
        ])));
    }), Kl = A2(Df, Nd, A2(Df, function(n) {
        return n.d;
    }, function(n) {
        return n.am;
    })), Zl = function(n) {
        return 20 === n.$ ? ut(n.a) : ct;
    }, Xl = F2(function(n, r) {
        return A2(Ku, function() {
            return r;
        }, Nd(r).f)(n(r));
    }), Jl = F2(function(n, r) {
        return t(Kl(r), Kl(n)) ? n : A2(Xl, F2(function(r, t) {
            return A2(ye, Jl(n), t);
        }), r);
    }), Wl = F2(function(n, r) {
        var t = r.b;
        return A2(Vc, r.a, b(t, {
            e8: A2(Pd, re, A2(fl, Zl, A2(fl, Jl(n), A2(fl, xc, t.e8))))
        }));
    }), Yl = function(n) {
        return 3 === n.$ ? ut(n.a) : ct;
    }, Ql = F2(function(n, r) {
        var t = r.b;
        return A2(Vc, r.a, b(t, {
            ba: A2(Pd, re, A2(fl, Yl, A2(fl, Jl(n), A2(fl, uc, t.ba))))
        }));
    }), nv = function(n) {
        return 19 === n.$ ? ut(n.a) : ct;
    }, rv = F2(function(n, r) {
        var t = r.b;
        return A2(Vc, r.a, b(t, {
            e9: A2(Pd, re, A2(fl, nv, A2(fl, Jl(n), A2(fl, Tc, t.e9))))
        }));
    }), tv = F2(function(n, r) {
        switch(n.$){
            case 1:
                return f(r, A2(jd, r.B.eG, A2(xb, n.a, r.a_)), Xu);
            case 2:
                return f(r, A2(jd, r.B.eG, A3(Eb, r.am, n.a, r.a_)), Xu);
            case 0:
                var e = n.a, u = A2(ql, function(n) {
                    return A2(tl, "Region", A2(rl, function(n) {
                        return n.a.eE;
                    }, n.F));
                }(r), e), c = Fl(r.F);
                return f(b(r, {
                    M: e
                }), Ee(g([
                    u,
                    c
                ])), Xu);
            case 5:
                return f(b(r, {
                    aR: n.a
                }), Xu, Xu);
            case 3:
                return A2(ml, n.a, function(n) {
                    return f(b(r, {
                        F: n
                    }), Fl(n), Xu);
                });
            default:
                var a = n.a;
                switch(a.$){
                    case 0:
                        var i = a.a;
                        return f(r, Xu, A2(Cl, function(n) {
                            var r = function() {
                                var r = n.M;
                                switch(r.$){
                                    case 1:
                                        return A2(fl, uc, A2(Pd, function(n) {
                                            return n.b.ba;
                                        }, el(n.F)));
                                    case 4:
                                        var e = r.a;
                                        return A2(Pd, vl(function(n) {
                                            return t(Kl(n), e);
                                        }), A2(fl, function(n) {
                                            return n.b.a;
                                        }, A2(Pd, function(n) {
                                            return n.b.e9;
                                        }, el(n.F))));
                                    default:
                                        return ct;
                                }
                            }();
                            return A3(Cd, l, ll, r);
                        }(r), i));
                    case 1:
                        return f(r, Xu, yl);
                    case 2:
                        var o = a.a;
                        return f(b(r, {
                            F: A2(rl, Wl(o), A2(rl, rv(o), A2(rl, Ql(o), r.F)))
                        }), Qd(o), Xu);
                    case 3:
                        return f(r, Hl(a.a), Xu);
                    default:
                        return f(r, Vl(A2(al, Fd, a.a)), Xu);
                }
        }
    }), ev = F2(function(n, r) {
        if (!n.$) return A2(ml, n.a, function(n) {
            return f(b(r, {
                ae: n
            }), function(n) {
                return A3(hl, Xu, Qd, n);
            }(n), Xu);
        });
        var t = n.a;
        switch(t.$){
            case 0:
                var e = t.a;
                return f(r, Xu, A2(Cl, function(n) {
                    return A3(hl, l, ll, n.ae);
                }(r), e));
            case 1:
                return f(r, Xu, yl);
            case 2:
                var u = t.a;
                return f(b(r, {
                    ae: gs(u)
                }), Qd(u), Xu);
            case 3:
                return f(r, Hl(t.a), Xu);
            default:
                return f(r, Vl(A2(al, Fd, t.a)), Xu);
        }
    }), uv = F2(function(n, r) {
        return 7 === n.$ ? n.a : r;
    }), cv = F2(function(n, r) {
        if (!n.$) return A2(ml, n.a, function(n) {
            var t;
            return f(b(r, {
                T: n
            }), (t = n, A3(hl, Xu, A2(Df, ic, Qd), t)), Xu);
        });
        var t = n.a;
        switch(t.$){
            case 0:
                var e = t.a;
                return f(r, Xu, A2(Cl, function(n) {
                    return A3(hl, l, A2(Df, ic, ll), n.T);
                }(r), e));
            case 1:
                return f(r, Xu, yl);
            case 2:
                var u = t.a, c = Qd(u);
                return f(b(r, {
                    T: A2(rl, uv(u), r.T)
                }), c, Xu);
            case 3:
                return f(r, Hl(t.a), Xu);
            default:
                return f(r, Vl(A2(al, Fd, t.a)), Xu);
        }
    }), av = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iv = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ov = Nn("back", function() {
        return ob;
    }), fv = Nn("reconfigureConsent", function() {
        return ob;
    }), sv = F3(function(n, r, t) {
        return 0 > a(t, n) ? n : a(t, r) > 0 ? r : t;
    }), bv = Nn("controlAudioPlayer", re), dv = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), lv = function(n) {
        return n.b ? ut(n.a) : ct;
    }, vv = F2(function(n, r) {
        return 0 > n ? ct : lv(A2(dv, n, r));
    }), hv = F2(function(n, r) {
        var e = A3(sv, 0, lt(n.X) - 1, n.L + r), u = A2(vv, e, n.X), c = n.V ? 0 > r ? "prev" : "next" : "load";
        return t(n.L, e) ? o(n, Xu) : o(b(n, {
            dT: u,
            L: e
        }), bv(Fd(c)));
    }), gv = function(n) {
        return !n;
    }, $v = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.b;
                return o(b(r, {
                    dT: A2(vv, e, t),
                    X: t,
                    L: e
                }), bv(Fd("load")));
            case 1:
                return o(r, bv(Fd("pause")));
            case 2:
                return A2(hv, r, 1);
            case 3:
                return A2(hv, r, -1);
            case 4:
                return o(b(r, {
                    aM: !1
                }), Xu);
            case 5:
                return o(b(r, {
                    dT: ct
                }), Xu);
            default:
                return o(b(r, {
                    V: !r.V
                }), Xu);
        }
    }), mv = {
        $: 0
    }, pv = Nn("saveConsent", re), wv = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return o(b(r, {
                    bq: !1
                }), pv(Dd(g([
                    o("functionalConsent", qd(r.Z)),
                    o("trackingConsent", qd(r.af))
                ]))));
            case 1:
                n = mv, r = b(r, {
                    Z: !0,
                    af: !0
                });
                continue n;
            case 2:
                n = mv, r = b(r, {
                    Z: !1,
                    af: !1
                });
                continue n;
            case 3:
                return o(b(r, {
                    Z: n.a
                }), Xu);
            default:
                return o(b(r, {
                    af: n.a
                }), Xu);
        }
    }), _v = F2(function(n, r) {
        var e = r.a, u = r.b;
        return t(n, e) ? o(e, b(u, {
            aW: !0
        })) : o(e, u);
    }), yv = Mn, zv = F2(function(n, r) {
        return A2(Ae, function() {
            return n;
        }, yv(r));
    }), Mv = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return o(o(t + 1, A2(Zr, o(t, n.a), e)), A2(zv, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(t), 5e3));
            case 1:
                return o(o(u = n.a, A2(ye, _v(u), e)), A2(zv, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(u), 100));
            default:
                var u;
                return o(o(t, A2(tu, A2(Df, Rt, We(u = n.a)), e)), Xu);
        }
    }), kv = function(n) {
        switch(n){
            case 0:
                return "Root";
            case 1:
                return "Hamburg";
            case 2:
                return "Schleswig-Holstein";
            case 3:
                return "Mecklenburg-Vorpommern";
            case 4:
                return "Hamburg | An Alster und Elbe";
            case 5:
                return "Hamburg | Metropolgebiet";
            case 6:
                return "Schleswig-Holstein | Luebeck";
            case 7:
                return "Schleswig-Holstein | Kiel";
            case 8:
                return "Schleswig-Holstein | An der Kueste";
            case 9:
                return "Schleswig-Holstein | Auf dem Land";
            case 10:
                return "Mecklenburg-Vorpommern | An der K\xfcste";
            default:
                return "Mecklenburg-Vorpommern | Auf dem Land";
        }
    }, xv = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return o(b(r, {
                    aS: t
                }), function(n) {
                    return il(A2(al, Fd, g([
                        "menuLevelChanged",
                        kv(n)
                    ])));
                }(t));
            case 1:
                return o(b(r, {
                    fk: !r.fk
                }), il(A2(al, Fd, g([
                    r.fk ? "sidebarClosed" : "sidebarOpened"
                ]))));
            default:
                return o(r, fv(0));
        }
    }), Cv = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2($v, n.a, r.ai), e = t.b;
                return o(b(r, {
                    ai: t.a
                }), A2(db, wl, e));
            case 1:
                var u = A2(wv, n.a, r.ax);
                return e = u.b, o(b(r, {
                    ax: u.a
                }), A2(db, Qb, e));
            case 2:
                var c = A2(Mv, n.a, r.aA);
                return e = c.b, o(b(r, {
                    aA: c.a
                }), A2(db, av, e));
            case 3:
                var a = A2(xv, n.a, r.fj);
                return e = a.b, o(b(r, {
                    fj: a.a
                }), A2(db, iv, e));
            case 4:
                return o(r, ov(0));
            default:
                return o(r, fv(0));
        }
    }), Hv = F2(function(n, r) {
        var t = o(n, r);
        switch(t.a.$){
            case 1:
                var e = t.a.a;
                return o(r, A2(Ae, function(n) {
                    return A2(vd, e, n.fB.fF);
                }, hd));
            case 2:
                var u = t.a, c = u.b, a = A2(vb, Rb(e = u.a), A2(yd, c, function(n) {
                    var r;
                    return A2(md, n, b(r = sb(n), {
                        fj: b(r.fj, {
                            fk: !1
                        })
                    }));
                }(r)));
                return o(a.a, Ee(g([
                    a.b,
                    Od(0),
                    qb(0)
                ])));
            case 3:
                var i = t.a.a;
                return i.$ ? o(r, function(n) {
                    return A2(Ae, $e, ln(function() {
                        try {
                            Br.location = n;
                        } catch (n) {
                            qn.location.reload(!1);
                        }
                    }));
                }(i.a)) : (e = i.a, o(r, A2(pd, sb(r).eG, function(n) {
                    return A3(Ed, "#", n.b9, A3(Ed, "?", n.cY, d(A2(Td, n.cT, d(n.cX ? "https://" : "http://", n.cg)), n.cP)));
                }(e))));
            case 4:
                return t.b.$ ? o(r, Xu) : A3(lb, Pu, Ou, A2(Sl, t.a.a, t.b.a));
            case 6:
                return 2 === t.b.$ ? A3(lb, Au, Eu, A2(Tl, t.a.a, t.b.a)) : o(r, Xu);
            case 5:
                return 1 === t.b.$ ? A3(lb, Vu, Tu, A2(Bd, t.a.a, t.b.a)) : o(r, Xu);
            case 7:
                return 3 === t.b.$ ? A3(lb, Iu, Su, A2(Gl, t.a.a, t.b.a)) : o(r, Xu);
            case 8:
                return 4 === t.b.$ ? A3(lb, Gu, ju, A2(tv, t.a.a, t.b.a)) : o(r, Xu);
            case 9:
                return 5 === t.b.$ ? A3(lb, Du, Lu, A2(cv, t.a.a, t.b.a)) : o(r, Xu);
            case 10:
                return 6 === t.b.$ ? A3(lb, Uu, Bu, A2(ev, t.a.a, t.b.a)) : o(r, Xu);
            case 11:
                var f = A2(Cv, t.a.a, sb(r)), s = f.b;
                return o(A2(md, r, l = f.a), A2(db, bb, s));
            case 0:
                return o(r, Xu);
            case 12:
                return o(A2(md, r, A2(zd, A2($d, t.a.a, re).a, sb(r))), Xu);
            case 13:
                return o(A2(md, r, A2(Ad, A2($d, t.a.a, re).a, sb(r))), Xu);
            case 14:
                var l = A2(Hd, t.a.a, sb(r));
                return o(A2(md, r, l), Xu);
            default:
                return o(A2(md, r, A2(Vd, t.a.a, sb(r))), Xu);
        }
    }), Vv = {
        $: 0
    }, Av = F2(function(n, r) {
        return A2(tr, n, Fd(r));
    }), Tv = Av("className"), Ev = Wn("div"), Ov = Qn, Sv = Ov, jv = function(n) {
        switch(n){
            case 2:
                return "churches";
            case 1:
                return "church";
            case 3:
                return "poi";
            case 4:
                return "regions";
            case 6:
                return "topics";
            case 5:
                return "static";
            case 7:
                return "map";
            default:
                return "other";
        }
    }, Bv = function(n) {
        return Yn(ur(n));
    }, Lv = Wn("span"), Pv = Zn, Nv = Pv, Iv = A2(Lv, g([
        Tv("headphone-message")
    ]), g([
        Nv("Bitte schlie\xdfen Sie Kopfh\xf6rer an!")
    ])), Gv = {
        $: 6
    }, Uv = Wn("button"), Dv = Wn("i"), Fv = F2(function(n, r) {
        return A2(Dv, d(r, g([
            Tv("fa fa-" + n)
        ])), l);
    }), Rv = F2(function(n, r) {
        return A2(Fv, n, g([
            Tv(r)
        ]));
    }), qv = function(n) {
        return A2(Rv, n, "");
    }, Kv = nr, Zv = F2(function(n, r) {
        return A2(Kv, n, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r));
    }), Xv = function(n) {
        return A2(Zv, "click", Qt(n));
    }, Jv = F3(function(n, r, t) {
        return n ? r : t;
    }), Wv = function(n) {
        return A2(Uv, g([
            Xv(Gv)
        ]), g([
            Nv("Autoplay: "),
            A3(Jv, n.V, qv("toggle-on"), qv("toggle-off"))
        ]));
    }, Yv = er("class"), Qv = Jn("http://www.w3.org/2000/svg"), nh = Qv("clipPath"), rh = Qv("g"), th = er("height"), eh = er("id"), uh = Qv("rect"), ch = Qv("svg"), ah = er("transform"), ih = er("viewBox"), oh = er("width"), fh = A2(ch, g([
        oh("24"),
        th("24"),
        ih("0 0 24 24")
    ]), g([
        A2(nh, g([
            eh("a")
        ]), g([
            A2(uh, g([
                Yv("a"),
                oh("24"),
                th("24")
            ]), l)
        ])),
        A2(rh, g([
            Yv("b")
        ]), g([
            A2(uh, g([
                Yv("c"),
                oh("30"),
                th("3"),
                ah("translate(2.121 0.357) rotate(45)")
            ]), l),
            A2(uh, g([
                Yv("c"),
                oh("30"),
                th("3"),
                ah("translate(0 21.57) rotate(-45)")
            ]), l)
        ]))
    ])), sh = A2(Ev, g([
        Xv({
            $: 5
        })
    ]), g([
        A2(Lv, g([
            Tv("pointer")
        ]), g([
            fh
        ]))
    ])), bh = F2(function(n, r) {
        return A3(Jv, n, r, Nv(""));
    }), dh = {
        $: 2
    }, lh = {
        $: 3
    }, vh = function(n) {
        return Tv(A2(ft, " ", A2(ye, Rt, A2(tu, Re, n))));
    }, hh = function(n) {
        return A2(Ev, l, g([
            A2(Uv, g([
                Xv(lh),
                vh(g([
                    o("opa-30", !n.L),
                    o("me-3", !0)
                ]))
            ]), g([
                qv("fast-backward")
            ])),
            Nv("Titel "),
            Nv(ot(n.L + 1)),
            Nv("/"),
            Nv(ot(lt(n.X))),
            A2(Uv, g([
                Xv(dh),
                vh(g([
                    o("opa-30", t(n.L, lt(n.X) - 1)),
                    o("ms-3", !0)
                ]))
            ]), g([
                qv("fast-forward")
            ]))
        ]));
    }, gh = function(n) {
        return A2(Ev, g([
            Tv("d-flex justify-content-between align-items-center mx-1 flex-column")
        ]), g([
            A2(bh, n.aM, Iv),
            A2(Ev, g([
                Tv("d-flex justify-content-between w-100 p-1")
            ]), g([
                hh(n),
                Wv(n),
                sh
            ]))
        ]));
    }, $h = {
        $: 4
    }, mh = F2(function(n, r) {
        return n ? r : Tv("");
    }), ph = Wn("audio"), wh = F2(function(n, r) {
        return A2(tr, n, qd(r));
    }), _h = wh("controls"), yh = Av("id"), zh = Wn("source"), Mh = function(n) {
        return A2(Av, "src", cr(n));
    }, kh = Av("title"), xh = Av("type"), Ch = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(ph, g([
            yh("audio-player"),
            Tv("w-100"),
            _h(!0),
            kh(t.eE),
            A2(mh, n.V, A2(Zv, "ended", Qt(dh))),
            A2(Zv, "play", Qt($h))
        ]), g([
            A2(zh, g([
                Mh(A2(Ku, "", e.ez)),
                xh("audio/mpeg")
            ]), l),
            A2(zh, g([
                Mh(e.a7),
                xh(e.bj)
            ]), l),
            Nv("Dieser Browser unterst\xfctzt kein <audio>")
        ]));
    }), Hh = F2(function(n, r) {
        return A2(Ev, g([
            Tv("audio-player-padding")
        ]), g([
            A3(Bv, "div", g([
                Tv("audio-player-container border")
            ]), g([
                o("audio-player-controls", gh(n)),
                o("audio-player", A2(Ch, n, r))
            ]))
        ]));
    }), Vh = F2(function(n, r) {
        return n.$ ? Nv("") : r(n.a);
    }), Ah = function(n) {
        var r;
        return A2(Sv, wl, A2(Vh, (r = n.ai).dT, Hh(r)));
    }, Th = er("d"), Eh = Qv("path"), Oh = A2(ch, g([
        oh("20.012"),
        th("16.655"),
        ih("0 0 20.012 16.655")
    ]), g([
        A2(Eh, g([
            Th("M12.64,3.23l-.52.515,7.2,7.284L1,11.192v.724l18.324.17-7.2,7.284.52.515L21.012,12.1V11.016Z"),
            ah("translate(-1 -3.23)")
        ]), l)
    ])), Sh = A2(Ev, g([
        Tv("rotate-270 d-flex")
    ]), g([
        Oh
    ])), jh = function(n) {
        return Wn(ur(n));
    }, Bh = A3(jh, "back-to-top", l, g([
        A2(Uv, l, g([
            Sh
        ]))
    ])), Lh = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ph = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Nh = Wn("a"), Ih = Wn("br"), Gh = wh("checked"), Uh = Av("htmlFor"), Dh = Wn("h1"), Fh = function(n) {
        var r;
        return A2(Av, "href", /^javascript:/i.test((r = n).replace(/\s/g, "")) ? "" : r);
    }, Rh = function(n) {
        return Fh(Sd(n));
    }, qh = Wn("input"), Kh = Wn("label"), Zh = A2(ua, g([
        "target",
        "checked"
    ]), pu), Xh = function(n) {
        return A2(Zv, "change", A2(Wt, n, Zh));
    }, Jh = F2(function(n, r) {
        return A2(bh, n.bq && !r, function(n) {
            return A2(Ev, g([
                Tv("consent-mask")
            ]), g([
                A2(Ev, g([
                    Tv("consent")
                ]), g([
                    A2(Dh, l, g([
                        Nv("Cookie-Einstellungen")
                    ])),
                    Nv("Wir benutzen Cookies, die Ihnen die M\xf6glichkeit eines besseren Nutzererlebnisses bieten. Dadurch wird Ihr Besuch auf unserer Website so komfortabel wie m\xf6glich gestaltet. Die Verwendung von Cookies erm\xf6glicht es uns, Ihnen zielgerichtete Informationen und Inhalte anzuzeigen."),
                    A2(Ih, l, l),
                    Nv("Sie entscheiden, welche Cookies und Pixel wir verwenden d\xfcrfen. Die technisch erforderlichen Cookies m\xfcssen gesetzt werden, um die Funktionalit\xe4t unserer Website zu gew\xe4hrleisten."),
                    A2(Ev, g([
                        Tv("checkbox")
                    ]), g([
                        A2(qh, g([
                            xh("checkbox"),
                            yh("consent-functional"),
                            Xh(Lh),
                            Gh(n.Z)
                        ]), l),
                        A2(Kh, g([
                            Uh("consent-functional")
                        ]), g([
                            Nv("Erforderliche Cookies")
                        ]))
                    ])),
                    A2(Ev, g([
                        Tv("checkbox")
                    ]), g([
                        A2(qh, g([
                            xh("checkbox"),
                            yh("consent-tracking"),
                            Xh(Ph),
                            Gh(n.af)
                        ]), l),
                        A2(Kh, g([
                            Uh("consent-tracking")
                        ]), g([
                            Nv("Tracking Cookies")
                        ]))
                    ])),
                    A2(Uv, g([
                        Tv("btn btn-tertiary"),
                        Xv(mv)
                    ]), g([
                        Nv("Auswahl speichern")
                    ])),
                    A2(Uv, g([
                        Tv("btn btn-primary"),
                        Xv(Yb)
                    ]), g([
                        Nv("Alle akzeptieren")
                    ])),
                    A2(Ev, l, g([
                        A2(Nh, g([
                            Rh(A2(Tb, "datenschutz", ct))
                        ]), g([
                            Nv("Datenschutz")
                        ])),
                        A2(Nh, g([
                            Rh(A2(Tb, "impressum", ct))
                        ]), g([
                            Nv("Impressum")
                        ]))
                    ]))
                ]))
            ]));
        }(n));
    }), Wh = F2(function(n, r) {
        return A2(Sv, Qb, A2(Jh, n.ax, r));
    }), Yh = rr, Qh = Yh, ng = function(n) {
        var r, t;
        return r = n.aA, t = function(n) {
            return A2(Ev, g([
                Tv("alert fade"),
                Tv("alert-" + n.bn),
                vh(g([
                    o("show", !n.aW)
                ]))
            ]), g([
                Nv(n.aD)
            ]));
        }, A2(Ev, g([
            Tv("alert-container"),
            A2(Qh, "z-index", "2000")
        ]), A2(ye, A2(Df, Re, t), r.b));
    }, rg = A2(ch, g([
        oh("30"),
        th("21"),
        ih("0 0 30 21")
    ]), g([
        A2(rh, g([
            ah("translate(-329 -14)")
        ]), g([
            A2(uh, g([
                oh("30"),
                th("3"),
                ah("translate(329 14)")
            ]), l),
            A2(uh, g([
                oh("30"),
                th("3"),
                ah("translate(329 23)")
            ]), l),
            A2(uh, g([
                oh("30"),
                th("3"),
                ah("translate(329 32)")
            ]), l)
        ]))
    ])), tg = A2(ch, g([
        oh("28.224"),
        th("26.703"),
        ih("0 0 28.224 26.703")
    ]), g([
        A2(Eh, g([
            Th("M30.7,19.352H16.584V16.014L11.292,6,6,16.014V32.7H9.923V29.325a1.378,1.378,0,0,1,2.752,0V32.7H34.224V22.69ZM18.7,30.7H16.584V25.026a1.06,1.06,0,0,1,2.117,0Zm4.234,0H20.817V25.026a1.06,1.06,0,0,1,2.117,0Zm4.234,0H25.051V25.026a1.06,1.06,0,0,1,2.117,0Zm4.234,0H29.285V25.026a1.06,1.06,0,0,1,2.117,0Z"),
            ah("translate(-6 -6)")
        ]), l)
    ])), eg = Wn("nav"), ug = {
        $: 1
    }, cg = iv(ug), ag = {
        $: 4
    }, ig = A2(ch, g([
        oh("13.787"),
        th("23.334"),
        ih("0 0 13.787 23.334")
    ]), g([
        A2(Eh, g([
            Th("M0,21.213l9.546-9.546L0,2.121,2.122,0,13.776,11.654h0l.013.013L2.122,23.334Z"),
            ah("translate(13.788 23.334) rotate(180)")
        ]), l)
    ])), og = function(n) {
        var r = n ? Xv(ag) : Tv("v-hidden");
        return A2(Ev, g([
            Tv("navbar-link"),
            r
        ]), g([
            ig
        ]));
    }, fg = Qv("defs"), sg = Qv("style"), bg = Pv, dg = A2(ch, g([
        oh("24"),
        th("24"),
        ih("0 0 24 24")
    ]), g([
        A2(fg, l, g([
            A2(sg, l, g([
                bg(".a{fill:none;}.b{clip-path:url(#a);}.sidebarClose{fill:#cce5ea;}")
            ])),
            A2(nh, g([
                eh("a")
            ]), g([
                A2(uh, g([
                    Yv("a"),
                    oh("24"),
                    th("24")
                ]), l)
            ]))
        ])),
        A2(rh, g([
            Yv("b")
        ]), g([
            A2(uh, g([
                Yv("sidebarClose"),
                oh("30"),
                th("3"),
                ah("translate(2.121 0.357) rotate(45)")
            ]), l),
            A2(uh, g([
                Yv("sidebarClose"),
                oh("30"),
                th("3"),
                ah("translate(0 21.57) rotate(-45)")
            ]), l)
        ]))
    ])), lg = F2(function(n, r) {
        var t = o(r, n);
        n: for(;;){
            r: for(;;){
                t: for(;;){
                    e: for(;;)switch(t.a.$){
                        case 3:
                            switch(t.b.$){
                                case 3:
                                    return gs((0, t.a.a)(t.b.a));
                                case 2:
                                    break n;
                                case 1:
                                    break t;
                                default:
                                    return nl;
                            }
                        case 2:
                            return hs(t.a.a);
                        case 1:
                            if (2 === t.b.$) break n;
                            break r;
                        default:
                            switch(t.b.$){
                                case 2:
                                    break n;
                                case 1:
                                    break t;
                                default:
                                    break e;
                            }
                    }
                    return nl;
                }
                return Oe;
            }
            return Oe;
        }
        return hs(t.b.a);
    }), vg = F3(function(n, r, t) {
        return A2(lg, t, A2(rl, n, r));
    }), hg = er("enable-background"), gg = er("fill"), $g = er("version"), mg = er("x"), pg = er("y"), wg = A2(ch, g([
        $g("1.1"),
        eh("Ebene_3"),
        mg("0px"),
        pg("0px"),
        oh("324.007px"),
        th("81.091px"),
        ih("0 0 324.007 81.091"),
        hg("new 0 0 324.007 81.091")
    ]), g([
        A2(rh, l, g([
            A2(rh, l, g([
                A2(rh, l, g([
                    A2(Eh, g([
                        Th("M107.793,22.136h-6.799v4.062h6.357v0.935h-6.357v4.47h6.867v0.935h-7.938V21.201h7.87V22.136z")
                    ]), l),
                    A2(Eh, g([
                        Th("M113.302,32.538h-1.088l-3.162-8.176h1.071l1.904,4.964c0.17,0.425,0.357,1.001,0.748,2.226 c0.323-1.003,0.493-1.563,0.765-2.295l1.751-4.896h1.02L113.302,32.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M124.894,32.488c-0.255,0.085-0.493,0.118-0.799,0.118c-0.782,0-1.054-0.407-1.054-1.495 c-0.731,1.155-1.683,1.665-3.094,1.665c-1.666,0-2.668-0.883-2.668-2.312c0-1.088,0.561-1.853,1.615-2.243 c0.578-0.204,0.663-0.222,2.805-0.442c0.986-0.085,1.292-0.34,1.292-1.037c0-1.224-0.663-1.785-2.142-1.785 c-1.411,0-2.09,0.595-2.227,1.92h-0.969c0.085-1.768,1.275-2.753,3.297-2.753c1.496,0,2.618,0.578,2.89,1.495 c0.102,0.341,0.119,0.612,0.119,1.343v3.656c0,1.037,0.068,1.155,0.561,1.155c0.119,0,0.204-0.017,0.374-0.069V32.488z M122.99,28.068c-0.323,0.29-0.561,0.356-2.261,0.578c-1.751,0.238-2.448,0.73-2.448,1.717c0,0.969,0.765,1.598,1.904,1.598 c1.632,0,2.805-1.071,2.805-2.55V28.068z")
                    ]), l),
                    A2(Eh, g([
                        Th("M127.903,25.893c0.289-0.494,0.442-0.698,0.68-0.918c0.561-0.561,1.326-0.85,2.227-0.85c1.054,0,1.955,0.408,2.414,1.121 c0.323,0.493,0.425,0.97,0.425,2.041v5.251h-1.003v-4.945c0-1.037-0.102-1.514-0.374-1.888c-0.34-0.459-0.952-0.714-1.683-0.714 c-1.003,0-1.836,0.477-2.244,1.275c-0.289,0.544-0.374,1.088-0.374,2.158v4.113h-1.003v-8.176h0.935V25.893z")
                    ]), l),
                    A2(Eh, g([
                        Th("M143.389,31.756c0,1.24-0.136,1.904-0.493,2.516c-0.561,0.969-1.683,1.479-3.179,1.479c-2.023,0-3.23-0.901-3.366-2.482 h1.02c0.153,1.106,0.935,1.666,2.363,1.666c1.853,0,2.669-0.883,2.669-2.94l0.017-1.36c-0.612,1.223-1.496,1.785-2.856,1.785 c-2.142,0-3.536-1.598-3.536-4.062c0-2.55,1.445-4.233,3.638-4.233c1.275,0,2.159,0.561,2.788,1.768v-1.531h0.935V31.756z M137.032,28.254c0,2.041,1.037,3.332,2.652,3.332c1.649,0,2.72-1.326,2.72-3.332c0-2.005-1.037-3.297-2.635-3.297 C138.086,24.958,137.032,26.216,137.032,28.254z")
                    ]), l),
                    A2(Eh, g([
                        Th("M153.03,29.835c-0.374,1.887-1.615,2.94-3.484,2.94c-2.278,0-3.757-1.665-3.757-4.249s1.547-4.402,3.74-4.402 c1.428,0,2.618,0.799,3.196,2.142c0.289,0.663,0.408,1.377,0.408,2.431l-6.34-0.017c0.051,2.106,1.037,3.264,2.771,3.264 c1.326,0,2.176-0.731,2.516-2.108H153.03z M152.112,27.864c-0.085-1.785-1.088-2.906-2.618-2.906 c-1.513,0-2.464,1.02-2.686,2.906H152.112z")
                    ]), l),
                    A2(Eh, g([
                        Th("M156.515,32.538h-1.003V21.201h1.003V32.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M160.51,22.798h-1.003v-1.598h1.003V22.798z M160.51,32.538h-1.003v-8.176h1.003V32.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M167.99,26.725c-0.119-1.224-0.799-1.768-2.193-1.768c-1.207,0-1.921,0.526-1.921,1.394c0,0.782,0.425,1.054,2.346,1.496 c1.156,0.271,1.683,0.459,2.176,0.781c0.544,0.356,0.867,0.969,0.867,1.648c0,1.497-1.309,2.499-3.247,2.499 c-2.108,0-3.315-1.036-3.366-2.907h0.969c0.102,1.412,0.884,2.075,2.414,2.075c1.343,0,2.244-0.63,2.244-1.581 c0-0.816-0.51-1.19-2.244-1.598c-1.445-0.341-1.802-0.458-2.227-0.697c-0.578-0.306-0.918-0.935-0.918-1.631 c0-1.428,1.156-2.312,2.975-2.312c1.122,0,2.006,0.322,2.533,0.951c0.374,0.426,0.527,0.851,0.578,1.649H167.99z")
                    ]), l),
                    A2(Eh, g([
                        Th("M178.325,29.615c-0.272,1.988-1.564,3.161-3.451,3.161c-2.278,0-3.774-1.683-3.774-4.249 c0-2.669,1.496-4.402,3.808-4.402c1.904,0,3.145,1.036,3.366,2.821h-1.02c-0.255-1.292-1.054-1.988-2.329-1.988 c-1.717,0-2.822,1.359-2.822,3.501c0,2.125,1.071,3.485,2.737,3.485c1.36,0,2.278-0.851,2.482-2.329H178.325z")
                    ]), l),
                    A2(Eh, g([
                        Th("M181.54,24.924c0,0.152,0,0.152-0.017,0.969c0.544-1.157,1.513-1.768,2.839-1.768c1.105,0,1.972,0.425,2.448,1.206 c0.306,0.477,0.408,1.003,0.408,1.938v5.269h-1.003v-5.133c0-0.867-0.102-1.309-0.391-1.683 c-0.374-0.477-0.969-0.731-1.717-0.731c-0.986,0-1.768,0.477-2.193,1.31c-0.289,0.561-0.374,1.07-0.374,2.227v4.011h-1.003 V21.201h1.003V24.924z")
                    ]), l),
                    A2(Eh, g([
                        Th("M192.692,28.798h-3.773v-0.9h3.773V28.798z")
                    ]), l),
                    A2(Eh, g([
                        Th("M202.025,32.538h-7.462V21.201h1.071v10.402h6.392V32.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M210.474,32.538h-0.935v-1.529c-0.663,1.19-1.581,1.768-2.873,1.768c-0.935,0-1.836-0.407-2.312-1.036 c-0.374-0.495-0.527-1.122-0.527-2.108v-5.27h1.003v4.845c0,0.867,0.051,1.257,0.204,1.649c0.255,0.629,0.986,1.055,1.853,1.055 c0.901,0,1.683-0.443,2.125-1.191c0.323-0.544,0.459-1.173,0.459-2.159v-4.199h1.003V32.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M216.22,25.195h-1.7v5.168c0,1.139,0.17,1.359,1.037,1.359c0.187,0,0.374-0.018,0.663-0.051v0.866 c-0.357,0.035-0.578,0.052-0.901,0.052c-0.867,0-1.377-0.221-1.615-0.697c-0.153-0.306-0.187-0.629-0.187-2.04v-4.658h-1.428 v-0.833h1.428v-2.516h1.003v2.516h1.7V25.195z")
                    ]), l),
                    A2(Eh, g([
                        Th("M219.297,24.924c0,0.152,0,0.152-0.017,0.969c0.544-1.157,1.513-1.768,2.839-1.768c1.105,0,1.972,0.425,2.448,1.206 c0.306,0.477,0.408,1.003,0.408,1.938v5.269h-1.003v-5.133c0-0.867-0.102-1.309-0.391-1.683 c-0.374-0.477-0.969-0.731-1.717-0.731c-0.986,0-1.768,0.477-2.193,1.31c-0.289,0.561-0.374,1.07-0.374,2.227v4.011h-1.003 V21.201h1.003V24.924z")
                    ]), l),
                    A2(Eh, g([
                        Th("M234.613,29.835c-0.374,1.887-1.615,2.94-3.484,2.94c-2.278,0-3.757-1.665-3.757-4.249s1.547-4.402,3.74-4.402 c1.428,0,2.618,0.799,3.196,2.142c0.289,0.663,0.408,1.377,0.408,2.431l-6.34-0.017c0.051,2.106,1.037,3.264,2.771,3.264 c1.326,0,2.176-0.731,2.516-2.108H234.613z M233.696,27.864c-0.085-1.785-1.088-2.906-2.618-2.906 c-1.513,0-2.464,1.02-2.686,2.906H233.696z")
                    ]), l),
                    A2(Eh, g([
                        Th("M241.175,25.246h-0.255c-0.833,0-1.581,0.323-2.091,0.918c-0.561,0.646-0.714,1.31-0.714,3.026v3.348h-1.003v-8.176 h0.935v1.955c0.612-1.445,1.598-2.107,3.127-2.074V25.246z")
                    ]), l),
                    A2(Eh, g([
                        Th("M243.965,22.798h-1.003v-1.598h1.003V22.798z M243.965,32.538h-1.003v-8.176h1.003V32.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M251.445,26.725c-0.119-1.224-0.799-1.768-2.193-1.768c-1.207,0-1.921,0.526-1.921,1.394 c0,0.782,0.425,1.054,2.346,1.496c1.156,0.271,1.683,0.459,2.176,0.781c0.544,0.356,0.867,0.969,0.867,1.648 c0,1.497-1.309,2.499-3.247,2.499c-2.108,0-3.315-1.036-3.366-2.907h0.969c0.102,1.412,0.884,2.075,2.414,2.075 c1.343,0,2.244-0.63,2.244-1.581c0-0.816-0.51-1.19-2.244-1.598c-1.445-0.341-1.802-0.458-2.227-0.697 c-0.578-0.306-0.918-0.935-0.918-1.631c0-1.428,1.156-2.312,2.975-2.312c1.122,0,2.006,0.322,2.533,0.951 c0.374,0.426,0.527,0.851,0.578,1.649H251.445z")
                    ]), l),
                    A2(Eh, g([
                        Th("M261.781,29.615c-0.272,1.988-1.564,3.161-3.451,3.161c-2.278,0-3.774-1.683-3.774-4.249 c0-2.669,1.496-4.402,3.808-4.402c1.904,0,3.145,1.036,3.366,2.821h-1.02c-0.255-1.292-1.054-1.988-2.329-1.988 c-1.717,0-2.822,1.359-2.822,3.501c0,2.125,1.071,3.485,2.737,3.485c1.36,0,2.278-0.851,2.482-2.329H261.781z")
                    ]), l),
                    A2(Eh, g([
                        Th("M264.996,24.924c0,0.152,0,0.152-0.017,0.969c0.544-1.157,1.513-1.768,2.839-1.768c1.105,0,1.972,0.425,2.448,1.206 c0.306,0.477,0.408,1.003,0.408,1.938v5.269h-1.002v-5.133c0-0.867-0.102-1.309-0.391-1.683 c-0.374-0.477-0.969-0.731-1.717-0.731c-0.986,0-1.768,0.477-2.193,1.31c-0.289,0.561-0.374,1.07-0.374,2.227v4.011h-1.003 V21.201h1.003V24.924z")
                    ]), l),
                    A2(Eh, g([
                        Th("M280.312,29.835c-0.374,1.887-1.615,2.94-3.484,2.94c-2.278,0-3.757-1.665-3.757-4.249s1.547-4.402,3.74-4.402 c1.428,0,2.618,0.799,3.196,2.142c0.289,0.663,0.408,1.377,0.408,2.431l-6.34-0.017c0.051,2.106,1.037,3.264,2.771,3.264 c1.326,0,2.176-0.731,2.516-2.108H280.312z M279.394,27.864c-0.085-1.785-1.088-2.906-2.618-2.906 c-1.513,0-2.464,1.02-2.686,2.906H279.394z")
                    ]), l),
                    A2(Eh, g([
                        Th("M103.934,45.824l5.354,6.713h-1.377l-4.743-5.966l-2.176,1.972v3.994h-1.071V41.201h1.071v6.103 c0.442-0.426,0.578-0.561,0.748-0.713l5.847-5.389h1.445L103.934,45.824z")
                    ]), l),
                    A2(Eh, g([
                        Th("M111.958,42.798h-1.003v-1.598h1.003V42.798z M111.958,52.538h-1.003v-8.176h1.003V52.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M119.03,45.246h-0.255c-0.833,0-1.581,0.323-2.091,0.918c-0.561,0.646-0.714,1.31-0.714,3.026v3.348h-1.003v-8.176h0.935 v1.955c0.612-1.445,1.598-2.107,3.127-2.074V45.246z")
                    ]), l),
                    A2(Eh, g([
                        Th("M127.223,49.615c-0.272,1.988-1.564,3.161-3.451,3.161c-2.278,0-3.774-1.683-3.774-4.249 c0-2.669,1.496-4.402,3.808-4.402c1.904,0,3.145,1.036,3.366,2.821h-1.02c-0.255-1.292-1.054-1.988-2.329-1.988 c-1.717,0-2.822,1.359-2.822,3.501c0,2.125,1.071,3.485,2.737,3.485c1.36,0,2.278-0.851,2.482-2.329H127.223z")
                    ]), l),
                    A2(Eh, g([
                        Th("M130.439,44.924c0,0.152,0,0.152-0.017,0.969c0.544-1.157,1.513-1.768,2.839-1.768c1.105,0,1.972,0.425,2.448,1.206 c0.306,0.477,0.408,1.003,0.408,1.938v5.269h-1.003v-5.133c0-0.867-0.102-1.309-0.391-1.683 c-0.374-0.477-0.969-0.731-1.717-0.731c-0.986,0-1.768,0.477-2.193,1.31c-0.289,0.561-0.374,1.07-0.374,2.227v4.011h-1.003 V41.201h1.003V44.924z")
                    ]), l),
                    A2(Eh, g([
                        Th("M145.755,49.835c-0.374,1.887-1.615,2.94-3.484,2.94c-2.278,0-3.757-1.665-3.757-4.249s1.547-4.402,3.74-4.402 c1.428,0,2.618,0.799,3.196,2.142c0.289,0.663,0.408,1.377,0.408,2.431l-6.34-0.017c0.051,2.106,1.037,3.264,2.771,3.264 c1.326,0,2.176-0.731,2.516-2.108H145.755z M144.837,47.864c-0.085-1.785-1.088-2.906-2.618-2.906 c-1.513,0-2.464,1.02-2.686,2.906H144.837z")
                    ]), l),
                    A2(Eh, g([
                        Th("M154,42.798h-1.002v-1.598H154V42.798z M154,52.538h-1.002v-8.176H154V52.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M157.944,45.893c0.289-0.494,0.442-0.698,0.68-0.918c0.561-0.561,1.326-0.85,2.227-0.85c1.054,0,1.955,0.408,2.414,1.121 c0.323,0.493,0.425,0.97,0.425,2.041v5.251h-1.003v-4.945c0-1.037-0.102-1.514-0.374-1.888c-0.34-0.459-0.952-0.714-1.683-0.714 c-1.003,0-1.836,0.477-2.244,1.275c-0.289,0.544-0.374,1.088-0.374,2.158v4.113h-1.003v-8.176h0.935V45.893z")
                    ]), l),
                    A2(Eh, g([
                        Th("M180.434,52.538h-1.207l-5.252-7.598c-1.071-1.648-1.207-1.853-1.496-2.447c0.034,0.441,0.051,0.662,0.051,1.104 l0.017,1.615v7.325h-1.037V41.201h1.207l5.269,7.683c0.561,0.816,1.122,1.717,1.479,2.379c-0.034-0.781-0.068-2.227-0.068-2.991 v-7.071h1.037V52.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M190.754,48.477c0,2.634-1.496,4.299-3.859,4.299s-3.893-1.683-3.893-4.317c0-2.652,1.53-4.334,3.944-4.334 C189.258,44.125,190.754,45.841,190.754,48.477z M184.022,48.459c0,2.142,1.122,3.485,2.89,3.485c1.734,0,2.839-1.36,2.839-3.485 c0-2.108-1.122-3.501-2.822-3.501C185.144,44.958,184.022,46.316,184.022,48.459z")
                    ]), l),
                    A2(Eh, g([
                        Th("M197.281,45.246h-0.255c-0.833,0-1.581,0.323-2.091,0.918c-0.561,0.646-0.714,1.31-0.714,3.026v3.348h-1.003v-8.176 h0.935v1.955c0.612-1.445,1.598-2.107,3.127-2.074V45.246z")
                    ]), l),
                    A2(Eh, g([
                        Th("M205.865,52.538h-0.935v-1.631c-0.578,1.257-1.53,1.869-2.941,1.869c-2.277,0-3.706-1.683-3.706-4.334 c0-2.617,1.445-4.317,3.672-4.317c1.377,0,2.346,0.578,2.907,1.75v-4.674h1.003V52.538z M199.287,48.441 c0,2.142,1.088,3.502,2.788,3.502c1.733,0,2.821-1.343,2.821-3.485c0-1.123-0.255-1.955-0.782-2.566 c-0.51-0.595-1.224-0.935-2.006-0.935C200.358,44.958,199.287,46.283,199.287,48.441z")
                    ]), l),
                    A2(Eh, g([
                        Th("M215.912,52.538h-0.935v-1.631c-0.578,1.257-1.53,1.869-2.941,1.869c-2.277,0-3.706-1.683-3.706-4.334 c0-2.617,1.445-4.317,3.672-4.317c1.377,0,2.346,0.578,2.907,1.75v-4.674h1.003V52.538z M209.333,48.441 c0,2.142,1.088,3.502,2.788,3.502c1.734,0,2.822-1.343,2.822-3.485c0-1.123-0.255-1.955-0.782-2.566 c-0.51-0.595-1.224-0.935-2.006-0.935C210.404,44.958,209.333,46.283,209.333,48.441z")
                    ]), l),
                    A2(Eh, g([
                        Th("M225.618,49.835c-0.374,1.887-1.615,2.94-3.484,2.94c-2.278,0-3.757-1.665-3.757-4.249s1.547-4.402,3.74-4.402 c1.428,0,2.618,0.799,3.196,2.142c0.289,0.663,0.408,1.377,0.408,2.431l-6.34-0.017c0.051,2.106,1.037,3.264,2.771,3.264 c1.326,0,2.176-0.731,2.516-2.108H225.618z M224.701,47.864c-0.085-1.785-1.088-2.906-2.618-2.906 c-1.513,0-2.464,1.02-2.686,2.906H224.701z")
                    ]), l),
                    A2(Eh, g([
                        Th("M234.697,52.538h-0.935v-1.529c-0.663,1.19-1.581,1.768-2.873,1.768c-0.935,0-1.836-0.407-2.312-1.036 c-0.374-0.495-0.527-1.122-0.527-2.108v-5.27h1.003v4.845c0,0.867,0.051,1.257,0.204,1.649c0.255,0.629,0.986,1.055,1.853,1.055 c0.901,0,1.683-0.443,2.125-1.191c0.323-0.544,0.459-1.173,0.459-2.159v-4.199h1.003V52.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M240.443,45.195h-1.7v5.168c0,1.139,0.17,1.359,1.037,1.359c0.187,0,0.374-0.018,0.663-0.051v0.866 c-0.357,0.035-0.578,0.052-0.901,0.052c-0.867,0-1.377-0.221-1.615-0.697c-0.153-0.306-0.187-0.629-0.187-2.04v-4.658h-1.428 v-0.833h1.428v-2.516h1.003v2.516h1.7V45.195z")
                    ]), l),
                    A2(Eh, g([
                        Th("M247.175,46.725c-0.119-1.224-0.799-1.768-2.193-1.768c-1.207,0-1.921,0.526-1.921,1.394 c0,0.782,0.425,1.054,2.346,1.496c1.156,0.271,1.683,0.459,2.176,0.781c0.544,0.356,0.867,0.969,0.867,1.648 c0,1.497-1.309,2.499-3.247,2.499c-2.108,0-3.315-1.036-3.366-2.907h0.969c0.102,1.412,0.884,2.075,2.414,2.075 c1.343,0,2.244-0.63,2.244-1.581c0-0.816-0.51-1.19-2.244-1.598c-1.445-0.341-1.802-0.458-2.227-0.697 c-0.578-0.306-0.918-0.935-0.918-1.631c0-1.428,1.156-2.312,2.975-2.312c1.122,0,2.006,0.322,2.533,0.951 c0.374,0.426,0.527,0.851,0.578,1.649H247.175z")
                    ]), l),
                    A2(Eh, g([
                        Th("M257.51,49.615c-0.272,1.988-1.564,3.161-3.451,3.161c-2.278,0-3.774-1.683-3.774-4.249c0-2.669,1.496-4.402,3.808-4.402 c1.904,0,3.145,1.036,3.366,2.821h-1.02c-0.255-1.292-1.054-1.988-2.329-1.988c-1.717,0-2.822,1.359-2.822,3.501 c0,2.125,1.071,3.485,2.737,3.485c1.36,0,2.278-0.851,2.482-2.329H257.51z")
                    ]), l),
                    A2(Eh, g([
                        Th("M260.725,44.924c0,0.152,0,0.152-0.017,0.969c0.544-1.157,1.513-1.768,2.839-1.768c1.105,0,1.972,0.425,2.448,1.206 c0.306,0.477,0.408,1.003,0.408,1.938v5.269H265.4v-5.133c0-0.867-0.102-1.309-0.391-1.683c-0.374-0.477-0.969-0.731-1.717-0.731 c-0.986,0-1.768,0.477-2.193,1.31c-0.289,0.561-0.374,1.07-0.374,2.227v4.011h-1.003V41.201h1.003V44.924z")
                    ]), l),
                    A2(Eh, g([
                        Th("M270.347,52.538h-1.003V41.201h1.003V52.538z")
                    ]), l),
                    A2(Eh, g([
                        Th("M280.275,52.488c-0.255,0.085-0.493,0.118-0.799,0.118c-0.782,0-1.054-0.407-1.054-1.495 c-0.731,1.155-1.683,1.665-3.094,1.665c-1.666,0-2.668-0.883-2.668-2.312c0-1.088,0.561-1.853,1.615-2.243 c0.578-0.204,0.663-0.222,2.805-0.442c0.986-0.085,1.292-0.34,1.292-1.037c0-1.224-0.663-1.785-2.142-1.785 c-1.411,0-2.09,0.595-2.227,1.92h-0.969c0.085-1.768,1.275-2.753,3.297-2.753c1.496,0,2.618,0.578,2.89,1.495 c0.102,0.341,0.119,0.612,0.119,1.343v3.656c0,1.037,0.068,1.155,0.561,1.155c0.119,0,0.204-0.017,0.374-0.069V52.488z M278.371,48.068c-0.323,0.29-0.561,0.356-2.261,0.578c-1.751,0.238-2.448,0.73-2.448,1.717c0,0.969,0.765,1.598,1.904,1.598 c1.632,0,2.805-1.071,2.805-2.55V48.068z")
                    ]), l),
                    A2(Eh, g([
                        Th("M283.284,45.893c0.289-0.494,0.442-0.698,0.68-0.918c0.561-0.561,1.326-0.85,2.227-0.85c1.054,0,1.955,0.408,2.414,1.121 c0.323,0.493,0.425,0.97,0.425,2.041v5.251h-1.003v-4.945c0-1.037-0.102-1.514-0.374-1.888c-0.34-0.459-0.952-0.714-1.683-0.714 c-1.003,0-1.836,0.477-2.244,1.275c-0.289,0.544-0.374,1.088-0.374,2.158v4.113h-1.003v-8.176h0.935V45.893z")
                    ]), l),
                    A2(Eh, g([
                        Th("M298.991,52.538h-0.935v-1.631c-0.578,1.257-1.53,1.869-2.941,1.869c-2.277,0-3.706-1.683-3.706-4.334 c0-2.617,1.445-4.317,3.672-4.317c1.377,0,2.346,0.578,2.907,1.75v-4.674h1.003V52.538z M292.413,48.441 c0,2.142,1.088,3.502,2.788,3.502c1.733,0,2.821-1.343,2.821-3.485c0-1.123-0.255-1.955-0.782-2.566 c-0.51-0.595-1.224-0.935-2.006-0.935C293.484,44.958,292.413,46.283,292.413,48.441z")
                    ]), l)
                ]))
            ])),
            A2(Eh, g([
                Th("M74.643,36.196l-21.995-1.319c-0.033-0.001-0.061-0.005-0.087-0.016c-0.151-0.104-0.28-0.233-0.386-0.388 c-0.005-0.028-0.013-0.05-0.013-0.079l-1.32-21.997c-0.324-0.014-0.649-0.026-0.979-0.026c-0.325,0-0.651,0.012-0.974,0.026 l-1.317,21.996c-0.002,0.026-0.007,0.052-0.014,0.082c-0.103,0.153-0.233,0.279-0.382,0.384c-0.026,0.009-0.058,0.017-0.088,0.017 l-22,1.324c-0.013,0.321-0.026,0.647-0.026,0.974c0,0.331,0.013,0.657,0.026,0.982l21.997,1.322c0.028,0,0.056,0.005,0.087,0.011 c0.147,0.109,0.279,0.239,0.384,0.388c0.005,0.028,0.014,0.056,0.014,0.082l1.316,28.626c0.327,0.01,0.653,0.024,0.978,0.024 c0.331,0,0.655-0.015,0.979-0.024l1.32-28.626c0.001-0.031,0.01-0.062,0.016-0.091c0.103-0.144,0.227-0.27,0.372-0.378 c0.031-0.006,0.063-0.011,0.099-0.014l21.995-1.322c0.011-0.324,0.024-0.648,0.024-0.979C74.667,36.846,74.654,36.52,74.643,36.196 z")
            ]), l)
        ])),
        A2(uh, g([
            eh("_x3C_Slice_x3E_"),
            mg("24.052"),
            pg("7.526"),
            gg("none"),
            oh("279"),
            th("65")
        ]), l)
    ])), _g = F2(function(n, r) {
        return o(n, r);
    }), yg = A2(Nh, g([
        Tv("nav-link"),
        Fh(""),
        Xv({
            $: 2
        })
    ]), g([
        Nv("Cookieeinstellungen bearbeiten")
    ])), zg = g([
        {
            a: l,
            A: 4,
            fy: "An Alster und Elbe"
        },
        {
            a: l,
            A: 5,
            fy: "Metropolgebiet"
        }
    ]), Mg = g([
        {
            a: l,
            A: 10,
            fy: "An der K\xfcste"
        },
        {
            a: l,
            A: 11,
            fy: "Auf dem Land"
        }
    ]), kg = g([
        {
            a: l,
            A: 6,
            fy: "L\xfcbeck"
        },
        {
            a: l,
            A: 7,
            fy: "Kiel"
        },
        {
            a: l,
            A: 8,
            fy: "An der K\xfcste"
        },
        {
            a: l,
            A: 9,
            fy: "Auf dem Land"
        }
    ]), xg = g([
        {
            a: zg,
            A: 1,
            fy: "Hamburg"
        },
        {
            a: kg,
            A: 2,
            fy: "Schleswig-Holstein"
        },
        {
            a: Mg,
            A: 3,
            fy: "Mecklenburg-Vorpommern"
        }
    ]), Cg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hg = er("style"), Vg = A2(ch, g([
        oh("7.811"),
        th("14.159"),
        ih("0 0 7.811 14.159"),
        Hg("transform: rotate(180deg)")
    ]), g([
        A2(nh, g([
            eh("a")
        ]), g([
            A2(uh, g([
                oh("7.811"),
                th("14.159")
            ]), l)
        ])),
        A2(rh, l, g([
            A2(Eh, g([
                Th("M6.01,18.032l6.346-6.345-6.38-6.38L6.7,4.58l7.074,7.074,0,0,.013.013-7.07,7.07Z"),
                ah("translate(-5.976 -4.58)")
            ]), l)
        ]))
    ])), Ag = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
            case 3:
                return 0;
            case 4:
            case 5:
                return 1;
            case 6:
            case 7:
            case 8:
            case 9:
                return 2;
            default:
                return 3;
        }
    }, Tg = function(n) {
        return n ? A2(Ev, g([
            Tv("border-bottom"),
            Xv(Cg(Ag(n)))
        ]), g([
            A2(Ev, g([
                Tv("nav-link d-flex align-items-center fill-primary")
            ]), g([
                Vg,
                A2(Lv, g([
                    Tv("ms-2")
                ]), g([
                    Nv("Zur\xfcck")
                ]))
            ]))
        ])) : Nv("");
    }, Eg = function(n) {
        switch(n){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 11;
            case 5:
                return 12;
            case 6:
                return 20;
            case 7:
                return 21;
            case 8:
                return 22;
            case 9:
                return 23;
            case 10:
                return 30;
            default:
                return 31;
        }
    }, Og = F2(function(n, r) {
        return A2(Nh, g([
            Tv("nav-link"),
            Rh(n)
        ]), g([
            Nv(r)
        ]));
    }), Sg = F2(function(n, r) {
        return A2(ye, function(n) {
            return A2(Ev, g([
                Tv("border-bottom")
            ]), g([
                n
            ]));
        }, A2(ye, function(n) {
            var r = n.a;
            return A2(Og, A2(Vb, r.am, ct), r.eE);
        }, A2(tu, function(n) {
            return t(r, n.b.ew);
        }, n)));
    }), jg = A2(ch, g([
        oh("7.811"),
        th("14.159"),
        ih("0 0 7.811 14.159")
    ]), g([
        A2(nh, g([
            eh("a")
        ]), g([
            A2(uh, g([
                oh("7.811"),
                th("14.159")
            ]), l)
        ])),
        A2(rh, l, g([
            A2(Eh, g([
                Th("M6.01,18.032l6.346-6.345-6.38-6.38L6.7,4.58l7.074,7.074,0,0,.013.013-7.07,7.07Z"),
                ah("translate(-5.976 -4.58)")
            ]), l)
        ]))
    ])), Bg = function(n) {
        var r = n;
        return A2(Ev, g([
            Tv("border-bottom"),
            Xv(Cg(r.A))
        ]), g([
            A2(Lv, g([
                Tv("nav-link d-flex justify-content-between align-items-center fill-primary")
            ]), g([
                Nv(r.fy),
                jg
            ]))
        ]));
    }, Lg = F3(function(n, r, t) {
        return A2(Ev, g([
            Tv("sidebar-churches")
        ]), A2(Zr, Tg(n), d(A2(Sg, r, Eg(n)), A2(ye, Bg, t))));
    }), Pg = F2(function(n, r) {
        return A2(ye, function(n) {
            return A2(Ev, g([
                Tv("border-bottom")
            ]), g([
                n
            ]));
        }, A2(ye, function(n) {
            var r = n.a;
            return A2(Og, A2(xb, r.am, ct), r.eE);
        }, A2(tu, function(n) {
            return A2(Ni, r, n.b.bk.cu);
        }, n)));
    }), Ng = F2(function(n, r) {
        return A2(Ev, g([
            Tv("sidebar-churches")
        ]), g([
            Tg(n),
            A2(Ev, g([
                Tv("overflow-auto")
            ]), A2(Pg, r, Eg(n)))
        ]));
    }), Ig = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.aS){
            case 0:
                return A3(Lg, 0, e, xg);
            case 1:
                return A3(Lg, 1, e, zg);
            case 2:
                return A3(Lg, 2, e, kg);
            case 3:
                return A3(Lg, 3, e, Mg);
            case 4:
                return A2(Ng, 4, t);
            case 5:
                return A2(Ng, 5, t);
            case 6:
                return A2(Ng, 6, t);
            case 7:
                return A2(Ng, 7, t);
            case 8:
                return A2(Ng, 8, t);
            case 9:
                return A2(Ng, 9, t);
            case 10:
                return A2(Ng, 10, t);
            default:
                return A2(Ng, 11, t);
        }
    }), Gg = F2(function(n, r) {
        switch(r.$){
            case 3:
                return n(r.a);
            case 0:
                return Nv("...");
            case 1:
                return Nv("Loading...");
            default:
                var t = r.a;
                return A2(Ev, g([
                    Tv("p-3")
                ]), g([
                    (e = t, u = A2(Ev, l, g([
                        Nv("Es ist ein Fehler aufgetreten."),
                        A2(Ih, l, l),
                        Nv("Bitte laden Sie die Ansicht neu und versuchen Sie es sp\xe4ter noch einmal."),
                        A2(Ih, l, l),
                        A2(Nh, g([
                            Tv("btn btn-outline-primary mt-3"),
                            Rh(Ab)
                        ]), g([
                            Nv("Neu laden")
                        ]))
                    ])), c = A2(Ev, l, g([
                        Nv("Dieser Inhalt ist nicht verf\xfcgbar."),
                        A2(Ih, l, l),
                        A2(Nh, g([
                            Tv("btn btn-outline-primary mt-3"),
                            Rh(Cb)
                        ]), g([
                            Nv("Zur Startseite")
                        ]))
                    ])), a = A2(Ev, l, g([
                        Nv("Dieser Inhalt steht momentan nicht offline zur Verf\xfcgung."),
                        A2(Ih, l, l),
                        Nv("Bitte \xfcberpr\xfcfen Sie die Internetverbindung und laden Sie die Ansicht erneut."),
                        A2(Ih, l, l),
                        A2(Nh, g([
                            Tv("btn btn-outline-primary mt-3"),
                            Rh(Ab)
                        ]), g([
                            Nv("Neu laden")
                        ]))
                    ])), i = function() {
                        switch(e.$){
                            case 1:
                                return o(a, Nv("Timeout"));
                            case 2:
                                return o(a, Nv("NetworkError"));
                            case 4:
                                return o(u, Nv("Bad Body: " + e.a));
                            case 0:
                                return o(u, Nv("Bad Url: " + e.a));
                            default:
                                return 404 === e.a ? o(c, Nv("Bad Status: 404")) : o(u, Nv("Bad Status: " + ot(e.a)));
                        }
                    }(), f = i.a, s = i.b, A2(Ev, l, g([
                        A2(Ev, g([
                            Tv("d-none")
                        ]), g([
                            s
                        ])),
                        f
                    ])))
                ]));
        }
        var e, u, c, a, i, f, s;
    }), Ug = F4(function(n, r, t, e) {
        return A2(Ev, g([
            Tv("sidebar-root")
        ]), g([
            A2(Ev, g([
                Tv("sidebar-close"),
                Xv(ug)
            ]), l),
            A2(Ev, g([
                Tv("sidebar-close-button")
            ]), g([
                A2(Uv, g([
                    Tv("navbar-toggler"),
                    Xv(ug)
                ]), g([
                    dg
                ]))
            ])),
            A2(Ev, g([
                Tv("sidebar")
            ]), g([
                A2(Ev, g([
                    Tv("sidebar-content")
                ]), g([
                    A2(Gg, Ig(e), A3(vg, _g, n, r)),
                    A2(Ev, g([
                        Tv("sidebar-statics")
                    ]), g([
                        A2(Ev, g([
                            Tv("d-flex")
                        ]), g([
                            wg
                        ])),
                        A2(Og, A2(Tb, "kontakt+feedback", ct), "Kontakt & Feedback"),
                        A2(Og, A2(Tb, "impressum", ct), "Impressum"),
                        A2(Og, A2(Tb, "datenschutz", ct), "Datenschutz"),
                        yg,
                        A2(bh, t, A2(Ev, g([
                            Tv("audio-player-padding")
                        ]), l))
                    ]))
                ]))
            ]))
        ]));
    }), Dg = F4(function(n, r, t, e) {
        return A2(bh, e.fk, A4(Ug, n, r, t, e));
    }), Fg = function(n) {
        return A2(Sv, iv, A4(Dg, n.dO, n.fa, function(n) {
            return !t(n.ai.dT, ct);
        }(n), n.fj));
    }, Rg = F2(function(n, r) {
        var t = o(n, r);
        switch(t.a){
            case 2:
                return 1 === t.b.$;
            case 1:
                switch(t.b.$){
                    case 1:
                    case 2:
                        return !0;
                    default:
                        return !1;
                }
            case 3:
                return 6 === t.b.$;
            case 4:
                return 3 === t.b.$;
            case 6:
                return 4 === t.b.$;
            case 5:
                return 5 === t.b.$;
            case 7:
                return !t.b.$;
            default:
                return !1;
        }
    }), qg = F4(function(n, r, t, e) {
        var u = g([
            o("active", A2(Rg, n, r)),
            o("justify-content-end", t),
            o("justify-content-start", !t)
        ]);
        return A2(Lv, g([
            Tv("nav-item flex-grow-1 d-flex"),
            vh(u)
        ]), g([
            A2(Nh, g([
                Tv("nav-link"),
                Rh(r)
            ]), e)
        ]));
    }), Kg = function(n) {
        var r = A2(Ev, g([
            Tv("sub-navbar-margin")
        ]), g([
            A2(eg, g([
                Tv("sub-navbar d-flex justify-content-around")
            ]), g([
                A2(Ev, l, l),
                A4(qg, n, Cb, !0, g([
                    Nv("Karte")
                ])),
                A4(qg, n, kb, !1, g([
                    Nv("Kirchen entdecken")
                ]))
            ]))
        ]));
        switch(n){
            case 2:
            case 7:
                return r;
            default:
                return Nv("");
        }
    }, Zg = F5(function(n, r, t, e, u) {
        var c, a = u.fy, i = u.dP, o = u.ed;
        return {
            aN: g([
                A2(Sv, t, (c = 7 !== e && !n.fj.fk, A2(Ev, g([
                    Tv("navbar-margin")
                ]), g([
                    A2(eg, g([
                        Tv("navbar fixed-top bg-primary")
                    ]), g([
                        A2(Ev, g([
                            Tv("container px-0")
                        ]), g([
                            og(c),
                            A2(Nh, g([
                                Tv("navbar-link"),
                                Rh(Cb)
                            ]), g([
                                tg
                            ])),
                            A2(Uv, g([
                                Tv("btn"),
                                Xv(cg)
                            ]), g([
                                rg
                            ]))
                        ]))
                    ]))
                ])))),
                A2(Sv, t, Fg(n)),
                A2(Sv, t, Kg(e)),
                A2(Sv, t, ng(n)),
                A2(Sv, r, A2(Ev, g([
                    Tv("page container px-0"),
                    Tv(jv(e))
                ]), g([
                    i
                ]))),
                A2(Sv, t, Ah(n)),
                A2(Sv, t, A2(Wh, n, o)),
                Bh
            ]),
            fy: a + " | Nordkirche"
        };
    }), Xg = {
        dP: Nv(""),
        ed: !1,
        fy: ""
    }, Jg = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wg = "/placeholder.svg", Yg = function(n) {
        var r = function() {
            switch(n){
                case 0:
                    return ut(767);
                case 1:
                    return ut(991);
                case 2:
                    return ut(1199);
                default:
                    return ct;
            }
        }();
        return A2(fl, function(n) {
            return "(max-width: " + ot(n) + "px)";
        }, r);
    }, Qg = function(n) {
        var r = function() {
            switch(n){
                case 0:
                    return ct;
                case 1:
                    return ut("1.5");
                case 2:
                    return ut("2.5");
                default:
                    return ut("3.5");
            }
        }();
        return A2(fl, function(n) {
            return "(-webkit-min-device-pixel-ratio: " + n + ")";
        }, r);
    }, n$ = F2(function(n, r) {
        var t = Dl(g([
            Qg(r),
            Yg(n)
        ]));
        return t.b ? ut(A2(ft, " and ", t)) : ct;
    }), r$ = F3(function(n, r, t) {
        var e = function() {
            switch(n){
                case 0:
                    return "s";
                case 1:
                    return "m";
                case 2:
                    return "l";
                default:
                    return "xl";
            }
        }(), u = function() {
            switch(r){
                case 0:
                    return "1x";
                case 1:
                    return "2x";
                case 2:
                    return "3x";
                default:
                    return "4x";
            }
        }();
        return qu(A2(ft, "_", g([
            e,
            u,
            t ? "orig" : "webp"
        ])));
    }), t$ = F2(function(n, r) {
        return A2(er, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), cr(r));
    }), e$ = t$, u$ = F2(function(n, r) {
        return n.$ ? Tv("") : r(n.a);
    }), c$ = F3(function(n, r, t) {
        return A3(jh, "source", g([
            A2(e$, "data-srcset", t),
            A2(u$, n, e$("media")),
            A2(u$, r, e$("type")),
            A2(e$, "srcset", t)
        ]), l);
    }), a$ = F4(function(n, r, t, e) {
        var u = function(n) {
            return n ? ct : ut("image/webp");
        }(t), c = A3(r$, n, r, t), a = A2(n$, n, r);
        return A3(Cd, Nv(""), A2(c$, a, u), c(e));
    }), i$ = g([
        3,
        2,
        1,
        0
    ]), o$ = g([
        0,
        1,
        2,
        3
    ]), f$ = g([
        0,
        1
    ]), s$ = Wn("img"), b$ = function(n) {
        return A2(s$, g([
            Tv("content-image"),
            Mh(n)
        ]), l);
    }, d$ = function(n) {
        var r, t = n.b;
        return A3(jh, "picture", l, A2(Xe, (r = t.fc, A2(Je, function(n) {
            return A2(Je, function(t) {
                return A2(ye, function(e) {
                    return A4(a$, n, t, e, r);
                }, f$);
            }, i$);
        }, o$)), g([
            b$(t.a7)
        ])));
    }, l$ = function(n) {
        var r, t = n.a, e = (r = n.b.dN).$ || 30 !== r.a.$ ? b$(Wg) : d$(r.a.a);
        return A2(Ev, g([
            Tv("church-list-item"),
            Xv(Jg(t.am))
        ]), g([
            A2(Ev, g([
                Tv("church-list-image")
            ]), g([
                e
            ])),
            A2(Ev, g([
                Tv("church-list-name")
            ]), g([
                Nv(t.eE)
            ]))
        ]));
    }, v$ = function(n) {
        return A2(Ev, g([
            Tv("w-100")
        ]), A2(ye, l$, A2(tu, function(n) {
            return n.b.bP;
        }, n)));
    }, h$ = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M339.9,470.8c-6.7,0-12.2-5.5-12.2-12.2v-102c0-6.7,5.5-12.2,12.2-12.2h22v-13.5c0-2.1,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7\n\t\tv13.5h60.3v-13.5c0-2.1,1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7v13.5h22c6.7,0,12.2,5.5,12.2,12.2v102c0,6.7-5.5,12.2-12.2,12.2H339.9z\n\t\t M335.2,458.6c0,2.6,2.1,4.7,4.7,4.7h119.2c2.6,0,4.7-2.1,4.7-4.7V403H335.2V458.6z M339.9,351.9c-2.6,0-4.7,2.1-4.7,4.7v38.9\n\t\th128.7v-38.9c0-2.6-2.1-4.7-4.7-4.7h-22V362l0.3,0.1c4.9,1.7,8.1,6.4,8.1,11.5c0,6.7-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2\n\t\tc0-5.2,3.3-9.8,8.1-11.5l0.3-0.1v-10.1h-60.3V362l0.3,0.1c4.9,1.7,8.1,6.4,8.1,11.5c0,6.7-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2\n\t\tc0-5.2,3.3-9.8,8.1-11.5l0.3-0.1v-10.1H339.9z M433.4,368.8c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7\n\t\tS436,368.8,433.4,368.8z M365.6,368.8c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7s4.7-2.1,4.7-4.7S368.2,368.8,365.6,368.8z")
            ]), l),
            A2(Eh, g([
                Th("M391,425.5c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7H408c2.1,0,3.7,1.7,3.7,3.7c0,2.1-1.7,3.7-3.7,3.7H391z")
            ]), l),
            A2(Eh, g([
                Th("M357.1,425.5c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7h16.9c2.1,0,3.7,1.7,3.7,3.7c0,2.1-1.7,3.7-3.7,3.7H357.1z")
            ]), l),
            A2(Eh, g([
                Th("M357.1,448.6c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7h16.9c2.1,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7H357.1z")
            ]), l),
            A2(Eh, g([
                Th("M391,448.6c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7H408c2.1,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7H391z")
            ]), l),
            A2(Eh, g([
                Th("M424.9,448.6c-2.1,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7h16.9c2.1,0,3.7,1.7,3.7,3.7s-1.7,3.7-3.7,3.7H424.9z")
            ]), l),
            A2(Eh, g([
                Th("M424.9,425.5c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7h16.9c2.1,0,3.7,1.7,3.7,3.7c0,2.1-1.7,3.7-3.7,3.7H424.9z")
            ]), l)
        ]))
    ])), g$ = function(n) {
        return !n.b;
    }, $$ = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M400,472.6c-40,0-72.6-32.6-72.6-72.6c0-40,32.6-72.6,72.6-72.6s72.6,32.6,72.6,72.6C472.6,440,440,472.6,400,472.6z\n\t\t M400,335.9c-35.3,0-64.1,28.7-64.1,64.1c0,35.3,28.7,64.1,64.1,64.1c35.3,0,64.1-28.7,64.1-64.1\n\t\tC464.1,364.7,435.3,335.9,400,335.9z")
            ]), l),
            A2(Eh, g([
                Th("M398,408.3c-2.4,0-4.3-1.9-4.3-4.3v-43.1c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3v38.8h35.6c2.4,0,4.3,1.9,4.3,4.3\n\t\ts-1.9,4.3-4.3,4.3H398z")
            ]), l)
        ]))
    ])), m$ = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M345.5,477.5c-0.4,0-0.8-0.1-1.2-0.2c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.2-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.3l-0.2-0.2\n\t\tc-0.3-0.3-0.5-0.6-0.6-0.9l-0.1-0.2c-0.2-0.5-0.3-0.9-0.3-1.2L342,367.5c0.2-0.4,17.7-42,56.5-44.8v-0.2l1.6,0.1l1.6-0.1l0,0.2\n\t\tc38.8,2.9,56.3,44.4,56.4,44.8l-0.1,106.7c0,0.4-0.1,0.8-0.2,1.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.3-0.4,0.6-0.6,0.9l-0.2,0.2\n\t\tc-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.4,0.2-0.8,0.2-1.2,0.2H345.5z M436.2,470.8\n\t\tl-22.3-8.5c-1.3-0.5-2.2-1.8-2.2-3.2l0-110c0-0.7,0-2.6,2.4-3.1l0.1,0l0.2,0c11.2,0.1,21.6,4.4,30.8,12.7c0.2,0.2,0.4,0.4,0.6,0.6\n\t\tc-8.6-12.6-24.2-29.6-45.9-30c-21.6,0.4-37.2,17.5-45.9,30.1c0.2-0.2,0.5-0.4,0.7-0.7c9.2-8.3,19.6-12.6,30.8-12.7l0.2,0l0.2,0\n\t\tc2.5,0.5,2.4,2.4,2.4,3.1l0,110c0,1.4-0.9,2.7-2.2,3.2l-22.3,8.5H436.2z M451.2,469.3v-92.9c-1.7-2.8-14.2-22-32.7-23.4\n\t\tc-0.1,29.5,0,94.8,0,103.8L451.2,469.3z M348.9,469.3l32.7-12.5c0-9,0.1-74.3,0-103.8c-18.6,1.4-31,20.6-32.7,23.4V469.3z")
            ]), l)
        ]))
    ])), p$ = function(n) {
        switch(n){
            case 0:
                return "01";
            case 1:
                return "02";
            case 2:
                return "03";
            case 3:
                return "04";
            case 4:
                return "05";
            case 5:
                return "06";
            case 6:
                return "07";
            case 7:
                return "08";
            case 8:
                return "09";
            case 9:
                return "10";
            case 10:
                return "11";
            default:
                return "12";
        }
    }, w$ = V, _$ = function(n) {
        return A2(w$, n, "");
    }, y$ = F3(function(n, r, t) {
        return n > 0 ? A3(y$, n >> 1, d(r, r), 1 & n ? d(t, r) : t) : t;
    }), z$ = F2(function(n, r) {
        return A3(y$, n, r, "");
    }), M$ = F3(function(n, r, t) {
        return d(A2(z$, n - ue(t), _$(r)), t);
    }), k$ = F2(function(n, r) {
        return Nt(n / r);
    }), x$ = function(n) {
        return n;
    }, C$ = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > a(e.bu, r)) return r + e.c;
            t = u;
        }
    }), H$ = F2(function(n, r) {
        var t = n.b;
        return A3(C$, n.a, A2(k$, r, 6e4), t);
    }), V$ = function(n) {
        var r = A2(k$, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, c = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), a = (5 * c + 2) / 153 | 0, i = a + (10 > a ? 3 : -9);
        return {
            bY: c - ((153 * a + 2) / 5 | 0) + 1,
            cw: i,
            dz: u + 400 * t + (i > 2 ? 0 : 1)
        };
    }, A$ = F2(function(n, r) {
        return V$(A2(H$, n, r)).bY;
    }), T$ = F2(function(n, r) {
        switch(V$(A2(H$, n, r)).cw){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), E$ = F2(function(n, r) {
        return V$(A2(H$, n, r)).dz;
    }), O$ = F2(function(n, r) {
        var t = A3(M$, 2, "0", ot(A2(E$, n, r))), e = p$(A2(T$, n, r));
        return A3(M$, 2, "0", ot(A2(A$, n, r))) + "." + e + "." + t;
    }), S$ = F2(function(n, r) {
        return A2(qe, 24, A2(k$, A2(H$, n, r), 60));
    }), j$ = F2(function(n, r) {
        return A2(qe, 60, A2(H$, n, r));
    }), B$ = F2(function(n, r) {
        var t = A3(M$, 2, "0", ot(A2(j$, n, r)));
        return A3(M$, 2, "0", ot(A2(S$, n, r))) + ":" + t;
    }), L$ = F2(function(n, r) {
        switch(A2(qe, 7, A2(k$, A2(H$, n, r), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), P$ = F2(function(n, r) {
        return function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Di";
                case 2:
                    return "Mi";
                case 3:
                    return "Do";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "So";
            }
        }(A2(L$, n, r));
    }), N$ = F2(function(n, r) {
        return A2(P$, n, r) + " " + A2(O$, n, r) + " | " + A2(B$, n, r) + " Uhr";
    }), I$ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), G$ = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), U$ = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(I$, e.a, e.b);
            var u = e.a, c = e.c, a = n(e.b)(c);
            if (1 === a.$) {
                var i = a.a;
                return A2(I$, u || i, a.b);
            }
            return i = a.a, A3(G$, u || i, a.b, a.c);
        };
    }), D$ = U$, F$ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), R$ = F4(function(n, r, t, e) {
        return {
            bO: r,
            dR: e,
            cU: t,
            c4: n
        };
    }), q$ = {
        $: 0
    }, K$ = F2(function(n, r) {
        return A2(F$, q$, A4(R$, n.c4, n.bO, r, n.g));
    }), Z$ = (As = {
        $: 10
    }, function(n) {
        return t(ue(n.fm), n.c) ? A3(G$, !1, 0, n) : A2(I$, !1, A2(K$, n, As));
    }), X$ = Fr, J$ = F5(function(n, r, e, u, c) {
        for(;;){
            var i = A3(X$, n, r, c.fm);
            if (t(i, -1)) return A3(G$, 0 > a(c.c, r), 0, {
                bO: u,
                g: c.g,
                h: c.h,
                c: r,
                c4: e,
                fm: c.fm
            });
            t(i, -2) ? (r += 1, e += 1, u = 1) : (r = i, u += 1);
        }
    }), W$ = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(I$, e.a, e.b);
            var u = e.b, c = e.c;
            return A3(G$, e.a, A2(n, A3(ce, r.c, c.c, r.fm), u), c);
        };
    }), Y$ = function(n) {
        return A2(W$, Xb, n);
    }, Q$ = function(n) {
        return function(n) {
            return function(r) {
                return A2(I$, !1, A2(K$, r, n));
            };
        }(function(n) {
            return {
                $: 12,
                a: n
            };
        }(n));
    }, nm = C, rm = function(n) {
        return function(r) {
            return A3(G$, !1, n, r);
        };
    }, tm = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return ct;
        var r = +n;
        return r == r ? ut(r) : ct;
    }, em = A2(D$, function(n) {
        if (ue(n) > 9) return Q$("Expected at most 9 digits, but got " + ot(ue(n)));
        var r = tm("0." + n);
        return r.$ ? Q$('Invalid float: "' + n + '"') : rm(nm(1e3 * r.a));
    }, Y$((Ls = _t, function(n) {
        return A5(J$, Ls, n.c, n.c4, n.bO, n);
    }))), um = re, cm = F6(function(n, r, t, e, u, c) {
        return um(n + 60 * r * 60000 + 60 * (t - c) * 1e3 + 1e3 * e + u);
    }), am = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(I$, t.a, t.b);
            var c = t.a, a = t.b, i = u(t.c);
            if (1 === i.$) {
                var o = i.a;
                return A2(I$, c || o, i.b);
            }
            o = i.a;
            var f = i.c;
            return A3(G$, c || o, A2(n, a, i.b), f);
        };
    }), im = F2(function(n, r) {
        return A3(am, Xb, n, r);
    }), om = im, fm = F2(function(n, r) {
        return A3(am, Bt, n, r);
    }), sm = fm, bm = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), dm = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var c;
                    if ((c = u).a) return c;
                    r = A2(bm, r, c.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(I$, !1, r);
        }
    }), lm = function(n) {
        return function(r) {
            return A3(dm, r, q$, n);
        };
    }, vm = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hm = A, gm = {
        $: 11
    }, $m = F2(function(n, r) {
        return function(e) {
            var u = A3(X$, n, e.c, e.fm);
            return t(u, -1) ? A2(I$, !1, A2(K$, e, r)) : t(u, -2) ? A3(G$, !0, 0, {
                bO: 1,
                g: e.g,
                h: e.h,
                c: e.c + 1,
                c4: e.c4 + 1,
                fm: e.fm
            }) : A3(G$, !0, 0, {
                bO: e.bO + 1,
                g: e.g,
                h: e.h,
                c: u,
                c4: e.c4,
                fm: e.fm
            });
        };
    }), mm = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return c = u.a, A2(I$, n || c, u.b);
            var c = u.a, a = u.b, i = u.c;
            if (a.$) return A3(G$, n || c, a.a, i);
            n = n || c, r = a.a, e = i;
        }
    }), pm = F2(function(n, r) {
        return function(t) {
            return A4(mm, !1, n, r, t);
        };
    }), wm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(I$, e.a, e.b);
            var u = e.c;
            return A3(G$, e.a, n(e.b), u);
        };
    }), _m = wm, ym = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, zm = F2(function(n, r) {
        return A2(pm, n, function(n) {
            return A2(_m, ym, r(n));
        });
    }), Mm = function(n) {
        var r = function(r) {
            if (t(ue(r), n)) {
                var e = se(r);
                return e.$ ? Q$('Invalid integer: "' + r + '"') : A2(_m, vm, rm(e.a));
            }
            return A2(_m, function(n) {
                return function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(A2(hm, r, n));
            }, Y$(A2($m, _t, gm)));
        };
        return A2(zm, "", r);
    }, km = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xm = Dr, Cm = function(n) {
        return function(n) {
            var r = n.a, e = n.b, u = !oe(r);
            return function(n) {
                var c = A5(xm, r, n.c, n.c4, n.bO, n.fm), a = c.a, i = c.b, o = c.c;
                return t(a, -1) ? A2(I$, !1, A2(K$, n, e)) : A3(G$, u, 0, {
                    bO: o,
                    g: n.g,
                    h: n.h,
                    c: a,
                    c4: i,
                    fm: n.fm
                });
            };
        }(A2(km, n, function(n) {
            return {
                $: 8,
                a: n
            };
        }(n)));
    }, Hm = function(n) {
        return Q$("Invalid day: " + ot(n));
    }, Vm = function(n) {
        return !(A2(qe, 4, n) || !A2(qe, 100, n) && A2(qe, 400, n));
    }, Am = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, Tm = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return Hm(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), c = 864e5 * ((3 > t || !Vm(r) ? e - 1 : e) + (Am(r) - Am(1970)));
            return rm(n + u + c);
        };
        switch(t){
            case 1:
                return e > 31 ? Hm(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !Vm(r) ? Hm(e) : u(26784e5);
            case 3:
                return e > 31 ? Hm(e) : u(50976e5);
            case 4:
                return e > 30 ? Hm(e) : u(7776e6);
            case 5:
                return e > 31 ? Hm(e) : u(10368e6);
            case 6:
                return e > 30 ? Hm(e) : u(130464e5);
            case 7:
                return e > 31 ? Hm(e) : u(156384e5);
            case 8:
                return e > 31 ? Hm(e) : u(183168e5);
            case 9:
                return e > 30 ? Hm(e) : u(209952e5);
            case 10:
                return e > 31 ? Hm(e) : u(235872e5);
            case 11:
                return e > 30 ? Hm(e) : u(262656e5);
            case 12:
                return e > 31 ? Hm(e) : u(288576e5);
            default:
                return Q$('Invalid month: "' + ot(t) + '"');
        }
    }, Em = A2(D$, Tm, A2(sm, A2(sm, A2(sm, rm(F3(function(n, r, t) {
        return f(n, r, t);
    })), Mm(4)), lm(g([
        A2(sm, A2(om, rm(re), Cm("-")), Mm(2)),
        Mm(2)
    ]))), lm(g([
        A2(sm, A2(om, rm(re), Cm("-")), Mm(2)),
        Mm(2)
    ])))), Om = (Ts = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(sm, rm(re), lm(g([
        A2(_m, function() {
            return 0;
        }, Cm("Z")),
        A2(sm, A2(sm, A2(sm, rm(Ts), lm(g([
            A2(_m, function() {
                return 1;
            }, Cm("+")),
            A2(_m, function() {
                return -1;
            }, Cm("-"))
        ]))), Mm(2)), lm(g([
            A2(sm, A2(om, rm(re), Cm(":")), Mm(2)),
            Mm(2),
            rm(0)
        ]))),
        A2(om, rm(0), Z$)
    ])))), Sm = A2(D$, function(n) {
        return lm(g([
            A2(sm, A2(sm, A2(sm, A2(sm, A2(sm, A2(om, rm(cm(n)), Cm("T")), Mm(2)), lm(g([
                A2(sm, A2(om, rm(re), Cm(":")), Mm(2)),
                Mm(2)
            ]))), lm(g([
                A2(sm, A2(om, rm(re), Cm(":")), Mm(2)),
                Mm(2),
                rm(0)
            ]))), lm(g([
                A2(sm, A2(om, rm(re), Cm(".")), em),
                rm(0)
            ]))), A2(om, Om, Z$)),
            A2(om, rm(A6(cm, n, 0, 0, 0, 0, 0)), Z$)
        ]));
    }, Em), jm = F3(function(n, r, t) {
        return {
            bO: r,
            cU: t,
            c4: n
        };
    }), Bm = function(n) {
        return A3(jm, n.c4, n.bO, n.cU);
    }, Lm = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(Zr, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Lm, e, r);
                continue n;
        }
    }), Pm = F2(function(n, r) {
        var t = n({
            bO: 1,
            g: l,
            h: 1,
            c: 0,
            c4: 1,
            fm: r
        });
        return t.$ ? Wr(A2(Lm, t.b, l)) : rt(t.b);
    }), Nm = F2(function(n, r) {
        var t = A2(Pm, n, r);
        return t.$ ? Wr(A2(ye, Bm, t.a)) : rt(t.a);
    }), Im = function(n) {
        return A2(Nm, Sm, n);
    }, Gm = F3(function(n, r, t) {
        return A3(Cd, t, n(r.fx), ed(Im(t)));
    }), Um = Gm(N$), Dm = F3(function(n, r, t) {
        var e = function(r) {
            var t = r.a, e = r.b;
            return A2(Ev, g([
                Tv("napi-event")
            ]), g([
                A2(Ev, g([
                    Tv("napi-event-title")
                ]), g([
                    Nv(t.fy)
                ])),
                A2(Ev, l, g([
                    Nv(A2(Um, n, t.dh))
                ])),
                e
            ]));
        };
        return lt(t) ? A2(Ev, l, A2(ye, e, t)) : Nv("Keine " + r + " angegeben");
    }), Fm = F3(function(n, r, t) {
        return A3(Dm, n, r, A2(ye, function(n) {
            return o(n, Nv(""));
        }, t));
    }), Rm = F2(function(n, r) {
        return A3(Fm, n, "Gottesdienste", r.b.bk.bK);
    }), qm = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Km = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Zm = A2(Ev, g([
        Tv("rotate-90 d-flex")
    ]), g([
        A2(ch, g([
            oh("7.86"),
            th("30"),
            ih("0 0 7.86 30")
        ]), g([
            A2(Eh, g([
                Th("M12.9,1.05,12.07,1l5.19,14.14.01,1.72L12.07,31l.83-.05,7.03-14.07V15.12Z"),
                ah("translate(-12.07 -1)")
            ]), l)
        ]))
    ])), Xm = F2(function(n, r) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(A2(Jl, r, n));
    }), Jm = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wm = A2(ch, g([
        $g("1.1"),
        eh("Ebene_1"),
        mg("0px"),
        pg("0px"),
        oh("100px"),
        th("100px"),
        ih("290 290 220 220"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M468.5,394.1c-0.3-37.2-30.7-67.3-67.9-67.3c-37.2,0-67.6,30.1-67.9,67.3c-19.3,2.1-34.4,18.5-34.4,38.4 c0,21.3,17.3,38.6,38.6,38.6h4.2v-76.3c0-32.9,26.7-59.6,59.6-59.6c32.6,0,59.1,26.3,59.6,58.7H460V471h4.2 c21.3,0,38.6-17.3,38.6-38.6C502.7,412.7,487.7,396.3,468.5,394.1z M332.7,462.4c-14.7-2-26.1-14.7-26.1-30s11.4-27.9,26.1-30 V462.4z M468.3,462.4v-59.9c14.7,2,26.1,14.7,26.1,30S483,460.4,468.3,462.4z")
            ]), l)
        ])),
        A2(Eh, g([
            Th("M381.3 452v-61l44.2,30.5L381.3,452z")
        ]), l)
    ])), Ym = F3(function(n, r, t) {
        return A2(Ev, g([
            Tv("audio-button"),
            Xv(Jm(t))
        ]), g([
            Wm
        ]));
    }), Qm = F3(function(n, r, t) {
        var e = t.a, u = t.c, c = La(A3(Pa, e, t.b, b(u, {
            co: !u.co
        }))), a = "folding-altar-" + ot(e.am);
        return A2(Ev, g([
            vh(g([
                o("folding-altar-container", !0),
                o("open", u.co)
            ]))
        ]), g([
            A3(Bv, "div", l, g([
                o(a, A2(Ev, g([
                    Tv("folding-altar"),
                    yh(a)
                ]), l))
            ])),
            A2(Uv, g([
                Tv("folding-altar-button"),
                Xv(r(c))
            ]), g([
                A3(Jv, u.co, Nv("Schlie\xdfen"), Nv("\xd6ffnen"))
            ]))
        ]));
    }), np = F2(function(n, r) {
        return A2(tr, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), cr(r));
    }), rp = np, tp = F3(function(n, r, t) {
        var e = t.a, u = t.b;
        return A3(Bv, "div", g([
            Tv("elph-editor__html-content")
        ]), g([
            o("html-viewer-" + ot(e.am), A3(jh, "html-viewer", g([
                A2(rp, "content", Fd(u.ee))
            ]), l))
        ]));
    }), ep = function(n) {
        var r = n.a, t = n.b;
        return Dd(g([
            o("latitude", bl(t.bk.bg)),
            o("longitude", bl(t.bk.bh)),
            o("id", Ud(r.am)),
            o("complex", qd(t.bP))
        ]));
    }, up = function(n) {
        return A2(al, ep, n);
    }, cp = function(n) {
        var r = n.a, t = n.b;
        return Dd(g([
            o("latitude", bl(t.bg)),
            o("longitude", bl(t.bh)),
            o("id", Ud(r.am))
        ]));
    }, ap = function(n) {
        return A2(al, cp, n);
    }, ip = F3(function(n, r, t) {
        var e = t.a, u = t.b;
        return A2(Gg, function(n) {
            var r = n.a, t = n.b;
            return A3(Bv, "div", l, g([
                o("content-" + ot(e.am), A3(jh, "leaflet-map", g([
                    A2(rp, "config", u.aQ),
                    A2(rp, "churches", up(r)),
                    A2(rp, "regions", ap(t))
                ]), l))
            ]));
        }, A3(vg, _g, n.dO, n.fa));
    }), op = F3(function(n, r, t) {
        var e = t.b;
        return A3(Bv, "div", l, g([
            o("content-" + ot(t.a.am), A3(jh, "searching-game", g([
                A2(rp, "config", e.aQ)
            ]), g([
                Nv("SEARCHINGGAME")
            ])))
        ]));
    }), fp = F3(function(n, r, t) {
        var e = t.b;
        return A3(Bv, "div", l, g([
            o("content-" + ot(t.a.am), A3(jh, "tangram-game", g([
                A2(rp, "config", e.aQ)
            ]), g([
                Nv("TANGRAM")
            ])))
        ]));
    }), sp = F3(function(n, r, t) {
        var e, u, c = t.a, a = t.b, i = t.c, f = (e = function(n) {
            switch(n){
                case 0:
                    return o(1, 0);
                case 1:
                    return o(2, 1);
                default:
                    return o(2, 4);
            }
        }(i.di), Ti(A3(Ei, c, a, b(i, {
            di: e.a,
            du: e.b
        })))), s = "triple-folding-altar-" + ot(c.am), d = (u = function(n) {
            switch(n){
                case 0:
                    return o(0, 4);
                case 1:
                    return o(0, 3);
                default:
                    return o(1, 2);
            }
        }(i.di), Ti(A3(Ei, c, a, b(i, {
            di: u.a,
            du: u.b
        }))));
        return A2(Ev, g([
            vh(g([
                o("folding-altar-container", !0),
                o(Zd(i.di), !0),
                o(Jd(i.du), !0)
            ]))
        ]), g([
            A2(Ev, g([
                Tv("folding-altar-button-container")
            ]), g([
                A2(Uv, g([
                    vh(g([
                        o("folding-altar-button", !0),
                        o("button-unavailable", !1)
                    ])),
                    Xv(r(f))
                ]), g([
                    Nv("\xd6ffnen")
                ])),
                A2(Uv, g([
                    vh(g([
                        o("folding-altar-button", !0),
                        o("button-unavailable", !1)
                    ])),
                    Xv(r(d))
                ]), g([
                    Nv("Schlie\xdfen")
                ]))
            ])),
            A3(Bv, "div", l, g([
                o(s, A2(Ev, g([
                    Tv("folding-altar"),
                    yh(s)
                ]), l))
            ]))
        ]));
    }), bp = {
        $: 1
    }, dp = Av("poster"), lp = Wn("video"), vp = F3(function(n, r, t) {
        var e = t.b;
        return A2(Ev, l, g([
            A2(lp, g([
                Tv("mw-100"),
                _h(!0),
                A2(Zv, "play", Qt(bp)),
                dp(e.e3)
            ]), g([
                A2(zh, g([
                    Mh(A2(Ku, "", e.eB)),
                    xh("video/mp4")
                ]), l),
                A2(zh, g([
                    Mh(e.a7),
                    xh(e.bj)
                ]), l),
                Nv("Dieser Browser unterst\xfctzt kein <video>")
            ]))
        ]));
    }), hp = F3(function(n, r, t) {
        return A2(Vh, t.b.bf, function(n) {
            return A2(Ev, g([
                Tv("widescreen-image")
            ]), g([
                A2(s$, g([
                    Mh(n.a7)
                ]), l)
            ]));
        });
    }), gp = function(n) {
        var r, t;
        return t = (r = n).b, o(ot(r.a.am), t.a7);
    }, $p = F3(function(n, r, t) {
        return n(r(t));
    }), mp = F2(function(n, r) {
        return A2(bh, r, A2(Ev, g([
            Tv("image-gallery-arrow-container")
        ]), g([
            A2(Ev, g([
                Tv("image-gallery-arrow left"),
                A2(u$, n, A2($p, Xv, Rt))
            ]), g([
                A2(Lv, g([
                    Tv("image-gallery-arrow-container-icon")
                ]), g([
                    A2(Lv, l, g([
                        Sh
                    ]))
                ]))
            ])),
            A2(Ev, g([
                Tv("image-gallery-arrow right"),
                A2(u$, n, A2($p, Xv, Re))
            ]), g([
                A2(Lv, g([
                    Tv("image-gallery-arrow-container-icon")
                ]), g([
                    A2(Lv, l, g([
                        Sh
                    ]))
                ]))
            ]))
        ])));
    }), pp = F3(function(n, r, t) {
        return A2(Ev, g([
            Tv("image-gallery")
        ]), g([
            t,
            A2(mp, n, r)
        ]));
    }), wp = F3(function(n, r, t) {
        var e, u = t.a, c = t.b, a = t.c, i = lt(c.a), f = sc(A3(bc, u, c, b(a, {
            dU: (a.dU + 1) % i
        }))), s = sc(A3(bc, u, c, b(a, {
            dU: (a.dU - 1 + i) % i
        }))), d = function(n) {
            return 30 === n.$ ? ut(n.a) : ct;
        }, v = A2(Ku, o("", ""), A2(fl, gp, (e = A2(fl, d, A2(vv, a.dU, c.a))).$ ? ct : e.a)), h = v.b, $ = A2(Ev, l, g([
            A2(s$, g([
                yh(v.a),
                Tv("object-fit-contain"),
                Mh(h)
            ]), l)
        ]));
        return A3(pp, ut(o(r(s), r(f))), i > 1, $);
    }), _p = function(n) {
        switch(n){
            case 1:
                return "imageToText";
            case 0:
                return "textToImage";
            default:
                return "textToText";
        }
    }, yp = Wn("h3"), zp = function(n) {
        return A2(Ba, function(n) {
            return n.$ ? ct : ut(n.a);
        }, n);
    }, Mp = Av("alt"), kp = er("draggable"), xp = function(n) {
        var r = n.a, t = n.b;
        return A2(s$, g([
            Tv("card-img"),
            Mp(r.eE),
            kp("false"),
            Mh(t.a7)
        ]), l);
    }, Cp = function(n) {
        return A2(Ev, g([
            Tv("association-game--text")
        ]), g([
            Nv(n)
        ]));
    }, Hp = F2(function(n, r) {
        if (!n) return 0 === r.$ ? xp(r.b) : Cp(r.b);
        switch(r.$){
            case 0:
            default:
                return Cp(r.a);
            case 1:
                return xp(r.a);
        }
    }), Vp = function(n) {
        var r = n.a, t = n.b.d6;
        return A2(Ev, g([
            Tv("association-game--option d-none"),
            A2(e$, "data-group", "association-group-" + ot(r.am))
        ]), g([
            A2(Hp, !0, t)
        ]));
    }, Ap = function(n) {
        return A2(Ev, g([
            Tv("association-game--options")
        ]), A2(ye, Vp, zp(n.a)));
    }, Tp = F2(function(n, r) {
        var t = r.a, e = r.b.ek, u = r.b.d6, c = A2(Hp, !1, u), a = A2(Ev, g([
            Tv("association-game--answer d-none")
        ]), g([
            A2(Hp, !0, u)
        ]));
        return A2(Ev, g([
            Tv("association-game--target"),
            A2(mh, n, Tv("d-none")),
            A2(e$, "data-group", "association-group-" + ot(t.am)),
            A2(e$, "data-info-text", A2(Ku, "", e))
        ]), g([
            c,
            a
        ]));
    }), Ep = F2(function(n, r) {
        return A2(ye, Tp(n), zp(r.a));
    }), Op = function(n) {
        var r;
        return r = A2(Ev, g([
            Tv("association-game--targets")
        ]), A2(Ep, !0, n)), A3(pp, ct, !0, r);
    }, Sp = F3(function(n, r, t) {
        var e = t.b;
        return A3(Bv, "div", l, g([
            o(ot(t.a.am), A3(jh, "association-game", g([
                Tv("association-game association-game--" + _p(e.fq)),
                A2(e$, "data-success-text", e.fu)
            ]), g([
                A2(yp, l, g([
                    Nv(e.fy)
                ])),
                A2(Ev, g([
                    Tv("association-game--content")
                ]), g([
                    e.fq ? function(n) {
                        return A2(Ev, g([
                            Tv("association-game--targets")
                        ]), A2(Ep, !1, n));
                    }(e) : Op(e),
                    Ap(e)
                ]))
            ])))
        ]));
    }), jp = function(n) {
        return kl(Pt(n));
    }, Bp = function(n) {
        return A2(Ev, g([
            Tv("levite-chair--selection-overlay")
        ]), g([
            A2(Ev, g([
                Tv("levite-chair--selection-index")
            ]), g([
                Nv(n)
            ]))
        ]));
    }, Lp = F2(function(n, r) {
        return A3(dt, Zr, r, n);
    }), Pp = F4(function(n, r, e, u) {
        for(;;){
            if (!e.b) return n;
            var c = e.a, a = e.b;
            if (t(r, c)) return A2(Lp, u, a);
            e = a, u = A2(Zr, c, u);
        }
    }), Np = F2(function(n, r) {
        return A4(Pp, r, n, r, l);
    }), Ip = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Zr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Gp = F2(function(n, r) {
        return zt(A3(Ip, n, r, l));
    }), Up = F3(function(n, r, t) {
        if (r > 0) {
            var e = o(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return g([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var c = e.b, a = c.b;
                                return g([
                                    c.a,
                                    a.a,
                                    a.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var i = e.b, f = i.b, s = f.b, b = s.b, d = b.b;
                                return A2(Zr, i.a, A2(Zr, f.a, A2(Zr, s.a, A2(Zr, b.a, n > 1e3 ? A2(Gp, r - 4, d) : A3(Up, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return g([
                e.b.a
            ]);
        }
        return l;
    }), Dp = F2(function(n, r) {
        return A3(Up, 0, n, r);
    }), Fp = F4(function(n, r, t, e) {
        for(;;){
            if (!t.b) return zt(e);
            var u = t.a, c = t.b, a = n(u);
            A2(Ni, a, r) ? t = c : (r = A2(Zr, a, r), t = c, e = A2(Zr, u, e));
        }
    }), Rp = F2(function(n, r) {
        var t;
        return b(n, {
            da: A2(Ni, r, n.da) ? A2(Np, r, n.da) : A2(Dp, 4, (t = A2(Xe, n.da, g([
                r
            ])), A4(Fp, re, l, t, l)))
        });
    }), qp = F3(function(n, r, t) {
        var e = t.a, u = t.b, c = A2(fl, ot, A2(fl, et(1), A2(jp, e, r.da)));
        return A2(Uv, g([
            Tv("levite-chair--item"),
            Xv(n(A2(Rp, r, e)))
        ]), g([
            A2(s$, g([
                yh(e),
                Mh("/levite/" + e),
                Mp(u)
            ]), l),
            A2(Vh, c, Bp),
            A2(Lv, g([
                Tv("levite-chair--item--title")
            ]), g([
                Nv(u)
            ]))
        ]));
    }), Kp = g([
        o("engel.png", "Der Engel verk\xfcndet Maria die Geburt Jesu"),
        o("geburt.png", "Jesu ist geboren"),
        o("taufe.png", "Johannes tauft Jesus im Jordan"),
        o("heilung.png", "Jesus heilt einen Gel\xe4hmten"),
        o("kreuz.png", "Jesus stirbt am Kreuz"),
        o("auferstehung.png", "Jesus ist auferstanden")
    ]), Zp = Wn("h2"), Xp = F3(function(n, r, t) {
        var e, u = t.a, c = t.c, a = function(n) {
            return r(Za(A3(Xa, u, 0, n)));
        };
        return A2(Ev, g([
            Tv("levite-chair")
        ]), g([
            A2(Ev, g([
                Tv("levite-chair--items")
            ]), A2(ye, A2(qp, a, c), Kp)),
            A2(Uv, g([
                Tv("btn btn-primary m-2"),
                Xv(a(b(c, {
                    c$: c.da
                })))
            ]), g([
                Nv("Bild generieren")
            ])),
            A2(bh, lt(c.c$) > 0, (e = c.c$, A2(Ev, g([
                Tv("mt-5")
            ]), g([
                A2(Zp, l, g([
                    Nv("Ihr Levitenstuhl")
                ])),
                A2(Ev, l, g([
                    Nv("Wenn Sie auf das Bild tippen, k\xf6nnen Sie es auf Ihrem Ger\xe4t abspeichern")
                ])),
                A3(jh, "levite-chair-render", g([
                    A2(rp, "selection", A2(al, Fd, e))
                ]), l)
            ])))),
            A2(s$, g([
                Tv("d-none"),
                yh("levite-chair-background"),
                Mh("/levite/_background.png")
            ]), l)
        ]));
    }), Jp = {
        $: 4
    }, Wp = {
        $: 2
    }, Yp = {
        $: 3
    }, Qp = F2(function(n, r) {
        return A2(Kv, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), nw = F2(function(n, r) {
        var t;
        return g([
            A2(Qp, "dragover", Qt({
                aD: n(Wp),
                aG: !0,
                aH: !0
            })),
            A2(Qp, "dragleave", Qt({
                aD: n(Yp),
                aG: !0,
                aH: !0
            })),
            A2(Qp, "drop", Qt({
                aD: n((t = o(r.e4, r.eP), !t.a.$ && t.b ? function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(t.a.a) : Jp)),
                aG: !0,
                aH: !0
            }))
        ]);
    }), rw = F2(function(n, r) {
        return A2(s$, d(g([
            Tv("present-game--baby"),
            Mh("/presents/baby.png")
        ]), A2(nw, n, r)), l);
    }), tw = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ew = F2(function(n, r) {
        return g([
            kp("true"),
            A2(Qp, "dragstart", Qt({
                aD: n(tw(r)),
                aG: !1,
                aH: !0
            })),
            A2(Qp, "dragend", Qt({
                aD: n(Jp),
                aG: !0,
                aH: !0
            }))
        ]);
    }), uw = function(n) {
        switch(n){
            case 0:
                return {
                    aw: g([
                        "Harz des Myrrhe-Strauches",
                        "Anbau in Somalia",
                        "wichtiges Heilmittel der Antike, desinfizierend und entz\xfcndungshemmend",
                        "heute noch eingesetzt in der Zahnheilkunde"
                    ]),
                    ay: "istock/Madeleine Steinbach",
                    am: "myrrh",
                    fy: "Myrrhe"
                };
            case 1:
                return {
                    aw: g([
                        "zeitlos wertvolles Edelmetall",
                        "Abbau beispielsweise in China, Australien, den Vereinigten Staaten, Kanada oder Afrika",
                        "Herstellung von Schmuck und M\xfcnzen sowie zur Vergoldung"
                    ]),
                    ay: "istock/BanksPhotos",
                    am: "gold",
                    fy: "Gold"
                };
            default:
                return {
                    aw: g([
                        "Harz des Weihrauch-Baumes",
                        "Anbau auf der arabischen Halbinsel",
                        "Duft entsteht beim Abbrennen",
                        "heute noch R\xe4uchermittel in verschiedenen Religionen"
                    ]),
                    ay: "istock/assalve",
                    am: "incense",
                    fy: "Weihrauch"
                };
        }
    }, cw = F2(function(n, r) {
        return A2(s$, d(g([
            Tv("present-game--" + uw(r).am),
            Mh("/presents/" + uw(r).am + ".png")
        ]), A2(ew, n, r)), l);
    }), aw = F2(function(n, r) {
        return A2(Ev, g([
            vh(g([
                o("present-game--container", !0),
                o("dragging", !t(r.e4, ct)),
                o("dropping", r.eP)
            ]))
        ]), g([
            A2(s$, g([
                Tv("present-game--background"),
                Mh("/presents/background.png")
            ]), l),
            A2(rw, n, r),
            A2(cw, n, 2),
            A2(cw, n, 0),
            A2(cw, n, 1)
        ]));
    }), iw = Wn("li"), ow = Wn("small"), fw = Wn("ul"), sw = F2(function(n, r) {
        var t = uw(r);
        return A2(Ev, g([
            Tv("present-game--modal")
        ]), g([
            A2(Ev, g([
                Tv("present-game--modal-content")
            ]), g([
                A2(Ev, l, g([
                    A2(Uv, g([
                        Tv("close"),
                        Xv(n),
                        A2(e$, "aria-label", "Detailansicht schlie\xdfen")
                    ]), g([
                        fh
                    ])),
                    A2(Zp, l, g([
                        Nv(t.fy)
                    ]))
                ])),
                A2(s$, g([
                    Mh("/presents/" + t.am + "_detail.jpg")
                ]), l),
                A2(ow, l, g([
                    Nv("Foto: " + t.ay)
                ])),
                A2(fw, l, A2(ye, function(n) {
                    return A2(iw, l, g([
                        Nv(n)
                    ]));
                }, t.aw)),
                A2(Uv, g([
                    Tv("btn btn-primary mt-5 d-block"),
                    Xv(n)
                ]), g([
                    Nv("N\xe4chste Gabe")
                ]))
            ]))
        ]));
    }), bw = F3(function(n, r, t) {
        var e = t.a, u = t.c, c = r(ai(A3(ii, e, 0, b(u, {
            cv: ct
        })))), a = u.aT, i = u.cv, o = function(n) {
            return r(ai(A3(ii, e, 0, function(n) {
                switch(n.$){
                    case 0:
                        return b(u, {
                            aT: b(a, {
                                eP: !1,
                                e4: ut(n.a)
                            })
                        });
                    case 1:
                        var r = n.a;
                        return b(u, {
                            aT: b(a, {
                                eP: !1,
                                e4: ct
                            }),
                            cv: ut(r)
                        });
                    case 2:
                        return b(u, {
                            aT: b(a, {
                                eP: !0
                            })
                        });
                    case 3:
                        return b(u, {
                            aT: b(a, {
                                eP: !1
                            })
                        });
                    default:
                        return b(u, {
                            aT: b(a, {
                                eP: !1,
                                e4: ct
                            })
                        });
                }
            }(n))));
        };
        return A2(Ev, g([
            Tv("present-game")
        ]), g([
            A2(aw, o, a),
            A2(Vh, i, sw(c))
        ]));
    }), dw = function(n) {
        return A2(Ba, function(n) {
            return 17 === n.$ ? ut(n.a) : ct;
        }, n);
    }, lw = function(n) {
        return lt(A2(tu, function(n) {
            return lt(n.b.a) > 0;
        }, dw(n)));
    }, vw = F3(function(n, r, e) {
        return A2(Ev, g([
            Tv("quiz-navigation")
        ]), g([
            A2(Uv, g([
                Xv(n(r - 1)),
                vh(g([
                    o("btn btn-outline-primary", !0),
                    o("invisible", !r)
                ]))
            ]), g([
                Nv("Zur\xfcck")
            ])),
            A2(Uv, g([
                Xv(n(r + 1)),
                vh(g([
                    o("btn btn-primary", !0),
                    o("invisible", t(r, e))
                ]))
            ]), g([
                Nv("Weiter")
            ]))
        ]));
    }), hw = F3(function(n, r, t) {
        var e = t.b;
        return A2(Uv, g([
            vh(g([
                o("btn", !0),
                o("btn-secondary", !r),
                o("btn-success", r && e.dS),
                o("btn-danger", r && !e.dS)
            ])),
            Xv(n)
        ]), g([
            Nv(e.dD)
        ]));
    }), gw = F2(function(n, r) {
        var e = r.a, u = r.b, c = r.c, a = F2(function(r, t) {
            var a = t.b;
            return n(yc(A3(zc, e, u, b(c, {
                bS: ut(r),
                b6: !1,
                b7: c.b7 || c.b6 && a.dS
            }))));
        });
        return A2($t, F2(function(n, r) {
            return A3(hw, A2(a, n, r), t(c.bS, ut(n)), r);
        }), A2(Ba, function(n) {
            return 16 === n.$ ? ut(n.a) : ct;
        }, u.a));
    }), $w = F3(function(n, r, t) {
        var e = t.b;
        return A2(Ev, g([
            Tv("quiz-question-container")
        ]), d(g([
            A2(Ev, g([
                Tv("quiz-question")
            ]), g([
                Nv(e.e5)
            ])),
            A2(Vh, e.d9, function(n) {
                return A2(s$, g([
                    Tv("content-image"),
                    Mh(n.a7)
                ]), l);
            }),
            A2(Ev, l, A2(Je, function(n) {
                return g([
                    Nv(n),
                    A2(Ih, l, l)
                ]);
            }, A2(st, "\n", e.ba)))
        ]), A2(gw, r, t)));
    }), mw = F5(function(n, r, t, e, u) {
        var c = u.b;
        return A2(Ev, l, g([
            A2(Ev, g([
                Tv("quiz-counter")
            ]), g([
                A2(bh, lt(c.a) > 0, Nv("Frage " + ot(t) + "/" + ot(e)))
            ])),
            A3($w, n, r, u)
        ]));
    }), pw = function(n) {
        return A2(dt, F2(function(r, t) {
            return n(r) ? t + 1 : t;
        }), 0);
    }, ww = F3(function(n, r, t) {
        var e = t.b, u = r(pc(A3(wc, t.a, b(e, {
            a: A2(ye, function(n) {
                return yc(A3(zc, n.a, n.b, ei));
            }, dw(e.a))
        }), ui))), c = A2(pw, function(n) {
            return n.c.b7;
        }, dw(e.a)), a = c ? ot(c) + " von " + ot(lw(e.a)) + " Fragen" : "keine Frage";
        return A2(Ev, g([
            Tv("quiz-summary")
        ]), g([
            A2(Dh, l, g([
                Nv("Ergebnis")
            ])),
            Nv("Du hast " + a + " richtig beantwortet."),
            A2(Uv, g([
                Xv(u),
                Tv("btn btn-primary")
            ]), g([
                Nv("Quiz neu starten")
            ]))
        ]));
    }), _w = F2(function(n, r) {
        return o(A2(Dp, n, r), A2(dv, n, r));
    }), yw = F3(function(n, r, t) {
        var e, u = t.a, c = t.b, a = t.c, i = lw(c.a), o = lw(A2(_w, a.bW, c.a).a), f = (e = A2(vv, a.bW, dw(c.a))).$ ? A3(ww, n, r, t) : A5(mw, n, r, o + 1, i, e.a), s = function(n) {
            return r(pc(A3(wc, u, c, b(a, {
                bW: n
            }))));
        };
        return A2(Ev, g([
            Tv("quiz")
        ]), g([
            f,
            A3(vw, s, a.bW, lt(c.a))
        ]));
    }), zw = F3(function(n, r, t) {
        return d$(t);
    }), Mw = {
        $: 1
    }, kw = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xw = {
        $: 0
    }, Cw = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), Hw = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Vw = F2(function(n, r) {
        return 0 > a(n, r) ? n : r;
    }), Aw = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tw = F3(function(n, r, e) {
        return g([
            kp("true"),
            vh(g([
                o("dragging", t(r.fm, ut(e)))
            ])),
            A2(Qp, "dragstart", Qt({
                aD: n(Aw(e)),
                aG: !1,
                aH: !0
            }))
        ]);
    }), Ew = {
        $: 4
    }, Ow = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Sw = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jw = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Bw = F3(function(n, r, e) {
        var u;
        return g([
            vh(g([
                o("dropping", t(r.dX, ut(e)))
            ])),
            A2(Qp, "dragover", Qt({
                aD: n(Sw(e)),
                aG: !0,
                aH: !0
            })),
            A2(Qp, "dragleave", Qt({
                aD: n(jw(e)),
                aG: !0,
                aH: !0
            })),
            A2(Qp, "drop", Qt({
                aD: n((u = o(r.fm, r.dX), u.a.$ || u.b.$ ? Ew : A2(Ow, u.a.a, u.b.a))),
                aG: !0,
                aH: !0
            }))
        ]);
    }), Lw = N, Pw = F2(function(n, r) {
        return A2(fl, function(n) {
            return A2(_w, n, r);
        }, A2(kl, n, r));
    }), Nw = F3(function(n, r, e) {
        var u = A2(Pw, function(r) {
            return t(r, n);
        }, e);
        if (u.$) return d(e, g([
            r
        ]));
        var c = u.a;
        return d(c.a, A2(Zr, r, c.b));
    }), Iw = F3(function(n, r, e) {
        return t(e, r) ? n : t(e, n) ? r : e;
    }), Gw = F3(function(n, r, e) {
        var u = e.a, c = e.b, a = e.c, i = function(n) {
            var r = n.bF, t = n.bG, e = lt(r), u = A2(Gt, e + .5, 3.5), c = A3(dt, F2(function(n, r) {
                return A2(Vw, r, n.fC);
            }), 1e3, r);
            return A2(Vw, c, c * t / (A3(dt, F2(function(n, r) {
                return r + n.eb * c / n.fC;
            }), 0, r) / e * u));
        }(a), o = "tower-game-" + ot(u.am), f = a.aT, s = a.b0, v = a.bF, h = a.ci, $ = function(n) {
            return lt(v) ? l : g([
                n
            ]);
        }, m = function(n) {
            return r(Lc(A3(Pc, u, c, function(n) {
                switch(n.$){
                    case 0:
                        return b(a, {
                            aT: b(f, {
                                dX: ct,
                                fm: ut(n.a)
                            })
                        });
                    case 1:
                        var r = n.a, e = n.b;
                        return b(a, {
                            bF: function() {
                                switch(e.$){
                                    case 1:
                                        return A2(Zr, r, A2(tu, We(r), v));
                                    case 0:
                                        return A2(tu, We(r), v);
                                    default:
                                        var n = e.a;
                                        return A2(Ni, r, s) ? A3(Nw, n, r, v) : A2(ye, A2(Iw, r, n), v);
                                }
                            }(),
                            aT: b(f, {
                                dX: ct,
                                fm: ct
                            }),
                            b0: t(e, xw) ? d(A2(tu, We(r), s), g([
                                r
                            ])) : A2(tu, We(r), s)
                        });
                    case 2:
                        return b(a, {
                            aT: b(f, {
                                dX: ut(n.a)
                            })
                        });
                    case 3:
                        return b(a, {
                            aT: b(f, {
                                dX: ct
                            })
                        });
                    case 4:
                        return b(a, {
                            aT: b(f, {
                                dX: ct,
                                fm: ct
                            })
                        });
                    case 5:
                        return b(a, {
                            b0: d(a.b0, g([
                                {
                                    eb: n.c,
                                    a7: n.a,
                                    fC: n.b
                                }
                            ]))
                        });
                    default:
                        return b(a, {
                            bG: n.a
                        });
                }
            }(n))));
        }, p = function(n) {
            return A2(Ev, d(A3(Tw, m, a.aT, n), d(A3(Bw, m, a.aT, function(n) {
                return {
                    $: 2,
                    a: n
                };
            }(n)), g([
                A2(Qh, "max-width", Lw(i) + "px")
            ]))), g([
                A2(s$, g([
                    Mh(n.a7)
                ]), l)
            ]));
        };
        return A2(Ev, l, g([
            A2(Ev, g([
                Tv("tower-game"),
                yh(o)
            ]), g([
                A2(Ev, g([
                    Tv("tg--game")
                ]), g([
                    A2(Ev, d(A3(Bw, m, a.aT, xw), g([
                        Tv("tg--drawer")
                    ])), A2(ye, function(n) {
                        return A2(s$, A2(Zr, Mh(n.a7), A3(Tw, m, a.aT, n)), l);
                    }, s)),
                    A2(Ev, d(A3(Bw, m, a.aT, Mw), A2(Zr, Tv("tg-dropzone"), $(Tv("tg-dropzone-empty")))), d(A2(ye, p, v), $(Nv("Ziehen Sie die Bilder auf diesen Text."))))
                ])),
                A2(Uv, g([
                    Tv("btn btn-primary p-2 export-button"),
                    Xv(Hw(A2(ye, function(n) {
                        return n.a7;
                    }, v)))
                ]), g([
                    Nv("Bild speichern")
                ])),
                A3(jh, "tower-game-helper", g([
                    A2(rp, "images", A2(al, Fd, h)),
                    A2(rp, "towerGameId", Fd(o)),
                    A2(Qp, "imageLoaded", A4(wa, F3(function(n, r, t) {
                        return {
                            aD: m(A3(Cw, n, r, t)),
                            aG: !1,
                            aH: !0
                        };
                    }), A2(ua, g([
                        "detail",
                        "url"
                    ]), Zc), A2(ua, g([
                        "detail",
                        "width"
                    ]), Ha), A2(ua, g([
                        "detail",
                        "height"
                    ]), Ha))),
                    A2(Qp, "heightChanged", A2(Wt, function(n) {
                        return {
                            aD: m(kw(n)),
                            aG: !1,
                            aH: !0
                        };
                    }, A2(ua, g([
                        "detail",
                        "canvasHeight"
                    ]), Ha)))
                ]), l)
            ]))
        ]));
    }), Uw = function(n) {
        var r = function(n) {
            var r;
            return 10 > n ? ot(n) : _$(0 > (r = 87 + n) || r > 1114111 ? "\uFFFD" : r > 65535 ? String.fromCharCode(Math.floor((r -= 65536) / 1024) + 55296, r % 1024 + 56320) : String.fromCharCode(r));
        };
        return 16 > n ? r(n) : d(Uw(n / 16 | 0), r(A2(qe, 16, n)));
    }, Dw = A2(Df, Uw, A2(M$, 2, "0")), Fw = F3(function(n, r, t) {
        var e, u, c, a;
        return e = function(n) {
            var r = n.a, t = n.b, e = n.c, u = e > .5 ? e + t - e * t : e * (t + 1), c = 2 * e - u, a = function(n) {
                var r = 0 > n ? n + 1 : n > 1 ? n - 1 : n;
                return 1 > 6 * r ? c + (u - c) * r * 6 : 1 > 2 * r ? u : 2 > 3 * r ? c + (u - c) * (2 / 3 - r) * 6 : c;
            };
            return f(a(r + 1 / 3), a(r), a(r - 1 / 3));
        }(f(n, r, t)), u = e.a, c = e.b, a = e.c, A2(ft, "", A2(Zr, "#", A2(ye, A2(Df, nm, Dw), g([
            255 * u,
            255 * c,
            255 * a
        ]))));
    }), Rw = Av("max"), qw = function(n) {
        return o(n, !0);
    }, Kw = F2(function(n, r) {
        return A2(Kv, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r));
    }), Zw = A2(ua, g([
        "target",
        "value"
    ]), Zc), Xw = function(n) {
        return A2(Kw, "input", A2(Wt, qw, A2(Wt, n, Zw)));
    }, Jw = function(n) {
        return A2(Av, "step", n);
    }, Ww = Av("value"), Yw = F2(function(n, r) {
        return A2(qh, g([
            Tv("window-color--picker hue"),
            xh("range"),
            Rw("1"),
            Jw("0.001"),
            Ww(Lw(r.ce)),
            Xw(function(t) {
                return n(b(r, {
                    ce: A2(Ku, 0, tm(t))
                }));
            })
        ]), l);
    }), Qw = F2(function(n, r) {
        return A2(qh, g([
            Tv("window-color--picker lightning"),
            xh("range"),
            Rw("0.95"),
            Jw("0.001"),
            Ww(Lw(1 - r.cs)),
            A2(e$, "style", "--color: " + A3(Fw, r.ce, r.c5, .5) + ";"),
            Xw(function(t) {
                return n(b(r, {
                    cs: 1 - A2(Ku, 0, tm(t))
                }));
            })
        ]), l);
    }), n_ = F2(function(n, r) {
        return A2(qh, g([
            Tv("window-color--picker saturation"),
            xh("range"),
            Rw("1"),
            Jw("0.001"),
            Ww(Lw(1 - r.c5)),
            A2(e$, "style", "--color: " + A3(Fw, r.ce, 1, .5) + ";"),
            Xw(function(t) {
                return n(b(r, {
                    c5: 1 - A2(Ku, 0, tm(t))
                }));
            })
        ]), l);
    }), r_ = F2(function(n, r) {
        return A2(Ev, g([
            Tv("window-color--colors")
        ]), g([
            A2(Ev, g([
                Tv("window-color--pickers")
            ]), g([
                A2(Yw, n, r),
                A2(n_, n, r),
                A2(Qw, n, r)
            ])),
            A2(Ev, g([
                Tv("window-color--preview"),
                A2(e$, "style", "--color: " + A3(Fw, r.ce, r.c5, r.cs) + ";")
            ]), l)
        ]));
    }), t_ = function(n) {
        return A3(Fw, n.ce, n.c5, n.cs);
    }, e_ = F3(function(n, r, t) {
        var e = t.a, u = t.b, c = t.c, a = function(n) {
            return r(Yi(A3(Qi, e, u, n)));
        };
        return A2(Ev, g([
            Tv("window-color")
        ]), g([
            A2(r_, a, c),
            A3(jh, "window-color", g([
                A2(rp, "config", u.aQ),
                A2(e$, "data-color", t_(c))
            ]), l)
        ]));
    }), u_ = g([
        0,
        1,
        2
    ]), c_ = function(n) {
        switch(n){
            case 0:
                return function(n) {
                    return n.bV;
                };
            case 1:
                return function(n) {
                    return n.bT;
                };
            default:
                return function(n) {
                    return n.bU;
                };
        }
    }, a_ = function(n) {
        switch(n){
            case 0:
                return g([
                    "eiderstedt_head",
                    "foehr_head",
                    "sylt_head"
                ]);
            case 1:
                return g([
                    "eiderstedt_body",
                    "foehr_body",
                    "sylt_body"
                ]);
            default:
                return g([
                    "eiderstedt_feet",
                    "foehr_feet",
                    "sylt_feet"
                ]);
        }
    }, i_ = function(n) {
        switch(n){
            case 0:
                return g([
                    "woman_head",
                    "dragon_head",
                    "devil_head"
                ]);
            case 1:
                return g([
                    "woman_body",
                    "dragon_body",
                    "devil_body"
                ]);
            default:
                return g([
                    "woman_feet",
                    "dragon_feet",
                    "devil_feet"
                ]);
        }
    }, o_ = function(n) {
        return n ? i_ : a_;
    }, f_ = F2(function(n, r) {
        return A2(ye, function(t) {
            return A2(Ku, "", A2(vv, A2(c_, t, r), A2(o_, n, t)));
        }, u_);
    }), s_ = F2(function(n, r) {
        return A2(ye, n ? function(n) {
            return o(n, "/schwahl/" + n + ".png");
        } : function(n) {
            return o(n, "/garb/" + n + ".jpg");
        }, A2(o_, n, r));
    }), b_ = F3(function(n, r, t) {
        switch(n){
            case 0:
                return b(r, {
                    bV: t
                });
            case 1:
                return b(r, {
                    bT: t
                });
            default:
                return b(r, {
                    bU: t
                });
        }
    }), d_ = F3(function(n, r, t) {
        var e = lt(t), u = n((r + 1) % e), c = n((r - 1 + e) % e), a = A2(Ku, o("", ""), A2(vv, r, t)), i = a.b, f = A2(Ev, l, g([
            A2(s$, g([
                yh(a.a),
                Tv("object-fit-contain"),
                Mh(i)
            ]), l)
        ]));
        return A3(pp, ut(o(c, u)), e > 1, f);
    }), l_ = F4(function(n, r, t, e) {
        return A3(d_, A2(Df, A2(b_, e, t), r), A2(c_, e, t), A2(s_, n, e));
    }), v_ = F2(function(n, r) {
        return function(n) {
            return {
                $: 3,
                a: n
            };
        }(Dd(g(n ? [
            o("imageIds", A2(al, Fd, r)),
            o("outfile", Fd("Ihr pers\xf6nliches Fabelwesen"))
        ] : [
            o("imageIds", A2(al, Fd, r)),
            o("outfile", Fd("Ihre pers\xf6nliche Tracht"))
        ])));
    }), h_ = F3(function(n, r, t) {
        return A2(Ev, g([
            Tv("gallery-game")
        ]), g([
            A2(Ev, g([
                Tv("gallery-game--items")
            ]), A2(ye, A3(l_, n, r, t), u_)),
            A2(Uv, g([
                Tv("btn btn-primary m-2"),
                Xv(A2(v_, n, A2(f_, n, t)))
            ]), g([
                Nv("Bild speichern")
            ]))
        ]));
    }), g_ = F3(function(n, r, t) {
        var e = t.a;
        return A3(h_, 0, function(n) {
            return r(ma(A3(pa, e, 0, n)));
        }, t.c);
    }), $_ = F3(function(n, r, t) {
        var e = t.a;
        return A3(h_, 1, function(n) {
            return r($i(A3(mi, e, 0, n)));
        }, t.c);
    }), m_ = F3(function(n, r, t) {
        return A2(Ev, l, A2(ye, A2(y_, n, r), t));
    }), p_ = F3(function(n, r, t) {
        return A3(m_, n, r, t.b.a);
    }), w_ = F3(function(n, r, t) {
        return A3(m_, n, r, t.b.a);
    }), __ = F3(function(n, r, t) {
        return A3(m_, n, r, t.b.a);
    }), y_ = F3(function(n, r, t) {
        var e = function() {
            switch(t.$){
                case 3:
                    return A3(p_, n, r, t.a);
                case 29:
                    return A3(Ym, n, r, t.a);
                case 30:
                    return A3(zw, n, r, t.a);
                case 31:
                    return A3(vp, n, r, t.a);
                case 8:
                    return A3(tp, n, r, t.a);
                case 22:
                    return A3(__, n, r, t.a);
                case 27:
                    return A3(hp, n, r, t.a);
                case 5:
                    return A3(Qm, n, r, t.a);
                case 6:
                    return A3(sp, n, r, t.a);
                case 11:
                    return A3(ip, n, r, t.a);
                case 15:
                    return A3(yw, n, r, t.a);
                case 1:
                    return A3(Sp, n, r, t.a);
                case 10:
                    return A3(Xp, n, r, t.a);
                case 4:
                    return A3(g_, n, r, t.a);
                case 21:
                    return A3($_, n, r, t.a);
                case 23:
                    return A3(op, n, r, t.a);
                case 24:
                    return A3(fp, n, r, t.a);
                case 7:
                    return A3(w_, n, r, t.a);
                case 25:
                    return A3(Gw, n, r, t.a);
                case 9:
                    return A3(wp, n, r, t.a);
                case 28:
                    return A3(e_, n, r, t.a);
                case 14:
                    return A3(bw, n, r, t.a);
                default:
                    return Nv("");
            }
        }();
        return A2(Ev, g([
            Tv("mb-4 w-100")
        ]), g([
            e
        ]));
    }), z_ = F2(function(n, r) {
        return A3(y_, n, Xm(r), r);
    }), M_ = F3(function(n, r, t) {
        var e;
        return A2(Ev, g([
            Tv("wlcontainer"),
            (e = r, Tv(e ? "" : "hide-full-content"))
        ]), g([
            A2(Ev, g([
                Tv("content")
            ]), g([
                A2(Sv, Km, A2(z_, n, t))
            ])),
            A2(bh, !r, A2(Ev, g([
                Tv("read-more pointer d-flex justify-content-center align-items-center mt-4 text-dark"),
                Xv(qm(1))
            ]), g([
                Zm
            ])))
        ]));
    }), k_ = F3(function(n, r, t) {
        var e = t.a, u = t.b;
        return A2(Ev, g([
            Tv("px-2 toggle-detail-box bg-white")
        ]), g([
            A2(Ev, g([
                Tv("d-flex justify-content-between align-items-center")
            ]), g([
                A2(Dh, g([
                    Tv("church-show-title")
                ]), g([
                    Nv(e.eE)
                ])),
                A2(bh, r, A2(Dh, g([
                    Xv(qm(0)),
                    Tv("church-show-title-close")
                ]), g([
                    fh
                ])))
            ])),
            A2(Vh, u.ba, function(t) {
                return A2(bh, lt(Id(t)) > 0, A3(M_, n, r, t));
            })
        ]));
    }), x_ = A2(Ev, g([
        Tv("rotate-270 d-flex")
    ]), g([
        A2(ch, g([
            oh("7.86"),
            th("30"),
            ih("0 0 7.86 30")
        ]), g([
            A2(Eh, g([
                Th("M12.9,1.05,12.07,1l5.19,14.14.01,1.72L12.07,31l.83-.05,7.03-14.07V15.12Z"),
                ah("translate(-12.07 -1)")
            ]), l)
        ]))
    ])), C_ = F4(function(n, r, e, u) {
        var c = t(n, r) ? f("open", x_, 0) : f("", Zm, r), a = c.a, i = c.b, o = c.c;
        return A2(Ev, g([
            Tv("detail-box-header"),
            Tv(a),
            Xv(qm(o))
        ]), g([
            A2(Ev, l, g([
                A2(Lv, g([
                    Tv("detail-icon-container")
                ]), g([
                    u
                ])),
                Nv(e)
            ])),
            A2(Ev, g([
                Tv("px-3")
            ]), g([
                i
            ]))
        ]));
    }), H_ = F5(function(n, r, e, u, c) {
        return A2(Ev, g([
            Tv("toggle-detail-box")
        ]), g([
            A4(C_, n, r, e, u),
            A2(bh, t(n, r), A2(Ev, g([
                Tv("detail-box-content")
            ]), g([
                c
            ])))
        ]));
    }), V_ = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M448.2,431v-6.9H462v-48.2h-55.1V369H462v-48.2H338V369h48.2v6.9H338v48.2h27.5c0,0.5,0.1,1,0.1,1.5v5.4v6.9v1.9\n\t\tc0,3.7,0.9,7.4,2.5,10.7l7.8,15.7v12.8l62,0.2v-12.6l5.5-7.3c3.1-4.1,4.8-9.3,4.8-14.5v-6.9V431z M344.9,362.1v-34.5h110.3v34.5\n\t\th-48.2v-3.4c0-5.7-4.6-10.3-10.3-10.3c-5.7,0-10.3,4.6-10.3,10.3v3.4H344.9z M358.7,405.4c0,1.4,0.3,2.8,1,4l3.9,7.8h-18.6v-34.5\n\t\th41.3v21.6c-4.6-4.9-11.2-7.9-18.5-7.9C362.7,396.4,358.7,400.5,358.7,405.4z M441.3,444.8c0,3.7-1.2,7.4-3.4,10.3l-6.9,9.2v8\n\t\tl-48.2-0.1v-7.6l-8.5-17.2c-1.2-2.4-1.8-5-1.8-7.7v-14.2c0-3.9-0.9-7.8-2.6-11.2l-4-8c-0.1-0.3-0.2-0.6-0.2-1c0-1.2,1-2.1,2.5-2.1\n\t\tc10,0,18.2,8.2,18.2,18.2v5.9v6.9h6.9v-6.9v-5.9v-62.9c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4V400v13.8h6.9V400\n\t\tc0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4v13.8h6.9V400c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4v6.9v6.9h6.9v-6.9\n\t\tc0-1.9,1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4V444.8z M437.9,396.6c-1.4,0-2.7,0.3-3.8,0.8c-1.2-4.4-5.2-7.6-9.9-7.6\n\t\tc-2.7,0-5.1,1-6.9,2.7c-1.8-1.7-4.2-2.7-6.9-2.7c-1.2,0-2.4,0.2-3.4,0.6v-7.5h48.2v34.5h-6.9v-10.3\n\t\tC448.2,401.2,443.6,396.6,437.9,396.6z")
            ]), l)
        ]))
    ])), A_ = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, c = A3(n, t.b, t.c, A3(A_, n, r, t.d));
            n = u, r = c, t = e;
        }
    }), T_ = F3(function(n, r, t) {
        return A3(A_, F3(function(t, e, u) {
            return A3(bn, n(t), r(e), u);
        }), {}, t);
    }), E_ = function(n) {
        return A2(al, function(n) {
            var r = n.b;
            return Dd(g([
                o("id", Ud(n.a.am)),
                o("xCoord", Ud(r.fE)),
                o("yCoord", Ud(r.fG))
            ]));
        }, n);
    }, O_ = F2(function(n, r) {
        return Dd(g([
            o("groundplanImageUrl", Fd(n.a7)),
            o("groundplanResizedImages", A3(T_, re, Fd, n.fc)),
            o("pois", E_(r))
        ]));
    }), S_ = F2(function(n, r) {
        var e = function() {
            var r = n.d8;
            if (r.$) return Nv("");
            var t = r.a;
            return A3(jh, "leaflet-groundplan", g([
                Tv("groundplan"),
                A2(rp, "params", A2(O_, t, n.ab))
            ]), l);
        }();
        return A3(Bv, "div", g([
            Tv("toggle-detail-box")
        ]), g([
            o("groundplan-header", A4(C_, n.M, r, "Interaktiver Grundriss", V_)),
            o("groundplan", A2(bh, t(n.M, r), e))
        ]));
    }), j_ = F4(function(n, r, t, e) {
        return {
            b2: t,
            bo: n,
            br: e,
            dg: r
        };
    }), B_ = A5(Aa, "default", ct, ct, !1, l), L_ = function(n) {
        return "default" === n.eE && t(n.dg, ct) && t(n.b2, ct);
    }, P_ = function(n) {
        return A2(Ku, B_, A2(vl, L_, n));
    }, N_ = F2(function(n, r) {
        var t = o(r.dg, r.b2);
        if (t.a.$) return !t.b.$ && 1 > a(n, e = t.b.a);
        if (t.b.$) return a(n, t.a.a) > -1;
        var e = t.b.a;
        return a(n, t.a.a) > -1 && 1 > a(n, e);
    }), I_ = F2(function(n, r) {
        return A2(Ku, P_(n), A2(vl, N_(r), n));
    }), G_ = F2(function(n, r) {
        return A2(ye, function(n) {
            return o(r, n);
        }, A2(tu, function(n) {
            return t(n.bX, ut(r));
        }, P_(n).cK));
    }), U_ = F2(function(n, r) {
        var e = F3(function(r, u, c) {
            n: for(;;){
                if (r.b) {
                    if (r.b.b) {
                        var a = r.a, i = r.b, o = i.a, f = i.b, s = A2(I_, n, o);
                        if (h = A2(G_, n, a), t(b = A2(I_, n, a), s)) {
                            r = A2(Zr, o, f), c = d(c, h);
                            continue n;
                        }
                        return A2(Zr, A4(j_, b, u, ut(a), d(c, h)), A3(e, A2(Zr, o, f), ut(o), l));
                    }
                    var b, v = r.a, h = A2(G_, n, v);
                    return g([
                        A4(j_, b = A2(I_, n, v), u, b.b2, d(c, h))
                    ]);
                }
                return l;
            }
        });
        return A3(e, r, ct, l);
    }), D_ = F2(function(n, r) {
        return A3(M$, 4, "0", ot(A2(E$, n, r))) + "-" + p$(A2(T$, n, r)) + "-" + A3(M$, 2, "0", ot(A2(A$, n, r)));
    }), F_ = function(n) {
        return A2(fl, x$, ed(Im(A2(D_, n.fx, um(n.fn)))));
    }, R_ = A2(Ue, 0, l), q_ = function(n) {
        return A2(D_, R_, um(n));
    }, K_ = F2(function(n, r) {
        var t = F3(function(n, t, e) {
            for(;;){
                var u = q_(e);
                if (a(u, r) > 0 || 0 >= t) return zt(n);
                n = A2(Zr, u, n), t -= 1, e += 864e5;
            }
        }), e = F_(n);
        return e.$ ? l : A3(t, l, 366, e.a);
    }), Z_ = F2(function(n, r) {
        var t = A2(Ku, "", A2(fl, function(n) {
            return q_(n + 7776e6);
        }, F_(n))), e = A2(vl, N_(t), r);
        return A2(U_, r, A2(K_, n, A2(Ku, t, A2(Pd, function(n) {
            return n.b2;
        }, e))));
    }), X_ = F2(function(n, r) {
        return !A2(Pi, A2($p, gv, n), r);
    }), J_ = function(n) {
        return A2(tu, function(n) {
            return t(n.bX, ct);
        }, n);
    }, W_ = function(n) {
        return n.aP || A2(X_, function(n) {
            return n.aP;
        }, J_(n.cK));
    }, Y_ = Wn("hr"), Q_ = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), ny = T, ry = function(n) {
        return $(A2(tu, _t, A3(ny, Zr, l, n))).join("");
    }, ty = F3(function(n, r, t) {
        return A2(ft, r, A2(st, n, t));
    }), ey = function(n) {
        var r = function() {
            switch(n.dv){
                case 0:
                    return o("phone", Fh("tel:+" + ry(n.dw)));
                case 1:
                    return o("envelope", Fh("mailto:" + n.dw));
                case 2:
                    return o("globe", Fh("//" + A3(ty, "https://", "", A3(ty, "http://", "", n.dw))));
                default:
                    return o("", Tv(""));
            }
        }(), t = r.a;
        return A2(Ev, l, g([
            A2(Nh, g([
                r.b
            ]), g([
                A2(Rv, t, "me-2"),
                Nv(n.dw)
            ]))
        ]));
    }, uy = Gm(O$), cy = function(n) {
        return n.cL + " - " + n.bN;
    }, ay = function(n) {
        if (n.b) {
            if (n.b.b) {
                var r = A2(tu, function(n) {
                    return !n.aP;
                }, n);
                return r.b ? A2(ft, " und ", A2(ye, cy, A2(au, function(n) {
                    return n.cL;
                }, r))) : "geschlossen";
            }
            var t = n.a;
            return t.aP ? "geschlossen" : cy(t);
        }
        return "Keine \xd6ffnungszeit angegeben";
    }, iy = Wn("td"), oy = Wn("tr"), fy = F2(function(n, r) {
        return A2(oy, l, g([
            A2(iy, g([
                Tv("opening-hours-season--day-col")
            ]), g([
                Nv(n)
            ])),
            A2(iy, l, g([
                Nv(ay(r))
            ]))
        ]));
    }), sy = Wn("table"), by = function(n) {
        return A2(sy, g([
            Tv("opening-hours-season--table")
        ]), n);
    }, dy = F2(function(n, r) {
        var t = r.b;
        return o(n(r.a), t);
    }), ly = F2(function(n, r) {
        var t = A3(_e, F2(function(n, r) {
            var t = n.b;
            return A3(as, n.a, function(n) {
                return ut(1 === n.$ ? g([
                    t
                ]) : A2(Zr, t, n.a));
            }, r);
        }), Be, r), e = A2(ye, function(n) {
            return A2(fy, n.a, n.b);
        }, A2(ye, dy(uy(n)), Jr(t)));
        return by(e);
    }), vy = F2(function(n, r) {
        var e, u, c, a = r.bo, i = r.dg, f = r.b2, s = r.br, b = W_(a) ? A2(Ev, l, g([
            Nv("Geschlossen")
        ])) : (e = J_(a.cK), c = function(n) {
            return A2(fy, function(n) {
                switch(n){
                    case 1:
                        return "Mo";
                    case 2:
                        return "Di";
                    case 3:
                        return "Mi";
                    case 4:
                        return "Do";
                    case 5:
                        return "Fr";
                    case 6:
                        return "Sa";
                    case 7:
                        return "So";
                    default:
                        return "";
                }
            }(n), A2(Ku, l, A2(qu, n, u)));
        }, -2 === (u = A3(_e, F2(function(n, r) {
            return A3(as, n.bZ, function(r) {
                return ut(1 === r.$ ? g([
                    n
                ]) : A2(Zr, n, r.a));
            }, r);
        }), Be, e)).$ ? Nv("") : by(A2(ye, c, A2(gt, 1, 7)))), d = A2(bh, !t(s, l), A2(Ev, g([
            Tv("opening-hours-season--special")
        ]), g([
            A2(Ev, g([
                Tv("opening-hours-season--special-title")
            ]), g([
                Nv("Besonderheiten:")
            ])),
            A2(ly, n, s)
        ]))), v = "default" !== a.eE ? " (" + a.eE + ")" : "", h = function() {
            var r = o(i, f);
            if (r.a.$) return "";
            if (r.b.$) return "\xd6ffnungszeiten ab dem " + A2(uy, n, r.a.a);
            var t = r.b.a;
            return "\xd6ffnungszeiten ab dem " + A2(uy, n, r.a.a) + " bis zum " + A2(uy, n, t);
        }(), $ = i.$ ? Nv("") : A2(Ev, g([
            Tv("opening-hours-season--date")
        ]), g([
            Nv(h),
            A2(Lv, g([
                Tv("opening-hours-season--name")
            ]), g([
                Nv(v)
            ]))
        ]));
        return A2(Ev, g([
            Tv("opening-hours-season")
        ]), g([
            $,
            b,
            d
        ]));
    }), hy = F2(function(n, r) {
        var e = t(r, l) ? g([
            Nv("Keine \xd6ffnungszeiten angegeben")
        ]) : A2(ye, vy(n), r);
        return A2(Ev, l, e);
    }), gy = F2(function(n, r) {
        var t, e, u = r.b, c = A2(Z_, n, u.bk.c8), a = function(n) {
            return A2(Pi, function(n) {
                var r = n.br;
                return !W_(n.bo) || A2(Pi, A2($p, A2($p, gv, function(n) {
                    return n.aP;
                }), Re), r);
            }, n);
        }(c), i = !g$(u.bk.bQ);
        return A2(Ev, l, g([
            A2(bh, a, A2(hy, n, c)),
            A2(bh, a, A2(Y_, l, l)),
            (e = u.bk, A2(Ev, l, g([
                A2(Ev, l, g([
                    Nv(e.dj)
                ])),
                A2(Ev, l, g([
                    Nv(e.bA)
                ])),
                A2(Ev, l, g([
                    Nv(e.dA + " " + e.bM)
                ])),
                A2(Uv, g([
                    Tv("pointer text-primary"),
                    Xv(A2(Q_, e.bg, e.bh))
                ]), g([
                    A2(Rv, "route", "me-2"),
                    Nv("Routenplanung")
                ]))
            ]))),
            A2(bh, i, A2(Y_, l, l)),
            A2(bh, i, (t = u.bk.bQ, A2(Ev, l, A2(ye, ey, t))))
        ]));
    }), $y = F2(function(n, r) {
        return A3(Fm, n, "Veranstaltungen", r.b.bk.cM);
    }), my = function(n) {
        return {
            $: 1,
            a: n
        };
    }, py = function(n) {
        return A2(Ku, Nv(""), A2(fl, d$, lv(n.ch)));
    }, wy = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(Ev, g([
            Tv("poi-list-item"),
            Xv(my(t.am))
        ]), g([
            A2(Ev, g([
                Tv("poi-list-image")
            ]), g([
                py(e)
            ])),
            A2(Ev, g([
                Tv("p-2 d-flex flex-column")
            ]), g([
                A2(Ev, g([
                    Tv("d-flex pb-2")
                ]), g([
                    A2(Ev, g([
                        Tv("poi-list groundplan-marker")
                    ]), g([
                        Nv(ot(n + 1))
                    ])),
                    A2(Ev, g([
                        Tv("poi-title")
                    ]), g([
                        Nv(t.eE)
                    ]))
                ])),
                A2(Ev, g([
                    Tv("text-dark")
                ]), g([
                    Nv(e.ft)
                ]))
            ]))
        ]));
    }), _y = Qv("circle"), yy = er("cx"), zy = er("cy"), My = er("fill-rule"), ky = er("r"), xy = er("stroke"), Cy = er("stroke-width"), Hy = A2(ch, g([
        ih("0 0 57 56")
    ]), g([
        A2(rh, g([
            gg("none"),
            My("evenodd")
        ]), g([
            A2(Eh, g([
                Th("M-4-8h582v402H-4z")
            ]), l),
            A2(rh, g([
                ah("translate(1 1)"),
                My("nonzero")
            ]), g([
                A2(Eh, g([
                    Th("M40.525 12.734c0-6.919-5.608-12.527-12.528-12.527-6.92 0-12.527 5.608-12.527 12.527 0 9.913 12.527 24.581 12.527 24.581s12.528-14.719 12.528-24.581zm-18.706-.748a6.18 6.18 0 1112.358 0 6.18 6.18 0 01-12.358 0h0z"),
                    xy("#037F94"),
                    Cy("2")
                ]), l),
                A2(_y, g([
                    yy("27.997"),
                    zy("11.986"),
                    ky("3.038")
                ]), l),
                A2(Eh, g([
                    Th("M32.45 38.282c9.104.661 15.07 3.04 17.29 4.812-2.6 2.076-10.327 4.995-22.24 4.995-11.911 0-19.638-2.92-22.239-4.995 2.22-1.77 8.182-4.148 17.276-4.811a124.727 124.727 0 01-3.198-5.28C8.136 34.338 0 38.35 0 43.093c0 5.834 12.313 10.566 27.5 10.566 15.189 0 27.5-4.73 27.5-10.566.002-4.745-8.143-8.759-19.356-10.093a126.53 126.53 0 01-3.194 5.282z"),
                    xy("#037F94"),
                    Cy("2")
                ]), l)
            ]))
        ]))
    ])), Vy = F3(function(n, r, t) {
        return A2(Ev, g([
            Tv("toggle-detail-box")
        ]), g([
            A2(Ev, g([
                Tv("detail-box-header"),
                Xv(n)
            ]), g([
                A2(Ev, l, g([
                    A2(Lv, g([
                        Tv("detail-icon-container")
                    ]), g([
                        t
                    ])),
                    Nv(r)
                ])),
                A2(Ev, g([
                    Tv("px-3")
                ]), g([
                    Oh
                ]))
            ]))
        ]));
    }), Ay = F2(function(n, r) {
        var e = r.a, u = r.b, c = A2(ye, function(n) {
            var r = n.a;
            return A3(Vy, function(n) {
                return {
                    $: 2,
                    a: n
                };
            }(r.am), r.eE, Hy);
        }, u.fa), a = A2(bh, u.bP, function(n) {
            return A2(Ev, l, A2($t, wy, n.ab));
        }(n)), i = !g$(u.bk.bK), o = !g$(u.bk.cM), f = g([
            A3(k_, n.B, !1, A2(tc, e, u)),
            A5(H_, n.M, 2, "\xd6ffnungszeiten & Kontakt", $$, A2(gy, n.B, A2(tc, e, u))),
            A2(bh, i, A5(H_, n.M, 3, "Gottesdienste", m$, A2(Rm, n.B, A2(tc, e, u)))),
            A2(bh, o, A5(H_, n.M, 4, "Veranstaltungen", h$, A2($y, n.B, A2(tc, e, u))))
        ]), s = A2(bh, u.bP && !t(n.d8, ct), A2(S_, n, 5));
        return A2(Ev, l, d(f, d(A2(Zr, s, c), g([
            a
        ]))));
    }), Ty = {
        $: 5
    }, Ey = F4(function(n, r, t, e) {
        return A2(Ev, l, g([
            A2(Ev, g([
                Xv(t),
                Tv("overlay")
            ]), l),
            A2(Ev, g([
                Tv("overlay-container")
            ]), g([
                A2(Ev, g([
                    Tv("overlay-title-container")
                ]), g([
                    A2(Ev, g([
                        Tv("overlay-title"),
                        Xv(e)
                    ]), g([
                        Nv(n)
                    ])),
                    A2(Ev, g([
                        Tv("pl-3"),
                        Xv(t)
                    ]), g([
                        fh
                    ]))
                ])),
                A2(Ev, g([
                    Tv("overlay-content")
                ]), r),
                A2(Ev, g([
                    Xv(e),
                    Tv("overlay-footer")
                ]), g([
                    Oh,
                    A2(Lv, g([
                        Tv("ms-2")
                    ]), g([
                        Nv("Weiterlesen")
                    ]))
                ]))
            ]))
        ]));
    }), Oy = function(n) {
        var r = n.a, t = n.b, e = g([
            py(t),
            A2(Ev, g([
                Tv("overlay-content-subtext")
            ]), g([
                Nv(t.ft)
            ]))
        ]);
        return A4(Ey, r.eE, e, Ty, my(r.am));
    }, Sy = F2(function(n, r) {
        var t, e, u, c = 1 === n.M ? A3(k_, n.B, !0, r) : A2(Ay, n, r);
        return A2(Ev, g([
            Tv("w-100 bg-white")
        ]), g([
            A2(Vh, n.ao, Oy),
            (t = r, u = (e = t.b.dN).$ || 30 !== e.a.$ ? b$(Wg) : d$(e.a.a), A2(Ev, g([
                Tv("church-title-image")
            ]), g([
                u
            ]))),
            c
        ]));
    }), jy = {
        $: 1
    }, By = F4(function(n, r, t, e) {
        return A4(Ey, n, r, t, e);
    }), Ly = function(n) {
        var r, t = n.a, e = (r = n.b.dN).$ || 30 !== r.a.$ ? b$(Wg) : d$(r.a.a);
        return A4(By, t.eE, g([
            e
        ]), jy, function(n) {
            return {
                $: 2,
                a: n
            };
        }(t.am));
    }, Py = {
        $: 4
    }, Ny = function(n) {
        return A2(Ba, function(n) {
            return 30 === n.$ ? ut(n.a) : ct;
        }, n);
    }, Iy = function(n) {
        var r = n.a, t = n.b, e = A2(Ku, b$("/regionPlaceholder.svg"), A2(fl, function(n) {
            return d$(n);
        }, A2(Pd, vv(0), A2(fl, Ny, A2(fl, function(n) {
            return n.b.a;
        }, t.ch)))));
        return A4(By, r.eE, g([
            e
        ]), Py, function(n) {
            return {
                $: 5,
                a: n
            };
        }(r.am));
    }, Gy = F2(function(n, r) {
        var t, e, u = r.a, c = r.b;
        return A2(Ev, g([
            Tv("h-100 w-100")
        ]), g([
            A3(Bv, "div", g([
                Tv("h-100 w-100")
            ]), g([
                o("main-map", A3(jh, "leaflet-map", g([
                    Tv("main-map"),
                    A2(rp, "params", (t = n.B, e = function() {
                        var n = t.eu;
                        if (1 === n.$) return l;
                        var r = n.a;
                        return g([
                            o("center", A2(al, bl, g([
                                r.bg,
                                r.bh
                            ]))),
                            o("zoom", Ud(r.fH))
                        ]);
                    }(), Dd(d(g([
                        o("gestureHandling", qd(!1)),
                        o("saveViewport", qd(!0))
                    ]), e)))),
                    A2(rp, "churches", up(u)),
                    A2(rp, "regions", ap(c))
                ]), l))
            ])),
            A2(Vh, n.an, Ly),
            A2(Vh, n.ap, Iy)
        ]));
    }), Uy = {
        dP: A2(Wn("main"), g([
            yh("content"),
            Tv("container"),
            A2(er, "tabIndex", ot(-1))
        ]), g([
            A2(Dh, l, g([
                Nv("Not Found")
            ]))
        ])),
        ed: !1,
        fy: "Page Not Found"
    }, Dy = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ry = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qy = function(n) {
        return Tv(n ? "active" : "");
    }, Ky = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M465.8,391.9c1.9-1.4,3.8-2.8,5.8-4.2c1.4-1,2.7-2.1,4.1-3c3-1.9,4.5-4.7,5.1-8.1c0.3-1.8,0.5-3.7,0.5-5.6 c0-12.6-0.2-25.3,0.1-37.9c0.1-5.3,2.8-9.8,7.8-12.3c2.9-1.4,5.9-0.6,8.6,0.8c1.7,0.9,3.3,2.1,4.8,3.4c0.6,0.5,1.2,1.5,1.3,2.3 c1.5,11.5,2.5,23.1,2.7,34.8c0.1,7.6-0.2,15.2-0.5,22.7c-0.5,13.7-6.5,24.8-16.1,34.3c-9.7,9.5-20.4,17.6-31.9,24.8 c-1.1,0.7-1.6,1.5-1.6,2.9c0.1,9.8,0,19.7,0,29.5c0,3.1-1.2,4.3-4.3,4.3c-13.8,0-27.6,0-41.4,0c-3.1,0-4.3-1.2-4.3-4.4 c0-18.9,0-37.9,0-56.8c0-1.6,0.5-2.8,1.5-4c15.9-17.2,31.8-34.5,47.7-51.7c2.2-2.4,5.3-3.4,8.2-4.2c2-0.6,4.3-0.8,6.4-0.7 c2.8,0.1,5,2.1,5.5,4.8c0.4,2.4,0.6,4.8,0.4,7.2c-0.2,2.5-0.9,5.1-1.5,7.6c-0.2,0.8-0.7,1.6-1.2,2.3c-2.3,3.1-4.6,6.2-6.9,9.3 c-0.4,0.5-0.7,1.1-1.1,1.6C465.7,391.8,465.7,391.9,465.8,391.9z M413.5,446.7c0,8.4,0,16.7,0,25.1c0,2,0,2,1.9,2 c10.8,0,21.5,0,32.3,0c2,0,2.1,0,2.1-2.1c0-9.2,0-18.4,0-27.6c0-2.2,0.7-3.6,2.6-4.7c3.7-2.2,7.3-4.6,10.9-7 c9.3-6.4,18.2-13.4,25.6-22c4.9-5.6,8.6-11.8,9.5-19.4c0.7-5.9,1.4-11.9,1.4-17.8c0-9.3-0.4-18.6-0.9-27.8c-0.3-5-1-9.9-1.5-14.8 c0-0.4-0.2-1-0.5-1.2c-1.9-1.5-5-2.2-7.1,0.5c-1.1,1.4-1.7,2.9-1.6,4.7c0,11.2,0,22.4,0,33.7c0,4.3,0,8.7-1.4,12.8 c-1,2.9-2.3,5.7-4.9,7.6c-6,4.5-11.9,8.9-17.9,13.3c-4.6,3.4-9.1,6.8-13.8,10.1c-2.3,1.7-5.3,0.6-5.6-2.1c-0.1-1,0.4-2.3,1.1-3.2 c6.9-9.4,13.8-18.8,20.8-28.1c2.1-2.8,2.4-5.7,2-8.8c-0.2-1.7-1.3-2.7-2.9-2.8c-2.1,0-4,0.4-5.5,2c-15.2,16.5-30.4,33.1-45.7,49.6 c-0.8,0.8-1.1,1.7-1.1,2.8C413.5,429.8,413.5,438.3,413.5,446.7z")
            ]), l),
            A2(Eh, g([
                Th("M336.1,391.7c-1.9-2.6-3.8-5.2-5.7-7.7c-0.3-0.4-0.6-0.8-0.9-1.2c-4.3-5.7-4.8-12.1-3.7-18.8c0.5-2.8,2.7-4.6,5.5-5 c4.1-0.5,7.7,0.9,11.2,2.6c1.4,0.7,2.8,1.7,3.9,2.9c15.8,17,31.5,34.1,47.2,51.2c1,1,1.4,2.2,1.4,3.6c0,19.1,0,38.2,0,57.3 c0,2.9-1.3,4.2-4.2,4.2c-13.9,0-27.8,0-41.7,0c-3,0-4.2-1.2-4.2-4.2c0-9.9,0-19.9,0-29.8c0-1.3-0.4-2-1.5-2.6 c-12.1-7.6-23.6-16.1-33.5-26.5c-4.5-4.7-8.4-9.8-11-15.9c-1.7-4-2.5-8.2-3-12.4c-1.8-14.4-1.3-28.7-0.1-43.1 c0.5-6.2,1.2-12.4,1.8-18.5c0.1-0.7,0.4-1.6,0.9-2.1c2.7-2.5,5.6-4.6,9.3-5.3c3-0.5,5.6,0.4,7.6,2.6c3,3.2,4.9,6.9,4.9,11.5 c-0.1,12.8-0.1,25.7,0,38.5c0,3.4,0.9,6.6,2.8,9.5c0.2,0.3,0.4,0.6,0.7,0.8c3.8,2.8,7.6,5.6,11.4,8.4c0.2,0.1,0.4,0.2,0.6,0.3 C336,391.8,336,391.7,336.1,391.7z M388.2,446.7c0-8.4,0-16.7,0-25.1c0-1.2-0.4-2.2-1.2-3.1c-15-16.3-30-32.6-45-48.9 c-1.5-1.6-3.2-2.4-5.3-2.6c-1.7-0.2-3.3,0.6-3.6,2.1c-0.6,2.9-0.7,5.9,1.2,8.5c2.2,3.1,4.5,6.1,6.7,9.1c5,6.7,10,13.4,14.9,20.2 c0.6,0.9,1.1,2.2,1,3.3c-0.4,2.8-3.3,3.6-5.8,1.8c-10.7-7.9-21.3-15.8-32-23.7c-0.4-0.3-0.8-0.6-1.1-1c-3-4.2-4.5-8.8-4.6-13.9 c-0.1-11.3,0-22.6,0-33.9c0-1.9,0.1-3.8,0-5.7c-0.2-4.6-4.5-7.1-8.1-4.7c-0.5,0.3-1,1.1-1.1,1.7c-0.7,6.5-1.3,13-1.8,19.5 c-0.9,12.3-1.2,24.6,0.2,36.9c0.5,4.3,1.2,8.6,3.1,12.7c2.5,5.5,6.3,10.1,10.5,14.4c9.8,10,21.1,18,33,25.2c2,1.2,2.8,2.6,2.8,4.9 c-0.1,9.2,0,18.5-0.1,27.7c0,1.4,0.4,1.8,1.8,1.8c10.9-0.1,21.9-0.1,32.8,0c1.4,0,1.7-0.5,1.7-1.7 C388.1,463.6,388.2,455.1,388.2,446.7z")
            ]), l)
        ]))
    ])), Zy = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(Eh, g([
            Th("M445.9,474.2c-0.7,0-1.5-0.2-2.3-0.7c-6.8-4-13.6-7.9-20.4-11.9l-10.1-5.9c-3.5-2-7-4.1-10.5-6.1c-0.7-0.4-1.4-0.6-2.2-0.6 c-0.8,0-1.5,0.2-2.2,0.6c-13.7,8-27.3,15.9-41,23.8c-0.8,0.4-1.6,0.7-2.4,0.7c-1.2,0-2.4-0.6-3.2-1.6c-0.4-0.5-0.8-1.2-0.8-2.9 l0.2-1.1c0.2-1.1,0.5-2.5,0.8-3.8c3-14.1,6.1-28.2,9.1-42.3c0.3-1.6-0.1-3-1.4-4.1c-7.3-6.5-14.6-13-21.9-19.5l-13.5-12 c-1.4-1.3-1.9-2.5-1.5-4.2c0.4-1.6,1.2-2.5,2.8-3c0.8-0.2,1.7-0.3,2.7-0.4l0.9-0.1c7.4-0.8,14.9-1.5,22.3-2.3l3.8-0.4 c6-0.6,12.1-1.2,18.1-1.8c2.1-0.2,3.6-1.2,4.4-3.2c6.3-14.3,12.5-28.5,18.9-42.9c0.7-1.7,2.2-2.7,3.9-2.7c0.8,0,1.6,0.2,2.3,0.7 c0.7,0.5,1.2,1.1,1.7,2.1c2.7,6.1,5.4,12.2,8.1,18.4l4.9,11.2c2,4.5,4,9.1,6,13.7c0.7,1.6,2,2.6,3.8,2.7c7.3,0.7,14.5,1.5,21.8,2.2 l5.8,0.6c6.6,0.7,13.2,1.4,19.8,2.1c1.8,0.2,2.8,1,3.4,2.8c0.6,1.7,0.2,3-1.1,4.3c-2,1.8-4,3.7-6,5.4c-0.8,0.7-1.6,1.5-2.5,2.2 l-3.8,3.4c-7.8,6.9-15.5,13.9-23.3,20.8c-1.2,1.1-1.7,2.5-1.3,4.2c1.9,8.8,10,46.2,10,46.2c0.3,1.4,0.1,2.7-0.6,3.7 c-0.6,0.9-1.6,1.5-2.8,1.7C446.3,474.2,446.1,474.2,445.9,474.2z M368.6,415.4c1.3,1.2,1.8,2.5,1.4,4.2c-1.5,6.9-3,13.8-4.5,20.7 l-4.6,21.2l6.1-3.3c0.2-0.1,0.4-0.2,0.6-0.3l8-4.7c7.4-4.3,14.8-8.6,22.1-12.9c0.9-0.6,1.8-0.8,2.6-0.8c0.8,0,1.7,0.3,2.6,0.8 c7.2,4.2,14.4,8.4,21.7,12.6l8.2,4.8l6.6,3.7l-1.1-6.5c0-0.2-0.1-0.4-0.1-0.6l-2.2-10.2c-1.8-8.2-3.6-16.5-5.3-24.7 c-0.3-1.6,0.1-2.9,1.3-4c5.5-5,11.1-9.9,16.6-14.9l7.2-6.5c0.7-0.6,8.2-7.3,8.2-7.3l-7-0.9c-0.3,0-0.5-0.1-0.8-0.1l-23.1-2.4 c-3.9-0.4-7.8-0.8-11.6-1.2c-2-0.2-3.2-1.1-4.1-3.1c-3.5-7.9-7-15.8-10.5-23.7l-3.6-8.2c-0.1-0.2-0.2-0.4-0.3-0.7l-2.9-5.8l-2.8,5.8 c-0.1,0.2-0.2,0.4-0.3,0.6L383,379.5c-0.7,1.7-1.9,2.5-3.7,2.7l-30.3,3.1l-12.3,1.3l5.1,4.8c0.2,0.2,0.3,0.3,0.4,0.4 C342.3,391.8,365.1,412.2,368.6,415.4z")
        ]), l)
    ])), Xy = F2(function(n, r) {
        return !g$(A2(Ku, l, A2(fl, Id, A2(Bl, n, r))));
    }), Jy = A2(ch, g([
        $g("1.1"),
        ih("275 300 250 200"),
        Hg("enable-background:new 0 0 800 800;")
    ]), g([
        A2(rh, l, g([
            A2(Eh, g([
                Th("M420.1,325.2c3.8-0.5,3-0.8,5.6,0c3.2,0.9,6.3,2.2,9.5,3.3c7,2.5,13.9,5.1,20.9,7.7c10.2,3.8,20.4,7.5,30.6,11.3 c1.3,0.5,2.1,1.4,2.2,2.8c0,0.4,0,0.7,0,1.1c0,3.4-0.6,4-3.8,4.7c-4.3,0.9-8.5,1.8-12.8,2.8c-26.7,6-53.5,12.1-80.2,18.1 c-2.4,0.5-4.8,1.1-7.2,1.6c-2.7,0.6-5.2-0.2-7.7-1.1c-14-5.4-28-10.8-42-16.2c-5.1-2-10.1-4-15.2-5.9c-5.3-2-10.4,0.4-11.9,5.4 c-1.2,4.3,0.8,8.7,4.9,10.3c15.1,5.9,30.1,11.7,45.2,17.4c5.6,2.1,11.2,4.3,16.9,6.2c5,1.6,10,1.6,15.2,0.3 c11.4-2.8,22.9-5.2,34.3-7.7c11.6-2.6,23.2-5.3,34.8-7.9c8.3-1.9,16.6-3.7,24.9-5.6c2.4-0.5,4.2,0.2,4.4,2.1 c0.4,3.1,0.4,5.5-2.8,6.2c-18.5,4.1-37,8.3-55.5,12.5c-13.7,3.1-27.4,6.2-41.1,9.3c-6.4,1.4-12.8,0.6-18.9-1.7 c-14-5.2-27.8-10.6-41.8-16c-6.1-2.3-12.2-4.7-18.2-7.1c-12.7-5-15.2-21.2-4.5-29.6c2-1.6,4.7-2.4,7.2-3c8-1.7,16-3,24-4.5 c12.4-2.4,24.7-4.9,37.1-7.3C374.7,334.6,416.1,326.2,420.1,325.2z")
            ]), l),
            A2(Eh, g([
                Th("M399.5,475.6c-6.7-0.1-13-2.1-19.1-4.5c-17.8-7-35.7-13.8-53.6-20.7c-12.5-4.8-15.5-19.9-5.7-29.1c1.4-1.3,3.3-2.1,5.1-2.9 c0.5-0.3,1.4,0,2,0.2c15.7,6,31.4,12.2,47.1,18.1c5.3,2,10.7,3.8,16.2,5.3c6.8,1.8,13.6,0.6,20.4-1c16.9-4,34-7.7,50.9-11.5 c13.4-3,26.7-6,40.1-9.1c1.7-0.4,2.1,0.1,2.1,1.7c0,3.6-0.6,4.4-4,5.2c-21.3,4.8-42.6,9.6-63.9,14.4c-11.8,2.6-23.6,5.3-35.4,8 c-2.9,0.7-5.6,0.1-8.2-0.9c-19-7.3-38-14.6-57-22c-3.6-1.4-6.9-1.4-9.9,1.2c-5,4.4-3.4,12.1,3,14.5c7.9,3.1,15.9,6.1,23.8,9.1 c10.9,4.2,21.9,8.4,32.8,12.7c7.1,2.8,14.1,3.3,21.6,1.5c25.9-6.1,51.8-11.7,77.7-17.6c5.2-1.2,10.4-2.3,15.6-3.3 c0.7-0.1,1.7,0,2.3,0.4c1.9,1.2,1.5,3.2,1.4,5.1c-0.1,1.4-1.1,2.4-2.5,2.7c-6.1,1.4-12.3,2.7-18.4,4.1c-7.1,1.6-14.1,3.2-21.2,4.8 c-19.8,4.5-39.6,8.9-59.4,13.3C402.1,475.5,400.8,475.5,399.5,475.6z")
            ]), l),
            A2(Eh, g([
                Th("M318.7,387c2.7,1.1,5.4,2.1,8.2,3.2c-0.3,0.3-0.4,0.6-0.6,0.8c-4.7,4.9-3.2,12,3.2,14.4c10.4,4,20.8,8,31.2,12 c8.2,3.2,16.4,6.3,24.6,9.6c7.8,3.1,15.5,3.6,23.8,1.6c23.7-5.7,47.6-10.8,71.4-16.2c6.7-1.5,13.4-3,20.1-4.5 c2.5-0.5,4.1,0.8,4.3,3.2c0.2,3.6-0.5,4.6-4,5.4c-23.6,5.3-47.2,10.6-70.7,15.9c-7.9,1.8-15.9,3.5-23.8,5.4 c-7.3,1.7-14.5,0.7-21.3-1.9c-15-5.6-29.8-11.4-44.7-17.2c-4.9-1.9-9.7-3.7-14.6-5.6C315.5,408.8,311.9,395.7,318.7,387z")
            ]), l),
            A2(Eh, g([
                Th("M386.2,408.9c7.1-1.6,13.6-3.1,20.2-4.6c13.7-3.1,27.4-6.1,41.2-9.2c12.7-2.9,25.4-5.8,38.2-8.6c3.9-0.8,6.7-2.6,7.5-6.8 c2.1,0.4,4,0.9,6,1.3c0.5,0.1,0.9,0.2,1.4,0.3c3.6,0.3,5.1,2.5,4.1,6c-0.4,1.5-1.5,2.2-3,2.5c-11.7,2.6-23.3,5.2-35,7.9 c-19.3,4.4-38.6,8.7-58,13.1c-2.3,0.5-4.5,1.2-6.8,1.5c-2.1,0.2-4.4,0.3-6.5-0.1C392.5,411.5,389.6,410.1,386.2,408.9z")
            ]), l)
        ]))
    ])), Wy = F3(function(n, r, t) {
        return A3(d_, n, r, A2(ye, function(n) {
            return gp(A2(Jc, n.a, n.b));
        }, t));
    }), Yy = F3(function(n, r, t) {
        var e, u = A2(Bl, r, t), c = 1 === (e = o(u, lt(A2(Ku, l, A2(fl, Id, u))))).a.$ ? Nv("Kein Inhalt") : e.b ? A2(z_, n, e.a.a) : Nv("Kein Inhalt");
        return A2(Ev, g([
            Tv("p-2 content")
        ]), g([
            c
        ]));
    }), Qy = F4(function(n, r, t, e) {
        var u = e.a, c = e.b;
        return A2(Ev, g([
            Tv("w-100")
        ]), g([
            A3(Wy, Dy, t, c.ch),
            A2(Ev, g([
                Tv("poi-details-title")
            ]), g([
                Nv(u.eE)
            ])),
            A2(Ev, g([
                Tv("d-flex justify-content-between align-items-center")
            ]), g([
                A2(bh, A2(Xy, 0, c), A2(Ev, g([
                    Tv("flex-grow-1 px-2 py-3 mb-0 poi-details-tab knowing"),
                    qy(!r),
                    Xv(Fy(0))
                ]), g([
                    Jy,
                    A2(Ev, g([
                        Tv("px-1")
                    ]), g([
                        Nv("Wissen")
                    ]))
                ]))),
                A2(bh, A2(Xy, 1, c), A2(Ev, g([
                    Tv("flex-grow-1 px-2 py-3 mb-0 poi-details-tab believing"),
                    qy(1 === r),
                    Xv(Fy(1))
                ]), g([
                    Ky,
                    A2(Ev, g([
                        Tv("px-1")
                    ]), g([
                        Nv("Glauben")
                    ]))
                ]))),
                A2(bh, A2(Xy, 2, c), A2(Ev, g([
                    Tv("flex-grow-1 px-2 py-3 mb-0 poi-details-tab experiencing"),
                    qy(2 === r),
                    Xv(Fy(2))
                ]), g([
                    Zy,
                    A2(Ev, g([
                        Tv("px-1")
                    ]), g([
                        Nv("Erleben")
                    ]))
                ])))
            ])),
            A2(Ev, g([
                Tv("bg-white")
            ]), g([
                A2(Sv, Ry, A3(Yy, n, r, c))
            ]))
        ]));
    }), nz = {
        $: 2
    }, rz = {
        $: 3
    }, tz = function(n) {
        return A2(Ba, function(n) {
            return 2 === n.$ ? ut(n.a) : ct;
        }, n);
    }, ez = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uz = function(n) {
        var r, t, e = n.a, u = n.b, c = (r = u.dN).$ || 30 !== r.a.$ ? b$(Wg) : d$(r.a.a);
        return A2(Ev, g([
            Tv("poi-list-item"),
            Xv(ez(e.am))
        ]), g([
            A2(Ev, g([
                Tv("poi-list-image")
            ]), g([
                c
            ])),
            A2(Ev, g([
                Tv("p-2 d-flex flex-column")
            ]), g([
                A2(Ev, g([
                    Tv("d-flex pb-2")
                ]), g([
                    A2(Ev, g([
                        Tv("poi-title")
                    ]), g([
                        Nv(e.eE)
                    ]))
                ])),
                A2(Ev, g([
                    Tv("text-dark")
                ]), g([
                    Nv(A2(ft, " - ", A2(tu, A2($p, gv, oe), g([
                        u.bk.dj,
                        (t = u.bk.dA + " " + u.bk.bM, t.trim())
                    ]))))
                ]))
            ]))
        ]));
    }, cz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, az = {
        $: 1
    }, iz = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oz = F3(function(n, r, t) {
        var e;
        return A2(Ev, g([
            Tv("wlcontainer"),
            (e = r, Tv(e ? "" : "hide-full-content"))
        ]), g([
            A2(Ev, g([
                Tv("content")
            ]), g([
                A2(Sv, iz, A2(z_, n, t))
            ])),
            A2(bh, !r, A2(Ev, g([
                Tv("read-more pointer d-flex justify-content-center align-items-center mt-4 text-dark"),
                Xv(cz(az))
            ]), g([
                Zm
            ])))
        ]));
    }), fz = F3(function(n, r, t) {
        var e = t.a, u = t.b;
        return A2(Ev, g([
            Tv("px-2 toggle-detail-box bg-white")
        ]), g([
            A2(Ev, g([
                Tv("d-flex justify-content-between align-items-center")
            ]), g([
                A2(Dh, g([
                    Tv("church-show-title")
                ]), g([
                    Nv(e.eE)
                ])),
                A2(bh, r, A2(Dh, g([
                    Xv(cz(Ys)),
                    Tv("church-show-title-close")
                ]), g([
                    fh
                ])))
            ])),
            A2(Vh, u.ba, function(t) {
                return A2(bh, lt(Id(uc(t))) > 0, A3(oz, n, r, uc(t)));
            })
        ]));
    }), sz = F4(function(n, r, e, u) {
        var c = t(n, r) ? f("open", x_, Ys) : f("", Zm, r), a = c.a, i = c.b, o = c.c;
        return A2(Ev, g([
            Tv("detail-box-header"),
            Tv(a),
            Xv(cz(o))
        ]), g([
            A2(Ev, l, g([
                A2(Lv, g([
                    Tv("detail-icon-container")
                ]), g([
                    u
                ])),
                Nv(e)
            ])),
            A2(Ev, g([
                Tv("px-3")
            ]), g([
                i
            ]))
        ]));
    }), bz = F5(function(n, r, e, u, c) {
        return A2(Ev, g([
            Tv("toggle-detail-box")
        ]), g([
            A4(sz, n, r, e, u),
            A2(bh, t(n, r), A2(Ev, g([
                Tv("detail-box-content")
            ]), g([
                c
            ])))
        ]));
    }), dz = F3(function(n, r, t) {
        var e = A2(Ku, l, A2(fl, tz, A2(fl, function(n) {
            return n.b.a;
        }, t.b.e8))), u = r ? o(function(n) {
            return n.bK;
        }, "Gottesdienste") : o(function(n) {
            return n.cM;
        }, "Veranstaltungen"), c = u.a;
        return A3(Dm, n, u.b, A2(au, function(n) {
            return n.a.dh;
        }, A2(Ba, function(n) {
            var r = n.a, t = A2(au, function(n) {
                return n.dh;
            }, c(n.b.bk));
            return t.b ? ut(o(t.a, function(n) {
                return A2(Lv, g([
                    Tv("pointer"),
                    Xv(ez(n.am))
                ]), g([
                    A2(Lv, g([
                        Tv("me-3")
                    ]), g([
                        Oh
                    ])),
                    Nv(n.eE)
                ]));
            }(r))) : ct;
        }, e)));
    }), lz = function(n) {
        return A2(Ba, function(n) {
            return 7 === n.$ ? ut(n.a) : ct;
        }, n);
    }, vz = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), hz = function(n) {
        var r = function() {
            switch(n){
                case 0:
                    return "bicycle";
                case 1:
                    return "church";
                case 3:
                    return "";
                default:
                    return "info-circle";
            }
        }();
        return qv(r);
    }, gz = F3(function(n, r, t) {
        return A2(Ev, g([
            Tv("toggle-detail-box")
        ]), g([
            A2(Ev, g([
                Tv("detail-box-header"),
                Xv(n)
            ]), g([
                A2(Ev, l, g([
                    A2(Lv, g([
                        Tv("detail-icon-container")
                    ]), g([
                        t
                    ])),
                    Nv(r)
                ])),
                A2(Ev, g([
                    Tv("px-3")
                ]), g([
                    Oh
                ]))
            ]))
        ]));
    }), $z = F2(function(n, r) {
        var t = r.a, e = r.b;
        return e.em ? A5(bz, n.M, A2(vz, t.am, t.eE), t.eE, hz(e.ef), A2(Sv, iz, A2(z_, n.B, ic(A2(oc, t, e))))) : A3(gz, function(n) {
            return {
                $: 2,
                a: n
            };
        }(t.am), t.eE, hz(e.ef));
    }), mz = F2(function(n, r) {
        var t = r.b;
        return A3(Cd, Nv(""), Ev(l), A2(fl, ye($z(n)), A2(fl, lz, A2(fl, function(n) {
            return n.b.a;
        }, t.e9))));
    }), pz = F2(function(n, r) {
        var t, e;
        return A2(Ev, l, g([
            A3(fz, n.B, !1, r),
            A5(bz, n.M, nz, "Gottesdienste", m$, A3(dz, n.B, !0, r)),
            A5(bz, n.M, rz, "Veranstaltungen", h$, A3(dz, n.B, !1, r)),
            A2(mz, n, r),
            (t = r, e = A2(Ku, l, A2(fl, tz, A2(fl, function(n) {
                return n.b.a;
            }, t.b.e8))), A2(Ev, g([
                Tv("toggle-detail-box")
            ]), g([
                A2(Ev, g([
                    Tv("detail-box-header")
                ]), g([
                    A2(Ev, l, g([
                        A2(Lv, g([
                            Tv("detail-icon-container")
                        ]), g([
                            qv("church")
                        ])),
                        Nv("Kirchen")
                    ]))
                ])),
                A2(Ev, l, A2(ye, uz, e))
            ])))
        ]));
    }), wz = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _z = F2(function(n, r) {
        return A3(Wy, wz, n, A2(Ku, l, A2(fl, function(n) {
            return Ny(n.b.a);
        }, r.b.ch)));
    }), yz = F2(function(n, r) {
        var t = 1 === n.M.$ ? A3(fz, n.B, !0, r) : A2(pz, n, r);
        return A2(Ev, g([
            Tv("w-100 bg-white")
        ]), g([
            A2(_z, n.aR, r),
            t
        ]));
    }), zz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mz = function(n) {
        return A2(Sv, zz, A2(Gg, z_(n.B), n.ae));
    }, kz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xz = F2(function(n, r) {
        var t = r.a, e = r.b, u = lt(e.a) ? A2(Sv, kz, A2(z_, n, ic(A2(oc, t, e)))) : Nv("Kein Inhalt");
        return A2(Ev, g([
            Tv("p-2 content")
        ]), g([
            u
        ]));
    }), Cz = (Os = {
        el: Kb,
        eQ: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        eR: function(n) {
            return {
                $: 3,
                a: n
            };
        },
        fs: function() {
            return Jb(g([
                A2(od, Eu, id(ad)),
                A2(od, Ou, sd(fd)),
                A2(od, Ou, dd(bd)),
                ld(Zb),
                A2(od, bb, rd(Xb(td))),
                A2(od, bb, Wb(Xb(nd))),
                cd(ud)
            ]));
        },
        fz: Hv,
        fA: function(n) {
            var r = F3(function(r, t, e) {
                return A5(Zg, sb(n), t, bb, r, e);
            });
            switch(n.$){
                case 8:
                    return A3(r, 0, function() {
                        return Vv;
                    }, Xg);
                case 7:
                    return A3(r, 0, function() {
                        return Vv;
                    }, Uy);
                case 0:
                    return A3(r, 7, Ou, function(n) {
                        return {
                            dP: A2(Gg, Gy(n), A3(vg, _g, n.B.dO, n.B.fa)),
                            ed: !1,
                            fy: "Karte"
                        };
                    }(n.a));
                case 2:
                    return A3(r, 1, Eu, function(n) {
                        return {
                            dP: A2(Gg, Sy(n), n.C),
                            ed: !1,
                            fy: A2(tl, "Kirche", A2(rl, function(n) {
                                return n.a.eE;
                            }, n.C))
                        };
                    }(n.a));
                case 1:
                    return A3(r, 2, Tu, function(n) {
                        return {
                            dP: A2(Gg, v$, n.dO),
                            ed: !1,
                            fy: "Kirchen"
                        };
                    }(n.a));
                case 3:
                    return A3(r, 3, Su, function(n) {
                        return {
                            dP: A2(Gg, A3(Qy, n.B, n.aj, n.aR), n.J),
                            ed: !1,
                            fy: A2(tl, "POI", A2(rl, function(n) {
                                return n.a.eE;
                            }, n.J))
                        };
                    }(n.a));
                case 4:
                    return A3(r, 4, ju, function(n) {
                        return {
                            dP: A2(Gg, yz(n), n.F),
                            ed: !1,
                            fy: A2(tl, "Region", A2(rl, function(n) {
                                return n.a.eE;
                            }, n.F))
                        };
                    }(n.a));
                case 5:
                    return A3(r, 6, Lu, function(n) {
                        return {
                            dP: A2(Gg, xz(n.B), n.T),
                            ed: !1,
                            fy: A2(tl, "Thema", A2(rl, function(n) {
                                return n.a.eE;
                            }, n.T))
                        };
                    }(n.a));
                default:
                    return A3(r, 5, Bu, function(n) {
                        var r, t = 3 === (r = n.ae).$ && 22 === r.a.$ ? r.a.a.a.eE : "Info", e = function() {
                            switch(n.fl){
                                case "impressum":
                                case "datenschutz":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }();
                        return {
                            dP: A2(Ev, g([
                                Tv("p-2 content")
                            ]), g([
                                Mz(n)
                            ])),
                            ed: e,
                            fy: t
                        };
                    }(n.a));
            }
        }
    }, Ss = Os.eQ, js = Os.eR, Bs = function() {
        Bs.a(Ss(Er()));
    }, Ar({
        bp: function(n) {
            return Bs.a = n, Br.addEventListener("popstate", Bs), 0 > Br.navigator.userAgent.indexOf("Trident") || Br.addEventListener("hashchange", Bs), F2(function(r, t) {
                if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || r.target || r.hasAttribute("download"))) {
                    t.preventDefault();
                    var e = r.href, u = Er(), c = ge(e).a;
                    n(js(c && u.cX === c.cX && u.cg === c.cg && u.cT.a === c.cT.a ? function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(c) : function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(e)));
                }
            });
        },
        el: function(n) {
            return A3(Os.el, n, Er(), Bs);
        },
        fA: Os.fA,
        fz: Os.fz,
        fs: Os.fs
    }));
    Es = {
        Main: {
            init: Cz(aa)(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? y(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Es) : n.Elm = Es;
}($a0b4f895e1596b3b$exports);


window._paq = window._paq || [];
delete window._trlk;
// Without consent nothing may be queued, because matomo.js replays the whole queue once it loads.
let $a178acb730566997$var$active = false;
let $a178acb730566997$var$loaded = false;
const $a178acb730566997$export$234c45b355edd85b = ()=>{
    if ($a178acb730566997$var$active) return;
    $a178acb730566997$var$active = true;
    if (!$a178acb730566997$var$loaded) {
        $a178acb730566997$var$loaded = true;
        (function() {
            var u = "//www.nordkirche.de/piwik/";
            _paq.push([
                'setTrackerUrl',
                u + 'matomo.php'
            ]);
            _paq.push([
                'setSiteId',
                '220'
            ]);
            var d = document, g = d.createElement('script'), h = d.getElementsByTagName('head')[0];
            g.type = 'text/javascript';
            g.async = true;
            g.defer = true;
            g.src = u + 'matomo.js';
            h.appendChild(g);
        })();
        _paq.push([
            'enableLinkTracking'
        ]);
    }
    $a178acb730566997$export$92ab14d0aa42e41e();
};
const $a178acb730566997$export$e96c1edfdaf2d1db = ()=>{
    $a178acb730566997$var$active = false;
};
const $a178acb730566997$export$92ab14d0aa42e41e = ()=>{
    if ($a178acb730566997$var$active && !window._trlk) {
        //set tracking lock to block multiple tracking requests
        //for example browser-back triggers tracking twice
        window._trlk = true;
        //wait a little for page title to have a chance to update
        setTimeout(()=>{
            //unset tracking lock
            delete window._trlk;
            if ($a178acb730566997$var$active) $a178acb730566997$var$doTrackPageView();
        }, 500);
    }
};
const $a178acb730566997$var$doTrackPageView = ()=>{
    //matomo doesn't update the title and url, if trackPageView is tracked multiple times without a refresh
    _paq.push([
        'setDocumentTitle',
        document.title
    ]);
    _paq.push([
        'setCustomUrl',
        window.location.href
    ]);
    _paq.push([
        'trackPageView'
    ]);
};
const $a178acb730566997$export$73d0a139caca1fee = (params)=>{
    if (!$a178acb730566997$var$active) return;
    //delay as in trackPageView to have events send synchronously
    setTimeout(()=>{
        if ($a178acb730566997$var$active) $a178acb730566997$var$doTrackEvent(params);
    }, 500);
};
const $a178acb730566997$var$doTrackEvent = (params)=>{
    params.unshift('trackEvent');
    _paq.push(params);
};
const $a178acb730566997$export$7886f1062191421 = (cookie)=>{
    return cookie.replace(/^ +/, "").startsWith("_pk_");
};



const $2575132a0d1b937c$var$saveCookie = (key, value)=>{
    const cookieExpires = new Date();
    cookieExpires.setFullYear(cookieExpires.getFullYear() + 1);
    document.cookie = `${key}=${value}; expires=${cookieExpires.toUTCString()}; path=/`;
};
const $2575132a0d1b937c$var$saveCookies = (params)=>{
    for(var key in params)$2575132a0d1b937c$var$saveCookie(key, params[key]);
};
const $2575132a0d1b937c$export$24a32d9eaac5e08d = (params)=>{
    if (params.functionalConsent) $2575132a0d1b937c$var$saveCookies(params);
    else {
        $2575132a0d1b937c$var$deleteConsentCookies();
        localStorage.clear();
    }
    if (params.trackingConsent) $a178acb730566997$export$234c45b355edd85b();
    else {
        $a178acb730566997$export$e96c1edfdaf2d1db();
        $2575132a0d1b937c$var$deleteMatomoCookies();
    }
};
const $2575132a0d1b937c$var$deleteCookie = (cookie)=>{
    document.cookie = cookie.replace(/^ +/, "").replace(/(=.*|$)/, `=;expires=${new Date().toUTCString()}; path=/`);
};
const $2575132a0d1b937c$var$deleteConsentCookies = ()=>{
    $2575132a0d1b937c$var$deleteCookie("functionalConsent");
    $2575132a0d1b937c$var$deleteCookie("trackingConsent");
};
const $2575132a0d1b937c$var$deleteMatomoCookies = ()=>{
    document.cookie.split(";").filter($a178acb730566997$export$7886f1062191421).forEach($2575132a0d1b937c$var$deleteCookie);
};
const $2575132a0d1b937c$export$bfd7cc394b894e30 = ()=>{
    $2575132a0d1b937c$var$deleteConsentCookies();
    location.reload();
};
const $2575132a0d1b937c$var$readCookie = (name)=>{
    //regexp from https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
    const regex = new RegExp(`(?:(?:^|.*;\\s*)${name}\\s*\\=\\s*([^;]*).*$)|^.*$`);
    const cookieValue = document.cookie.replace(regex, "$1");
    return cookieValue;
};
const $2575132a0d1b937c$export$8590d4ef0e2ee08a = ()=>{
    return $2575132a0d1b937c$var$readCookie("trackingConsent") == "true";
};
const $2575132a0d1b937c$export$15edae4d2e698bfb = ()=>{
    return $2575132a0d1b937c$var$readCookie("functionalConsent") == "true";
};
const $2575132a0d1b937c$export$f4d3dcfc47dd8e3a = ()=>{
    return !$2575132a0d1b937c$export$15edae4d2e698bfb();
};
// This functions are for iOS to hide the consentBanner if ATTrackingManager is used
window.disableAllTracking = ()=>{
    document._app.ports.consentNone.send();
};
window.acceptAllTracking = ()=>{
    document._app.ports.consentAll.send();
};


parcelRequire("8JYDX");
parcelRequire("f1q41");
const $2b6dd1db8e0472e6$var$altars = [];
const $2b6dd1db8e0472e6$var$tripleAltarImages = {};
const $2b6dd1db8e0472e6$var$tripleAltarStates = {};
//config options
const $2b6dd1db8e0472e6$var$overlayDivSelector = ".leaflet-overlay-pane";
const $2b6dd1db8e0472e6$var$transitionDurationSec = 1.4;
const $2b6dd1db8e0472e6$var$minZoom = -3;
const $2b6dd1db8e0472e6$var$maxZoom = 4;
const $2b6dd1db8e0472e6$var$centerBounds = [
    [
        0,
        250
    ],
    [
        1000,
        750
    ]
];
const $2b6dd1db8e0472e6$var$innerLeftBounds = [
    [
        0,
        0
    ],
    [
        1000,
        250
    ]
];
const $2b6dd1db8e0472e6$var$innerRightBounds = [
    [
        0,
        750
    ],
    [
        1000,
        1000
    ]
];
const $2b6dd1db8e0472e6$var$outerLeftBounds = [
    [
        0,
        250
    ],
    [
        1000,
        500
    ]
];
const $2b6dd1db8e0472e6$var$outerRightBounds = [
    [
        0,
        500
    ],
    [
        1000,
        750
    ]
];
const $2b6dd1db8e0472e6$var$outerBounds = [
    [
        0,
        0
    ],
    [
        1000,
        1000
    ]
];
const $2b6dd1db8e0472e6$var$emptyGif = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
const $2b6dd1db8e0472e6$export$33ddfbd0d1c07730 = (params)=>{
    const altarId = `folding-altar-${params.data.id}`;
    const altarDiv = document.getElementById(altarId);
    if (!altarDiv) return;
    if (!altarDiv._leaflet_id) $2b6dd1db8e0472e6$var$initAltar(altarId, params.data, params.state.isOpen);
    else $2b6dd1db8e0472e6$var$setAltarOpen(altarId, params.state.isOpen);
};
const $2b6dd1db8e0472e6$export$87b743d6f3254408 = (params)=>{
    const altarId = `triple-folding-altar-${params.data.id}`;
    const altarDiv = document.getElementById(altarId);
    if (!altarDiv) return;
    $2b6dd1db8e0472e6$var$tripleAltarStates[altarId] = params.state.state;
    if (!altarDiv._leaflet_id) $2b6dd1db8e0472e6$var$initTripleAltar(altarId, params.data);
    else $2b6dd1db8e0472e6$var$setTripleAltarState(altarId, params.transition.transition);
};
const $2b6dd1db8e0472e6$var$initAltar = (altarId, data, isOpen)=>{
    const altar = L.map(altarId, {
        crs: L.CRS.Simple,
        minZoom: $2b6dd1db8e0472e6$var$minZoom,
        maxZoom: $2b6dd1db8e0472e6$var$maxZoom,
        zoomControl: false,
        zoomAnimation: false,
        attributionControl: false
    });
    $2b6dd1db8e0472e6$var$altars[altarId] = altar;
    L.control.zoom({
        position: "topright"
    }).addTo(altar);
    const centerImageUrl = data.centerImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(centerImageUrl, $2b6dd1db8e0472e6$var$centerBounds, {
        className: "center-image"
    }).addTo(altar);
    const innerLeftImageUrl = data.innerLeftImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(innerLeftImageUrl, $2b6dd1db8e0472e6$var$innerLeftBounds, {
        className: "inner-left-image"
    }).addTo(altar);
    const innerRightImageUrl = data.innerRightImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(innerRightImageUrl, $2b6dd1db8e0472e6$var$innerRightBounds, {
        className: "inner-right-image"
    }).addTo(altar);
    const outerLeftImageUrl = data.outerLeftImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(outerLeftImageUrl, $2b6dd1db8e0472e6$var$outerLeftBounds, {
        className: "outer-left-image"
    }).addTo(altar);
    const outerRightImageUrl = data.outerRightImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(outerRightImageUrl, $2b6dd1db8e0472e6$var$outerRightBounds, {
        className: "outer-right-image"
    }).addTo(altar);
    $2b6dd1db8e0472e6$var$fixateZoom(altar);
    altar.setMaxBounds($2b6dd1db8e0472e6$var$outerBounds);
    altar.on("drag", ()=>{
        altar.panInsideBounds($2b6dd1db8e0472e6$var$outerBounds, {
            animate: false
        });
    });
    setTimeout(()=>$2b6dd1db8e0472e6$var$setAltarOpen(altarId, isOpen), 1);
    const altarDiv = document.querySelector(`#${altarId}`);
    const overlayDiv = altarDiv.querySelector($2b6dd1db8e0472e6$var$overlayDivSelector);
    altar.on("zoomstart", ()=>{
        //disable animation stuff
        overlayDiv.style.transition = "0s";
    });
    altar.on("zoomend", ()=>{
        // let "zoomend" finish before restoring the wing rotations, Leaflet's reset would overwrite them
        setTimeout(()=>{
            const state = altarDiv.attributes["data-open"];
            $2b6dd1db8e0472e6$var$setAltarOpen(altarId, state);
        }, 1);
        // re-enable animation only after a short while. Otherwise it could still trigger sometimes
        setTimeout(()=>{
            overlayDiv.style.transition = `${$2b6dd1db8e0472e6$var$transitionDurationSec}s`;
        }, 100);
    });
    overlayDiv.style.transition = `${$2b6dd1db8e0472e6$var$transitionDurationSec}s`;
};
const $2b6dd1db8e0472e6$var$initTripleAltar = (altarId, data)=>{
    const altar = L.map(altarId, {
        crs: L.CRS.Simple,
        minZoom: $2b6dd1db8e0472e6$var$minZoom,
        maxZoom: $2b6dd1db8e0472e6$var$maxZoom,
        zoomControl: false,
        zoomAnimation: false,
        attributionControl: false
    });
    $2b6dd1db8e0472e6$var$altars[altarId] = altar;
    delete $2b6dd1db8e0472e6$var$tripleAltarImages[altarId];
    L.control.zoom({
        position: "topright"
    }).addTo(altar);
    const centerImageUrl = data.centerImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(centerImageUrl, $2b6dd1db8e0472e6$var$centerBounds, {
        className: "center-image"
    }).addTo(altar);
    const openedOnceInnerLeftImageUrl = data.openedOnceInnerLeftImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedOnceInnerLeftImageUrl, $2b6dd1db8e0472e6$var$innerLeftBounds, {
        className: "opened-once-inner-left-image"
    }).addTo(altar);
    const openedOnceInnerRightImageUrl = data.openedOnceInnerRightImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedOnceInnerRightImageUrl, $2b6dd1db8e0472e6$var$innerRightBounds, {
        className: "opened-once-inner-right-image"
    }).addTo(altar);
    const openedTwiceInnerLeftImageUrl = data.openedTwiceInnerLeftImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedTwiceInnerLeftImageUrl, $2b6dd1db8e0472e6$var$innerLeftBounds, {
        className: "opened-twice-inner-left-image"
    }).addTo(altar);
    const openedTwiceInnerRightImageUrl = data.openedTwiceInnerRightImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedTwiceInnerRightImageUrl, $2b6dd1db8e0472e6$var$innerRightBounds, {
        className: "opened-twice-inner-right-image"
    }).addTo(altar);
    const openedTwiceOuterLeftImageUrl = data.openedTwiceOuterLeftImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedTwiceOuterLeftImageUrl, $2b6dd1db8e0472e6$var$outerLeftBounds, {
        className: "opened-twice-outer-left-image"
    }).addTo(altar);
    const openedTwiceOuterRightImageUrl = data.openedTwiceOuterRightImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedTwiceOuterRightImageUrl, $2b6dd1db8e0472e6$var$outerRightBounds, {
        className: "opened-twice-outer-right-image"
    }).addTo(altar);
    const openedOnceOuterLeftImageUrl = data.openedOnceOuterLeftImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedOnceOuterLeftImageUrl, $2b6dd1db8e0472e6$var$outerLeftBounds, {
        className: "opened-once-outer-left-image"
    }).addTo(altar);
    const openedOnceOuterRightImageUrl = data.openedOnceOuterRightImageUrl || $2b6dd1db8e0472e6$var$emptyGif;
    L.imageOverlay(openedOnceOuterRightImageUrl, $2b6dd1db8e0472e6$var$outerRightBounds, {
        className: "opened-once-outer-right-image"
    }).addTo(altar);
    $2b6dd1db8e0472e6$var$fixateZoom(altar);
    altar.setMaxBounds($2b6dd1db8e0472e6$var$outerBounds);
    altar.on("drag", ()=>{
        altar.panInsideBounds($2b6dd1db8e0472e6$var$outerBounds, {
            animate: false
        });
    });
    const altarDiv = document.querySelector(`#${altarId}`);
    setTimeout(()=>{
        const images = {
            openedOnceInnerLeftImage: altarDiv.querySelector(".opened-once-inner-left-image"),
            openedOnceInnerRightImage: altarDiv.querySelector(".opened-once-inner-right-image"),
            openedOnceOuterLeftImage: altarDiv.querySelector(".opened-once-outer-left-image"),
            openedOnceOuterRightImage: altarDiv.querySelector(".opened-once-outer-right-image"),
            openedTwiceInnerLeftImage: altarDiv.querySelector(".opened-twice-inner-left-image"),
            openedTwiceInnerRightImage: altarDiv.querySelector(".opened-twice-inner-right-image"),
            openedTwiceOuterLeftImage: altarDiv.querySelector(".opened-twice-outer-left-image"),
            openedTwiceOuterRightImage: altarDiv.querySelector(".opened-twice-outer-right-image")
        };
        $2b6dd1db8e0472e6$var$tripleAltarImages[altarId] = images;
        // initial zoom has transitions disabled here, so this does not animate
        $2b6dd1db8e0472e6$var$applyTripleAltarState(altarId);
        if ($2b6dd1db8e0472e6$var$tripleAltarStates[altarId] !== "Closed") $2b6dd1db8e0472e6$var$unfixateZoom(altar);
    }, 1);
    const overlayDiv = altarDiv.querySelector($2b6dd1db8e0472e6$var$overlayDivSelector);
    altar.on("zoomstart", ()=>{
        //disable animation stuff
        overlayDiv.style.transition = "0s";
    });
    altar.on("zoomend", ()=>{
        // let "zoomend" finish before restoring the wing rotations, Leaflet's reset would overwrite them
        setTimeout(()=>$2b6dd1db8e0472e6$var$applyTripleAltarState(altarId), 1);
        // re-enable animation only after a short while. Otherwise it could still trigger sometimes
        setTimeout(()=>{
            overlayDiv.style.transition = `${$2b6dd1db8e0472e6$var$transitionDurationSec}s`;
        }, 100);
    });
    overlayDiv.style.transition = `${$2b6dd1db8e0472e6$var$transitionDurationSec}s`;
};
const $2b6dd1db8e0472e6$var$setAltarOpen = (altarId, isOpen)=>{
    const altar = $2b6dd1db8e0472e6$var$altars[altarId];
    const altarDiv = document.querySelector(`#${altarId}`);
    altarDiv.attributes["data-open"] = isOpen;
    const innerLeftImage = altarDiv.querySelector(".inner-left-image");
    const innerRightImage = altarDiv.querySelector(".inner-right-image");
    const outerLeftImage = altarDiv.querySelector(".outer-left-image");
    const outerRightImage = altarDiv.querySelector(".outer-right-image");
    if (isOpen) {
        $2b6dd1db8e0472e6$var$replaceRotation(innerLeftImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(innerRightImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(outerLeftImage, -180);
        $2b6dd1db8e0472e6$var$replaceRotation(outerRightImage, 180);
        $2b6dd1db8e0472e6$var$unfixateZoom(altar);
    } else {
        $2b6dd1db8e0472e6$var$replaceRotation(innerLeftImage, 180);
        $2b6dd1db8e0472e6$var$replaceRotation(innerRightImage, -180);
        $2b6dd1db8e0472e6$var$replaceRotation(outerLeftImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(outerRightImage, 0);
        //add a little extra delay, so animation is definitely done
        $2b6dd1db8e0472e6$var$fixateZoom(altar, $2b6dd1db8e0472e6$var$transitionDurationSec * 1000 + 100);
    }
};
const $2b6dd1db8e0472e6$var$setTripleAltarState = (altarId, transition)=>{
    const altar = $2b6dd1db8e0472e6$var$altars[altarId];
    const altarDiv = document.querySelector(`#${altarId}`);
    if (!altarDiv) return;
    const images = $2b6dd1db8e0472e6$var$tripleAltarImages[altarId];
    if (!images) return;
    const { openedOnceInnerLeftImage: openedOnceInnerLeftImage, openedOnceInnerRightImage: openedOnceInnerRightImage, openedOnceOuterLeftImage: openedOnceOuterLeftImage, openedOnceOuterRightImage: openedOnceOuterRightImage, openedTwiceInnerLeftImage: openedTwiceInnerLeftImage, openedTwiceInnerRightImage: openedTwiceInnerRightImage, openedTwiceOuterLeftImage: openedTwiceOuterLeftImage, openedTwiceOuterRightImage: openedTwiceOuterRightImage } = images;
    if (transition === "ClosedToOpenedOnce") {
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceInnerLeftImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceInnerRightImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceOuterLeftImage, -180);
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceOuterRightImage, 180);
        $2b6dd1db8e0472e6$var$unfixateZoom(altar);
    } else if (transition === "OpenedOnceToOpenedTwice") {
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceInnerLeftImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceInnerRightImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceOuterLeftImage, -180);
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceOuterRightImage, 180);
        $2b6dd1db8e0472e6$var$unfixateZoom(altar);
    } else if (transition === "OpenedTwiceToOpenedOnce") {
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceInnerLeftImage, 180);
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceInnerRightImage, -180);
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceOuterLeftImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(openedTwiceOuterRightImage, 0);
        $2b6dd1db8e0472e6$var$unfixateZoom(altar);
    } else if (transition === "OpenedOnceToClosed") {
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceInnerLeftImage, 180);
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceInnerRightImage, -180);
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceOuterLeftImage, 0);
        $2b6dd1db8e0472e6$var$replaceRotation(openedOnceOuterRightImage, 0);
        //add a little extra delay, so animation is definitely done
        $2b6dd1db8e0472e6$var$fixateZoom(altar, $2b6dd1db8e0472e6$var$transitionDurationSec * 1000 + 100);
    }
};
// Sets the final wing rotations for the current state. Leaflet resets each
// overlay's transform on zoom, which drops the rotateY of every wing.
const $2b6dd1db8e0472e6$var$applyTripleAltarState = (altarId)=>{
    const images = $2b6dd1db8e0472e6$var$tripleAltarImages[altarId];
    if (!images) return;
    const state = $2b6dd1db8e0472e6$var$tripleAltarStates[altarId];
    const openedOnce = state === "OpenedOnce" || state === "OpenedTwice";
    const openedTwice = state === "OpenedTwice";
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedOnceInnerLeftImage, openedOnce ? 0 : 180);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedOnceInnerRightImage, openedOnce ? 0 : -180);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedOnceOuterLeftImage, openedOnce ? -180 : 0);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedOnceOuterRightImage, openedOnce ? 180 : 0);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedTwiceInnerLeftImage, openedTwice ? 0 : 180);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedTwiceInnerRightImage, openedTwice ? 0 : -180);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedTwiceOuterLeftImage, openedTwice ? -180 : 0);
    $2b6dd1db8e0472e6$var$replaceRotation(images.openedTwiceOuterRightImage, openedTwice ? 180 : 0);
};
const $2b6dd1db8e0472e6$var$replaceRotation = (div, rotation, visibility = Math.abs(rotation) <= 90)=>{
    div.style.transform = `${div.style.transform.replace(/rotateY\([^)]*\)/, "")} rotateY(${rotation}deg)`;
    $2b6dd1db8e0472e6$var$setVisibility(div, visibility ? "visible" : "hidden");
};
const $2b6dd1db8e0472e6$var$setVisibility = (div, visibility)=>{
    div.style.visibility = visibility;
};
const $2b6dd1db8e0472e6$var$unfixateZoom = (altar)=>{
    altar.setMaxZoom($2b6dd1db8e0472e6$var$maxZoom);
    altar.setMinZoom($2b6dd1db8e0472e6$var$minZoom);
};
const $2b6dd1db8e0472e6$var$fixateZoom = (altar, delay = 0)=>{
    setTimeout(()=>{
        altar.fitBounds($2b6dd1db8e0472e6$var$centerBounds);
        const fixedZoom = altar.getZoom();
        altar.setMinZoom(fixedZoom);
        altar.setMaxZoom(fixedZoom);
    }, delay);
};


const $d52aae875779adc4$export$b3890eb0ae9dca99 = (params)=>{
    params = params || {};
    let imageIds = params.imageIds || [];
    let outfile = params.outfile || "Ihre pers\xf6nliche Grafik";
    // draw on canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    let canvasWidth = 0;
    let canvasHeight = 0;
    imageIds.forEach((val, idx)=>{
        const img = document.getElementById(val);
        canvasWidth = Math.max(canvasWidth, img.naturalWidth);
        canvasHeight += img.naturalHeight;
    });
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    let currentHeight = 0;
    imageIds.forEach((val, idx)=>{
        const img = document.getElementById(val);
        ctx.drawImage(img, 0, currentHeight, img.naturalWidth, img.naturalHeight);
        currentHeight += img.naturalHeight;
    });
    const url = canvas.toDataURL("image/png");
    const image = new Image();
    image.src = url;
    // trigger download
    const a = document.createElement("a");
    a.download = outfile + ".png";
    a.href = url.replace("image/png", "image/octet-stream");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};


window.customElements.define("tower-game-helper", class TowerGameHelper extends HTMLElement {
    async connectedCallback() {
        this.images.map((src)=>this.loadImage(src));
        this.onResize = ()=>this.heightChanged();
        requestAnimationFrame(()=>{
            if (!this.isConnected) return;
            this.heightChanged();
            window.addEventListener('resize', this.onResize);
        });
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
    }
    heightChanged() {
        const towerGame = document.getElementById(this.towerGameId);
        if (!towerGame) return;
        this.dispatchEvent(new CustomEvent("heightChanged", {
            detail: {
                canvasHeight: towerGame.clientHeight
            }
        }));
    }
    loadImage(src) {
        var img = new Image();
        img.onload = ()=>{
            this.dispatchEvent(// BEWARE! elm silently fails in case it can't decode the event's data.
            new CustomEvent("imageLoaded", {
                detail: {
                    url: img.src,
                    height: img.height,
                    width: img.width
                }
            }));
        };
        img.src = src;
    }
});
const $c4728770149235fa$export$b3890eb0ae9dca99 = async (images)=>{
    const imgs = await Promise.all(images.map($c4728770149235fa$var$loadImage));
    const smallestWidth = Math.min(...imgs.map((i)=>i.width));
    // draw on canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    let y = 0;
    canvas.width = smallestWidth;
    const scaledHeight = (img)=>Math.round(img.height * (smallestWidth / img.width));
    canvas.height = imgs.reduce((acc, img)=>acc + scaledHeight(img), 0);
    imgs.forEach((img)=>{
        ctx.drawImage(img, 0, y, smallestWidth, scaledHeight(img));
        y = y + scaledHeight(img);
    });
    // export image from canvas
    const url = canvas.toDataURL("image/png");
    const image = new Image();
    image.src = url;
    // trigger download
    const a = document.createElement("a");
    a.download = "Ihr pers\xf6nlicher Turm.png";
    a.href = url.replace("image/png", "image/octet-stream");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
const $c4728770149235fa$var$loadImage = (src)=>new Promise((resolve, reject)=>{
        var img = new Image();
        img.onload = function() {
            resolve(this);
        };
        img.onerror = ()=>reject(new Error(`Failed to load tower image ${src}`));
        img.src = src;
    });


var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v4.0.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.com/license/
 *
 * Date: 2026-01-18T00:20Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    $4eae0a726ab50395$exports = factory(global, true);
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    "use strict";
    if (!window1.document) throw new Error("jQuery requires a window with a document");
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    // Support: IE 11+
    // IE doesn't have Array#flat; provide a fallback.
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    // [[Class]] -> type pairs
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    // All support tests are defined in their respective modules.
    var support = {};
    function toType(obj) {
        if (obj == null) return obj + "";
        return typeof obj === "object" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    function isWindow(obj) {
        return obj != null && obj === obj.window;
    }
    function isArrayLike(obj) {
        var length = !!obj && obj.length, type = toType(obj);
        if (typeof obj === "function" || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var document$1 = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document$1;
        var i, script = doc.createElement("script");
        script.text = code;
        for(i in preservedScriptAttributes)if (node && node[i]) script[i] = node[i];
        if (doc.head.appendChild(script).parentNode) script.parentNode.removeChild(script);
    }
    var version = "4.0.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        }
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && typeof target !== "function") target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Note: an element does not contain itself
        contains: function(a, b) {
            var bup = b && b.parentNode;
            return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
            // IE doesn't have `contains` on SVG.
            (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        },
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    // https://www.w3.org/TR/css3-selectors/#whitespace
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var isIE = document$1.documentMode;
    var rbuggyQSA = isIE && new RegExp(// Support: IE 9 - 11+
    // IE's :disabled selector does not pick up the children of disabled fieldsets
    ":enabled|:disabled|\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
    var identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+";
    var rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*");
    var rdescend = new RegExp(whitespace + "|>");
    var rsibling = /[+~]/;
    var documentElement$1 = document$1.documentElement;
    // Support: IE 9 - 11+
    // IE requires a prefix.
    var matches = documentElement$1.matches || documentElement$1.msMatchesSelector;
    /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
        var keys = [];
        function cache(key, value) {
            // Use (key + " ") to avoid collision with native prototype properties
            // (see https://github.com/jquery/sizzle/issues/157)
            if (keys.push(key + " ") > jQuery.expr.cacheLength) // Only keep the most recent entries
            delete cache[keys.shift()];
            return cache[key + " "] = value;
        }
        return cache;
    }
    /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
    var attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]";
    var pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)";
    var filterMatchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i")
    };
    var rpseudo = new RegExp(pseudos);
    // CSS escapes
    // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    var runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
        return nonHex;
        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    };
    function unescapeSelector(sel) {
        return sel.replace(runescape, funescape);
    }
    function selectorError(msg) {
        jQuery.error("Syntax error, unrecognized expression: " + msg);
    }
    var rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*");
    var tokenCache = createCache();
    function tokenize(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) return parseOnly ? 0 : cached.slice(0);
        soFar = selector;
        groups = [];
        preFilters = jQuery.expr.preFilter;
        while(soFar){
            // Comma and first run
            if (!matched || (match = rcomma.exec(soFar))) {
                if (match) // Don't consume trailing commas as valid
                soFar = soFar.slice(match[0].length) || soFar;
                groups.push(tokens = []);
            }
            matched = false;
            // Combinators
            if (match = rleadingCombinator.exec(soFar)) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    // Cast descendant combinators to space
                    type: match[0].replace(rtrimCSS, " ")
                });
                soFar = soFar.slice(matched.length);
            }
            // Filters
            for(type in filterMatchExpr)if ((match = jQuery.expr.match[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    type: type,
                    matches: match
                });
                soFar = soFar.slice(matched.length);
            }
            if (!matched) break;
        }
        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        if (parseOnly) return soFar.length;
        return soFar ? selectorError(selector) : // Cache the tokens
        tokenCache(selector, groups).slice(0);
    }
    var preFilter = {
        ATTR: function(match) {
            match[1] = unescapeSelector(match[1]);
            // Move the given value to match[3] whether quoted or unquoted
            match[3] = unescapeSelector(match[3] || match[4] || match[5] || "");
            if (match[2] === "~=") match[3] = " " + match[3] + " ";
            return match.slice(0, 4);
        },
        CHILD: function(match) {
            /* matches from filterMatchExpr["CHILD"]
			1 type (only|nth|...)
			2 what (child|of-type)
			3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
			4 xn-component of xn+y argument ([+-]?\d*n|)
			5 sign of xn-component
			6 x of xn-component
			7 sign of y-component
			8 y of y-component
		*/ match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
                // nth-* requires argument
                if (!match[3]) selectorError(match[0]);
                // numeric x and y parameters for jQuery.expr.filter.CHILD
                // remember that false/true cast respectively to 0/1
                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                match[5] = +(match[7] + match[8] || match[3] === "odd");
            // other types prohibit arguments
            } else if (match[3]) selectorError(match[0]);
            return match;
        },
        PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (filterMatchExpr.CHILD.test(match[0])) return null;
            // Accept quoted arguments as-is
            if (match[3]) match[2] = match[4] || match[5] || "";
            else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                // excess is a negative index
                match[0] = match[0].slice(0, excess);
                match[2] = unquoted.slice(0, excess);
            }
            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice(0, 3);
        }
    };
    function toSelector(tokens) {
        var i = 0, len = tokens.length, selector = "";
        for(; i < len; i++)selector += tokens[i].value;
        return selector;
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    function access(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (typeof value !== "function") raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    }
    // Only count HTML whitespace
    // Other whitespace should count in values
    // https://infra.spec.whatwg.org/#ascii-whitespace
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()];
            if (value !== undefined) {
                if (value === null || // For compat with previous handling of boolean attributes,
                // remove when `false` passed. For ARIA attributes -
                // many of which recognize a `"false"` value - continue to
                // set the `"false"` value as jQuery <4 did.
                value === false && name.toLowerCase().indexOf("aria-") !== 0) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value);
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = elem.getAttribute(name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {},
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Support: IE <=11+
    // An input loses its value after becoming a radio
    if (isIE) jQuery.attrHooks.type = {
        set: function(elem, value) {
            if (value === "radio" && nodeName(elem, "input")) {
                var val = elem.value;
                elem.setAttribute("type", value);
                if (val) elem.value = val;
                return value;
            }
        }
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var sort = arr.sort;
    var splice = arr.splice;
    var hasDuplicate;
    // Document order sorting
    function sortOrder(a, b) {
        // Flag for duplicate removal
        if (a === b) {
            hasDuplicate = true;
            return 0;
        }
        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) return compare;
        // Calculate position if both inputs belong to the same document
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1;
        // Disconnected nodes
        if (compare & 1) {
            // Choose the first element that is related to the document
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (a == document$1 || a.ownerDocument == document$1 && jQuery.contains(document$1, a)) return -1;
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (b == document$1 || b.ownerDocument == document$1 && jQuery.contains(document$1, b)) return 1;
            // Maintain original order
            return 0;
        }
        return compare & 4 ? -1 : 1;
    }
    /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i = 0;
        hasDuplicate = false;
        sort.call(results, sortOrder);
        if (hasDuplicate) {
            while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
            while(j--)splice.call(results, duplicates[j], 1);
        }
        return results;
    };
    jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
    };
    var i, outermostContext, // Local document vars
    document, documentElement, documentIsHTML, // Instance-specific data
    dirruns = 0, done = 0, classCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), // Regular expressions
    // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = jQuery.extend({
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    }, filterMatchExpr), rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, // Used for iframes; see `setDocument`.
    // Support: IE 9 - 11+
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE.
    unloadHandler = function() {
        setDocument();
    }, inDisabledFieldset = addCombinator(function(elem) {
        return elem.disabled === true && nodeName(elem, "fieldset");
    }, {
        dir: "parentNode",
        next: "legend"
    });
    function find(selector, context, results, seed) {
        var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
        results = results || [];
        // Return early from calls with invalid selector or context
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if (!seed) {
            setDocument(context);
            context = context || document;
            if (documentIsHTML) {
                // If the selector is sufficiently simple, try using a "get*By*" DOM method
                // (excepting DocumentFragment context, where the methods don't exist)
                if (nodeType !== 11 && (match = rquickExpr$1.exec(selector))) {
                    // ID selector
                    if (m = match[1]) {
                        // Document context
                        if (nodeType === 9) {
                            if (elem = context.getElementById(m)) push.call(results, elem);
                            return results;
                        // Element context
                        } else if (newContext && (elem = newContext.getElementById(m)) && jQuery.contains(context, elem)) {
                            push.call(results, elem);
                            return results;
                        }
                    // Type selector
                    } else if (match[2]) {
                        push.apply(results, context.getElementsByTagName(selector));
                        return results;
                    // Class selector
                    } else if ((m = match[3]) && context.getElementsByClassName) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                    }
                }
                // Take advantage of querySelectorAll
                if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                    newSelector = selector;
                    newContext = context;
                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                        // Expand context for sibling selectors
                        newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        // Outside of IE, if we're not changing the context we can
                        // use :scope instead of an ID.
                        // Support: IE 11+
                        // IE sometimes throws a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (newContext != context || isIE) {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                            else context.setAttribute("id", nid = jQuery.expando);
                        }
                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                        newSelector = groups.join(",");
                    }
                    try {
                        push.apply(results, newContext.querySelectorAll(newSelector));
                        return results;
                    } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                    } finally{
                        if (nid === jQuery.expando) context.removeAttribute("id");
                    }
                }
            }
        }
        // All others
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
    }
    /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
        fn[jQuery.expando] = true;
        return fn;
    }
    /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
        return function(elem) {
            return nodeName(elem, "input") && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
        return function(elem) {
            return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function(elem) {
            // Only certain elements can match :enabled or :disabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
            if ("form" in elem) {
                // Check for inherited disabledness on relevant non-disabled elements:
                // * listed form-associated elements in a disabled fieldset
                //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                // * option elements in a disabled optgroup
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                // All such elements have a "form" property.
                if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ("label" in elem) {
                        if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                        else return elem.disabled === disabled;
                    }
                    // Support: IE 6 - 11+
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                    elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                }
                return elem.disabled === disabled;
            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
            } else if ("label" in elem) return elem.disabled === disabled;
            // Remaining elements are neither :enabled nor :disabled
            return false;
        };
    }
    /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
            argument = +argument;
            return markFunction(function(seed, matches) {
                var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                // Match elements found at the specified indexes
                while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
            });
        });
    }
    /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 */ function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : document$1;
        // Return early if doc is invalid or already selected
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (doc == document || doc.nodeType !== 9) return;
        // Update global variables
        document = doc;
        documentElement = document.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document);
        // Support: IE 9 - 11+
        // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (isIE && document$1 != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) subWindow.addEventListener("unload", unloadHandler);
    }
    find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
    };
    find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
            return matches.call(elem, expr);
        } catch (e) {
            nonnativeSelectorCache(expr, true);
        }
        return find(expr, document, null, [
            elem
        ]).length > 0;
    };
    jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        find: {
            ID: function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                    var elem = context.getElementById(id);
                    return elem ? [
                        elem
                    ] : [];
                }
            },
            TAG: function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            },
            CLASS: function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            }
        },
        relative: {
            ">": {
                dir: "parentNode",
                first: true
            },
            " ": {
                dir: "parentNode"
            },
            "+": {
                dir: "previousSibling",
                first: true
            },
            "~": {
                dir: "previousSibling"
            }
        },
        preFilter: preFilter,
        filter: {
            ID: function(id) {
                var attrId = unescapeSelector(id);
                return function(elem) {
                    return elem.getAttribute("id") === attrId;
                };
            },
            TAG: function(nodeNameSelector) {
                var expectedNodeName = unescapeSelector(nodeNameSelector).toLowerCase();
                return nodeNameSelector === "*" ? function() {
                    return true;
                } : function(elem) {
                    return nodeName(elem, expectedNodeName);
                };
            },
            CLASS: function(className) {
                var pattern = classCache[className + " "];
                return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                }));
            },
            ATTR: function(name, operator, check) {
                return function(elem) {
                    var result = jQuery.attr(elem, name);
                    if (result == null) return operator === "!=";
                    if (!operator) return true;
                    result += "";
                    if (operator === "=") return result === check;
                    if (operator === "!=") return result !== check;
                    if (operator === "^=") return check && result.indexOf(check) === 0;
                    if (operator === "*=") return check && result.indexOf(check) > -1;
                    if (operator === "$=") return check && result.slice(-check.length) === check;
                    if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                    if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                    return false;
                };
            },
            CHILD: function(type, what, _argument, first, last) {
                var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                function(elem) {
                    return !!elem.parentNode;
                } : function(elem, _context, xml) {
                    var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                    if (parent) {
                        // :(first|last|only)-(child|of-type)
                        if (simple) {
                            while(dir){
                                node = elem;
                                while(node = node[dir]){
                                    if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                }
                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir = type === "only" && !start && "nextSibling";
                            }
                            return true;
                        }
                        start = [
                            forward ? parent.firstChild : parent.lastChild
                        ];
                        // non-xml :nth-child(...) stores cache data on `parent`
                        if (forward && useCache) {
                            // Seek `elem` from a previously-cached index
                            outerCache = parent[jQuery.expando] || (parent[jQuery.expando] = {});
                            cache = outerCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];
                            while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                            (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                            if (node.nodeType === 1 && ++diff && node === elem) {
                                outerCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff
                                ];
                                break;
                            }
                        } else {
                            // Use previously-cached element index if available
                            if (useCache) {
                                outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                            }
                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                        outerCache = node[jQuery.expando] || (node[jQuery.expando] = {});
                                        outerCache[type] = [
                                            dirruns,
                                            diff
                                        ];
                                    }
                                    if (node === elem) break;
                                }
                            }
                        }
                        // Incorporate the offset, then check against cycle size
                        diff -= last;
                        return diff === first || diff % first === 0 && diff / first >= 0;
                    }
                };
            },
            PSEUDO: function(pseudo, argument) {
                // pseudo-class names are case-insensitive
                // https://www.w3.org/TR/selectors/#pseudo-classes
                // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                // Remember that setFilters inherits from pseudos
                var fn = jQuery.expr.pseudos[pseudo] || jQuery.expr.setFilters[pseudo.toLowerCase()] || selectorError("unsupported pseudo: " + pseudo);
                // The user may use createPseudo to indicate that
                // arguments are needed to create the filter function
                // just as jQuery does
                if (fn[jQuery.expando]) return fn(argument);
                return fn;
            }
        },
        pseudos: {
            // Potentially complex pseudos
            not: markFunction(function(selector) {
                // Trim the selector passed to compile
                // to avoid treating leading and trailing
                // spaces as combinators
                var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                return matcher[jQuery.expando] ? markFunction(function(seed, matches, _context, xml) {
                    var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                    // Match elements unmatched by `matcher`
                    while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                }) : function(elem, _context, xml) {
                    input[0] = elem;
                    matcher(input, null, xml, results);
                    // Don't keep the element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    input[0] = null;
                    return !results.pop();
                };
            }),
            has: markFunction(function(selector) {
                return function(elem) {
                    return find(selector, elem).length > 0;
                };
            }),
            contains: markFunction(function(text) {
                text = unescapeSelector(text);
                return function(elem) {
                    return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                };
            }),
            // "Whether an element is represented by a :lang() selector
            // is based solely on the element's language value
            // being equal to the identifier C,
            // or beginning with the identifier C immediately followed by "-".
            // The matching of C against the element's language value is performed case-insensitively.
            // The identifier C does not have to be a valid language name."
            // https://www.w3.org/TR/selectors/#lang-pseudo
            lang: markFunction(function(lang) {
                // lang value must be a valid identifier
                if (!ridentifier.test(lang || "")) selectorError("unsupported lang: " + lang);
                lang = unescapeSelector(lang).toLowerCase();
                return function(elem) {
                    var elemLang;
                    do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                    }
                    while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                };
            }),
            // Miscellaneous
            target: function(elem) {
                var hash = window1.location && window1.location.hash;
                return hash && hash.slice(1) === elem.id;
            },
            root: function(elem) {
                return elem === documentElement;
            },
            focus: function(elem) {
                return elem === document.activeElement && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
            },
            // Boolean properties
            enabled: createDisabledPseudo(false),
            disabled: createDisabledPseudo(true),
            checked: function(elem) {
                // In CSS3, :checked should return both checked and selected elements
                // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
            },
            selected: function(elem) {
                // Support: IE <=11+
                // Accessing the selectedIndex property
                // forces the browser to treat the default option as
                // selected when in an optgroup.
                if (isIE && elem.parentNode) // eslint-disable-next-line no-unused-expressions
                elem.parentNode.selectedIndex;
                return elem.selected === true;
            },
            // Contents
            empty: function(elem) {
                // https://www.w3.org/TR/selectors/#empty-pseudo
                // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                //   but not by others (comment: 8; processing instruction: 7; etc.)
                // nodeType < 6 works because attributes (2) do not appear as children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                    if (elem.nodeType < 6) return false;
                }
                return true;
            },
            parent: function(elem) {
                return !jQuery.expr.pseudos.empty(elem);
            },
            // Element/input types
            header: function(elem) {
                return rheader.test(elem.nodeName);
            },
            input: function(elem) {
                return rinputs.test(elem.nodeName);
            },
            button: function(elem) {
                return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
            },
            text: function(elem) {
                return nodeName(elem, "input") && elem.type === "text";
            },
            // Position-in-collection
            first: createPositionalPseudo(function() {
                return [
                    0
                ];
            }),
            last: createPositionalPseudo(function(_matchIndexes, length) {
                return [
                    length - 1
                ];
            }),
            eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                return [
                    argument < 0 ? argument + length : argument
                ];
            }),
            even: createPositionalPseudo(function(matchIndexes, length) {
                var i = 0;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            odd: createPositionalPseudo(function(matchIndexes, length) {
                var i = 1;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i;
                if (argument < 0) i = argument + length;
                else if (argument > length) i = length;
                else i = argument;
                for(; --i >= 0;)matchIndexes.push(i);
                return matchIndexes;
            }),
            gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i = argument < 0 ? argument + length : argument;
                for(; ++i < length;)matchIndexes.push(i);
                return matchIndexes;
            })
        }
    };
    jQuery.expr.pseudos.nth = jQuery.expr.pseudos.eq;
    // Add button/input type pseudos
    for(i in {
        radio: true,
        checkbox: true,
        file: true,
        password: true,
        image: true
    })jQuery.expr.pseudos[i] = createInputPseudo(i);
    for(i in {
        submit: true,
        reset: true
    })jQuery.expr.pseudos[i] = createButtonPseudo(i);
    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = jQuery.expr.pseudos;
    jQuery.expr.setFilters = new setFilters();
    function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? // Check against closest ancestor/preceding element
        function(elem, context, xml) {
            while(elem = elem[dir]){
                if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
            }
            return false;
        } : // Check against all ancestor/preceding elements
        function(elem, context, xml) {
            var oldCache, outerCache, newCache = [
                dirruns,
                doneName
            ];
            // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
            if (xml) {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    if (matcher(elem, context, xml)) return true;
                }
            } else {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                    if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                    else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                    return newCache[2] = oldCache[2];
                    else {
                        // Reuse newcache so results back-propagate to previous elements
                        outerCache[key] = newCache;
                        // A match means we're done; a fail means we have to keep checking
                        if (newCache[2] = matcher(elem, context, xml)) return true;
                    }
                }
            }
            return false;
        };
    }
    function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
            var i = matchers.length;
            while(i--){
                if (!matchers[i](elem, context, xml)) return false;
            }
            return true;
        } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
        var i = 0, len = contexts.length;
        for(; i < len; i++)find(selector, contexts[i], results);
        return results;
    }
    function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
        for(; i < len; i++){
            if (elem = unmatched[i]) {
                if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) map.push(i);
                }
            }
        }
        return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[jQuery.expando]) postFilter = setMatcher(postFilter);
        if (postFinder && !postFinder[jQuery.expando]) postFinder = setMatcher(postFinder, postSelector);
        return markFunction(function(seed, results, context, xml) {
            var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                context
            ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
            if (matcher) {
                // If we have a postFinder, or filtered seed, or non-seed postFilter
                // or preexisting results,
                matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results;
                // Find primary matches
                matcher(matcherIn, matcherOut, context, xml);
            } else matcherOut = matcherIn;
            // Apply postFilter
            if (postFilter) {
                temp = condense(matcherOut, postMap);
                postFilter(temp, [], context, xml);
                // Un-match failing elements by moving them back to matcherIn
                i = temp.length;
                while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
            if (seed) {
                if (postFinder || preFilter) {
                    if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                        temp.push(matcherIn[i] = elem);
                        postFinder(null, matcherOut = [], temp, xml);
                    }
                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length;
                    while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                }
            } else {
                matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                if (postFinder) postFinder(null, results, matcherOut, xml);
                else push.apply(results, matcherOut);
            }
        });
    }
    function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = jQuery.expr.relative[tokens[0].type], implicitRelative = leadingRelative || jQuery.expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function(elem) {
            return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
            return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [
            function(elem, context, xml) {
                // Support: IE 11+
                // IE sometimes throws a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                // Avoid hanging onto element
                // (see https://github.com/jquery/sizzle/issues/299)
                checkContext = null;
                return ret;
            }
        ];
        for(; i < len; i++)if (matcher = jQuery.expr.relative[tokens[i].type]) matchers = [
            addCombinator(elementMatcher(matchers), matcher)
        ];
        else {
            matcher = jQuery.expr.filter[tokens[i].type].apply(null, tokens[i].matches);
            // Return special upon seeing a positional matcher
            if (matcher[jQuery.expando]) {
                // Find the next relative operator (if any) for proper handling
                j = ++i;
                for(; j < len; j++){
                    if (jQuery.expr.relative[tokens[j].type]) break;
                }
                return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                tokens.slice(0, i - 1).concat({
                    value: tokens[i - 2].type === " " ? "*" : ""
                })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
        }
        return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
            elems = seed || byElement && jQuery.expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1;
            if (outermost) // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
            // Add elements passing elementMatchers directly to results
            for(; (elem = elems[i]) != null; i++){
                if (byElement && elem) {
                    j = 0;
                    // Support: IE 11+
                    // IE sometimes throws a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (!context && elem.ownerDocument != document) {
                        setDocument(elem);
                        xml = !documentIsHTML;
                    }
                    while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                        push.call(results, elem);
                        break;
                    }
                    if (outermost) dirruns = dirrunsUnique;
                }
                // Track unmatched elements for set filters
                if (bySet) {
                    // They will have gone through all possible matchers
                    if (elem = !matcher && elem) matchedCount--;
                    // Lengthen the array for every element, matched or not
                    if (seed) unmatched.push(elem);
                }
            }
            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;
            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if (bySet && i !== matchedCount) {
                j = 0;
                while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                if (seed) {
                    // Reintegrate element matches to eliminate the need for sorting
                    if (matchedCount > 0) {
                        while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                    }
                    // Discard index placeholder values to get only actual matches
                    setMatched = condense(setMatched);
                }
                // Add matches to results
                push.apply(results, setMatched);
                // Seedless set matches succeeding multiple successful matchers stipulate sorting
                if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
            }
            // Override manipulation of globals by nested matchers
            if (outermost) {
                dirruns = dirrunsUnique;
                outermostContext = contextBackup;
            }
            return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
    }
    function compile(selector, match /* Internal Use Only */ ) {
        var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
            // Generate a function of recursive functions that can be used to check each element
            if (!match) match = tokenize(selector);
            i = match.length;
            while(i--){
                cached = matcherFromTokens(match[i]);
                if (cached[jQuery.expando]) setMatchers.push(cached);
                else elementMatchers.push(cached);
            }
            // Cache the compiled function
            cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
            // Save selector and tokenization
            cached.selector = selector;
        }
        return cached;
    }
    /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
        var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if (match.length === 1) {
            // Reduce context if the leading compound selector is an ID
            tokens = match[0] = match[0].slice(0);
            if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && jQuery.expr.relative[tokens[1].type]) {
                context = (jQuery.expr.find.ID(unescapeSelector(token.matches[0]), context) || [])[0];
                if (!context) return results;
                else if (compiled) context = context.parentNode;
                selector = selector.slice(tokens.shift().value.length);
            }
            // Fetch a seed set for right-to-left matching
            i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while(i--){
                token = tokens[i];
                // Abort if we hit a combinator
                if (jQuery.expr.relative[type = token.type]) break;
                if (find = jQuery.expr.find[type]) // Search, expanding context for leading sibling combinators
                {
                    if (seed = find(unescapeSelector(token.matches[0]), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                            push.apply(results, seed);
                            return results;
                        }
                        break;
                    }
                }
            }
        }
        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
    }
    // Initialize against the default document
    setDocument();
    jQuery.find = find;
    // These have always been private, but they used to be documented as part of
    // Sizzle so let's maintain them for now for backwards compatibility purposes.
    find.compile = compile;
    find.select = select;
    find.setDocument = setDocument;
    find.tokenize = tokenize;
    function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    }
    function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    }
    var rneedsContext = jQuery.expr.match.needsContext;
    // rsingleTag matches a string consisting of a single HTML element with no attributes
    // and captures the element's name
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function isObviousHtml(input) {
        return input[0] === "<" && input[input.length - 1] === ">" && input.length >= 3;
    }
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (typeof qualifier === "function") return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // HANDLE: $(DOMElement)
        if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (typeof selector === "function") return rootjQuery.ready !== undefined ? rootjQuery.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        else {
            // Handle obvious HTML strings
            match = selector + "";
            if (isObviousHtml(match)) // Assume that strings that start and end with <> are HTML and skip
            // the regex check. This also handles browser-supported HTML wrappers
            // like TrustedHTML.
            match = [
                null,
                selector,
                null
            ];
            else if (typeof selector === "string") match = rquickExpr.exec(selector);
            else return jQuery.makeArray(selector, this);
            // Match html or make sure no context is specified for #id
            // Note: match[1] may be a string or a TrustedHTML wrapper
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document$1, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (typeof this[match] === "function") this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document$1.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || rootjQuery).find(selector);
            else return this.constructor(context).find(selector);
        }
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document$1);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11+
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (typeof arg === "function") {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && typeof (method = value.promise) === "function") method.call(value).done(resolve).fail(reject);
            else if (value && typeof (method = value.then) === "function") method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            reject(value);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                catch: function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = typeof fns[tuple[4]] === "function" && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && typeof returned.promise === "function") returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (typeof then === "function") {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, typeof onProgress === "function" ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, typeof onFulfilled === "function" ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, typeof onRejected === "function" ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || typeof (resolveValues[i] && resolveValues[i].then) === "function") return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        if (error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception", error, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document$1, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document$1.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    if (document$1.readyState !== "loading") // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document$1.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Matches dashed string for camelizing
    var rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase
    function camelCase(string) {
        return string.replace(rdashAlpha, fcamelCase);
    }
    /**
 * Determines whether an object can have data
 */ function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    }
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = Object.create(null);
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return value;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45+
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11+
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.set(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.set(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    // isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
    // through the CSS cascade), which is useful in deciding whether or not to make it visible.
    // It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
    // * A hidden ancestor does not force an element to be classified as hidden.
    // * Being disconnected from the document does not force an element to be classified as hidden.
    // These differences improve the behavior of .toggle() et al. when applied to elements that are
    // detached or contained within hidden ancestors (gh-2404, gh-2863).
    function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && jQuery.css(elem, "display") === "none";
    }
    var ralphaStart = /^[a-z]/, // The regex visualized:
    //
    //                         /----------\
    //                        |            |    /-------\
    //                        |  / Top  \  |   |         |
    //         /--- Border ---+-| Right  |-+---+- Width -+---\
    //        |                 | Bottom |                    |
    //        |                  \ Left /                     |
    //        |                                               |
    //        |                              /----------\     |
    //        |          /-------------\    |            |    |- END
    //        |         |               |   |  / Top  \  |    |
    //        |         |  / Margin  \  |   | | Right  | |    |
    //        |---------+-|           |-+---+-| Bottom |-+----|
    //        |            \ Padding /         \ Left /       |
    // BEGIN -|                                               |
    //        |                /---------\                    |
    //        |               |           |                   |
    //        |               |  / Min \  |    / Width  \     |
    //         \--------------+-|       |-+---|          |---/
    //                           \ Max /       \ Height /
    rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function isAutoPx(prop) {
        // The first test is used to ensure that:
        // 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
        // 2. The prop is not empty.
        return ralphaStart.test(prop) && rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
    }
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (isAutoPx(prop) ? "px" : ""), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (!isAutoPx(prop) || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54 - 66+
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/;
    // Convert dashed to camelCase, handle vendor prefixes.
    // Used by the css & effects modules.
    // Support: IE <=9 - 11+
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function cssCamelCase(string) {
        return camelCase(string.replace(rmsPrefix, "ms-"));
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+
    // Check attachment across shadow DOM boundaries when possible (gh-3504).
    // Provide a fallback for browsers without Shadow DOM v1 support.
    if (!documentElement$1.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    };
    // rtagName captures the name from the first start tag in a string of HTML
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var wrapMap = {
        // Table parts need to be wrapped with `<table>` or they're
        // stripped to their contents when put in a div.
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do, so we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        // Support: IE <=9 - 11+
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") // Use slice to snapshot the live collection from gEBTN
        ret = arr.slice.call(context.getElementsByTagName(tag || "*"));
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object" && (elem.nodeType || isArrayLike(elem))) jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || arr;
                    // Create wrappers & descend into them.
                    j = wrap.length;
                    while(--j > -1)tmp = tmp.appendChild(context.createElement(wrap[j]));
                    tmp.innerHTML = jQuery.htmlPrefilter(elem);
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = typeof value === "function";
        if (valueIsFunction) return collection.each(function(index) {
            var self = collection.eq(index);
            args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.get(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce,
                                    crossOrigin: node.crossOrigin
                                }, doc);
                            } else DOMEval(node.textContent, node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement$1, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: Firefox <=42 - 66+
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11+
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: typeof hook === "function" ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: jQuery.extend(Object.create(null), {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    if (event.result !== undefined) // Setting `event.originalEvent.returnValue` in modern
                    // browsers does the same as just calling `preventDefault()`,
                    // the browsers ignore the value anyway.
                    // Incidentally, IE 11 is the only browser from our supported
                    // ones which respects the value returned from a `beforeunload`
                    // handler attached by `addEventListener`; other browsers do
                    // so only for inline handlers, so not setting the value
                    // directly shouldn't reduce any functionality.
                    event.preventDefault();
                }
            }
        })
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                // This controller function is invoked under multiple circumstances,
                // differentiated by the stored value in `saved`:
                // 1. For an outer synthetic `.trigger()`ed event (detected by
                //    `event.isTrigger & 1` and non-array `saved`), it records arguments
                //    as an array and fires an [inner] native event to prompt state
                //    changes that should be observed by registered listeners (such as
                //    checkbox toggling and focus updating), then clears the stored value.
                // 2. For an [inner] native event (detected by `saved` being
                //    an array), it triggers an inner synthetic event, records the
                //    result, and preempts propagation to further jQuery listeners.
                // 3. For an inner synthetic event (detected by `event.isTrigger & 1` and
                //    array `saved`), it prevents double-propagation of surrogate events
                //    but otherwise allows everything to proceed (particularly including
                //    further listeners).
                // Possible `saved` data shapes: `[...], `{ value }`, `false`.
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object),
                        // so this array will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is
                            // blurred by clicking outside of it, it invokes the handler
                            // synchronously. If that handler calls `.remove()` on
                            // the element, the data is cleared, leaving `result`
                            // undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling
                    // surrogate (focus or blur), assume that the surrogate already
                    // propagated from triggering the native event and prevent that
                    // from happening again here.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order.
                // Fire an inner synthetic event with the original arguments.
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(saved[0], saved.slice(1), this)
                    });
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
            // Create target properties
            this.target = src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        // Support: IE 11+
        // Attach a single focusin/focusout handler on the document while someone wants focus/blur.
        // This is because the former are synchronous in IE while the latter are async. In other
        // browsers, all those handlers are invoked synchronously.
        function focusMappedHandler(nativeEvent) {
            // `eventHandle` would already wrap the event, but we need to change the `type` here.
            var event = jQuery.event.fix(nativeEvent);
            event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
            event.isSimulated = true;
            // focus/blur don't bubble while focusin/focusout do; simulate the former by only
            // invoking the handler at the lower level.
            if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
            // `jQuery.event.add`, so event handle will already have been set
            // by this point.
            dataPriv.get(this, "handle")(event);
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (isIE) this.addEventListener(delegateType, focusMappedHandler);
                else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                if (isIE) this.removeEventListener(delegateType, focusMappedHandler);
                else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11+
    // In IE using regex groups here causes severe slowdowns.
    rnoInnerhtml = /<script|<style|<link/i;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var type, i, l, events = dataPriv.get(src, "events");
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (events) {
            dataPriv.remove(dest, "handle events");
            for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) dataUser.set(dest, jQuery.extend({}, dataUser.get(src)));
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (isIE && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)// Support: IE <=11+
                // IE fails to set the defaultValue to the correct value when
                // cloning textareas.
                if (nodeName(destElements[i], "textarea")) destElements[i].defaultValue = srcElements[i].defaultValue;
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                push.apply(ret, elems);
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    function getStyles(elem) {
        // Support: IE <=11+ (trac-14150)
        // In IE popup's `window` is the opener window which makes `window.getComputedStyle( elem )`
        // break. Using `elem.ownerDocument.defaultView` avoids the issue.
        var view = elem.ownerDocument.defaultView;
        // `document.implementation.createHTMLDocument( "" )` has a `null` `defaultView`
        // property; check `defaultView` truthiness to fallback to window in such a case.
        if (!view) view = window1;
        return view.getComputedStyle(elem);
    }
    // A method for quickly swapping in/out CSS properties to get correct calculations.
    function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    }
    function curCSS(elem, name, computed) {
        var ret, isCustomProp = rcustomProp.test(name);
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for `.css('--customProperty')` (gh-3144)
        if (computed) {
            // A fallback to direct property access is needed as `computed`, being
            // the output of `getComputedStyle`, contains camelCased keys and
            // `getPropertyValue` requires kebab-case ones.
            //
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105 - 135+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
        }
        return ret !== undefined ? // Support: IE <=9 - 11+
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document$1.createElement("div").style;
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped vendor prefixed property
    function finalPropName(name) {
        if (name in emptyStyle) return name;
        return vendorPropName(name) || name;
    }
    var reliableTrDimensionsVal, reliableColDimensionsVal, table = document$1.createElement("table");
    // Executing table tests requires only one layout, so they're executed
    // at the same time to save the second computation.
    function computeTableStyleTests() {
        if (// This is a singleton, we need to execute it only once
        !table || // Finish early in limited (non-browser) environments
        !table.style) return;
        var trStyle, col = document$1.createElement("col"), tr = document$1.createElement("tr"), td = document$1.createElement("td");
        table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0";
        tr.style.cssText = "box-sizing:content-box;border:1px solid;height:1px";
        td.style.cssText = "height:9px;width:9px;padding:0";
        col.span = 2;
        documentElement$1.appendChild(table).appendChild(col).parentNode.appendChild(tr).appendChild(td).parentNode.appendChild(td.cloneNode(true));
        // Don't run until window is visible
        if (table.offsetWidth === 0) {
            documentElement$1.removeChild(table);
            return;
        }
        trStyle = window1.getComputedStyle(tr);
        // Support: Firefox 135+
        // Firefox always reports computed width as if `span` was 1.
        // Support: Safari 18.3+
        // In Safari, computed width for columns is always 0.
        // In both these browsers, using `offsetWidth` solves the issue.
        // Support: IE 11+
        // In IE, `<col>` computed width is `"auto"` unless `width` is set
        // explicitly via CSS so measurements there remain incorrect. Because of
        // the lack of a proper workaround, we accept this limitation, treating
        // IE as passing the test.
        reliableColDimensionsVal = isIE || Math.round(parseFloat(window1.getComputedStyle(col).width)) === 18;
        // Support: IE 10 - 11+
        // IE misreports `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Support: Firefox 70 - 135+
        // Only Firefox includes border widths
        // in computed dimensions for table rows. (gh-4529)
        reliableTrDimensionsVal = Math.round(parseFloat(trStyle.height) + parseFloat(trStyle.borderTopWidth) + parseFloat(trStyle.borderBottomWidth)) === tr.offsetHeight;
        documentElement$1.removeChild(table);
        // Nullify the table so it wouldn't be stored in the memory;
        // it will also be a sign that checks were already performed.
        table = null;
    }
    jQuery.extend(support, {
        reliableTrDimensions: function() {
            computeTableStyleTests();
            return reliableTrDimensionsVal;
        },
        reliableColDimensions: function() {
            computeTableStyleTests();
            return reliableColDimensionsVal;
        }
    });
    var cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = isIE || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        if (// Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        (val === "auto" || // Support: IE 9 - 11+
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        isIE && isBorderBox || !support.reliableColDimensions() && nodeName(elem, "col") || !support.reliableTrDimensions() && nodeName(elem, "tr")) && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If the value is a number, add `px` for certain CSS properties
                if (type === "number") value += ret && ret[3] || (isAutoPx(origName) ? "px" : "");
                // Support: IE <=9 - 11+
                // background-* props of a cloned element affect the source element (trac-8908)
                if (isIE && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Elements with `display: none` can have dimension info if
                // we invisibly show them.
                return jQuery.css(elem, "display") === "none" ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                isBorderBox = extra && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (isAutoPx(prop) ? "px" : "");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document$1.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, 13);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11+
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.set(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                // eslint-disable-next-line no-loop-func
                anim.done(function() {
                    // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = cssCamelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), percent = 1 - (remaining / animation.duration || 0), index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (typeof result.stop === "function") jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (typeof animation.opts.start === "function") animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (typeof props === "function") {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || easing || typeof speed === "function" && speed,
            duration: speed,
            easing: fn && easing || easing && typeof easing !== "function" && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (typeof opt.old === "function") opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11+
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = elem.getAttribute("tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || // href-less anchor's `tabIndex` property value is `0` and
                    // the `tabindex` attribute value: `null`. We want `-1`.
                    rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11+
    // Accessing the selectedIndex property forces the browser to respect
    // setting selected on the option. The getter ensures a default option
    // is selected when in an optgroup. ESLint rule "no-unused-expressions"
    // is disabled for this code since it considers such accessions noop.
    if (isIE) jQuery.propHooks.selected = {
        get: function(elem) {
            var parent = elem.parentNode;
            if (parent && parent.parentNode) // eslint-disable-next-line no-unused-expressions
            parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                // eslint-disable-next-line no-unused-expressions
                parent.selectedIndex;
                if (parent.parentNode) // eslint-disable-next-line no-unused-expressions
                parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self;
            if (typeof value === "function") return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean") return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                // Toggle individual class names
                self = jQuery(this);
                for(i = 0; i < classNames.length; i++){
                    className = classNames[i];
                    // Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                }
            });
            return this;
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = typeof value === "function";
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        if (option.selected && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        if (option.selected = jQuery.inArray(jQuery(option).val(), values) > -1) optionSet = true;
                    }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    if (isIE) jQuery.valHooks.option = {
        get: function(elem) {
            var val = elem.getAttribute("value");
            return val != null ? val : // Support: IE <=10 - 11+
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse(jQuery.text(elem));
        }
    };
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
    });
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document$1
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document$1;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document$1)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && typeof elem[type] === "function" && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11+
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = typeof valueOrFunction === "function" ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document$1.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (typeof func === "function") {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))// Support: IE 11+
                            // `getResponseHeader( key )` in IE doesn't combine all header
                            // values for the provided key into a single result with values
                            // joined by commas as other browsers do. Instead, it returns
                            // them on separate lines.
                            responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document$1.createElement("a");
                // Support: IE <=8 - 11+
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11+
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an ESM-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted.
            // Handle the null callback placeholder.
            if (typeof data === "function" || data === null) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            scriptAttrs: options.crossOrigin ? {
                "crossOrigin": options.crossOrigin
            } : undefined,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (typeof html === "function") html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (typeof html === "function") return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = typeof html === "function";
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        return new window1.XMLHttpRequest();
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200
    };
    jQuery.ajaxTransport(function(options) {
        var callback;
        return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                            xhr.status, xhr.statusText);
                            else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") === "text" ? {
                                text: xhr.responseText
                            } : {
                                binary: xhr.response
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                xhr.onabort = xhr.onerror = xhr.ontimeout = callback("error");
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    function canUseScriptTag(s) {
        // A script tag can only be used for async, cross domain or forced-by-attrs requests.
        // Requests with headers cannot use a script tag. However, when both `scriptAttrs` &
        // `headers` options are specified, both are impossible to satisfy together; we
        // prefer `scriptAttrs` then.
        // Sync requests remain handled differently to preserve strict script ordering.
        return s.scriptAttrs || !s.headers && (s.crossDomain || // When dealing with JSONP (`s.dataTypes` include "json" then)
        // don't use a script tag so that error responses still may have
        // `responseJSON` set. Continue using a script tag for JSONP requests that:
        //   * are cross-domain as AJAX requests won't work without a CORS setup
        //   * have `scriptAttrs` set as that's a script-only functionality
        // Note that this means JSONP requests violate strict CSP script-src settings.
        // A proper solution is to migrate from using JSONP to a CORS setup.
        s.async && jQuery.inArray("json", s.dataTypes) < 0);
    }
    // Install script dataType. Don't specify `contents.script` so that an explicit
    // `dataType: "script"` is required (see gh-2432, gh-4822)
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        // These types of requests are handled via a script tag
        // so force their methods to GET.
        if (canUseScriptTag(s)) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        if (canUseScriptTag(s)) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document$1.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Get callback name, remembering preexisting value associated with it
        callbackName = s.jsonpCallback = typeof s.jsonpCallback === "function" ? s.jsonpCallback() : s.jsonpCallback;
        // Insert callback into url or form data
        if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        // Use data converter to retrieve json after script execution
        s.converters["script json"] = function() {
            if (!responseContainer) jQuery.error(callbackName + " was not called");
            return responseContainer[0];
        };
        // Force json dataType
        s.dataTypes[0] = "json";
        // Install callback
        overwritten = window1[callbackName];
        window1[callbackName] = function() {
            responseContainer = arguments;
        };
        // Clean-up function (fires after converters)
        jqXHR.always(function() {
            // If previous value didn't exist - remove it
            if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
            else window1[callbackName] = overwritten;
            // Save back as free
            if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback;
                // Save the callback name for future use
                oldCallbacks.push(callbackName);
            }
            // Call if it was a function and we have a response
            if (responseContainer && typeof overwritten === "function") overwritten(responseContainer[0]);
            responseContainer = overwritten = undefined;
        });
        // Delegate to script
        return "script";
    });
    jQuery.ajaxPrefilter(function(s, origOptions) {
        // Binary data needs to be passed to XHR as-is without stringification.
        if (typeof s.data !== "string" && !jQuery.isPlainObject(s.data) && !Array.isArray(s.data) && // Don't disable data processing if explicitly set by the user.
        !("processData" in origOptions)) s.processData = false;
        // `Content-Type` for requests with `FormData` bodies needs to be set
        // by the browser as it needs to append the `boundary` it generated.
        if (s.data instanceof window1.FormData) s.contentType = false;
    });
    // Argument "data" should be string of html or a TrustedHTML wrapper of obvious HTML
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string" && !isObviousHtml(data + "")) return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var parsed, scripts;
        if (!context) // Stop scripts or inline event handlers from being executed immediately
        // by using DOMParser
        context = new window1.DOMParser().parseFromString("", "text/html");
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (typeof params === "function") {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (typeof options === "function") // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11+
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && offsetParent !== doc.documentElement && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent || doc.documentElement;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 && jQuery.css(offsetParent, "position") !== "static") {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement$1;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (typeof fn !== "function") return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.expr[":"] = jQuery.expr.filters = jQuery.expr.pseudos;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, gh-557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


window.$ = window.jQuery = $4eae0a726ab50395$exports;
/*!
 * jQuery UI Widget 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: https://api.jqueryui.com/jQuery.widget/
//>>demos: https://jqueryui.com/widget/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    var widgetUuid = 0;
    var widgetHasOwnProperty = Array.prototype.hasOwnProperty;
    var widgetSlice = Array.prototype.slice;
    $.cleanData = function(orig) {
        return function(elems) {
            var events, elem, i;
            for(i = 0; (elem = elems[i]) != null; i++){
                // Only trigger remove when necessary to save time
                events = $._data(elem, "events");
                if (events && events.remove) $(elem).triggerHandler("remove");
            }
            orig(elems);
        };
    }($.cleanData);
    $.widget = function(name, base, prototype) {
        var existingConstructor, constructor, basePrototype;
        // ProxiedPrototype allows the provided prototype to remain unmodified
        // so that it can be used as a mixin for multiple widgets (#8876)
        var proxiedPrototype = {};
        var namespace = name.split(".")[0];
        name = name.split(".")[1];
        if (name === "__proto__" || name === "constructor") return $.error("Invalid widget name: " + name);
        var fullName = namespace + "-" + name;
        if (!prototype) {
            prototype = base;
            base = $.Widget;
        }
        if (Array.isArray(prototype)) prototype = $.extend.apply(null, [
            {}
        ].concat(prototype));
        // Create selector for plugin
        $.expr.pseudos[fullName.toLowerCase()] = function(elem) {
            return !!$.data(elem, fullName);
        };
        $[namespace] = $[namespace] || {};
        existingConstructor = $[namespace][name];
        constructor = $[namespace][name] = function(options, element) {
            // Allow instantiation without "new" keyword
            if (!this || !this._createWidget) return new constructor(options, element);
            // Allow instantiation without initializing for simple inheritance
            // must use "new" keyword (the code above always passes args)
            if (arguments.length) this._createWidget(options, element);
        };
        // Extend with the existing constructor to carry over any static properties
        $.extend(constructor, existingConstructor, {
            version: prototype.version,
            // Copy the object used to create the prototype in case we need to
            // redefine the widget later
            _proto: $.extend({}, prototype),
            // Track widgets that inherit from this widget in case this widget is
            // redefined after a widget inherits from it
            _childConstructors: []
        });
        basePrototype = new base();
        // We need to make the options hash a property directly on the new instance
        // otherwise we'll modify the options hash on the prototype that we're
        // inheriting from
        basePrototype.options = $.widget.extend({}, basePrototype.options);
        $.each(prototype, function(prop, value) {
            if (typeof value !== "function") {
                proxiedPrototype[prop] = value;
                return;
            }
            proxiedPrototype[prop] = function() {
                function _super() {
                    return base.prototype[prop].apply(this, arguments);
                }
                function _superApply(args) {
                    return base.prototype[prop].apply(this, args);
                }
                return function() {
                    var __super = this._super;
                    var __superApply = this._superApply;
                    var returnValue;
                    this._super = _super;
                    this._superApply = _superApply;
                    returnValue = value.apply(this, arguments);
                    this._super = __super;
                    this._superApply = __superApply;
                    return returnValue;
                };
            }();
        });
        constructor.prototype = $.widget.extend(basePrototype, {
            // TODO: remove support for widgetEventPrefix
            // always use the name + a colon as the prefix, e.g., draggable:start
            // don't prefix for widgets that aren't DOM-based
            widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name
        }, proxiedPrototype, {
            constructor: constructor,
            namespace: namespace,
            widgetName: name,
            widgetFullName: fullName
        });
        // If this widget is being redefined then we need to find all widgets that
        // are inheriting from it and redefine all of them so that they inherit from
        // the new version of this widget. We're essentially trying to replace one
        // level in the prototype chain.
        if (existingConstructor) {
            $.each(existingConstructor._childConstructors, function(i, child) {
                var childPrototype = child.prototype;
                // Redefine the child widget using the same prototype that was
                // originally used, but inherit from the new version of the base
                $.widget(childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto);
            });
            // Remove the list of existing child constructors from the old constructor
            // so the old child constructors can be garbage collected
            delete existingConstructor._childConstructors;
        } else base._childConstructors.push(constructor);
        $.widget.bridge(name, constructor);
        return constructor;
    };
    $.widget.extend = function(target) {
        var input = widgetSlice.call(arguments, 1);
        var inputIndex = 0;
        var inputLength = input.length;
        var key;
        var value;
        for(; inputIndex < inputLength; inputIndex++)for(key in input[inputIndex]){
            value = input[inputIndex][key];
            if (widgetHasOwnProperty.call(input[inputIndex], key) && value !== undefined) {
                // Clone objects
                if ($.isPlainObject(value)) target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) : // Don't extend strings, arrays, etc. with objects
                $.widget.extend({}, value);
                else target[key] = value;
            }
        }
        return target;
    };
    $.widget.bridge = function(name, object) {
        var fullName = object.prototype.widgetFullName || name;
        $.fn[name] = function(options) {
            var isMethodCall = typeof options === "string";
            var args = widgetSlice.call(arguments, 1);
            var returnValue = this;
            if (isMethodCall) {
                // If this is an empty collection, we need to have the instance method
                // return undefined instead of the jQuery instance
                if (!this.length && options === "instance") returnValue = undefined;
                else this.each(function() {
                    var methodValue;
                    var instance = $.data(this, fullName);
                    if (options === "instance") {
                        returnValue = instance;
                        return false;
                    }
                    if (!instance) return $.error("cannot call methods on " + name + " prior to initialization; " + "attempted to call method '" + options + "'");
                    if (typeof instance[options] !== "function" || options.charAt(0) === "_") return $.error("no such method '" + options + "' for " + name + " widget instance");
                    methodValue = instance[options].apply(instance, args);
                    if (methodValue !== instance && methodValue !== undefined) {
                        returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
                        return false;
                    }
                });
            } else {
                // Allow multiple hashes to be passed on init
                if (args.length) options = $.widget.extend.apply(null, [
                    options
                ].concat(args));
                this.each(function() {
                    var instance = $.data(this, fullName);
                    if (instance) {
                        instance.option(options || {});
                        if (instance._init) instance._init();
                    } else $.data(this, fullName, new object(options, this));
                });
            }
            return returnValue;
        };
    };
    $.Widget = function() {};
    $.Widget._childConstructors = [];
    $.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            classes: {},
            disabled: false,
            // Callbacks
            create: null
        },
        _createWidget: function(options, element) {
            element = $(element || this.defaultElement || this)[0];
            this.element = $(element);
            this.uuid = widgetUuid++;
            this.eventNamespace = "." + this.widgetName + this.uuid;
            this.bindings = $();
            this.hoverable = $();
            this.focusable = $();
            this.classesElementLookup = {};
            if (element !== this) {
                $.data(element, this.widgetFullName, this);
                this._on(true, this.element, {
                    remove: function(event) {
                        if (event.target === element) this.destroy();
                    }
                });
                this.document = $(element.style ? // Element within the document
                element.ownerDocument : // Element is window or document
                element.document || element);
                this.window = $(this.document[0].defaultView || this.document[0].parentWindow);
            }
            this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options);
            this._create();
            if (this.options.disabled) this._setOptionDisabled(this.options.disabled);
            this._trigger("create", null, this._getCreateEventData());
            this._init();
        },
        _getCreateOptions: function() {
            return {};
        },
        _getCreateEventData: $.noop,
        _create: $.noop,
        _init: $.noop,
        destroy: function() {
            var that = this;
            this._destroy();
            $.each(this.classesElementLookup, function(key, value) {
                that._removeClass(value, key);
            });
            // We can probably remove the unbind calls in 2.0
            // all event bindings should go through this._on()
            this.element.off(this.eventNamespace).removeData(this.widgetFullName);
            this.widget().off(this.eventNamespace).removeAttr("aria-disabled");
            // Clean up events and states
            this.bindings.off(this.eventNamespace);
        },
        _destroy: $.noop,
        widget: function() {
            return this.element;
        },
        option: function(key, value) {
            var options = key;
            var parts;
            var curOption;
            var i;
            if (arguments.length === 0) // Don't return a reference to the internal hash
            return $.widget.extend({}, this.options);
            if (typeof key === "string") {
                // Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
                options = {};
                parts = key.split(".");
                key = parts.shift();
                if (parts.length) {
                    curOption = options[key] = $.widget.extend({}, this.options[key]);
                    for(i = 0; i < parts.length - 1; i++){
                        curOption[parts[i]] = curOption[parts[i]] || {};
                        curOption = curOption[parts[i]];
                    }
                    key = parts.pop();
                    if (arguments.length === 1) return curOption[key] === undefined ? null : curOption[key];
                    curOption[key] = value;
                } else {
                    if (arguments.length === 1) return this.options[key] === undefined ? null : this.options[key];
                    options[key] = value;
                }
            }
            this._setOptions(options);
            return this;
        },
        _setOptions: function(options) {
            var key;
            for(key in options)this._setOption(key, options[key]);
            return this;
        },
        _setOption: function(key, value) {
            if (key === "classes") this._setOptionClasses(value);
            this.options[key] = value;
            if (key === "disabled") this._setOptionDisabled(value);
            return this;
        },
        _setOptionClasses: function(value) {
            var classKey, elements, currentElements;
            for(classKey in value){
                currentElements = this.classesElementLookup[classKey];
                if (value[classKey] === this.options.classes[classKey] || !currentElements || !currentElements.length) continue;
                // We are doing this to create a new jQuery object because the _removeClass() call
                // on the next line is going to destroy the reference to the current elements being
                // tracked. We need to save a copy of this collection so that we can add the new classes
                // below.
                elements = $(currentElements.get());
                this._removeClass(currentElements, classKey);
                // We don't use _addClass() here, because that uses this.options.classes
                // for generating the string of classes. We want to use the value passed in from
                // _setOption(), this is the new value of the classes option which was passed to
                // _setOption(). We pass this value directly to _classes().
                elements.addClass(this._classes({
                    element: elements,
                    keys: classKey,
                    classes: value,
                    add: true
                }));
            }
        },
        _setOptionDisabled: function(value) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!value);
            // If the widget is becoming disabled, then nothing is interactive
            if (value) {
                this._removeClass(this.hoverable, null, "ui-state-hover");
                this._removeClass(this.focusable, null, "ui-state-focus");
            }
        },
        enable: function() {
            return this._setOptions({
                disabled: false
            });
        },
        disable: function() {
            return this._setOptions({
                disabled: true
            });
        },
        _classes: function(options) {
            var full = [];
            var that = this;
            options = $.extend({
                element: this.element,
                classes: this.options.classes || {}
            }, options);
            function bindRemoveEvent() {
                var nodesToBind = [];
                options.element.each(function(_, element) {
                    var isTracked = $.map(that.classesElementLookup, function(elements) {
                        return elements;
                    }).some(function(elements) {
                        return elements.is(element);
                    });
                    if (!isTracked) nodesToBind.push(element);
                });
                that._on($(nodesToBind), {
                    remove: "_untrackClassesElement"
                });
            }
            function processClassString(classes, checkOption) {
                var current, i;
                for(i = 0; i < classes.length; i++){
                    current = that.classesElementLookup[classes[i]] || $();
                    if (options.add) {
                        bindRemoveEvent();
                        current = $($.uniqueSort(current.get().concat(options.element.get())));
                    } else current = $(current.not(options.element).get());
                    that.classesElementLookup[classes[i]] = current;
                    full.push(classes[i]);
                    if (checkOption && options.classes[classes[i]]) full.push(options.classes[classes[i]]);
                }
            }
            if (options.keys) processClassString(options.keys.match(/\S+/g) || [], true);
            if (options.extra) processClassString(options.extra.match(/\S+/g) || []);
            return full.join(" ");
        },
        _untrackClassesElement: function(event) {
            var that = this;
            $.each(that.classesElementLookup, function(key, value) {
                if ($.inArray(event.target, value) !== -1) that.classesElementLookup[key] = $(value.not(event.target).get());
            });
            this._off($(event.target));
        },
        _removeClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, false);
        },
        _addClass: function(element, keys, extra) {
            return this._toggleClass(element, keys, extra, true);
        },
        _toggleClass: function(element, keys, extra, add) {
            add = typeof add === "boolean" ? add : extra;
            var shift = typeof element === "string" || element === null, options = {
                extra: shift ? keys : extra,
                keys: shift ? element : keys,
                element: shift ? this.element : element,
                add: add
            };
            options.element.toggleClass(this._classes(options), add);
            return this;
        },
        _on: function(suppressDisabledCheck, element, handlers) {
            var delegateElement;
            var instance = this;
            // No suppressDisabledCheck flag, shuffle arguments
            if (typeof suppressDisabledCheck !== "boolean") {
                handlers = element;
                element = suppressDisabledCheck;
                suppressDisabledCheck = false;
            }
            // No element argument, shuffle and use this.element
            if (!handlers) {
                handlers = element;
                element = this.element;
                delegateElement = this.widget();
            } else {
                element = delegateElement = $(element);
                this.bindings = this.bindings.add(element);
            }
            $.each(handlers, function(event, handler) {
                function handlerProxy() {
                    // Allow widgets to customize the disabled handling
                    // - disabled as an array instead of boolean
                    // - disabled class as method for disabling individual parts
                    if (!suppressDisabledCheck && (instance.options.disabled === true || $(this).hasClass("ui-state-disabled"))) return;
                    return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
                }
                // Copy the guid so direct unbinding works
                if (typeof handler !== "string") handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++;
                var match = event.match(/^([\w:-]*)\s*(.*)$/);
                var eventName = match[1] + instance.eventNamespace;
                var selector = match[2];
                if (selector) delegateElement.on(eventName, selector, handlerProxy);
                else element.on(eventName, handlerProxy);
            });
        },
        _off: function(element, eventName) {
            eventName = (eventName || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace;
            element.off(eventName);
            // Clear the stack to avoid memory leaks (#10056)
            this.bindings = $(this.bindings.not(element).get());
            this.focusable = $(this.focusable.not(element).get());
            this.hoverable = $(this.hoverable.not(element).get());
        },
        _delay: function(handler, delay) {
            function handlerProxy() {
                return (typeof handler === "string" ? instance[handler] : handler).apply(instance, arguments);
            }
            var instance = this;
            return setTimeout(handlerProxy, delay || 0);
        },
        _hoverable: function(element) {
            this.hoverable = this.hoverable.add(element);
            this._on(element, {
                mouseenter: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-hover");
                },
                mouseleave: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-hover");
                }
            });
        },
        _focusable: function(element) {
            this.focusable = this.focusable.add(element);
            this._on(element, {
                focusin: function(event) {
                    this._addClass($(event.currentTarget), null, "ui-state-focus");
                },
                focusout: function(event) {
                    this._removeClass($(event.currentTarget), null, "ui-state-focus");
                }
            });
        },
        _trigger: function(type, event, data) {
            var prop, orig;
            var callback = this.options[type];
            data = data || {};
            event = $.Event(event);
            event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase();
            // The original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[0];
            // Copy original event properties over to the new event
            orig = event.originalEvent;
            if (orig) {
                for(prop in orig)if (!(prop in event)) event[prop] = orig[prop];
            }
            this.element.trigger(event, data);
            return !(typeof callback === "function" && callback.apply(this.element[0], [
                event
            ].concat(data)) === false || event.isDefaultPrevented());
        }
    };
    $.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function(method, defaultEffect) {
        $.Widget.prototype["_" + method] = function(element, options, callback) {
            if (typeof options === "string") options = {
                effect: options
            };
            var hasOptions;
            var effectName = !options ? method : options === true || typeof options === "number" ? defaultEffect : options.effect || defaultEffect;
            options = options || {};
            if (typeof options === "number") options = {
                duration: options
            };
            else if (options === true) options = {};
            hasOptions = !$.isEmptyObject(options);
            options.complete = callback;
            if (options.delay) element.delay(options.delay);
            if (hasOptions && $.effects && $.effects.effect[effectName]) element[method](options);
            else if (effectName !== method && element[effectName]) element[effectName](options.duration, options.easing, callback);
            else element.queue(function(next) {
                $(this)[method]();
                if (callback) callback.call(element[0]);
                next();
            });
        };
    });
    return $.widget;
});


/*!
 * jQuery UI Mouse 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: https://api.jqueryui.com/mouse/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    var mouseHandled = false;
    $(document).on("mouseup", function() {
        mouseHandled = false;
    });
    return $.widget("ui.mouse", {
        version: "1.14.2",
        options: {
            cancel: "input, textarea, button, select, option",
            distance: 1,
            delay: 0
        },
        _mouseInit: function() {
            var that = this;
            this.element.on("mousedown." + this.widgetName, function(event) {
                return that._mouseDown(event);
            }).on("click." + this.widgetName, function(event) {
                if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
                    $.removeData(event.target, that.widgetName + ".preventClickEvent");
                    event.stopImmediatePropagation();
                    return false;
                }
            });
            this.started = false;
        },
        // TODO: make sure destroying one instance of mouse doesn't mess with
        // other instances of mouse
        _mouseDestroy: function() {
            this.element.off("." + this.widgetName);
            if (this._mouseMoveDelegate) this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate);
        },
        _mouseDown: function(event) {
            // don't let more than one widget handle mouseStart
            if (mouseHandled) return;
            this._mouseMoved = false;
            // We may have missed mouseup (out of window)
            if (this._mouseStarted) this._mouseUp(event);
            this._mouseDownEvent = event;
            var that = this, btnIsLeft = event.which === 1, elIsCancel = typeof this.options.cancel === "string" ? $(event.target).closest(this.options.cancel).length : false;
            if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) return true;
            this.mouseDelayMet = !this.options.delay;
            if (!this.mouseDelayMet) this._mouseDelayTimer = setTimeout(function() {
                that.mouseDelayMet = true;
            }, this.options.delay);
            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = this._mouseStart(event) !== false;
                if (!this._mouseStarted) {
                    event.preventDefault();
                    return true;
                }
            }
            // Click event may never have fired (Gecko & Opera)
            if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) $.removeData(event.target, this.widgetName + ".preventClickEvent");
            // These delegates are required to keep context
            this._mouseMoveDelegate = function(event) {
                return that._mouseMove(event);
            };
            this._mouseUpDelegate = function(event) {
                return that._mouseUp(event);
            };
            this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate);
            event.preventDefault();
            mouseHandled = true;
            return true;
        },
        _mouseMove: function(event) {
            // Only check for mouseups outside the document if you've moved inside the document
            // at least once.
            if (this._mouseMoved && !event.which) {
                // Support: Safari <=8 - 9
                // Safari sets which to 0 if you press any of the following keys
                // during a drag (#14461)
                if (event.originalEvent.altKey || event.originalEvent.ctrlKey || event.originalEvent.metaKey || event.originalEvent.shiftKey) this.ignoreMissingWhich = true;
                else if (!this.ignoreMissingWhich) return this._mouseUp(event);
            }
            if (event.which || event.button) this._mouseMoved = true;
            if (this._mouseStarted) {
                this._mouseDrag(event);
                return event.preventDefault();
            }
            if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
                this._mouseStarted = this._mouseStart(this._mouseDownEvent, event) !== false;
                if (this._mouseStarted) this._mouseDrag(event);
                else this._mouseUp(event);
            }
            return !this._mouseStarted;
        },
        _mouseUp: function(event) {
            this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate);
            if (this._mouseStarted) {
                this._mouseStarted = false;
                if (event.target === this._mouseDownEvent.target) $.data(event.target, this.widgetName + ".preventClickEvent", true);
                this._mouseStop(event);
            }
            if (this._mouseDelayTimer) {
                clearTimeout(this._mouseDelayTimer);
                delete this._mouseDelayTimer;
            }
            this.ignoreMissingWhich = false;
            mouseHandled = false;
            event.preventDefault();
        },
        _mouseDistanceMet: function(event) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - event.pageX), Math.abs(this._mouseDownEvent.pageY - event.pageY)) >= this.options.distance;
        },
        _mouseDelayMet: function() {
            return this.mouseDelayMet;
        },
        // These are placeholder methods, to be overriden by extending plugin
        _mouseStart: function() {},
        _mouseDrag: function() {},
        _mouseStop: function() {},
        _mouseCapture: function() {
            return true;
        }
    });
});


/*!
 * jQuery UI :data 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: https://api.jqueryui.com/data-selector/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.extend($.expr.pseudos, {
        data: $.expr.createPseudo(function(dataName) {
            return function(elem) {
                return !!$.data(elem, dataName);
            };
        })
    });
});


(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    // $.ui.plugin is deprecated. Use $.widget() extensions instead.
    return $.ui.plugin = {
        add: function(module, option, set) {
            var i, proto = $.ui[module].prototype;
            for(i in set){
                proto.plugins[i] = proto.plugins[i] || [];
                proto.plugins[i].push([
                    option,
                    set[i]
                ]);
            }
        },
        call: function(instance, name, args, allowDisconnected) {
            var i, set = instance.plugins[name];
            if (!set) return;
            if (!allowDisconnected && (!instance.element[0].parentNode || instance.element[0].parentNode.nodeType === 11)) return;
            for(i = 0; i < set.length; i++)if (instance.options[set[i][0]]) set[i][1].apply(instance.element, args);
        }
    };
});


/*!
 * jQuery UI Scroll Parent 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: https://api.jqueryui.com/scrollParent/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./version"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.fn.scrollParent = function(includeHidden) {
        var position = this.css("position"), excludeStaticParent = position === "absolute", overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/, scrollParent = this.parents().filter(function() {
            var parent = $(this);
            if (excludeStaticParent && parent.css("position") === "static") return false;
            return overflowRegex.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
        }).eq(0);
        return position === "fixed" || !scrollParent.length ? $(this[0].ownerDocument || document) : scrollParent;
    };
});


/*!
 * jQuery UI Draggable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Draggable
//>>group: Interactions
//>>description: Enables dragging functionality for any element.
//>>docs: https://api.jqueryui.com/draggable/
//>>demos: https://jqueryui.com/draggable/
//>>css.structure: ../../themes/base/draggable.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./mouse",
        "../data",
        "../plugin",
        "../scroll-parent",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.widget("ui.draggable", $.ui.mouse, {
        version: "1.14.2",
        widgetEventPrefix: "drag",
        options: {
            addClasses: true,
            appendTo: "parent",
            axis: false,
            connectToSortable: false,
            containment: false,
            cursor: "auto",
            cursorAt: false,
            grid: false,
            handle: false,
            helper: "original",
            iframeFix: false,
            opacity: false,
            refreshPositions: false,
            revert: false,
            revertDuration: 500,
            scope: "default",
            scroll: true,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            snap: false,
            snapMode: "both",
            snapTolerance: 20,
            stack: false,
            zIndex: false,
            // Callbacks
            drag: null,
            start: null,
            stop: null
        },
        _create: function() {
            if (this.options.helper === "original") this._setPositionRelative();
            if (this.options.addClasses) this._addClass("ui-draggable");
            this._setHandleClassName();
            this._mouseInit();
        },
        _setOption: function(key, value) {
            this._super(key, value);
            if (key === "handle") {
                this._removeHandleClassName();
                this._setHandleClassName();
            }
        },
        _destroy: function() {
            if ((this.helper || this.element).is(".ui-draggable-dragging")) {
                this.destroyOnClear = true;
                return;
            }
            this._removeHandleClassName();
            this._mouseDestroy();
        },
        _mouseCapture: function(event) {
            var o = this.options;
            // Among others, prevent a drag on a resizable-handle
            if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) return false;
            //Quit if we're not on a valid handle
            this.handle = this._getHandle(event);
            if (!this.handle) return false;
            this._blurActiveElement(event);
            this._blockFrames(o.iframeFix === true ? "iframe" : o.iframeFix);
            return true;
        },
        _blockFrames: function(selector) {
            this.iframeBlocks = this.document.find(selector).map(function() {
                var iframe = $(this);
                return $("<div>").css("position", "absolute").appendTo(iframe.parent()).outerWidth(iframe.outerWidth()).outerHeight(iframe.outerHeight()).offset(iframe.offset())[0];
            });
        },
        _unblockFrames: function() {
            if (this.iframeBlocks) {
                this.iframeBlocks.remove();
                delete this.iframeBlocks;
            }
        },
        _blurActiveElement: function(event) {
            var activeElement = this.document[0].activeElement, target = $(event.target);
            // Don't blur if the event occurred on an element that is within
            // the currently focused element
            // See #10527, #12472
            if (target.closest(activeElement).length) return;
            // Blur any element that currently has focus, see #4261
            $(activeElement).trigger("blur");
        },
        _mouseStart: function(event) {
            var o = this.options;
            //Create and append the visible helper
            this.helper = this._createHelper(event);
            this._addClass(this.helper, "ui-draggable-dragging");
            //Cache the helper size
            this._cacheHelperProportions();
            //If ddmanager is used for droppables, set the global draggable
            if ($.ui.ddmanager) $.ui.ddmanager.current = this;
            /*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */ //Cache the margins of the original element
            this._cacheMargins();
            //Store the helper's css position
            this.cssPosition = this.helper.css("position");
            this.scrollParent = this.helper.scrollParent(true);
            this.offsetParent = this.helper.offsetParent();
            this.hasFixedAncestor = this.helper.parents().filter(function() {
                return $(this).css("position") === "fixed";
            }).length > 0;
            //The element's absolute position on the page minus margins
            this.positionAbs = this.element.offset();
            this._refreshOffsets(event);
            //Generate the original position
            this.originalPosition = this.position = this._generatePosition(event, false);
            this.originalPageX = event.pageX;
            this.originalPageY = event.pageY;
            //Adjust the mouse offset relative to the helper if "cursorAt" is supplied
            if (o.cursorAt) this._adjustOffsetFromHelper(o.cursorAt);
            //Set a containment if given in the options
            this._setContainment();
            //Trigger event + callbacks
            if (this._trigger("start", event) === false) {
                this._clear();
                return false;
            }
            //Recache the helper size
            this._cacheHelperProportions();
            //Prepare the droppable offsets
            if ($.ui.ddmanager && !o.dropBehaviour) $.ui.ddmanager.prepareOffsets(this, event);
            // Execute the drag once - this causes the helper not to be visible before getting its
            // correct position
            this._mouseDrag(event, true);
            // If the ddmanager is used for droppables, inform the manager that dragging has started
            // (see #5003)
            if ($.ui.ddmanager) $.ui.ddmanager.dragStart(this, event);
            return true;
        },
        _refreshOffsets: function(event) {
            this.offset = {
                top: this.positionAbs.top - this.margins.top,
                left: this.positionAbs.left - this.margins.left,
                scroll: false,
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset()
            };
            this.offset.click = {
                left: event.pageX - this.offset.left,
                top: event.pageY - this.offset.top
            };
        },
        _mouseDrag: function(event, noPropagation) {
            // reset any necessary cached properties (see #5009)
            if (this.hasFixedAncestor) this.offset.parent = this._getParentOffset();
            //Compute the helpers position
            this.position = this._generatePosition(event, true);
            this.positionAbs = this._convertPositionTo("absolute");
            //Call plugins and callbacks and use the resulting position if something is returned
            if (!noPropagation) {
                var ui = this._uiHash();
                if (this._trigger("drag", event, ui) === false) {
                    this._mouseUp(new $.Event("mouseup", event));
                    return false;
                }
                this.position = ui.position;
            }
            this.helper[0].style.left = this.position.left + "px";
            this.helper[0].style.top = this.position.top + "px";
            if ($.ui.ddmanager) $.ui.ddmanager.drag(this, event);
            return false;
        },
        _mouseStop: function(event) {
            //If we are using droppables, inform the manager about the drop
            var that = this, dropped = false;
            if ($.ui.ddmanager && !this.options.dropBehaviour) dropped = $.ui.ddmanager.drop(this, event);
            //if a drop comes from outside (a sortable)
            if (this.dropped) {
                dropped = this.dropped;
                this.dropped = false;
            }
            if (this.options.revert === "invalid" && !dropped || this.options.revert === "valid" && dropped || this.options.revert === true || typeof this.options.revert === "function" && this.options.revert.call(this.element, dropped)) $(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
                if (that._trigger("stop", event) !== false) that._clear();
            });
            else if (this._trigger("stop", event) !== false) this._clear();
            return false;
        },
        _mouseUp: function(event) {
            this._unblockFrames();
            // If the ddmanager is used for droppables, inform the manager that dragging has stopped
            // (see #5003)
            if ($.ui.ddmanager) $.ui.ddmanager.dragStop(this, event);
            // Only need to focus if the event occurred on the draggable itself, see #10527
            if (this.handleElement.is(event.target)) // The interaction is over; whether or not the click resulted in a drag,
            // focus the element
            this.element.trigger("focus");
            return $.ui.mouse.prototype._mouseUp.call(this, event);
        },
        cancel: function() {
            if (this.helper.is(".ui-draggable-dragging")) this._mouseUp(new $.Event("mouseup", {
                target: this.element[0]
            }));
            else this._clear();
            return this;
        },
        _getHandle: function(event) {
            return this.options.handle ? !!$(event.target).closest(this.element.find(this.options.handle)).length : true;
        },
        _setHandleClassName: function() {
            this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element;
            this._addClass(this.handleElement, "ui-draggable-handle");
        },
        _removeHandleClassName: function() {
            this._removeClass(this.handleElement, "ui-draggable-handle");
        },
        _createHelper: function(event) {
            var o = this.options, helperIsFunction = typeof o.helper === "function", helper = helperIsFunction ? $(o.helper.apply(this.element[0], [
                event
            ])) : o.helper === "clone" ? this.element.clone().removeAttr("id") : this.element;
            if (!helper.parents("body").length) helper.appendTo(o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo);
            // https://bugs.jqueryui.com/ticket/9446
            // a helper function can return the original element
            // which wouldn't have been set to relative in _create
            if (helperIsFunction && helper[0] === this.element[0]) this._setPositionRelative();
            if (helper[0] !== this.element[0] && !/(fixed|absolute)/.test(helper.css("position"))) helper.css("position", "absolute");
            return helper;
        },
        _setPositionRelative: function() {
            if (!/^(?:r|a|f)/.test(this.element.css("position"))) this.element[0].style.position = "relative";
        },
        _adjustOffsetFromHelper: function(obj) {
            if (typeof obj === "string") obj = obj.split(" ");
            if (Array.isArray(obj)) obj = {
                left: +obj[0],
                top: +obj[1] || 0
            };
            if ("left" in obj) this.offset.click.left = obj.left + this.margins.left;
            if ("right" in obj) this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
            if ("top" in obj) this.offset.click.top = obj.top + this.margins.top;
            if ("bottom" in obj) this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
        },
        _isRootNode: function(element) {
            return /(html|body)/i.test(element.tagName) || element === this.document[0];
        },
        _getParentOffset: function() {
            //Get the offsetParent and cache its position
            var po = this.offsetParent.offset(), document = this.document[0];
            // This is a special case where we need to modify a offset calculated on start, since the
            // following happened:
            // 1. The position of the helper is absolute, so it's position is calculated based on the
            // next positioned parent
            // 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
            // the document, which means that the scroll is included in the initial calculation of the
            // offset of the parent, and never recalculated upon drag
            if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
                po.left += this.scrollParent.scrollLeft();
                po.top += this.scrollParent.scrollTop();
            }
            if (this._isRootNode(this.offsetParent[0])) po = {
                top: 0,
                left: 0
            };
            return {
                top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            };
        },
        _getRelativeOffset: function() {
            if (this.cssPosition !== "relative") return {
                top: 0,
                left: 0
            };
            var p = this.element.position(), scrollIsRootNode = this._isRootNode(this.scrollParent[0]);
            return {
                top: p.top - (parseInt(this.helper.css("top"), 10) || 0) + (!scrollIsRootNode ? this.scrollParent.scrollTop() : 0),
                left: p.left - (parseInt(this.helper.css("left"), 10) || 0) + (!scrollIsRootNode ? this.scrollParent.scrollLeft() : 0)
            };
        },
        _cacheMargins: function() {
            this.margins = {
                left: parseInt(this.element.css("marginLeft"), 10) || 0,
                top: parseInt(this.element.css("marginTop"), 10) || 0,
                right: parseInt(this.element.css("marginRight"), 10) || 0,
                bottom: parseInt(this.element.css("marginBottom"), 10) || 0
            };
        },
        _cacheHelperProportions: function() {
            this.helperProportions = {
                width: this.helper.outerWidth(),
                height: this.helper.outerHeight()
            };
        },
        _setContainment: function() {
            var isUserScrollable, c, ce, o = this.options, document = this.document[0];
            this.relativeContainer = null;
            if (!o.containment) {
                this.containment = null;
                return;
            }
            if (o.containment === "window") {
                this.containment = [
                    $(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
                    $(window).scrollTop() - this.offset.relative.top - this.offset.parent.top,
                    $(window).scrollLeft() + $(window).width() - this.helperProportions.width - this.margins.left,
                    $(window).scrollTop() + ($(window).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
                ];
                return;
            }
            if (o.containment === "document") {
                this.containment = [
                    0,
                    0,
                    $(document).width() - this.helperProportions.width - this.margins.left,
                    ($(document).height() || document.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
                ];
                return;
            }
            if (o.containment.constructor === Array) {
                this.containment = o.containment;
                return;
            }
            if (o.containment === "parent") o.containment = this.helper[0].parentNode;
            c = $(o.containment);
            ce = c[0];
            if (!ce) return;
            isUserScrollable = /(scroll|auto)/.test(c.css("overflow"));
            this.containment = [
                (parseInt(c.css("borderLeftWidth"), 10) || 0) + (parseInt(c.css("paddingLeft"), 10) || 0),
                (parseInt(c.css("borderTopWidth"), 10) || 0) + (parseInt(c.css("paddingTop"), 10) || 0),
                (isUserScrollable ? Math.max(ce.scrollWidth, ce.offsetWidth) : ce.offsetWidth) - (parseInt(c.css("borderRightWidth"), 10) || 0) - (parseInt(c.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right,
                (isUserScrollable ? Math.max(ce.scrollHeight, ce.offsetHeight) : ce.offsetHeight) - (parseInt(c.css("borderBottomWidth"), 10) || 0) - (parseInt(c.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom
            ];
            this.relativeContainer = c;
        },
        _convertPositionTo: function(d, pos) {
            if (!pos) pos = this.position;
            var mod = d === "absolute" ? 1 : -1, scrollIsRootNode = this._isRootNode(this.scrollParent[0]);
            return {
                top: // The absolute mouse position
                pos.top + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.relative.top * mod + // The offsetParent's offset without borders (offset + border)
                this.offset.parent.top * mod - (this.cssPosition === "fixed" ? -this.offset.scroll.top : scrollIsRootNode ? 0 : this.offset.scroll.top) * mod,
                left: // The absolute mouse position
                pos.left + // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.relative.left * mod + // The offsetParent's offset without borders (offset + border)
                this.offset.parent.left * mod - (this.cssPosition === "fixed" ? -this.offset.scroll.left : scrollIsRootNode ? 0 : this.offset.scroll.left) * mod
            };
        },
        _generatePosition: function(event, constrainPosition) {
            var containment, co, top, left, o = this.options, scrollIsRootNode = this._isRootNode(this.scrollParent[0]), pageX = event.pageX, pageY = event.pageY;
            // Cache the scroll
            if (!scrollIsRootNode || !this.offset.scroll) this.offset.scroll = {
                top: this.scrollParent.scrollTop(),
                left: this.scrollParent.scrollLeft()
            };
            /*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */ // If we are not dragging yet, we won't check for options
            if (constrainPosition) {
                if (this.containment) {
                    if (this.relativeContainer) {
                        co = this.relativeContainer.offset();
                        containment = [
                            this.containment[0] + co.left,
                            this.containment[1] + co.top,
                            this.containment[2] + co.left,
                            this.containment[3] + co.top
                        ];
                    } else containment = this.containment;
                    if (event.pageX - this.offset.click.left < containment[0]) pageX = containment[0] + this.offset.click.left;
                    if (event.pageY - this.offset.click.top < containment[1]) pageY = containment[1] + this.offset.click.top;
                    if (event.pageX - this.offset.click.left > containment[2]) pageX = containment[2] + this.offset.click.left;
                    if (event.pageY - this.offset.click.top > containment[3]) pageY = containment[3] + this.offset.click.top;
                }
                if (o.grid) {
                    //Check for grid elements set to 0 to prevent divide by 0 error causing invalid
                    // argument errors in IE (see ticket #6950)
                    top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
                    pageY = containment ? top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3] ? top : top - this.offset.click.top >= containment[1] ? top - o.grid[1] : top + o.grid[1] : top;
                    left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
                    pageX = containment ? left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2] ? left : left - this.offset.click.left >= containment[0] ? left - o.grid[0] : left + o.grid[0] : left;
                }
                if (o.axis === "y") pageX = this.originalPageX;
                if (o.axis === "x") pageY = this.originalPageY;
            }
            return {
                top: // The absolute mouse position
                pageY - // Click offset (relative to the element)
                this.offset.click.top - // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.relative.top - // The offsetParent's offset without borders (offset + border)
                this.offset.parent.top + (this.cssPosition === "fixed" ? -this.offset.scroll.top : scrollIsRootNode ? 0 : this.offset.scroll.top),
                left: // The absolute mouse position
                pageX - // Click offset (relative to the element)
                this.offset.click.left - // Only for relative positioned nodes: Relative offset from element to offset parent
                this.offset.relative.left - // The offsetParent's offset without borders (offset + border)
                this.offset.parent.left + (this.cssPosition === "fixed" ? -this.offset.scroll.left : scrollIsRootNode ? 0 : this.offset.scroll.left)
            };
        },
        _clear: function() {
            this._removeClass(this.helper, "ui-draggable-dragging");
            if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) this.helper.remove();
            this.helper = null;
            this.cancelHelperRemoval = false;
            if (this.destroyOnClear) this.destroy();
        },
        // From now on bulk stuff - mainly helpers
        _trigger: function(type, event, ui) {
            ui = ui || this._uiHash();
            $.ui.plugin.call(this, type, [
                event,
                ui,
                this
            ], true);
            // Absolute position and offset (see #6884 ) have to be recalculated after plugins
            if (/^(drag|start|stop)/.test(type)) {
                this.positionAbs = this._convertPositionTo("absolute");
                ui.offset = this.positionAbs;
            }
            return $.Widget.prototype._trigger.call(this, type, event, ui);
        },
        plugins: {},
        _uiHash: function() {
            return {
                helper: this.helper,
                position: this.position,
                originalPosition: this.originalPosition,
                offset: this.positionAbs
            };
        }
    });
    $.ui.plugin.add("draggable", "connectToSortable", {
        start: function(event, ui, draggable) {
            var uiSortable = $.extend({}, ui, {
                item: draggable.element
            });
            draggable.sortables = [];
            $(draggable.options.connectToSortable).each(function() {
                var sortable = $(this).sortable("instance");
                if (sortable && !sortable.options.disabled) {
                    draggable.sortables.push(sortable);
                    // RefreshPositions is called at drag start to refresh the containerCache
                    // which is used in drag. This ensures it's initialized and synchronized
                    // with any changes that might have happened on the page since initialization.
                    sortable.refreshPositions();
                    sortable._trigger("activate", event, uiSortable);
                }
            });
        },
        stop: function(event, ui, draggable) {
            var uiSortable = $.extend({}, ui, {
                item: draggable.element
            });
            draggable.cancelHelperRemoval = false;
            $.each(draggable.sortables, function() {
                var sortable = this;
                if (sortable.isOver) {
                    sortable.isOver = 0;
                    // Allow this sortable to handle removing the helper
                    draggable.cancelHelperRemoval = true;
                    sortable.cancelHelperRemoval = false;
                    // Use _storedCSS To restore properties in the sortable,
                    // as this also handles revert (#9675) since the draggable
                    // may have modified them in unexpected ways (#8809)
                    sortable._storedCSS = {
                        position: sortable.placeholder.css("position"),
                        top: sortable.placeholder.css("top"),
                        left: sortable.placeholder.css("left")
                    };
                    sortable._mouseStop(event);
                    // Once drag has ended, the sortable should return to using
                    // its original helper, not the shared helper from draggable
                    sortable.options.helper = sortable.options._helper;
                } else {
                    // Prevent this Sortable from removing the helper.
                    // However, don't set the draggable to remove the helper
                    // either as another connected Sortable may yet handle the removal.
                    sortable.cancelHelperRemoval = true;
                    sortable._trigger("deactivate", event, uiSortable);
                }
            });
        },
        drag: function(event, ui, draggable) {
            $.each(draggable.sortables, function() {
                var innermostIntersecting = false, sortable = this;
                // Copy over variables that sortable's _intersectsWith uses
                sortable.positionAbs = draggable.positionAbs;
                sortable.helperProportions = draggable.helperProportions;
                sortable.offset.click = draggable.offset.click;
                if (sortable._intersectsWith(sortable.containerCache)) {
                    innermostIntersecting = true;
                    $.each(draggable.sortables, function() {
                        // Copy over variables that sortable's _intersectsWith uses
                        this.positionAbs = draggable.positionAbs;
                        this.helperProportions = draggable.helperProportions;
                        this.offset.click = draggable.offset.click;
                        if (this !== sortable && this._intersectsWith(this.containerCache) && $.contains(sortable.element[0], this.element[0])) innermostIntersecting = false;
                        return innermostIntersecting;
                    });
                }
                if (innermostIntersecting) {
                    // If it intersects, we use a little isOver variable and set it once,
                    // so that the move-in stuff gets fired only once.
                    if (!sortable.isOver) {
                        sortable.isOver = 1;
                        // Store draggable's parent in case we need to reappend to it later.
                        draggable._parent = ui.helper.parent();
                        sortable.currentItem = ui.helper.appendTo(sortable.element).data("ui-sortable-item", true);
                        // Store helper option to later restore it
                        sortable.options._helper = sortable.options.helper;
                        sortable.options.helper = function() {
                            return ui.helper[0];
                        };
                        // Fire the start events of the sortable with our passed browser event,
                        // and our own helper (so it doesn't create a new one)
                        event.target = sortable.currentItem[0];
                        sortable._mouseCapture(event, true);
                        sortable._mouseStart(event, true, true);
                        // Because the browser event is way off the new appended portlet,
                        // modify necessary variables to reflect the changes
                        sortable.offset.click.top = draggable.offset.click.top;
                        sortable.offset.click.left = draggable.offset.click.left;
                        sortable.offset.parent.left -= draggable.offset.parent.left - sortable.offset.parent.left;
                        sortable.offset.parent.top -= draggable.offset.parent.top - sortable.offset.parent.top;
                        draggable._trigger("toSortable", event);
                        // Inform draggable that the helper is in a valid drop zone,
                        // used solely in the revert option to handle "valid/invalid".
                        draggable.dropped = sortable.element;
                        // Need to refreshPositions of all sortables in the case that
                        // adding to one sortable changes the location of the other sortables (#9675)
                        $.each(draggable.sortables, function() {
                            this.refreshPositions();
                        });
                        // Hack so receive/update callbacks work (mostly)
                        draggable.currentItem = draggable.element;
                        sortable.fromOutside = draggable;
                    }
                    if (sortable.currentItem) {
                        sortable._mouseDrag(event);
                        // Copy the sortable's position because the draggable's can potentially reflect
                        // a relative position, while sortable is always absolute, which the dragged
                        // element has now become. (#8809)
                        ui.position = sortable.position;
                    }
                } else // If it doesn't intersect with the sortable, and it intersected before,
                // we fake the drag stop of the sortable, but make sure it doesn't remove
                // the helper by using cancelHelperRemoval.
                if (sortable.isOver) {
                    sortable.isOver = 0;
                    sortable.cancelHelperRemoval = true;
                    // Calling sortable's mouseStop would trigger a revert,
                    // so revert must be temporarily false until after mouseStop is called.
                    sortable.options._revert = sortable.options.revert;
                    sortable.options.revert = false;
                    sortable._trigger("out", event, sortable._uiHash(sortable));
                    sortable._mouseStop(event, true);
                    // Restore sortable behaviors that were modfied
                    // when the draggable entered the sortable area (#9481)
                    sortable.options.revert = sortable.options._revert;
                    sortable.options.helper = sortable.options._helper;
                    if (sortable.placeholder) sortable.placeholder.remove();
                    // Restore and recalculate the draggable's offset considering the sortable
                    // may have modified them in unexpected ways. (#8809, #10669)
                    ui.helper.appendTo(draggable._parent);
                    draggable._refreshOffsets(event);
                    ui.position = draggable._generatePosition(event, true);
                    draggable._trigger("fromSortable", event);
                    // Inform draggable that the helper is no longer in a valid drop zone
                    draggable.dropped = false;
                    // Need to refreshPositions of all sortables just in case removing
                    // from one sortable changes the location of other sortables (#9675)
                    $.each(draggable.sortables, function() {
                        this.refreshPositions();
                    });
                }
            });
        }
    });
    $.ui.plugin.add("draggable", "cursor", {
        start: function(event, ui, instance) {
            var t = $("body"), o = instance.options;
            if (t.css("cursor")) o._cursor = t.css("cursor");
            t.css("cursor", o.cursor);
        },
        stop: function(event, ui, instance) {
            var o = instance.options;
            if (o._cursor) $("body").css("cursor", o._cursor);
        }
    });
    $.ui.plugin.add("draggable", "opacity", {
        start: function(event, ui, instance) {
            var t = $(ui.helper), o = instance.options;
            if (t.css("opacity")) o._opacity = t.css("opacity");
            t.css("opacity", o.opacity);
        },
        stop: function(event, ui, instance) {
            var o = instance.options;
            if (o._opacity) $(ui.helper).css("opacity", o._opacity);
        }
    });
    $.ui.plugin.add("draggable", "scroll", {
        start: function(event, ui, i) {
            if (!i.scrollParentNotHidden) i.scrollParentNotHidden = i.helper.scrollParent(false);
            if (i.scrollParentNotHidden[0] !== i.document[0] && i.scrollParentNotHidden[0].tagName !== "HTML") i.overflowOffset = i.scrollParentNotHidden.offset();
        },
        drag: function(event, ui, i) {
            var o = i.options, scrolled = false, scrollParent = i.scrollParentNotHidden[0], document = i.document[0];
            if (scrollParent !== document && scrollParent.tagName !== "HTML") {
                if (!o.axis || o.axis !== "x") {
                    if (i.overflowOffset.top + scrollParent.offsetHeight - event.pageY < o.scrollSensitivity) scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
                    else if (event.pageY - i.overflowOffset.top < o.scrollSensitivity) scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
                }
                if (!o.axis || o.axis !== "y") {
                    if (i.overflowOffset.left + scrollParent.offsetWidth - event.pageX < o.scrollSensitivity) scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
                    else if (event.pageX - i.overflowOffset.left < o.scrollSensitivity) scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
                }
            } else {
                if (!o.axis || o.axis !== "x") {
                    if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
                    else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
                }
                if (!o.axis || o.axis !== "y") {
                    if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
                    else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
                }
            }
            if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) $.ui.ddmanager.prepareOffsets(i, event);
        }
    });
    $.ui.plugin.add("draggable", "snap", {
        start: function(event, ui, i) {
            var o = i.options;
            i.snapElements = [];
            $(o.snap.constructor !== String ? o.snap.items || ":data(ui-draggable)" : o.snap).each(function() {
                var $t = $(this), $o = $t.offset();
                if (this !== i.element[0]) i.snapElements.push({
                    item: this,
                    width: $t.outerWidth(),
                    height: $t.outerHeight(),
                    top: $o.top,
                    left: $o.left
                });
            });
        },
        drag: function(event, ui, inst) {
            var ts, bs, ls, rs, l, r, t, b, i, first, o = inst.options, d = o.snapTolerance, x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width, y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
            for(i = inst.snapElements.length - 1; i >= 0; i--){
                l = inst.snapElements[i].left - inst.margins.left;
                r = l + inst.snapElements[i].width;
                t = inst.snapElements[i].top - inst.margins.top;
                b = t + inst.snapElements[i].height;
                if (x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains(inst.snapElements[i].item.ownerDocument, inst.snapElements[i].item)) {
                    if (inst.snapElements[i].snapping) {
                        if (inst.options.snap.release) inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), {
                            snapItem: inst.snapElements[i].item
                        }));
                    }
                    inst.snapElements[i].snapping = false;
                    continue;
                }
                if (o.snapMode !== "inner") {
                    ts = Math.abs(t - y2) <= d;
                    bs = Math.abs(b - y1) <= d;
                    ls = Math.abs(l - x2) <= d;
                    rs = Math.abs(r - x1) <= d;
                    if (ts) ui.position.top = inst._convertPositionTo("relative", {
                        top: t - inst.helperProportions.height,
                        left: 0
                    }).top;
                    if (bs) ui.position.top = inst._convertPositionTo("relative", {
                        top: b,
                        left: 0
                    }).top;
                    if (ls) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: l - inst.helperProportions.width
                    }).left;
                    if (rs) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: r
                    }).left;
                }
                first = ts || bs || ls || rs;
                if (o.snapMode !== "outer") {
                    ts = Math.abs(t - y1) <= d;
                    bs = Math.abs(b - y2) <= d;
                    ls = Math.abs(l - x1) <= d;
                    rs = Math.abs(r - x2) <= d;
                    if (ts) ui.position.top = inst._convertPositionTo("relative", {
                        top: t,
                        left: 0
                    }).top;
                    if (bs) ui.position.top = inst._convertPositionTo("relative", {
                        top: b - inst.helperProportions.height,
                        left: 0
                    }).top;
                    if (ls) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: l
                    }).left;
                    if (rs) ui.position.left = inst._convertPositionTo("relative", {
                        top: 0,
                        left: r - inst.helperProportions.width
                    }).left;
                }
                if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
                    if (inst.options.snap.snap) inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), {
                        snapItem: inst.snapElements[i].item
                    }));
                }
                inst.snapElements[i].snapping = ts || bs || ls || rs || first;
            }
        }
    });
    $.ui.plugin.add("draggable", "stack", {
        start: function(event, ui, instance) {
            var min, o = instance.options, group = $.makeArray($(o.stack)).sort(function(a, b) {
                return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
            });
            if (!group.length) return;
            min = parseInt($(group[0]).css("zIndex"), 10) || 0;
            $(group).each(function(i) {
                $(this).css("zIndex", min + i);
            });
            this.css("zIndex", min + group.length);
        }
    });
    $.ui.plugin.add("draggable", "zIndex", {
        start: function(event, ui, instance) {
            var t = $(ui.helper), o = instance.options;
            if (t.css("zIndex")) o._zIndex = t.css("zIndex");
            t.css("zIndex", o.zIndex);
        },
        stop: function(event, ui, instance) {
            var o = instance.options;
            if (o._zIndex) $(ui.helper).css("zIndex", o._zIndex);
        }
    });
    return $.ui.draggable;
});


/*!
 * jQuery UI Droppable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Droppable
//>>group: Interactions
//>>description: Enables drop targets for draggable elements.
//>>docs: https://api.jqueryui.com/droppable/
//>>demos: https://jqueryui.com/droppable/
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./draggable",
        "./mouse",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    $.widget("ui.droppable", {
        version: "1.14.2",
        widgetEventPrefix: "drop",
        options: {
            accept: "*",
            addClasses: true,
            greedy: false,
            scope: "default",
            tolerance: "intersect",
            // Callbacks
            activate: null,
            deactivate: null,
            drop: null,
            out: null,
            over: null
        },
        _create: function() {
            var proportions, o = this.options, accept = o.accept;
            this.isover = false;
            this.isout = true;
            this.accept = typeof accept === "function" ? accept : function(d) {
                return d.is(accept);
            };
            this.proportions = function() {
                if (arguments.length) // Store the droppable's proportions
                proportions = arguments[0];
                else // Retrieve or derive the droppable's proportions
                return proportions ? proportions : proportions = {
                    width: this.element[0].offsetWidth,
                    height: this.element[0].offsetHeight
                };
            };
            this._addToManager(o.scope);
            if (o.addClasses) this._addClass("ui-droppable");
        },
        _addToManager: function(scope) {
            // Add the reference and positions to the manager
            $.ui.ddmanager.droppables[scope] = $.ui.ddmanager.droppables[scope] || [];
            $.ui.ddmanager.droppables[scope].push(this);
        },
        _splice: function(drop) {
            var i = 0;
            for(; i < drop.length; i++)if (drop[i] === this) drop.splice(i, 1);
        },
        _destroy: function() {
            var drop = $.ui.ddmanager.droppables[this.options.scope];
            this._splice(drop);
        },
        _setOption: function(key, value) {
            if (key === "accept") this.accept = typeof value === "function" ? value : function(d) {
                return d.is(value);
            };
            else if (key === "scope") {
                var drop = $.ui.ddmanager.droppables[this.options.scope];
                this._splice(drop);
                this._addToManager(value);
            }
            this._super(key, value);
        },
        _activate: function(event) {
            var draggable = $.ui.ddmanager.current;
            this._addActiveClass();
            if (draggable) this._trigger("activate", event, this.ui(draggable));
        },
        _deactivate: function(event) {
            var draggable = $.ui.ddmanager.current;
            this._removeActiveClass();
            if (draggable) this._trigger("deactivate", event, this.ui(draggable));
        },
        _over: function(event) {
            var draggable = $.ui.ddmanager.current;
            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) return;
            if (this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                this._addHoverClass();
                this._trigger("over", event, this.ui(draggable));
            }
        },
        _out: function(event) {
            var draggable = $.ui.ddmanager.current;
            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) return;
            if (this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                this._removeHoverClass();
                this._trigger("out", event, this.ui(draggable));
            }
        },
        _drop: function(event, custom) {
            var draggable = custom || $.ui.ddmanager.current, childrenIntersection = false;
            // Bail if draggable and droppable are same element
            if (!draggable || (draggable.currentItem || draggable.element)[0] === this.element[0]) return false;
            this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function() {
                var inst = $(this).droppable("instance");
                if (inst.options.greedy && !inst.options.disabled && inst.options.scope === draggable.options.scope && inst.accept.call(inst.element[0], draggable.currentItem || draggable.element) && $.ui.intersect(draggable, $.extend(inst, {
                    offset: inst.element.offset()
                }), inst.options.tolerance, event)) {
                    childrenIntersection = true;
                    return false;
                }
            });
            if (childrenIntersection) return false;
            if (this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                this._removeActiveClass();
                this._removeHoverClass();
                this._trigger("drop", event, this.ui(draggable));
                return this.element;
            }
            return false;
        },
        ui: function(c) {
            return {
                draggable: c.currentItem || c.element,
                helper: c.helper,
                position: c.position,
                offset: c.positionAbs
            };
        },
        // Extension points just to make backcompat sane and avoid duplicating logic
        // TODO: Remove in 1.14 along with call to it below
        _addHoverClass: function() {
            this._addClass("ui-droppable-hover");
        },
        _removeHoverClass: function() {
            this._removeClass("ui-droppable-hover");
        },
        _addActiveClass: function() {
            this._addClass("ui-droppable-active");
        },
        _removeActiveClass: function() {
            this._removeClass("ui-droppable-active");
        }
    });
    $.ui.intersect = function() {
        function isOverAxis(x, reference, size) {
            return x >= reference && x < reference + size;
        }
        return function(draggable, droppable, toleranceMode, event) {
            if (!droppable.offset) return false;
            var x1 = (draggable.positionAbs || draggable.position.absolute).left + draggable.margins.left, y1 = (draggable.positionAbs || draggable.position.absolute).top + draggable.margins.top, x2 = x1 + draggable.helperProportions.width, y2 = y1 + draggable.helperProportions.height, l = droppable.offset.left, t = droppable.offset.top, r = l + droppable.proportions().width, b = t + droppable.proportions().height;
            switch(toleranceMode){
                case "fit":
                    return l <= x1 && x2 <= r && t <= y1 && y2 <= b;
                case "intersect":
                    return l < x1 + draggable.helperProportions.width / 2 && // Right Half
                    x2 - draggable.helperProportions.width / 2 < r && // Left Half
                    t < y1 + draggable.helperProportions.height / 2 && // Bottom Half
                    y2 - draggable.helperProportions.height / 2 < b; // Top Half
                case "pointer":
                    return isOverAxis(event.pageY, t, droppable.proportions().height) && isOverAxis(event.pageX, l, droppable.proportions().width);
                case "touch":
                    return (y1 >= t && y1 <= b || // Top edge touching
                    y2 >= t && y2 <= b || // Bottom edge touching
                    y1 < t && y2 > b // Surrounded vertically
                    ) && (x1 >= l && x1 <= r || // Left edge touching
                    x2 >= l && x2 <= r || // Right edge touching
                    x1 < l && x2 > r // Surrounded horizontally
                    );
                default:
                    return false;
            }
        };
    }();
    /*
	This manager tracks offsets of draggables and droppables
*/ $.ui.ddmanager = {
        current: null,
        droppables: {
            "default": []
        },
        prepareOffsets: function(t, event) {
            var i, j, m = $.ui.ddmanager.droppables[t.options.scope] || [], type = event ? event.type : null, list = (t.currentItem || t.element).find(":data(ui-droppable)").addBack();
            droppablesLoop: for(i = 0; i < m.length; i++){
                // No disabled and non-accepted
                if (m[i].options.disabled || t && !m[i].accept.call(m[i].element[0], t.currentItem || t.element)) continue;
                // Filter out elements in the current dragged item
                for(j = 0; j < list.length; j++)if (list[j] === m[i].element[0]) {
                    m[i].proportions().height = 0;
                    continue droppablesLoop;
                }
                m[i].visible = m[i].element.css("display") !== "none";
                if (!m[i].visible) continue;
                // Activate the droppable if used directly from draggables
                if (type === "mousedown") m[i]._activate.call(m[i], event);
                m[i].offset = m[i].element.offset();
                m[i].proportions({
                    width: m[i].element[0].offsetWidth,
                    height: m[i].element[0].offsetHeight
                });
            }
        },
        drop: function(draggable, event) {
            var dropped = false;
            // Create a copy of the droppables in case the list changes during the drop (#9116)
            $.each(($.ui.ddmanager.droppables[draggable.options.scope] || []).slice(), function() {
                if (!this.options) return;
                if (!this.options.disabled && this.visible && $.ui.intersect(draggable, this, this.options.tolerance, event)) dropped = this._drop.call(this, event) || dropped;
                if (!this.options.disabled && this.visible && this.accept.call(this.element[0], draggable.currentItem || draggable.element)) {
                    this.isout = true;
                    this.isover = false;
                    this._deactivate.call(this, event);
                }
            });
            return dropped;
        },
        dragStart: function(draggable, event) {
            // Listen for scrolling so that if the dragging causes scrolling the position of the
            // droppables can be recalculated (see #5003)
            draggable.element.parentsUntil("body").on("scroll.droppable", function() {
                if (!draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);
            });
        },
        drag: function(draggable, event) {
            // If you have a highly dynamic page, you might try this option. It renders positions
            // every time you move the mouse.
            if (draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);
            // Run through all droppables and check their positions based on specific tolerance options
            $.each($.ui.ddmanager.droppables[draggable.options.scope] || [], function() {
                if (this.options.disabled || this.greedyChild || !this.visible) return;
                var parentInstance, scope, parent, intersects = $.ui.intersect(draggable, this, this.options.tolerance, event), c = !intersects && this.isover ? "isout" : intersects && !this.isover ? "isover" : null;
                if (!c) return;
                if (this.options.greedy) {
                    // find droppable parents with same scope
                    scope = this.options.scope;
                    parent = this.element.parents(":data(ui-droppable)").filter(function() {
                        return $(this).droppable("instance").options.scope === scope;
                    });
                    if (parent.length) {
                        parentInstance = $(parent[0]).droppable("instance");
                        parentInstance.greedyChild = c === "isover";
                    }
                }
                // We just moved into a greedy child
                if (parentInstance && c === "isover") {
                    parentInstance.isover = false;
                    parentInstance.isout = true;
                    parentInstance._out.call(parentInstance, event);
                }
                this[c] = true;
                this[c === "isout" ? "isover" : "isout"] = false;
                this[c === "isover" ? "_over" : "_out"].call(this, event);
                // We just moved out of a greedy child
                if (parentInstance && c === "isout") {
                    parentInstance.isout = false;
                    parentInstance.isover = true;
                    parentInstance._over.call(parentInstance, event);
                }
            });
        },
        dragStop: function(draggable, event) {
            draggable.element.parentsUntil("body").off("scroll.droppable");
            // Call prepareOffsets one final time since IE does not fire return scroll events when
            // overflow was caused by drag (see #5003)
            if (!draggable.options.refreshPositions) $.ui.ddmanager.prepareOffsets(draggable, event);
        }
    };
    // DEPRECATED
    // TODO: switch return back to widget declaration at top of file when this is removed
    if ($.uiBackCompat === true) // Backcompat for activeClass and hoverClass options
    $.widget("ui.droppable", $.ui.droppable, {
        options: {
            hoverClass: false,
            activeClass: false
        },
        _addActiveClass: function() {
            this._super();
            if (this.options.activeClass) this.element.addClass(this.options.activeClass);
        },
        _removeActiveClass: function() {
            this._super();
            if (this.options.activeClass) this.element.removeClass(this.options.activeClass);
        },
        _addHoverClass: function() {
            this._super();
            if (this.options.hoverClass) this.element.addClass(this.options.hoverClass);
        },
        _removeHoverClass: function() {
            this._super();
            if (this.options.hoverClass) this.element.removeClass(this.options.hoverClass);
        }
    });
    return $.ui.droppable;
});


/*!
 * jQuery UI Selectable 1.14.2
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */ //>>label: Selectable
//>>group: Interactions
//>>description: Allows groups of elements to be selected with the mouse.
//>>docs: https://api.jqueryui.com/selectable/
//>>demos: https://jqueryui.com/selectable/
//>>css.structure: ../../themes/base/selectable.css
(function(factory) {
    "use strict";
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery",
        "./mouse",
        "../version",
        "../widget"
    ], factory);
    else // Browser globals
    factory(jQuery);
})(function($) {
    "use strict";
    return $.widget("ui.selectable", $.ui.mouse, {
        version: "1.14.2",
        options: {
            appendTo: "body",
            autoRefresh: true,
            distance: 0,
            filter: "*",
            tolerance: "touch",
            // Callbacks
            selected: null,
            selecting: null,
            start: null,
            stop: null,
            unselected: null,
            unselecting: null
        },
        _create: function() {
            var that = this;
            this._addClass("ui-selectable");
            this.dragged = false;
            // Cache selectee children based on filter
            this.refresh = function() {
                that.elementPos = $(that.element[0]).offset();
                that.selectees = $(that.options.filter, that.element[0]);
                that._addClass(that.selectees, "ui-selectee");
                that.selectees.each(function() {
                    var $this = $(this), selecteeOffset = $this.offset(), pos = {
                        left: selecteeOffset.left - that.elementPos.left,
                        top: selecteeOffset.top - that.elementPos.top
                    };
                    $.data(this, "selectable-item", {
                        element: this,
                        $element: $this,
                        left: pos.left,
                        top: pos.top,
                        right: pos.left + $this.outerWidth(),
                        bottom: pos.top + $this.outerHeight(),
                        startselected: false,
                        selected: $this.hasClass("ui-selected"),
                        selecting: $this.hasClass("ui-selecting"),
                        unselecting: $this.hasClass("ui-unselecting")
                    });
                });
            };
            this.refresh();
            this._mouseInit();
            this.helper = $("<div>");
            this._addClass(this.helper, "ui-selectable-helper");
        },
        _destroy: function() {
            this.selectees.removeData("selectable-item");
            this._mouseDestroy();
        },
        _mouseStart: function(event) {
            var that = this, options = this.options;
            this.opos = [
                event.pageX,
                event.pageY
            ];
            this.elementPos = $(this.element[0]).offset();
            if (this.options.disabled) return;
            this.selectees = $(options.filter, this.element[0]);
            this._trigger("start", event);
            $(options.appendTo).append(this.helper);
            // position helper (lasso)
            this.helper.css({
                "left": event.pageX,
                "top": event.pageY,
                "width": 0,
                "height": 0
            });
            if (options.autoRefresh) this.refresh();
            this.selectees.filter(".ui-selected").each(function() {
                var selectee = $.data(this, "selectable-item");
                selectee.startselected = true;
                if (!event.metaKey && !event.ctrlKey) {
                    that._removeClass(selectee.$element, "ui-selected");
                    selectee.selected = false;
                    that._addClass(selectee.$element, "ui-unselecting");
                    selectee.unselecting = true;
                    // selectable UNSELECTING callback
                    that._trigger("unselecting", event, {
                        unselecting: selectee.element
                    });
                }
            });
            $(event.target).parents().addBack().each(function() {
                var doSelect, selectee = $.data(this, "selectable-item");
                if (selectee) {
                    doSelect = !event.metaKey && !event.ctrlKey || !selectee.$element.hasClass("ui-selected");
                    that._removeClass(selectee.$element, doSelect ? "ui-unselecting" : "ui-selected")._addClass(selectee.$element, doSelect ? "ui-selecting" : "ui-unselecting");
                    selectee.unselecting = !doSelect;
                    selectee.selecting = doSelect;
                    selectee.selected = doSelect;
                    // selectable (UN)SELECTING callback
                    if (doSelect) that._trigger("selecting", event, {
                        selecting: selectee.element
                    });
                    else that._trigger("unselecting", event, {
                        unselecting: selectee.element
                    });
                    return false;
                }
            });
        },
        _mouseDrag: function(event) {
            this.dragged = true;
            if (this.options.disabled) return;
            var tmp, that = this, options = this.options, x1 = this.opos[0], y1 = this.opos[1], x2 = event.pageX, y2 = event.pageY;
            if (x1 > x2) {
                tmp = x2;
                x2 = x1;
                x1 = tmp;
            }
            if (y1 > y2) {
                tmp = y2;
                y2 = y1;
                y1 = tmp;
            }
            this.helper.css({
                left: x1,
                top: y1,
                width: x2 - x1,
                height: y2 - y1
            });
            this.selectees.each(function() {
                var selectee = $.data(this, "selectable-item"), hit = false, offset = {};
                //prevent helper from being selected if appendTo: selectable
                if (!selectee || selectee.element === that.element[0]) return;
                offset.left = selectee.left + that.elementPos.left;
                offset.right = selectee.right + that.elementPos.left;
                offset.top = selectee.top + that.elementPos.top;
                offset.bottom = selectee.bottom + that.elementPos.top;
                if (options.tolerance === "touch") hit = !(offset.left > x2 || offset.right < x1 || offset.top > y2 || offset.bottom < y1);
                else if (options.tolerance === "fit") hit = offset.left > x1 && offset.right < x2 && offset.top > y1 && offset.bottom < y2;
                if (hit) {
                    // SELECT
                    if (selectee.selected) {
                        that._removeClass(selectee.$element, "ui-selected");
                        selectee.selected = false;
                    }
                    if (selectee.unselecting) {
                        that._removeClass(selectee.$element, "ui-unselecting");
                        selectee.unselecting = false;
                    }
                    if (!selectee.selecting) {
                        that._addClass(selectee.$element, "ui-selecting");
                        selectee.selecting = true;
                        // selectable SELECTING callback
                        that._trigger("selecting", event, {
                            selecting: selectee.element
                        });
                    }
                } else {
                    // UNSELECT
                    if (selectee.selecting) {
                        if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
                            that._removeClass(selectee.$element, "ui-selecting");
                            selectee.selecting = false;
                            that._addClass(selectee.$element, "ui-selected");
                            selectee.selected = true;
                        } else {
                            that._removeClass(selectee.$element, "ui-selecting");
                            selectee.selecting = false;
                            if (selectee.startselected) {
                                that._addClass(selectee.$element, "ui-unselecting");
                                selectee.unselecting = true;
                            }
                            // selectable UNSELECTING callback
                            that._trigger("unselecting", event, {
                                unselecting: selectee.element
                            });
                        }
                    }
                    if (selectee.selected) {
                        if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
                            that._removeClass(selectee.$element, "ui-selected");
                            selectee.selected = false;
                            that._addClass(selectee.$element, "ui-unselecting");
                            selectee.unselecting = true;
                            // selectable UNSELECTING callback
                            that._trigger("unselecting", event, {
                                unselecting: selectee.element
                            });
                        }
                    }
                }
            });
            return false;
        },
        _mouseStop: function(event) {
            var that = this;
            this.dragged = false;
            $(".ui-unselecting", this.element[0]).each(function() {
                var selectee = $.data(this, "selectable-item");
                that._removeClass(selectee.$element, "ui-unselecting");
                selectee.unselecting = false;
                selectee.startselected = false;
                that._trigger("unselected", event, {
                    unselected: selectee.element
                });
            });
            $(".ui-selecting", this.element[0]).each(function() {
                var selectee = $.data(this, "selectable-item");
                that._removeClass(selectee.$element, "ui-selecting")._addClass(selectee.$element, "ui-selected");
                selectee.selecting = false;
                selectee.selected = true;
                selectee.startselected = true;
                that._trigger("selected", event, {
                    selected: selectee.element
                });
            });
            this._trigger("stop", event);
            this.helper.remove();
            return false;
        }
    });
});


/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */ (function($) {
    // Detect touch support
    $.support.touch = 'ontouchend' in document;
    // Ignore browsers without touch support
    if (!$.support.touch) return;
    var mouseProto = $.ui.mouse.prototype, _mouseInit = mouseProto._mouseInit, _mouseDestroy = mouseProto._mouseDestroy, touchHandled;
    /**
   * Simulate a mouse event based on a corresponding touch event
   * @param {Object} event A touch event
   * @param {String} simulatedType The corresponding mouse event
   */ function simulateMouseEvent(event, simulatedType) {
        // Ignore multi-touch events
        if (event.originalEvent.touches.length > 1) return;
        event.preventDefault();
        var touch = event.originalEvent.changedTouches[0], simulatedEvent = document.createEvent('MouseEvents');
        // Initialize the simulated mouse event using the touch event's coordinates
        simulatedEvent.initMouseEvent(simulatedType, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null // relatedTarget              
        );
        // Dispatch the simulated event to the target element
        event.target.dispatchEvent(simulatedEvent);
    }
    /**
   * Handle the jQuery UI widget's touchstart events
   * @param {Object} event The widget element's touchstart event
   */ mouseProto._touchStart = function(event) {
        var self = this;
        // Ignore the event if another widget is already being handled
        if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) return;
        // Set the flag to prevent other widgets from inheriting the touch event
        touchHandled = true;
        // Track movement to determine if interaction was a click
        self._touchMoved = false;
        // Simulate the mouseover event
        simulateMouseEvent(event, 'mouseover');
        // Simulate the mousemove event
        simulateMouseEvent(event, 'mousemove');
        // Simulate the mousedown event
        simulateMouseEvent(event, 'mousedown');
    };
    /**
   * Handle the jQuery UI widget's touchmove events
   * @param {Object} event The document's touchmove event
   */ mouseProto._touchMove = function(event) {
        // Ignore event if not handled
        if (!touchHandled) return;
        // Interaction was not a click
        this._touchMoved = true;
        // Simulate the mousemove event
        simulateMouseEvent(event, 'mousemove');
    };
    /**
   * Handle the jQuery UI widget's touchend events
   * @param {Object} event The document's touchend event
   */ mouseProto._touchEnd = function(event) {
        // Ignore event if not handled
        if (!touchHandled) return;
        // Simulate the mouseup event
        simulateMouseEvent(event, 'mouseup');
        // Simulate the mouseout event
        simulateMouseEvent(event, 'mouseout');
        // If the touch interaction did not move, it should trigger a click
        if (!this._touchMoved) // Simulate the click event
        simulateMouseEvent(event, 'click');
        // Unset the flag to allow other widgets to inherit the touch event
        touchHandled = false;
    };
    /**
   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
   * This method extends the widget with bound touch event handlers that
   * translate touch events to mouse events and pass them to the widget's
   * original mouse event handling methods.
   */ mouseProto._mouseInit = function() {
        var self = this;
        // Delegate the touch handlers to the widget's element
        self.element.bind({
            touchstart: $.proxy(self, '_touchStart'),
            touchmove: $.proxy(self, '_touchMove'),
            touchend: $.proxy(self, '_touchEnd')
        });
        // Call the original $.ui.mouse init method
        _mouseInit.call(self);
    };
    /**
   * Remove the touch event handlers
   */ mouseProto._mouseDestroy = function() {
        var self = this;
        // Delegate the touch handlers to the widget's element
        self.element.unbind({
            touchstart: $.proxy(self, '_touchStart'),
            touchmove: $.proxy(self, '_touchMove'),
            touchend: $.proxy(self, '_touchEnd')
        });
        // Call the original $.ui.mouse destroy method
        _mouseDestroy.call(self);
    };
})(jQuery);


window.customElements.define("association-game", class AssociationGame extends HTMLElement {
    connectedCallback() {
        window.$ = $4eae0a726ab50395$exports;
        this.randomizeOptions();
        if ($4eae0a726ab50395$exports(this).hasClass('association-game--textToImage')) this.initGallery();
        // Delay drag & drop init to avoid problems after reordering.
        window.setTimeout(()=>this.initDraggability(), 50);
        window.popups = {};
    }
    initGallery() {
        const $targets = $4eae0a726ab50395$exports(this).find('.association-game--targets').children();
        const switchGalleryImage = (offset)=>{
            const currentIdx = $targets.toArray().findIndex((el)=>!$4eae0a726ab50395$exports(el).hasClass('d-none'));
            const targetIdx = (currentIdx + offset + $targets.length) % $targets.length;
            $4eae0a726ab50395$exports($targets[currentIdx]).addClass('d-none');
            $4eae0a726ab50395$exports($targets[targetIdx]).removeClass('d-none');
        };
        $targets.first().removeClass('d-none');
        $4eae0a726ab50395$exports(this).find('.image-gallery-arrow.right').on('click', ()=>{
            switchGalleryImage(1);
        });
        $4eae0a726ab50395$exports(this).find('.image-gallery-arrow.left').on('click', ()=>{
            switchGalleryImage(-1);
        });
    }
    randomIndex(array) {
        return Math.floor(Math.random() * array.length);
    }
    randomizeOptions() {
        const options = $4eae0a726ab50395$exports(this).find('.association-game--option');
        const optionsCopy = options.clone().removeClass('d-none').toArray();
        options.each((idx, option)=>{
            $4eae0a726ab50395$exports(option).replaceWith(optionsCopy.splice(this.randomIndex(optionsCopy), 1));
        });
    }
    initDraggability() {
        $4eae0a726ab50395$exports(this).find('.association-game--option').each((idx, option)=>{
            this.initDraggableOption(option);
        });
    }
    initDraggableOption(dragged) {
        const $dragged = $4eae0a726ab50395$exports(dragged);
        const group = $dragged.data('group');
        $dragged.draggable({
            revert: 'invalid',
            containment: 'document'
        });
        $4eae0a726ab50395$exports(this).find(`.association-game--target[data-group="${group}"]`).each((idx, target)=>{
            const $target = $4eae0a726ab50395$exports(target);
            $target.droppable({
                accept: `.association-game--option[data-group="${group}"]`,
                drop: ()=>{
                    $target.find('.association-game--answer').removeClass("d-none");
                    $target.data('success', true);
                    $dragged.remove();
                    this.showInfoText($target.data('infoText'));
                    this.checkComplete();
                }
            });
        });
    }
    checkComplete() {
        const $game = $4eae0a726ab50395$exports(this);
        let isComplete = true;
        $game.find('.association-game--target').each(function(idx, target) {
            isComplete = isComplete && $4eae0a726ab50395$exports(target).data('success');
        });
        if (isComplete) {
            this.showSuccessText($game.data('successText'));
            $game.find('.association-game--target').addClass('solved');
        }
    }
    showInfoText(text) {
        this.showPopupText(text, 'info-text');
    }
    showSuccessText(text) {
        this.showPopupText(text, 'success-text');
    }
    showPopupText(text, classSuffix) {
        if (!text) return;
        let $popupText = $4eae0a726ab50395$exports(`.association-game--${classSuffix}`);
        if (!$popupText.length) {
            $popupText = $4eae0a726ab50395$exports(`<div class="association-game--${classSuffix}">${text}</div>`);
            $4eae0a726ab50395$exports('body').append($popupText);
            $4eae0a726ab50395$exports('body').click(()=>$popupText.removeClass('visible'));
        } else {
            $popupText.text(text);
            if (window.popups[`${classSuffix}Popup`]) window.clearTimeout(window.popups[`${classSuffix}Popup`]);
        }
        window.setTimeout(()=>{
            $popupText.addClass('visible');
        }, 0);
        window.popups[`${classSuffix}Popup`] = window.setTimeout(()=>{
            $popupText.removeClass('visible');
        }, 15000);
    }
});


window.customElements.define("back-to-top", class BackToTop extends HTMLElement {
    startFadeAt = 100;
    finishFadeAfter = 400;
    connectedCallback() {
        this.addEventListener('click', this.scrollToTop);
        this.setOpacity();
        window.addEventListener('scroll', this.setOpacity);
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this.setOpacity);
    }
    scrollToTop = ()=>{
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    };
    setOpacity = ()=>{
        const rawOpacity = (window.scrollY - this.startFadeAt) / this.finishFadeAfter;
        const opacity = Math.max(0, Math.min(rawOpacity, 1));
        this.style.opacity = opacity;
    };
});


parcelRequire("8JYDX");
var $d74276d64ed130b8$exports = {};
/*
 * Leaflet.markercluster 1.5.3+master.e5124b2,
 * Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 * https://github.com/Leaflet/Leaflet.markercluster
 * (c) 2012-2017, Dave Leaver, smartrak
 */ (function(global, factory) {
    factory($d74276d64ed130b8$exports);
})($d74276d64ed130b8$exports, function(exports1) {
    'use strict';
    /*
	 * L.MarkerClusterGroup extends L.FeatureGroup by clustering the markers contained within
	 */ var MarkerClusterGroup = L.MarkerClusterGroup = L.FeatureGroup.extend({
        options: {
            maxClusterRadius: 80,
            iconCreateFunction: null,
            clusterPane: L.Marker.prototype.options.pane,
            spiderfyOnEveryZoom: false,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: true,
            zoomToBoundsOnClick: true,
            singleMarkerMode: false,
            disableClusteringAtZoom: null,
            // Setting this to false prevents the removal of any clusters outside of the viewpoint, which
            // is the default behaviour for performance reasons.
            removeOutsideVisibleBounds: true,
            // Set to false to disable all animations (zoom and spiderfy).
            // If false, option animateAddingMarkers below has no effect.
            // If L.DomUtil.TRANSITION is falsy, this option has no effect.
            animate: true,
            //Whether to animate adding markers after adding the MarkerClusterGroup to the map
            // If you are adding individual markers set to true, if adding bulk markers leave false for massive performance gains.
            animateAddingMarkers: false,
            // Make it possible to provide custom function to calculate spiderfy shape positions
            spiderfyShapePositions: null,
            //Increase to increase the distance away that spiderfied markers appear from the center
            spiderfyDistanceMultiplier: 1,
            // Make it possible to specify a polyline options on a spider leg
            spiderLegPolylineOptions: {
                weight: 1.5,
                color: '#222',
                opacity: 0.5
            },
            // When bulk adding layers, adds markers in chunks. Means addLayers may not add all the layers in the call, others will be loaded during setTimeouts
            chunkedLoading: false,
            chunkInterval: 200,
            chunkDelay: 50,
            chunkProgress: null,
            //Options to pass to the L.Polygon constructor
            polygonOptions: {}
        },
        initialize: function(options) {
            L.Util.setOptions(this, options);
            if (!this.options.iconCreateFunction) this.options.iconCreateFunction = this._defaultIconCreateFunction;
            this._featureGroup = L.featureGroup();
            this._featureGroup.addEventParent(this);
            this._nonPointGroup = L.featureGroup();
            this._nonPointGroup.addEventParent(this);
            this._inZoomAnimation = 0;
            this._needsClustering = [];
            this._needsRemoving = []; //Markers removed while we aren't on the map need to be kept track of
            //The bounds of the currently shown area (from _getExpandedVisibleBounds) Updated on zoom/move
            this._currentShownBounds = null;
            this._queue = [];
            this._childMarkerEventHandlers = {
                'dragstart': this._childMarkerDragStart,
                'move': this._childMarkerMoved,
                'dragend': this._childMarkerDragEnd
            };
            // Hook the appropriate animation methods.
            var animate = L.DomUtil.TRANSITION && this.options.animate;
            L.extend(this, animate ? this._withAnimation : this._noAnimation);
            // Remember which MarkerCluster class to instantiate (animated or not).
            this._markerCluster = animate ? L.MarkerCluster : L.MarkerClusterNonAnimated;
        },
        addLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.addLayers([
                layer
            ]);
            //Don't cluster non point data
            if (!layer.getLatLng) {
                this._nonPointGroup.addLayer(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                this._needsClustering.push(layer);
                this.fire('layeradd', {
                    layer: layer
                });
                return this;
            }
            if (this.hasLayer(layer)) return this;
            //If we have already clustered we'll need to add this one to a cluster
            if (this._unspiderfy) this._unspiderfy();
            this._addLayer(layer, this._maxZoom);
            this.fire('layeradd', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Work out what is visible
            var visibleLayer = layer, currentZoom = this._zoom;
            if (layer.__parent) while(visibleLayer.__parent._zoom >= currentZoom)visibleLayer = visibleLayer.__parent;
            if (this._currentShownBounds.contains(visibleLayer.getLatLng())) {
                if (this.options.animateAddingMarkers) this._animationAddLayer(layer, visibleLayer);
                else this._animationAddLayerNonAnimated(layer, visibleLayer);
            }
            return this;
        },
        removeLayer: function(layer) {
            if (layer instanceof L.LayerGroup) return this.removeLayers([
                layer
            ]);
            //Non point layers
            if (!layer.getLatLng) {
                this._nonPointGroup.removeLayer(layer);
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!this._map) {
                if (!this._arraySplice(this._needsClustering, layer) && this.hasLayer(layer)) this._needsRemoving.push({
                    layer: layer,
                    latlng: layer._latlng
                });
                this.fire('layerremove', {
                    layer: layer
                });
                return this;
            }
            if (!layer.__parent) return this;
            if (this._unspiderfy) {
                this._unspiderfy();
                this._unspiderfyLayer(layer);
            }
            //Remove the marker from clusters
            this._removeLayer(layer, true);
            this.fire('layerremove', {
                layer: layer
            });
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            layer.off(this._childMarkerEventHandlers, this);
            if (this._featureGroup.hasLayer(layer)) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
            }
            return this;
        },
        //Takes an array of markers and adds them in bulk
        addLayers: function(layersArray, skipLayerAddEvent) {
            if (!L.Util.isArray(layersArray)) return this.addLayer(layersArray);
            var fg = this._featureGroup, npg = this._nonPointGroup, chunked = this.options.chunkedLoading, chunkInterval = this.options.chunkInterval, chunkProgress = this.options.chunkProgress, l = layersArray.length, offset = 0, originalArray = true, m;
            if (this._map) {
                var started = new Date().getTime();
                var process = L.bind(function() {
                    var start = new Date().getTime();
                    // Make sure to unspiderfy before starting to add some layers
                    if (this._map && this._unspiderfy) this._unspiderfy();
                    for(; offset < l; offset++){
                        if (chunked && offset % 200 === 0) {
                            // every couple hundred markers, instrument the time elapsed since processing started:
                            var elapsed = new Date().getTime() - start;
                            if (elapsed > chunkInterval) break; // been working too hard, time to take a break :-)
                        }
                        m = layersArray[offset];
                        // Group of layers, append children to layersArray and skip.
                        // Side effects:
                        // - Total increases, so chunkProgress ratio jumps backward.
                        // - Groups are not included in this group, only their non-group child layers (hasLayer).
                        // Changing array length while looping does not affect performance in current browsers:
                        // http://jsperf.com/for-loop-changing-length/6
                        if (m instanceof L.LayerGroup) {
                            if (originalArray) {
                                layersArray = layersArray.slice();
                                originalArray = false;
                            }
                            this._extractNonGroupLayers(m, layersArray);
                            l = layersArray.length;
                            continue;
                        }
                        //Not point data, can't be clustered
                        if (!m.getLatLng) {
                            npg.addLayer(m);
                            if (!skipLayerAddEvent) this.fire('layeradd', {
                                layer: m
                            });
                            continue;
                        }
                        if (this.hasLayer(m)) continue;
                        this._addLayer(m, this._maxZoom);
                        if (!skipLayerAddEvent) this.fire('layeradd', {
                            layer: m
                        });
                        //If we just made a cluster of size 2 then we need to remove the other marker from the map (if it is) or we never will
                        if (m.__parent) {
                            if (m.__parent.getChildCount() === 2) {
                                var markers = m.__parent.getAllChildMarkers(), otherMarker = markers[0] === m ? markers[1] : markers[0];
                                fg.removeLayer(otherMarker);
                            }
                        }
                    }
                    if (chunkProgress) // report progress and time elapsed:
                    chunkProgress(offset, l, new Date().getTime() - started);
                    // Completed processing all markers.
                    if (offset === l) {
                        // Refresh bounds and weighted positions.
                        this._topClusterLevel._recalculateBounds();
                        this._refreshClustersIcons();
                        this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
                    } else setTimeout(process, this.options.chunkDelay);
                }, this);
                process();
            } else {
                var needsClustering = this._needsClustering;
                for(; offset < l; offset++){
                    m = layersArray[offset];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    //Not point data, can't be clustered
                    if (!m.getLatLng) {
                        npg.addLayer(m);
                        continue;
                    }
                    if (this.hasLayer(m)) continue;
                    needsClustering.push(m);
                }
            }
            return this;
        },
        //Takes an array of markers and removes them in bulk
        removeLayers: function(layersArray) {
            var i, m, l = layersArray.length, fg = this._featureGroup, npg = this._nonPointGroup, originalArray = true;
            if (!this._map) {
                for(i = 0; i < l; i++){
                    m = layersArray[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        if (originalArray) {
                            layersArray = layersArray.slice();
                            originalArray = false;
                        }
                        this._extractNonGroupLayers(m, layersArray);
                        l = layersArray.length;
                        continue;
                    }
                    this._arraySplice(this._needsClustering, m);
                    npg.removeLayer(m);
                    if (this.hasLayer(m)) this._needsRemoving.push({
                        layer: m,
                        latlng: m._latlng
                    });
                    this.fire('layerremove', {
                        layer: m
                    });
                }
                return this;
            }
            if (this._unspiderfy) {
                this._unspiderfy();
                // Work on a copy of the array, so that next loop is not affected.
                var layersArray2 = layersArray.slice(), l2 = l;
                for(i = 0; i < l2; i++){
                    m = layersArray2[i];
                    // Group of layers, append children to layersArray and skip.
                    if (m instanceof L.LayerGroup) {
                        this._extractNonGroupLayers(m, layersArray2);
                        l2 = layersArray2.length;
                        continue;
                    }
                    this._unspiderfyLayer(m);
                }
            }
            for(i = 0; i < l; i++){
                m = layersArray[i];
                // Group of layers, append children to layersArray and skip.
                if (m instanceof L.LayerGroup) {
                    if (originalArray) {
                        layersArray = layersArray.slice();
                        originalArray = false;
                    }
                    this._extractNonGroupLayers(m, layersArray);
                    l = layersArray.length;
                    continue;
                }
                if (!m.__parent) {
                    npg.removeLayer(m);
                    this.fire('layerremove', {
                        layer: m
                    });
                    continue;
                }
                this._removeLayer(m, true, true);
                this.fire('layerremove', {
                    layer: m
                });
                if (fg.hasLayer(m)) {
                    fg.removeLayer(m);
                    if (m.clusterShow) m.clusterShow();
                }
            }
            // Refresh bounds and weighted positions.
            this._topClusterLevel._recalculateBounds();
            this._refreshClustersIcons();
            //Fix up the clusters and markers on the map
            this._topClusterLevel._recursivelyAddChildrenToMap(null, this._zoom, this._currentShownBounds);
            return this;
        },
        //Removes all layers from the MarkerClusterGroup
        clearLayers: function() {
            //Need our own special implementation as the LayerGroup one doesn't work for us
            //If we aren't on the map (yet), blow away the markers we know of
            if (!this._map) {
                this._needsClustering = [];
                this._needsRemoving = [];
                delete this._gridClusters;
                delete this._gridUnclustered;
            }
            if (this._noanimationUnspiderfy) this._noanimationUnspiderfy();
            //Remove all the visible layers
            this._featureGroup.clearLayers();
            this._nonPointGroup.clearLayers();
            this.eachLayer(function(marker) {
                marker.off(this._childMarkerEventHandlers, this);
                delete marker.__parent;
            }, this);
            if (this._map) //Reset _topClusterLevel and the DistanceGrids
            this._generateInitialClusters();
            return this;
        },
        //Override FeatureGroup.getBounds as it doesn't work
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            if (this._topClusterLevel) bounds.extend(this._topClusterLevel._bounds);
            for(var i = this._needsClustering.length - 1; i >= 0; i--)bounds.extend(this._needsClustering[i].getLatLng());
            bounds.extend(this._nonPointGroup.getBounds());
            return bounds;
        },
        //Overrides LayerGroup.eachLayer
        eachLayer: function(method, context) {
            var markers = this._needsClustering.slice(), needsRemoving = this._needsRemoving, thisNeedsRemoving, i, j;
            if (this._topClusterLevel) this._topClusterLevel.getAllChildMarkers(markers);
            for(i = markers.length - 1; i >= 0; i--){
                thisNeedsRemoving = true;
                for(j = needsRemoving.length - 1; j >= 0; j--)if (needsRemoving[j].layer === markers[i]) {
                    thisNeedsRemoving = false;
                    break;
                }
                if (thisNeedsRemoving) method.call(context, markers[i]);
            }
            this._nonPointGroup.eachLayer(method, context);
        },
        //Overrides LayerGroup.getLayers
        getLayers: function() {
            var layers = [];
            this.eachLayer(function(l) {
                layers.push(l);
            });
            return layers;
        },
        //Overrides LayerGroup.getLayer, WARNING: Really bad performance
        getLayer: function(id) {
            var result = null;
            id = parseInt(id, 10);
            this.eachLayer(function(l) {
                if (L.stamp(l) === id) result = l;
            });
            return result;
        },
        //Returns true if the given layer is in this MarkerClusterGroup
        hasLayer: function(layer) {
            if (!layer) return false;
            var i, anArray = this._needsClustering;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i] === layer) return true;
            }
            anArray = this._needsRemoving;
            for(i = anArray.length - 1; i >= 0; i--){
                if (anArray[i].layer === layer) return false;
            }
            return !!(layer.__parent && layer.__parent._group === this) || this._nonPointGroup.hasLayer(layer);
        },
        //Zoom down to show the given layer (spiderfying if necessary) then calls the callback
        zoomToShowLayer: function(layer, callback) {
            var map = this._map;
            if (typeof callback !== 'function') callback = function() {};
            var showMarker = function() {
                // Assumes that map.hasLayer checks for direct appearance on map, not recursively calling
                // hasLayer on Layer Groups that are on map (typically not calling this MarkerClusterGroup.hasLayer, which would always return true)
                if ((map.hasLayer(layer) || map.hasLayer(layer.__parent)) && !this._inZoomAnimation) {
                    this._map.off('moveend', showMarker, this);
                    this.off('animationend', showMarker, this);
                    if (map.hasLayer(layer)) callback();
                    else if (layer.__parent._icon) {
                        this.once('spiderfied', callback, this);
                        layer.__parent.spiderfy();
                    }
                }
            };
            if (layer._icon && this._map.getBounds().contains(layer.getLatLng())) //Layer is visible ond on screen, immediate return
            callback();
            else if (layer.__parent._zoom < Math.round(this._map._zoom)) {
                //Layer should be visible at this zoom level. It must not be on screen so just pan over to it
                this._map.on('moveend', showMarker, this);
                this._map.panTo(layer.getLatLng());
            } else {
                this._map.on('moveend', showMarker, this);
                this.on('animationend', showMarker, this);
                layer.__parent.zoomToBounds();
            }
        },
        //Overrides FeatureGroup.onAdd
        onAdd: function(map) {
            this._map = map;
            var i, l, layer;
            if (!isFinite(this._map.getMaxZoom())) throw "Map has no maxZoom specified";
            this._featureGroup.addTo(map);
            this._nonPointGroup.addTo(map);
            if (!this._gridClusters) this._generateInitialClusters();
            this._maxLat = map.options.crs.projection.MAX_LATITUDE;
            //Restore all the positions as they are in the MCG before removing them
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                layer.newlatlng = layer.layer._latlng;
                layer.layer._latlng = layer.latlng;
            }
            //Remove them, then restore their new positions
            for(i = 0, l = this._needsRemoving.length; i < l; i++){
                layer = this._needsRemoving[i];
                this._removeLayer(layer.layer, true);
                layer.layer._latlng = layer.newlatlng;
            }
            this._needsRemoving = [];
            //Remember the current zoom level and bounds
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
            this._map.on('zoomend', this._zoomEnd, this);
            this._map.on('moveend', this._moveEnd, this);
            if (this._spiderfierOnAdd) this._spiderfierOnAdd();
            this._bindEvents();
            //Actually add our markers to the map:
            l = this._needsClustering;
            this._needsClustering = [];
            this.addLayers(l, true);
        },
        //Overrides FeatureGroup.onRemove
        onRemove: function(map) {
            map.off('zoomend', this._zoomEnd, this);
            map.off('moveend', this._moveEnd, this);
            this._unbindEvents();
            //In case we are in a cluster animation
            this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            if (this._spiderfierOnRemove) this._spiderfierOnRemove();
            delete this._maxLat;
            //Clean up all the layers we added to the map
            this._hideCoverage();
            this._featureGroup.remove();
            this._nonPointGroup.remove();
            this._featureGroup.clearLayers();
            this._map = null;
        },
        getVisibleParent: function(marker) {
            var vMarker = marker;
            while(vMarker && !vMarker._icon)vMarker = vMarker.__parent;
            return vMarker || null;
        },
        //Remove the given object from the given array
        _arraySplice: function(anArray, obj) {
            for(var i = anArray.length - 1; i >= 0; i--)if (anArray[i] === obj) {
                anArray.splice(i, 1);
                return true;
            }
        },
        /**
		 * Removes a marker from all _gridUnclustered zoom levels, starting at the supplied zoom.
		 * @param marker to be removed from _gridUnclustered.
		 * @param z integer bottom start zoom level (included)
		 * @private
		 */ _removeFromGridUnclustered: function(marker, z) {
            var map = this._map, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom());
            for(; z >= minZoom; z--){
                if (!gridUnclustered[z].removeObject(marker, map.project(marker.getLatLng(), z))) break;
            }
        },
        _childMarkerDragStart: function(e) {
            e.target.__dragStart = e.target._latlng;
        },
        _childMarkerMoved: function(e) {
            if (!this._ignoreMove && !e.target.__dragStart) {
                var isPopupOpen = e.target._popup && e.target._popup.isOpen();
                this._moveChild(e.target, e.oldLatLng, e.latlng);
                if (isPopupOpen) e.target.openPopup();
            }
        },
        _moveChild: function(layer, from, to) {
            layer._latlng = from;
            this.removeLayer(layer);
            layer._latlng = to;
            this.addLayer(layer);
        },
        _childMarkerDragEnd: function(e) {
            var dragStart = e.target.__dragStart;
            delete e.target.__dragStart;
            if (dragStart) this._moveChild(e.target, dragStart, e.target._latlng);
        },
        //Internal function for removing a marker from everything.
        //dontUpdateMap: set to true if you will handle updating the map manually (for bulk functions)
        _removeLayer: function(marker, removeFromDistanceGrid, dontUpdateMap) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, fg = this._featureGroup, map = this._map, minZoom = Math.floor(this._map.getMinZoom());
            //Remove the marker from distance clusters it might be in
            if (removeFromDistanceGrid) this._removeFromGridUnclustered(marker, this._maxZoom);
            //Work our way up the clusters removing them as we go if required
            var cluster = marker.__parent, markers = cluster._markers, otherMarker;
            //Remove the marker from the immediate parents marker list
            this._arraySplice(markers, marker);
            while(cluster){
                cluster._childCount--;
                cluster._boundsNeedUpdate = true;
                if (cluster._zoom < minZoom) break;
                else if (removeFromDistanceGrid && cluster._childCount <= 1) {
                    //We need to push the other marker up to the parent
                    otherMarker = cluster._markers[0] === marker ? cluster._markers[1] : cluster._markers[0];
                    //Update distance grid
                    gridClusters[cluster._zoom].removeObject(cluster, map.project(cluster._cLatLng, cluster._zoom));
                    gridUnclustered[cluster._zoom].addObject(otherMarker, map.project(otherMarker.getLatLng(), cluster._zoom));
                    //Move otherMarker up to parent
                    this._arraySplice(cluster.__parent._childClusters, cluster);
                    cluster.__parent._markers.push(otherMarker);
                    otherMarker.__parent = cluster.__parent;
                    if (cluster._icon) {
                        //Cluster is currently on the map, need to put the marker on the map instead
                        fg.removeLayer(cluster);
                        if (!dontUpdateMap) fg.addLayer(otherMarker);
                    }
                } else cluster._iconNeedsUpdate = true;
                cluster = cluster.__parent;
            }
            delete marker.__parent;
        },
        _isOrIsParent: function(el, oel) {
            while(oel){
                if (el === oel) return true;
                oel = oel.parentNode;
            }
            return false;
        },
        //Override L.Evented.fire
        fire: function(type, data, propagate) {
            if (data && data.layer instanceof L.MarkerCluster) {
                //Prevent multiple clustermouseover/off events if the icon is made up of stacked divs (Doesn't work in ie <= 8, no relatedTarget)
                if (data.originalEvent && this._isOrIsParent(data.layer._icon, data.originalEvent.relatedTarget)) return;
                type = 'cluster' + type;
            }
            L.FeatureGroup.prototype.fire.call(this, type, data, propagate);
        },
        //Override L.Evented.listens
        listens: function(type, propagate) {
            return L.FeatureGroup.prototype.listens.call(this, type, propagate) || L.FeatureGroup.prototype.listens.call(this, 'cluster' + type, propagate);
        },
        //Default functionality
        _defaultIconCreateFunction: function(cluster) {
            var childCount = cluster.getChildCount();
            var c = ' marker-cluster-';
            if (childCount < 10) c += 'small';
            else if (childCount < 100) c += 'medium';
            else c += 'large';
            return new L.DivIcon({
                html: '<div><span>' + childCount + '</span></div>',
                className: 'marker-cluster' + c,
                iconSize: new L.Point(40, 40)
            });
        },
        _bindEvents: function() {
            var map = this._map, spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom;
            //Zoom on cluster click or spiderfy if we are at the lowest level
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.on('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            //Show convex hull (boundary) polygon on mouse over
            if (showCoverageOnHover) {
                this.on('clustermouseover', this._showCoverage, this);
                this.on('clustermouseout', this._hideCoverage, this);
                map.on('zoomend', this._hideCoverage, this);
            }
        },
        _zoomOrSpiderfy: function(e) {
            var cluster = e.layer, bottomCluster = cluster;
            if (e.type === 'clusterkeypress' && e.originalEvent && e.originalEvent.keyCode !== 13) return;
            while(bottomCluster._childClusters.length === 1)bottomCluster = bottomCluster._childClusters[0];
            if (bottomCluster._zoom === this._maxZoom && bottomCluster._childCount === cluster._childCount && this.options.spiderfyOnMaxZoom) // All child markers are contained in a single cluster from this._maxZoom to this cluster.
            cluster.spiderfy();
            else if (this.options.zoomToBoundsOnClick) cluster.zoomToBounds();
            if (this.options.spiderfyOnEveryZoom) cluster.spiderfy();
            // Focus the map again for keyboard users.
            if (e.originalEvent && e.originalEvent.keyCode === 13) this._map._container.focus();
        },
        _showCoverage: function(e) {
            var map = this._map;
            if (this._inZoomAnimation) return;
            if (this._shownPolygon) map.removeLayer(this._shownPolygon);
            if (e.layer.getChildCount() > 2 && e.layer !== this._spiderfied) {
                this._shownPolygon = new L.Polygon(e.layer.getConvexHull(), this.options.polygonOptions);
                map.addLayer(this._shownPolygon);
            }
        },
        _hideCoverage: function() {
            if (this._shownPolygon) {
                this._map.removeLayer(this._shownPolygon);
                this._shownPolygon = null;
            }
        },
        _unbindEvents: function() {
            var spiderfyOnMaxZoom = this.options.spiderfyOnMaxZoom, showCoverageOnHover = this.options.showCoverageOnHover, zoomToBoundsOnClick = this.options.zoomToBoundsOnClick, spiderfyOnEveryZoom = this.options.spiderfyOnEveryZoom, map = this._map;
            if (spiderfyOnMaxZoom || zoomToBoundsOnClick || spiderfyOnEveryZoom) this.off('clusterclick clusterkeypress', this._zoomOrSpiderfy, this);
            if (showCoverageOnHover) {
                this.off('clustermouseover', this._showCoverage, this);
                this.off('clustermouseout', this._hideCoverage, this);
                map.off('zoomend', this._hideCoverage, this);
            }
        },
        _zoomEnd: function() {
            if (!this._map) return;
            this._mergeSplitClusters();
            this._zoom = Math.round(this._map._zoom);
            this._currentShownBounds = this._getExpandedVisibleBounds();
        },
        _moveEnd: function() {
            if (this._inZoomAnimation) return;
            var newBounds = this._getExpandedVisibleBounds();
            this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, newBounds);
            this._topClusterLevel._recursivelyAddChildrenToMap(null, Math.round(this._map._zoom), newBounds);
            this._currentShownBounds = newBounds;
            return;
        },
        _generateInitialClusters: function() {
            var maxZoom = Math.ceil(this._map.getMaxZoom()), minZoom = Math.floor(this._map.getMinZoom()), radius = this.options.maxClusterRadius, radiusFn = radius;
            //If we just set maxClusterRadius to a single number, we need to create
            //a simple function to return that number. Otherwise, we just have to
            //use the function we've passed in.
            if (typeof radius !== "function") radiusFn = function() {
                return radius;
            };
            if (this.options.disableClusteringAtZoom !== null) maxZoom = this.options.disableClusteringAtZoom - 1;
            this._maxZoom = maxZoom;
            this._gridClusters = {};
            this._gridUnclustered = {};
            //Set up DistanceGrids for each zoom
            for(var zoom = maxZoom; zoom >= minZoom; zoom--){
                this._gridClusters[zoom] = new L.DistanceGrid(radiusFn(zoom));
                this._gridUnclustered[zoom] = new L.DistanceGrid(radiusFn(zoom));
            }
            // Instantiate the appropriate L.MarkerCluster class (animated or not).
            this._topClusterLevel = new this._markerCluster(this, minZoom - 1);
        },
        //Zoom: Zoom to start adding at (Pass this._maxZoom to start at the bottom)
        _addLayer: function(layer, zoom) {
            var gridClusters = this._gridClusters, gridUnclustered = this._gridUnclustered, minZoom = Math.floor(this._map.getMinZoom()), markerPoint, z;
            if (this.options.singleMarkerMode) this._overrideMarkerIcon(layer);
            layer.on(this._childMarkerEventHandlers, this);
            //Find the lowest zoom level to slot this one in
            for(; zoom >= minZoom; zoom--){
                markerPoint = this._map.project(layer.getLatLng(), zoom); // calculate pixel position
                //Try find a cluster close by
                var closest = gridClusters[zoom].getNearObject(markerPoint);
                if (closest) {
                    closest._addChild(layer);
                    layer.__parent = closest;
                    return;
                }
                //Try find a marker close by to form a new cluster with
                closest = gridUnclustered[zoom].getNearObject(markerPoint);
                if (closest) {
                    var parent = closest.__parent;
                    if (parent) this._removeLayer(closest, false);
                    //Create new cluster with these 2 in it
                    var newCluster = new this._markerCluster(this, zoom, closest, layer);
                    gridClusters[zoom].addObject(newCluster, this._map.project(newCluster._cLatLng, zoom));
                    closest.__parent = newCluster;
                    layer.__parent = newCluster;
                    //First create any new intermediate parent clusters that don't exist
                    var lastParent = newCluster;
                    for(z = zoom - 1; z > parent._zoom; z--){
                        lastParent = new this._markerCluster(this, z, lastParent);
                        gridClusters[z].addObject(lastParent, this._map.project(closest.getLatLng(), z));
                    }
                    parent._addChild(lastParent);
                    //Remove closest from this zoom level and any above that it is in, replace with newCluster
                    this._removeFromGridUnclustered(closest, zoom);
                    return;
                }
                //Didn't manage to cluster in at this zoom, record us as a marker here and continue upwards
                gridUnclustered[zoom].addObject(layer, markerPoint);
            }
            //Didn't get in anything, add us to the top
            this._topClusterLevel._addChild(layer);
            layer.__parent = this._topClusterLevel;
            return;
        },
        /**
		 * Refreshes the icon of all "dirty" visible clusters.
		 * Non-visible "dirty" clusters will be updated when they are added to the map.
		 * @private
		 */ _refreshClustersIcons: function() {
            this._featureGroup.eachLayer(function(c) {
                if (c instanceof L.MarkerCluster && c._iconNeedsUpdate) c._updateIcon();
            });
        },
        //Enqueue code to fire after the marker expand/contract has happened
        _enqueue: function(fn) {
            this._queue.push(fn);
            if (!this._queueTimeout) this._queueTimeout = setTimeout(L.bind(this._processQueue, this), 300);
        },
        _processQueue: function() {
            for(var i = 0; i < this._queue.length; i++)this._queue[i].call(this);
            this._queue.length = 0;
            clearTimeout(this._queueTimeout);
            this._queueTimeout = null;
        },
        //Merge and split any existing clusters that are too big or small
        _mergeSplitClusters: function() {
            var mapZoom = Math.round(this._map._zoom);
            //In case we are starting to split before the animation finished
            this._processQueue();
            if (this._zoom < mapZoom && this._currentShownBounds.intersects(this._getExpandedVisibleBounds())) {
                this._animationStart();
                //Remove clusters now off screen
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), this._zoom, this._getExpandedVisibleBounds());
                this._animationZoomIn(this._zoom, mapZoom);
            } else if (this._zoom > mapZoom) {
                this._animationStart();
                this._animationZoomOut(this._zoom, mapZoom);
            } else this._moveEnd();
        },
        //Gets the maps visible bounds expanded in each direction by the size of the screen (so the user cannot see an area we do not cover in one pan)
        _getExpandedVisibleBounds: function() {
            if (!this.options.removeOutsideVisibleBounds) return this._mapBoundsInfinite;
            else if (L.Browser.mobile) return this._checkBoundsMaxLat(this._map.getBounds());
            return this._checkBoundsMaxLat(this._map.getBounds().pad(1)); // Padding expands the bounds by its own dimensions but scaled with the given factor.
        },
        /**
		 * Expands the latitude to Infinity (or -Infinity) if the input bounds reach the map projection maximum defined latitude
		 * (in the case of Web/Spherical Mercator, it is 85.0511287798 / see https://en.wikipedia.org/wiki/Web_Mercator#Formulas).
		 * Otherwise, the removeOutsideVisibleBounds option will remove markers beyond that limit, whereas the same markers without
		 * this option (or outside MCG) will have their position floored (ceiled) by the projection and rendered at that limit,
		 * making the user think that MCG "eats" them and never displays them again.
		 * @param bounds L.LatLngBounds
		 * @returns {L.LatLngBounds}
		 * @private
		 */ _checkBoundsMaxLat: function(bounds) {
            var maxLat = this._maxLat;
            if (maxLat !== undefined) {
                if (bounds.getNorth() >= maxLat) bounds._northEast.lat = Infinity;
                if (bounds.getSouth() <= -maxLat) bounds._southWest.lat = -Infinity;
            }
            return bounds;
        },
        //Shared animation code
        _animationAddLayerNonAnimated: function(layer, newCluster) {
            if (newCluster === layer) this._featureGroup.addLayer(layer);
            else if (newCluster._childCount === 2) {
                newCluster._addToMap();
                var markers = newCluster.getAllChildMarkers();
                this._featureGroup.removeLayer(markers[0]);
                this._featureGroup.removeLayer(markers[1]);
            } else newCluster._updateIcon();
        },
        /**
		 * Extracts individual (i.e. non-group) layers from a Layer Group.
		 * @param group to extract layers from.
		 * @param output {Array} in which to store the extracted layers.
		 * @returns {*|Array}
		 * @private
		 */ _extractNonGroupLayers: function(group, output) {
            var layers = group.getLayers(), i = 0, layer;
            output = output || [];
            for(; i < layers.length; i++){
                layer = layers[i];
                if (layer instanceof L.LayerGroup) {
                    this._extractNonGroupLayers(layer, output);
                    continue;
                }
                output.push(layer);
            }
            return output;
        },
        /**
		 * Implements the singleMarkerMode option.
		 * @param layer Marker to re-style using the Clusters iconCreateFunction.
		 * @returns {L.Icon} The newly created icon.
		 * @private
		 */ _overrideMarkerIcon: function(layer) {
            var icon = layer.options.icon = this.options.iconCreateFunction({
                getChildCount: function() {
                    return 1;
                },
                getAllChildMarkers: function() {
                    return [
                        layer
                    ];
                }
            });
            return icon;
        }
    });
    // Constant bounds used in case option "removeOutsideVisibleBounds" is set to false.
    L.MarkerClusterGroup.include({
        _mapBoundsInfinite: new L.LatLngBounds(new L.LatLng(-Infinity, -Infinity), new L.LatLng(Infinity, Infinity))
    });
    L.MarkerClusterGroup.include({
        _noAnimation: {
            //Non Animated versions of everything
            _animationStart: function() {
            //Do nothing...
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel);
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //We didn't actually animate, but we use this event to mean "clustering animations have finished"
                this.fire('animationend');
            },
            _animationAddLayer: function(layer, newCluster) {
                this._animationAddLayerNonAnimated(layer, newCluster);
            }
        },
        _withAnimation: {
            //Animated versions here
            _animationStart: function() {
                this._map._mapPane.className += ' leaflet-cluster-anim';
                this._inZoomAnimation++;
            },
            _animationZoomIn: function(previousZoomLevel, newZoomLevel) {
                var bounds = this._getExpandedVisibleBounds(), fg = this._featureGroup, minZoom = Math.floor(this._map.getMinZoom()), i;
                this._ignoreMove = true;
                //Add all children of current clusters to map and remove those clusters from map
                this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                    var startPos = c._latlng, markers = c._markers, m;
                    if (!bounds.contains(startPos)) startPos = null;
                    if (c._isSingleParent() && previousZoomLevel + 1 === newZoomLevel) {
                        fg.removeLayer(c);
                        c._recursivelyAddChildrenToMap(null, newZoomLevel, bounds);
                    } else {
                        //Fade out old cluster
                        c.clusterHide();
                        c._recursivelyAddChildrenToMap(startPos, newZoomLevel, bounds);
                    }
                    //Remove all markers that aren't visible any more
                    //TODO: Do we actually need to do this on the higher levels too?
                    for(i = markers.length - 1; i >= 0; i--){
                        m = markers[i];
                        if (!bounds.contains(m._latlng)) fg.removeLayer(m);
                    }
                });
                this._forceLayout();
                //Update opacities
                this._topClusterLevel._recursivelyBecomeVisible(bounds, newZoomLevel);
                //TODO Maybe? Update markers in _recursivelyBecomeVisible
                fg.eachLayer(function(n) {
                    if (!(n instanceof L.MarkerCluster) && n._icon) n.clusterShow();
                });
                //update the positions of the just added clusters/markers
                this._topClusterLevel._recursively(bounds, previousZoomLevel, newZoomLevel, function(c) {
                    c._recursivelyRestoreChildPositions(newZoomLevel);
                });
                this._ignoreMove = false;
                //Remove the old clusters and close the zoom animation
                this._enqueue(function() {
                    //update the positions of the just added clusters/markers
                    this._topClusterLevel._recursively(bounds, previousZoomLevel, minZoom, function(c) {
                        fg.removeLayer(c);
                        c.clusterShow();
                    });
                    this._animationEnd();
                });
            },
            _animationZoomOut: function(previousZoomLevel, newZoomLevel) {
                this._animationZoomOutSingle(this._topClusterLevel, previousZoomLevel - 1, newZoomLevel);
                //Need to add markers for those that weren't on the map before but are now
                this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds());
                //Remove markers that were on the map before but won't be now
                this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, Math.floor(this._map.getMinZoom()), previousZoomLevel, this._getExpandedVisibleBounds());
            },
            _animationAddLayer: function(layer, newCluster) {
                var me = this, fg = this._featureGroup;
                fg.addLayer(layer);
                if (newCluster !== layer) {
                    if (newCluster._childCount > 2) {
                        newCluster._updateIcon();
                        this._forceLayout();
                        this._animationStart();
                        layer._setPos(this._map.latLngToLayerPoint(newCluster.getLatLng()));
                        layer.clusterHide();
                        this._enqueue(function() {
                            fg.removeLayer(layer);
                            layer.clusterShow();
                            me._animationEnd();
                        });
                    } else {
                        this._forceLayout();
                        me._animationStart();
                        me._animationZoomOutSingle(newCluster, this._map.getMaxZoom(), this._zoom);
                    }
                }
            }
        },
        // Private methods for animated versions.
        _animationZoomOutSingle: function(cluster, previousZoomLevel, newZoomLevel) {
            var bounds = this._getExpandedVisibleBounds(), minZoom = Math.floor(this._map.getMinZoom());
            //Animate all of the markers in the clusters to move to their cluster center point
            cluster._recursivelyAnimateChildrenInAndAddSelfToMap(bounds, minZoom, previousZoomLevel + 1, newZoomLevel);
            var me = this;
            //Update the opacity (If we immediately set it they won't animate)
            this._forceLayout();
            cluster._recursivelyBecomeVisible(bounds, newZoomLevel);
            //TODO: Maybe use the transition timing stuff to make this more reliable
            //When the animations are done, tidy up
            this._enqueue(function() {
                //This cluster stopped being a cluster before the timeout fired
                if (cluster._childCount === 1) {
                    var m = cluster._markers[0];
                    //If we were in a cluster animation at the time then the opacity and position of our child could be wrong now, so fix it
                    this._ignoreMove = true;
                    m.setLatLng(m.getLatLng());
                    this._ignoreMove = false;
                    if (m.clusterShow) m.clusterShow();
                } else cluster._recursively(bounds, newZoomLevel, minZoom, function(c) {
                    c._recursivelyRemoveChildrenFromMap(bounds, minZoom, previousZoomLevel + 1);
                });
                me._animationEnd();
            });
        },
        _animationEnd: function() {
            if (this._map) this._map._mapPane.className = this._map._mapPane.className.replace(' leaflet-cluster-anim', '');
            this._inZoomAnimation--;
            this.fire('animationend');
        },
        //Force a browser layout of stuff in the map
        // Should apply the current opacity and location to all elements so we can update them again for an animation
        _forceLayout: function() {
            //In my testing this works, infact offsetWidth of any element seems to work.
            //Could loop all this._layers and do this for each _icon if it stops working
            L.Util.falseFn(document.body.offsetWidth);
        }
    });
    L.markerClusterGroup = function(options) {
        return new L.MarkerClusterGroup(options);
    };
    var MarkerCluster = L.MarkerCluster = L.Marker.extend({
        options: L.Icon.prototype.options,
        initialize: function(group, zoom, a, b) {
            L.Marker.prototype.initialize.call(this, a ? a._cLatLng || a.getLatLng() : new L.LatLng(0, 0), {
                icon: this,
                pane: group.options.clusterPane
            });
            this._group = group;
            this._zoom = zoom;
            this._markers = [];
            this._childClusters = [];
            this._childCount = 0;
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._bounds = new L.LatLngBounds();
            if (a) this._addChild(a);
            if (b) this._addChild(b);
        },
        //Recursively retrieve all child markers of this cluster
        getAllChildMarkers: function(storageArray, ignoreDraggedMarker) {
            storageArray = storageArray || [];
            for(var i = this._childClusters.length - 1; i >= 0; i--)this._childClusters[i].getAllChildMarkers(storageArray, ignoreDraggedMarker);
            for(var j = this._markers.length - 1; j >= 0; j--){
                if (ignoreDraggedMarker && this._markers[j].__dragStart) continue;
                storageArray.push(this._markers[j]);
            }
            return storageArray;
        },
        //Returns the count of how many child markers we have
        getChildCount: function() {
            return this._childCount;
        },
        //Zoom to the minimum of showing all of the child markers, or the extents of this cluster
        zoomToBounds: function(fitBoundsOptions) {
            var childClusters = this._childClusters.slice(), map = this._group._map, boundsZoom = map.getBoundsZoom(this._bounds), zoom = this._zoom + 1, mapZoom = map.getZoom(), i;
            //calculate how far we need to zoom down to see all of the markers
            while(childClusters.length > 0 && boundsZoom > zoom){
                zoom++;
                var newClusters = [];
                for(i = 0; i < childClusters.length; i++)newClusters = newClusters.concat(childClusters[i]._childClusters);
                childClusters = newClusters;
            }
            if (boundsZoom > zoom) this._group._map.setView(this._latlng, zoom);
            else if (boundsZoom <= mapZoom) this._group._map.setView(this._latlng, mapZoom + 1);
            else this._group._map.fitBounds(this._bounds, fitBoundsOptions);
        },
        getBounds: function() {
            var bounds = new L.LatLngBounds();
            bounds.extend(this._bounds);
            return bounds;
        },
        _updateIcon: function() {
            this._iconNeedsUpdate = true;
            if (this._icon) this.setIcon(this);
        },
        //Cludge for Icon, we pretend to be an icon for performance
        createIcon: function() {
            if (this._iconNeedsUpdate) {
                this._iconObj = this._group.options.iconCreateFunction(this);
                this._iconNeedsUpdate = false;
            }
            return this._iconObj.createIcon();
        },
        createShadow: function() {
            return this._iconObj.createShadow();
        },
        _addChild: function(new1, isNotificationFromChild) {
            this._iconNeedsUpdate = true;
            this._boundsNeedUpdate = true;
            this._setClusterCenter(new1);
            if (new1 instanceof L.MarkerCluster) {
                if (!isNotificationFromChild) {
                    this._childClusters.push(new1);
                    new1.__parent = this;
                }
                this._childCount += new1._childCount;
            } else {
                if (!isNotificationFromChild) this._markers.push(new1);
                this._childCount++;
            }
            if (this.__parent) this.__parent._addChild(new1, true);
        },
        /**
		 * Makes sure the cluster center is set. If not, uses the child center if it is a cluster, or the marker position.
		 * @param child L.MarkerCluster|L.Marker that will be used as cluster center if not defined yet.
		 * @private
		 */ _setClusterCenter: function(child) {
            if (!this._cLatLng) // when clustering, take position of the first point as the cluster center
            this._cLatLng = child._cLatLng || child._latlng;
        },
        /**
		 * Assigns impossible bounding values so that the next extend entirely determines the new bounds.
		 * This method avoids having to trash the previous L.LatLngBounds object and to create a new one, which is much slower for this class.
		 * As long as the bounds are not extended, most other methods would probably fail, as they would with bounds initialized but not extended.
		 * @private
		 */ _resetBounds: function() {
            var bounds = this._bounds;
            if (bounds._southWest) {
                bounds._southWest.lat = Infinity;
                bounds._southWest.lng = Infinity;
            }
            if (bounds._northEast) {
                bounds._northEast.lat = -Infinity;
                bounds._northEast.lng = -Infinity;
            }
        },
        _recalculateBounds: function() {
            var markers = this._markers, childClusters = this._childClusters, latSum = 0, lngSum = 0, totalCount = this._childCount, i, child, childLatLng, childCount;
            // Case where all markers are removed from the map and we are left with just an empty _topClusterLevel.
            if (totalCount === 0) return;
            // Reset rather than creating a new object, for performance.
            this._resetBounds();
            // Child markers.
            for(i = 0; i < markers.length; i++){
                childLatLng = markers[i]._latlng;
                this._bounds.extend(childLatLng);
                latSum += childLatLng.lat;
                lngSum += childLatLng.lng;
            }
            // Child clusters.
            for(i = 0; i < childClusters.length; i++){
                child = childClusters[i];
                // Re-compute child bounds and weighted position first if necessary.
                if (child._boundsNeedUpdate) child._recalculateBounds();
                this._bounds.extend(child._bounds);
                childLatLng = child._wLatLng;
                childCount = child._childCount;
                latSum += childLatLng.lat * childCount;
                lngSum += childLatLng.lng * childCount;
            }
            this._latlng = this._wLatLng = new L.LatLng(latSum / totalCount, lngSum / totalCount);
            // Reset dirty flag.
            this._boundsNeedUpdate = false;
        },
        //Set our markers position as given and add it to the map
        _addToMap: function(startPos) {
            if (startPos) {
                this._backupLatlng = this._latlng;
                this.setLatLng(startPos);
            }
            this._group._featureGroup.addLayer(this);
        },
        _recursivelyAnimateChildrenIn: function(bounds, center, maxZoom) {
            this._recursively(bounds, this._group._map.getMinZoom(), maxZoom - 1, function(c) {
                var markers = c._markers, i, m;
                for(i = markers.length - 1; i >= 0; i--){
                    m = markers[i];
                    //Only do it if the icon is still on the map
                    if (m._icon) {
                        m._setPos(center);
                        m.clusterHide();
                    }
                }
            }, function(c) {
                var childClusters = c._childClusters, j, cm;
                for(j = childClusters.length - 1; j >= 0; j--){
                    cm = childClusters[j];
                    if (cm._icon) {
                        cm._setPos(center);
                        cm.clusterHide();
                    }
                }
            });
        },
        _recursivelyAnimateChildrenInAndAddSelfToMap: function(bounds, mapMinZoom, previousZoomLevel, newZoomLevel) {
            this._recursively(bounds, newZoomLevel, mapMinZoom, function(c) {
                c._recursivelyAnimateChildrenIn(bounds, c._group._map.latLngToLayerPoint(c.getLatLng()).round(), previousZoomLevel);
                //TODO: depthToAnimateIn affects _isSingleParent, if there is a multizoom we may/may not be.
                //As a hack we only do a animation free zoom on a single level zoom, if someone does multiple levels then we always animate
                if (c._isSingleParent() && previousZoomLevel - 1 === newZoomLevel) {
                    c.clusterShow();
                    c._recursivelyRemoveChildrenFromMap(bounds, mapMinZoom, previousZoomLevel); //Immediately remove our children as we are replacing them. TODO previousBounds not bounds
                } else c.clusterHide();
                c._addToMap();
            });
        },
        _recursivelyBecomeVisible: function(bounds, zoomLevel) {
            this._recursively(bounds, this._group._map.getMinZoom(), zoomLevel, null, function(c) {
                c.clusterShow();
            });
        },
        _recursivelyAddChildrenToMap: function(startPos, zoomLevel, bounds) {
            this._recursively(bounds, this._group._map.getMinZoom() - 1, zoomLevel, function(c) {
                if (zoomLevel === c._zoom) return;
                //Add our child markers at startPos (so they can be animated out)
                for(var i = c._markers.length - 1; i >= 0; i--){
                    var nm = c._markers[i];
                    if (!bounds.contains(nm._latlng)) continue;
                    if (startPos) {
                        nm._backupLatlng = nm.getLatLng();
                        nm.setLatLng(startPos);
                        if (nm.clusterHide) nm.clusterHide();
                    }
                    c._group._featureGroup.addLayer(nm);
                }
            }, function(c) {
                c._addToMap(startPos);
            });
        },
        _recursivelyRestoreChildPositions: function(zoomLevel) {
            //Fix positions of child markers
            for(var i = this._markers.length - 1; i >= 0; i--){
                var nm = this._markers[i];
                if (nm._backupLatlng) {
                    nm.setLatLng(nm._backupLatlng);
                    delete nm._backupLatlng;
                }
            }
            if (zoomLevel - 1 === this._zoom) //Reposition child clusters
            for(var j = this._childClusters.length - 1; j >= 0; j--)this._childClusters[j]._restorePosition();
            else for(var k = this._childClusters.length - 1; k >= 0; k--)this._childClusters[k]._recursivelyRestoreChildPositions(zoomLevel);
        },
        _restorePosition: function() {
            if (this._backupLatlng) {
                this.setLatLng(this._backupLatlng);
                delete this._backupLatlng;
            }
        },
        //exceptBounds: If set, don't remove any markers/clusters in it
        _recursivelyRemoveChildrenFromMap: function(previousBounds, mapMinZoom, zoomLevel, exceptBounds) {
            var m, i;
            this._recursively(previousBounds, mapMinZoom - 1, zoomLevel - 1, function(c) {
                //Remove markers at every level
                for(i = c._markers.length - 1; i >= 0; i--){
                    m = c._markers[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            }, function(c) {
                //Remove child clusters at just the bottom level
                for(i = c._childClusters.length - 1; i >= 0; i--){
                    m = c._childClusters[i];
                    if (!exceptBounds || !exceptBounds.contains(m._latlng)) {
                        c._group._featureGroup.removeLayer(m);
                        if (m.clusterShow) m.clusterShow();
                    }
                }
            });
        },
        //Run the given functions recursively to this and child clusters
        // boundsToApplyTo: a L.LatLngBounds representing the bounds of what clusters to recurse in to
        // zoomLevelToStart: zoom level to start running functions (inclusive)
        // zoomLevelToStop: zoom level to stop running functions (inclusive)
        // runAtEveryLevel: function that takes an L.MarkerCluster as an argument that should be applied on every level
        // runAtBottomLevel: function that takes an L.MarkerCluster as an argument that should be applied at only the bottom level
        _recursively: function(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel) {
            var childClusters = this._childClusters, zoom = this._zoom, i, c;
            if (zoomLevelToStart <= zoom) {
                if (runAtEveryLevel) runAtEveryLevel(this);
                if (runAtBottomLevel && zoom === zoomLevelToStop) runAtBottomLevel(this);
            }
            if (zoom < zoomLevelToStart || zoom < zoomLevelToStop) for(i = childClusters.length - 1; i >= 0; i--){
                c = childClusters[i];
                if (c._boundsNeedUpdate) c._recalculateBounds();
                if (boundsToApplyTo.intersects(c._bounds)) c._recursively(boundsToApplyTo, zoomLevelToStart, zoomLevelToStop, runAtEveryLevel, runAtBottomLevel);
            }
        },
        //Returns true if we are the parent of only one cluster and that cluster is the same as us
        _isSingleParent: function() {
            //Don't need to check this._markers as the rest won't work if there are any
            return this._childClusters.length > 0 && this._childClusters[0]._childCount === this._childCount;
        }
    });
    /*
	* Extends L.Marker to include two extra methods: clusterHide and clusterShow.
	* 
	* They work as setOpacity(0) and setOpacity(1) respectively, but
	* don't overwrite the options.opacity
	* 
	*/ L.Marker.include({
        clusterHide: function() {
            var backup = this.options.opacity;
            this.setOpacity(0);
            this.options.opacity = backup;
            return this;
        },
        clusterShow: function() {
            return this.setOpacity(this.options.opacity);
        }
    });
    L.DistanceGrid = function(cellSize) {
        this._cellSize = cellSize;
        this._sqCellSize = cellSize * cellSize;
        this._grid = {};
        this._objectPoint = {};
    };
    L.DistanceGrid.prototype = {
        addObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], stamp = L.Util.stamp(obj);
            this._objectPoint[stamp] = point;
            cell.push(obj);
        },
        updateObject: function(obj, point) {
            this.removeObject(obj);
            this.addObject(obj, point);
        },
        //Returns true if the object was found
        removeObject: function(obj, point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), grid = this._grid, row = grid[y] = grid[y] || {}, cell = row[x] = row[x] || [], i, len;
            delete this._objectPoint[L.Util.stamp(obj)];
            for(i = 0, len = cell.length; i < len; i++)if (cell[i] === obj) {
                cell.splice(i, 1);
                if (len === 1) delete row[x];
                return true;
            }
        },
        eachObject: function(fn, context) {
            var i, j, k, len, row, cell, removed, grid = this._grid;
            for(i in grid){
                row = grid[i];
                for(j in row){
                    cell = row[j];
                    for(k = 0, len = cell.length; k < len; k++){
                        removed = fn.call(context, cell[k]);
                        if (removed) {
                            k--;
                            len--;
                        }
                    }
                }
            }
        },
        getNearObject: function(point) {
            var x = this._getCoord(point.x), y = this._getCoord(point.y), i, j, k, row, cell, len, obj, dist, objectPoint = this._objectPoint, closestDistSq = this._sqCellSize, closest = null;
            for(i = y - 1; i <= y + 1; i++){
                row = this._grid[i];
                if (row) for(j = x - 1; j <= x + 1; j++){
                    cell = row[j];
                    if (cell) for(k = 0, len = cell.length; k < len; k++){
                        obj = cell[k];
                        dist = this._sqDist(objectPoint[L.Util.stamp(obj)], point);
                        if (dist < closestDistSq || dist <= closestDistSq && closest === null) {
                            closestDistSq = dist;
                            closest = obj;
                        }
                    }
                }
            }
            return closest;
        },
        _getCoord: function(x) {
            var coord = Math.floor(x / this._cellSize);
            return isFinite(coord) ? coord : x;
        },
        _sqDist: function(p, p2) {
            var dx = p2.x - p.x, dy = p2.y - p.y;
            return dx * dx + dy * dy;
        }
    };
    /* Copyright (c) 2012 the authors listed at the following URL, and/or
	the authors of referenced articles or incorporated external code:
	http://en.literateprograms.org/Quickhull_(Javascript)?action=history&offset=20120410175256

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	Retrieved from: http://en.literateprograms.org/Quickhull_(Javascript)?oldid=18434
	*/ (function() {
        L.QuickHull = {
            /*
			 * @param {Object} cpt a point to be measured from the baseline
			 * @param {Array} bl the baseline, as represented by a two-element
			 *   array of latlng objects.
			 * @returns {Number} an approximate distance measure
			 */ getDistant: function(cpt, bl) {
                var vY = bl[1].lat - bl[0].lat, vX = bl[0].lng - bl[1].lng;
                return vX * (cpt.lat - bl[0].lat) + vY * (cpt.lng - bl[0].lng);
            },
            /*
			 * @param {Array} baseLine a two-element array of latlng objects
			 *   representing the baseline to project from
			 * @param {Array} latLngs an array of latlng objects
			 * @returns {Object} the maximum point and all new points to stay
			 *   in consideration for the hull.
			 */ findMostDistantPointFromBaseLine: function(baseLine, latLngs) {
                var maxD = 0, maxPt = null, newPoints = [], i, pt, d;
                for(i = latLngs.length - 1; i >= 0; i--){
                    pt = latLngs[i];
                    d = this.getDistant(pt, baseLine);
                    if (d > 0) newPoints.push(pt);
                    else continue;
                    if (d > maxD) {
                        maxD = d;
                        maxPt = pt;
                    }
                }
                return {
                    maxPoint: maxPt,
                    newPoints: newPoints
                };
            },
            /*
			 * Given a baseline, compute the convex hull of latLngs as an array
			 * of latLngs.
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ buildConvexHull: function(baseLine, latLngs) {
                var convexHullBaseLines = [], t = this.findMostDistantPointFromBaseLine(baseLine, latLngs);
                if (t.maxPoint) {
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        baseLine[0],
                        t.maxPoint
                    ], t.newPoints));
                    convexHullBaseLines = convexHullBaseLines.concat(this.buildConvexHull([
                        t.maxPoint,
                        baseLine[1]
                    ], t.newPoints));
                    return convexHullBaseLines;
                } else return [
                    baseLine[0]
                ];
            },
            /*
			 * Given an array of latlngs, compute a convex hull as an array
			 * of latlngs
			 *
			 * @param {Array} latLngs
			 * @returns {Array}
			 */ getConvexHull: function(latLngs) {
                // find first baseline
                var maxLat = false, minLat = false, maxLng = false, minLng = false, maxLatPt = null, minLatPt = null, maxLngPt = null, minLngPt = null, maxPt = null, minPt = null, i;
                for(i = latLngs.length - 1; i >= 0; i--){
                    var pt = latLngs[i];
                    if (maxLat === false || pt.lat > maxLat) {
                        maxLatPt = pt;
                        maxLat = pt.lat;
                    }
                    if (minLat === false || pt.lat < minLat) {
                        minLatPt = pt;
                        minLat = pt.lat;
                    }
                    if (maxLng === false || pt.lng > maxLng) {
                        maxLngPt = pt;
                        maxLng = pt.lng;
                    }
                    if (minLng === false || pt.lng < minLng) {
                        minLngPt = pt;
                        minLng = pt.lng;
                    }
                }
                if (minLat !== maxLat) {
                    minPt = minLatPt;
                    maxPt = maxLatPt;
                } else {
                    minPt = minLngPt;
                    maxPt = maxLngPt;
                }
                var ch = [].concat(this.buildConvexHull([
                    minPt,
                    maxPt
                ], latLngs), this.buildConvexHull([
                    maxPt,
                    minPt
                ], latLngs));
                return ch;
            }
        };
    })();
    L.MarkerCluster.include({
        getConvexHull: function() {
            var childMarkers = this.getAllChildMarkers(), points = [], p, i;
            for(i = childMarkers.length - 1; i >= 0; i--){
                p = childMarkers[i].getLatLng();
                points.push(p);
            }
            return L.QuickHull.getConvexHull(points);
        }
    });
    //This code is 100% based on https://github.com/jawj/OverlappingMarkerSpiderfier-Leaflet
    //Huge thanks to jawj for implementing it first to make my job easy :-)
    L.MarkerCluster.include({
        _2PI: Math.PI * 2,
        _circleFootSeparation: 25,
        _circleStartAngle: 0,
        _spiralFootSeparation: 28,
        _spiralLengthStart: 11,
        _spiralLengthFactor: 5,
        _circleSpiralSwitchover: 9,
        // 0 -> always spiral; Infinity -> always circle
        spiderfy: function() {
            if (this._group._spiderfied === this || this._group._inZoomAnimation) return;
            var childMarkers = this.getAllChildMarkers(null, true), group = this._group, map = group._map, center = map.latLngToLayerPoint(this._latlng), positions;
            this._group._unspiderfy();
            this._group._spiderfied = this;
            //TODO Maybe: childMarkers order by distance to center
            if (this._group.options.spiderfyShapePositions) positions = this._group.options.spiderfyShapePositions(childMarkers.length, center);
            else if (childMarkers.length >= this._circleSpiralSwitchover) positions = this._generatePointsSpiral(childMarkers.length, center);
            else {
                center.y += 10; // Otherwise circles look wrong => hack for standard blue icon, renders differently for other icons.
                positions = this._generatePointsCircle(childMarkers.length, center);
            }
            this._animationSpiderfy(childMarkers, positions);
        },
        unspiderfy: function(zoomDetails) {
            /// <param Name="zoomDetails">Argument from zoomanim if being called in a zoom animation or null otherwise</param>
            if (this._group._inZoomAnimation) return;
            this._animationUnspiderfy(zoomDetails);
            this._group._spiderfied = null;
        },
        _generatePointsCircle: function(count, centerPt) {
            var circumference = this._group.options.spiderfyDistanceMultiplier * this._circleFootSeparation * (2 + count), legLength = circumference / this._2PI, angleStep = this._2PI / count, res = [], i, angle;
            legLength = Math.max(legLength, 35); // Minimum distance to get outside the cluster icon.
            res.length = count;
            for(i = 0; i < count; i++){
                angle = this._circleStartAngle + i * angleStep;
                res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
            }
            return res;
        },
        _generatePointsSpiral: function(count, centerPt) {
            var spiderfyDistanceMultiplier = this._group.options.spiderfyDistanceMultiplier, legLength = spiderfyDistanceMultiplier * this._spiralLengthStart, separation = spiderfyDistanceMultiplier * this._spiralFootSeparation, lengthFactor = spiderfyDistanceMultiplier * this._spiralLengthFactor * this._2PI, angle = 0, res = [], i;
            res.length = count;
            // Higher index, closer position to cluster center.
            for(i = count; i >= 0; i--){
                // Skip the first position, so that we are already farther from center and we avoid
                // being under the default cluster icon (especially important for Circle Markers).
                if (i < count) res[i] = new L.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle))._round();
                angle += separation / legLength + i * 0.0005;
                legLength += lengthFactor / angle;
            }
            return res;
        },
        _noanimationUnspiderfy: function() {
            var group = this._group, map = group._map, fg = group._featureGroup, childMarkers = this.getAllChildMarkers(null, true), m, i;
            group._ignoreMove = true;
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                fg.removeLayer(m);
                if (m._preSpiderfyLatlng) {
                    m.setLatLng(m._preSpiderfyLatlng);
                    delete m._preSpiderfyLatlng;
                }
                if (m.setZIndexOffset) m.setZIndexOffset(0);
                if (m._spiderLeg) {
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
            }
            group.fire('unspiderfied', {
                cluster: this,
                markers: childMarkers
            });
            group._ignoreMove = false;
            group._spiderfied = null;
        }
    });
    //Non Animated versions of everything
    L.MarkerClusterNonAnimated = L.MarkerCluster.extend({
        _animationSpiderfy: function(childMarkers, positions) {
            var group = this._group, map = group._map, fg = group._featureGroup, legOptions = this._group.options.spiderLegPolylineOptions, i, m, leg, newPos;
            group._ignoreMove = true;
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    this._latlng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Now add the marker.
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); //Make these appear on top of EVERYTHING
                fg.addLayer(m);
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            group.fire('spiderfied', {
                cluster: this,
                markers: childMarkers
            });
        },
        _animationUnspiderfy: function() {
            this._noanimationUnspiderfy();
        }
    });
    //Animated versions here
    L.MarkerCluster.include({
        _animationSpiderfy: function(childMarkers, positions) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerLatLng = this._latlng, thisLayerPos = map.latLngToLayerPoint(thisLayerLatLng), svg = L.Path.SVG, legOptions = L.extend({}, this._group.options.spiderLegPolylineOptions), finalLegOpacity = legOptions.opacity, i, m, leg, legPath, legLength, newPos;
            if (finalLegOpacity === undefined) finalLegOpacity = L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity;
            if (svg) {
                // If the initial opacity of the spider leg is not 0 then it appears before the animation starts.
                legOptions.opacity = 0;
                // Add the class for CSS transitions.
                legOptions.className = (legOptions.className || '') + ' leaflet-cluster-spider-leg';
            } else // Make sure we have a defined opacity.
            legOptions.opacity = finalLegOpacity;
            group._ignoreMove = true;
            // Add markers and spider legs to map, hidden at our center point.
            // Traverse in ascending order to make sure that inner circleMarkers are on top of further legs. Normal markers are re-ordered by newPosition.
            // The reverse order trick no longer improves performance on modern browsers.
            for(i = 0; i < childMarkers.length; i++){
                m = childMarkers[i];
                newPos = map.layerPointToLatLng(positions[i]);
                // Add the leg before the marker, so that in case the latter is a circleMarker, the leg is behind it.
                leg = new L.Polyline([
                    thisLayerLatLng,
                    newPos
                ], legOptions);
                map.addLayer(leg);
                m._spiderLeg = leg;
                // Explanations: https://jakearchibald.com/2013/animated-line-drawing-svg/
                // In our case the transition property is declared in the CSS file.
                if (svg) {
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1; // Need a small extra length to avoid remaining dot in Firefox.
                    legPath.style.strokeDasharray = legLength; // Just 1 length is enough, it will be duplicated.
                    legPath.style.strokeDashoffset = legLength;
                }
                // If it is a marker, add it now and we'll animate it out
                if (m.setZIndexOffset) m.setZIndexOffset(1000000); // Make normal markers appear on top of EVERYTHING
                if (m.clusterHide) m.clusterHide();
                // Vectors just get immediately added
                fg.addLayer(m);
                if (m._setPos) m._setPos(thisLayerPos);
            }
            group._forceLayout();
            group._animationStart();
            // Reveal markers and spider legs.
            for(i = childMarkers.length - 1; i >= 0; i--){
                newPos = map.layerPointToLatLng(positions[i]);
                m = childMarkers[i];
                //Move marker to new position
                m._preSpiderfyLatlng = m._latlng;
                m.setLatLng(newPos);
                if (m.clusterShow) m.clusterShow();
                // Animate leg (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legPath.style.strokeDashoffset = 0;
                    //legPath.style.strokeOpacity = finalLegOpacity;
                    leg.setStyle({
                        opacity: finalLegOpacity
                    });
                }
            }
            this.setOpacity(0.3);
            group._ignoreMove = false;
            setTimeout(function() {
                group._animationEnd();
                group.fire('spiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        },
        _animationUnspiderfy: function(zoomDetails) {
            var me = this, group = this._group, map = group._map, fg = group._featureGroup, thisLayerPos = zoomDetails ? map._latLngToNewLayerPoint(this._latlng, zoomDetails.zoom, zoomDetails.center) : map.latLngToLayerPoint(this._latlng), childMarkers = this.getAllChildMarkers(null, true), svg = L.Path.SVG, m, i, leg, legPath, legLength, nonAnimatable;
            group._ignoreMove = true;
            group._animationStart();
            //Make us visible and bring the child markers back in
            this.setOpacity(1);
            for(i = childMarkers.length - 1; i >= 0; i--){
                m = childMarkers[i];
                //Marker was added to us after we were spiderfied
                if (!m._preSpiderfyLatlng) continue;
                //Close any popup on the marker first, otherwise setting the location of the marker will make the map scroll
                m.closePopup();
                //Fix up the location to the real one
                m.setLatLng(m._preSpiderfyLatlng);
                delete m._preSpiderfyLatlng;
                //Hack override the location to be our center
                nonAnimatable = true;
                if (m._setPos) {
                    m._setPos(thisLayerPos);
                    nonAnimatable = false;
                }
                if (m.clusterHide) {
                    m.clusterHide();
                    nonAnimatable = false;
                }
                if (nonAnimatable) fg.removeLayer(m);
                // Animate the spider leg back in (animation is actually delegated to CSS transition).
                if (svg) {
                    leg = m._spiderLeg;
                    legPath = leg._path;
                    legLength = legPath.getTotalLength() + 0.1;
                    legPath.style.strokeDashoffset = legLength;
                    leg.setStyle({
                        opacity: 0
                    });
                }
            }
            group._ignoreMove = false;
            setTimeout(function() {
                //If we have only <= one child left then that marker will be shown on the map so don't remove it!
                var stillThereChildCount = 0;
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (m._spiderLeg) stillThereChildCount++;
                }
                for(i = childMarkers.length - 1; i >= 0; i--){
                    m = childMarkers[i];
                    if (!m._spiderLeg) continue;
                    if (m.clusterShow) m.clusterShow();
                    if (m.setZIndexOffset) m.setZIndexOffset(0);
                    if (stillThereChildCount > 1) fg.removeLayer(m);
                    map.removeLayer(m._spiderLeg);
                    delete m._spiderLeg;
                }
                group._animationEnd();
                group.fire('unspiderfied', {
                    cluster: me,
                    markers: childMarkers
                });
            }, 200);
        }
    });
    L.MarkerClusterGroup.include({
        //The MarkerCluster currently spiderfied (if any)
        _spiderfied: null,
        unspiderfy: function() {
            this._unspiderfy.apply(this, arguments);
        },
        _spiderfierOnAdd: function() {
            this._map.on('click', this._unspiderfyWrapper, this);
            if (this._map.options.zoomAnimation) this._map.on('zoomstart', this._unspiderfyZoomStart, this);
            //Browsers without zoomAnimation or a big zoom don't fire zoomstart
            this._map.on('zoomend', this._noanimationUnspiderfy, this);
            if (!L.Browser.touch) this._map.getRenderer(this);
        },
        _spiderfierOnRemove: function() {
            this._map.off('click', this._unspiderfyWrapper, this);
            this._map.off('zoomstart', this._unspiderfyZoomStart, this);
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._map.off('zoomend', this._noanimationUnspiderfy, this);
            //Ensure that markers are back where they should be
            // Use no animation to avoid a sticky leaflet-cluster-anim class on mapPane
            this._noanimationUnspiderfy();
        },
        //On zoom start we add a zoomanim handler so that we are guaranteed to be last (after markers are animated)
        //This means we can define the animation they do rather than Markers doing an animation to their actual location
        _unspiderfyZoomStart: function() {
            if (!this._map) return;
            this._map.on('zoomanim', this._unspiderfyZoomAnim, this);
        },
        _unspiderfyZoomAnim: function(zoomDetails) {
            //Wait until the first zoomanim after the user has finished touch-zooming before running the animation
            if (L.DomUtil.hasClass(this._map._mapPane, 'leaflet-touching')) return;
            this._map.off('zoomanim', this._unspiderfyZoomAnim, this);
            this._unspiderfy(zoomDetails);
        },
        _unspiderfyWrapper: function() {
            /// <summary>_unspiderfy but passes no arguments</summary>
            this._unspiderfy();
        },
        _unspiderfy: function(zoomDetails) {
            if (this._spiderfied) this._spiderfied.unspiderfy(zoomDetails);
        },
        _noanimationUnspiderfy: function() {
            if (this._spiderfied) this._spiderfied._noanimationUnspiderfy();
        },
        //If the given layer is currently being spiderfied then we unspiderfy it so it isn't on the map anymore etc
        _unspiderfyLayer: function(layer) {
            if (layer._spiderLeg) {
                this._featureGroup.removeLayer(layer);
                if (layer.clusterShow) layer.clusterShow();
                //Position will be fixed up immediately in _animationUnspiderfy
                if (layer.setZIndexOffset) layer.setZIndexOffset(0);
                this._map.removeLayer(layer._spiderLeg);
                delete layer._spiderLeg;
            }
        }
    });
    /**
	 * Adds 1 public method to MCG and 1 to L.Marker to facilitate changing
	 * markers' icon options and refreshing their icon and their parent clusters
	 * accordingly (case where their iconCreateFunction uses data of childMarkers
	 * to make up the cluster icon).
	 */ L.MarkerClusterGroup.include({
        /**
		 * Updates the icon of all clusters which are parents of the given marker(s).
		 * In singleMarkerMode, also updates the given marker(s) icon.
		 * @param layers L.MarkerClusterGroup|L.LayerGroup|Array(L.Marker)|Map(L.Marker)|
		 * L.MarkerCluster|L.Marker (optional) list of markers (or single marker) whose parent
		 * clusters need to be updated. If not provided, retrieves all child markers of this.
		 * @returns {L.MarkerClusterGroup}
		 */ refreshClusters: function(layers) {
            if (!layers) layers = this._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.MarkerClusterGroup) layers = layers._topClusterLevel.getAllChildMarkers();
            else if (layers instanceof L.LayerGroup) layers = layers._layers;
            else if (layers instanceof L.MarkerCluster) layers = layers.getAllChildMarkers();
            else if (layers instanceof L.Marker) layers = [
                layers
            ];
             // else: must be an Array(L.Marker)|Map(L.Marker)
            this._flagParentsIconsNeedUpdate(layers);
            this._refreshClustersIcons();
            // In case of singleMarkerMode, also re-draw the markers.
            if (this.options.singleMarkerMode) this._refreshSingleMarkerModeMarkers(layers);
            return this;
        },
        /**
		 * Simply flags all parent clusters of the given markers as having a "dirty" icon.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _flagParentsIconsNeedUpdate: function(layers) {
            var id, parent;
            // Assumes layers is an Array or an Object whose prototype is non-enumerable.
            for(id in layers){
                // Flag parent clusters' icon as "dirty", all the way up.
                // Dumb process that flags multiple times upper parents, but still
                // much more efficient than trying to be smart and make short lists,
                // at least in the case of a hierarchy following a power law:
                // http://jsperf.com/flag-nodes-in-power-hierarchy/2
                parent = layers[id].__parent;
                while(parent){
                    parent._iconNeedsUpdate = true;
                    parent = parent.__parent;
                }
            }
        },
        /**
		 * Re-draws the icon of the supplied markers.
		 * To be used in singleMarkerMode only.
		 * @param layers Array(L.Marker)|Map(L.Marker) list of markers.
		 * @private
		 */ _refreshSingleMarkerModeMarkers: function(layers) {
            var id, layer;
            for(id in layers){
                layer = layers[id];
                // Make sure we do not override markers that do not belong to THIS group.
                if (this.hasLayer(layer)) // Need to re-create the icon first, then re-draw the marker.
                layer.setIcon(this._overrideMarkerIcon(layer));
            }
        }
    });
    L.Marker.include({
        /**
		 * Updates the given options in the marker's icon and refreshes the marker.
		 * @param options map object of icon options.
		 * @param directlyRefreshClusters boolean (optional) true to trigger
		 * MCG.refreshClustersOf() right away with this single marker.
		 * @returns {L.Marker}
		 */ refreshIconOptions: function(options, directlyRefreshClusters) {
            var icon = this.options.icon;
            L.setOptions(icon, options);
            this.setIcon(icon);
            // Shortcut to refresh the associated MCG clusters right away.
            // To be used when refreshing a single marker.
            // Otherwise, better use MCG.refreshClusters() once at the end with
            // the list of modified markers.
            if (directlyRefreshClusters && this.__parent) this.__parent._group.refreshClusters(this);
            return this;
        }
    });
    exports1.MarkerClusterGroup = MarkerClusterGroup;
    exports1.MarkerCluster = MarkerCluster;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


var $8b5163881eb78704$exports = {};
/*!
 Leaflet.TileLayer.Fallback 1.0.4+e36cde9
 (c) 2015-2018 Boris Seang
 License Apache-2.0
 */ 
!function(i, e) {
    "function" == typeof define && define.amd ? define([
        "leaflet"
    ], e) : e($8b5163881eb78704$exports ? (parcelRequire("8JYDX")) : i.L);
}($8b5163881eb78704$exports, function(i) {
    i.TileLayer.Fallback = i.TileLayer.extend({
        options: {
            minNativeZoom: 0
        },
        initialize: function(e, r) {
            i.TileLayer.prototype.initialize.call(this, e, r);
        },
        createTile: function(e, r) {
            var t = i.TileLayer.prototype.createTile.call(this, e, r);
            return t._originalCoords = e, t._originalSrc = t.src, t;
        },
        _createCurrentCoords: function(i) {
            var e = this._wrapCoords(i);
            return e.fallback = !0, e;
        },
        _originalTileOnError: i.TileLayer.prototype._tileOnError,
        _tileOnError: function(i, e, r) {
            var t, l, o, a = this, n = e._originalCoords, c = e._currentCoords = e._currentCoords || a._createCurrentCoords(n), s = e._fallbackZoom = void 0 === e._fallbackZoom ? n.z - 1 : e._fallbackZoom - 1, f = e._fallbackScale = 2 * (e._fallbackScale || 1), p = a.getTileSize(), u = e.style;
            if (s < a.options.minNativeZoom) return this._originalTileOnError(i, e, r);
            c.z = s, c.x = Math.floor(c.x / 2), c.y = Math.floor(c.y / 2), t = a.getTileUrl(c), u.width = p.x * f + "px", u.height = p.y * f + "px", l = (n.y - c.y * f) * p.y, u.marginTop = -l + "px", o = (n.x - c.x * f) * p.x, u.marginLeft = -o + "px", u.clip = "rect(" + l + "px " + (o + p.x) + "px " + (l + p.y) + "px " + o + "px)", a.fire("tilefallback", {
                tile: e,
                url: e._originalSrc,
                urlMissing: e.src,
                urlFallback: t
            }), e.src = t;
        },
        getTileUrl: function(e) {
            var r = e.z = e.fallback ? e.z : this._getZoomForUrl(), t = {
                r: i.Browser.retina ? "@2x" : "",
                s: this._getSubdomain(e),
                x: e.x,
                y: e.y,
                z: r
            };
            if (this._map && !this._map.options.crs.infinite) {
                var l = this._globalTileRange.max.y - e.y;
                this.options.tms && (t.y = l), t["-y"] = l;
            }
            return i.Util.template(this._url, i.extend(t, this.options));
        }
    }), i.tileLayer.fallback = function(e, r) {
        return new i.TileLayer.Fallback(e, r);
    };
});


var $b6abf3c9d720b1b1$exports = {};
!function(a, t) {
    t($b6abf3c9d720b1b1$exports);
}($b6abf3c9d720b1b1$exports, function(a) {
    "use strict";
    var o = {
        ar: {
            touch: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0625\u0635\u0628\u0639\u064A\u0646 \u0644\u062A\u062D\u0631\u064A\u0643 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
            scroll: "\u200F\u0627\u0633\u062A\u062E\u062F\u0645 ctrl + scroll \u0644\u062A\u0635\u063A\u064A\u0631/\u062A\u0643\u0628\u064A\u0631 \u0627\u0644\u062E\u0631\u064A\u0637\u0629",
            scrollMac: "\u064A\u0645\u0643\u0646\u0643 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u2318 + \u0627\u0644\u062A\u0645\u0631\u064A\u0631 \u0644\u062A\u0643\u0628\u064A\u0631/\u062A\u0635\u063A\u064A\u0631 \u0627\u0644\u062E\u0631\u064A\u0637\u0629"
        },
        bg: {
            touch: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0434\u0432\u0430 \u043F\u0440\u044A\u0441\u0442\u0430, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u043A\u0430\u0440\u0442\u0430\u0442\u0430",
            scroll: "\u0417\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 Ctrl \u043D\u0430\u0442\u0438\u0441\u043D\u0430\u0442, \u0434\u043E\u043A\u0430\u0442\u043E \u043F\u0440\u0435\u0432\u044A\u0440\u0442\u0430\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0430\u0449\u0430\u0431\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430",
            scrollMac: "\u0417\u0430\u0434\u0440\u044A\u0436\u0442\u0435 \u0431\u0443\u0442\u043E\u043D\u0430 \u2318 \u043D\u0430\u0442\u0438\u0441\u043D\u0430\u0442, \u0434\u043E\u043A\u0430\u0442\u043E \u043F\u0440\u0435\u0432\u044A\u0440\u0442\u0430\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u043C\u0435\u043D\u0438\u0442\u0435 \u043C\u0430\u0449\u0430\u0431\u0430 \u043D\u0430 \u043A\u0430\u0440\u0442\u0430\u0442\u0430"
        },
        bn: {
            touch: "\u09AE\u09BE\u09A8\u099A\u09BF\u09A4\u09CD\u09B0\u099F\u09BF\u0995\u09C7 \u09B8\u09B0\u09BE\u09A4\u09C7 \u09A6\u09C1\u099F\u09BF \u0986\u0999\u09CD\u0997\u09C1\u09B2 \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
            scroll: "\u09AE\u09CD\u09AF\u09BE\u09AA \u099C\u09C1\u09AE \u0995\u09B0\u09A4\u09C7 ctrl + scroll \u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0 \u0995\u09B0\u09C1\u09A8",
            scrollMac: "\u09AE\u09CD\u09AF\u09BE\u09AA\u09C7 \u099C\u09C1\u09AE \u0995\u09B0\u09A4\u09C7 \u2318 \u09AC\u09CB\u09A4\u09BE\u09AE \u099F\u09BF\u09AA\u09C7 \u09B8\u09CD\u0995\u09CD\u09B0\u09B2 \u0995\u09B0\u09C1\u09A8"
        },
        ca: {
            touch: "Fes servir dos dits per moure el mapa",
            scroll: "Prem la tecla Control mentre et desplaces per apropar i allunyar el mapa",
            scrollMac: "Prem la tecla \u2318 mentre et desplaces per apropar i allunyar el mapa"
        },
        cs: {
            touch: "K\xa0posunut\xed mapy pou\u017Eijte dva prsty",
            scroll: "Velikost zobrazen\xed mapy zm\u011B\u0148te podr\u017Een\xedm kl\xe1vesy Ctrl a\xa0posouv\xe1n\xedm kole\u010Dka my\u0161i",
            scrollMac: "Velikost zobrazen\xed mapy zm\u011Bn\xedte podr\u017Een\xedm kl\xe1vesy \u2318 a\xa0posunut\xedm kole\u010Dka my\u0161i / touchpadu"
        },
        da: {
            touch: "Brug to fingre til at flytte kortet",
            scroll: "Brug ctrl + rullefunktionen til at zoome ind og ud p\xe5 kortet",
            scrollMac: "Brug \u2318 + rullefunktionen til at zoome ind og ud p\xe5 kortet"
        },
        de: {
            touch: "Verschieben der Karte mit zwei Fingern",
            scroll: "Verwende Strg+Scrollen zum Zoomen der Karte",
            scrollMac: "\u2318"
        },
        el: {
            touch: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03B4\u03AC\u03C7\u03C4\u03C5\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BC\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
            scroll: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF Ctrl \u03BA\u03B1\u03B9 \u03BA\u03CD\u03BB\u03B9\u03C3\u03B7, \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03B5\u03B3\u03B5\u03B8\u03CD\u03BD\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
            scrollMac: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF \u2318 + \u03BA\u03CD\u03BB\u03B9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C3\u03C4\u03AF\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7"
        },
        en: {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        "en-AU": {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        "en-GB": {
            touch: "Use two fingers to move the map",
            scroll: "Use ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        es: {
            touch: "Para mover el mapa, utiliza dos dedos",
            scroll: "Mant\xe9n pulsada la tecla Ctrl mientras te desplazas para acercar o alejar el mapa",
            scrollMac: "Mant\xe9n pulsada la tecla \u2318 mientras te desplazas para acercar o alejar el mapa"
        },
        eu: {
            touch: "Erabili bi hatz mapa mugitzeko",
            scroll: "Mapan zooma aplikatzeko, sakatu Ktrl eta egin gora edo behera",
            scrollMac: "Eduki sakatuta \u2318 eta egin gora eta behera mapa handitu eta txikitzeko"
        },
        fa: {
            touch: "\u0628\u0631\u0627\u06CC \u062D\u0631\u06A9\u062A \u062F\u0627\u062F\u0646 \u0646\u0642\u0634\u0647 \u0627\u0632 \u062F\u0648 \u0627\u0646\u06AF\u0634\u062A \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.",
            scroll: "\u200F\u0628\u0631\u0627\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC \u0646\u0642\u0634\u0647 \u0627\u0632 ctrl + scroll \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F",
            scrollMac: "\u0628\u0631\u0627\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC \u0646\u0642\u0634\u0647\u060C \u0627\u0632 \u2318 + \u067E\u06CC\u0645\u0627\u06CC\u0634 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F."
        },
        fi: {
            touch: "Siirr\xe4 karttaa kahdella sormella.",
            scroll: "Zoomaa karttaa painamalla Ctrl-painiketta ja vieritt\xe4m\xe4ll\xe4.",
            scrollMac: "Zoomaa karttaa pit\xe4m\xe4ll\xe4 painike \u2318 painettuna ja vieritt\xe4m\xe4ll\xe4."
        },
        fil: {
            touch: "Gumamit ng dalawang daliri upang iusog ang mapa",
            scroll: "Gamitin ang ctrl + scroll upang i-zoom ang mapa",
            scrollMac: "Gamitin ang \u2318 + scroll upang i-zoom ang mapa"
        },
        fr: {
            touch: "Utilisez deux\xa0doigts pour d\xe9placer la carte",
            scroll: "Vous pouvez zoomer sur la carte \xe0 l'aide de CTRL+Molette de d\xe9filement",
            scrollMac: "Vous pouvez zoomer sur la carte \xe0 l'aide de \u2318+Molette de d\xe9filement"
        },
        gl: {
            touch: "Utiliza dous dedos para mover o mapa",
            scroll: "Preme Ctrl mentres te desprazas para ampliar o mapa",
            scrollMac: "Preme \u2318 e despr\xe1zate para ampliar o mapa"
        },
        gu: {
            touch: "\u0AA8\u0A95\u0AB6\u0ACB \u0A96\u0AB8\u0AC7\u0AA1\u0AB5\u0ABE \u0AAC\u0AC7 \u0A86\u0A82\u0A97\u0AB3\u0AC0\u0A93\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB",
            scroll: "\u0AA8\u0A95\u0AB6\u0ABE\u0AA8\u0AC7 \u0A9D\u0AC2\u0AAE \u0A95\u0AB0\u0AB5\u0ABE \u0AAE\u0ABE\u0A9F\u0AC7 ctrl + \u0AB8\u0ACD\u0A95\u0ACD\u0AB0\u0ACB\u0AB2\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB",
            scrollMac: "\u0AA8\u0A95\u0AB6\u0ABE\u0AA8\u0AC7 \u0A9D\u0AC2\u0AAE \u0A95\u0AB0\u0AB5\u0ABE \u2318 + \u0AB8\u0ACD\u0A95\u0ACD\u0AB0\u0ACB\u0AB2\u0AA8\u0ACB \u0A89\u0AAA\u0AAF\u0ACB\u0A97 \u0A95\u0AB0\u0ACB"
        },
        hi: {
            touch: "\u092E\u0948\u092A \u090F\u0915 \u091C\u0917\u0939 \u0938\u0947 \u0926\u0942\u0938\u0930\u0940 \u091C\u0917\u0939 \u0932\u0947 \u091C\u093E\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0926\u094B \u0909\u0902\u0917\u0932\u093F\u092F\u094B\u0902 \u0915\u093E \u0907\u0938\u094D\u0924\u0947\u092E\u093E\u0932 \u0915\u0930\u0947\u0902",
            scroll: "\u092E\u0948\u092A \u0915\u094B \u091C\u093C\u0942\u092E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F ctrl + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902",
            scrollMac: "\u092E\u0948\u092A \u0915\u094B \u091C\u093C\u0942\u092E \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u2318 + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902"
        },
        hr: {
            touch: "Pomi\u010Dite kartu pomo\u0107u dva prsta",
            scroll: "Upotrijebite Ctrl i kliza\u010D mi\u0161a da biste zumirali kartu",
            scrollMac: "Upotrijebite gumb \u2318 dok se pomi\u010Dete za zumiranje karte"
        },
        hu: {
            touch: "K\xe9t ujjal mozgassa a t\xe9rk\xe9pet",
            scroll: "A t\xe9rk\xe9p a ctrl + g\xf6rget\xe9s haszn\xe1lat\xe1val nagy\xedthat\xf3",
            scrollMac: "A t\xe9rk\xe9p a \u2318 + g\xf6rget\xe9s haszn\xe1lat\xe1val nagy\xedthat\xf3"
        },
        id: {
            touch: "Gunakan dua jari untuk menggerakkan peta",
            scroll: "Gunakan ctrl + scroll untuk memperbesar atau memperkecil peta",
            scrollMac: "Gunakan \u2318 + scroll untuk memperbesar atau memperkecil peta"
        },
        it: {
            touch: "Utilizza due dita per spostare la mappa",
            scroll: "Utilizza CTRL + scorrimento per eseguire lo zoom della mappa",
            scrollMac: "Utilizza \u2318 + scorrimento per eseguire lo zoom della mappa"
        },
        iw: {
            touch: "\u05D4\u05D6\u05D6 \u05D0\u05EA \u05D4\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05E9\u05EA\u05D9 \u05D0\u05E6\u05D1\u05E2\u05D5\u05EA",
            scroll: "\u200F\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05DE\u05E8\u05D7\u05E7 \u05D4\u05EA\u05E6\u05D5\u05D2\u05D4 \u05D1\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E7\u05E9 ctrl \u05D5\u05D2\u05DC\u05D9\u05DC\u05D4",
            scrollMac: "\u05D0\u05E4\u05E9\u05E8 \u05DC\u05E9\u05E0\u05D5\u05EA \u05D0\u05EA \u05DE\u05E8\u05D7\u05E7 \u05D4\u05EA\u05E6\u05D5\u05D2\u05D4 \u05D1\u05DE\u05E4\u05D4 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05DE\u05E7\u05E9 \u2318 \u05D5\u05D2\u05DC\u05D9\u05DC\u05D4"
        },
        ja: {
            touch: "\u5730\u56F3\u3092\u79FB\u52D5\u3055\u305B\u308B\u306B\u306F\u6307 2 \u672C\u3067\u64CD\u4F5C\u3057\u307E\u3059",
            scroll: "\u5730\u56F3\u3092\u30BA\u30FC\u30E0\u3059\u308B\u306B\u306F\u3001Ctrl \u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044",
            scrollMac: "\u5730\u56F3\u3092\u30BA\u30FC\u30E0\u3059\u308B\u306B\u306F\u3001\u2318 \u30AD\u30FC\u3092\u62BC\u3057\u306A\u304C\u3089\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044"
        },
        kn: {
            touch: "Use two fingers to move the map",
            scroll: "Use Ctrl + scroll to zoom the map",
            scrollMac: "Use \u2318 + scroll to zoom the map"
        },
        ko: {
            touch: "\uC9C0\uB3C4\uB97C \uC6C0\uC9C1\uC774\uB824\uBA74 \uB450 \uC190\uAC00\uB77D\uC744 \uC0AC\uC6A9\uD558\uC138\uC694.",
            scroll: "\uC9C0\uB3C4\uB97C \uD655\uB300/\uCD95\uC18C\uD558\uB824\uBA74 Ctrl\uC744 \uB204\uB978 \uCC44 \uC2A4\uD06C\uB864\uD558\uC138\uC694.",
            scrollMac: "\uC9C0\uB3C4\uB97C \uD655\uB300\uD558\uB824\uBA74 \u2318 + \uC2A4\uD06C\uB864 \uC0AC\uC6A9"
        },
        lt: {
            touch: "Perkelkite \u017Eem\u0117lap\u012F dviem pir\u0161tais",
            scroll: "Slinkite nuspaud\u0119 klavi\u0161\u0105 \u201ECtrl\u201C, kad pakeistum\u0117te \u017Eem\u0117lapio mastel\u012F",
            scrollMac: "Paspauskite klavi\u0161\u0105 \u2318 ir slinkite, kad priartintum\u0117te \u017Eem\u0117lap\u012F"
        },
        lv: {
            touch: "Lai p\u0101rvietotu karti, b\u012Bdiet to ar diviem pirkstiem",
            scroll: "Kartes t\u0101lummai\u0146ai izmantojiet ctrl + ritin\u0101\u0161anu",
            scrollMac: "Lai veiktu kartes t\u0101lummai\u0146u, izmantojiet \u2318 + ritin\u0101\u0161anu"
        },
        ml: {
            touch: "\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u0D28\u0D40\u0D15\u0D4D\u0D15\u0D3E\u0D7B \u0D30\u0D23\u0D4D\u0D1F\u0D4D \u0D35\u0D3F\u0D30\u0D32\u0D41\u0D15\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D15\u0D4D\u0D15\u0D41\u0D15",
            scroll: "\u0D15\u0D7A\u0D1F\u0D4D\u0D30\u0D4B\u0D7E + \u0D38\u0D4D\u200C\u0D15\u0D4D\u0D30\u0D4B\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D1A\u0D4D\u0D1A\u0D4D \u200C\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u200C\u0D38\u0D42\u0D02 \u0D1A\u0D46\u0D2F\u0D4D\u0D2F\u0D41\u0D15",
            scrollMac: "\u2318 + \u0D38\u0D4D\u200C\u0D15\u0D4D\u0D30\u0D4B\u0D7E \u0D09\u0D2A\u0D2F\u0D4B\u0D17\u0D3F\u0D1A\u0D4D\u0D1A\u0D4D \u200C\u0D2E\u0D3E\u0D2A\u0D4D\u0D2A\u0D4D \u200C\u0D38\u0D42\u0D02 \u0D1A\u0D46\u0D2F\u0D4D\u0D2F\u0D41\u0D15"
        },
        mr: {
            touch: "\u0928\u0915\u093E\u0936\u093E \u0939\u0932\u0935\u093F\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 \u0926\u094B\u0928 \u092C\u094B\u091F\u0947 \u0935\u093E\u092A\u0930\u093E",
            scroll: "\u0928\u0915\u093E\u0936\u093E \u091D\u0942\u092E \u0915\u0930\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 ctrl + scroll \u0935\u093E\u092A\u0930\u093E",
            scrollMac: "\u0928\u0915\u093E\u0936\u093E\u0935\u0930 \u091D\u0942\u092E \u0915\u0930\u0923\u094D\u092F\u093E\u0938\u093E\u0920\u0940 \u2318 + \u0938\u094D\u0915\u094D\u0930\u094B\u0932 \u0935\u093E\u092A\u0930\u093E"
        },
        nl: {
            touch: "Gebruik twee vingers om de kaart te verplaatsen",
            scroll: "Gebruik Ctrl + scrollen om in- en uit te zoomen op de kaart",
            scrollMac: "Gebruik \u2318 + scrollen om in en uit te zoomen op de kaart"
        },
        no: {
            touch: "Bruk to fingre for \xe5 flytte kartet",
            scroll: "Hold ctrl-tasten inne og rull for \xe5 zoome p\xe5 kartet",
            scrollMac: "Hold inne \u2318-tasten og rull for \xe5 zoome p\xe5 kartet"
        },
        pl: {
            touch: "Przesu\u0144 map\u0119 dwoma palcami",
            scroll: "Naci\u015Bnij CTRL i przewi\u0144, by przybli\u017Cy\u0107 map\u0119",
            scrollMac: "Naci\u015Bnij\xa0\u2318 i przewi\u0144, by przybli\u017Cy\u0107 map\u0119"
        },
        pt: {
            touch: "Use dois dedos para mover o mapa",
            scroll: "Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",
            scrollMac: "Use \u2318 e role a tela simultaneamente para aplicar zoom no mapa"
        },
        "pt-BR": {
            touch: "Use dois dedos para mover o mapa",
            scroll: "Pressione Ctrl e role a tela simultaneamente para aplicar zoom no mapa",
            scrollMac: "Use \u2318 e role a tela simultaneamente para aplicar zoom no mapa"
        },
        "pt-PT": {
            touch: "Utilize dois dedos para mover o mapa",
            scroll: "Utilizar ctrl + deslocar para aumentar/diminuir zoom do mapa",
            scrollMac: "Utilize \u2318 + deslocar para aumentar/diminuir o zoom do mapa"
        },
        ro: {
            touch: "Folosi\u021Bi dou\u0103 degete pentru a deplasa harta",
            scroll: "Ap\u0103sa\u021Bi tasta ctrl \u0219i derula\u021Bi simultan pentru a m\u0103ri harta",
            scrollMac: "Folosi\u021Bi \u2318 \u0219i derula\u021Bi pentru a m\u0103ri/mic\u0219ora harta"
        },
        ru: {
            touch: "\u0427\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u0443, \u043F\u0440\u043E\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E \u043D\u0435\u0439 \u0434\u0432\u0443\u043C\u044F \u043F\u0430\u043B\u044C\u0446\u0430\u043C\u0438",
            scroll: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0438\u0432\u0430\u0439\u0442\u0435 \u043A\u0430\u0440\u0442\u0443, \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044F \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Ctrl.",
            scrollMac: "\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u2318\xa0+ \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430"
        },
        sk: {
            touch: "Mapu m\xf4\u017Eete posun\xfa\u0165 dvoma prstami",
            scroll: "Ak chcete pribl\xed\u017Ei\u0165 mapu, stla\u010Dte kl\xe1ves ctrl a\xa0pos\xfavajte",
            scrollMac: "Ak chcete pribl\xed\u017Ei\u0165 mapu, stla\u010Dte kl\xe1ves \u2318 a\xa0pos\xfavajte kolieskom my\u0161i"
        },
        sl: {
            touch: "Premaknite zemljevid z dvema prstoma",
            scroll: "Zemljevid pove\u010Date tako, da dr\u017Eite tipko Ctrl in vrtite kolesce na mi\u0161ki",
            scrollMac: "Uporabite \u2318 + funkcijo pomika, da pove\u010Date ali pomanj\u0161ate zemljevid"
        },
        sr: {
            touch: "\u041C\u0430\u043F\u0443 \u043F\u043E\u043C\u0435\u0440\u0430\u0458\u0442\u0435 \u043F\u043E\u043C\u043E\u045B\u0443 \u0434\u0432\u0430 \u043F\u0440\u0441\u0442\u0430",
            scroll: "\u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 ctrl \u0442\u0430\u0441\u0442\u0435\u0440 \u0434\u043E\u043A \u043F\u043E\u043C\u0435\u0440\u0430\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u0437\u0443\u043C\u0438\u0440\u0430\u043B\u0438 \u043C\u0430\u043F\u0443",
            scrollMac: "\u041F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 \u0442\u0430\u0441\u0442\u0435\u0440 \u2318 \u0434\u043E\u043A \u043F\u043E\u043C\u0435\u0440\u0430\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u0437\u0443\u043C\u0438\u0440\u0430\u043B\u0438 \u043C\u0430\u043F\u0443"
        },
        sv: {
            touch: "Anv\xe4nd tv\xe5 fingrar f\xf6r att flytta kartan",
            scroll: "Anv\xe4nd ctrl + rulla f\xf6r att zooma kartan",
            scrollMac: "Anv\xe4nd \u2318 + rulla f\xf6r att zooma p\xe5 kartan"
        },
        ta: {
            touch: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BA8\u0B95\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4 \u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BC1 \u0BB5\u0BBF\u0BB0\u0BB2\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD",
            scroll: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAA\u0BC6\u0BB0\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF/\u0B9A\u0BBF\u0BB1\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95, ctrl \u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BC8\u0BAA\u0BCD \u0BAA\u0BBF\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF, \u0BAE\u0BC7\u0BB2\u0BC7/\u0B95\u0BC0\u0BB4\u0BC7 \u0BB8\u0BCD\u0B95\u0BCD\u0BB0\u0BBE\u0BB2\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BB5\u0BC1\u0BAE\u0BCD",
            scrollMac: "\u0BAE\u0BC7\u0BAA\u0BCD\u0BAA\u0BC8 \u0BAA\u0BC6\u0BB0\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF/\u0B9A\u0BBF\u0BB1\u0BBF\u0BA4\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAA\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95, \u2318 \u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BC8\u0BAA\u0BCD \u0BAA\u0BBF\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF, \u0BAE\u0BC7\u0BB2\u0BC7/\u0B95\u0BC0\u0BB4\u0BC7 \u0BB8\u0BCD\u0B95\u0BCD\u0BB0\u0BBE\u0BB2\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BAF\u0BB5\u0BC1\u0BAE\u0BCD"
        },
        te: {
            touch: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D\u200C\u0C28\u0C3F \u0C24\u0C30\u0C32\u0C3F\u0C02\u0C1A\u0C21\u0C02 \u0C15\u0C4B\u0C38\u0C02 \u0C30\u0C46\u0C02\u0C21\u0C41 \u0C35\u0C47\u0C33\u0C4D\u0C32\u0C28\u0C41 \u0C09\u0C2A\u0C2F\u0C4B\u0C17\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F",
            scroll: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D\u200C\u0C28\u0C3F \u0C1C\u0C42\u0C2E\u0C4D \u0C1A\u0C47\u0C2F\u0C21\u0C3E\u0C28\u0C3F\u0C15\u0C3F ctrl \u0C2C\u0C1F\u0C28\u0C4D\u200C\u0C28\u0C41 \u0C28\u0C4A\u0C15\u0C4D\u0C15\u0C3F \u0C09\u0C02\u0C1A\u0C3F, \u0C38\u0C4D\u0C15\u0C4D\u0C30\u0C4B\u0C32\u0C4D \u0C1A\u0C47\u0C2F\u0C02\u0C21\u0C3F",
            scrollMac: "\u0C2E\u0C4D\u0C2F\u0C3E\u0C2A\u0C4D \u0C1C\u0C42\u0C2E\u0C4D \u0C1A\u0C47\u0C2F\u0C3E\u0C32\u0C02\u0C1F\u0C47 \u2318 + \u0C38\u0C4D\u0C15\u0C4D\u0C30\u0C4B\u0C32\u0C4D \u0C09\u0C2A\u0C2F\u0C4B\u0C17\u0C3F\u0C02\u0C1A\u0C02\u0C21\u0C3F"
        },
        th: {
            touch: "\u0E43\u0E0A\u0E49 2 \u0E19\u0E34\u0E49\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48",
            scroll: "\u0E01\u0E14 Ctrl \u0E04\u0E49\u0E32\u0E07\u0E44\u0E27\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E39\u0E21\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48",
            scrollMac: "\u0E01\u0E14 \u2318 \u0E41\u0E25\u0E49\u0E27\u0E40\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0B\u0E39\u0E21\u0E41\u0E1C\u0E19\u0E17\u0E35\u0E48"
        },
        tl: {
            touch: "Gumamit ng dalawang daliri upang iusog ang mapa",
            scroll: "Gamitin ang ctrl + scroll upang i-zoom ang mapa",
            scrollMac: "Gamitin ang \u2318 + scroll upang i-zoom ang mapa"
        },
        tr: {
            touch: "Haritada gezinmek i\xe7in iki parma\u011F\u0131n\u0131z\u0131 kullan\u0131n",
            scroll: "Haritay\u0131 yak\u0131nla\u015Ft\u0131rmak i\xe7in ctrl + kayd\u0131rma kombinasyonunu kullan\u0131n",
            scrollMac: "Haritay\u0131 yak\u0131nla\u015Ft\u0131rmak i\xe7in \u2318 tu\u015Funa bas\u0131p ekran\u0131 kayd\u0131r\u0131n"
        },
        uk: {
            touch: "\u041F\u0435\u0440\u0435\u043C\u0456\u0449\u0443\u0439\u0442\u0435 \u043A\u0430\u0440\u0442\u0443 \u0434\u0432\u043E\u043C\u0430 \u043F\u0430\u043B\u044C\u0446\u044F\u043C\u0438",
            scroll: "\u0429\u043E\u0431 \u0437\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0439\u0442\u0435 \u043A\u043E\u043B\u0456\u0449\u0430\u0442\u043A\u043E \u043C\u0438\u0448\u0456, \u0443\u0442\u0440\u0438\u043C\u0443\u044E\u0447\u0438 \u043A\u043B\u0430\u0432\u0456\u0448\u0443 Ctrl",
            scrollMac: "\u0429\u043E\u0431 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u2318 + \u043F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0432\u0430\u043D\u043D\u044F"
        },
        vi: {
            touch: "S\u1EED d\u1EE5ng hai ng\xf3n tay \u0111\u1EC3 di chuy\u1EC3n b\u1EA3n \u0111\u1ED3",
            scroll: "S\u1EED d\u1EE5ng ctrl + cu\u1ED9n \u0111\u1EC3 thu ph\xf3ng b\u1EA3n \u0111\u1ED3",
            scrollMac: "S\u1EED d\u1EE5ng \u2318 + cu\u1ED9n \u0111\u1EC3 thu ph\xf3ng b\u1EA3n \u0111\u1ED3"
        },
        "zh-CN": {
            touch: "\u4F7F\u7528\u53CC\u6307\u79FB\u52A8\u5730\u56FE",
            scroll: "\u6309\u4F4F Ctrl \u5E76\u6EDA\u52A8\u9F20\u6807\u6EDA\u8F6E\u624D\u53EF\u7F29\u653E\u5730\u56FE",
            scrollMac: "\u6309\u4F4F \u2318 \u5E76\u6EDA\u52A8\u9F20\u6807\u6EDA\u8F6E\u624D\u53EF\u7F29\u653E\u5730\u56FE"
        },
        "zh-TW": {
            touch: "\u540C\u6642\u4EE5\u5169\u6307\u79FB\u52D5\u5730\u5716",
            scroll: "\u6309\u4F4F ctrl \u9375\u52A0\u4E0A\u6372\u52D5\u6ED1\u9F20\u53EF\u4EE5\u7E2E\u653E\u5730\u5716",
            scrollMac: "\u6309 \u2318 \u52A0\u4E0A\u6EFE\u52D5\u6372\u8EF8\u53EF\u4EE5\u7E2E\u653E\u5730\u5716"
        }
    };
    L.Map.mergeOptions({
        gestureHandlingOptions: {
            text: {},
            duration: 1e3
        }
    });
    var t = !1, e = L.Handler.extend({
        addHooks: function() {
            this._handleTouch = this._handleTouch.bind(this), this._setupPluginOptions(), this._setLanguageContent(), this._disableInteractions(), this._map._container.addEventListener("touchstart", this._handleTouch), this._map._container.addEventListener("touchmove", this._handleTouch), this._map._container.addEventListener("touchend", this._handleTouch), this._map._container.addEventListener("touchcancel", this._handleTouch), this._map._container.addEventListener("click", this._handleTouch), L.DomEvent.on(this._map._container, "wheel", this._handleScroll, this), L.DomEvent.on(this._map, "mouseover", this._handleMouseOver, this), L.DomEvent.on(this._map, "mouseout", this._handleMouseOut, this), L.DomEvent.on(this._map, "movestart", this._handleDragging, this), L.DomEvent.on(this._map, "move", this._handleDragging, this), L.DomEvent.on(this._map, "moveend", this._handleDragging, this);
        },
        removeHooks: function() {
            this._enableInteractions(), this._map._container.removeEventListener("touchstart", this._handleTouch), this._map._container.removeEventListener("touchmove", this._handleTouch), this._map._container.removeEventListener("touchend", this._handleTouch), this._map._container.removeEventListener("touchcancel", this._handleTouch), this._map._container.removeEventListener("click", this._handleTouch), L.DomEvent.off(this._map._container, "wheel", this._handleScroll, this), L.DomEvent.off(this._map, "mouseover", this._handleMouseOver, this), L.DomEvent.off(this._map, "mouseout", this._handleMouseOut, this), L.DomEvent.off(this._map, "movestart", this._handleDragging, this), L.DomEvent.off(this._map, "move", this._handleDragging, this), L.DomEvent.off(this._map, "moveend", this._handleDragging, this);
        },
        _handleDragging: function(a) {
            "movestart" == a.type || "move" == a.type ? t = !0 : "moveend" == a.type && (t = !1);
        },
        _disableInteractions: function() {
            this._map.dragging.disable(), this._map.scrollWheelZoom.disable(), this._map.tap && this._map.tap.disable();
        },
        _enableInteractions: function() {
            this._map.dragging.enable(), this._map.scrollWheelZoom.enable(), this._map.tap && this._map.tap.enable();
        },
        _setupPluginOptions: function() {
            this._map.options.gestureHandlingText && (this._map.options.gestureHandlingOptions.text = this._map.options.gestureHandlingText);
        },
        _setLanguageContent: function() {
            var a;
            if (this._map.options.gestureHandlingOptions && this._map.options.gestureHandlingOptions.text && this._map.options.gestureHandlingOptions.text.touch && this._map.options.gestureHandlingOptions.text.scroll && this._map.options.gestureHandlingOptions.text.scrollMac) a = this._map.options.gestureHandlingOptions.text;
            else {
                var t = this._getUserLanguage();
                t || (t = "en"), o[t] && (a = o[t]), a || -1 === t.indexOf("-") || (t = t.split("-")[0], a = o[t]), a || (a = o[t = "en"]);
            }
            var e = !1;
            0 <= navigator.platform.toUpperCase().indexOf("MAC") && (e = !0);
            var l = a.scroll;
            e && (l = a.scrollMac), this._map._container.setAttribute("data-gesture-handling-touch-content", a.touch), this._map._container.setAttribute("data-gesture-handling-scroll-content", l);
        },
        _getUserLanguage: function() {
            return navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
        },
        _handleTouch: function(a) {
            for(var t = [
                "leaflet-control-minimap",
                "leaflet-interactive",
                "leaflet-popup-content",
                "leaflet-popup-content-wrapper",
                "leaflet-popup-close-button",
                "leaflet-control-zoom-in",
                "leaflet-control-zoom-out"
            ], e = !1, l = 0; l < t.length; l++)L.DomUtil.hasClass(a.target, t[l]) && (e = !0);
            e ? L.DomUtil.hasClass(a.target, "leaflet-interactive") && "touchmove" === a.type && 1 === a.touches.length ? (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-touch-warning"), this._disableInteractions()) : L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning") : "touchmove" === a.type || "touchstart" === a.type ? 1 === a.touches.length ? (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-touch-warning"), this._disableInteractions()) : (a.preventDefault(), this._enableInteractions(), L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning")) : L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-touch-warning");
        },
        _isScrolling: !1,
        _handleScroll: function(a) {
            a.metaKey || a.ctrlKey ? (a.preventDefault(), L.DomUtil.removeClass(this._map._container, "leaflet-gesture-handling-scroll-warning"), this._map.scrollWheelZoom.enable()) : (L.DomUtil.addClass(this._map._container, "leaflet-gesture-handling-scroll-warning"), this._map.scrollWheelZoom.disable(), clearTimeout(this._isScrolling), this._isScrolling = setTimeout(function() {
                for(var a = document.getElementsByClassName("leaflet-gesture-handling-scroll-warning"), t = 0; t < a.length; t++)L.DomUtil.removeClass(a[t], "leaflet-gesture-handling-scroll-warning");
            }, this._map.options.gestureHandlingOptions.duration));
        },
        _handleMouseOver: function(a) {
            this._enableInteractions();
        },
        _handleMouseOut: function(a) {
            t || this._disableInteractions();
        }
    });
    L.Map.addInitHook("addHandler", "gestureHandling", e), a.GestureHandling = e, a.default = e, Object.defineProperty(a, "__esModule", {
        value: !0
    });
});


const $892d7dc6dbc410a5$var$gestureHandlingText = {
    touch: "Verschieben der Karte mit zwei Fingern",
    scroll: "Verwende Strg+Scrollen zum Zoomen der Karte",
    scrollMac: "Verwende \u2318+Scrollen zum Zoomen der Karte"
};
///////
// Wordmap-stuff
const $892d7dc6dbc410a5$var$churchMarkerConfig = {
    // size of the icon
    iconSize: [
        39,
        53
    ],
    // point of the icon which will correspond to marker's location
    iconAnchor: [
        19,
        51
    ]
};
const $892d7dc6dbc410a5$var$simpleChurchMarkerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="53.298" height="69.275" viewBox="0 0 53.298 69.275"><defs><style>.a{fill:#007f95;}.b{fill:#fff;}</style></defs><g transform="translate(-3.69)"><path class="a" d="M3.69,0,9.015,53.277h16l5.325,16,5.325-16h16L56.988,0Z"/><path class="b" d="M35.18,24.276H20.7V18.691L15.134,2,9.57,18.691V40.967c15.287-.026,7.067.057,27.71,0V29.84Z" transform="translate(6.849 2.33)"/></g></svg>`;
const $892d7dc6dbc410a5$var$complexChurchMarkerSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="53.298" height="69.275" viewBox="0 0 53.298 69.275"><defs><style>.a{fill:#850057;}.b{fill:#fff;}</style></defs><g transform="translate(-3.69)"><path class="a" d="M3.69,0,9.015,53.277h16l5.325,16,5.325-16h16L56.988,0Z"/><path class="b" d="M35.18,24.276H20.7V18.691L15.134,2,9.57,18.691V40.967H12.9v-4.46c0-1.84,2.165-3.334,2.165-3.334s2.165,1.494,2.165,3.334h0v4.46H37.28V29.84ZM24.053,38.8H21.888V32.07a1.1,1.1,0,1,1,2.165,0h0Zm4.46,0H26.347V32.07a1.1,1.1,0,1,1,2.165,0h0Zm4.46,0H30.807V32.07a1.1,1.1,0,1,1,2.165,0h0Z" transform="translate(6.849 2.33)"/></g></svg>`;
const $892d7dc6dbc410a5$var$regionMarkerSvg = `<svg width="64" height="64" xmlns="http://www.w3.org/2000/svg"><g><title>background</title><rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/></g><g><title>Layer 1</title><path fill="#037f94" id="svg_2" d="m44.525,20.734c0,-6.919 -5.608,-12.527 -12.528,-12.527s-12.527,5.608 -12.527,12.527c0,9.913 12.527,24.581 12.527,24.581s12.528,-14.719 12.528,-24.581zm-18.706,-0.748c0,-3.413 2.767,-6.179 6.179,-6.179c3.412,0 6.179,2.766 6.179,6.179c0,3.413 -2.767,6.179 -6.179,6.179c-3.412,0 -6.179,-2.766 -6.179,-6.179z"/><circle fill="#037f94" id="svg_3" r="3.038" cy="19.986" cx="31.997"/><path fill="#037f94" id="svg_4" d="m39.08,40.958c-1.021,1.475 -1.979,2.761 -2.777,3.793c7.916,0.475 13.104,2.184 15.034,3.456c-2.261,1.491 -8.98,3.587 -19.338,3.587c-10.358,0 -17.077,-2.097 -19.338,-3.587c1.93,-1.271 7.114,-2.979 15.022,-3.455c-0.8,-1.032 -1.759,-2.317 -2.781,-3.792c-9.741,0.959 -16.816,3.841 -16.816,7.246c0,4.19 10.707,7.588 23.913,7.588c13.207,0 23.912,-3.397 23.912,-7.588c0.002,-3.407 -7.081,-6.29 -16.831,-7.248z"/></g></svg>`;
const $892d7dc6dbc410a5$var$svgPrefix = "data:image/svg+xml;base64,";
/* This params can all be overriden via the params parameter (as done in `Map.elm`) or via a 
`config`-Object encoded as JSON-string (as used by the `map` content type).
This constant is also used as documentation so please make sure there is a default set for
every possible option.
*/ const $892d7dc6dbc410a5$var$defaultParams = {
    // The center of the map (if fitToWaypoints = false)
    center: [
        53.60833,
        11.396347
    ],
    // The default zoom level (if fitToWaypoints = false)
    zoom: 6,
    // Should scrolling and zooming be handled with gestures?
    // This should only be false for the main map
    gestureHandling: true,
    // Should the viewport be saved, so that it can be restored later?
    // This should only be true for the main map
    saveViewport: false,
    // A list of coords to be shown as path on the map. Coords in same format as center.
    waypoints: [],
    // Should the view be fit to the waypoints? Only works if waypoints is set.
    // Overrides zoom and center above.
    fitToWaypoints: false,
    // The color of the route drawn via waypoints
    waypointsColor: "#850057"
};
const $892d7dc6dbc410a5$var$churchMarkerIcons = {
    simple: L.icon({
        ...$892d7dc6dbc410a5$var$churchMarkerConfig,
        iconUrl: $892d7dc6dbc410a5$var$svgPrefix + btoa($892d7dc6dbc410a5$var$simpleChurchMarkerSvg),
        type: "simple"
    }),
    complex: L.icon({
        ...$892d7dc6dbc410a5$var$churchMarkerConfig,
        iconUrl: $892d7dc6dbc410a5$var$svgPrefix + btoa($892d7dc6dbc410a5$var$complexChurchMarkerSvg),
        type: "complex"
    })
};
const $892d7dc6dbc410a5$var$markerClusterIcon = (cluster)=>{
    const complexMarker = cluster.getAllChildMarkers().find((elem)=>elem.options.icon.options.type == "complex");
    const regionMarker = cluster.getAllChildMarkers().find((elem)=>elem.options.icon.options.type == "region");
    const markerCls = complexMarker == undefined ? "simple" : "complex";
    const regionCls = regionMarker == undefined ? "" : "region";
    return L.divIcon({
        className: `map-marker-cluster ${markerCls} ${regionCls}`,
        html: cluster.getChildCount(),
        iconSize: [
            42,
            42
        ]
    });
};
const $892d7dc6dbc410a5$var$regionMarkerIcon = L.icon({
    iconSize: [
        64,
        64
    ],
    iconAnchor: [
        32,
        48
    ],
    iconUrl: $892d7dc6dbc410a5$var$svgPrefix + btoa($892d7dc6dbc410a5$var$regionMarkerSvg),
    type: "region"
});
const $892d7dc6dbc410a5$export$179ddc2cadda5c47 = (map)=>{
    if (!map) return;
    map.remove();
    map.dragging.disable();
    map.scrollWheelZoom.disable();
};
const $892d7dc6dbc410a5$var$attributionString = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
window.customElements.define("leaflet-map", class LeafletMap extends HTMLElement {
    connectedCallback() {
        let config = {};
        if (this.config) try {
            config = JSON.parse(this.config);
        } catch (e) {
            // This can only be a syntax error. Print it to the console, but don't fail.
            console.error(e);
        }
        const params = {
            ...$892d7dc6dbc410a5$var$defaultParams,
            ...config,
            ...this.params
        };
        const map = L.map(this, {
            zoomControl: false,
            attributionControl: false,
            gestureHandling: params.gestureHandling,
            gestureHandlingText: $892d7dc6dbc410a5$var$gestureHandlingText
        });
        this._map = map;
        map.setView(params.center, params.zoom);
        if (params.saveViewport) map.on("moveend", ()=>document._app.ports.mapViewportChanged.send({
                center: map.getCenter(),
                zoom: map.getZoom()
            }));
        var tileSource = "https://nordkirche-osm.delink-server.net/map/{z}/{x}/{y}.png";
        if (L.Browser.retina) tileSource = "https://nordkirche-osm.delink-server.net/map2x/{z}/{x}/{y}.png";
        L.tileLayer.fallback(tileSource, {
            attribution: $892d7dc6dbc410a5$var$attributionString,
            maxZoom: 16,
            minZoom: 5,
            crossOrigin: "anonymous"
        }).addTo(map);
        L.control.zoom({
            position: "topright"
        }).addTo(map);
        L.control.attribution({
            prefix: '<a href="https://leafletjs.com">Leaflet</a>'
        }).addTo(map);
        const markerCluster = L.markerClusterGroup({
            iconCreateFunction: $892d7dc6dbc410a5$var$markerClusterIcon
        });
        this.churches.forEach((church)=>{
            const marker = L.marker([
                church.latitude,
                church.longitude
            ], {
                icon: church.complex ? $892d7dc6dbc410a5$var$churchMarkerIcons["complex"] : $892d7dc6dbc410a5$var$churchMarkerIcons["simple"]
            });
            marker.on("click", ()=>document._app.ports.mapChurchSelected.send(church.id));
            markerCluster.addLayer(marker);
        });
        this.regions.forEach((region)=>{
            const marker = L.marker([
                region.latitude,
                region.longitude
            ], {
                icon: $892d7dc6dbc410a5$var$regionMarkerIcon
            });
            marker.on("click", ()=>document._app.ports.mapRegionSelected.send(region.id));
            markerCluster.addLayer(marker);
        });
        map.addLayer(markerCluster);
        if (Array.isArray(params.waypoints) && params.waypoints.length > 0) {
            const polyline = L.polyline(params.waypoints, {
                color: params.waypointsColor
            }).addTo(map);
            const bounds = polyline.getBounds();
            if (params.fitToWaypoints && bounds.isValid()) map.fitBounds(bounds);
        }
    }
    disconnectedCallback() {
        $892d7dc6dbc410a5$export$179ddc2cadda5c47(this._map);
        this._map = null;
    }
});


parcelRequire("8JYDX");


const $325f528095f849cb$var$gestureHandlingText = {
    touch: "Verschieben des Grundrisses mit zwei Fingern",
    scroll: "Verwende Strg+Scrollen zum Zoomen des Grundrisses",
    scrollMac: "Verwende \u2318+Scrollen zum Zoomen des Grundrisses"
};
// see Views/Content/ResponsiveImage.elm
const $325f528095f849cb$var$SIZE_BREAKPOINTS = [
    {
        key: "s",
        maxWidth: 767
    },
    {
        key: "m",
        maxWidth: 991
    },
    {
        key: "l",
        maxWidth: 1199
    },
    {
        key: "xl",
        maxWidth: null
    }
];
// see Views/Content/ResponsiveImage.elm
const $325f528095f849cb$var$RATIO_THRESHOLDS = [
    {
        key: "4x",
        minRatio: 3.5
    },
    {
        key: "3x",
        minRatio: 2.5
    },
    {
        key: "2x",
        minRatio: 1.5
    },
    {
        key: "1x",
        minRatio: null
    }
];
// Offscreen styling instead of `display: none` — some browsers defer image
// loading for hidden subtrees, which breaks `<picture>` source selection.
const $325f528095f849cb$var$OFFSCREEN_STYLE = "position:absolute;width:0;height:0;visibility:hidden;pointer-events:none;";
/**
 * Builds a picture element with source elements for responsive image selection.
 */ function $325f528095f849cb$var$buildPictureElement(resizedImages, fallbackUrl) {
    const picture = document.createElement("picture");
    picture.style.cssText = $325f528095f849cb$var$OFFSCREEN_STYLE;
    for (const size of $325f528095f849cb$var$SIZE_BREAKPOINTS){
        for (const ratio of $325f528095f849cb$var$RATIO_THRESHOLDS)for (const type of [
            "webp",
            "orig"
        ]){
            const key = `${size.key}_${ratio.key}_${type}`;
            const url = resizedImages[key];
            if (!url) continue;
            const source = document.createElement("source");
            source.srcset = url;
            const mediaConditions = [];
            if (ratio.minRatio) mediaConditions.push(`(-webkit-min-device-pixel-ratio: ${ratio.minRatio})`);
            if (size.maxWidth) mediaConditions.push(`(max-width: ${size.maxWidth}px)`);
            if (mediaConditions.length > 0) source.media = mediaConditions.join(" and ");
            if (type === "webp") source.type = "image/webp";
            picture.appendChild(source);
        }
    }
    const img = document.createElement("img");
    img.src = fallbackUrl;
    picture.appendChild(img);
    return picture;
}
// Picks best URL via native `<picture>` source selection. URL is resolved
// once at connect time — viewport changes (resize, rotate) after that do not
// re-pick. Acceptable for the groundplan modal where users rarely resize
// mid-view.
async function $325f528095f849cb$var$getResponsiveImageUrl(resizedImages, fallbackUrl) {
    if (!resizedImages || Object.keys(resizedImages).length === 0) return fallbackUrl;
    const picture = $325f528095f849cb$var$buildPictureElement(resizedImages, fallbackUrl);
    const img = picture.querySelector("img");
    document.body.appendChild(picture);
    try {
        await img.decode();
        return img.currentSrc || img.src;
    } catch  {
        return fallbackUrl;
    } finally{
        picture.remove();
    }
}
window.customElements.define("leaflet-groundplan", class LeafletGroundplan extends HTMLElement {
    async connectedCallback() {
        const groundplan = L.map(this, {
            crs: L.CRS.Simple,
            minZoom: -5,
            zoomControl: false,
            attributionControl: false,
            gestureHandling: true,
            gestureHandlingText: $325f528095f849cb$var$gestureHandlingText
        });
        this._groundplan = groundplan;
        L.control.zoom({
            position: "topright"
        }).addTo(groundplan);
        const bounds = [
            [
                0,
                0
            ],
            [
                1000,
                1000
            ]
        ];
        const imageUrl = await $325f528095f849cb$var$getResponsiveImageUrl(this.params.groundplanResizedImages, this.params.groundplanImageUrl);
        if (this._groundplan !== groundplan) return;
        L.imageOverlay(imageUrl, bounds).addTo(groundplan);
        groundplan.fitBounds(bounds);
        groundplan.setZoom(groundplan.getZoom() + 1, {
            animate: false
        });
        groundplan.setMaxBounds(bounds);
        groundplan.on("drag", function() {
            groundplan.panInsideBounds(bounds, {
                animate: false
            });
        });
        const groundplanMarkers = L.featureGroup();
        this.params.pois.forEach((poi, index)=>{
            const groundplanIcon = L.divIcon({
                className: "groundplan-marker",
                html: index + 1,
                iconSize: [
                    24,
                    24
                ]
            });
            const poiMarker = L.marker([
                poi.yCoord,
                poi.xCoord
            ], {
                icon: groundplanIcon
            }).addTo(groundplan);
            poiMarker.on("click", ()=>document._app.ports.groundplanPoiSelected.send(poi.id));
            groundplanMarkers.addLayer(poiMarker);
        });
        groundplan.addLayer(groundplanMarkers);
    }
    disconnectedCallback() {
        (0, $892d7dc6dbc410a5$export$179ddc2cadda5c47)(this._groundplan);
        this._groundplan = null;
    }
});


const $2c78bf92814919af$var$canvasWidth = 2000;
const $2c78bf92814919af$var$canvasHeight = 2800;
const $2c78bf92814919af$var$imageWidth = 346;
const $2c78bf92814919af$var$imageHeight = 244;
const $2c78bf92814919af$var$imagePositions = [
    [
        1014,
        858
    ],
    [
        1014,
        1128
    ],
    [
        1014,
        1398
    ],
    [
        1014,
        1668
    ]
];
const $2c78bf92814919af$var$backgroundUrl = "/levite/_background.png";
let $2c78bf92814919af$var$backgroundImage;
const $2c78bf92814919af$var$fallbackBackground = ()=>{
    if (!$2c78bf92814919af$var$backgroundImage) {
        $2c78bf92814919af$var$backgroundImage = new Image();
        $2c78bf92814919af$var$backgroundImage.src = $2c78bf92814919af$var$backgroundUrl;
    }
    return $2c78bf92814919af$var$backgroundImage;
};
const $2c78bf92814919af$var$whenLoaded = (img)=>img.complete ? null : new Promise((resolve)=>{
        img.addEventListener('load', resolve, {
            once: true
        });
        img.addEventListener('error', resolve, {
            once: true
        });
    });
window.customElements.define("levite-chair-render", class LeviteChairRender extends HTMLElement {
    connectedCallback() {
        if (!this._output) {
            this._canvas = document.createElement('canvas');
            this._canvas.width = $2c78bf92814919af$var$canvasWidth;
            this._canvas.height = $2c78bf92814919af$var$canvasHeight;
            this._output = document.createElement('a');
            this._output.download = "Ihr Levitenstuhl.png";
            this.appendChild(this._output);
        }
        this.renderSelection();
    }
    constructor(){
        super();
        this._selection = [];
    }
    set selection(selection) {
        // two arrays are never the same in js
        if (JSON.stringify(this._selection) === JSON.stringify(selection)) return;
        this._selection = selection;
        this.renderSelection();
    }
    renderSelection() {
        if (!this._canvas || !this._output) return;
        const background = document.getElementById('levite-chair-background') || $2c78bf92814919af$var$fallbackBackground();
        const pictures = this._selection.slice(0, $2c78bf92814919af$var$imagePositions.length).map((val)=>document.getElementById(val));
        const images = [
            background,
            ...pictures
        ].filter((img)=>img);
        const renderId = this._renderId = (this._renderId || 0) + 1;
        Promise.all(images.map($2c78bf92814919af$var$whenLoaded)).then(()=>{
            if (renderId !== this._renderId || !this.isConnected) return;
            this.draw(background, pictures);
        });
    }
    draw(background, pictures) {
        const ctx = this._canvas.getContext("2d");
        const isDrawable = (img)=>img && img.complete && img.naturalWidth > 0;
        ctx.clearRect(0, 0, $2c78bf92814919af$var$canvasWidth, $2c78bf92814919af$var$canvasHeight);
        if (isDrawable(background)) ctx.drawImage(background, 0, 0, $2c78bf92814919af$var$canvasWidth, $2c78bf92814919af$var$canvasHeight);
        pictures.forEach((img, idx)=>{
            if (!isDrawable(img)) return;
            ctx.drawImage(img, $2c78bf92814919af$var$imagePositions[idx][0], $2c78bf92814919af$var$imagePositions[idx][1], $2c78bf92814919af$var$imageWidth, $2c78bf92814919af$var$imageHeight);
        });
        const url = this._canvas.toDataURL("image/png");
        const image = new Image();
        image.src = url;
        this._output.href = url.replace("image/png", "image/octet-stream");
        this._output.innerHTML = image.outerHTML;
        setTimeout(()=>{
            this._output.scrollIntoView({
                block: "end",
                behavior: "smooth"
            });
        }, 100);
    }
});


window.customElements.define("html-viewer", class WindowColor extends HTMLElement {
    connectedCallback() {
        this.innerHTML = this.content;
        this.executeScriptElements();
    }
    // Source: https://stackoverflow.com/a/69190644
    executeScriptElements() {
        const scriptElements = this.querySelectorAll("script");
        Array.from(scriptElements).forEach((scriptElement)=>{
            const clonedElement = document.createElement("script");
            Array.from(scriptElement.attributes).forEach((attribute)=>{
                clonedElement.setAttribute(attribute.name, attribute.value);
            });
            clonedElement.text = scriptElement.text;
            scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
        });
    }
});


// we need to import core of the Konva and then extend it with all additional objects
// what is core parts of Konva?
/*
 * Konva JavaScript Framework v10.9.1
 * http://konvajs.org/
 * Licensed under the MIT
 * Date: @@date
 *
 * Original work Copyright (C) 2011 - 2013 by Eric Rowell (KineticJS)
 * Modified work Copyright (C) 2014 - present by Anton Lavrenov (Konva)
 *
 * @license
 */ const $8c8384c27430fce8$var$PI_OVER_180 = Math.PI / 180;
/**
 * @namespace Konva
 */ function $8c8384c27430fce8$var$detectBrowser() {
    return typeof window !== 'undefined' && // browser case
    (({}).toString.call(window) === '[object Window]' || // electron case
    ({}).toString.call(window) === '[object global]');
}
const $8c8384c27430fce8$export$442f1a04865e4790 = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : {};
const $8c8384c27430fce8$export$b9f99057a3c7692 = {
    _global: $8c8384c27430fce8$export$442f1a04865e4790,
    version: '10.9.1',
    isBrowser: $8c8384c27430fce8$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $8c8384c27430fce8$export$b9f99057a3c7692.angleDeg ? angle * $8c8384c27430fce8$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    /**
     * Should Konva automatically update canvas on any changes. Default is true.
     * @property autoDrawEnabled
     * @default true
     * @name autoDrawEnabled
     * @memberof Konva
     * @example
     * Konva.autoDrawEnabled = true;
     */ autoDrawEnabled: true,
    /**
     * Should we enable hit detection while dragging? For performance reasons, by default it is false.
     * But on some rare cases you want to see hit graph and check intersections. Just set it to true.
     * @property hitOnDragEnabled
     * @default false
     * @name hitOnDragEnabled
     * @memberof Konva
     * @example
     * Konva.hitOnDragEnabled = true;
     */ hitOnDragEnabled: false,
    /**
     * Should we capture touch events and bind them to the touchstart target? That is how it works on DOM elements.
     * The case: we touchstart on div1, then touchmove out of that element into another element div2.
     * DOM will continue trigger touchmove events on div1 (not div2). Because events are "captured" into initial target.
     * By default Konva do not do that and will trigger touchmove on another element, while pointer is moving.
     * @property capturePointerEventsEnabled
     * @default false
     * @name capturePointerEventsEnabled
     * @memberof Konva
     * @example
     * Konva.capturePointerEventsEnabled = true;
     */ capturePointerEventsEnabled: false,
    _renderBackend: 'web',
    /**
     * Use legacy text rendering. with "middle" baseline by default.
     * @property legacyTextRendering
     * @default false
     * @name legacyTextRendering
     * @memberof Konva
     * @example
     * Konva.legacyTextRendering = true;
     */ legacyTextRendering: false,
    /**
     * Global pixel ratio configuration. KonvaJS automatically detect pixel ratio of current device.
     * But you may override such property, if you want to use your value. Set this value before any components initializations.
     * @property pixelRatio
     * @default window.devicePixelRatio || 1
     * @name pixelRatio
     * @memberof Konva
     * @example
     * // before any Konva code:
     * Konva.pixelRatio = 1;
     */ pixelRatio: typeof window !== 'undefined' && window.devicePixelRatio || 1,
    /**
     * Drag distance property. If you start to drag a node you may want to wait until pointer is moved to some distance from start point
     * on either axis, only then start dragging. Default is 3px.
     * @property dragDistance
     * @default 3
     * @memberof Konva
     * @example
     * Konva.dragDistance = 10;
     */ dragDistance: 3,
    /**
     * Use degree values for angle properties. You may set this property to false if you want to use radian values.
     * @property angleDeg
     * @default true
     * @memberof Konva
     * @example
     * node.rotation(45); // 45 degrees
     * Konva.angleDeg = false;
     * node.rotation(Math.PI / 2); // PI/2 radian
     */ angleDeg: true,
    /**
     * Show warnings about wrong API usage (`Konva.Util.warn`). Errors are always printed
     * @property showWarnings
     * @default true
     * @memberof Konva
     * @example
     * Konva.showWarnings = false;
     */ showWarnings: true,
    /**
     * Configure what mouse buttons can be used for drag and drop.
     * Default value is [0, 1] - left and middle mouse buttons.
     * @property dragButtons
     * @default [0, 1]
     * @memberof Konva
     * @example
     * // enable left and right mouse buttons
     * Konva.dragButtons = [0, 2];
     */ dragButtons: [
        0,
        1
    ],
    /**
     * returns whether or not drag and drop is currently active
     * @method
     * @memberof Konva
     */ isDragging () {
        return $8c8384c27430fce8$export$b9f99057a3c7692['DD'].isDragging;
    },
    /**
     * returns whether or not a Transformer is currently transforming a node
     * @method
     * @memberof Konva
     */ isTransforming () {
        var _a, _b;
        return (_b = (_a = $8c8384c27430fce8$export$b9f99057a3c7692['Transformer']) === null || _a === void 0 ? void 0 : _a.isTransforming()) !== null && _b !== void 0 ? _b : false;
    },
    /**
     * returns whether or not a drag and drop operation is ready, but may
     *  not necessarily have started
     * @method
     * @memberof Konva
     */ isDragReady () {
        return !!$8c8384c27430fce8$export$b9f99057a3c7692['DD'].node;
    },
    /**
     * Should Konva release canvas elements on destroy. Default is true.
     * Useful to avoid memory leak issues in Safari on macOS/iOS.
     * @property releaseCanvasOnDestroy
     * @default true
     * @name releaseCanvasOnDestroy
     * @memberof Konva
     * @example
     * Konva.releaseCanvasOnDestroy = true;
     */ releaseCanvasOnDestroy: true,
    document: $8c8384c27430fce8$export$442f1a04865e4790.document,
    // insert Konva into global namespace (window)
    // it is required for npm packages
    _injectGlobal (Konva) {
        if (typeof $8c8384c27430fce8$export$442f1a04865e4790.Konva !== 'undefined') console.error('Several Konva instances detected. It is not recommended to use multiple Konva instances in the same environment.');
        $8c8384c27430fce8$export$442f1a04865e4790.Konva = Konva;
    }
};
const $8c8384c27430fce8$export$207d43d7c3d095c2 = new Set();
const $8c8384c27430fce8$export$f7a70d87a5e829eb = (NodeClass, boundsCoverPaint = false)=>{
    $8c8384c27430fce8$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
    if (boundsCoverPaint) $8c8384c27430fce8$export$207d43d7c3d095c2.add(NodeClass);
};
$8c8384c27430fce8$export$b9f99057a3c7692._injectGlobal($8c8384c27430fce8$export$b9f99057a3c7692);



const $d4400dec7c2a8326$var$NODE_ERROR = `Konva.js unsupported environment.

Looks like you are trying to use Konva.js in Node.js environment (or in a Web Worker), because "document" object is undefined.

To use Konva.js in Node.js environment, you need to use the "canvas-backend" or "skia-backend" module.

bash: npm install canvas
js: import "konva/canvas-backend";

or

bash: npm install skia-canvas
js: import "konva/skia-backend";
`;
const $d4400dec7c2a8326$var$ensureBrowser = ()=>{
    if (typeof document === 'undefined') throw new Error($d4400dec7c2a8326$var$NODE_ERROR);
};
class $d4400dec7c2a8326$export$563a914cafbdc389 {
    constructor(m){
        this.dirty = false;
        this.m = m ? m.slice() : [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    /**
     * Copy Konva.Transform object
     * @method
     * @name Konva.Transform#copy
     * @returns {Konva.Transform}
     * @example
     * const tr = shape.getTransform().copy()
     */ copy() {
        return new $d4400dec7c2a8326$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    /**
     * Transform point
     * @method
     * @name Konva.Transform#point
     * @param {Object} point 2D point(x, y)
     * @returns {Object} 2D point(x, y)
     */ point(point) {
        const m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    // Axis-aligned bounds of a rectangle after this transform.
    _getTransformedRect(rect) {
        const [a, b, c, d, e, f] = this.m;
        const x1 = rect.x, y1 = rect.y, x2 = rect.x + rect.width, y2 = rect.y + rect.height;
        const xs = [
            a * x1 + c * y1 + e,
            a * x2 + c * y1 + e,
            a * x2 + c * y2 + e,
            a * x1 + c * y2 + e
        ];
        const ys = [
            b * x1 + d * y1 + f,
            b * x2 + d * y1 + f,
            b * x2 + d * y2 + f,
            b * x1 + d * y2 + f
        ];
        const minX = Math.min(xs[0], xs[1], xs[2], xs[3]);
        const minY = Math.min(ys[0], ys[1], ys[2], ys[3]);
        return {
            x: minX,
            y: minY,
            width: Math.max(xs[0], xs[1], xs[2], xs[3]) - minX,
            height: Math.max(ys[0], ys[1], ys[2], ys[3]) - minY
        };
    }
    /**
     * Apply translation
     * @method
     * @name Konva.Transform#translate
     * @param {Number} x
     * @param {Number} y
     * @returns {Konva.Transform}
     */ translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    /**
     * Apply scale
     * @method
     * @name Konva.Transform#scale
     * @param {Number} sx
     * @param {Number} sy
     * @returns {Konva.Transform}
     */ scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    /**
     * Apply rotation
     * @method
     * @name Konva.Transform#rotate
     * @param {Number} rad  Angle in radians
     * @returns {Konva.Transform}
     */ rotate(rad) {
        const c = Math.cos(rad);
        const s = Math.sin(rad);
        const m11 = this.m[0] * c + this.m[2] * s;
        const m12 = this.m[1] * c + this.m[3] * s;
        const m21 = this.m[0] * -s + this.m[2] * c;
        const m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    /**
     * Returns the translation
     * @method
     * @name Konva.Transform#getTranslation
     * @returns {Object} 2D point(x, y)
     */ getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    /**
     * Apply skew
     * @method
     * @name Konva.Transform#skew
     * @param {Number} sx
     * @param {Number} sy
     * @returns {Konva.Transform}
     */ skew(sx, sy) {
        const m11 = this.m[0] + this.m[2] * sy;
        const m12 = this.m[1] + this.m[3] * sy;
        const m21 = this.m[2] + this.m[0] * sx;
        const m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    /**
     * Transform multiplication
     * @method
     * @name Konva.Transform#multiply
     * @param {Konva.Transform} matrix
     * @returns {Konva.Transform}
     */ multiply(matrix) {
        const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    /**
     * Invert the matrix
     * @method
     * @name Konva.Transform#invert
     * @returns {Konva.Transform}
     */ // a transform with a zero scale on an axis has no inverse
    isInvertible() {
        return this.m[0] * this.m[3] - this.m[1] * this.m[2] !== 0;
    }
    invert() {
        const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        const m0 = this.m[3] * d;
        const m1 = -this.m[1] * d;
        const m2 = -this.m[2] * d;
        const m3 = this.m[0] * d;
        const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    /**
     * return matrix
     * @method
     * @name Konva.Transform#getMatrix
     */ getMatrix() {
        return this.m;
    }
    /**
     * convert transformation matrix back into node's attributes
     * @method
     * @name Konva.Transform#decompose
     * @returns {Konva.Transform}
     */ decompose() {
        const a = this.m[0];
        const b = this.m[1];
        const c = this.m[2];
        const d = this.m[3];
        const e = this.m[4];
        const f = this.m[5];
        const delta = a * d - b * c;
        const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        // Apply the QR-like decomposition. A zero determinant (a scale of 0, or
        // a shear that collapses the plane) has no skew, rather than a NaN or
        // an infinite one
        if (a != 0 || b != 0) {
            const r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = delta && (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = delta && (a * c + b * d) / delta;
        }
        result.rotation = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
}
// CONSTANTS
const $d4400dec7c2a8326$var$OBJECT_ARRAY = '[object Array]', $d4400dec7c2a8326$var$OBJECT_NUMBER = '[object Number]', $d4400dec7c2a8326$var$OBJECT_STRING = '[object String]', $d4400dec7c2a8326$var$OBJECT_BOOLEAN = '[object Boolean]', $d4400dec7c2a8326$var$PI_OVER_DEG180 = Math.PI / 180, $d4400dec7c2a8326$var$DEG180_OVER_PI = 180 / Math.PI, $d4400dec7c2a8326$var$HASH = '#', $d4400dec7c2a8326$var$EMPTY_STRING = '', $d4400dec7c2a8326$var$ZERO = '0', $d4400dec7c2a8326$var$KONVA_WARNING = 'Konva warning: ', $d4400dec7c2a8326$var$KONVA_ERROR = 'Konva error: ', $d4400dec7c2a8326$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        0,
        0,
        0,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
// Cache for canvas farbling detection
let $d4400dec7c2a8326$var$_isCanvasFarblingActive = null;
// A stage may be rendered in another window than the one Konva was imported
// into, and a window that is not visible gives almost no frames. So frames are
// asked from the window of the stage, and the callbacks are kept per window
const $d4400dec7c2a8326$var$defaultWindow = typeof window !== 'undefined' ? window : {};
const $d4400dec7c2a8326$var$animQueues = new WeakMap();
const $d4400dec7c2a8326$var$requestFrame = (win, f)=>{
    if (typeof win.requestAnimationFrame === 'function') win.requestAnimationFrame(f);
    else if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(f);
    else setTimeout(f, 16); // 60fps ≈ 16.67ms per frame
};
const $d4400dec7c2a8326$var$capitalizeCache = new Map();
const $d4400dec7c2a8326$export$914b3a8889b8a8a9 = Object.getPrototypeOf(Int8Array);
// Split the components of rgb()/hsl(). CSS separates them with commas (legacy
// syntax), or with spaces and a slash before the alpha (CSS Color 4 syntax),
// but never with both. Keep the two apart, so that a space inside a
// comma-separated color adds no component. A component the user left empty
// stays as "", which then fails the color.
const $d4400dec7c2a8326$var$splitColorComponents = (str)=>{
    const components = str.trim();
    return components.indexOf(',') === -1 ? components.split(/\s*\/\s*|\s+/) : components.split(/\s*,\s*/);
};
// A CSS number: "50", "-0.5", ".5", "1e2". Everything else, from "50abc" to
// "0x10" and "1.2.3", is not a number and makes the color fail.
const $d4400dec7c2a8326$var$NUMBER_SOURCE = '[+-]?(?:\\d+\\.?\\d*|\\.\\d+)(?:e[+-]?\\d+)?';
// A component is a number with an optional "%" sign.
const $d4400dec7c2a8326$var$COLOR_COMPONENT_REGEX = new RegExp(`^(${$d4400dec7c2a8326$var$NUMBER_SOURCE})(%?)$`, 'i');
// Parse one color component. 100% is `max`: 255 for the color channels of
// rgb(), 1 for the alpha, 100 for the saturation and the lightness of hsl().
// CSS clamps a component to [0, max], and so do we: Konva multiplies and
// interpolates these numbers (shadowOpacity, Tween) before the canvas sees
// them. NaN stays NaN, so a bad value still fails.
const $d4400dec7c2a8326$var$parseColorComponent = (value, max)=>{
    const match = $d4400dec7c2a8326$var$COLOR_COMPONENT_REGEX.exec(value);
    if (!match) return NaN;
    const n = match[2] ? Number(match[1]) / 100 * max : Number(match[1]);
    return Math.min(Math.max(n, 0), max);
};
// parseInt() stops at the first character it can not read, so "#0g0000" would
// give a valid black instead of failing. The hex parsers test the shape first.
const $d4400dec7c2a8326$var$HEX_COLOR_REGEX = /^#[0-9a-f]+$/i;
// The hue of hsl() is the same number, with a CSS Color 4 angle unit
// instead of the "%" sign. No unit means degrees.
const $d4400dec7c2a8326$var$HUE_REGEX = new RegExp(`^(${$d4400dec7c2a8326$var$NUMBER_SOURCE})(deg|grad|rad|turn)?$`, 'i');
const $d4400dec7c2a8326$var$HUE_UNITS = {
    deg: 1,
    grad: 0.9,
    rad: $d4400dec7c2a8326$var$DEG180_OVER_PI,
    turn: 360
};
/**
 * @namespace Util
 * @memberof Konva
 */ // a negative corner radius would throw in context.arc()
function $d4400dec7c2a8326$var$clampRadius(radius, max) {
    return Math.min(Math.max(radius || 0, 0), max);
}
const $d4400dec7c2a8326$export$f8f26dd395d7e1bd = {
    /*
     * cherry-picked utilities from underscore.js
     */ _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $d4400dec7c2a8326$var$OBJECT_BOOLEAN;
    },
    // arrays are objects too
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== 'string') return false;
        const firstChar = selector[0];
        return firstChar === '#' || firstChar === '.' || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) // that is not what sign usually returns
        // but that is what we need
        return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback, win) {
        const target = win && !win.closed && win || $d4400dec7c2a8326$var$defaultWindow;
        let queue = $d4400dec7c2a8326$var$animQueues.get(target);
        if (!queue) {
            queue = [];
            $d4400dec7c2a8326$var$animQueues.set(target, queue);
            $d4400dec7c2a8326$var$requestFrame(target, function() {
                $d4400dec7c2a8326$var$animQueues.delete(target);
                queue.forEach(function(cb) {
                    cb();
                });
            });
        }
        queue.push(callback);
    },
    createCanvasElement () {
        $d4400dec7c2a8326$var$ensureBrowser();
        const canvas = document.createElement('canvas');
        // on some environments canvas.style is readonly
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        $d4400dec7c2a8326$var$ensureBrowser();
        return document.createElement('img');
    },
    /*
     * arg can be an image object or image data
     */ _urlToImage (url, callback, onError) {
        // if arg is a string, then it's a data url
        const imageObj = $d4400dec7c2a8326$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.onerror = (event)=>{
            onError === null || onError === void 0 || onError(event instanceof Error ? event : new Error('Unable to load image.'));
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($d4400dec7c2a8326$var$HASH, $d4400dec7c2a8326$var$EMPTY_STRING);
        const bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    /**
     * return random hex color
     * @method
     * @memberof Konva.Util
     * @example
     * shape.fill(Konva.Util.getRandomColor());
     */ getRandomColor () {
        let randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $d4400dec7c2a8326$var$ZERO + randColor;
        return $d4400dec7c2a8326$var$HASH + randColor;
    },
    /**
     * Check if canvas farbling is active (e.g., Brave browser fingerprinting protection)
     * @method
     * @memberof Konva.Util
     * @returns {Boolean}
     */ isCanvasFarblingActive () {
        if ($d4400dec7c2a8326$var$_isCanvasFarblingActive !== null) return $d4400dec7c2a8326$var$_isCanvasFarblingActive;
        if (typeof document === 'undefined') {
            $d4400dec7c2a8326$var$_isCanvasFarblingActive = false;
            return false;
        }
        const c = this.createCanvasElement();
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext('2d', {
            willReadFrequently: true
        });
        ctx.clearRect(0, 0, 10, 10);
        ctx.fillStyle = '#282828'; // 40, 40, 40
        ctx.fillRect(0, 0, 10, 10);
        const d = ctx.getImageData(0, 0, 10, 10).data;
        let isFarbling = false;
        for(let i = 0; i < 100; i++)if (d[i * 4] !== 40 || d[i * 4 + 1] !== 40 || d[i * 4 + 2] !== 40 || d[i * 4 + 3] !== 255) {
            isFarbling = true;
            break;
        }
        $d4400dec7c2a8326$var$_isCanvasFarblingActive = isFarbling;
        this.releaseCanvas(c);
        return $d4400dec7c2a8326$var$_isCanvasFarblingActive;
    },
    /**
     * Get a random color for hit detection (snapped to the hit color grid)
     * @method
     * @memberof Konva.Util
     * @returns {String} hex color string
     */ getHitColor () {
        const channel = ()=>Math.random() * 256 | 0;
        return this.getHitColorKey(channel(), channel(), channel());
    },
    /**
     * Get hit color key from RGB values (snapped to the hit color grid)
     * @method
     * @memberof Konva.Util
     * @param {Number} r - red component (0-255)
     * @param {Number} g - green component (0-255)
     * @param {Number} b - blue component (0-255)
     * @returns {String} hex color key string
     */ getHitColorKey (r, g, b) {
        // hit colours live on a grid, so a pixel of the hit graph that reads
        // back slightly off still rounds to the key of its shape: an edge pixel
        // is stored premultiplied by its alpha and comes back off by up to one
        // per channel, canvas farbling (Brave) adds a little noise on top
        const step = this.isCanvasFarblingActive() ? 5 : 3;
        const snap = (value)=>Math.round(value / step) * step;
        return $d4400dec7c2a8326$var$HASH + this._rgbToHex(snap(r), snap(g), snap(b));
    },
    /**
     * Snap a hex color to the hit color grid
     * @method
     * @memberof Konva.Util
     * @param {String} hex - hex color string (e.g., "#ff00ff")
     * @returns {String} snapped hex color string
     */ getSnappedHexColor (hex) {
        const { r: r, g: g, b: b } = this._hexToRgb(hex);
        return this.getHitColorKey(r, g, b);
    },
    /**
     * get RGB components of a color
     * @method
     * @memberof Konva.Util
     * @param {String} color
     * @example
     * // each of the following examples return {r:0, g:0, b:255}
     * var rgb = Konva.Util.getRGB('blue');
     * var rgb = Konva.Util.getRGB('#0000ff');
     * var rgb = Konva.Util.getRGB('rgb(0,0,255)');
     */ getRGB (color) {
        var _a;
        // black for a color we can not parse
        const { r: r = 0, g: g = 0, b: b = 0 } = (_a = $d4400dec7c2a8326$export$f8f26dd395d7e1bd.colorToRGBA(color)) !== null && _a !== void 0 ? _a : {};
        return {
            r: r,
            g: g,
            b: b
        };
    },
    // convert any color string to RGBA object
    // from https://github.com/component/color-parser
    colorToRGBA (str) {
        // a CSS custom property keeps the space after the colon,
        // so "--brand: #ff0000" gives us " #ff0000"
        str = (str || '').trim() || 'black';
        const color = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
        // a NaN component stays invisible until it reaches the canvas and drops the
        // shape, so a color we can not fully parse must fail as a whole
        if (color && [
            color.r,
            color.g,
            color.b,
            color.a
        ].every($d4400dec7c2a8326$export$f8f26dd395d7e1bd._isNumber)) return color;
    },
    // Parse named css color. Like "green"
    _namedColorToRBA (str) {
        const c = $d4400dec7c2a8326$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: c.length > 3 ? c[3] : 1
        };
    },
    // Parse rgb(n, n, n), rgba(n, n, n, n) and rgb(n n n / n)
    _rgbColorToRGBA (str) {
        const match = /^rgba?\(([^)]*)\)$/i.exec(str);
        if (!match) return;
        const parts = $d4400dec7c2a8326$var$splitColorComponents(match[1]);
        if (parts.length < 3 || parts.length > 4) return;
        return {
            r: $d4400dec7c2a8326$var$parseColorComponent(parts[0], 255),
            g: $d4400dec7c2a8326$var$parseColorComponent(parts[1], 255),
            b: $d4400dec7c2a8326$var$parseColorComponent(parts[2], 255),
            a: parts.length > 3 ? $d4400dec7c2a8326$var$parseColorComponent(parts[3], 1) : 1
        };
    },
    // Parse #nnnnnnnn
    _hex8ColorToRGBA (str) {
        if (str.length === 9 && $d4400dec7c2a8326$var$HEX_COLOR_REGEX.test(str)) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    // Parse #nnnnnn
    _hex6ColorToRGBA (str) {
        if (str.length === 7 && $d4400dec7c2a8326$var$HEX_COLOR_REGEX.test(str)) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    // Parse #nnnn
    _hex4ColorToRGBA (str) {
        if (str.length === 5 && $d4400dec7c2a8326$var$HEX_COLOR_REGEX.test(str)) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    // Parse #nnn
    _hex3ColorToRGBA (str) {
        if (str.length === 4 && $d4400dec7c2a8326$var$HEX_COLOR_REGEX.test(str)) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    // Code adapted from https://github.com/Qix-/color-convert/blob/master/conversions.js#L244
    // Parse hsl(h, s%, l%), hsla(h, s%, l%, n) and hsl(h s% l% / n)
    _hslColorToRGBA (str) {
        const match = /^hsla?\(([^)]*)\)$/i.exec(str);
        if (!match) return;
        const parts = $d4400dec7c2a8326$var$splitColorComponents(match[1]);
        if (parts.length < 3 || parts.length > 4) return;
        // a hue we can not parse gives a gray color instead of a NaN one,
        // so colorToRGBA() can not catch it at the end
        const hue = $d4400dec7c2a8326$var$HUE_REGEX.exec(parts[0]);
        if (!hue) return;
        const unit = hue[2];
        const degrees = Number(hue[1]) * (unit ? $d4400dec7c2a8326$var$HUE_UNITS[unit.toLowerCase()] : 1);
        if (!isFinite(degrees)) return;
        // the hue is an angle, so keep it in [0, 360) to also accept
        // negative angles and angles over one full turn
        const h = (degrees % 360 + 360) % 360 / 360;
        // the saturation and the lightness are percentages of 1, written with or
        // without the "%" sign, so read them out of 100 and then scale them down
        const s = $d4400dec7c2a8326$var$parseColorComponent(parts[1], 100) / 100;
        const l = $d4400dec7c2a8326$var$parseColorComponent(parts[2], 100) / 100;
        const a = parts.length > 3 ? $d4400dec7c2a8326$var$parseColorComponent(parts[3], 1) : 1;
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const rgb = [
            0,
            0,
            0
        ];
        for(let i = 0; i < 3; i++){
            let t3 = h + 1 / 3 * -(i - 1);
            if (t3 < 0) t3++;
            if (t3 > 1) t3--;
            let val;
            if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
            else if (2 * t3 < 1) val = t2;
            else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
            else val = t1;
            rgb[i] = val * 255;
        }
        return {
            r: Math.round(rgb[0]),
            g: Math.round(rgb[1]),
            b: Math.round(rgb[2]),
            a: a
        };
    },
    // the bounds of a flat [x0, y0, x1, y1, ...] array. A NaN coordinate is
    // skipped so one bad point cannot turn the whole box into NaN; no usable
    // point at all is an empty rect
    _getPointsRect (points) {
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        for(let i = 0; i < points.length; i += 2){
            const x = points[i];
            const y = points[i + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        if (!isFinite(minX + minY)) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    },
    /**
     * check intersection of two client rectangles
     * @method
     * @memberof Konva.Util
     * @param {Object} r1 - { x, y, width, height } client rectangle
     * @param {Object} r2 - { x, y, width, height } client rectangle
     * @example
     * const overlapping = Konva.Util.haveIntersection(shape1.getClientRect(), shape2.getClientRect());
     */ haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    // a deep copy of plain objects and arrays; class instances and elements
    // are shared, typed arrays are copied
    cloneObject (obj) {
        const copy = {};
        for(const key in obj)copy[key] = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._cloneValue(obj[key]);
        return copy;
    },
    _cloneValue (val) {
        if ($d4400dec7c2a8326$export$f8f26dd395d7e1bd._isArray(val)) // a flat array (points) is sliced, an array holding objects copied deep
        return val.some((item)=>typeof item === 'object') ? val.map($d4400dec7c2a8326$export$f8f26dd395d7e1bd._cloneValue) : val.slice();
        if ($d4400dec7c2a8326$export$f8f26dd395d7e1bd._isPlainObject(val)) return $d4400dec7c2a8326$export$f8f26dd395d7e1bd.cloneObject(val);
        return val instanceof $d4400dec7c2a8326$export$914b3a8889b8a8a9 ? val.slice() : val;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $d4400dec7c2a8326$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $d4400dec7c2a8326$var$DEG180_OVER_PI;
    },
    _getRotation (radians) {
        return (0, $8c8384c27430fce8$export$b9f99057a3c7692).angleDeg ? $d4400dec7c2a8326$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    // Memoized — called per-attr per setAttrs; input vocabulary is bounded.
    _capitalize (str) {
        const cached = $d4400dec7c2a8326$var$capitalizeCache.get(str);
        if (cached !== undefined) return cached;
        const out = str.charAt(0).toUpperCase() + str.slice(1);
        $d4400dec7c2a8326$var$capitalizeCache.set(str, out);
        return out;
    },
    throw (str) {
        throw new Error($d4400dec7c2a8326$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($d4400dec7c2a8326$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).showWarnings) return;
        console.warn($d4400dec7c2a8326$var$KONVA_WARNING + str);
    },
    _batchEvents (batch, run) {
        if (!batch) return run();
        let called = false;
        let active = true;
        try {
            batch(()=>{
                if (called || !active) {
                    $d4400dec7c2a8326$export$f8f26dd395d7e1bd.warn('eventBatchFunc must call its argument exactly once, synchronously.');
                    return;
                }
                called = true;
                run();
            });
        } finally{
            active = false;
            if (!called) $d4400dec7c2a8326$export$f8f26dd395d7e1bd.warn('eventBatchFunc must call its argument synchronously.');
        }
    },
    each (obj, func) {
        for(const key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        let x, y, dist;
        const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    // line as array of points.
    // line might be closed
    _getProjectionToLine (pt, line, isClosed) {
        const pc = $d4400dec7c2a8326$export$f8f26dd395d7e1bd.cloneObject(pt);
        let dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            const p2 = line[(i + 1) % line.length];
            const proj = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        const start = [], end = [];
        if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(let n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(let n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        const newStart = [];
        end.forEach(function(point) {
            const pr = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    // copies plain objects and arrays without DOM elements and circular
    // references, so the input (the live attrs of a node) is never modified.
    // Other objects (Date, class instances) are kept as they are
    _prepareToStringify (obj, ancestors = new Set()) {
        const copy = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._isArray(obj) ? [] : {};
        ancestors.add(obj);
        for (const key of Object.keys(obj)){
            const val = obj[key];
            if ($d4400dec7c2a8326$export$f8f26dd395d7e1bd._isElement(val) || ancestors.has(val)) continue;
            copy[key] = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._isPlainObject(val) || $d4400dec7c2a8326$export$f8f26dd395d7e1bd._isArray(val) ? $d4400dec7c2a8326$export$f8f26dd395d7e1bd._prepareToStringify(val, ancestors) : val;
        }
        ancestors.delete(obj);
        return copy;
    },
    // very simplified version of Object.assign
    _assign (target, source) {
        for(const key in source)target[key] = source[key];
        return target;
    },
    _getEventType (type) {
        if (type.indexOf('pointer') >= 0) return 'pointer';
        if (type.indexOf('touch') >= 0) return 'touch';
        return 'mouse';
    },
    _getFirstPointerId (evt) {
        var _a;
        if (!evt.touches) return (_a = evt.pointerId) !== null && _a !== void 0 ? _a : 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    // [topLeft, topRight, bottomRight, bottomLeft] radii that fit the box
    _cornerRadii (cornerRadius, width, height) {
        const max = Math.min(width, height) / 2;
        if (typeof cornerRadius === 'number') {
            const radius = $d4400dec7c2a8326$var$clampRadius(cornerRadius, max);
            return [
                radius,
                radius,
                radius,
                radius
            ];
        }
        return [
            $d4400dec7c2a8326$var$clampRadius(cornerRadius[0], max),
            $d4400dec7c2a8326$var$clampRadius(cornerRadius[1], max),
            $d4400dec7c2a8326$var$clampRadius(cornerRadius[2], max),
            $d4400dec7c2a8326$var$clampRadius(cornerRadius[3], max)
        ];
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        // if negative dimensions, abs width/height and move rectangle
        let xOrigin = width < 0 ? width : 0;
        let yOrigin = height < 0 ? height : 0;
        width = Math.abs(width);
        height = Math.abs(height);
        const [topLeft, topRight, bottomRight, bottomLeft] = $d4400dec7c2a8326$export$f8f26dd395d7e1bd._cornerRadii(cornerRadius, width, height);
        context.moveTo(xOrigin + topLeft, yOrigin);
        context.lineTo(xOrigin + width - topRight, yOrigin);
        context.arc(xOrigin + width - topRight, yOrigin + topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(xOrigin + width, yOrigin + height - bottomRight);
        context.arc(xOrigin + width - bottomRight, yOrigin + height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(xOrigin + bottomLeft, yOrigin + height);
        context.arc(xOrigin + bottomLeft, yOrigin + height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(xOrigin, yOrigin + topLeft);
        context.arc(xOrigin + topLeft, yOrigin + topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    },
    drawRoundedPolygonPath (context, points, sides, radius, cornerRadius) {
        radius = Math.abs(radius);
        for(let i = 0; i < sides; i++){
            const prev = points[(i - 1 + sides) % sides];
            const curr = points[i];
            const next = points[(i + 1) % sides];
            const vec1 = {
                x: curr.x - prev.x,
                y: curr.y - prev.y
            };
            const vec2 = {
                x: next.x - curr.x,
                y: next.y - curr.y
            };
            const len1 = Math.hypot(vec1.x, vec1.y);
            const len2 = Math.hypot(vec2.x, vec2.y);
            let currCornerRadius;
            if (typeof cornerRadius === 'number') currCornerRadius = cornerRadius;
            else currCornerRadius = i < cornerRadius.length ? cornerRadius[i] : 0;
            // a negative corner radius would throw in context.arcTo()
            currCornerRadius = Math.max(currCornerRadius, 0);
            const maxCornerRadius = radius * Math.cos(Math.PI / sides);
            // cornerRadius creates perfect circle at 1/2 radius
            currCornerRadius = maxCornerRadius * Math.min(1, currCornerRadius / radius * 2);
            const normalVec1 = {
                x: vec1.x / len1,
                y: vec1.y / len1
            };
            const normalVec2 = {
                x: vec2.x / len2,
                y: vec2.y / len2
            };
            const p1 = {
                x: curr.x - normalVec1.x * currCornerRadius,
                y: curr.y - normalVec1.y * currCornerRadius
            };
            const p2 = {
                x: curr.x + normalVec2.x * currCornerRadius,
                y: curr.y + normalVec2.y * currCornerRadius
            };
            if (i === 0) context.moveTo(p1.x, p1.y);
            else context.lineTo(p1.x, p1.y);
            context.arcTo(curr.x, curr.y, p2.x, p2.y, currCornerRadius);
        }
    }
};





function $02f524f4df5fe352$var$simplifyArray(arr) {
    const retArr = [], len = arr.length, util = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd);
    for(let n = 0; n < len; n++){
        let val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + '';
        retArr.push(val);
    }
    return retArr;
}
const $02f524f4df5fe352$var$COMMA = ',', $02f524f4df5fe352$var$OPEN_PAREN = '(', $02f524f4df5fe352$var$CLOSE_PAREN = ')', $02f524f4df5fe352$var$SEMICOLON = ';', $02f524f4df5fe352$var$DOUBLE_PAREN = '()', // EMPTY_STRING = '',
$02f524f4df5fe352$var$EQUALS = '=', // SET = 'set',
$02f524f4df5fe352$var$CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'roundRect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate'
];
const $02f524f4df5fe352$var$CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'letterSpacing',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'direction',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled',
    'imageSmoothingQuality',
    'filter'
];
const $02f524f4df5fe352$var$traceArrMax = 100;
// Check if CSS filters are supported in the current browser
let $02f524f4df5fe352$var$_cssFiltersSupported = null;
function $02f524f4df5fe352$export$887ce9926cc3f80f() {
    if ($02f524f4df5fe352$var$_cssFiltersSupported !== null) return $02f524f4df5fe352$var$_cssFiltersSupported;
    try {
        const canvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
        const ctx = canvas.getContext('2d');
        $02f524f4df5fe352$var$_cssFiltersSupported = !!ctx && 'filter' in ctx;
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    } catch (e) {
        $02f524f4df5fe352$var$_cssFiltersSupported = false;
    }
    return $02f524f4df5fe352$var$_cssFiltersSupported;
}
class $02f524f4df5fe352$export$841858b892ce1f4c {
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    /**
     * fill shape
     * @method
     * @name Konva.Context#fillShape
     * @param {Konva.Shape} shape
     */ fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {
    // abstract
    }
    /**
     * stroke shape
     * @method
     * @name Konva.Context#strokeShape
     * @param {Konva.Shape} shape
     */ strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {
    // abstract
    }
    /**
     * fill then stroke
     * @method
     * @name Konva.Context#fillStrokeShape
     * @param {Konva.Shape} shape
     */ fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        let traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            // methods
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $02f524f4df5fe352$var$DOUBLE_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === 'number' ? Math.floor(a) : a);
                    str += $02f524f4df5fe352$var$OPEN_PAREN + args.join($02f524f4df5fe352$var$COMMA) + $02f524f4df5fe352$var$CLOSE_PAREN;
                }
            } else {
                // properties
                str += trace.property;
                if (!relaxed) str += $02f524f4df5fe352$var$EQUALS + trace.val;
            }
            str += $02f524f4df5fe352$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        let traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $02f524f4df5fe352$var$traceArrMax) traceArr.shift();
    }
    /**
     * reset canvas context transform
     * @method
     * @name Konva.Context#reset
     */ reset() {
        const pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    /**
     * get canvas wrapper
     * @method
     * @name Konva.Context#getCanvas
     * @returns {Konva.Canvas}
     */ getCanvas() {
        return this.canvas;
    }
    /**
     * clear canvas
     * @method
     * @name Konva.Context#clear
     * @param {Object} [bounds]
     * @param {Number} [bounds.x]
     * @param {Number} [bounds.y]
     * @param {Number} [bounds.width]
     * @param {Number} [bounds.height]
     */ clear(bounds) {
        const canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    // Copy a buffer already rasterized in destination pixels. The caller owns
    // save/restore, opacity, compositing and the destination clip.
    _drawDeviceBuffer(canvas) {
        const { x: x, y: y, width: width, height: height } = canvas._isolationRect;
        this.setTransform(1, 0, 0, 1, 0, 0);
        this.imageSmoothingEnabled = false;
        this.drawImage(canvas._canvas, 0, 0, width, height, x, y, width, height);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr('lineCap', lineCap);
    }
    _getOpacity(shape) {
        if (!this._opacityRoot) return shape.getAbsoluteOpacity();
        let opacity = shape.opacity();
        let parent = shape.parent;
        while(parent && parent !== this._opacityRoot){
            opacity *= parent.opacity();
            parent = parent.parent;
        }
        return opacity;
    }
    _applyOpacity(shape) {
        const absOpacity = this._getOpacity(shape);
        if (absOpacity !== 1) this.setAttr('globalAlpha', absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr('lineJoin', lineJoin);
    }
    _applyMiterLimit(shape) {
        const miterLimit = shape.attrs.miterLimit;
        if (miterLimit != null) this.setAttr('miterLimit', miterLimit);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    /**
     * arc function.
     * @method
     * @name Konva.Context#arc
     */ arc(x, y, radius, startAngle, endAngle, counterClockwise) {
        this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    }
    /**
     * arcTo function.
     * @method
     * @name Konva.Context#arcTo
     *
     */ arcTo(x1, y1, x2, y2, radius) {
        this._context.arcTo(x1, y1, x2, y2, radius);
    }
    /**
     * beginPath function.
     * @method
     * @name Konva.Context#beginPath
     */ beginPath() {
        this._context.beginPath();
    }
    /**
     * bezierCurveTo function.
     * @method
     * @name Konva.Context#bezierCurveTo
     */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    }
    /**
     * clearRect function.
     * @method
     * @name Konva.Context#clearRect
     */ clearRect(x, y, width, height) {
        this._context.clearRect(x, y, width, height);
    }
    clip(...args) {
        this._context.clip.apply(this._context, args);
    }
    /**
     * closePath function.
     * @method
     * @name Konva.Context#closePath
     */ closePath() {
        this._context.closePath();
    }
    /**
     * createImageData function.
     * @method
     * @name Konva.Context#createImageData
     */ createImageData(width, height) {
        const a = arguments;
        if (a.length === 2) return this._context.createImageData(width, height);
        else if (a.length === 1) return this._context.createImageData(width);
    }
    /**
     * createLinearGradient function.
     * @method
     * @name Konva.Context#createLinearGradient
     */ createLinearGradient(x0, y0, x1, y1) {
        return this._context.createLinearGradient(x0, y0, x1, y1);
    }
    /**
     * createPattern function.
     * @method
     * @name Konva.Context#createPattern
     */ createPattern(image, repetition) {
        return this._context.createPattern(image, repetition);
    }
    /**
     * createRadialGradient function.
     * @method
     * @name Konva.Context#createRadialGradient
     */ createRadialGradient(x0, y0, r0, x1, y1, r1) {
        return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
    }
    /**
     * drawImage function.
     * @method
     * @name Konva.Context#drawImage
     */ drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
        // this._context.drawImage(...arguments);
        const a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(image, sx, sy);
        else if (a.length === 5) _context.drawImage(image, sx, sy, sWidth, sHeight);
        else if (a.length === 9) _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
    }
    /**
     * ellipse function.
     * @method
     * @name Konva.Context#ellipse
     */ ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
        this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
    }
    /**
     * isPointInPath function.
     * @method
     * @name Konva.Context#isPointInPath
     */ isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(...args) {
        // this._context.fill();
        this._context.fill.apply(this._context, args);
    }
    /**
     * fillRect function.
     * @method
     * @name Konva.Context#fillRect
     */ fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    /**
     * strokeRect function.
     * @method
     * @name Konva.Context#strokeRect
     */ strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    /**
     * fillText function.
     * @method
     * @name Konva.Context#fillText
     */ fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    /**
     * measureText function.
     * @method
     * @name Konva.Context#measureText
     */ measureText(text) {
        return this._context.measureText(text);
    }
    /**
     * getImageData function.
     * @method
     * @name Konva.Context#getImageData
     */ getImageData(sx, sy, sw, sh) {
        return this._context.getImageData(sx, sy, sw, sh);
    }
    /**
     * lineTo function.
     * @method
     * @name Konva.Context#lineTo
     */ lineTo(x, y) {
        this._context.lineTo(x, y);
    }
    /**
     * moveTo function.
     * @method
     * @name Konva.Context#moveTo
     */ moveTo(x, y) {
        this._context.moveTo(x, y);
    }
    /**
     * rect function.
     * @method
     * @name Konva.Context#rect
     */ rect(x, y, width, height) {
        this._context.rect(x, y, width, height);
    }
    /**
     * roundRect function.
     * @method
     * @name Konva.Context#roundRect
     */ roundRect(x, y, width, height, radii) {
        this._context.roundRect(x, y, width, height, radii);
    }
    /**
     * putImageData function.
     * @method
     * @name Konva.Context#putImageData
     */ putImageData(imageData, dx, dy) {
        this._context.putImageData(imageData, dx, dy);
    }
    /**
     * quadraticCurveTo function.
     * @method
     * @name Konva.Context#quadraticCurveTo
     */ quadraticCurveTo(cpx, cpy, x, y) {
        this._context.quadraticCurveTo(cpx, cpy, x, y);
    }
    /**
     * restore function.
     * @method
     * @name Konva.Context#restore
     */ restore() {
        this._context.restore();
    }
    /**
     * rotate function.
     * @method
     * @name Konva.Context#rotate
     */ rotate(angle) {
        this._context.rotate(angle);
    }
    /**
     * save function.
     * @method
     * @name Konva.Context#save
     */ save() {
        this._context.save();
    }
    /**
     * scale function.
     * @method
     * @name Konva.Context#scale
     */ scale(x, y) {
        this._context.scale(x, y);
    }
    /**
     * setLineDash function.
     * @method
     * @name Konva.Context#setLineDash
     */ setLineDash(segments) {
        this._context.setLineDash(segments);
    }
    /**
     * getLineDash function.
     * @method
     * @name Konva.Context#getLineDash
     */ getLineDash() {
        return this._context.getLineDash();
    }
    /**
     * setTransform function.
     * @method
     * @name Konva.Context#setTransform
     */ setTransform(a, b, c, d, e, f) {
        this._context.setTransform(a, b, c, d, e, f);
    }
    /**
     * stroke function.
     * @method
     * @name Konva.Context#stroke
     */ stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    /**
     * strokeText function.
     * @method
     * @name Konva.Context#strokeText
     */ strokeText(text, x, y, maxWidth) {
        this._context.strokeText(text, x, y, maxWidth);
    }
    /**
     * transform function.
     * @method
     * @name Konva.Context#transform
     */ transform(a, b, c, d, e, f) {
        this._context.transform(a, b, c, d, e, f);
    }
    /**
     * translate function.
     * @method
     * @name Konva.Context#translate
     */ translate(x, y) {
        this._context.translate(x, y);
    }
    _enableTrace() {
        let that = this, len = $02f524f4df5fe352$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        // to prevent creating scope function at each loop
        const func = function(methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $02f524f4df5fe352$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        // methods
        for(n = 0; n < len; n++)func($02f524f4df5fe352$var$CONTEXT_METHODS[n]);
        // attrs
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === 'shadowOffsetX' || prop === 'shadowOffsetY' || prop === 'shadowBlur') val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        const def = !op || op === 'source-over';
        if (!def) this.setAttr('globalCompositeOperation', op);
    }
}
$02f524f4df5fe352$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($02f524f4df5fe352$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $02f524f4df5fe352$export$576380cfa99ddf20 extends $02f524f4df5fe352$export$841858b892ce1f4c {
    constructor(canvas, { willReadFrequently: willReadFrequently = false } = {}){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: willReadFrequently
        });
    }
    _getFillPattern(shape) {
        // node-canvas exposes pattern smoothing through patternQuality.
        const context = this._context;
        if ('patternQuality' in context) context.patternQuality = context.imageSmoothingEnabled ? 'good' : 'nearest';
        return shape._getFillPattern();
    }
    _getFillStyle(shape) {
        const color = shape.fill();
        const priority = shape.fillPriority();
        if (color && priority === 'color') return color;
        const pattern = shape.fillPatternImage();
        if (pattern && priority === 'pattern') return this._getFillPattern(shape);
        const linear = shape.fillLinearGradientColorStops();
        if (linear && priority === 'linear-gradient') return shape._getLinearGradient();
        const radial = shape.fillRadialGradientColorStops();
        if (radial && priority === 'radial-gradient') return shape._getRadialGradient();
        if (color) return color;
        if (pattern) return this._getFillPattern(shape);
        if (linear) return shape._getLinearGradient();
        if (radial) return shape._getRadialGradient();
    }
    _fill(shape) {
        const style = this._getFillStyle(shape);
        if (style !== undefined) {
            this.setAttr('fillStyle', style);
            shape._fillFunc(this);
        }
    }
    _strokeLinearGradient(shape) {
        let start = shape._toStyleSpace(shape.getStrokeLinearGradientStartPoint()), end = shape._toStyleSpace(shape.getStrokeLinearGradientEndPoint());
        if (!shape.getStrokeScaleEnabled()) {
            const { a: a, b: b, c: c, d: d, e: e, f: f } = this._context.getTransform();
            const transform = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)([
                a,
                b,
                c,
                d,
                e,
                f
            ]);
            const ratio = this.canvas.getPixelRatio();
            const dx = end.x - start.x;
            const dy = end.y - start.y;
            // Gradient colors follow the inverse-transposed direction. Transforming
            // the endpoints alone distorts them under skew or nonuniform scaling.
            const nx = d * dx - b * dy;
            const ny = a * dy - c * dx;
            const lengthSquared = nx * nx + ny * ny;
            const scale = lengthSquared ? (dx * dx + dy * dy) * (a * d - b * c) / lengthSquared : 0;
            start = transform.point(start);
            end = {
                x: start.x + nx * scale,
                y: start.y + ny * scale
            };
            start = {
                x: start.x / ratio,
                y: start.y / ratio
            };
            end = {
                x: end.x / ratio,
                y: end.y / ratio
            };
        }
        const colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            // build color stops
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr('strokeStyle', grd);
        }
    }
    _applyStrokeStyle(shape) {
        if (shape.strokeLinearGradientColorStops()) this._strokeLinearGradient(shape);
        else this.setAttr('strokeStyle', shape.stroke());
    }
    // Text decorations are drawn like the glyphs: with the fill, or with the
    // stroke when the text is only outlined. False when the glyphs paint nothing.
    _applyDecorationStyle(shape) {
        if (shape.hasFill()) this.strokeStyle = this._getFillStyle(shape);
        else if (shape.hasStroke()) this._applyStrokeStyle(shape);
        else return false;
        return true;
    }
    _stroke(shape) {
        const dash = shape.dash(), // ignore strokeScaleEnabled for Text
        strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (!strokeScaleEnabled) this.save();
        this._applyLineCap(shape);
        if (dash && shape.dashEnabled()) {
            this.setLineDash(dash);
            this.setAttr('lineDashOffset', shape.dashOffset());
        }
        this.setAttr('lineWidth', shape.strokeWidth());
        const shadowColor = this.shadowColor;
        const shadowForStrokeEnabled = shape.getShadowForStrokeEnabled();
        if (!shadowForStrokeEnabled) this.setAttr('shadowColor', 'rgba(0,0,0,0)');
        this._applyStrokeStyle(shape);
        // Resolve the gradient in local coordinates before drawing an unscaled stroke.
        if (!strokeScaleEnabled) {
            const pixelRatio = this.getCanvas().getPixelRatio();
            this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        }
        try {
            shape._strokeFunc(this);
        } finally{
            if (!shadowForStrokeEnabled) this.setAttr('shadowColor', shadowColor);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a;
        const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : 'black', blur = shape.getShadowBlur(), offset = shape.getShadowOffset(), scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    }
}
class $02f524f4df5fe352$export$85eec7ef35542dce extends $02f524f4df5fe352$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext('2d', {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        // ignore strokeScaleEnabled for Text
        const strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (!strokeScaleEnabled) {
            this.save();
            const pixelRatio = this.getCanvas().getPixelRatio();
            this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        }
        this._applyLineCap(shape);
        const hitStrokeWidth = shape.hitStrokeWidth();
        const strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
        this.setAttr('lineWidth', strokeWidth);
        this.setAttr('strokeStyle', shape.colorKey);
        shape._strokeFuncHit(this);
        if (!strokeScaleEnabled) this.restore();
    }
}



class $94cf583ff38878f8$export$8d01c972ee8b14a9 {
    constructor(config){
        this.pixelRatio = 1;
        // the bitmap size, in device pixels
        this.width = 0;
        this.height = 0;
        // the size the canvas was given, in CSS pixels; the bitmap truncates it
        this._logicalWidth = 0;
        this._logicalHeight = 0;
        this.isCache = false;
        const conf = config || {};
        // a Konva.pixelRatio reset to undefined or 0 means the device ratio
        const pixelRatio = conf.pixelRatio || (0, $8c8384c27430fce8$export$b9f99057a3c7692).pixelRatio || (0, $8c8384c27430fce8$export$b9f99057a3c7692)._global.devicePixelRatio || 1;
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
        // set inline styles
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    /**
     * get canvas context
     * @method
     * @name Konva.Canvas#getContext
     * @returns {CanvasContext} context
     */ getContext() {
        return this.context;
    }
    /**
     * get pixel ratio
     * @method
     * @name Konva.Canvas#getPixelRatio
     * @returns {Number} pixel ratio
     * @example
     * var pixelRatio = layer.getCanvas().getPixelRatio();
     */ getPixelRatio() {
        return this.pixelRatio;
    }
    /**
     * set pixel ratio
     * KonvaJS automatically handles pixel ratio adustments in order to render crisp drawings
     *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
     *  of 1.  Some high end tablets and phones, like iPhones and iPads have a device pixel ratio
     *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
     *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
     *  specificed, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
     *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
     * @method
     * @name Konva.Canvas#setPixelRatio
     * @param {Number} pixelRatio
     * @example
     * layer.getCanvas().setPixelRatio(3);
     */ setPixelRatio(pixelRatio) {
        this.pixelRatio = pixelRatio;
        this.setSize(this._logicalWidth, this._logicalHeight);
    }
    setWidth(width) {
        this.setSize(width, this._logicalHeight);
    }
    setHeight(height) {
        this.setSize(this._logicalWidth, height);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    // the bitmap holds whole pixels: a fractional pixel ratio truncates, and
    // a size that does not match the bitmap would resample every draw of it
    _bitmapSize(size) {
        return Math.floor((size || 0) * this.pixelRatio);
    }
    setSize(width, height) {
        // a NaN or Infinity size would silently give an empty bitmap
        if (!isFinite(width !== null && width !== void 0 ? width : 0) || !isFinite(height !== null && height !== void 0 ? height : 0)) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error(`Canvas size must be finite numbers, got ${width}x${height}. The canvas is left empty.`);
            width = height = 0;
        }
        width = width || 0;
        height = height || 0;
        const pixelRatio = this.pixelRatio;
        const context = this.getContext()._context;
        const imageSmoothingEnabled = context.imageSmoothingEnabled;
        this._logicalWidth = width;
        this._logicalHeight = height;
        // take into account pixel ratio. Assigning a dimension reallocates the
        // bitmap and resets the whole context state, so scale once after both
        this.width = this._canvas.width = this._bitmapSize(width);
        this.height = this._canvas.height = this._bitmapSize(height);
        this._canvas.style.width = width + 'px';
        this._canvas.style.height = height + 'px';
        context.scale(pixelRatio, pixelRatio);
        context.imageSmoothingEnabled = imageSmoothingEnabled;
    }
    // setSize() re-allocates and clears the canvas even for the same size,
    // so lazily sized canvases use this to stay untouched when nothing changed
    setSizeIfChanged(width, height) {
        if (this.width !== this._bitmapSize(width) || this.height !== this._bitmapSize(height)) this.setSize(width, height);
    }
    /**
     * to data url
     * @method
     * @name Konva.Canvas#toDataURL
     * @param {String} mimeType
     * @param {Number} quality between 0 and 1 for jpg mime types
     * @returns {String} data url string
     */ toDataURL(mimeType, quality) {
        try {
            // If the requested encoding fails, retry with the default PNG encoding.
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Unable to get data URL. ' + err.message + ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                throw err;
            }
        }
    }
}
class $94cf583ff38878f8$export$ee612225bd2e63be extends $94cf583ff38878f8$export$8d01c972ee8b14a9 {
    // A cleared surface over `rect` (in the current drawing space), or over the
    // whole canvas, in this canvas's device pixels. Siblings reuse it; nested
    // groups borrow from the surface itself, so they cannot clear a parent's
    // unfinished image.
    _prepareIsolationCanvas(rect) {
        const { a: a, b: b, c: c, d: d, e: e, f: f } = this.getContext()._context.getTransform();
        const view = this._isolationRect || this;
        let x = 0, y = 0, width = view.width, height = view.height;
        if (rect) {
            const box = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)([
                a,
                b,
                c,
                d,
                e,
                f
            ])._getTransformedRect(rect);
            // Round outwards, with a pixel for antialiasing.
            x = Math.max(0, Math.floor(box.x) - 1);
            y = Math.max(0, Math.floor(box.y) - 1);
            width = Math.min(width, Math.ceil(box.x + box.width) + 1) - x;
            height = Math.min(height, Math.ceil(box.y + box.height) + 1) - y;
        }
        if (!(width > 0 && height > 0)) {
            // An empty source must still composite for copy/destination-in/etc.
            x = y = 0;
            width = height = 1;
        }
        const surface = this._isolationCanvas || (this._isolationCanvas = new $94cf583ff38878f8$export$ee612225bd2e63be({
            width: 0,
            height: 0,
            pixelRatio: this.pixelRatio
        }));
        if (surface.width < width || surface.height < height) {
            // Headroom on a short side, so a growing group does not reallocate
            // every frame.
            const ratio = this.pixelRatio;
            const grow = (need, have, max)=>Math.min(max, Math.ceil((have < need ? Math.max(need, have * 1.5) : have) / ratio));
            surface.setSize(grow(width, surface.width, this._logicalWidth), grow(height, surface.height, this._logicalHeight));
        }
        surface._isolationRect = {
            x: x,
            y: y,
            width: width,
            height: height
        };
        const peak = surface._isolationPeak;
        peak.width = Math.max(peak.width, width);
        peak.height = Math.max(peak.height, height);
        const context = surface.getContext();
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, width, height);
        context.setTransform(a, b, c, d, e - x, f - y);
        const parent = this.getContext();
        context.imageSmoothingEnabled = parent.imageSmoothingEnabled;
        context.imageSmoothingQuality = parent.imageSmoothingQuality;
        context.direction = parent.direction;
        return surface;
    }
    // After a frame, free surfaces that ten frames in a row did not use or used
    // a small part of. Content that changes size keeps its surface.
    _trimIsolationCanvas() {
        const surface = this._isolationCanvas;
        if (!surface) return;
        const peak = surface._isolationPeak;
        const low = surface.width * surface.height > 4 * peak.width * peak.height;
        surface._isolationLowFrames = low ? surface._isolationLowFrames + 1 : 0;
        if (surface._isolationLowFrames >= 10) this._releaseIsolationCanvas();
        else {
            peak.width = peak.height = 0;
            surface._trimIsolationCanvas();
        }
    }
    _releaseIsolationCanvas() {
        const surface = this._isolationCanvas;
        if (surface) {
            surface._releaseIsolationCanvas();
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(surface._canvas);
            this._isolationCanvas = undefined;
        }
    }
    setSize(width, height) {
        // A bitmap reset also resets its origin-clean state. A surface from the
        // previous lifetime may be tainted even after clearing its pixels.
        this._releaseIsolationCanvas();
        super.setSize(width, height);
    }
    constructor(config = {
        width: 0,
        height: 0,
        willReadFrequently: false
    }){
        super(config);
        // The largest width and height requested since the last trim.
        this._isolationPeak = {
            width: 0,
            height: 0
        };
        // Consecutive frames that used less than a quarter of the surface.
        this._isolationLowFrames = 0;
        this.context = new (0, $02f524f4df5fe352$export$576380cfa99ddf20)(this, {
            willReadFrequently: config.willReadFrequently
        });
        this.setSize(config.width, config.height);
    }
}
class $94cf583ff38878f8$export$43a2e1456e27dc84 extends $94cf583ff38878f8$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $02f524f4df5fe352$export$85eec7ef35542dce)(this);
        this.context.imageSmoothingEnabled = false;
        this.setSize(config.width, config.height);
    }
}




const $fa6dae8e3add958f$export$e34f1b340034d7f = {
    get isDragging () {
        let flag = false;
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging') flag = true;
        });
        return flag;
    },
    get node () {
        let node;
        for (const elem of $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.values()){
            if (elem.dragStatus === 'dragging') return elem.node;
            node = elem.node;
        }
        // isDragReady() also uses this getter before movement starts.
        return node;
    },
    _dragElements: new Map(),
    // Konva is imported into one window, but a stage may be rendered in another
    // one: an iframe, or a window opened with `window.open`. Such a window sends
    // its pointer events to itself, so `Konva.Stage` asks for every window it is
    // rendered in. The handlers get the window they listen to, as only that
    // window has pointer positions the stages of that window can use
    _listenToWindow (win) {
        const endDragBefore = (evt)=>$fa6dae8e3add958f$export$e34f1b340034d7f._endDragBefore(evt, win);
        const drag = (evt)=>$fa6dae8e3add958f$export$e34f1b340034d7f._batchEvents(()=>$fa6dae8e3add958f$export$e34f1b340034d7f._drag(evt, win), win);
        const endDragAfter = (evt)=>$fa6dae8e3add958f$export$e34f1b340034d7f._batchEvents(()=>$fa6dae8e3add958f$export$e34f1b340034d7f._endDragAfter(evt));
        win.addEventListener('mouseup', endDragBefore, true);
        win.addEventListener('touchend', endDragBefore, true);
        // add touchcancel to fix this: https://github.com/konvajs/konva/issues/1843
        win.addEventListener('touchcancel', endDragBefore, true);
        win.addEventListener('mousemove', drag);
        win.addEventListener('touchmove', drag);
        win.addEventListener('mouseup', endDragAfter, false);
        win.addEventListener('touchend', endDragAfter, false);
        win.addEventListener('touchcancel', endDragAfter, false);
    },
    _batchEvents (callback, win) {
        if (!$fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.size) return;
        // One scope per integration, even when several stages use the same callback.
        // Keep all positions and handlers in the original order across those stages.
        const batches = new Set();
        for (const { node: node } of $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.values()){
            const stage = node.getStage();
            if (!stage || win && stage._getOwnerWindow() !== win) continue;
            const batch = stage.eventBatchFunc();
            if (batch) batches.add(batch);
        }
        let run = callback;
        for (const batch of batches){
            const next = run;
            run = ()=>(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._batchEvents(batch, next);
        }
        run();
    },
    // methods
    _drag (evt, win) {
        const nodesToFireEvents = [];
        // reading the positions forces a layout, so do it once per stage
        const positioned = new Set();
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            // we need to find pointer relative to that node
            const stage = node.getStage();
            // a pointer position of another window is relative to another viewport,
            // it would drag the node to a random place
            if (win && stage._getOwnerWindow() !== win) return;
            if (!positioned.has(stage)) {
                stage.setPointersPositions(evt);
                positioned.add(stage);
            }
            if (elem.pointerEventType && elem.pointerEventType !== stage._pointerEventType) return;
            // it is possible that user call startDrag without any event
            // it that case we need to detect first movable pointer and attach it into the node
            if (elem.pointerId === undefined) {
                elem.pointerId = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
                elem.pointerEventType = stage._pointerEventType;
                if (elem.dragStatus === 'dragging') stage._cancelClick(elem.pointerId, elem.pointerEventType);
            }
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            // not related pointer
            if (!pos) return;
            if (elem.dragStatus !== 'dragging') {
                const dragDistance = node.dragDistance();
                const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                // a user can stop dragging inside `dragstart`
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        // call dragmove only after ALL positions are changed
        nodesToFireEvents.forEach((node)=>{
            // node may have been destroyed during a previous dragmove handler
            if (!node.getStage()) return;
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt
            }, true);
        });
    },
    // dragBefore and dragAfter allows us to set correct order of events
    // setup all in dragbefore, and stop dragging only after pointerup triggered.
    _endDragBefore (evt, win, only) {
        const drawNodes = [];
        const positioned = new Set();
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            // node.stopDrag() ends only the drags of the same gesture: a Transformer
            // drags its other nodes with the same pointer, another pointer is its own
            if (only && elem !== only && elem.pointerId !== only.pointerId) return;
            // we need to find pointer relative to that node
            const stage = node.getStage();
            // a pointer released in another window ends the drag too - the pointer
            // is up everywhere - but its position is not used for this stage
            if (evt && !positioned.has(stage) && (!win || stage._getOwnerWindow() === win)) {
                stage.setPointersPositions(evt);
                positioned.add(stage);
            }
            if (!only) {
                if (evt && elem.pointerEventType && elem.pointerEventType !== (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.type)) return;
                // a drag started without an event (node.startDrag()) that has not
                // moved yet has no pointer: any release ends it
                const released = elem.pointerId === undefined || stage._changedPointerPositions.some((pos)=>pos.id === elem.pointerId);
                // that pointer is not related: a "ready" element of another pointer
                // waits for its own release
                if (!released) return;
            }
            if (elem.dragStatus === 'ready') $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.delete(key);
            else {
                // if a node is stopped manually we still need to reset events:
                stage._cancelClick(elem.pointerId, elem.pointerEventType);
                elem.dragStatus = 'stopped';
                // a node that has not moved needs no redraw
                const drawNode = node.getLayer() || stage;
                if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
            }
        });
        // draw in a sync way
        // because mousemove event may trigger BEFORE batch draw is called
        // but as we have not hit canvas updated yet, it will trigger incorrect mouseover/mouseout events
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt, only) {
        $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus !== 'stopped' || only && elem !== only && elem.pointerId !== only.pointerId) return;
            elem.node.fire('dragend', {
                type: 'dragend',
                target: elem.node,
                evt: evt
            }, true);
            // a dragend handler may have started a new drag of the node
            if (elem.dragStatus !== 'dragging') $fa6dae8e3add958f$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};



const $6d58c7ba166afa5f$var$Captures = new Map();
// we may use this module for capturing touch events too
// so make sure we don't do something super specific to pointer
const $6d58c7ba166afa5f$var$SUPPORT_POINTER_EVENTS = (0, $8c8384c27430fce8$export$b9f99057a3c7692)._global['PointerEvent'] !== undefined;
function $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pointerId, stage) {
    const capture = $6d58c7ba166afa5f$var$Captures.get(pointerId);
    return capture && (!stage || capture.stage === stage) ? capture.shape : undefined;
}
function $6d58c7ba166afa5f$var$fireCapture(shape, type, pointerId) {
    shape._fire(type, {
        evt: new PointerEvent(type, {
            pointerId: pointerId
        }),
        pointerId: pointerId
    });
}
function $6d58c7ba166afa5f$export$3b42bc7c43025bad(pointerId, shape) {
    var _a;
    return ((_a = $6d58c7ba166afa5f$var$Captures.get(pointerId)) === null || _a === void 0 ? void 0 : _a.shape) === shape;
}
function $6d58c7ba166afa5f$export$1cab177b65f17c5a(pointerId, shape) {
    var _a;
    $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    // Native capture belongs to this stage even if the shape is reparented.
    $6d58c7ba166afa5f$var$Captures.set(pointerId, {
        shape: shape,
        stage: stage
    });
    if ($6d58c7ba166afa5f$var$SUPPORT_POINTER_EVENTS) {
        // capture on the DOM level too, so the stage keeps receiving the events
        // of that pointer even when it moves outside of the stage container
        // https://github.com/konvajs/konva/issues/1992
        try {
            (_a = stage.content) === null || _a === void 0 || _a.setPointerCapture(pointerId);
        } catch (e) {
        // capture is possible only for an active pointer;
        // ids of mouse and touch events (999 and touch identifiers) and
        // programmatic calls outside of a pointer event land here
        }
        $6d58c7ba166afa5f$var$fireCapture(shape, 'gotpointercapture', pointerId);
    }
}
function $6d58c7ba166afa5f$export$4b400545f620d75(node) {
    $6d58c7ba166afa5f$var$Captures.forEach(({ shape: shape, stage: stage }, pointerId)=>{
        if (shape === node || stage === node) $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId);
    });
}
function $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId, target) {
    var _a;
    const capture = $6d58c7ba166afa5f$var$Captures.get(pointerId);
    // a node can only release its own capture
    if (!capture || target && capture.shape !== target) return;
    const { shape: shape, stage: stage } = capture;
    $6d58c7ba166afa5f$var$Captures.delete(pointerId);
    if ($6d58c7ba166afa5f$var$SUPPORT_POINTER_EVENTS) {
        try {
            (_a = stage.content) === null || _a === void 0 || _a.releasePointerCapture(pointerId);
        } catch (e) {
        // same as in setPointerCapture: the pointer may not be active
        }
        $6d58c7ba166afa5f$var$fireCapture(shape, 'lostpointercapture', pointerId);
    }
}





function $d7c0e5ae0fe3f9a6$var$_formatValue(val) {
    if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === '[object Number]') return val;
    if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $d7c0e5ae0fe3f9a6$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ')');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isNumber = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(val);
        const isAuto = val === 'auto';
        if (!(isNumber || isAuto)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$9c72f966a828cc68() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === '[object CanvasGradient]' || val && val['addColorStop'];
        if (!(isString || isGradient)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$42b6f8f340e9a165() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val instanceof (0, $d4400dec7c2a8326$export$914b3a8889b8a8a9)) return val;
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + '. Make sure that all elements are numbers.');
        });
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1() {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isBool = val === true || val === false;
        if (!isBool) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $d7c0e5ae0fe3f9a6$export$5c1978fb8431d4a1(components) {
    if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        // ignore validation on undefined value, because it will reset to defalt
        if (val === undefined || val === null) return val;
        if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($d7c0e5ae0fe3f9a6$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


const $abe0ad8331aee635$var$GET = 'get';
const $abe0ad8331aee635$var$SET = 'set';
const $abe0ad8331aee635$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $abe0ad8331aee635$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $abe0ad8331aee635$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $abe0ad8331aee635$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        const method = $abe0ad8331aee635$var$GET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        // array defaults are shared between instances, so hand out a copy
        const isArr = Array.isArray(def);
        const getter = function() {
            const val = this.attrs[attr];
            return val === undefined ? isArr ? def.slice() : def : val;
        };
        // toObject() compares an attr with the default of the generated getter
        getter._def = def;
        constructor.prototype[method] = constructor.prototype[method] || getter;
    },
    addSetter (constructor, attr, validator, after) {
        const method = $abe0ad8331aee635$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $abe0ad8331aee635$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        const method = $abe0ad8331aee635$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        const len = components.length, capitalize = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize, getter = $abe0ad8331aee635$var$GET + capitalize(attr), setter = $abe0ad8331aee635$var$SET + capitalize(attr), keys = components.map((c)=>attr + capitalize(c)), // built-in components have their own getters, e.g. getOffsetX
        getters = keys.map((key)=>$abe0ad8331aee635$var$GET + capitalize(key));
        // getter
        constructor.prototype[getter] = function() {
            const ret = {};
            for(let n = 0; n < len; n++){
                const get = this[getters[n]];
                ret[components[n]] = get ? get.call(this) : this.attrs[keys[n]];
            }
            return ret;
        };
        const basicValidator = (0, $d7c0e5ae0fe3f9a6$export$5c1978fb8431d4a1)(components);
        // setter
        constructor.prototype[setter] = function(val) {
            const oldVal = this[getter]();
            if (validator) val = validator.call(this, val, attr);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(const key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $abe0ad8331aee635$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        const capitalizedAttr = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $abe0ad8331aee635$var$SET + capitalizedAttr, getter = $abe0ad8331aee635$var$GET + capitalizedAttr;
        const accessor = function() {
            // setting
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            // getting
            return this[getter]();
        };
        constructor.prototype[attr] = accessor;
    },
    backCompat (constructor, methods) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = $abe0ad8331aee635$var$GET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            const oldSetter = $abe0ad8331aee635$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
                return method.apply(this, arguments);
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





// CSS filter parser for fallback to function filters.
function $367bbc8f6a40f243$var$parseCSSFilters(cssFilter) {
    const steps = [];
    const filterRegex = /(\w+)\(([^)]*)\)/g;
    let match;
    while((match = filterRegex.exec(cssFilter)) !== null){
        const [, name, argument] = match;
        const fallback = $367bbc8f6a40f243$var$cssFilterFallbacks[name];
        if (!fallback) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn(`CSS filter "${name}" is not supported in fallback mode. Consider using function filters for better compatibility.`);
            continue;
        }
        const value = argument.trim() === '' ? name === 'blur' ? 0 : 1 : parseFloat(argument) / (argument.includes('%') ? 100 : 1);
        steps.push({
            fallback: fallback,
            value: value
        });
    }
    return function(imageData, pixelRatio = 1) {
        for (const { fallback: fallback, value: value } of steps)fallback(imageData, value, pixelRatio);
    };
}
// Fallbacks for CSS filter functions. Filter modules register theirs on
// import, so the core build carries none of their code.
const $367bbc8f6a40f243$var$cssFilterFallbacks = {};
function $367bbc8f6a40f243$export$2e200cc9b9e69000(name, fallback) {
    $367bbc8f6a40f243$var$cssFilterFallbacks[name] = fallback;
}
for (const name of [
    'grayscale',
    'sepia',
    'invert'
])$367bbc8f6a40f243$export$2e200cc9b9e69000(name, (imageData, value)=>{
    const amount = Math.min(1, Math.max(0, value));
    const data = imageData.data;
    for(let i = 0; i < data.length; i += 4){
        const r = data[i], g = data[i + 1], b = data[i + 2];
        let red, green, blue;
        if (name === 'grayscale') red = green = blue = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        else if (name === 'sepia') {
            red = 0.393 * r + 0.769 * g + 0.189 * b;
            green = 0.349 * r + 0.686 * g + 0.168 * b;
            blue = 0.272 * r + 0.534 * g + 0.131 * b;
        } else {
            red = 255 - r;
            green = 255 - g;
            blue = 255 - b;
        }
        // CSS interpolates the color matrix before clamping the result.
        data[i] = r + (red - r) * amount;
        data[i + 1] = g + (green - g) * amount;
        data[i + 2] = b + (blue - b) * amount;
    }
});
// CONSTANTS
const $367bbc8f6a40f243$var$ABSOLUTE_OPACITY = 'absoluteOpacity', $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM = 'absoluteTransform', $367bbc8f6a40f243$var$CHANGE = 'Change', $367bbc8f6a40f243$var$CHILDREN = 'children', $367bbc8f6a40f243$var$KONVA = 'konva', $367bbc8f6a40f243$var$LISTENING = 'listening', $367bbc8f6a40f243$var$MOUSEENTER = 'mouseenter', $367bbc8f6a40f243$var$MOUSELEAVE = 'mouseleave', $367bbc8f6a40f243$var$POINTERENTER = 'pointerenter', $367bbc8f6a40f243$var$POINTERLEAVE = 'pointerleave', $367bbc8f6a40f243$var$TOUCHENTER = 'touchenter', $367bbc8f6a40f243$var$TOUCHLEAVE = 'touchleave', $367bbc8f6a40f243$var$NON_BUBBLING_EVENTS = [
    $367bbc8f6a40f243$var$MOUSEENTER,
    $367bbc8f6a40f243$var$MOUSELEAVE,
    $367bbc8f6a40f243$var$POINTERENTER,
    $367bbc8f6a40f243$var$POINTERLEAVE,
    $367bbc8f6a40f243$var$TOUCHENTER,
    $367bbc8f6a40f243$var$TOUCHLEAVE
], $367bbc8f6a40f243$var$SET = 'set', $367bbc8f6a40f243$var$SHAPE = 'Shape', $367bbc8f6a40f243$var$SPACE = ' ', $367bbc8f6a40f243$var$STAGE = 'stage', $367bbc8f6a40f243$var$TRANSFORM = 'transform', $367bbc8f6a40f243$var$UPPER_STAGE = 'Stage', $367bbc8f6a40f243$var$VISIBLE = 'visible', $367bbc8f6a40f243$var$TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva'
].join($367bbc8f6a40f243$var$SPACE);
let $367bbc8f6a40f243$var$idCounter = 1;
class $367bbc8f6a40f243$export$85c928794f8d04d4 {
    constructor(config){
        this._id = $367bbc8f6a40f243$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this.parent = null;
        // derived values (transforms, visibility, opacity...), see _getCache()
        this._cache = {};
        // canvases of cache(), see _getCanvasCache()
        this._canvasCache = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        // on initial set attrs wi don't need to fire change events
        // because nobody is listening to them yet
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    // all change event listeners are attached to the prototype
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        // if we want to clear transform cache
        // we don't really need to remove it from the cache
        // but instead mark as "dirty"
        // so we don't need to create a new instance next time
        if ((attr === $367bbc8f6a40f243$var$TRANSFORM || attr === $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM) && this._cache[attr]) this._cache[attr].dirty = true;
        else if (attr) this._cache[attr] = undefined;
        else {
            this._cache = {};
            // clearCache() also reaches descendants whose ancestor transform changes
            // were suppressed while cached. Invalidate their saved Transformer bounds.
            if (this._attrsVersion !== undefined) this._attrsVersion++;
        }
    }
    // drop the cached canvases and give their memory back
    _releaseCanvasCache() {
        const cache = this._canvasCache;
        if (cache) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(cache.scene._canvas, cache.filter._canvas, ...cache.hit ? [
                cache.hit._canvas
            ] : []);
            this._canvasCache = null;
        }
    }
    _getCache(attr, privateGetter) {
        let cache = this._cache[attr];
        // for transform the cache can be NOT empty
        // but we still need to recalculate it if it is dirty
        const isTransform = attr === $367bbc8f6a40f243$var$TRANSFORM || attr === $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM;
        const invalid = cache === undefined || isTransform && cache.dirty === true;
        // if not cached, we need to set it using the private getter method.
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache[attr] = cache;
        }
        return cache;
    }
    _getCanvasCache() {
        return this._canvasCache;
    }
    /*
     * when the logic for a cached result depends on ancestor propagation, use this
     * method to clear self and children cache
     */ _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        // trigger clear cache, so transformer can use it
        if (attr === undefined || attr === $367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM) this.fire('absoluteTransformChange');
    }
    static _runAfterUpdateBatch(cb) {
        if ($367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth > 0) $367bbc8f6a40f243$export$85c928794f8d04d4._pendingUpdates.add(cb);
        else cb();
    }
    static _flushUpdateBatch() {
        if ($367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth > 0) return;
        const callbacks = $367bbc8f6a40f243$export$85c928794f8d04d4._pendingUpdates;
        if (!callbacks.size) return;
        $367bbc8f6a40f243$export$85c928794f8d04d4._pendingUpdates = new Set();
        callbacks.forEach((callback)=>callback());
    }
    static _updateBatch(fn) {
        $367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth++;
        try {
            return fn();
        } finally{
            $367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth--;
            $367bbc8f6a40f243$export$85c928794f8d04d4._flushUpdateBatch();
        }
    }
    static _beginUpdateBatch() {
        $367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth++;
        let finished = false;
        return ()=>{
            if (finished) return;
            finished = true;
            $367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth--;
            $367bbc8f6a40f243$export$85c928794f8d04d4._flushUpdateBatch();
        };
    }
    /**
     * clear cached canvas
     * @method
     * @name Konva.Node#clearCache
     * @returns {Konva.Node}
     * @example
     * node.clearCache();
     */ clearCache() {
        this._releaseCanvasCache();
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    /**
     *  cache node to improve drawing performance, apply filters, or create more accurate
     *  hit regions. For all basic shapes size of cache canvas will be automatically detected.
     *  If you need to cache your custom `Konva.Shape` instance you have to pass shape's bounding box
     *  properties. Look at [https://konvajs.org/docs/performance/Shape_Caching.html](https://konvajs.org/docs/performance/Shape_Caching.html) for more information.
     * @method
     * @name Konva.Node#cache
     * @param {Object} [config]
     * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Number} [config.offset]  increase canvas size by `offset` pixel in all directions.
     * @param {Boolean} [config.drawBorder] when set to true, a red border will be drawn around the cached
     *  region for debugging purposes
     * @param {Number} [config.pixelRatio] pixel ratio of the cache canvas, the canvas pixels per CSS pixel of the node. Default is `Konva.pixelRatio`, the device pixel ratio. A higher value keeps the cache sharp when the node is scaled up.
     * @param {Boolean} [config.imageSmoothingEnabled] control imageSmoothingEnabled property of created canvas for cache
     * @param {Number} [config.hitCanvasPixelRatio] change quality (or pixel ratio) of cached hit canvas.
     * @returns {Konva.Node}
     * @example
     * // cache a shape with the x,y position of the bounding box at the center and
     * // the width and height of the bounding box equal to the width and height of
     * // the shape obtained from shape.width() and shape.height()
     * image.cache();
     *
     * // cache a node and define the bounding box position and size
     * node.cache({
     *   x: -30,
     *   y: -30,
     *   width: 100,
     *   height: 200
     * });
     *
     * // cache a node and draw a red border around the bounding box
     * // for debugging purposes
     * node.cache({
     *   x: -30,
     *   y: -30,
     *   width: 100,
     *   height: 200,
     *   offset : 10,
     *   drawBorder: true
     * });
     */ cache(config) {
        const conf = config || {};
        let rect = {};
        // don't call getClientRect if we have all attributes
        // it means call it only if have one undefined
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) {
            const wasUnderCache = this._isUnderCache;
            this._isUnderCache = true;
            rect = this.getClientRect({
                skipTransform: true,
                relativeTo: this.getParent() || undefined
            });
            this._isUnderCache = wasUnderCache;
        }
        let x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, // round the far edge, not the size, so the last row and column fit in
        width = Math.ceil(conf.width || rect.x + rect.width - x), height = Math.ceil(conf.height || rect.y + rect.height - y), pixelRatio = conf.pixelRatio, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (width <= 0 || height <= 0 || !isFinite(x + y + width + height)) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error(`Can not cache the node. Its size is 0 or its bounds are not finite numbers (${x}, ${y}, ${width}x${height}). Caching is skipped.`);
            return this;
        }
        width += offset * 2;
        height += offset * 2;
        x -= offset;
        y -= offset;
        const cachedSceneCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
        }), sceneContext = cachedSceneCanvas.getContext();
        cachedSceneCanvas.isCache = true;
        this._releaseCanvasCache();
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        sceneContext.translate(-x, -y);
        // extra flag to skip on getAbsolute opacity calc
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
        try {
            this.drawScene(cachedSceneCanvas, this);
        } catch (e) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(cachedSceneCanvas._canvas);
            throw e;
        } finally{
            this._isUnderCache = false;
            // descendants cached their opacity relative to this node while drawing
            this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
            sceneContext.restore();
            cachedSceneCanvas._releaseIsolationCanvas();
        }
        // this will draw a red border around the cached box for
        // debugging purposes
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._canvasCache = {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            // the hit canvas is built on demand (see _getCachedHitCanvas)
            hit: null,
            hitConfig: {
                pixelRatio: hitCanvasPixelRatio,
                width: width,
                height: height
            },
            x: x,
            y: y
        };
        // Entering cache space changes non-scaling stroke bounds for descendants.
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    // build the hit canvas of a cached node lazily - only when the hit graph
    // is actually needed, so a non-listening node never allocates it
    // https://github.com/konvajs/konva/issues/2009
    _getCachedHitCanvas(top) {
        // top === this means the node is drawing into its own cache right now:
        // the build below re-enters drawHit for this very node, and consulting
        // the not-yet-stored canvas again would recurse forever
        if (top === this) return null;
        const cache = this._getCanvasCache();
        if (!cache) return null;
        if (cache.hit) return cache.hit;
        const hitCanvas = new (0, $94cf583ff38878f8$export$43a2e1456e27dc84)(cache.hitConfig);
        hitCanvas.isCache = true;
        const hitContext = hitCanvas.getContext();
        hitContext.save();
        hitContext.translate(-cache.x, -cache.y);
        this.drawHit(hitCanvas, this);
        hitContext.restore();
        cache.hit = hitCanvas;
        return hitCanvas;
    }
    /**
     * determine if node is currently cached
     * @method
     * @name Konva.Node#isCached
     * @returns {Boolean}
     */ isCached() {
        return !!this._canvasCache;
    }
    /**
     * Return client rectangle {x, y, width, height} of node. This rectangle also include all styling (strokes, shadows, etc).
     * The purpose of the method is similar to getBoundingClientRect API of the DOM.
     * Non-scaling stroke padding is converted from its drawing canvas to the requested coordinates.
     * Cached strokes use the cache's coordinates; their pixels scale with the cached bitmap.
     * @method
     * @name Konva.Node#getClientRect
     * @param {Object} config
     * @param {Boolean} [config.skipTransform] should we apply transform to node for calculating rect?
     * @param {Boolean} [config.skipShadow] should we apply shadow to the node for calculating bound box?
     * @param {Boolean} [config.skipStroke] should we apply stroke to the node for calculating bound box?
     * @param {Object} [config.relativeTo] calculate client rect relative to one of the parents
     * @returns {Object} rect with {x, y, width, height} properties
     * @example
     * var rect = new Konva.Rect({
     *      width : 100,
     *      height : 100,
     *      x : 50,
     *      y : 50,
     *      strokeWidth : 4,
     *      stroke : 'black',
     *      offsetX : 50,
     *      scaleY : 2
     * });
     *
     * // get client rect without think off transformations (position, rotation, scale, offset, etc)
     * rect.getClientRect({ skipTransform: true});
     * // returns {
     * //     x : -2,   // two pixels for stroke / 2
     * //     y : -2,
     * //     width : 104, // increased by 4 for stroke
     * //     height : 104
     * //}
     *
     * // get client rect with transformation applied
     * rect.getClientRect();
     * // returns Object {x: -2, y: 46, width: 104, height: 208}
     */ getClientRect(config) {
        // abstract method
        // redefine in Container and Shape
        throw new Error('abstract "getClientRect" method call');
    }
    _getCachedSceneRect(config) {
        const cache = config._forDrawing && !this._isUnderCache && this._getCanvasCache();
        if (!cache) return;
        const rect = {
            x: cache.x,
            y: cache.y,
            width: cache.scene.width / cache.scene.pixelRatio,
            height: cache.scene.height / cache.scene.pixelRatio
        };
        return config.skipTransform ? rect : this._transformedRect(rect, config.relativeTo);
    }
    _transformedRect(rect, top) {
        return this.getAbsoluteTransform(top)._getTransformedRect(rect);
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        const cacheCanvas = this._getCachedSceneCanvas();
        const ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context, hitCanvas) {
        const canvasCache = this._getCanvasCache();
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (!filters || filters.length === 0) return sceneCanvas;
        if (this._filterUpToDate) return filterCanvas;
        let useNativeOnly = true;
        for(let i = 0; i < filters.length; i++)if (typeof filters[i] !== 'string' || !(0, $02f524f4df5fe352$export$887ce9926cc3f80f)()) {
            useNativeOnly = false;
            break;
        }
        const ratio = sceneCanvas.pixelRatio;
        filterCanvas.setSizeIfChanged(sceneCanvas._logicalWidth, sceneCanvas._logicalHeight);
        if (useNativeOnly) {
            // Canvas filters use backing-pixel coordinates, independent of the CTM.
            // Scale length tokens, leaving colors, percentages and URL references alone.
            const finalFilter = filters.join(' ').replace(/url\((?:[^()"']|"[^"]*"|'[^']*')*\)|"[^"]*"|'[^']*'|([-+]?(?:\d*\.)?\d+(?:e[-+]?\d+)?)(px|em|rem|ex|ch|cap|ic|lh|rlh|vw|vh|vmin|vmax|cm|mm|q|in|pt|pc)\b/gi, (token, value, unit)=>value === undefined ? token : `${Number(value) * ratio}${unit}`);
            filterContext.clear();
            filterContext.save();
            filterContext.setAttr('filter', finalFilter);
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            filterContext.restore();
            this._filterUpToDate = true;
            return filterCanvas;
        }
        try {
            len = filters.length;
            filterContext.clear();
            // copy cached canvas onto filter context
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
            // apply filters to filter context
            for(n = 0; n < len; n++){
                filter = filters[n];
                if (typeof filter === 'string') filter = $367bbc8f6a40f243$var$parseCSSFilters(filter);
                filter.call(this, imageData, ratio);
            }
            filterContext.putImageData(imageData, 0, 0);
        } catch (e) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Unable to apply filter. ' + e.message + ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
        }
        this._filterUpToDate = true;
        return filterCanvas;
    }
    /**
     * bind events to the node. KonvaJS supports mouseover, mousemove,
     *  mouseout, mouseenter, mouseleave, mousedown, mouseup, wheel, contextmenu, click, dblclick, touchstart, touchmove,
     *  touchend, tap, dbltap, dragstart, dragmove, dragend and destroy events.
     *  Pass in a string of events delimited by a space to bind multiple events at once
     *  such as 'mousedown mouseup mousemove'. Include a namespace to bind an
     *  event by name such as 'click.foobar'.
     * @method
     * @name Konva.Node#on
     * @param {String} evtStr e.g. 'click', 'mousedown touchstart', 'mousedown.foo touchstart.foo'
     * @param {Function} handler The handler function. The first argument of that function is event object. Event object has `target` as main target of the event, `currentTarget` as current node listener and `evt` as native browser event.
     * @returns {Konva.Node}
     * @example
     * // add click listener
     * node.on('click', function() {
     *   console.log('you clicked me!');
     * });
     *
     * // get the target node
     * node.on('click', function(evt) {
     *   console.log(evt.target);
     * });
     *
     * // stop event propagation
     * node.on('click', function(evt) {
     *   evt.cancelBubble = true;
     * });
     *
     * // bind multiple listeners
     * node.on('click touchstart', function() {
     *   console.log('you clicked/touched me!');
     * });
     *
     * // namespace listener
     * node.on('click.foo', function() {
     *   console.log('you clicked/touched me!');
     * });
     *
     * // get the event type
     * node.on('click tap', function(evt) {
     *   var eventType = evt.type;
     * });
     *
     * // get native event object
     * node.on('click tap', function(evt) {
     *   var nativeEvent = evt.evt;
     * });
     *
     * // for change events, get the old and new val
     * node.on('xChange', function(evt) {
     *   var oldVal = evt.oldVal;
     *   var newVal = evt.newVal;
     * });
     *
     * // get event targets
     * // with event delegations
     * layer.on('click', 'Group', function(evt) {
     *   var shape = evt.target;
     *   var group = evt.currentTarget;
     * });
     */ on(...args) {
        this._prepareListeners();
        const evtStr = args[0];
        const selectorOrHandler = args[1];
        const handler = args[2];
        if (args.length === 3) return this._delegate.apply(this, args);
        const events = evtStr.split($367bbc8f6a40f243$var$SPACE);
        /*
         * loop through types and attach event listeners to
         * each one.  eg. 'click mouseover.namespace mouseout'
         * will create three event bindings
         */ for(let n = 0; n < events.length; n++){
            const event = events[n];
            const parts = event.split('.');
            const baseEvent = parts[0];
            const name = parts[1] || '';
            // create events array if it doesn't exist
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: selectorOrHandler
            });
        }
        return this;
    }
    /**
     * remove event bindings from the node. Pass in a string of
     *  event types delimmited by a space to remove multiple event
     *  bindings at once such as 'mousedown mouseup mousemove'.
     *  include a namespace to remove an event binding by name
     *  such as 'click.foobar'. If you only give a name like '.foobar',
     *  all events in that namespace will be removed.
     * @method
     * @name Konva.Node#off
     * @param {String} evtStr e.g. 'click', 'mousedown touchstart', '.foobar'
     * @returns {Konva.Node}
     * @example
     * // remove listener
     * node.off('click');
     *
     * // remove multiple listeners
     * node.off('click touchstart');
     *
     * // remove listener by name
     * node.off('click.foo');
     */ // listeners added to a prototype go into its own map, not the parent's,
    // and the lists flattened from the prototype chain so far are stale
    _prepareListeners() {
        if (this === this.constructor.prototype) {
            if (!this.hasOwnProperty('eventListeners')) this.eventListeners = {};
            $367bbc8f6a40f243$export$85c928794f8d04d4.protoListenerMap = new WeakMap();
        }
    }
    off(evtStr, callback) {
        this._prepareListeners();
        let events = (evtStr || '').split($367bbc8f6a40f243$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        if (!evtStr) // remove all events
        for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    // some event aliases for third party integration like HammerJS
    dispatchEvent(evt) {
        const e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        // we have to pass native event to handler
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    // like node.on
    _delegate(event, selector, handler) {
        const stopNode = this;
        this.on(event, function(evt) {
            const original = evt;
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for(let i = 0; i < targets.length; i++){
                evt = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
            // handlers get copies, so pass a cancelled bubble back
            if (evt.cancelBubble) original.cancelBubble = true;
        });
        return this;
    }
    /**
     * remove a node from parent, but don't destroy. You can reuse the node later.
     * @method
     * @name Konva.Node#remove
     * @returns {Konva.Node}
     * @example
     * node.remove();
     */ remove() {
        if (this.isDragging()) this.stopDrag();
        // we can have drag element but that is not dragged yet
        // so just clear it
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.delete(this._id);
        // also remove any dragging descendants, otherwise they'll
        // have a broken parent chain and crash on getStage()
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.forEach((elem, key)=>{
            if (this.isAncestorOf(elem.node)) (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.delete(key);
        });
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$STAGE);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$VISIBLE);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$LISTENING);
    }
    _remove() {
        const parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
        // every cached attr that is calculated via node tree
        // traversal must be cleared when removing a node
        this._clearCaches();
    }
    /**
     * remove and destroy a node. Kill it and delete forever! You should not reuse node after destroy().
     * If the node is a container (Group, Stage or Layer) it will destroy all children too.
     * The node fires a `destroy` event first, so anything holding a reference to it can let go.
     * When an ancestor is being destroyed the node is already detached from its parent at that point.
     * @method
     * @name Konva.Node#destroy
     * @example
     * node.on('destroy', () => console.log('gone'));
     * node.destroy();
     */ destroy() {
        this._fire('destroy', {
            target: this
        });
        $6d58c7ba166afa5f$export$4b400545f620d75(this);
        this.remove();
        this.clearCache();
        return this;
    }
    /**
     * get attr
     * @method
     * @name Konva.Node#getAttr
     * @param {String} attr
     * @returns {Integer|String|Object|Array}
     * @example
     * var x = node.getAttr('x');
     */ getAttr(attr) {
        const method = 'get' + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        // otherwise get directly
        return this.attrs[attr];
    }
    /**
     * get ancestors
     * @method
     * @name Konva.Node#getAncestors
     * @returns {Array}
     * @example
     * shape.getAncestors().forEach(function(node) {
     *   console.log(node.id());
     * })
     */ getAncestors() {
        let parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    /**
     * get attrs object literal
     * @method
     * @name Konva.Node#getAttrs
     * @returns {Object}
     */ getAttrs() {
        return this.attrs || {};
    }
    /**
     * set multiple attrs at once using an object literal
     * @method
     * @name Konva.Node#setAttrs
     * @param {Object} config object containing key value pairs
     * @returns {Konva.Node}
     * @example
     * node.setAttrs({
     *   x: 5,
     *   fill: 'red'
     * });
     */ setAttrs(config) {
        this._batchTransformChanges(()=>{
            let key, method;
            if (!config) return this;
            for(key in config){
                if (key === $367bbc8f6a40f243$var$CHILDREN) continue;
                method = $367bbc8f6a40f243$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(key);
                // use setter if available
                if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else // otherwise set directly
                this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    /**
     * determine if node is listening for events by taking into account ancestors.
     *
     * Parent    | Self      | isListening
     * listening | listening |
     * ----------+-----------+------------
     * T         | T         | T
     * T         | F         | F
     * F         | T         | F
     * F         | F         | F
     *
     * @method
     * @name Konva.Node#isListening
     * @returns {Boolean}
     */ isListening() {
        return this._getCache($367bbc8f6a40f243$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    /**
     * determine if node is visible by taking into account ancestors.
     *
     * Parent    | Self      | isVisible
     * visible   | visible   |
     * ----------+-----------+------------
     * T         | T         | T
     * T         | F         | F
     * F         | T         | F
     * F         | F         | F
     * @method
     * @name Konva.Node#isVisible
     * @returns {Boolean}
     */ isVisible() {
        return this._getCache($367bbc8f6a40f243$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top) {
        if (top) return this._isVisible(top) && this._isListening(top);
        return this.isListening() && this.isVisible();
    }
    /**
     * show node. set visible = true
     * @method
     * @name Konva.Node#show
     * @returns {Konva.Node}
     */ show() {
        this.visible(true);
        return this;
    }
    /**
     * hide node.  Hidden nodes are no longer detectable
     * @method
     * @name Konva.Node#hide
     * @returns {Konva.Node}
     */ hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    /**
     * get absolute z-index which takes into account sibling
     *  and ancestor indices
     * @method
     * @name Konva.Node#getAbsoluteZIndex
     * @returns {Integer}
     */ getAbsoluteZIndex() {
        let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $367bbc8f6a40f243$var$SHAPE) nodes = nodes.concat(child.children);
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        const stage = this.getStage();
        if (that.nodeType !== $367bbc8f6a40f243$var$UPPER_STAGE && stage) addChildren(stage.children);
        return index;
    }
    /**
     * get node depth in node tree.  Returns an integer.
     *  e.g. Stage depth will always be 0.  Layers will always be 1.  Groups and Shapes will always
     *  be >= 2
     * @method
     * @name Konva.Node#getDepth
     * @returns {Integer}
     * @example
     * var depth = shape.getDepth(); // 2 for a shape right inside of a layer
     */ getDepth() {
        let depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    // sometimes we do several attributes changes
    // like node.position(pos)
    // for performance reasons, lets batch transform reset
    // so it work faster
    _batchTransformChanges(func) {
        if (this._batchingTransformChange) {
            func();
            return;
        }
        $367bbc8f6a40f243$export$85c928794f8d04d4._updateBatch(()=>{
            this._batchingTransformChange = true;
            try {
                func();
            } finally{
                this._batchingTransformChange = false;
                if (this._needClearTransformCache) {
                    this._needClearTransformCache = false;
                    this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
                    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
                }
            }
        });
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    /**
     * get position of first pointer (like mouse or first touch) relative to local coordinates of current node
     * @method
     * @name Konva.Node#getRelativePointerPosition
     * @returns {Konva.Node}
     * @example
     *
     * // let's think we have a rectangle at position x = 10, y = 10
     * // now we clicked at x = 15, y = 15 of the stage
     * // if you want to know position of the click, related to the rectangle you can use
     * rect.getRelativePointerPosition();
     */ getRelativePointerPosition() {
        const stage = this.getStage();
        if (!stage) return null;
        // get pointer (say mouse or touch) position
        const pos = stage.getPointerPosition();
        if (!pos) return null;
        const transform = this.getAbsoluteTransform().copy();
        // to detect relative position we need to invert transform
        transform.invert();
        // now we can find relative point
        return transform.point(pos);
    }
    /**
     * get absolute position of a node. That function can be used to calculate absolute position, but relative to any ancestor
     * @method
     * @name Konva.Node#getAbsolutePosition
     * @param {Object} [top] optional ancestor node
     * @returns {Konva.Node}
     * @example
     *
     * // returns absolute position relative to top-left corner of canvas
     * node.getAbsolutePosition();
     *
     * // calculate absolute position of node, inside stage
     * // so stage transforms are ignored
     * node.getAbsolutePosition(stage)
     */ getAbsolutePosition(top) {
        const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)(), offset = this.offset();
        // clone the matrix array
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        const { x: x, y: y, ...origTrans } = this._clearTransform();
        // don't clear translation
        this.attrs.x = x;
        this.attrs.y = y;
        // important, use non cached value
        this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
        const it = this._getAbsoluteTransform().copy();
        const invertible = it.isInvertible();
        it.invert();
        it.translate(pos.x, pos.y);
        const { x: dx, y: dy } = it.getTranslation();
        this._setTransform(origTrans);
        if (invertible) this.setPosition({
            x: this.attrs.x + dx,
            y: this.attrs.y + dy
        });
        else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Cannot set the absolute position: the absolute transform is not invertible (an ancestor has a zero scale).');
        this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
        this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        let key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        // return original transform
        return trans;
    }
    /**
     * move node by an amount relative to its current position
     * @method
     * @name Konva.Node#move
     * @param {Object} change
     * @param {Number} change.x
     * @param {Number} change.y
     * @returns {Konva.Node}
     * @example
     * // move node in x direction by 1px and y direction by 2px
     * node.move({
     *   x: 1,
     *   y: 2
     * });
     */ move(change) {
        let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    /**
     * rotate node by an amount in degrees relative to its current rotation
     * @method
     * @name Konva.Node#rotate
     * @param {Number} theta
     * @returns {Konva.Node}
     */ rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    /**
     * move node to the top of its siblings
     * @method
     * @name Konva.Node#moveToTop
     * @returns {Boolean}
     */ moveToTop() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.children.length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    /**
     * move node up
     * @method
     * @name Konva.Node#moveUp
     * @returns {Boolean} flag is moved or not
     */ moveUp() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        const index = this.index, len = this.parent.children.length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    /**
     * move node down
     * @method
     * @name Konva.Node#moveDown
     * @returns {Boolean}
     */ moveDown() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    /**
     * move node to the bottom of its siblings
     * @method
     * @name Konva.Node#moveToBottom
     * @returns {Boolean}
     */ moveToBottom() {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Unexpected value ' + zIndex + ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' + (this.parent.children.length - 1) + '.');
        const index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    /**
     * get absolute opacity
     * @method
     * @name Konva.Node#getAbsoluteOpacity
     * @returns {Number}
     */ getAbsoluteOpacity() {
        return this._getCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        let absOpacity = this.opacity();
        const parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    /**
     * move node to another container
     * @method
     * @name Konva.Node#moveTo
     * @param {Container} newContainer
     * @returns {Konva.Node}
     * @example
     * // move node from current layer into layer2
     * node.moveTo(layer2);
     */ moveTo(newContainer) {
        // do nothing if new container is already parent
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    /**
     * convert Node into an object for serialization.  Returns an object.
     * @method
     * @name Konva.Node#toObject
     * @returns {Object}
     */ toObject() {
        var _a;
        const attrs = this.getAttrs();
        let key, val, nonPlainObject;
        const obj = {
            attrs: {},
            className: this.getClassName()
        };
        for(key in attrs){
            val = attrs[key];
            // JSON has no typed arrays, so typed line points are written as an array
            if (val instanceof (0, $d4400dec7c2a8326$export$914b3a8889b8a8a9)) val = Array.from(val);
            // if value is object and object is not plain
            // like class instance, we should skip it and to not include
            nonPlainObject = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val) && !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            // only the getters generated by Factory carry a default, so an explicit
            // value equal to a computed one (Text width, dragDistance) is kept
            // Shared filter parameters can distinguish an explicit value from unset.
            if (((_a = this['get' + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(key)]) === null || _a === void 0 ? void 0 : _a._def) !== val || key === 'brightness' || key === 'threshold') obj.attrs[key] = key === 'filters' && (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(val) ? val.filter((filter)=>typeof filter === 'string') : (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val) ? (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._prepareToStringify(val) : val;
        }
        return obj;
    }
    /**
     * convert Node into a JSON string.  Returns a JSON string.
     * @method
     * @name Konva.Node#toJSON
     * @returns {String}
     */ toJSON() {
        return JSON.stringify(this.toObject());
    }
    /**
     * get parent container
     * @method
     * @name Konva.Node#getParent
     * @returns {Konva.Node}
     */ getParent() {
        return this.parent;
    }
    /**
     * get all ancestors (parent then parent of the parent, etc) of the node
     * @method
     * @name Konva.Node#findAncestors
     * @param {String} selector selector for search
     * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
     * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
     * @returns {Array} [ancestors]
     * @example
     * // get one of the parent group
     * var parentGroups = node.findAncestors('Group');
     */ findAncestors(selector, includeSelf, stopNode) {
        const res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        let ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    /**
     * get ancestor (parent or parent of the parent, etc) of the node that match passed selector
     * @method
     * @name Konva.Node#findAncestor
     * @param {String} selector selector for search
     * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
     * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
     * @returns {Konva.Node} ancestor
     * @example
     * // get one of the parent group
     * var group = node.findAncestors('.mygroup');
     */ findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    // is current node match passed selector?
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === 'function') return selector(this);
        let selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Konva is awesome, right?');
            }
            // id selector
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === '.') {
                // name selector
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    /**
     * get layer ancestor
     * @method
     * @name Konva.Node#getLayer
     * @returns {Konva.Layer}
     */ getLayer() {
        const parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    /**
     * get stage ancestor
     * @method
     * @name Konva.Node#getStage
     * @returns {Konva.Stage}
     */ getStage() {
        return this._getCache($367bbc8f6a40f243$var$STAGE, this._getStage);
    }
    _getStage() {
        const parent = this.getParent();
        if (parent) return parent.getStage();
        else return null;
    }
    /**
     * fire event
     * @method
     * @name Konva.Node#fire
     * @param {String} eventType event type.  can be a regular event, like click, mouseover, or mouseout, or it can be a custom event, like myCustomEvent
     * @param {Event} [evt] event object
     * @param {Boolean} [bubble] setting the value to false, or leaving it undefined, will result in the event
     *  not bubbling.  Setting the value to true will result in the event bubbling.
     * @returns {Konva.Node}
     * @example
     * // manually fire click event
     * node.fire('click');
     *
     * // fire custom event
     * node.fire('foo');
     *
     * // fire custom event with custom event object
     * node.fire('foo', {
     *   bar: 10
     * });
     *
     * // fire click event that bubbles
     * node.fire('click', null, true);
     */ fire(eventType, evt, bubble) {
        evt = evt || {};
        evt.target = evt.target || this;
        // bubble
        if (bubble) this._fireAndBubble(eventType, evt);
        else // no bubble
        this._fire(eventType, evt);
        return this;
    }
    /**
     * get absolute transform of the node which takes into
     *  account its ancestor transforms
     * @method
     * @name Konva.Node#getAbsoluteTransform
     * @returns {Konva.Transform}
     */ getAbsoluteTransform(top) {
        // relative to an ancestor, or under a cached one, the result can't come
        // from the cache: a cached container keeps the transform caches of its
        // descendants while it moves (see Container._clearSelfAndDescendantCache)
        if (top || this._hasCachedAncestor()) return this._getAbsoluteTransform(top);
        return this._getCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM, this._getCachedAbsoluteTransform);
    }
    _hasCachedAncestor() {
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) return true;
            parent = parent.parent;
        }
        return false;
    }
    // relative to `top`: the transforms of `top` and of its ancestors are
    // left out. Goes through the parent, so an ancestor that redefines its
    // absolute transform (Konva.Transformer) is honoured
    _getAbsoluteTransform(top) {
        const at = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        if (this === top) return at;
        if (this.parent && this.parent !== top) this.parent.getAbsoluteTransform(top).copyInto(at);
        return this._multiplyOwnTransform(at);
    }
    // the cached transform of the parent, then the own one
    _getCachedAbsoluteTransform() {
        const at = this._cache[$367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM] || new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
        else at.reset();
        this._multiplyOwnTransform(at);
        at.dirty = false;
        return at;
    }
    _multiplyOwnTransform(at) {
        const transformsEnabled = this.transformsEnabled();
        if (transformsEnabled === 'all') at.multiply(this.getTransform());
        else if (transformsEnabled === 'position') {
            // use "attrs" directly, because it is a bit faster
            const x = this.attrs.x || 0;
            const y = this.attrs.y || 0;
            const offsetX = this.attrs.offsetX || 0;
            const offsetY = this.attrs.offsetY || 0;
            at.translate(x - offsetX, y - offsetY);
        }
        return at;
    }
    /**
     * get absolute scale of the node which takes into
     *  account its ancestor scales
     * @method
     * @name Konva.Node#getAbsoluteScale
     * @returns {Object}
     * @example
     * // get absolute scale x
     * var scaleX = node.getAbsoluteScale().x;
     */ getAbsoluteScale(top) {
        // do not cache this calculations,
        // because it use cache transform
        // this is special logic for caching with some shapes with shadow
        let parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    /**
     * get absolute rotation of the node which takes into
     *  account its ancestor rotations
     * @method
     * @name Konva.Node#getAbsoluteRotation
     * @returns {Number}
     * @example
     * // get absolute rotation
     * var rotation = node.getAbsoluteRotation();
     */ getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    /**
     * get transform of the node
     * @method
     * @name Konva.Node#getTransform
     * @returns {Konva.Transform}
     */ getTransform() {
        return this._getCache($367bbc8f6a40f243$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        const m = this._cache[$367bbc8f6a40f243$var$TRANSFORM] || new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        m.reset();
        // I was trying to use attributes directly here
        // but it doesn't work for Transformer well
        // because it overwrite x,y getters
        const x = this.x(), y = this.y(), rotation = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    /**
     * clone node.  Returns a new Node instance with identical attributes.  You can also override
     *  the node properties with an object literal, enabling you to use an existing node as a template
     *  for another node
     * @method
     * @name Konva.Node#clone
     * @param {Object} obj override attrs
     * @returns {Konva.Node}
     * @example
     * // simple clone
     * var clone = node.clone();
     *
     * // clone a node and override the x position
     * var clone = rect.clone({
     *   x: 5
     * });
     */ clone(obj) {
        // instantiate new node
        let attrs = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        // apply attr overrides
        for(key in obj)attrs[key] = obj[key];
        const node = new this.constructor(attrs);
        // copy over listeners
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                /*
                 * don't include konva namespaced listeners because
                 *  these are generated by the constructors
                 */ if (listener.name.indexOf($367bbc8f6a40f243$var$KONVA) < 0) {
                    // if listeners array doesn't exist, then create it
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        // the client rect is only needed for the parts of the box not configured
        const needsBox = config.x === undefined || config.y === undefined || !config.width || !config.height;
        const box = needsBox ? this.getClientRect() : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!isFinite(box.x + box.y + box.width + box.height)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error(`Cannot find the bounds of the node to export, its client rect is ${box.x}, ${box.y}, ${box.width}x${box.height}. Check its position, size and points.`);
        const stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: config.width || Math.max(0, Math.ceil(box.x + box.width - x)) || (stage ? stage.width() : 0),
            height: config.height || Math.max(0, Math.ceil(box.y + box.height - y)) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas);
        context.restore();
        canvas._releaseIsolationCanvas();
        return canvas;
    }
    /**
     * converts node into an canvas element.
     * @method
     * @name Konva.Node#toCanvas
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.pixelRatio] pixelRatio of output canvas. Default is 1.
     * Higher pixel ratios increase export resolution. Cached nodes keep their cache resolution.
     * Rebuild caches at the export pixel ratio to preserve detail.
     * The pixel ratio multiplies the dimensions of the exported image.
     * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
     * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
     * @example
     * var canvas = node.toCanvas();
     */ toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    /**
     * Creates a composite data URL (base64 string). If MIME type is not
     * specified, then "image/png" will result. For "image/jpeg", specify a quality
     * level as quality (range 0.0 - 1.0)
     * @method
     * @name Konva.Node#toDataURL
     * @param {Object} config
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     * @param {Number} [config.pixelRatio] pixelRatio of output image url. Default is 1.
     * Higher pixel ratios increase export resolution. Cached nodes keep their cache resolution.
     * Rebuild caches at the export pixel ratio to preserve detail.
     * The pixel ratio multiplies the dimensions of the exported image.
     * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
     * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
     * @returns {String}
     */ toDataURL(config) {
        var _a;
        config = config || {};
        const mimeType = config.mimeType || null, quality = (_a = config.quality) !== null && _a !== void 0 ? _a : null;
        const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    /**
     * converts node into an image.  Since the toImage
     *  method is asynchronous, the resulting image can only be retrieved from the config callback
     *  or the returned Promise.  toImage is most commonly used
     *  to cache complex drawings as an image so that they don't have to constantly be redrawn
     * @method
     * @name Konva.Node#toImage
     * @param {Object} config
     * @param {Function} [config.callback] function executed when the composite has completed
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     * @param {Number} [config.pixelRatio] pixelRatio of output image. Default is 1.
     * Higher pixel ratios increase export resolution. Cached nodes keep their cache resolution.
     * Rebuild caches at the export pixel ratio to preserve detail.
     * The pixel ratio multiplies the dimensions of the exported image.
     * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
     * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
     * @return {Promise<Image>}
     * @example
     * var image = node.toImage({
     *   callback(img) {
     *     // do stuff with img
     *   }
     * });
     */ toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const { callback: callback, ...rest } = config || {};
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(rest), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                }, reject);
            } catch (err) {
                reject(err);
            }
        });
    }
    /**
     * Converts node into a blob.  Since the toBlob method is asynchronous,
     *  the resulting blob can only be retrieved from the config callback
     *  or the returned Promise.
     * @method
     * @name Konva.Node#toBlob
     * @param {Object} config
     * @param {Function} [config.callback] function executed when the composite has completed
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.pixelRatio] pixelRatio of output canvas. Default is 1.
     * Higher pixel ratios increase export resolution. Cached nodes keep their cache resolution.
     * Rebuild caches at the export pixel ratio to preserve detail.
     * The pixel ratio multiplies the dimensions of the exported image.
     * If you export to 500x500 size with pixelRatio = 2, then produced image will have size 1000x1000.
     * @param {Boolean} [config.imageSmoothingEnabled] set this to false if you want to disable imageSmoothing
     * @example
     * var blob = await node.toBlob({});
     * @returns {Promise<Blob>} rejects if the canvas can not be encoded
     */ toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                this.toCanvas(config).toBlob((blob)=>{
                    var _a;
                    // the canvas reports a failed encode by passing null
                    if (!blob) {
                        reject(new Error('Konva: toBlob() failed, the canvas was not encoded'));
                        return;
                    }
                    resolve(blob);
                    (_a = config === null || config === void 0 ? void 0 : config.callback) === null || _a === void 0 || _a.call(config, blob);
                }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    /**
     * get class name, which may return Stage, Layer, Group, or shape class names like Rect, Circle, Text, etc.
     * @method
     * @name Konva.Node#getClassName
     * @returns {String}
     */ getClassName() {
        return this.className || this.nodeType;
    }
    /**
     * get the node type, which may return Stage, Layer, Group, or Shape
     * @method
     * @name Konva.Node#getType
     * @returns {String}
     */ getType() {
        return this.nodeType;
    }
    getDragDistance() {
        // compare with undefined because we need to track 0 value
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $8c8384c27430fce8$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        let evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            // the following two conditions must be true in order to remove a handler:
            // 1) the current event name cannot be konva unless the event name is konva
            //    this enables developers to force remove a konva specific listener for whatever reason
            // 2) an event name is not specified, or if one is specified, it matches the current event name
            if ((evtName !== 'konva' || name === 'konva') && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $367bbc8f6a40f243$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    /**
     * add name to node
     * @method
     * @name Konva.Node#addName
     * @param {String} name
     * @returns {Konva.Node}
     * @example
     * node.name('red');
     * node.addName('selected');
     * node.name(); // return 'red selected'
     */ addName(name) {
        if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + ' ' + name : name;
            this.name(newName);
        }
        return this;
    }
    /**
     * check is node has name
     * @method
     * @name Konva.Node#hasName
     * @param {String} name
     * @returns {Boolean}
     * @example
     * node.name('red');
     * node.hasName('red');   // return true
     * node.hasName('selected'); // return false
     * node.hasName(''); // return false
     */ hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        // if name is '' the "names" will be [''], so I added extra check above
        const names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    /**
     * remove name from node
     * @method
     * @name Konva.Node#removeName
     * @param {String} name
     * @returns {Konva.Node}
     * @example
     * node.name('red selected');
     * node.removeName('selected');
     * node.hasName('selected'); // return false
     * node.name(); // return 'red'
     */ removeName(name) {
        const names = (this.name() || '').split(/\s/g);
        const index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(' '));
        }
        return this;
    }
    /**
     * set attr
     * @method
     * @name Konva.Node#setAttr
     * @param {String} attr
     * @param {*} val
     * @returns {Konva.Node}
     * @example
     * node.setAttr('x', 5);
     */ setAttr(attr, val) {
        const func = this[$367bbc8f6a40f243$var$SET + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else // otherwise set directly
        this._setAttr(attr, val);
        return this;
    }
    _addSubtreeObserver(observer) {
        var _a;
        ((_a = this._subtreeObservers) !== null && _a !== void 0 ? _a : this._subtreeObservers = new Set()).add(observer);
        $367bbc8f6a40f243$export$85c928794f8d04d4._subtreeObserverCount++;
    }
    _removeSubtreeObserver(observer) {
        var _a;
        if ((_a = this._subtreeObservers) === null || _a === void 0 ? void 0 : _a.delete(observer)) $367bbc8f6a40f243$export$85c928794f8d04d4._subtreeObserverCount--;
    }
    // Tells the observers of this node and of its ancestors that something below
    // them changed. A node's own changes reach its observers through its change
    // events, so a draw request starts at the parent. A container calls this
    // itself when its child list changes.
    _notifySubtreeChange() {
        if (!$367bbc8f6a40f243$export$85c928794f8d04d4._subtreeObserverCount) return;
        for(let node = this; node; node = node.parent){
            const observers = node._subtreeObservers;
            if (observers) for (const o of observers)o._onSubtreeChange(node);
        }
    }
    _requestDraw() {
        var _a;
        (_a = this.parent) === null || _a === void 0 || _a._notifySubtreeChange();
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        const oldVal = this.attrs[key];
        if (oldVal === val && !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._attrsVersion !== undefined) this._attrsVersion++;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $367bbc8f6a40f243$var$SHAPE) evt.target = this;
        const nonBubbling = $367bbc8f6a40f243$var$NON_BUBBLING_EVENTS.indexOf(eventType) !== -1;
        const shouldStop = nonBubbling && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === 'Stage' && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            // simulate event bubbling
            const stopBubble = nonBubbling && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b;
        const proto = Object.getPrototypeOf(this);
        let allListeners = $367bbc8f6a40f243$export$85c928794f8d04d4.protoListenerMap.get(proto);
        if (!allListeners) {
            allListeners = {};
            $367bbc8f6a40f243$export$85c928794f8d04d4.protoListenerMap.set(proto, allListeners);
        }
        let events = allListeners[eventType];
        if (events === undefined) {
            //recalculate cache
            events = [];
            // Dedupe across the prototype chain: subclasses without their own
            // `eventListeners` inherit the parent's, so a single handler would
            // otherwise be pushed once per chain level (Stage→Container→Node = 3x).
            const seen = new Set();
            let obj = Object.getPrototypeOf(this);
            while(obj){
                const hierarchyEvents = (_b = (_a = obj.eventListeners) === null || _a === void 0 ? void 0 : _a[eventType]) !== null && _b !== void 0 ? _b : [];
                for(let i = 0; i < hierarchyEvents.length; i++){
                    const entry = hierarchyEvents[i];
                    if (!seen.has(entry)) {
                        seen.add(entry);
                        events.push(entry);
                    }
                }
                obj = Object.getPrototypeOf(obj);
            }
            // update cache
            allListeners[eventType] = events;
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) // The list is rebuilt when a prototype gains a listener, so no
        // defensive .slice() needed (hot path: every *Change).
        for(let i = 0; i < topListeners.length; i++)topListeners[i].handler.call(this, evt);
        // snapshot prevents skipping listeners when a handler mutates the array
        // (e.g. off + on for the same event), but we also need to fire listeners
        // added during dispatch (e.g. draggable(true) inside mousedown)
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) {
            const list = selfListeners.slice();
            const origLen = list.length;
            for(let i = 0; i < list.length; i++)list[i].handler.call(this, evt);
            // fire any listeners appended during dispatch
            const liveListeners = this.eventListeners[eventType];
            if (liveListeners) for(let i = origLen; i < liveListeners.length; i++)liveListeners[i].handler.call(this, evt);
        }
    }
    /**
     * draw both scene and hit graphs.  If the node being drawn is the stage, all of the layers will be cleared and redrawn
     * @method
     * @name Konva.Node#draw
     * @returns {Konva.Node}
     */ draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    // drag & drop
    _createDragElement(evt) {
        var _a;
        const pointerId = evt ? evt.pointerId : undefined;
        const stage = this.getStage();
        const ap = this.getAbsolutePosition();
        if (!stage) return;
        const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        const type = ((_a = evt === null || evt === void 0 ? void 0 : evt.evt) === null || _a === void 0 ? void 0 : _a.type) ? (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.evt.type) : stage._pointerEventType;
        // drags follow mouse and touch window events only, so a drag started from
        // a pointer event stays unbound until such an event attaches its pointer
        const bound = type !== 'pointer';
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: 'ready',
            pointerId: bound ? pointerId !== null && pointerId !== void 0 ? pointerId : 'id' in pos ? pos.id : undefined : undefined,
            pointerEventType: bound ? type : undefined,
            startEvent: evt
        });
    }
    /**
     * initiate drag and drop.
     * @method
     * @name Konva.Node#startDrag
     */ startDrag(evt, bubbleEvent = true) {
        var _a;
        if (!(0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
        // a node outside of a stage has no pointer to follow
        if (!elem) return;
        elem.dragStatus = 'dragging';
        (_a = this.getStage()) === null || _a === void 0 || _a._cancelClick(elem.pointerId, elem.pointerEventType);
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            // Use the stored start event if available (from mousedown/touchstart),
            // otherwise fall back to the provided event (when startDrag is called programmatically)
            evt: elem.startEvent && elem.startEvent.evt || evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        const dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            else if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(bounded.x) || !(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isNumber(bounded.y)) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn(`dragBoundFunc returned a position with a non-finite x or y (${bounded.x}, ${bounded.y}). The node was not moved.`);
                return;
            } else newNodePos = bounded;
        }
        const lastPos = elem.lastPos;
        if (!lastPos || lastPos.x !== newNodePos.x || lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        elem.lastPos = newNodePos;
    }
    /**
     * stop drag and drop
     * @method
     * @name Konva.Node#stopDrag
     */ stopDrag(evt) {
        const elem = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (!elem) return;
        elem.dragStatus = 'stopped';
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._endDragBefore(evt, undefined, elem);
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._endDragAfter(evt, elem);
    }
    setDraggable(draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    }
    /**
     * determine if node is currently in drag and drop mode
     * @method
     * @name Konva.Node#isDragging
     */ isDragging() {
        const elem = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function(evt) {
            const shouldCheckButton = evt.evt['button'] !== undefined;
            const canDrag = !shouldCheckButton || (0, $8c8384c27430fce8$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) return;
            if ((0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.has(this._id)) return;
            let hasDraggingChild = false;
            (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            // nested drag can be started
            // in that case we don't need to start new drag
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            // remove event listeners
            this._dragCleanup();
            /*
             * force drag and drop to end
             * if this node is currently in
             * drag and drop mode
             */ const stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === 'dragging';
            const isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    }
    /**
     * determine if node (at least partially) is currently in user-visible area
     * @method
     * @param {(Number | Object)} margin optional margin in pixels
     * @param {Number} margin.x
     * @param {Number} margin.y
     * @returns {Boolean}
     * @name Konva.Node#isClientRectOnScreen
     * @example
     * // get index
     * // default calculations
     * var isOnScreen = node.isClientRectOnScreen()
     * // increase object size (or screen size) for cases when objects close to the screen still need to be marked as "visible"
     * var isOnScreen = node.isClientRectOnScreen({ x: stage.width(), y: stage.height() })
     */ isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    /**
     * create node with JSON string or an Object. Deserialization restores attributes only,
     *  not functions, images or event handlers (that would make the serialized object huge):
     *  `sceneFunc`/`hitFunc` of custom shapes, images and `fillPatternImage`, `clipFunc`,
     *  `dragBoundFunc`, filter functions, the `nodes`, `boundBoxFunc` and `anchorStyleFunc`
     *  of a Transformer, typed arrays and the `cache()` state. If your app uses them (it probably
     *  does), select the nodes after loading the stage and set these properties again with
     *  `on()`, `sceneFunc()`, `image()` and so on
     * @method
     * @memberof Konva.Node
     * @param {String|Object} data string or object
     * @param {Element} [container] optional container dom element used only if you're
     *  creating a stage node
     */ static create(data, container) {
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        let className = $367bbc8f6a40f243$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        // if container was passed in, add it to attrs
        if (container) obj.attrs.container = container;
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692)[className]) {
            const fallback = children ? 'Group' : 'Shape';
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + `". Fallback to "${fallback}".`);
            className = fallback;
        }
        const Class = (0, $8c8384c27430fce8$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($367bbc8f6a40f243$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
}
// Number of registered observers. The ancestor walk is skipped while it is 0.
$367bbc8f6a40f243$export$85c928794f8d04d4._subtreeObserverCount = 0;
// Perf: while a batch is open, work that depends on many nodes (a Konva
// .Transformer refresh) is queued and runs once when the outermost scope
// ends, instead of once per node change. Scopes are the callers of
// _updateBatch() and _beginUpdateBatch().
$367bbc8f6a40f243$export$85c928794f8d04d4._updateBatchDepth = 0;
// a Set, so a callback queued once per change runs once per batch
$367bbc8f6a40f243$export$85c928794f8d04d4._pendingUpdates = new Set();
// keyed by prototype: subclasses that share a nodeType (every shape class)
// have their own listeners
$367bbc8f6a40f243$export$85c928794f8d04d4.protoListenerMap = new WeakMap();
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.nodeType = 'Node';
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
// attache events listeners once into prototype
// that way we don't spend too much time on making an new instance
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on($367bbc8f6a40f243$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($367bbc8f6a40f243$var$TRANSFORM);
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_TRANSFORM);
});
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on('visibleChange.konva', function() {
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$VISIBLE);
});
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on('listeningChange.konva', function() {
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$LISTENING);
    for(let parent = this.getParent(); parent; parent = parent.getParent()){
        const cache = parent._getCanvasCache();
        if (cache === null || cache === void 0 ? void 0 : cache.hit) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(cache.hit._canvas);
            cache.hit = null;
        }
    }
});
$367bbc8f6a40f243$export$85c928794f8d04d4.prototype.on('opacityChange.konva', function() {
    this._clearSelfAndDescendantCache($367bbc8f6a40f243$var$ABSOLUTE_OPACITY);
});
const $367bbc8f6a40f243$var$addGetterSetter = (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter;
/**
 * get/set zIndex relative to the node's siblings who share the same parent.
 * Please remember that zIndex is not absolute (like in CSS). It is relative to parent element only.
 * @name Konva.Node#zIndex
 * @method
 * @param {Number} index
 * @returns {Number}
 * @example
 * // get index
 * var index = node.zIndex();
 *
 * // set index
 * node.zIndex(2);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'zIndex');
/**
 * get/set node absolute position
 * @name Konva.Node#absolutePosition
 * @method
 * @param {Object} pos
 * @param {Number} pos.x
 * @param {Number} pos.y
 * @returns {Object}
 * @example
 * // get position
 * var position = node.absolutePosition();
 *
 * // set position
 * node.absolutePosition({
 *   x: 5,
 *   y: 10
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'absolutePosition');
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'position');
/**
 * get/set node position relative to parent
 * @name Konva.Node#position
 * @method
 * @param {Object} pos
 * @param {Number} pos.x
 * @param {Number} pos.y
 * @returns {Object}
 * @example
 * // get position
 * var position = node.position();
 *
 * // set position
 * node.position({
 *   x: 5,
 *   y: 10
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'x', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set x position
 * @name Konva.Node#x
 * @method
 * @param {Number} x
 * @returns {Object}
 * @example
 * // get x
 * var x = node.x();
 *
 * // set x
 * node.x(5);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'y', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set y position
 * @name Konva.Node#y
 * @method
 * @param {Number} y
 * @returns {Integer}
 * @example
 * // get y
 * var y = node.y();
 *
 * // set y
 * node.y(5);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'globalCompositeOperation', 'source-over', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set globalCompositeOperation of a node. globalCompositeOperation DOESN'T affect hit graph of nodes. So they are still trigger to events as they have default "source-over" globalCompositeOperation.
 * @name Konva.Node#globalCompositeOperation
 * @method
 * @param {String} type
 * @returns {String}
 * @example
 * // get globalCompositeOperation
 * var globalCompositeOperation = shape.globalCompositeOperation();
 *
 * // set globalCompositeOperation
 * shape.globalCompositeOperation('source-in');
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'opacity', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set opacity.  Opacity values range from 0 to 1.
 *  A node with an opacity of 0 is fully transparent, and a node
 *  with an opacity of 1 is fully opaque
 * @name Konva.Node#opacity
 * @method
 * @param {Object} opacity
 * @returns {Number}
 * @example
 * // get opacity
 * var opacity = node.opacity();
 *
 * // set opacity
 * node.opacity(0.5);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'name', '', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set name.
 * @name Konva.Node#name
 * @method
 * @param {String} name
 * @returns {String}
 * @example
 * // get name
 * var name = node.name();
 *
 * // set name
 * node.name('foo');
 *
 * // also node may have multiple names (as css classes)
 * node.name('foo bar');
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'id', '', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set id. Id is global for whole page.
 * @name Konva.Node#id
 * @method
 * @param {String} id
 * @returns {String}
 * @example
 * // get id
 * var name = node.id();
 *
 * // set id
 * node.id('foo');
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'rotation', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set rotation in degrees
 * @name Konva.Node#rotation
 * @method
 * @param {Number} rotation
 * @returns {Number}
 * @example
 * // get rotation in degrees
 * var rotation = node.rotation();
 *
 * // set rotation in degrees
 * node.rotation(45);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'scale', [
    'x',
    'y'
]);
/**
 * get/set scale
 * @name Konva.Node#scale
 * @param {Object} scale
 * @param {Number} scale.x
 * @param {Number} scale.y
 * @method
 * @returns {Object}
 * @example
 * // get scale
 * var scale = node.scale();
 *
 * // set scale
 * shape.scale({
 *   x: 2,
 *   y: 3
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'scaleX', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set scale x
 * @name Konva.Node#scaleX
 * @param {Number} x
 * @method
 * @returns {Number}
 * @example
 * // get scale x
 * var scaleX = node.scaleX();
 *
 * // set scale x
 * node.scaleX(2);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'scaleY', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set scale y
 * @name Konva.Node#scaleY
 * @param {Number} y
 * @method
 * @returns {Number}
 * @example
 * // get scale y
 * var scaleY = node.scaleY();
 *
 * // set scale y
 * node.scaleY(2);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'skew', [
    'x',
    'y'
]);
/**
 * get/set skew
 * @name Konva.Node#skew
 * @param {Object} skew
 * @param {Number} skew.x
 * @param {Number} skew.y
 * @method
 * @returns {Object}
 * @example
 * // get skew
 * var skew = node.skew();
 *
 * // set skew
 * node.skew({
 *   x: 20,
 *   y: 10
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'skewX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set skew x
 * @name Konva.Node#skewX
 * @param {Number} x
 * @method
 * @returns {Number}
 * @example
 * // get skew x
 * var skewX = node.skewX();
 *
 * // set skew x
 * node.skewX(3);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'skewY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set skew y
 * @name Konva.Node#skewY
 * @param {Number} y
 * @method
 * @returns {Number}
 * @example
 * // get skew y
 * var skewY = node.skewY();
 *
 * // set skew y
 * node.skewY(3);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'offset', [
    'x',
    'y'
]);
/**
 * get/set offset.  Offsets the default position and rotation point
 * @method
 * @param {Object} offset
 * @param {Number} offset.x
 * @param {Number} offset.y
 * @returns {Object}
 * @example
 * // get offset
 * var offset = node.offset();
 *
 * // set offset
 * node.offset({
 *   x: 20,
 *   y: 10
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'offsetX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set offset x
 * @name Konva.Node#offsetX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get offset x
 * var offsetX = node.offsetX();
 *
 * // set offset x
 * node.offsetX(3);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'offsetY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set offset y
 * @name Konva.Node#offsetY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get offset y
 * var offsetY = node.offsetY();
 *
 * // set offset y
 * node.offsetY(3);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'dragDistance', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set drag distance. A drag starts once the pointer moved this far from where it
 *  went down, on either axis. Default is `Konva.dragDistance`
 * @name Konva.Node#dragDistance
 * @method
 * @param {Number} distance
 * @returns {Number}
 * @example
 * // get drag distance
 * var dragDistance = node.dragDistance();
 *
 * // set distance
 * // node starts dragging only if pointer moved more then 3 pixels
 * node.dragDistance(3);
 * // or set globally
 * Konva.dragDistance = 3;
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'width', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set width
 * @name Konva.Node#width
 * @method
 * @param {Number} width
 * @returns {Number}
 * @example
 * // get width
 * var width = node.width();
 *
 * // set width
 * node.width(100);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'height', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set height
 * @name Konva.Node#height
 * @method
 * @param {Number} height
 * @returns {Number}
 * @example
 * // get height
 * var height = node.height();
 *
 * // set height
 * node.height(100);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'listening', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * get/set listening attr.  If you need to determine if a node is listening or not
 *   by taking into account its parents, use the isListening() method
 *   nodes with listening set to false will not be detected in hit graph
 *   so they will be ignored in container.getIntersection() method
 *   a non-listening layer (or a layer of a non-listening stage) also
 *   releases its hit canvas, so it uses less memory
 * @name Konva.Node#listening
 * @method
 * @param {Boolean} listening Can be true, or false.  The default is true.
 * @returns {Boolean}
 * @example
 * // get listening attr
 * var listening = node.listening();
 *
 * // stop listening for events, remove node and all its children from hit graph
 * node.listening(false);
 *
 * // listen to events according to the parent
 * node.listening(true);
 */ /**
 * get/set preventDefault
 * By default all shapes will prevent default behavior
 * of a browser on a pointer move or tap.
 * that will prevent native scrolling when you are trying to drag&drop a node
 * but sometimes you may need to enable default actions
 * in that case you can set the property to false
 * @name Konva.Node#preventDefault
 * @method
 * @param {Boolean} preventDefault
 * @returns {Boolean}
 * @example
 * // get preventDefault
 * var shouldPrevent = shape.preventDefault();
 *
 * // set preventDefault
 * shape.preventDefault(false);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'preventDefault', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
$367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'filters', undefined, function(val) {
    this._filterUpToDate = false;
    return val;
});
/**
 * get/set filters. Supports function filters, CSS filter strings, or mixed arrays.
 * CSS filters are applied using native browser performance when possible, function filters use ImageData manipulation.
 * CSS filters automatically fall back to function filters in unsupported browsers.
 * The fallback covers blur, brightness, contrast, grayscale, sepia and invert. A core build needs the Blur, Brightness and Contrast filters imported for the first three.
 * Blur radii, pixelation sizes and CSS lengths use node coordinates, independent of cache pixelRatio.
 * Custom filters receive (imageData, pixelRatio). ImageData contains full-resolution backing pixels.
 * @name Konva.Node#filters
 * @method
 * @param {Array} filters array of filter functions and/or CSS filter strings
 * @returns {Array}
 * @example
 * // get filters
 * var filters = node.filters();
 *
 * // set CSS filters only (caching required, uses native performance)
 * node.cache();
 * node.filters(['blur(5px)', 'brightness(1.2)', 'contrast(1.5)']);
 *
 * // set function filters only (caching required)
 * node.cache();
 * node.filters([Konva.Filters.Blur, Konva.Filters.Sepia, Konva.Filters.Invert]);
 *
 * // mix CSS and function filters (caching required, uses fallback strategy)
 * node.cache();
 * node.filters([
 *   'blur(3px)',           // CSS filter
 *   Konva.Filters.Invert,  // function filter
 *   'brightness(1.5)'      // CSS filter
 * ]);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'visible', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * get/set visible attr.  Can be true, or false.  The default is true.
 *   If you need to determine if a node is visible or not
 *   by taking into account its parents, use the isVisible() method
 * @name Konva.Node#visible
 * @method
 * @param {Boolean} visible
 * @returns {Boolean}
 * @example
 * // get visible attr
 * var visible = node.visible();
 *
 * // make invisible
 * node.visible(false);
 *
 * // make visible (according to the parent)
 * node.visible(true);
 *
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'transformsEnabled', 'all', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set transforms that are enabled.  Can be "all", "none", or "position".  The default
 *  is "all"
 * @name Konva.Node#transformsEnabled
 * @method
 * @param {String} enabled
 * @returns {String}
 * @example
 * // enable position transform only to improve draw performance
 * node.transformsEnabled('position');
 *
 * // enable all transforms
 * node.transformsEnabled('all');
 */ /**
 * get/set node size
 * @name Konva.Node#size
 * @method
 * @param {Object} size
 * @param {Number} size.width
 * @param {Number} size.height
 * @returns {Object}
 * @example
 * // get node size
 * var size = node.size();
 * var width = size.width;
 * var height = size.height;
 *
 * // set size
 * node.size({
 *   width: 100,
 *   height: 200
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'size');
/**
 * get/set drag bound function.  This is used to override the default
 *  drag and drop position. The function is called with the absolute position
 *  the node is about to get and the native event, and must return the
 *  absolute position to use
 * @name Konva.Node#dragBoundFunc
 * @method
 * @param {Function} dragBoundFunc function(pos, evt) returning `{ x, y }`
 * @returns {Function}
 * @example
 * // get drag bound function
 * var dragBoundFunc = node.dragBoundFunc();
 *
 * // create vertical drag and drop
 * node.dragBoundFunc(function(pos){
 *   // important pos - is absolute position of the node
 *   // you should return absolute position too
 *   return {
 *     x: this.absolutePosition().x,
 *     y: pos.y
 *   };
 * });
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'dragBoundFunc');
/**
 * get/set draggable flag
 * @name Konva.Node#draggable
 * @method
 * @param {Boolean} draggable
 * @returns {Boolean}
 * @example
 * // get draggable flag
 * var draggable = node.draggable();
 *
 * // enable drag and drop
 * node.draggable(true);
 *
 * // disable drag and drop
 * node.draggable(false);
 */ $367bbc8f6a40f243$var$addGetterSetter($367bbc8f6a40f243$export$85c928794f8d04d4, 'draggable', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($367bbc8f6a40f243$export$85c928794f8d04d4, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation'
});





class $f02a8e3513953b09$export$42a852a2b6b56249 extends (0, $367bbc8f6a40f243$export$85c928794f8d04d4) {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    /**
     * returns an array of direct descendant nodes
     * @method
     * @name Konva.Container#getChildren
     * @param {Function} [filterFunc] filter function
     * @returns {Array}
     * @example
     * // get all children
     * var children = layer.getChildren();
     *
     * // get only circles
     * var circles = layer.getChildren(function(node){
     *    return node.getClassName() === 'Circle';
     * });
     */ getChildren(filterFunc) {
        // a copy, so that removing children while iterating over it is safe
        const children = this.children || [];
        return filterFunc ? children.filter(filterFunc) : children.slice();
    }
    /**
     * determine if node has children
     * @method
     * @name Konva.Container#hasChildren
     * @returns {Boolean}
     */ hasChildren() {
        return this.children.length > 0;
    }
    /**
     * remove all children. Children will be still in memory.
     * If you want to completely destroy all children please use "destroyChildren" method instead
     * @method
     * @name Konva.Container#removeChildren
     */ removeChildren() {
        return this._clearChildren('remove');
    }
    /**
     * destroy all children nodes.
     * @method
     * @name Konva.Container#destroyChildren
     */ destroyChildren() {
        return this._clearChildren('destroy');
    }
    _clearChildren(dispose) {
        return (0, $367bbc8f6a40f243$export$85c928794f8d04d4)._updateBatch(()=>{
            this.children.forEach((child)=>{
                // reset parent to prevent many _setChildrenIndices calls
                child.parent = null;
                child.index = 0;
                child[dispose]();
            });
            this.children = [];
            // because all children were detached from parent, request draw via container
            this._notifySubtreeChange();
            this._requestDraw();
            return this;
        });
    }
    /**
     * add a child and children into container
     * @name Konva.Container#add
     * @method
     * @param {...Konva.Node} children
     * @returns {Container}
     * @example
     * layer.add(rect);
     * layer.add(shape1, shape2, shape3);
     * // empty arrays are accepted, though each individual child must be defined
     * layer.add(...shapes);
     */ add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.children.length;
        child.parent = this;
        child._clearCaches();
        this.children.push(child);
        this._fire('add', {
            child: child
        });
        this._notifySubtreeChange();
        this._requestDraw();
        // chainable
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    /**
     * return an array of nodes that match the selector.
     * You can provide a string with '#' for id selections and '.' for name selections.
     * Or a function that will return true/false when a node is passed through.  See example below.
     * With strings you can also select by type or class name. Pass multiple selectors
     * separated by a comma.
     * @method
     * @name Konva.Container#find
     * @param {String | Function} selector
     * @returns {Array}
     * @example
     *
     * Passing a string as a selector
     * // select node with id foo
     * var node = stage.find('#foo');
     *
     * // select nodes with name bar inside layer
     * var nodes = layer.find('.bar');
     *
     * // select all groups inside layer
     * var nodes = layer.find('Group');
     *
     * // select all rectangles inside layer
     * var nodes = layer.find('Rect');
     *
     * // select node with an id of foo or a name of bar inside layer
     * var nodes = layer.find('#foo, .bar');
     *
     * Passing a function as a selector
     *
     * // get all groups with a function
     * var groups = stage.find(node => {
     *  return node.getType() === 'Group';
     * });
     *
     * // get only Nodes with partial opacity
     * var alphaNodes = layer.find(node => {
     *  return node.getType() === 'Node' && node.getAbsoluteOpacity() < 1;
     * });
     */ find(selector) {
        // protecting _generalFind to prevent user from accidentally adding
        // second argument and getting unexpected `findOne` result
        return this._generalFind(selector, false);
    }
    /**
     * return a first node from `find` method
     * @method
     * @name Konva.Container#findOne
     * @param {String | Function} selector
     * @returns {Konva.Node | Undefined}
     * @example
     * // select node with id foo
     * var node = stage.findOne('#foo');
     *
     * // select node with name bar inside layer
     * var nodes = layer.findOne('.bar');
     *
     * // select the first node to return true in a function
     * var node = stage.findOne(node => {
     *  return node.getType() === 'Shape'
     * })
     */ findOne(selector) {
        const result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        const retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        for (const child of this.children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    // extenders
    toObject() {
        const obj = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.children.forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    /**
     * determine if node is an ancestor
     * of descendant
     * @method
     * @name Konva.Container#isAncestorOf
     * @param {Konva.Node} node
     */ isAncestorOf(node) {
        let parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        // call super method
        const node = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.children.forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    /**
     * get all shapes that intersect a point.  Note: because this method must clear a temporary
     * canvas and redraw every shape inside the container, it should only be used for special situations
     * because it performs very poorly.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
     * because it performs much better.
     * Nodes with listening set to false or invisible nodes are not detected
     * @method
     * @name Konva.Container#getAllIntersections
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Array} array of shapes
     */ getAllIntersections(pos) {
        const arr = [];
        this.find('Shape').forEach((shape)=>{
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        // Perf: an absoluteTransform cascade is an update batch, so a listener on
        // one of N descendants defers its work until the outermost walk returns.
        // try/finally so depth/flush survive listener exceptions.
        const isAbsTransform = attr === undefined || attr === 'absoluteTransform';
        if (isAbsTransform) (0, $367bbc8f6a40f243$export$85c928794f8d04d4)._updateBatchDepth++;
        try {
            super._clearSelfAndDescendantCache(attr);
            // a cached container is drawn from its bitmap, so its descendants keep
            // their transform caches while it moves (perf); Node.getAbsoluteTransform
            // skips those caches under a cached ancestor
            if (attr === 'absoluteTransform' && this.isCached()) return;
            (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
                node._clearSelfAndDescendantCache(attr);
            });
        } finally{
            if (isAbsTransform && --(0, $367bbc8f6a40f243$export$85c928794f8d04d4)._updateBatchDepth === 0) (0, $367bbc8f6a40f243$export$85c928794f8d04d4)._flushUpdateBatch();
        }
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._notifySubtreeChange();
        this._requestDraw();
    }
    drawScene(can, top) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        const caching = top === this;
        if (!(top ? this._isVisible(top) : this.isVisible()) && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren('drawScene', canvas, top);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedHitCanvas = this._getCachedHitCanvas(top);
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context, cachedHitCanvas);
            context.restore();
        } else this._drawChildren('drawHit', canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top) {
        const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === 'number' && typeof clipHeight === 'number' || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            const transform = this.getAbsoluteTransform(top);
            let m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) clipArgs = clipFunc.call(this, context, this);
            else {
                const clipX = this.clipX();
                const clipY = this.clipY();
                context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        const hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        try {
            this._drawChildNodes(drawMethod, canvas, top);
        } finally{
            if (hasComposition) context.restore();
            if (hasClip) context.restore();
        }
    }
    _drawChildNodes(drawMethod, canvas, top) {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top);
        });
    }
    getClientRect(config = {}) {
        var _a;
        const cachedRect = this._getCachedSceneRect(config);
        if (cachedRect) return cachedRect;
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const [a, b, c, d] = this.getAbsoluteTransform().getMatrix();
        // A zero scale cannot project local padding for a non-scaling stroke.
        const measureTransformed = !skipTransform && (config._forDrawing || a * d - b * c === 0);
        let minX, minY, maxX, maxY;
        let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        const that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            // skip invisible children
            if (!child.visible()) return;
            const rect = child.getClientRect({
                relativeTo: measureTransformed ? relativeTo : that,
                _forDrawing: config._forDrawing,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            // skip invisible children (like empty groups) and a child whose rect
            // would poison the whole box
            if (rect.width === 0 && rect.height === 0 || !isFinite(rect.x + rect.y + rect.width + rect.height)) return;
            if (minX === undefined) {
                // initial value for first child
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        if (minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform && !measureTransformed) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
// add getters setters
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clip', [
    'x',
    'y',
    'width',
    'height'
]);
/**
 * get/set clip
 * @method
 * @name Konva.Container#clip
 * @param {Object} clip
 * @param {Number} clip.x
 * @param {Number} clip.y
 * @param {Number} clip.width
 * @param {Number} clip.height
 * @returns {Object}
 * @example
 * // get clip
 * var clip = container.clip();
 *
 * // set clip
 * container.clip({
 *   x: 20,
 *   y: 20,
 *   width: 20,
 *   height: 20
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipX', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set clip x
 * @name Konva.Container#clipX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get clip x
 * var clipX = container.clipX();
 *
 * // set clip x
 * container.clipX(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipY', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set clip y
 * @name Konva.Container#clipY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get clip y
 * var clipY = container.clipY();
 *
 * // set clip y
 * container.clipY(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipWidth', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set clip width
 * @name Konva.Container#clipWidth
 * @method
 * @param {Number} width
 * @returns {Number}
 * @example
 * // get clip width
 * var clipWidth = container.clipWidth();
 *
 * // set clip width
 * container.clipWidth(100);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipHeight', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set clip height
 * @name Konva.Container#clipHeight
 * @method
 * @param {Number} height
 * @returns {Number}
 * @example
 * // get clip height
 * var clipHeight = container.clipHeight();
 *
 * // set clip height
 * container.clipHeight(100);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f02a8e3513953b09$export$42a852a2b6b56249, 'clipFunc'); /**
 * get/set clip function
 * @name Konva.Container#clipFunc
 * @method
 * @param {Function} function
 * @returns {Function}
 * @example
 * // get clip function
 * var clipFunction = container.clipFunc();
 *
 * // set clip function
 * container.clipFunc(function(ctx) {
 *   ctx.rect(0, 0, 100, 100);
 * });
 *
 * container.clipFunc(function(ctx) {
 *   // optionally return a clip Path2D and clip-rule or just the clip-rule
 *   return [new Path2D('M0 0v50h50Z'), 'evenodd']
 * });
 */ 









// CONSTANTS
const $ac2a2e8b879d4f85$var$STAGE = 'Stage', $ac2a2e8b879d4f85$var$STRING = 'string', $ac2a2e8b879d4f85$var$PX = 'px', $ac2a2e8b879d4f85$var$MOUSEOUT = 'mouseout', $ac2a2e8b879d4f85$var$MOUSELEAVE = 'mouseleave', $ac2a2e8b879d4f85$var$MOUSEOVER = 'mouseover', $ac2a2e8b879d4f85$var$MOUSEENTER = 'mouseenter', $ac2a2e8b879d4f85$var$MOUSEMOVE = 'mousemove', $ac2a2e8b879d4f85$var$MOUSEDOWN = 'mousedown', $ac2a2e8b879d4f85$var$MOUSEUP = 'mouseup', $ac2a2e8b879d4f85$var$POINTERMOVE = 'pointermove', $ac2a2e8b879d4f85$var$POINTERDOWN = 'pointerdown', $ac2a2e8b879d4f85$var$POINTERUP = 'pointerup', $ac2a2e8b879d4f85$var$POINTERCANCEL = 'pointercancel', $ac2a2e8b879d4f85$var$LOSTPOINTERCAPTURE = 'lostpointercapture', $ac2a2e8b879d4f85$var$POINTEROUT = 'pointerout', $ac2a2e8b879d4f85$var$POINTERLEAVE = 'pointerleave', $ac2a2e8b879d4f85$var$POINTEROVER = 'pointerover', $ac2a2e8b879d4f85$var$POINTERENTER = 'pointerenter', $ac2a2e8b879d4f85$var$CONTEXTMENU = 'contextmenu', $ac2a2e8b879d4f85$var$TOUCHSTART = 'touchstart', $ac2a2e8b879d4f85$var$TOUCHEND = 'touchend', $ac2a2e8b879d4f85$var$TOUCHMOVE = 'touchmove', $ac2a2e8b879d4f85$var$TOUCHCANCEL = 'touchcancel', $ac2a2e8b879d4f85$var$WHEEL = 'wheel', $ac2a2e8b879d4f85$var$MAX_LAYERS_NUMBER = 5, $ac2a2e8b879d4f85$var$EVENTS = [
    [
        $ac2a2e8b879d4f85$var$MOUSEENTER,
        '_pointerenter'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEDOWN,
        '_pointerdown'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEMOVE,
        '_pointermove'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEUP,
        '_pointerup'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSELEAVE,
        '_pointerleave'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHSTART,
        '_pointerdown'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHMOVE,
        '_pointermove'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHEND,
        '_pointerup'
    ],
    [
        $ac2a2e8b879d4f85$var$TOUCHCANCEL,
        '_pointercancel'
    ],
    [
        $ac2a2e8b879d4f85$var$MOUSEOVER,
        '_pointerover'
    ],
    [
        $ac2a2e8b879d4f85$var$WHEEL,
        '_wheel'
    ],
    [
        $ac2a2e8b879d4f85$var$CONTEXTMENU,
        '_contextmenu'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERDOWN,
        '_pointerdown'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERMOVE,
        '_pointermove'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERUP,
        '_pointerup'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERCANCEL,
        '_pointercancel'
    ],
    [
        $ac2a2e8b879d4f85$var$POINTERLEAVE,
        '_pointerleave'
    ],
    [
        $ac2a2e8b879d4f85$var$LOSTPOINTERCAPTURE,
        '_lostpointercapture'
    ]
];
const $ac2a2e8b879d4f85$var$EVENTS_MAP = {
    mouse: {
        [$ac2a2e8b879d4f85$var$POINTEROUT]: $ac2a2e8b879d4f85$var$MOUSEOUT,
        [$ac2a2e8b879d4f85$var$POINTERLEAVE]: $ac2a2e8b879d4f85$var$MOUSELEAVE,
        [$ac2a2e8b879d4f85$var$POINTEROVER]: $ac2a2e8b879d4f85$var$MOUSEOVER,
        [$ac2a2e8b879d4f85$var$POINTERENTER]: $ac2a2e8b879d4f85$var$MOUSEENTER,
        [$ac2a2e8b879d4f85$var$POINTERMOVE]: $ac2a2e8b879d4f85$var$MOUSEMOVE,
        [$ac2a2e8b879d4f85$var$POINTERDOWN]: $ac2a2e8b879d4f85$var$MOUSEDOWN,
        [$ac2a2e8b879d4f85$var$POINTERUP]: $ac2a2e8b879d4f85$var$MOUSEUP,
        [$ac2a2e8b879d4f85$var$POINTERCANCEL]: 'mousecancel',
        pointerclick: 'click',
        pointerdblclick: 'dblclick'
    },
    touch: {
        [$ac2a2e8b879d4f85$var$POINTEROUT]: 'touchout',
        [$ac2a2e8b879d4f85$var$POINTERLEAVE]: 'touchleave',
        [$ac2a2e8b879d4f85$var$POINTEROVER]: 'touchover',
        [$ac2a2e8b879d4f85$var$POINTERENTER]: 'touchenter',
        [$ac2a2e8b879d4f85$var$POINTERMOVE]: $ac2a2e8b879d4f85$var$TOUCHMOVE,
        [$ac2a2e8b879d4f85$var$POINTERDOWN]: $ac2a2e8b879d4f85$var$TOUCHSTART,
        [$ac2a2e8b879d4f85$var$POINTERUP]: $ac2a2e8b879d4f85$var$TOUCHEND,
        [$ac2a2e8b879d4f85$var$POINTERCANCEL]: $ac2a2e8b879d4f85$var$TOUCHCANCEL,
        pointerclick: 'tap',
        pointerdblclick: 'dbltap'
    },
    pointer: {
        [$ac2a2e8b879d4f85$var$POINTEROUT]: $ac2a2e8b879d4f85$var$POINTEROUT,
        [$ac2a2e8b879d4f85$var$POINTERLEAVE]: $ac2a2e8b879d4f85$var$POINTERLEAVE,
        [$ac2a2e8b879d4f85$var$POINTEROVER]: $ac2a2e8b879d4f85$var$POINTEROVER,
        [$ac2a2e8b879d4f85$var$POINTERENTER]: $ac2a2e8b879d4f85$var$POINTERENTER,
        [$ac2a2e8b879d4f85$var$POINTERMOVE]: $ac2a2e8b879d4f85$var$POINTERMOVE,
        [$ac2a2e8b879d4f85$var$POINTERDOWN]: $ac2a2e8b879d4f85$var$POINTERDOWN,
        [$ac2a2e8b879d4f85$var$POINTERUP]: $ac2a2e8b879d4f85$var$POINTERUP,
        [$ac2a2e8b879d4f85$var$POINTERCANCEL]: $ac2a2e8b879d4f85$var$POINTERCANCEL,
        pointerclick: 'pointerclick',
        pointerdblclick: 'pointerdblclick'
    }
};
const $ac2a2e8b879d4f85$var$getEventsMap = (eventType)=>{
    const type = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(eventType);
    if (type === 'pointer') return (0, $8c8384c27430fce8$export$b9f99057a3c7692).pointerEventsEnabled && $ac2a2e8b879d4f85$var$EVENTS_MAP.pointer;
    if (type === 'touch') return $ac2a2e8b879d4f85$var$EVENTS_MAP.touch;
    if (type === 'mouse') return $ac2a2e8b879d4f85$var$EVENTS_MAP.mouse;
};
function $ac2a2e8b879d4f85$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    return attrs;
}
const $ac2a2e8b879d4f85$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05 = [];
// A stage may be rendered in another window than the one Konva was imported
// into: an iframe, or a window opened with `window.open`. Such a window sends
// its own events and has its own visibility state, so Konva listens to every
// window it renders a stage in
const $ac2a2e8b879d4f85$var$listeningWindows = new WeakSet();
const $ac2a2e8b879d4f85$var$listenToWindow = (win)=>{
    if (!win || $ac2a2e8b879d4f85$var$listeningWindows.has(win)) return;
    $ac2a2e8b879d4f85$var$listeningWindows.add(win);
    (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._listenToWindow(win);
    // chrome is clearing canvas in inactive browser window, causing layer content to be erased
    // so let's redraw layers as soon as window becomes active
    win.document.addEventListener('visibilitychange', ()=>{
        $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.forEach((stage)=>{
            stage.batchDraw();
        });
    });
};
class $ac2a2e8b879d4f85$export$208cd1682bd0e4b6 extends (0, $f02a8e3513953b09$export$42a852a2b6b56249) {
    constructor(config){
        super($ac2a2e8b879d4f85$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._pointerStates = new Map();
        this._lastClicks = {};
        this._buildDOM();
        this._bindContentEvents();
        $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.push(this);
        this.on('widthChange.konva heightChange.konva', this._resizeDOM);
        this.on('visibleChange.konva', this._checkVisibility);
        this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', ()=>{
            $ac2a2e8b879d4f85$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === 'Layer';
        const isFastLayer = child.getType() === 'FastLayer';
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('You may only add layers to the stage.');
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    }
    /**
     * The window the stage is rendered in. It is not always the window Konva was
     * imported into: the container may belong to an iframe, or to a window
     * opened with `window.open`.
     */ _getOwnerWindow() {
        var _a;
        const element = this.content || this.container();
        // a document with no browsing context, such as one of `DOMParser`, has no
        // window of its own. The window Konva was imported into is used then
        return ((_a = element === null || element === void 0 ? void 0 : element.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) || ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser ? window : null);
    }
    /**
     * set container dom element which contains the stage wrapper div element
     * @method
     * @name Konva.Stage#setContainer
     * @param {DomElement} container can pass in a dom element or id string
     */ setContainer(container) {
        if (typeof container === $ac2a2e8b879d4f85$var$STRING) {
            let id;
            if (container.charAt(0) === '.') {
                const className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                if (container.charAt(0) !== '#') id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw 'Can not find container in document with id ' + id;
        }
        this._setAttr('container', container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
            // the new container may be in another window, with its own events
            $ac2a2e8b879d4f85$var$listenToWindow(this._getOwnerWindow());
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    /**
     * clear all layers
     * @method
     * @name Konva.Stage#clear
     */ clear() {
        const layers = this.children, len = layers.length;
        for(let n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== 'undefined' && document.createElement('div');
        return (0, $f02a8e3513953b09$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        var _a;
        super.destroy();
        this._pointerStates.clear();
        this._lastClicks = {};
        const content = this.content;
        (_a = content === null || content === void 0 ? void 0 : content.parentNode) === null || _a === void 0 || _a.removeChild(content);
        const index = $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferHitCanvas._canvas);
        return this;
    }
    /**
     * returns ABSOLUTE pointer position which can be a touch position or mouse position
     * pointer position doesn't include any transforms (such as scale) of the stage
     * it is just a plain position of pointer relative to top-left corner of the canvas
     * @method
     * @name Konva.Stage#getPointerPosition
     * @returns {Vector2d|null}
     */ getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn($ac2a2e8b879d4f85$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = {
            ...config
        };
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        const canvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        const _context = canvas.getContext()._context;
        const layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        // every layer renders on its own canvas, like on screen, so a
        // globalCompositeOperation inside a layer does not reach the layers below
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(layerCanvas._canvas);
        });
        return canvas;
    }
    /**
     * get visible intersection shape. This is the preferred
     *  method for determining if a point intersects a shape or not.
     *  It reads the hit canvas, so it finds what pointer events would: nodes with
     *  listening set to false or invisible nodes are not detected, a shape with opacity 0
     *  is, and `hitStrokeWidth` counts. The position is relative to the top left corner of the
     * stage container, like `stage.getPointerPosition()`, without the stage transform
     * @method
     * @name Konva.Stage#getIntersection
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Konva.Node}
     * @example
     * var shape = stage.getIntersection({x: 50, y: 50});
     */ getIntersection(pos) {
        if (!pos) return null;
        const layers = this.children, len = layers.length, end = len - 1;
        for(let n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        const width = this.width();
        const height = this.height();
        if (this.content) {
            // set content dimensions
            this.content.style.width = width + $ac2a2e8b879d4f85$var$PX;
            this.content.style.height = height + $ac2a2e8b879d4f85$var$PX;
        }
        // set layer dimensions
        this.children.forEach((layer)=>{
            layer._setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        const length = this.children.length;
        if (length > $ac2a2e8b879d4f85$var$MAX_LAYERS_NUMBER) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('The stage has ' + length + ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        layer._setSize({
            width: this.width(),
            height: this.height()
        });
        // draw layer and append canvas to container
        layer.draw();
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        // chainable
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $6d58c7ba166afa5f$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $6d58c7ba166afa5f$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId, this);
    }
    /**
     * returns an array of layers
     * @method
     * @name Konva.Stage#getLayers
     */ getLayers() {
        return this.getChildren();
    }
    _bindContentEvents() {
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) return;
        $ac2a2e8b879d4f85$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this._batchEvents(()=>this[methodName](evt));
            }, {
                passive: false
            });
        });
    }
    _batchEvents(callback) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._batchEvents(this.eventBatchFunc(), callback);
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerEventsEnabled() {
        if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).hitOnDragEnabled) return true;
        for (const { node: node, dragStatus: dragStatus } of (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.values()){
            if (dragStatus === 'dragging' && node.getStage() === this) return false;
        }
        return !this.getLayers().some((layer)=>{
            var _a;
            return (_a = (0, $8c8384c27430fce8$export$b9f99057a3c7692)['Transformer']) === null || _a === void 0 ? void 0 : _a._isLayerTransforming(layer);
        });
    }
    _cancelClick(pointerId, eventType) {
        const types = eventType ? [
            eventType
        ] : [
            'mouse',
            'touch',
            'pointer'
        ];
        for (const type of types){
            const state = this._pointerStates.get(`${type}:${pointerId}`);
            if (!state) continue;
            state.clickStartShape = undefined;
            if (state.relatedPointer) state.relatedPointer.clickStartShape = undefined;
        }
    }
    _pointerleave(evt) {
        var _a, _b;
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const pointerId = (_a = this._changedPointerPositions[0]) === null || _a === void 0 ? void 0 : _a.id;
        const key = `${eventType}:${pointerId}`;
        const state = this._pointerStates.get(key);
        const targetShape = ((_b = state === null || state === void 0 ? void 0 : state.targetShape) === null || _b === void 0 ? void 0 : _b.getStage()) === this ? state.targetShape : undefined;
        // A released touch will not return to deliver a deferred hover exit.
        const eventsEnabled = this._pointerEventsEnabled() || evt.pointerType === 'touch' && !(state === null || state === void 0 ? void 0 : state.downPosition);
        if (eventsEnabled) {
            if ((state === null || state === void 0 ? void 0 : state.clickStartShape) !== undefined) state.targetShape = undefined;
            else this._pointerStates.delete(key);
        }
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt,
                pointerId: pointerId
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt,
                pointerId: pointerId
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = null;
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._pointerEventType = undefined;
    }
    _pointerdown(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var _a;
            const shape = this.getIntersection(pos);
            const key = `${eventType}:${pos.id}`;
            const state = {
                targetShape: (_a = this._pointerStates.get(key)) === null || _a === void 0 ? void 0 : _a.targetShape,
                clickStartShape: shape && shape.isListening() ? shape : null,
                lastClick: this._lastClicks[eventType],
                downPosition: pos,
                pointerType: evt.pointerType
            };
            // A native pointerdown precedes its compatibility mouse/touch event.
            // Keep that association for the press: IDs can differ, and mouse
            // coordinates can be rounded by the browser.
            this._pointerStates.delete(key);
            if (eventType !== 'pointer') for (const [pointerKey, pointer] of [
                ...this._pointerStates
            ].reverse()){
                if (!pointerKey.startsWith('pointer:') || !pointer.downPosition || eventType === 'touch' && pointer.relatedPointer) continue;
                const matches = eventType === 'mouse' ? pointer.pointerType !== 'touch' : pointer.pointerType === 'touch' && pointer.downPosition.x === pos.x && pointer.downPosition.y === pos.y;
                if (matches) {
                    state.relatedPointer = pointer;
                    pointer.relatedPointer = state;
                    if (pointer.clickStartShape === undefined) state.clickStartShape = undefined;
                    break;
                }
            }
            this._pointerStates.set(key, state);
            for (const elem of (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.values())if (elem.dragStatus === 'dragging' && (elem.pointerId === undefined || elem.pointerEventType === eventType && elem.pointerId === pos.id || elem.pointerEventType === 'mouse' && eventType === 'pointer' && state.pointerType !== 'touch') && elem.node.getStage() === this) {
                // Drag movement uses the compatibility mouse/touch pointer.
                if (elem.pointerId === undefined && eventType !== 'pointer') {
                    elem.pointerId = pos.id;
                    elem.pointerEventType = eventType;
                }
                this._cancelClick(pos.id, eventType);
            }
            // no shape detected? do nothing
            if (!shape || !shape.isListening()) return;
            if ((0, $8c8384c27430fce8$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            // only call preventDefault if the shape is listening for events
            const isTouch = evt.type.indexOf('touch') >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        // trigger down on stage if not already
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.type);
        if (!events) return;
        // prevent default only for touch-based interactions to avoid blocking
        // native mouse wheel scrolling during drag on desktop
        const isTouchPointer = evt.type.indexOf('touch') >= 0 || evt.pointerType === 'touch';
        if (evt.cancelable && isTouchPointer) {
            for (const { node: node, dragStatus: dragStatus } of (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.values())if (dragStatus === 'dragging' && node.getStage() === this && node.preventDefault()) {
                evt.preventDefault();
                break;
            }
        }
        this.setPointersPositions(evt);
        const eventsEnabled = this._pointerEventsEnabled();
        if (!eventsEnabled) return;
        const processedShapesIds = {};
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            var _a;
            const key = `${eventType}:${pos.id}`;
            let state = this._pointerStates.get(key);
            if (!state) {
                state = {};
                this._pointerStates.set(key, state);
            }
            const shape = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const targetShape = state.targetShape === shape || ((_a = state.targetShape) === null || _a === void 0 ? void 0 : _a.getStage()) === this ? state.targetShape : undefined;
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            const differentTarget = targetShape !== shape;
            state.targetShape = shape && shape.isListening() ? shape : undefined;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, {
                    ...event
                }, shape);
                targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                }, shape);
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, {
                        ...event
                    }, targetShape);
                    shape._fireAndBubble(events.pointerenter, {
                        ...event
                    }, targetShape);
                }
                if (!processedShapesIds[shape._id]) {
                    processedShapesIds[shape._id] = true;
                    shape._fireAndBubble(events.pointermove, {
                        ...event
                    });
                }
            } else if (targetShape) this._fire(events.pointerover, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: pointerId
            });
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        const eventType = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const processedShapesIds = {};
        let skipPointerUpTrigger = false;
        this._changedPointerPositions.forEach((pos)=>{
            var _a;
            const key = `${eventType}:${pos.id}`;
            const state = this._pointerStates.get(key);
            const listenClick = (state === null || state === void 0 ? void 0 : state.clickStartShape) !== undefined;
            const clickStartShape = state === null || state === void 0 ? void 0 : state.clickStartShape;
            if ((state === null || state === void 0 ? void 0 : state.targetShape) && eventType !== 'touch') this._pointerStates.set(key, {
                targetShape: state.targetShape
            });
            else this._pointerStates.delete(key);
            const shape = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const alreadyReleased = shape && processedShapesIds[shape._id];
            if (shape) {
                shape.releaseCapture(pos.id);
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            const clickTarget = shape && shape.isListening() ? shape : null;
            const lastClick = this._lastClicks[eventType];
            const canClick = listenClick && (!clickTarget || clickStartShape === clickTarget);
            const fireDblClick = canClick && lastClick && (state === null || state === void 0 ? void 0 : state.lastClick) === lastClick && lastClick.shape === clickTarget && Date.now() - lastClick.time < (0, $8c8384c27430fce8$export$b9f99057a3c7692).dblClickWindow;
            if (canClick) this._lastClicks[eventType] = fireDblClick ? undefined : {
                shape: clickTarget,
                time: Date.now()
            };
            if (shape && shape.isListening()) {
                skipPointerUpTrigger = true;
                if (!alreadyReleased) shape._fireAndBubble(events.pointerup, {
                    ...event
                });
                // detect if click or double click occurred
                if (listenClick && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, {
                        ...event
                    });
                    if (fireDblClick) shape._fireAndBubble(events.pointerdblclick, {
                        ...event
                    });
                }
            } else {
                if (!skipPointerUpTrigger) {
                    this._fire(events.pointerup, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId: this._changedPointerPositions[0].id
                    });
                    skipPointerUpTrigger = true;
                }
                if (listenClick) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
            if (eventType === 'touch' && ((_a = state === null || state === void 0 ? void 0 : state.targetShape) === null || _a === void 0 ? void 0 : _a.getStage()) === this) {
                state.targetShape._fireAndBubble(events.pointerout, {
                    ...event
                });
                state.targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                });
            }
        });
        if (!skipPointerUpTrigger) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        // always call preventDefault for desktop events because some browsers
        // try to drag and drop the canvas element
        // do not call this function on mobile because it prevent "click" event on all parent containers
        // but apps may listen to it.
        if (evt.cancelable && eventType !== 'touch' && eventType !== 'pointer') evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($ac2a2e8b879d4f85$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($ac2a2e8b879d4f85$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($ac2a2e8b879d4f85$var$WHEEL, {
            evt: evt
        });
        else this._fire($ac2a2e8b879d4f85$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const events = $ac2a2e8b879d4f85$var$getEventsMap(evt.type);
        this._changedPointerPositions.forEach((pos)=>{
            var _a;
            const eventType = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getEventType(evt.type);
            const key = `${eventType}:${pos.id}`;
            this._cancelClick(pos.id, eventType);
            const targetShape = (_a = this._pointerStates.get(key)) === null || _a === void 0 ? void 0 : _a.targetShape;
            if (targetShape && eventType !== 'touch') this._pointerStates.set(key, {
                targetShape: targetShape
            });
            else this._pointerStates.delete(key);
            const shape = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const event = {
                evt: evt,
                pointerId: pos.id
            };
            if (shape) {
                if (events) shape._fireAndBubble(events.pointercancel, {
                    ...event
                });
                // Keep the historical pointerup notification for cancellation listeners.
                shape._fireAndBubble($ac2a2e8b879d4f85$var$POINTERUP, {
                    ...event
                });
            } else if (events) this._fire(events.pointercancel, {
                ...event,
                target: this,
                currentTarget: this
            });
            $6d58c7ba166afa5f$export$50f687f23c43e4d9(pos.id);
            if (events && eventType === 'touch' && (targetShape === null || targetShape === void 0 ? void 0 : targetShape.getStage()) === this) {
                targetShape._fireAndBubble(events.pointerout, {
                    ...event
                });
                targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                });
            }
        });
    }
    _lostpointercapture(evt) {
        const captured = $6d58c7ba166afa5f$export$a55e3aaa85f15b00(evt.pointerId, this);
        if (captured) $6d58c7ba166afa5f$export$50f687f23c43e4d9(evt.pointerId);
    }
    /**
     * manually register pointers positions (mouse/touch) in the stage.
     * So you can use stage.getPointerPosition(). Usually you don't need to use that method
     * because all internal events are automatically registered. It may be useful if event
     * is triggered outside of the stage, but you still want to use Konva methods to get pointers position.
     * @method
     * @name Konva.Stage#setPointersPositions
     * @param {Object} evt Event object
     * @example
     *
     * window.addEventListener('mousemove', (e) => {
     *   stage.setPointersPositions(e);
     * });
     */ setPointersPositions(evt) {
        const contentPosition = this._getContentPosition();
        let x = null, y = null;
        evt = evt ? evt : window.event;
        // touch events
        if (evt.touches !== undefined) {
            this._pointerEventType = 'touch';
            // touchlist has not support for map method
            // so we have to iterate
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            // mouse events
            this._pointerEventType = evt.pointerId === undefined ? 'mouse' : 'pointer';
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        const rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            // sometimes clientWidth can be equals to 0
            // i saw it in react-konva test, looks like it is because of hidden testing element
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        // lazy buffer canvas, sized by Shape.intersects() on first use
        // https://github.com/konvajs/konva/issues/2009
        this.bufferHitCanvas = new (0, $94cf583ff38878f8$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: 0,
            height: 0
        });
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).isBrowser) return;
        const container = this.container();
        if (!container) throw 'Stage has no container. A container is required.';
        // clear content inside container
        container.innerHTML = '';
        // content
        // the container may belong to another document - an iframe, or a popout
        // window - so the content is created in the document of the container
        this.content = container.ownerDocument.createElement('div');
        this.content.style.position = 'relative';
        this.content.style.userSelect = 'none';
        this.content.className = 'konvajs-content';
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        $ac2a2e8b879d4f85$var$listenToWindow(this._getOwnerWindow());
        this._resizeDOM();
    }
    // currently cache function is now working for stage, because stage has no its own canvas element
    cache() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    }
    clearCache() {
        return this;
    }
    /**
     * batch draw
     * @method
     * @name Konva.Stage#batchDraw
     * @return {Konva.Stage} this
     */ batchDraw() {
        var _a;
        // the config applied by the Node constructor already requests a draw,
        // before the children array exists
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$ac2a2e8b879d4f85$export$208cd1682bd0e4b6.prototype.nodeType = $ac2a2e8b879d4f85$var$STAGE;
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($ac2a2e8b879d4f85$export$208cd1682bd0e4b6);
/**
 * get/set container DOM element. The container may belong to another window
 * than the one Konva was imported into: an iframe, or a window opened with
 * `window.open`. The stage then uses the events and the frames of that window.
 * @method
 * @name Konva.Stage#container
 * @returns {DomElement} container
 * @example
 * // get container
 * var container = stage.container();
 * // set container
 * var container = document.createElement('div');
 * body.appendChild(container);
 * stage.container(container);
 *
 * // a stage in a popout window
 * var popout = window.open('', '', 'width=600,height=400');
 * stage.container(popout.document.body);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ac2a2e8b879d4f85$export$208cd1682bd0e4b6, 'container');
/**
 * Get/set the callback used by framework integrations to batch native input.
 * The callback must invoke its argument exactly once, synchronously. Existing
 * node events keep their order and cancellation behavior. Direct node.fire()
 * and programmatic mutations do not create a batch.
 * Missing calls warn; duplicate or late calls warn and are ignored. Exceptions
 * propagate and skipped input is not replayed, so an invalid callback can
 * prevent input processing and drag cleanup.
 * Each native Konva listener creates its own scope; a DOM event may invoke
 * several listeners. Batching does not reorder or merge those listeners.
 * @method
 * @name Konva.Stage#eventBatchFunc
 * @example
 * stage.eventBatchFunc((run) => frameworkBatch(run));
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ac2a2e8b879d4f85$export$208cd1682bd0e4b6, 'eventBatchFunc');













const $9081147451080c7d$var$HAS_SHADOW = 'hasShadow';
const $9081147451080c7d$var$HAS_FILL = 'hasFill';
const $9081147451080c7d$var$HAS_STROKE = 'hasStroke';
const $9081147451080c7d$var$SHADOW_RGBA = 'shadowRGBA';
const $9081147451080c7d$var$patternImage = 'patternImage';
const $9081147451080c7d$var$linearGradient = 'linearGradient';
const $9081147451080c7d$var$radialGradient = 'radialGradient';
let $9081147451080c7d$var$dummyContext;
function $9081147451080c7d$var$getDummyContext() {
    if ($9081147451080c7d$var$dummyContext) return $9081147451080c7d$var$dummyContext;
    $9081147451080c7d$var$dummyContext = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement().getContext('2d');
    return $9081147451080c7d$var$dummyContext;
}
const $9081147451080c7d$export$4ff7fc6f1af248b5 = {};
function $9081147451080c7d$var$_fillFunc(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $9081147451080c7d$var$_strokeFunc(context) {
    context.stroke();
}
function $9081147451080c7d$var$_clearHasShadowCache() {
    this._clearCache($9081147451080c7d$var$HAS_SHADOW);
}
function $9081147451080c7d$var$_clearHasFillCache() {
    this._clearCache($9081147451080c7d$var$HAS_FILL);
}
function $9081147451080c7d$var$_clearHasStrokeCache() {
    this._clearCache($9081147451080c7d$var$HAS_STROKE);
}
function $9081147451080c7d$var$_clearGetShadowRGBACache() {
    this._clearCache($9081147451080c7d$var$SHADOW_RGBA);
}
function $9081147451080c7d$var$_clearFillPatternCache() {
    this._clearCache($9081147451080c7d$var$patternImage);
}
function $9081147451080c7d$var$_clearLinearGradientCache() {
    this._clearCache($9081147451080c7d$var$linearGradient);
}
function $9081147451080c7d$var$_clearRadialGradientCache() {
    this._clearCache($9081147451080c7d$var$radialGradient);
}
class $9081147451080c7d$export$6428a7f2611ef1fa extends (0, $367bbc8f6a40f243$export$85c928794f8d04d4) {
    constructor(config){
        super(config);
        // set colorKey
        let key;
        let attempts = 0;
        while(true){
            key = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).getHitColor();
            if (key && !(key in $9081147451080c7d$export$4ff7fc6f1af248b5)) break;
            attempts++;
            if (attempts >= 10000) {
                (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Failed to find a unique color key for a shape. Konva may work incorrectly. Most likely your browser is using canvas farbling. Consider disabling it.');
                key = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).getRandomColor();
                break;
            }
        }
        this.colorKey = key;
        $9081147451080c7d$export$4ff7fc6f1af248b5[key] = this;
    }
    /**
     * @deprecated
     */ getContext() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('shape.getContext() method is deprecated. Please do not use it.');
        return this.getLayer().getContext();
    }
    /**
     * @deprecated
     */ getCanvas() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('shape.getCanvas() method is deprecated. Please do not use it.');
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this['_hitFunc'];
    }
    /**
     * returns whether or not a shadow will be rendered
     * @method
     * @name Konva.Shape#hasShadow
     * @returns {Boolean}
     */ hasShadow() {
        return this._getCache($9081147451080c7d$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _toStyleSpace(point) {
        return this._styleTransform ? this._styleTransform.point(point) : point;
    }
    // Unlike a gradient, a pattern can be moved after it is created, so one
    // pattern serves every space it is drawn in (see _styleTransform).
    _getFillPattern() {
        const pattern = this._getCache($9081147451080c7d$var$patternImage, this._createFillPattern);
        return pattern && this._setFillPatternTransform(pattern);
    }
    _createFillPattern() {
        if (this.fillPatternImage()) return $9081147451080c7d$var$getDummyContext().createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
    }
    _setFillPatternTransform(pattern) {
        var _a;
        if (pattern.setTransform) {
            const tr = ((_a = this._styleTransform) === null || _a === void 0 ? void 0 : _a.copy()) || new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
            tr.translate(this.fillPatternX(), this.fillPatternY());
            tr.rotate((0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
            tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
            tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
            const m = tr.getMatrix();
            const matrix = typeof DOMMatrix === 'undefined' ? {
                a: m[0],
                b: m[1],
                c: m[2],
                d: m[3],
                e: m[4],
                f: m[5]
            } : new DOMMatrix(m);
            pattern.setTransform(matrix);
        }
        return pattern;
    }
    _getLinearGradient() {
        if (this._styleTransform) return this.__getLinearGradient();
        return this._getCache($9081147451080c7d$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        const colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            const ctx = $9081147451080c7d$var$getDummyContext();
            const start = this._toStyleSpace(this.fillLinearGradientStartPoint());
            const end = this._toStyleSpace(this.fillLinearGradientEndPoint());
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            // build color stops
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        if (this._styleTransform) return this.__getRadialGradient();
        return this._getCache($9081147451080c7d$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        const colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            const ctx = $9081147451080c7d$var$getDummyContext();
            // a rigid transform keeps the radii
            const start = this._toStyleSpace(this.fillRadialGradientStartPoint());
            const end = this._toStyleSpace(this.fillRadialGradientEndPoint());
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            // build color stops
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($9081147451080c7d$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        const rgba = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a * (this.shadowOpacity() || 1) + ')';
    }
    /**
     * returns whether or not the shape will be filled
     * @method
     * @name Konva.Shape#hasFill
     * @returns {Boolean}
     */ hasFill() {
        return this._getCache($9081147451080c7d$var$HAS_FILL, this._hasFill);
    }
    _hasFill() {
        return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
    }
    /**
     * returns whether or not the shape will be stroked
     * @method
     * @name Konva.Shape#hasStroke
     * @returns {Boolean}
     */ hasStroke() {
        return this._getCache($9081147451080c7d$var$HAS_STROKE, this._hasStroke);
    }
    _hasStroke() {
        return this.strokeEnabled() && !!(this.strokeWidth() && (this.stroke() || this.strokeLinearGradientColorStops()));
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        // on auto just check by stroke
        if (width === 'auto') return this.hasStroke();
        // we should enable hit stroke if stroke is enabled
        // and we have some value from width
        return this.strokeEnabled() && !!width;
    }
    /**
     * determines if point is in the shape, regardless if other shapes are on top of it.  Note: because
     *  this method clears a temporary canvas and then redraws the shape, it performs very poorly if executed many times
     *  consecutively.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
     *  because it performs much better. A shape that is invisible, not listening or not on a stage
     *  never intersects
     * @method
     * @name Konva.Shape#intersects
     * @param {Object} point
     * @param {Number} point.x
     * @param {Number} point.y
     * @returns {Boolean}
     */ intersects(point) {
        const stage = this.getStage();
        if (!stage) return false;
        const bufferHitCanvas = stage.bufferHitCanvas;
        // lazy: allocated at stage size on first use
        bufferHitCanvas.setSizeIfChanged(stage.width(), stage.height());
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas);
        const p = bufferHitCanvas.context.getImageData(Math.floor(point.x), Math.floor(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $9081147451080c7d$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    // why do we need buffer canvas?
    // it give better result when a shape has
    // stroke with fill and with some opacity
    _useBufferCanvas(forceFill, opacity = this.getAbsoluteOpacity()) {
        // image and sprite still has "fill" as image
        // so they use that method with forced fill
        // it probably will be simpler, then copy/paste the code
        var _a;
        // force skip buffer canvas
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = !this._isUnderCache && opacity !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) this.hitStrokeWidth('auto');
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    /**
     * return self rectangle (x, y, width, height) of shape.
     * This method are not taken into account transformation and styles.
     * @method
     * @name Konva.Shape#getSelfRect
     * @returns {Object} rect with {x, y, width, height} properties
     * @example
     *
     * rect.getSelfRect();  // return {x:0, y:0, width:rect.width(), height:rect.height()}
     * circle.getSelfRect();  // return {x: - circle.width() / 2, y: - circle.height() / 2, width:circle.width(), height:circle.height()}
     *
     */ getSelfRect() {
        const selfRectFunc = this.attrs.selfRectFunc;
        if (selfRectFunc) return {
            ...selfRectFunc.call(this, this)
        };
        const size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    _getSelfRectForDrawing() {
        return this.getSelfRect();
    }
    getClientRect(config = {}) {
        const cachedRect = this._getCachedSceneRect(config);
        if (cachedRect) return cachedRect;
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        const forDrawing = config._forDrawing;
        // Painted bounds are measured in the canvas that draws the shape
        // (relativeTo): non-scaling strokes and shadows use that canvas's axes.
        let fillRect = forDrawing ? this._getSelfRectForDrawing() : this.getSelfRect();
        if (forDrawing && !this.strokeScaleEnabled()) fillRect = this._transformedRect(fillRect, relativeTo);
        else if (fillRect.width < 0 || fillRect.height < 0) // The identity transform normalizes negative sizes.
        fillRect = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)()._getTransformedRect(fillRect);
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke ? forDrawing ? this._getStrokePadding() * 2 : this.strokeWidth() : 0;
        let strokeWidthX = strokeWidth;
        let strokeWidthY = strokeWidth;
        let collapsedStroke;
        if (!forDrawing && strokeWidth && !this.strokeScaleEnabled()) {
            // Strokes are constant in the canvas they are drawn into. A cached
            // ancestor supplies that coordinate space until its bitmap is rebuilt.
            let top = this;
            while(top && !top.isCached() && !top._isUnderCache)top = top.parent;
            const [a, b, c, d] = this.getAbsoluteTransform(top).getMatrix();
            const determinant = Math.abs(a * d - b * c);
            if (determinant) {
                strokeWidthX *= Math.hypot(c, d) / determinant;
                strokeWidthY *= Math.hypot(a, b) / determinant;
            } else if (!skipTransform) {
                // A collapsed path can still draw a stroke after the context resets
                // its transform. Expand in the destination space in this case.
                strokeWidthX = strokeWidthY = 0;
                collapsedStroke = top ? top.getAbsoluteTransform().copy() : new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
                if (relativeTo) {
                    const relativeTransform = relativeTo.getAbsoluteTransform();
                    const [a, b, c, d] = relativeTransform.getMatrix();
                    // A collapsed ancestor has no inverse. Its local bounds can only
                    // describe the uncollapsed stroke; world bounds are measured directly.
                    collapsedStroke = a * d - b * c ? relativeTransform.copy().invert().multiply(collapsedStroke) : new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
                }
            }
        }
        let rect = {
            x: fillRect.x - strokeWidthX / 2,
            y: fillRect.y - strokeWidthY / 2,
            width: fillRect.width + strokeWidthX,
            height: fillRect.height + strokeWidthY
        };
        if (forDrawing && this.strokeScaleEnabled()) rect = this._transformedRect(rect, relativeTo);
        if (!config.skipShadow && this.hasShadow()) {
            const scale = forDrawing ? this.getAbsoluteScale() : {
                x: 1,
                y: 1
            };
            const dx = this.shadowOffsetX() * scale.x;
            const dy = this.shadowOffsetY() * scale.y;
            const blur = this.shadowBlur() * (forDrawing ? 2 * Math.min(Math.abs(scale.x), Math.abs(scale.y)) : 1);
            rect.x += Math.min(0, dx) - blur;
            rect.y += Math.min(0, dy) - blur;
            rect.width += Math.abs(dx) + blur * 2;
            rect.height += Math.abs(dy) + blur * 2;
        }
        if (forDrawing) return rect;
        if (!skipTransform) {
            const transformed = this._transformedRect(rect, relativeTo);
            if (collapsedStroke) {
                const [a, b, c, d] = collapsedStroke.getMatrix();
                const x = strokeWidth * Math.hypot(a, c) / 2;
                const y = strokeWidth * Math.hypot(b, d) / 2;
                transformed.x -= x;
                transformed.y -= y;
                transformed.width += x * 2;
                transformed.height += y * 2;
            }
            return transformed;
        }
        return rect;
    }
    _getStrokePadding(miterLimit = this.miterLimit() || 10) {
        // Custom paths can have sharper joins than the built-in geometry.
        if (this.attrs.sceneFunc) miterLimit = this.miterLimit() || 10;
        return Math.abs(this.strokeWidth()) / 2 * Math.max(this.lineCap() === 'square' ? Math.SQRT2 : 1, (this.lineJoin() || 'miter') === 'miter' ? miterLimit : 1);
    }
    drawScene(can, top) {
        // basically there are 3 drawing modes
        // 1 - simple drawing when nothing is cached.
        // 2 - when we are caching current
        // 3 - when node is cached and we need to draw it into layer
        const layer = this.getLayer();
        const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
        const cachingSelf = top === this;
        if (!(top ? this._isVisible(top) : this.isVisible()) && !cachingSelf) return this;
        // if node is cached we just need to draw from cache
        if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        try {
            // if buffer canvas is needed; an empty canvas has nothing to draw into
            if (canvas.width && canvas.height && this._useBufferCanvas(undefined, context._getOpacity(this))) {
                // Built-in shapes, custom shapes with a selfRectFunc and isolated
                // groups use a buffer the size of the painted bounds. Other custom
                // drawing (sceneFunc, charRenderFunc, own classes) gets the whole
                // canvas, since it can paint outside its bounds. The shadow is
                // applied when the buffer is drawn, not inside it.
                const bounded = !!context._opacityRoot || !!this.attrs.selfRectFunc && this.getSelfRect === $9081147451080c7d$export$6428a7f2611ef1fa.prototype.getSelfRect || !this.attrs.sceneFunc && !this.attrs.charRenderFunc && (0, $8c8384c27430fce8$export$207d43d7c3d095c2).has(this.constructor);
                const bc = canvas._prepareIsolationCanvas(bounded ? this.getClientRect({
                    _forDrawing: true,
                    relativeTo: top,
                    skipShadow: true
                }) : undefined);
                const bufferContext = bc.getContext();
                bufferContext.save();
                bufferContext._applyLineJoin(this);
                bufferContext._applyMiterLimit(this);
                // layer might be undefined if we are using cache before adding to layer
                const o = this.getAbsoluteTransform(top).getMatrix();
                bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                drawFunc.call(this, bufferContext, this);
                bufferContext.restore();
                if (hasShadow) context._applyShadow(this);
                // if we are caching self, we don't need to apply opacity and global composite operation
                // because it will be applied in the cache
                if (!cachingSelf) {
                    context._applyOpacity(this);
                    context._applyGlobalCompositeOperation(this);
                }
                context._drawDeviceBuffer(bc);
            } else {
                context._applyLineJoin(this);
                context._applyMiterLimit(this);
                if (!cachingSelf) {
                    const o = this.getAbsoluteTransform(top).getMatrix();
                    context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                    context._applyOpacity(this);
                    context._applyGlobalCompositeOperation(this);
                }
                if (hasShadow) context._applyShadow(this);
                drawFunc.call(this, context, this);
            }
        } catch (error) {
            // A throwing sceneFunc can leave a clip on the shared buffer.
            canvas._releaseIsolationCanvas();
            throw error;
        } finally{
            context.restore();
        }
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedHitCanvas = this._getCachedHitCanvas(top);
        if (!this.colorKey) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()');
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context, cachedHitCanvas);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        context._applyMiterLimit(this);
        const selfCache = this === top;
        if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        try {
            drawFunc.call(this, context, this);
        } finally{
            context.restore();
        }
        return this;
    }
    /**
     * draw hit graph using the cached scene canvas
     * @method
     * @name Konva.Shape#drawHitFromCache
     * @param {Integer} alphaThreshold alpha channel threshold that determines whether or not
     *  a pixel should be drawn onto the hit graph.  Must be a value between 0 and 255.
     *  The default is 0
     * @returns {Konva.Shape}
     * @example
     * shape.cache();
     * shape.drawHitFromCache();
     */ drawHitFromCache(alphaThreshold = 0) {
        const sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = this._getCachedHitCanvas(), hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
        hitContext.clear();
        // the hit context is scaled by its pixel ratio, so it draws logical units
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth / hitCanvas.pixelRatio, hitHeight / hitCanvas.pixelRatio);
        try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            // replace non transparent pixels with color key
            for(let i = 0; i < len; i += 4){
                const alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $6d58c7ba166afa5f$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $6d58c7ba166afa5f$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $6d58c7ba166afa5f$export$50f687f23c43e4d9(pointerId, this);
    }
}
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._fillFunc = $9081147451080c7d$var$_fillFunc;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._strokeFunc = $9081147451080c7d$var$_strokeFunc;
// the hit graph is filled and stroked the same way as the scene
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._fillFuncHit = $9081147451080c7d$var$_fillFunc;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $9081147451080c7d$var$_strokeFunc;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype._centroid = false;
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.nodeType = 'Shape';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($9081147451080c7d$export$6428a7f2611ef1fa);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('shadowColorChange.konva shadowBlurChange.konva shadowOffsetXChange.konva shadowOffsetYChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $9081147451080c7d$var$_clearHasShadowCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', $9081147451080c7d$var$_clearGetShadowRGBACache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('fillEnabledChange.konva fillChange.konva fillPatternImageChange.konva fillLinearGradientColorStopsChange.konva fillRadialGradientColorStopsChange.konva', $9081147451080c7d$var$_clearHasFillCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('strokeEnabledChange.konva strokeWidthChange.konva strokeChange.konva strokeLinearGradientColorStopsChange.konva', $9081147451080c7d$var$_clearHasStrokeCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva', $9081147451080c7d$var$_clearFillPatternCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', $9081147451080c7d$var$_clearLinearGradientCache);
$9081147451080c7d$export$6428a7f2611ef1fa.prototype.on('fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', $9081147451080c7d$var$_clearRadialGradientCache);
// add getters and setters
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'stroke', undefined, (0, $d7c0e5ae0fe3f9a6$export$9c72f966a828cc68)());
/**
 * get/set stroke color
 * @name Konva.Shape#stroke
 * @method
 * @param {String} color
 * @returns {String}
 * @example
 * // get stroke color
 * var stroke = shape.stroke();
 *
 * // set stroke color with color string
 * shape.stroke('green');
 *
 * // set stroke color with hex
 * shape.stroke('#00ff00');
 *
 * // set stroke color with rgb
 * shape.stroke('rgb(0,255,0)');
 *
 * // set stroke color with rgba and make it 50% opaque
 * shape.stroke('rgba(0,255,0,0.5');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeWidth', 2, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set stroke width
 * @name Konva.Shape#strokeWidth
 * @method
 * @param {Number} strokeWidth
 * @returns {Number}
 * @example
 * // get stroke width
 * var strokeWidth = shape.strokeWidth();
 *
 * // set stroke width
 * shape.strokeWidth(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillAfterStrokeEnabled', false);
/**
 * get/set fillAfterStrokeEnabled property. By default Konva is drawing filling first, then stroke on top of the fill.
 * In rare situations you may want a different behavior. When you have a stroke first then fill on top of it.
 * Especially useful for Text objects.
 * Default is false.
 * @name Konva.Shape#fillAfterStrokeEnabled
 * @method
 * @param {Boolean} fillAfterStrokeEnabled
 * @returns {Boolean}
 * @example
 * // get stroke width
 * var fillAfterStrokeEnabled = shape.fillAfterStrokeEnabled();
 *
 * // set stroke width
 * shape.fillAfterStrokeEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'hitStrokeWidth', 'auto', (0, $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404)());
/**
 * get/set stroke width for hit detection. Default value is "auto", it means it will be equals to strokeWidth
 * @name Konva.Shape#hitStrokeWidth
 * @method
 * @param {Number} hitStrokeWidth
 * @returns {Number}
 * @example
 * // get stroke width
 * var hitStrokeWidth = shape.hitStrokeWidth();
 *
 * // set hit stroke width
 * shape.hitStrokeWidth(20);
 * // set hit stroke width always equals to scene stroke width
 * shape.hitStrokeWidth('auto');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeHitEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * **deprecated, use hitStrokeWidth instead!** get/set strokeHitEnabled property. Useful for performance optimization.
 * You may set `shape.strokeHitEnabled(false)`. In this case stroke will be no draw on hit canvas, so hit area
 * of shape will be decreased (by lineWidth / 2). Remember that non closed line with `strokeHitEnabled = false`
 * will be not drawn on hit canvas, that is mean line will no trigger pointer events (like mouseover)
 * Default value is true.
 * @name Konva.Shape#strokeHitEnabled
 * @method
 * @param {Boolean} strokeHitEnabled
 * @returns {Boolean}
 * @example
 * // get strokeHitEnabled
 * var strokeHitEnabled = shape.strokeHitEnabled();
 *
 * // set strokeHitEnabled
 * shape.strokeHitEnabled();
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'perfectDrawEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * get/set perfectDrawEnabled. If a shape has fill, stroke and opacity you may set `perfectDrawEnabled` to false to improve performance.
 * See http://konvajs.org/docs/performance/Disable_Perfect_Draw.html for more information.
 * Default value is true
 * @name Konva.Shape#perfectDrawEnabled
 * @method
 * @param {Boolean} perfectDrawEnabled
 * @returns {Boolean}
 * @example
 * // get perfectDrawEnabled
 * var perfectDrawEnabled = shape.perfectDrawEnabled();
 *
 * // set perfectDrawEnabled
 * shape.perfectDrawEnabled();
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowForStrokeEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * get/set shadowForStrokeEnabled. Useful for performance optimization.
 * You may set `shape.shadowForStrokeEnabled(false)`. In this case stroke will no effect shadow.
 * Remember if you set `shadowForStrokeEnabled = false` for non closed line - that line will have no shadow!.
 * Default value is true
 * @name Konva.Shape#shadowForStrokeEnabled
 * @method
 * @param {Boolean} shadowForStrokeEnabled
 * @returns {Boolean}
 * @example
 * // get shadowForStrokeEnabled
 * var shadowForStrokeEnabled = shape.shadowForStrokeEnabled();
 *
 * // set shadowForStrokeEnabled
 * shape.shadowForStrokeEnabled();
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'lineJoin');
/**
 * get/set line join.  Can be miter, round, or bevel.  The
 *  default is miter
 * @name Konva.Shape#lineJoin
 * @method
 * @param {String} lineJoin
 * @returns {String}
 * @example
 * // get line join
 * var lineJoin = shape.lineJoin();
 *
 * // set line join
 * shape.lineJoin('round');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'lineCap');
/**
 * get/set line cap.  Can be butt, round, or square
 * @name Konva.Shape#lineCap
 * @method
 * @param {String} lineCap
 * @returns {String}
 * @example
 * // get line cap
 * var lineCap = shape.lineCap();
 *
 * // set line cap
 * shape.lineCap('round');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'miterLimit');
/**
 * get/set miterLimit.
 * @name Konva.Shape#miterLimit
 * @method
 * @param {Number} miterLimit
 * @returns {Number}
 * @example
 * // get miter limit
 * var miterLimit = shape.miterLimit();
 *
 * // set miter limit
 * shape.miterLimit(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'sceneFunc');
/**
 * get/set scene draw function. That function is used to draw the shape on a canvas.
 * Also that function will be used to draw hit area of the shape, in case if hitFunc is not defined.
 * @name Konva.Shape#sceneFunc
 * @method
 * @param {Function} drawFunc drawing function
 * @returns {Function}
 * @example
 * // get scene draw function
 * var sceneFunc = shape.sceneFunc();
 *
 * // set scene draw function
 * shape.sceneFunc(function(context, shape) {
 *   context.beginPath();
 *   context.rect(0, 0, shape.width(), shape.height());
 *   context.closePath();
 *   // important Konva method that fill and stroke shape from its properties
 *   // like stroke and fill
 *   context.fillStrokeShape(shape);
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'hitFunc');
/**
 * get/set hit draw function. That function is used to draw custom hit area of a shape.
 * @name Konva.Shape#hitFunc
 * @method
 * @param {Function} drawFunc drawing function
 * @returns {Function}
 * @example
 * // get hit draw function
 * var hitFunc = shape.hitFunc();
 *
 * // set hit draw function
 * shape.hitFunc(function(context) {
 *   context.beginPath();
 *   context.rect(0, 0, shape.width(), shape.height());
 *   context.closePath();
 *   // important Konva method that fill and stroke shape from its properties
 *   context.fillStrokeShape(shape);
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'selfRectFunc');
/**
 * get/set the function that returns the self rectangle of a custom shape: the
 * local, untransformed area its sceneFunc paints, before the stroke and shadow
 * Konva adds. Use it when drawing goes outside the width and height box, so
 * bounds, cache(), isolated groups and perfect drawing include that paint.
 * Paint outside the returned rectangle can be clipped. Meant for custom
 * shapes, and for Text drawn with charRenderFunc; built-in shapes that compute
 * their own bounds may ignore it.
 * @name Konva.Shape#selfRectFunc
 * @method
 * @param {Function} selfRectFunc function returning {x, y, width, height}
 * @returns {Function}
 * @example
 * shape.selfRectFunc(() => ({ x: -10, y: -10, width: 120, height: 120 }));
 * // back to the automatic width and height box
 * shape.selfRectFunc(undefined);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'dash');
/**
 * get/set dash array for stroke.
 * @name Konva.Shape#dash
 * @method
 * @param {Array} dash
 * @returns {Array}
 * @example
 *  // apply dashed stroke that is 10px long and 5 pixels apart
 *  line.dash([10, 5]);
 *  // apply dashed stroke that is made up of alternating dashed
 *  // lines that are 10px long and 20px apart, and dots that have
 *  // a radius of 5px and are 20px apart
 *  line.dash([10, 20, 0.001, 20]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'dashOffset', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set dash offset for stroke.
 * @name Konva.Shape#dash
 * @method
 * @param {Number} dash offset
 * @returns {Number}
 * @example
 *  // apply dashed stroke that is 10px long and 5 pixels apart with an offset of 5px
 *  line.dash([10, 5]);
 *  line.dashOffset(5);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowColor', undefined, (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set shadow color
 * @name Konva.Shape#shadowColor
 * @method
 * @param {String} color
 * @returns {String}
 * @example
 * // get shadow color
 * var shadow = shape.shadowColor();
 *
 * // set shadow color with color string
 * shape.shadowColor('green');
 *
 * // set shadow color with hex
 * shape.shadowColor('#00ff00');
 *
 * // set shadow color with rgb
 * shape.shadowColor('rgb(0,255,0)');
 *
 * // set shadow color with rgba and make it 50% opaque
 * shape.shadowColor('rgba(0,255,0,0.5');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowBlur', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set shadow blur
 * @name Konva.Shape#shadowBlur
 * @method
 * @param {Number} blur
 * @returns {Number}
 * @example
 * // get shadow blur
 * var shadowBlur = shape.shadowBlur();
 *
 * // set shadow blur
 * shape.shadowBlur(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOpacity', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set shadow opacity.  must be a value between 0 and 1
 * @name Konva.Shape#shadowOpacity
 * @method
 * @param {Number} opacity
 * @returns {Number}
 * @example
 * // get shadow opacity
 * var shadowOpacity = shape.shadowOpacity();
 *
 * // set shadow opacity
 * shape.shadowOpacity(0.5);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOffset', [
    'x',
    'y'
]);
/**
 * get/set shadow offset
 * @name Konva.Shape#shadowOffset
 * @method
 * @param {Object} offset
 * @param {Number} offset.x
 * @param {Number} offset.y
 * @returns {Object}
 * @example
 * // get shadow offset
 * var shadowOffset = shape.shadowOffset();
 *
 * // set shadow offset
 * shape.shadowOffset({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOffsetX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set shadow offset x
 * @name Konva.Shape#shadowOffsetX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get shadow offset x
 * var shadowOffsetX = shape.shadowOffsetX();
 *
 * // set shadow offset x
 * shape.shadowOffsetX(5);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowOffsetY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set shadow offset y
 * @name Konva.Shape#shadowOffsetY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get shadow offset y
 * var shadowOffsetY = shape.shadowOffsetY();
 *
 * // set shadow offset y
 * shape.shadowOffsetY(5);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternImage');
/**
 * get/set fill pattern image
 * @name Konva.Shape#fillPatternImage
 * @method
 * @param {Image} image object
 * @returns {Image}
 * @example
 * // get fill pattern image
 * var fillPatternImage = shape.fillPatternImage();
 *
 * // set fill pattern image
 * var imageObj = new Image();
 * imageObj.onload = function() {
 *   shape.fillPatternImage(imageObj);
 * };
 * imageObj.src = 'path/to/image/jpg';
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fill', undefined, (0, $d7c0e5ae0fe3f9a6$export$9c72f966a828cc68)());
/**
 * get/set fill color
 * @name Konva.Shape#fill
 * @method
 * @param {String} color
 * @returns {String}
 * @example
 * // get fill color
 * var fill = shape.fill();
 *
 * // set fill color with color string
 * shape.fill('green');
 *
 * // set fill color with hex
 * shape.fill('#00ff00');
 *
 * // set fill color with rgb
 * shape.fill('rgb(0,255,0)');
 *
 * // set fill color with rgba and make it 50% opaque
 * shape.fill('rgba(0,255,0,0.5');
 *
 * // shape without fill
 * shape.fill(null);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set fill pattern x
 * @name Konva.Shape#fillPatternX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill pattern x
 * var fillPatternX = shape.fillPatternX();
 * // set fill pattern x
 * shape.fillPatternX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set fill pattern y
 * @name Konva.Shape#fillPatternY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill pattern y
 * var fillPatternY = shape.fillPatternY();
 * // set fill pattern y
 * shape.fillPatternY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientColorStops');
/**
 * get/set fill linear gradient color stops
 * @name Konva.Shape#fillLinearGradientColorStops
 * @method
 * @param {Array} colorStops
 * @returns {Array} colorStops
 * @example
 * // get fill linear gradient color stops
 * var colorStops = shape.fillLinearGradientColorStops();
 *
 * // create a linear gradient that starts with red, changes to blue
 * // halfway through, and then changes to green
 * shape.fillLinearGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientColorStops');
/**
 * get/set stroke linear gradient color stops
 * @name Konva.Shape#strokeLinearGradientColorStops
 * @method
 * @param {Array} colorStops
 * @returns {Array} colorStops
 * @example
 * // get stroke linear gradient color stops
 * var colorStops = shape.strokeLinearGradientColorStops();
 *
 * // create a linear gradient that starts with red, changes to blue
 * // halfway through, and then changes to green
 * shape.strokeLinearGradientColorStops([0, 'red', 0.5, 'blue', 1, 'green']);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartRadius', 0);
/**
 * get/set fill radial gradient start radius
 * @name Konva.Shape#fillRadialGradientStartRadius
 * @method
 * @param {Number} radius
 * @returns {Number}
 * @example
 * // get radial gradient start radius
 * var startRadius = shape.fillRadialGradientStartRadius();
 *
 * // set radial gradient start radius
 * shape.fillRadialGradientStartRadius(0);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndRadius', 0);
/**
 * get/set fill radial gradient end radius
 * @name Konva.Shape#fillRadialGradientEndRadius
 * @method
 * @param {Number} radius
 * @returns {Number}
 * @example
 * // get radial gradient end radius
 * var endRadius = shape.fillRadialGradientEndRadius();
 *
 * // set radial gradient end radius
 * shape.fillRadialGradientEndRadius(100);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientColorStops');
/**
 * get/set fill radial gradient color stops
 * @name Konva.Shape#fillRadialGradientColorStops
 * @method
 * @param {Number} colorStops
 * @returns {Array}
 * @example
 * // get fill radial gradient color stops
 * var colorStops = shape.fillRadialGradientColorStops();
 *
 * // create a radial gradient that starts with red, changes to blue
 * // halfway through, and then changes to green
 * shape.fillRadialGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternRepeat', 'repeat');
/**
 * get/set fill pattern repeat.  Can be 'repeat', 'repeat-x', 'repeat-y', or 'no-repeat'.  The default is 'repeat'
 * @name Konva.Shape#fillPatternRepeat
 * @method
 * @param {String} repeat
 * @returns {String}
 * @example
 * // get fill pattern repeat
 * var repeat = shape.fillPatternRepeat();
 *
 * // repeat pattern in x direction only
 * shape.fillPatternRepeat('repeat-x');
 *
 * // do not repeat the pattern
 * shape.fillPatternRepeat('no-repeat');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillEnabled', true);
/**
 * get/set fill enabled flag
 * @name Konva.Shape#fillEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get fill enabled flag
 * var fillEnabled = shape.fillEnabled();
 *
 * // disable fill
 * shape.fillEnabled(false);
 *
 * // enable fill
 * shape.fillEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeEnabled', true);
/**
 * get/set stroke enabled flag
 * @name Konva.Shape#strokeEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get stroke enabled flag
 * var strokeEnabled = shape.strokeEnabled();
 *
 * // disable stroke
 * shape.strokeEnabled(false);
 *
 * // enable stroke
 * shape.strokeEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'shadowEnabled', true);
/**
 * get/set shadow enabled flag
 * @name Konva.Shape#shadowEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get shadow enabled flag
 * var shadowEnabled = shape.shadowEnabled();
 *
 * // disable shadow
 * shape.shadowEnabled(false);
 *
 * // enable shadow
 * shape.shadowEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'dashEnabled', true);
/**
 * get/set dash enabled flag
 * @name Konva.Shape#dashEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get dash enabled flag
 * var dashEnabled = shape.dashEnabled();
 *
 * // disable dash
 * shape.dashEnabled(false);
 *
 * // enable dash
 * shape.dashEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeScaleEnabled', true);
/**
 * get/set strokeScale enabled flag. Text and TextPath always scale their stroke.
 * @name Konva.Shape#strokeScaleEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get stroke scale enabled flag
 * var strokeScaleEnabled = shape.strokeScaleEnabled();
 *
 * // disable stroke scale
 * shape.strokeScaleEnabled(false);
 *
 * // enable stroke scale
 * shape.strokeScaleEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPriority', 'color');
/**
 * get/set fill priority.  can be color, pattern, linear-gradient, or radial-gradient.  The default is color.
 *   This is handy if you want to toggle between different fill types.
 * @name Konva.Shape#fillPriority
 * @method
 * @param {String} priority
 * @returns {String}
 * @example
 * // get fill priority
 * var fillPriority = shape.fillPriority();
 *
 * // set fill priority
 * shape.fillPriority('linear-gradient');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternOffset', [
    'x',
    'y'
]);
/**
 * get/set fill pattern offset
 * @name Konva.Shape#fillPatternOffset
 * @method
 * @param {Object} offset
 * @param {Number} offset.x
 * @param {Number} offset.y
 * @returns {Object}
 * @example
 * // get fill pattern offset
 * var patternOffset = shape.fillPatternOffset();
 *
 * // set fill pattern offset
 * shape.fillPatternOffset({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternOffsetX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set fill pattern offset x
 * @name Konva.Shape#fillPatternOffsetX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill pattern offset x
 * var patternOffsetX = shape.fillPatternOffsetX();
 *
 * // set fill pattern offset x
 * shape.fillPatternOffsetX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternOffsetY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set fill pattern offset y
 * @name Konva.Shape#fillPatternOffsetY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill pattern offset y
 * var patternOffsetY = shape.fillPatternOffsetY();
 *
 * // set fill pattern offset y
 * shape.fillPatternOffsetY(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternScale', [
    'x',
    'y'
]);
/**
 * get/set fill pattern scale
 * @name Konva.Shape#fillPatternScale
 * @method
 * @param {Object} scale
 * @param {Number} scale.x
 * @param {Number} scale.y
 * @returns {Object}
 * @example
 * // get fill pattern scale
 * var patternScale = shape.fillPatternScale();
 *
 * // set fill pattern scale
 * shape.fillPatternScale({
 *   x: 2,
 *   y: 2
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternScaleX', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set fill pattern scale x
 * @name Konva.Shape#fillPatternScaleX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill pattern scale x
 * var patternScaleX = shape.fillPatternScaleX();
 *
 * // set fill pattern scale x
 * shape.fillPatternScaleX(2);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternScaleY', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set fill pattern scale y
 * @name Konva.Shape#fillPatternScaleY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill pattern scale y
 * var patternScaleY = shape.fillPatternScaleY();
 *
 * // set fill pattern scale y
 * shape.fillPatternScaleY(2);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientStartPoint', [
    'x',
    'y'
]);
/**
 * get/set fill linear gradient start point
 * @name Konva.Shape#fillLinearGradientStartPoint
 * @method
 * @param {Object} startPoint
 * @param {Number} startPoint.x
 * @param {Number} startPoint.y
 * @returns {Object}
 * @example
 * // get fill linear gradient start point
 * var startPoint = shape.fillLinearGradientStartPoint();
 *
 * // set fill linear gradient start point
 * shape.fillLinearGradientStartPoint({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPoint', [
    'x',
    'y'
]);
/**
 * get/set stroke linear gradient start point
 * @name Konva.Shape#strokeLinearGradientStartPoint
 * @method
 * @param {Object} startPoint
 * @param {Number} startPoint.x
 * @param {Number} startPoint.y
 * @returns {Object}
 * @example
 * // get stroke linear gradient start point
 * var startPoint = shape.strokeLinearGradientStartPoint();
 *
 * // set stroke linear gradient start point
 * shape.strokeLinearGradientStartPoint({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointX', 0);
/**
 * get/set fill linear gradient start point x
 * @name Konva.Shape#fillLinearGradientStartPointX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill linear gradient start point x
 * var startPointX = shape.fillLinearGradientStartPointX();
 *
 * // set fill linear gradient start point x
 * shape.fillLinearGradientStartPointX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointX', 0);
/**
 * get/set stroke linear gradient start point x
 * @name Konva.Shape#strokeLinearGradientStartPointX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get stroke linear gradient start point x
 * var startPointX = shape.strokeLinearGradientStartPointX();
 *
 * // set stroke linear gradient start point x
 * shape.strokeLinearGradientStartPointX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientStartPointY', 0);
/**
 * get/set fill linear gradient start point y
 * @name Konva.Shape#fillLinearGradientStartPointY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill linear gradient start point y
 * var startPointY = shape.fillLinearGradientStartPointY();
 *
 * // set fill linear gradient start point y
 * shape.fillLinearGradientStartPointY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientStartPointY', 0);
/**
 * get/set stroke linear gradient start point y
 * @name Konva.Shape#strokeLinearGradientStartPointY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get stroke linear gradient start point y
 * var startPointY = shape.strokeLinearGradientStartPointY();
 *
 * // set stroke linear gradient start point y
 * shape.strokeLinearGradientStartPointY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientEndPoint', [
    'x',
    'y'
]);
/**
 * get/set fill linear gradient end point
 * @name Konva.Shape#fillLinearGradientEndPoint
 * @method
 * @param {Object} endPoint
 * @param {Number} endPoint.x
 * @param {Number} endPoint.y
 * @returns {Object}
 * @example
 * // get fill linear gradient end point
 * var endPoint = shape.fillLinearGradientEndPoint();
 *
 * // set fill linear gradient end point
 * shape.fillLinearGradientEndPoint({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPoint', [
    'x',
    'y'
]);
/**
 * get/set stroke linear gradient end point
 * @name Konva.Shape#strokeLinearGradientEndPoint
 * @method
 * @param {Object} endPoint
 * @param {Number} endPoint.x
 * @param {Number} endPoint.y
 * @returns {Object}
 * @example
 * // get stroke linear gradient end point
 * var endPoint = shape.strokeLinearGradientEndPoint();
 *
 * // set stroke linear gradient end point
 * shape.strokeLinearGradientEndPoint({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointX', 0);
/**
 * get/set fill linear gradient end point x
 * @name Konva.Shape#fillLinearGradientEndPointX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill linear gradient end point x
 * var endPointX = shape.fillLinearGradientEndPointX();
 *
 * // set fill linear gradient end point x
 * shape.fillLinearGradientEndPointX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointX', 0);
/**
 * get/set fill linear gradient end point x
 * @name Konva.Shape#strokeLinearGradientEndPointX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get stroke linear gradient end point x
 * var endPointX = shape.strokeLinearGradientEndPointX();
 *
 * // set stroke linear gradient end point x
 * shape.strokeLinearGradientEndPointX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillLinearGradientEndPointY', 0);
/**
 * get/set fill linear gradient end point y
 * @name Konva.Shape#fillLinearGradientEndPointY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill linear gradient end point y
 * var endPointY = shape.fillLinearGradientEndPointY();
 *
 * // set fill linear gradient end point y
 * shape.fillLinearGradientEndPointY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'strokeLinearGradientEndPointY', 0);
/**
 * get/set stroke linear gradient end point y
 * @name Konva.Shape#strokeLinearGradientEndPointY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get stroke linear gradient end point y
 * var endPointY = shape.strokeLinearGradientEndPointY();
 *
 * // set stroke linear gradient end point y
 * shape.strokeLinearGradientEndPointY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartPoint', [
    'x',
    'y'
]);
/**
 * get/set fill radial gradient start point
 * @name Konva.Shape#fillRadialGradientStartPoint
 * @method
 * @param {Object} startPoint
 * @param {Number} startPoint.x
 * @param {Number} startPoint.y
 * @returns {Object}
 * @example
 * // get fill radial gradient start point
 * var startPoint = shape.fillRadialGradientStartPoint();
 *
 * // set fill radial gradient start point
 * shape.fillRadialGradientStartPoint({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointX', 0);
/**
 * get/set fill radial gradient start point x
 * @name Konva.Shape#fillRadialGradientStartPointX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill radial gradient start point x
 * var startPointX = shape.fillRadialGradientStartPointX();
 *
 * // set fill radial gradient start point x
 * shape.fillRadialGradientStartPointX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientStartPointY', 0);
/**
 * get/set fill radial gradient start point y
 * @name Konva.Shape#fillRadialGradientStartPointY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill radial gradient start point y
 * var startPointY = shape.fillRadialGradientStartPointY();
 *
 * // set fill radial gradient start point y
 * shape.fillRadialGradientStartPointY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndPoint', [
    'x',
    'y'
]);
/**
 * get/set fill radial gradient end point
 * @name Konva.Shape#fillRadialGradientEndPoint
 * @method
 * @param {Object} endPoint
 * @param {Number} endPoint.x
 * @param {Number} endPoint.y
 * @returns {Object}
 * @example
 * // get fill radial gradient end point
 * var endPoint = shape.fillRadialGradientEndPoint();
 *
 * // set fill radial gradient end point
 * shape.fillRadialGradientEndPoint({
 *   x: 20,
 *   y: 10
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointX', 0);
/**
 * get/set fill radial gradient end point x
 * @name Konva.Shape#fillRadialGradientEndPointX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get fill radial gradient end point x
 * var endPointX = shape.fillRadialGradientEndPointX();
 *
 * // set fill radial gradient end point x
 * shape.fillRadialGradientEndPointX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRadialGradientEndPointY', 0);
/**
 * get/set fill radial gradient end point y
 * @name Konva.Shape#fillRadialGradientEndPointY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get fill radial gradient end point y
 * var endPointY = shape.fillRadialGradientEndPointY();
 *
 * // set fill radial gradient end point y
 * shape.fillRadialGradientEndPointY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillPatternRotation', 0);
/**
 * get/set fill pattern rotation in degrees
 * @name Konva.Shape#fillPatternRotation
 * @method
 * @param {Number} rotation
 * @returns {Konva.Shape}
 * @example
 * // get fill pattern rotation
 * var patternRotation = shape.fillPatternRotation();
 *
 * // set fill pattern rotation
 * shape.fillPatternRotation(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($9081147451080c7d$export$6428a7f2611ef1fa, 'fillRule', undefined, (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set fill rule
 * @name Konva.Shape#fillRule
 * @method
 * @param {CanvasFillRule} rotation
 * @returns {Konva.Shape}
 * @example
 * // get fill rule
 * var fillRule = shape.fillRule();
 *
 * // set fill rule
 * shape.fillRule('evenodd');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($9081147451080c7d$export$6428a7f2611ef1fa, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'setDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc'
});




// constants
const $1ff13b72400727ee$var$BEFORE_DRAW = 'beforeDraw', $1ff13b72400727ee$var$DRAW = 'draw', // getIntersection() reads the hit canvas around an edge pixel in blocks
// of this radius, doubling it as long as the search goes on
$1ff13b72400727ee$var$HIT_SEARCH_RADIUS = 10, $1ff13b72400727ee$var$HIT_SEARCH_MAX_DISTANCE = 256;
// the shape drawn at a pixel of the hit graph: an opaque pixel, or an edge
// pixel that the shape covers by at least half, so that its colour read back
// premultiplied still rounds to the key of the shape (see getHitColorKey)
function $1ff13b72400727ee$var$getHitShape(data, i) {
    return data[i + 3] >= 128 ? (0, $9081147451080c7d$export$4ff7fc6f1af248b5)[(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).getHitColorKey(data[i], data[i + 1], data[i + 2])] : undefined;
}
class $1ff13b72400727ee$export$936d0764594b6eb3 extends (0, $f02a8e3513953b09$export$42a852a2b6b56249) {
    constructor(config){
        super(config);
        this.canvas = new (0, $94cf583ff38878f8$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $94cf583ff38878f8$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on('visibleChange.konva', this._checkVisibility);
        this._checkVisibility();
        this.on('imageSmoothingEnabledChange.konva', this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    // for nodejs?
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    /**
     * get layer canvas wrapper
     * @method
     * @name Konva.Layer#getCanvas
     */ getCanvas() {
        return this.canvas;
    }
    /**
     * get native canvas element
     * @method
     * @name Konva.Layer#getNativeCanvasElement
     */ getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    /**
     * get layer hit canvas
     * @method
     * @name Konva.Layer#getHitCanvas
     */ getHitCanvas() {
        return this.hitCanvas;
    }
    /**
     * get layer canvas context
     * @method
     * @name Konva.Layer#getContext
     */ getContext() {
        return this.getCanvas().getContext();
    }
    /**
     * clear the scene and hit canvas of the layer. The nodes stay and are
     * drawn again by the next `draw()`
     * @method
     * @name Konva.Layer#clear
     * @param {Object} [bounds] clear only this rectangle: `{ x, y, width, height }`
     * @returns {Konva.Layer}
     * @example
     * layer.clear();
     * layer.clear({ x: 0, y: 0, width: 100, height: 100 });
     */ clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    // extend Node.prototype.setZIndex
    setZIndex(index) {
        super.setZIndex(index);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        const moved = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        const stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    // extend Node.prototype.moveDown
    moveDown() {
        if ((0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    // extend Node.prototype.moveToBottom
    moveToBottom() {
        if ((0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        var _a, _b;
        super.remove();
        // both canvases live in stage.content: the scene one always, the hit one
        // while toggleHitCanvas() shows it
        const scene = this.getNativeCanvasElement();
        const hit = this.getHitCanvas()._canvas;
        (_a = scene.parentNode) === null || _a === void 0 || _a.removeChild(scene);
        (_b = hit.parentNode) === null || _b === void 0 || _b.removeChild(hit);
        return this;
    }
    getStage() {
        return this.parent;
    }
    // the canvases follow the stage size. The public size() of a layer, like
    // width() and height(), warns and does nothing
    _setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this._syncHitCanvasSize();
        this._setSmoothEnabled();
        return this;
    }
    // the hit canvas is only allocated while the layer is listening;
    // for a non-listening layer it is kept released (0x0), so a purely
    // presentational layer does not pay for a stage-sized hit bitmap
    // https://github.com/konvajs/konva/issues/2009
    _syncHitCanvasSize() {
        const listening = this.isListening();
        this.hitCanvas.setSizeIfChanged((listening ? this.getWidth() : 0) || 0, (listening ? this.getHeight() : 0) || 0);
    }
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to a layer.');
    }
    _toKonvaCanvas(config) {
        config = {
            ...config
        };
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = 'block';
        else this.canvas._canvas.style.display = 'none';
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    /**
     * get/set width of layer. getter return width of stage. setter doing nothing.
     * if you want change width use `stage.width(value);`
     * @name Konva.Layer#width
     * @method
     * @returns {Number}
     * @example
     * var width = layer.width();
     */ getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    /**
     * get/set height of layer.getter return height of stage. setter doing nothing.
     * if you want change height use `stage.height(value);`
     * @name Konva.Layer#height
     * @method
     * @returns {Number}
     * @example
     * var height = layer.height();
     */ getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    /**
     * batch draw. this function will not do immediate draw
     * but it will schedule drawing to next tick (requestAnimFrame)
     * @method
     * @name Konva.Layer#batchDraw
     * @return {Konva.Layer} this
     */ batchDraw() {
        var _a;
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            // ask the window the stage is rendered in for the frame: a stage in a
            // popout window keeps drawing while the opener window is not visible
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                // reset before drawing, so a throwing draw does not freeze the layer
                // and a draw handler can request the next frame
                this._waitingForDraw = false;
                this.draw();
            }, (_a = this.getStage()) === null || _a === void 0 ? void 0 : _a._getOwnerWindow());
        }
        return this;
    }
    /**
     * get visible intersection shape. This is the preferred
     * method for determining if a point intersects a shape or not.
     * It reads the hit canvas, so it finds what pointer events would: nodes with
     * listening set to false or invisible nodes are not detected, a shape with opacity 0
     * is, and `hitStrokeWidth` counts. The position is relative to the top left corner of the
     * stage container, like `stage.getPointerPosition()`, without the stage transform
     * @method
     * @name Konva.Layer#getIntersection
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Konva.Node}
     * @example
     * var shape = layer.getIntersection({x: 50, y: 50});
     */ getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        const hit = this._getIntersection(pos);
        if (hit.shape) return hit.shape;
        if (!hit.antialiased) return null;
        // the pointer is on the outer part of an edge, or on an opaque pixel with
        // the colours of two shapes mixed. Walk outward ring by ring to the
        // nearest pixel that resolves to a shape. The smoothed edge of a cached
        // node that is scaled up can be many pixels wide, so keep going while the
        // alpha still rises (the ramp leads into the shape) or the ring holds
        // mixed pixels. A thin line has a flat alpha, so the search stops at once
        // instead of walking along it to an unrelated shape nearby
        const ratio = this.hitCanvas.pixelRatio, cx = Math.floor(pos.x * ratio), cy = Math.floor(pos.y * ratio);
        const read = (r)=>this.hitCanvas.context.getImageData(cx - r, cy - r, r * 2 + 1, r * 2 + 1).data;
        let r = $1ff13b72400727ee$var$HIT_SEARCH_RADIUS, size = r * 2 + 1, data = read(r), previousMax = data[(r * size + r) * 4 + 3];
        for(let d = 1; d <= $1ff13b72400727ee$var$HIT_SEARCH_MAX_DISTANCE; d++){
            if (d > r) {
                r = Math.min($1ff13b72400727ee$var$HIT_SEARCH_MAX_DISTANCE, r * 2);
                size = r * 2 + 1;
                data = read(r);
            }
            let max = 0;
            for(let y = -d; y <= d; y++){
                // whole top and bottom rows, only the two side pixels of the others
                const step = Math.abs(y) === d ? 1 : d * 2;
                for(let x = -d; x <= d; x += step){
                    const i = ((y + r) * size + x + r) * 4;
                    const shape = $1ff13b72400727ee$var$getHitShape(data, i);
                    if (shape) return shape;
                    max = Math.max(max, data[i + 3]);
                }
            }
            // 255 here is a mixed pixel, as an opaque one resolved above
            if (max <= previousMax && max !== 255) return null;
            previousMax = max;
        }
        return null;
    }
    _getIntersection(pos) {
        // a non-listening layer keeps its hit canvas released (0x0),
        // and a just-enabled layer may not have drawn its hit graph yet
        if (!this.hitCanvas.width || !this.hitCanvas.height) return {};
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.floor(pos.x * ratio), Math.floor(pos.y * ratio), 1, 1).data;
        const shape = $1ff13b72400727ee$var$getHitShape(p, 0);
        if (shape) return {
            shape: shape
        };
        if (p[3] > 0) // an edge pixel, or an opaque one with the colours of two shapes mixed
        return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($1ff13b72400727ee$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $f02a8e3513953b09$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top);
        canvas._trimIsolationCanvas();
        this._fire($1ff13b72400727ee$var$DRAW, {
            node: this
        });
        return this;
    }
    // the hit graph is skipped while a node of the layer (or the stage) is
    // dragged or a transformer on the layer, or of a node on it, is
    // transforming, as the layer is redrawn every frame; the draw that follows
    // restores it
    shouldDrawHit(top) {
        var _a;
        if (!super.shouldDrawHit(top)) return false;
        if (top || (0, $8c8384c27430fce8$export$b9f99057a3c7692).hitOnDragEnabled) return true;
        let underDrag = false;
        (0, $fa6dae8e3add958f$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus === 'dragging' && (elem.node === this.getStage() || elem.node.getLayer() === this)) underDrag = true;
        });
        return !underDrag && !((_a = (0, $8c8384c27430fce8$export$b9f99057a3c7692)['Transformer']) === null || _a === void 0 ? void 0 : _a._isLayerTransforming(this));
    }
    drawHit(can, top) {
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (!can && layer) {
            // allocate or release the hit canvas to match the current listening
            // state - this also picks up a listening change made after the last draw
            layer._syncHitCanvasSize();
            if (layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        }
        (0, $f02a8e3513953b09$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    /**
     * enable hit graph. **DEPRECATED!** Use `layer.listening(true)` instead.
     * @name Konva.Layer#enableHitGraph
     * @method
     * @returns {Layer}
     */ enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    /**
     * disable hit graph. **DEPRECATED!** Use `layer.listening(false)` instead.
     * @name Konva.Layer#disableHitGraph
     * @method
     * @returns {Layer}
     */ disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    }
    /**
     * Show or hide hit canvas over the stage. May be useful for debugging custom hitFunc
     * @name Konva.Layer#toggleHitCanvas
     * @method
     */ toggleHitCanvas() {
        if (!this.parent || !this.parent['content']) return;
        const parent = this.parent;
        const added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        this.getCanvas()._releaseIsolationCanvas();
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$1ff13b72400727ee$export$936d0764594b6eb3.prototype.nodeType = 'Layer';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($1ff13b72400727ee$export$936d0764594b6eb3);
/**
 * get/set imageSmoothingEnabled flag
 * For more info see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/imageSmoothingEnabled
 * @name Konva.Layer#imageSmoothingEnabled
 * @method
 * @param {Boolean} imageSmoothingEnabled
 * @returns {Boolean}
 * @example
 * // get imageSmoothingEnabled flag
 * var imageSmoothingEnabled = layer.imageSmoothingEnabled();
 *
 * layer.imageSmoothingEnabled(false);
 *
 * layer.imageSmoothingEnabled(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($1ff13b72400727ee$export$936d0764594b6eb3, 'imageSmoothingEnabled', true);
/**
 * get/set clearBeforeDraw flag which determines if the layer is cleared or not
 *  before drawing
 * @name Konva.Layer#clearBeforeDraw
 * @method
 * @param {Boolean} clearBeforeDraw
 * @returns {Boolean}
 * @example
 * // get clearBeforeDraw flag
 * var clearBeforeDraw = layer.clearBeforeDraw();
 *
 * // disable clear before draw
 * layer.clearBeforeDraw(false);
 *
 * // enable clear before draw
 * layer.clearBeforeDraw(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($1ff13b72400727ee$export$936d0764594b6eb3, 'clearBeforeDraw', true);
// the getter and setter are the deprecated ones above
(0, $abe0ad8331aee635$export$8354032f3852ec50).addOverloadedGetterSetter($1ff13b72400727ee$export$936d0764594b6eb3, 'hitGraphEnabled'); /**
 * get/set hitGraphEnabled flag.  **DEPRECATED!** Use `layer.listening(false)` instead.
 *  Disabling the hit graph will greatly increase
 *  draw performance because the hit graph will not be redrawn each time the layer is
 *  drawn.  This, however, also disables mouse/touch event detection
 * @name Konva.Layer#hitGraphEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get hitGraphEnabled flag
 * var hitGraphEnabled = layer.hitGraphEnabled();
 *
 * // disable hit graph
 * layer.hitGraphEnabled(false);
 *
 * // enable hit graph
 * layer.hitGraphEnabled(true);
 */ 





class $42d998124386a05c$export$92d64f29192d1118 extends (0, $1ff13b72400727ee$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Konva.FastLayer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$42d998124386a05c$export$92d64f29192d1118.prototype.nodeType = 'FastLayer';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($42d998124386a05c$export$92d64f29192d1118);







class $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4 extends (0, $f02a8e3513953b09$export$42a852a2b6b56249) {
    _validateAdd(child) {
        const type = child.getType();
        if (type !== 'Group' && type !== 'Shape') (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('You may only add groups and shapes to groups.');
    }
    _drawChildNodes(drawMethod, canvas, top) {
        // cache() already provides an isolated surface and owns its snapshot.
        if (drawMethod !== 'drawScene' || !this.isolated() || top === this) return super._drawChildNodes(drawMethod, canvas, top);
        if (!canvas.width || !canvas.height) return;
        const context = canvas.getContext();
        const surface = canvas._prepareIsolationCanvas(this.getClientRect({
            _forDrawing: true,
            relativeTo: top
        }));
        const surfaceContext = surface.getContext();
        surfaceContext._opacityRoot = this;
        context.save();
        try {
            super._drawChildNodes(drawMethod, surface, top);
            context._applyOpacity(this);
            context._drawDeviceBuffer(surface);
        } catch (error) {
            // A throwing sceneFunc can leave unbalanced saves or a clip on the
            // scratch context. Discard it rather than contaminate the next draw.
            canvas._releaseIsolationCanvas();
            throw error;
        } finally{
            context.restore();
            surfaceContext._opacityRoot = undefined;
        }
    }
}
/**
 * Get or set group isolation. Default is false.
 * An isolated group draws its children into a transparent canvas on each scene draw.
 * The group opacity and globalCompositeOperation apply once to the completed image.
 * Child blend modes and erasing affect only the content inside that canvas.
 *
 * Explicit cache() calls keep their snapshot behavior. clearCache() resumes live drawing.
 * Hit testing keeps its normal behavior, including hits on erased content.
 * For video or canvas sources, schedule draws when the source changes.
 *
 * Buffers use conservative content bounds at the destination pixel ratio.
 * Moving the buffer origin changes native edge coverage. A few edge pixels
 * can differ substantially; isolation does not promise pixel-identical antialiasing.
 * Like cache(), isolation requires custom drawing (sceneFunc, charRenderFunc) to provide accurate
 * bounds, including any pixels it paints outside its size: selfRectFunc or a
 * getSelfRect() override.
 * Text is bounded by its lines plus one font size, so a glyph with many stacked
 * marks can be clipped. node-canvas shadows can change with bitmap origin.
 * Siblings reuse a buffer; unused or oversized buffers are freed after each layer draw.
 * @name Konva.Group#isolated
 * @method
 * @param {Boolean} isolated
 * @returns {Boolean}
 * @example
 * const group = new Konva.Group({ isolated: true, opacity: 0.5 });
 * group.add(shape1, shape2);
 * group.isolated(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4, 'isolated', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
$644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4.prototype.nodeType = 'Group';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4);







var $e780181a0ef0b2c4$var$_a;
const $e780181a0ef0b2c4$var$now = (($e780181a0ef0b2c4$var$_a = (0, $8c8384c27430fce8$export$442f1a04865e4790).performance) === null || $e780181a0ef0b2c4$var$_a === void 0 ? void 0 : $e780181a0ef0b2c4$var$_a.now) ? ()=>(0, $8c8384c27430fce8$export$442f1a04865e4790).performance.now() : Date.now;
class $e780181a0ef0b2c4$export$c35d437ae5945fcd {
    constructor(func, layers){
        this.id = $e780181a0ef0b2c4$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $e780181a0ef0b2c4$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    /**
     * set layers to be redrawn on each animation frame
     * @method
     * @name Konva.Animation#setLayers
     * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn. Can be a layer, an array of layers, or null.  Not specifying a node will result in no redraw.
     * @return {Konva.Animation} this
     */ setLayers(layers) {
        // a copy, so that addLayer() never pushes into the caller's array
        this.layers = layers ? [].concat(layers) : [];
        return this;
    }
    /**
     * get layers
     * @method
     * @name Konva.Animation#getLayers
     * @return {Array} Array of Konva.Layer
     */ getLayers() {
        return this.layers;
    }
    /**
     * add layer.  Returns true if the layer was added, and false if it was not
     * @method
     * @name Konva.Animation#addLayer
     * @param {Konva.Layer} layer to add
     * @return {Bool} true if layer is added to animation, otherwise false
     */ addLayer(layer) {
        const layers = this.layers;
        const len = layers.length;
        // don't add the layer if it already exists
        for(let n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    /**
     * determine if animation is running or not.  returns true or false
     * @method
     * @name Konva.Animation#isRunning
     * @return {Bool} is animation running?
     */ isRunning() {
        return $e780181a0ef0b2c4$export$c35d437ae5945fcd.animations.has(this);
    }
    /**
     * start animation
     * @method
     * @name Konva.Animation#start
     * @return {Konva.Animation} this
     */ start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $e780181a0ef0b2c4$var$now();
        $e780181a0ef0b2c4$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    /**
     * stop animation
     * @method
     * @name Konva.Animation#stop
     * @return {Konva.Animation} this
     */ stop() {
        $e780181a0ef0b2c4$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.add(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        this.animations.delete(anim);
    }
    static _runFrames() {
        // every layer is drawn once, however many animations touch it
        const layersToDraw = new Set();
        // an animation may stop or restart itself, or another one, inside its
        // function: each one runs at most once per frame, a stopped one not at all
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4)._updateBatch(()=>{
            Array.from(this.animations).forEach((anim)=>{
                if (!this.animations.has(anim)) return;
                anim._updateFrameObject($e780181a0ef0b2c4$var$now());
                // the function returns false to skip the redraw
                if (anim.func && anim.func.call(anim, anim.frame) === false) return;
                anim.layers.forEach((layer)=>layer && layersToDraw.add(layer));
            });
        });
        layersToDraw.forEach((layer)=>layer.batchDraw());
    }
    static _animationLoop() {
        const Anim = $e780181a0ef0b2c4$export$c35d437ae5945fcd;
        if (Anim.animations.size) {
            Anim._runFrames();
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
}
$e780181a0ef0b2c4$export$c35d437ae5945fcd.animations = new Set();
$e780181a0ef0b2c4$export$c35d437ae5945fcd.animIdCounter = 0;
$e780181a0ef0b2c4$export$c35d437ae5945fcd.animRunning = false;






// every config key that is not an attribute to tween
const $1a900cbc7cd0dac4$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    onUpdate: 1,
    onReset: 1,
    yoyo: 1
}, $1a900cbc7cd0dac4$var$PAUSED = 1, $1a900cbc7cd0dac4$var$PLAYING = 2, $1a900cbc7cd0dac4$var$REVERSING = 3, $1a900cbc7cd0dac4$var$colorAttrs = [
    'fill',
    'stroke',
    'shadowColor'
];
let $1a900cbc7cd0dac4$var$idCounter = 0;
// the diff below reads r/g/b/a directly, so a color we can not parse must fail
// with its own message instead of "Cannot read properties of undefined"
function $1a900cbc7cd0dac4$var$colorToRGBA(color) {
    return (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).colorToRGBA(color) || (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).throw('can not tween the color "' + color + '", because it is not a valid color.');
}
function $1a900cbc7cd0dac4$var$colorDiff(start, end) {
    return {
        r: end.r - start.r,
        g: end.g - start.g,
        b: end.b - start.b,
        a: end.a - start.a
    };
}
function $1a900cbc7cd0dac4$var$tweenColor(start, diff, i) {
    return 'rgba(' + Math.round(start.r + diff.r * i) + ',' + Math.round(start.g + diff.g * i) + ',' + Math.round(start.b + diff.b * i) + ',' + (start.a + diff.a * i) + ')';
}
class $1a900cbc7cd0dac4$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        const handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $1a900cbc7cd0dac4$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.fire('onPlay');
        this.onEnterFrame();
    }
    reverse() {
        this.state = $1a900cbc7cd0dac4$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.fire('onReverse');
        this.onEnterFrame();
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    }
    onEnterFrame() {
        const t = this.getTimer() - this._startTime;
        if (this.state === $1a900cbc7cd0dac4$var$PLAYING) this.setTime(t);
        else if (this.state === $1a900cbc7cd0dac4$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $1a900cbc7cd0dac4$var$PAUSED;
        this.fire('onPause');
    }
    getTimer() {
        return Date.now();
    }
}
class $1a900cbc7cd0dac4$export$208a41d6b4e37b97 {
    constructor(config){
        const that = this, node = config.node, nodeId = node._id, easing = config.easing || $1a900cbc7cd0dac4$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo;
        let duration, key;
        if (typeof config.duration === 'undefined') duration = 0.3;
        else if (config.duration === 0) // zero is bad value for duration
        duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $1a900cbc7cd0dac4$var$idCounter++;
        const layers = node.getLayer() || (node instanceof (0, $8c8384c27430fce8$export$b9f99057a3c7692)['Stage'] ? node.getLayers() : null);
        if (!layers) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        this.anim = new (0, $e780181a0ef0b2c4$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $1a900cbc7cd0dac4$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        // init attrs map
        if (!$1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId]) $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        // init tweens map
        if (!$1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId]) $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($1a900cbc7cd0dac4$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        // callbacks
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        // a component attribute ({x, y} of scale, offset, a gradient point...)
        // is tweened through its components: scale -> scaleX, scaleY
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isPlainObject(end)) {
            for(const component in end)this._addAttr(key + (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._capitalize(component), end[component]);
            return;
        }
        const node = this.node, nodeId = node._id;
        let diff, len, trueEnd, trueStart;
        // remove conflict from tween map if it exists
        const tweenId = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId !== undefined) delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        // add to tween map
        let start = node.getAttr(key);
        if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(end) || (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(start)) {
            diff = [];
            // only normalized arrays are interpolated, so the values the user asked
            // for are restored when the tween ends
            trueStart = start;
            trueEnd = end;
            // an attribute the node does not have yet starts from zeros, a scalar
            // side tweens every entry. A copy of start, as the colour stops are
            // replaced by RGBA objects below
            start = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(start) ? start.slice() : new Array(end.length).fill(start || 0);
            if (!(0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(end)) end = new Array(start.length).fill(end);
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                // before tweening points we need to make sure that start.length === end.length
                // Util._prepareArrayForTween thinking that end.length > start.length
                if (end.length > start.length) // so in this case we will increase number of starting points
                start = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                else // in this case we will increase number of eding points
                end = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
            }
            if (key.endsWith('ColorStops')) {
                for(let n = 0; n < len; n++)if (n % 2 === 0) diff.push((end[n] || 0) - (start[n] || 0));
                else {
                    const startRGBA = $1a900cbc7cd0dac4$var$colorToRGBA(start[n]);
                    start[n] = startRGBA;
                    diff.push($1a900cbc7cd0dac4$var$colorDiff(startRGBA, $1a900cbc7cd0dac4$var$colorToRGBA(end[n])));
                }
            } else for(let n = 0; n < len; n++)diff.push((end[n] || 0) - (start[n] || 0));
        } else if ($1a900cbc7cd0dac4$var$colorAttrs.indexOf(key) !== -1) {
            start = $1a900cbc7cd0dac4$var$colorToRGBA(start);
            diff = $1a900cbc7cd0dac4$var$colorDiff(start, $1a900cbc7cd0dac4$var$colorToRGBA(end));
        } else diff = end - start;
        $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        var _a;
        const node = this.node, attrs = (_a = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[node._id]) === null || _a === void 0 ? void 0 : _a[this._id];
        let key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.endsWith('ColorStops')) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push($1a900cbc7cd0dac4$var$tweenColor(start[n], diff[n], i));
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($1a900cbc7cd0dac4$var$colorAttrs.indexOf(key) !== -1) newVal = $1a900cbc7cd0dac4$var$tweenColor(start, diff, i);
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        // a running tween is destroyed with its node (the animation loop would
        // keep both alive); a stopped one is not held by the node at all.
        // The namespace contains "konva" so clone() does not copy the listener
        const destroyEvent = `destroy.konva-tween${this._id}`;
        const onDestroy = ()=>this.destroy();
        const start = ()=>{
            this.node.off(destroyEvent).on(destroyEvent, onDestroy);
            this.anim.start();
        };
        this.tween.onPlay = start;
        this.tween.onReverse = start;
        // stop listeners
        this.tween.onPause = ()=>{
            this.node.off(destroyEvent);
            this.anim.stop();
        };
        const end = (edge, callback)=>{
            var _a;
            // no attributes means the tween was destroyed inside the last onUpdate
            const attrs = (_a = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[this.node._id]) === null || _a === void 0 ? void 0 : _a[this._id];
            if (!attrs) return;
            for(const key in attrs)if (attrs[key][edge] !== undefined) this.node.setAttr(key, attrs[key][edge]);
            callback === null || callback === void 0 || callback.call(this);
        };
        this.tween.onFinish = ()=>end('trueEnd', this.onFinish);
        this.tween.onReset = ()=>end('trueStart', this.onReset);
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    /**
     * play
     * @method
     * @name Konva.Tween#play
     * @returns {Tween}
     */ play() {
        this.tween.play();
        return this;
    }
    /**
     * reverse
     * @method
     * @name Konva.Tween#reverse
     * @returns {Tween}
     */ reverse() {
        this.tween.reverse();
        return this;
    }
    /**
     * reset
     * @method
     * @name Konva.Tween#reset
     * @returns {Tween}
     */ reset() {
        this.tween.reset();
        return this;
    }
    /**
     * seek
     * @method
     * @name Konva.Tween#seek
     * @param {Number} t time in seconds between 0 and the duration
     * @returns {Tween}
     */ seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    /**
     * pause
     * @method
     * @name Konva.Tween#pause
     * @returns {Tween}
     */ pause() {
        this.tween.pause();
        return this;
    }
    /**
     * finish
     * @method
     * @name Konva.Tween#finish
     * @returns {Tween}
     */ finish() {
        this.tween.finish();
        return this;
    }
    /**
     * destroy
     * @method
     * @name Konva.Tween#destroy
     */ destroy() {
        var _a;
        const nodeId = this.node._id, thisId = this._id, owned = (_a = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId]) === null || _a === void 0 ? void 0 : _a[thisId], owners = $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId];
        this.pause();
        if (this.anim) this.anim.stop();
        // release only the attributes this tween still owns, other tweens on
        // the node keep theirs (nothing left to do when destroyed twice)
        if (owned) {
            if (owners) {
                for(const key in owned)delete owners[key];
                if (Object.keys(owners).length === 0) delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens[nodeId];
            }
            delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId][thisId];
            if (Object.keys($1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId]).length === 0) delete $1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs[nodeId];
        }
    }
}
$1a900cbc7cd0dac4$export$208a41d6b4e37b97.attrs = {};
$1a900cbc7cd0dac4$export$208a41d6b4e37b97.tweens = {};
/**
 * Tween node properties. Shorter usage of {@link Konva.Tween} object.
 *
 * @method Konva.Node#to
 * @param {Object} [params] tween params
 * @returns {Konva.Tween}
 * @example
 *
 * circle.to({
 *   x : 50,
 *   duration : 0.5,
 *   onUpdate: () => console.log('props updated'),
 *   onFinish: () => console.log('finished'),
 * });
 */ (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.to = function(params) {
    const onFinish = params.onFinish;
    // params stay untouched, so the same object can animate several nodes
    const tween = new $1a900cbc7cd0dac4$export$208a41d6b4e37b97({
        ...params,
        node: this,
        onFinish () {
            tween.destroy();
            if (onFinish) onFinish();
        }
    });
    tween.play();
    return tween;
};
const $1a900cbc7cd0dac4$export$ade85cc9682adcc5 = {
    /**
     * back ease in
     * @function
     * @memberof Konva.Easings
     */ BackEaseIn (t, b, c, d) {
        const s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    /**
     * back ease out
     * @function
     * @memberof Konva.Easings
     */ BackEaseOut (t, b, c, d) {
        const s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    /**
     * back ease in out
     * @function
     * @memberof Konva.Easings
     */ BackEaseInOut (t, b, c, d) {
        let s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    /**
     * elastic ease in
     * @function
     * @memberof Konva.Easings
     */ ElasticEaseIn (t, b, c, d, a, p) {
        // added s = 0
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    /**
     * elastic ease out
     * @function
     * @memberof Konva.Easings
     */ ElasticEaseOut (t, b, c, d, a, p) {
        // added s = 0
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    /**
     * elastic ease in out
     * @function
     * @memberof Konva.Easings
     */ ElasticEaseInOut (t, b, c, d, a, p) {
        // added s = 0
        let s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    /**
     * bounce ease out
     * @function
     * @memberof Konva.Easings
     */ BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    /**
     * bounce ease in
     * @function
     * @memberof Konva.Easings
     */ BounceEaseIn (t, b, c, d) {
        return c - $1a900cbc7cd0dac4$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    /**
     * bounce ease in out
     * @function
     * @memberof Konva.Easings
     */ BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $1a900cbc7cd0dac4$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $1a900cbc7cd0dac4$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    /**
     * ease in
     * @function
     * @memberof Konva.Easings
     */ EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    /**
     * ease out
     * @function
     * @memberof Konva.Easings
     */ EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    /**
     * ease in out
     * @function
     * @memberof Konva.Easings
     */ EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    /**
     * strong ease in
     * @function
     * @memberof Konva.Easings
     */ StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    /**
     * strong ease out
     * @function
     * @memberof Konva.Easings
     */ StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    /**
     * strong ease in out
     * @function
     * @memberof Konva.Easings
     */ StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    /**
     * linear
     * @function
     * @memberof Konva.Easings
     */ Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $184c4f87393bf8b7$export$b9f99057a3c7692 = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._assign((0, $8c8384c27430fce8$export$b9f99057a3c7692), {
    /**
     * Defer automatic Konva.Transformer updates across many synchronous node changes
     * and run them once when the returned function is called.
     * A Transformer normally updates after every change of an attached node, so a loop
     * over N selected nodes costs N updates, each measuring all N nodes. In a batch it costs one.
     * A single setAttrs(), position(), destroyChildren(), removeChildren() call or animation frame is
     * already batched; use this for anything else, for example a React commit or an undo.
     * Attributes and change events stay synchronous. Inside the batch, the Transformer's own
     * x(), y(), width(), height() and getClientRect() are computed on read; its anchors are laid out
     * when the batch finishes, or earlier if something draws or measures them.
     * Change events fire inside the batch, so a listener sees the new attributes and the
     * Transformer's box, but not its anchors; call transformer.update() there if it needs them.
     * Batches nest. Call the returned function in a finally block, and do not keep a batch
     * open across an await or an animation frame.
     * @method
     * @name Konva.beginUpdateBatch
     * @returns {Function} finishes the batch and runs the pending updates
     * @example
     * const finish = Konva.beginUpdateBatch();
     * try {
     *   selectedNodes.forEach((node) => node.width(100));
     * } finally {
     *   finish();
     * }
     */ beginUpdateBatch: (0, $367bbc8f6a40f243$export$85c928794f8d04d4)._beginUpdateBatch,
    Util: $d4400dec7c2a8326$export$f8f26dd395d7e1bd,
    Transform: $d4400dec7c2a8326$export$563a914cafbdc389,
    Node: $367bbc8f6a40f243$export$85c928794f8d04d4,
    Container: $f02a8e3513953b09$export$42a852a2b6b56249,
    Stage: $ac2a2e8b879d4f85$export$208cd1682bd0e4b6,
    stages: $ac2a2e8b879d4f85$export$1bfcff8d7c4bf05,
    Layer: $1ff13b72400727ee$export$936d0764594b6eb3,
    FastLayer: $42d998124386a05c$export$92d64f29192d1118,
    Group: $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4,
    DD: $fa6dae8e3add958f$export$e34f1b340034d7f,
    Shape: $9081147451080c7d$export$6428a7f2611ef1fa,
    shapes: $9081147451080c7d$export$4ff7fc6f1af248b5,
    Animation: $e780181a0ef0b2c4$export$c35d437ae5945fcd,
    Tween: $1a900cbc7cd0dac4$export$208a41d6b4e37b97,
    Easings: $1a900cbc7cd0dac4$export$ade85cc9682adcc5,
    Context: $02f524f4df5fe352$export$841858b892ce1f4c,
    Canvas: $94cf583ff38878f8$export$8d01c972ee8b14a9
});
var $184c4f87393bf8b7$export$2e2bcd8739ae039 = $184c4f87393bf8b7$export$b9f99057a3c7692;






class $7e6edc1d7eb9aa8d$export$6ef80ffb606dd232 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const angle = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, Math.abs(this.outerRadius()), 0, angle, clockwise);
        context.arc(0, 0, Math.abs(this.innerRadius()), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return Math.abs(this.outerRadius()) * 2;
    }
    getHeight() {
        return Math.abs(this.outerRadius()) * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const r1 = Math.abs(this.innerRadius()), r2 = Math.abs(this.outerRadius());
        const innerRadius = Math.min(r1, r2), outerRadius = Math.max(r1, r2);
        const clockwise = this.clockwise();
        // canvas draws a full circle for any non-zero full-turn end angle regardless
        // of direction, and nothing for angle 0. Keep exact turns distinct from
        // the modulo-normalized partial sweep below.
        const rawAngle = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.angle());
        if (rawAngle % (Math.PI * 2) === 0) return rawAngle !== 0 ? {
            x: -outerRadius,
            y: -outerRadius,
            width: outerRadius * 2,
            height: outerRadius * 2
        } : {
            x: innerRadius,
            y: 0,
            width: outerRadius - innerRadius,
            height: 0
        };
        const turn = Math.PI * 2;
        const sweep = clockwise ? -rawAngle : rawAngle;
        const angle = sweep >= turn ? turn : (sweep % turn + turn) % turn;
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$7e6edc1d7eb9aa8d$export$6ef80ffb606dd232.prototype._centroid = true;
$7e6edc1d7eb9aa8d$export$6ef80ffb606dd232.prototype.className = 'Arc';
$7e6edc1d7eb9aa8d$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius',
    'angle',
    'clockwise'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, true);
// add getters setters
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'innerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set innerRadius
 * @name Konva.Arc#innerRadius
 * @method
 * @param {Number} innerRadius
 * @returns {Number}
 * @example
 * // get inner radius
 * var innerRadius = arc.innerRadius();
 *
 * // set inner radius
 * arc.innerRadius(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'outerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set outerRadius
 * @name Konva.Arc#outerRadius
 * @method
 * @param {Number} outerRadius
 * @returns {Number}
 * @example
 * // get outer radius
 * var outerRadius = arc.outerRadius();
 *
 * // set outer radius
 * arc.outerRadius(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'angle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set angle in degrees
 * @name Konva.Arc#angle
 * @method
 * @param {Number} angle
 * @returns {Number}
 * @example
 * // get angle
 * var angle = arc.angle();
 *
 * // set angle
 * arc.angle(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($7e6edc1d7eb9aa8d$export$6ef80ffb606dd232, 'clockwise', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)()); /**
 * get/set clockwise flag
 * @name Konva.Arc#clockwise
 * @method
 * @param {Boolean} clockwise
 * @returns {Boolean}
 * @example
 * // get clockwise flag
 * var clockwise = arc.clockwise();
 *
 * // draw arc counter-clockwise
 * arc.clockwise(false);
 *
 * // draw arc clockwise
 * arc.clockwise(true);
 */ 



// Credits: rveciana/svg-path-properties
// Keep order 20 separate so the main bundle can omit the other quadrature rows.
// Legendre-Gauss abscissae (xi values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
const $5445f83816334314$var$tValues20 = [
    -0.07652652113349734,
    0.0765265211334973337546404093988382110047,
    -0.22778585114164507,
    0.227785851141645078080496195368574624743,
    -0.37370608871541955,
    0.3737060887154195606725481770249272373957,
    -0.5108670019508271,
    0.5108670019508270980043640509552509984254,
    -0.636053680726515,
    0.6360536807265150254528366962262859367433,
    -0.7463319064601508,
    0.7463319064601507926143050703556415903107,
    -0.8391169718222188,
    0.8391169718222188233945290617015206853296,
    -0.912234428251326,
    0.9122344282513259058677524412032981130491,
    -0.9639719272779138,
    0.963971927277913791267666131197277221912,
    -0.9931285991850949,
    0.9931285991850949247861223884713202782226
];
const $5445f83816334314$export$9b0e545caa171200 = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476
    ],
    [
        0,
        -0.7745966692414834,
        0.7745966692414833770358530799564799221665
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957
    ],
    [
        0,
        -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347
    ],
    [
        0,
        0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282
    ],
    [
        0,
        -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282
    ],
    [
        0,
        -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601
    ],
    [
        0,
        -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676
    ],
    [
        0,
        -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262
    ],
    [
        0,
        -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525
    ],
    [
        0,
        -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893
    ],
    $5445f83816334314$var$tValues20,
    [
        0,
        -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393
    ],
    [
        0,
        -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ]
];
// Legendre-Gauss weights (wi values, defined by a function linked to in the Bezier primer article)
const $5445f83816334314$var$cValues20 = [
    0.1527533871307258506980843319550975934919,
    0.1527533871307258506980843319550975934919,
    0.1491729864726037467878287370019694366926,
    0.1491729864726037467878287370019694366926,
    0.1420961093183820513292983250671649330345,
    0.1420961093183820513292983250671649330345,
    0.1316886384491766268984944997481631349161,
    0.1316886384491766268984944997481631349161,
    0.118194531961518417312377377711382287005,
    0.118194531961518417312377377711382287005,
    0.1019301198172404350367501354803498761666,
    0.1019301198172404350367501354803498761666,
    0.0832767415767047487247581432220462061001,
    0.0832767415767047487247581432220462061001,
    0.0626720483341090635695065351870416063516,
    0.0626720483341090635695065351870416063516,
    0.040601429800386941331039952274932109879,
    0.040601429800386941331039952274932109879,
    0.0176140071391521183118619623518528163621,
    0.0176140071391521183118619623518528163621
];
const $5445f83816334314$export$63f082a24e4d0d2 = [
    [],
    [],
    [
        1.0,
        1.0
    ],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529
    ],
    $5445f83816334314$var$cValues20,
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ]
];
const $5445f83816334314$export$75c342514231e6de = [
    [
        1
    ],
    [
        1,
        1
    ],
    [
        1,
        2,
        1
    ],
    [
        1,
        3,
        3,
        1
    ]
];
const $5445f83816334314$export$303d0010d4a82673 = (xs, ys, t)=>{
    const z = t / 2;
    let sum = 0;
    for(let i = 0; i < $5445f83816334314$var$tValues20.length; i++){
        const correctedT = z * $5445f83816334314$var$tValues20[i] + z;
        sum += $5445f83816334314$var$cValues20[i] * $5445f83816334314$var$BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
const $5445f83816334314$export$80a8cfc7cba8a0a9 = (xs, ys, t = 1)=>$5445f83816334314$export$303d0010d4a82673([
        xs[0],
        xs[0] + 2 / 3 * (xs[1] - xs[0]),
        xs[2] + 2 / 3 * (xs[1] - xs[2]),
        xs[2]
    ], [
        ys[0],
        ys[0] + 2 / 3 * (ys[1] - ys[0]),
        ys[2] + 2 / 3 * (ys[1] - ys[2]),
        ys[2]
    ], t);
function $5445f83816334314$var$BFunc(xs, ys, t) {
    // Interpolate the three derivative control points of a cubic curve.
    const mt = 1 - t;
    const a = mt * mt;
    const b = 2 * mt * t;
    const c = t * t;
    const dx = a * (3 * (xs[1] - xs[0])) + b * (3 * (xs[2] - xs[1])) + c * (3 * (xs[3] - xs[2]));
    const dy = a * (3 * (ys[1] - ys[0])) + b * (3 * (ys[2] - ys[1])) + c * (3 * (ys[3] - ys[2]));
    return Math.sqrt(dx * dx + dy * dy);
}
const $5445f83816334314$export$e638253c5cb35420 = (length, totalLength, func)=>{
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while(error > 0.001){
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            } else step /= 2;
        }
        numIterations++;
        if (numIterations > 500) break;
    }
    return t;
};
const $5445f83816334314$var$quadraticAt = (p0, p1, p2, t)=>{
    const mt = 1 - t;
    return mt * mt * p0 + 2 * mt * t * p1 + t * t * p2;
};
const $5445f83816334314$export$fe5f0b515ac55e59 = (x0, y0, x1, y1, x2, y2)=>{
    const extrema = [];
    for (const axis of [
        [
            x0,
            x1,
            x2
        ],
        [
            y0,
            y1,
            y2
        ]
    ]){
        // the derivative of the quadratic is linear, so it has one root. A straight
        // segment makes the denominator 0, and the division then gives a value that
        // is not in the range below.
        const t = (axis[0] - axis[1]) / (axis[0] - 2 * axis[1] + axis[2]);
        if (t > 0 && t < 1) extrema.push($5445f83816334314$var$quadraticAt(x0, x1, x2, t), $5445f83816334314$var$quadraticAt(y0, y1, y2, t));
    }
    return extrema;
};
const $5445f83816334314$var$cubicAt = (p0, p1, p2, p3, t)=>{
    const mt = 1 - t;
    return mt * mt * mt * p0 + 3 * mt * mt * t * p1 + 3 * mt * t * t * p2 + t * t * t * p3;
};
const $5445f83816334314$export$5290a5c75ff26013 = (x0, y0, x1, y1, x2, y2, x3, y3)=>{
    const extrema = [];
    for (const axis of [
        [
            x0,
            x1,
            x2,
            x3
        ],
        [
            y0,
            y1,
            y2,
            y3
        ]
    ]){
        // the derivative of the cubic is a * t * t + b * t + c
        const a = -3 * axis[0] + 9 * axis[1] - 9 * axis[2] + 3 * axis[3];
        const b = 6 * axis[0] - 12 * axis[1] + 6 * axis[2];
        const c = -3 * axis[0] + 3 * axis[1];
        const discriminant = b * b - 4 * a * c;
        if (discriminant < 0) continue;
        // stable form of the quadratic formula. The plain (-b +- d) / (2 * a)
        // loses the root that stays finite when a is zero or near zero, which is
        // what a symmetric pair of control points gives. Roots that are not
        // finite fall out of the range test below.
        const q = -(b + (b < 0 ? -1 : 1) * Math.sqrt(discriminant)) / 2;
        for (const t of [
            q / a,
            c / q
        ])if (t > 0 && t < 1) extrema.push($5445f83816334314$var$cubicAt(x0, x1, x2, x3, t), $5445f83816334314$var$cubicAt(y0, y1, y2, y3, t));
    }
    return extrema;
};







function $5329876ec3db1142$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), dSum = d01 + d12;
    // all three points are the same, so the control points collapse into that
    // point. Without this the divisions below are 0 / 0 = NaN.
    if (dSum === 0) return [
        x1,
        y1,
        x1,
        y1
    ];
    const fa = t * d01 / dSum, fb = t * d12 / dSum, p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $5329876ec3db1142$var$expandPoints(p, tension) {
    const len = p.length, allPoints = [];
    for(let n = 2; n < len - 2; n += 2){
        const cp = $5329876ec3db1142$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
function $5329876ec3db1142$var$getBezierExtremaPoints(points) {
    const extrema = [];
    // points[0], points[1] is the starting point; every subsequent group of
    // 6 values is one cubic bezier segment (cp1x, cp1y, cp2x, cp2y, x, y),
    // whose start is the previous segment's end point (matching the layout
    // Line#_sceneFunc feeds to context.bezierCurveTo in a loop).
    for(let n = 0; n + 7 < points.length; n += 6)// the end point of the segment. It is a joint with the next segment, and
    // the curve can reach its highest or lowest value there without the
    // derivative going to zero on either side.
    extrema.push(points[n + 6], points[n + 7], ...(0, $5445f83816334314$export$5290a5c75ff26013)(points[n], points[n + 1], points[n + 2], points[n + 3], points[n + 4], points[n + 5], points[n + 6], points[n + 7]));
    return extrema;
}
class $5329876ec3db1142$export$17d680238e50603e extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function() {
            this._clearCache('tensionPoints');
        });
    }
    _hasTension() {
        return this.tension() !== 0 && this.points().length > 4;
    }
    /**
     * Report every curve segment of a line with a tension, in draw order. Both
     * the scene function and the bounding rect read the shape through this, so
     * that they can not disagree about which curve the line is.
     *
     * The handlers take plain numbers, because this runs on every frame.
     */ _eachTensionSegment(onQuadratic, onCubic) {
        const points = this.points(), length = points.length, closed = this.closed(), tp = this.getTensionPoints(), len = tp.length;
        let x0 = points[0], y0 = points[1], // a closed line has a curve on both sides of the first point, so it
        // starts on a full cubic. An open one is capped by a quadratic instead
        n = closed ? 0 : 4;
        if (!closed) {
            onQuadratic(x0, y0, tp[0], tp[1], tp[2], tp[3]);
            x0 = tp[2];
            y0 = tp[3];
        }
        while(n < len - 2){
            const cp1x = tp[n++], cp1y = tp[n++], cp2x = tp[n++], cp2y = tp[n++], x = tp[n++], y = tp[n++];
            onCubic(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y);
            x0 = x;
            y0 = y;
        }
        if (!closed) onQuadratic(x0, y0, tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
    }
    _getStrokePadding(miterLimit = this.points().length === 4 && !this.closed() ? 1 : undefined) {
        return super._getStrokePadding(miterLimit);
    }
    _sceneFunc(context) {
        const points = this.points(), length = points.length, closed = this.closed(), bezier = this.bezier();
        if (!length) return;
        let n = 0;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        // tension
        if (this._hasTension()) this._eachTensionSegment((_x0, _y0, cpx, cpy, x, y)=>context.quadraticCurveTo(cpx, cpy, x, y), (_x0, _y0, cp1x, cp1y, cp2x, cp2y, x, y)=>context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y));
        else if (bezier) {
            // no tension but bezier
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else // no tension
        for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        // closed e.g. polygons and blobs
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else // open e.g. lines and splines
        context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache('tensionPoints', this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $5329876ec3db1142$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        const p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $5329876ec3db1142$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $5329876ec3db1142$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $5329876ec3db1142$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    // overload size detection
    getSelfRect() {
        let points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this._hasTension()) {
            // the two end points of every segment, plus the points where it turns
            // back on either axis. Together they are the exact bounds of the curve
            const bounds = [
                points[0],
                points[1]
            ];
            this._eachTensionSegment((x0, y0, cpx, cpy, x, y)=>bounds.push(x, y, ...(0, $5445f83816334314$export$fe5f0b515ac55e59)(x0, y0, cpx, cpy, x, y)), (x0, y0, cp1x, cp1y, cp2x, cp2y, x, y)=>bounds.push(x, y, ...(0, $5445f83816334314$export$5290a5c75ff26013)(x0, y0, cp1x, cp1y, cp2x, cp2y, x, y)));
            points = bounds;
        } else if (this.bezier()) // no trailing point here: the extrema already carry the end point of
        // every segment that is drawn. Adding the last pair of the array back
        // would include a control point of a trailing partial segment, which
        // _sceneFunc never draws.
        points = [
            points[0],
            points[1],
            ...$5329876ec3db1142$var$getBezierExtremaPoints(points)
        ];
        return (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getPointsRect(points);
    }
}
$5329876ec3db1142$export$17d680238e50603e.prototype.className = 'Line';
$5329876ec3db1142$export$17d680238e50603e.prototype._attrsAffectingSize = [
    'points',
    'bezier',
    'tension',
    'closed'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($5329876ec3db1142$export$17d680238e50603e, true);
// add getters setters
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'closed', false);
/**
 * get/set closed flag.  The default is false
 * @name Konva.Line#closed
 * @method
 * @param {Boolean} closed
 * @returns {Boolean}
 * @example
 * // get closed flag
 * var closed = line.closed();
 *
 * // close the shape
 * line.closed(true);
 *
 * // open the shape
 * line.closed(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'bezier', false);
/**
 * get/set bezier flag.  The default is false
 * @name Konva.Line#bezier
 * @method
 * @param {Boolean} bezier
 * @returns {Boolean}
 * @example
 * // get whether the line is a bezier
 * var isBezier = line.bezier();
 *
 * // set whether the line is a bezier
 * line.bezier(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'tension', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set tension
 * @name Konva.Line#tension
 * @method
 * @param {Number} tension Higher values will result in a more curvy line.  A value of 0 will result in no interpolation. The default is 0
 * @returns {Number}
 * @example
 * // get tension
 * var tension = line.tension();
 *
 * // set tension
 * line.tension(3);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5329876ec3db1142$export$17d680238e50603e, 'points', [], (0, $d7c0e5ae0fe3f9a6$export$42b6f8f340e9a165)()); /**
 * get/set points array. Points is a flat array [x1, y1, x2, y2]. It is flat for performance reasons.
 * @name Konva.Line#points
 * @method
 * @param {Array} points
 * @returns {Array}
 * @example
 * // get points
 * var points = line.points();
 *
 * // set points
 * line.points([10, 20, 30, 40, 50, 60]);
 *
 * // push a new point
 * line.points(line.points().concat([70, 80]));
 */ 









// how many numbers each path command takes
const $d1bc11ae7d9e9a07$var$PARAM_COUNT = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7,
    z: 0
};
const $d1bc11ae7d9e9a07$var$TAU = Math.PI * 2;
class $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on('dataChange.konva', function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        const ca = this.dataArray;
        // context position
        context.beginPath();
        let isClosed = false;
        for(let n = 0; n < ca.length; n++){
            const c = ca[n].command;
            const p = ca[n].points;
            switch(c){
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    context.ellipse(p[0], p[1], p[2], p[3], p[6], p[4], p[4] + p[5], !p[7]);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        const points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === 'A') {
                // the two end points, plus the angles where the ellipse turns back on
                // either axis, when they fall inside the sweep. Together they are the
                // exact bounds of the segment
                const [cx, cy, rx, ry, start, dTheta, psi] = data.points;
                const cos = Math.cos(psi), sin = Math.sin(psi);
                const end = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, start + dTheta, psi);
                points.push(data.start.x, data.start.y, end.x, end.y);
                const tx = Math.atan2(-ry * sin, rx * cos);
                const ty = Math.atan2(ry * cos, rx * sin);
                [
                    tx,
                    tx + Math.PI,
                    ty,
                    ty + Math.PI
                ].forEach((t)=>{
                    // how far into the sweep t is, in the direction of the sweep
                    const k = ((t - start) * Math.sign(dTheta) % $d1bc11ae7d9e9a07$var$TAU + $d1bc11ae7d9e9a07$var$TAU) % $d1bc11ae7d9e9a07$var$TAU;
                    if (k < Math.abs(dTheta)) {
                        const point = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, t, psi);
                        points.push(point.x, point.y);
                    }
                });
            } else if (data.command === 'C') // the two end points, plus the points where the curve turns back on
            // either axis. Together they are the exact bounds of the segment
            points.push(data.start.x, data.start.y, data.points[4], data.points[5], ...(0, $5445f83816334314$export$5290a5c75ff26013)(data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]));
            else if (data.command === 'Q') // same as 'C'. Note that 'q', 'T' and 't' are all normalised to 'Q' by
            // the parser, so this one branch covers every quadratic segment
            points.push(data.start.x, data.start.y, data.points[2], data.points[3], ...(0, $5445f83816334314$export$fe5f0b515ac55e59)(data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3]));
            else points.push(...data.points);
        });
        return (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getPointsRect(points);
    }
    /**
     * Return length of the path.
     * @method
     * @name Konva.Path#getLength
     * @returns {Number} length
     * @example
     * var length = path.getLength();
     */ getLength() {
        return this.pathLength;
    }
    /**
     * Get point on path at specific length of the path
     * @method
     * @name Konva.Path#getPointAtLength
     * @param {Number} length length
     * @returns {Object} point {x,y} point
     * @example
     * var point = path.getPointAtLength(10);
     */ getPointAtLength(length) {
        return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for(let i = 0; i < dataArray.length; ++i)pathLength += dataArray[i].pathLength;
        return pathLength;
    }
    // The optional cursor is for sequential lookups within one continuous subpath.
    static getPointAtLengthOfDataArray(length, dataArray, cursor) {
        var _a, _b;
        let points, i = (_a = cursor === null || cursor === void 0 ? void 0 : cursor.index) !== null && _a !== void 0 ? _a : 0, offset = (_b = cursor === null || cursor === void 0 ? void 0 : cursor.offset) !== null && _b !== void 0 ? _b : 0, ii = dataArray.length;
        if (!ii) return null;
        // Negative spacing can move a text glyph back into an earlier segment.
        while(i > 0 && length <= offset)offset -= dataArray[--i].pathLength;
        length -= offset;
        while(i < ii && length > dataArray[i].pathLength){
            const segmentLength = dataArray[i].pathLength;
            length -= segmentLength;
            offset += segmentLength;
            ++i;
        }
        if (cursor && i < ii) {
            cursor.index = i;
            cursor.offset = offset;
        }
        if (i === ii) {
            // past the end: the end of the last segment
            i--;
            length = dataArray[i].pathLength;
        }
        if (length < 0.01) {
            const cmd = dataArray[i].command;
            if (cmd === 'M') {
                points = dataArray[i].points.slice(0, 2);
                return {
                    x: points[0],
                    y: points[1]
                };
            } else return {
                x: dataArray[i].start.x,
                y: dataArray[i].start.y
            };
        }
        const cp = dataArray[i];
        const p = cp.points;
        switch(cp.command){
            case 'L':
            case 'z':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnCubicBezier((0, $5445f83816334314$export$e638253c5cb35420)(length, cp.pathLength, (i)=>{
                    return (0, $5445f83816334314$export$303d0010d4a82673)([
                        cp.start.x,
                        p[0],
                        p[2],
                        p[4]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3],
                        p[5]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier((0, $5445f83816334314$export$e638253c5cb35420)(length, cp.pathLength, (i)=>{
                    return (0, $5445f83816334314$export$80a8cfc7cba8a0a9)([
                        cp.start.x,
                        p[0],
                        p[2]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                return $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(p[0], p[1], p[2], p[3], // on a circle angle is proportional to distance, so the walk is only
                // needed for a real ellipse
                p[2] === p[3] ? p[4] + p[5] * length / cp.pathLength : $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9._walkArc(p, length).theta, p[6]);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
        fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
        const len = this.getLineLength(P1x, P1y, P2x, P2y);
        if (len < 1e-10) return {
            x: P1x,
            y: P1y
        };
        if (P2x === P1x) // Vertical line
        return {
            x: fromX,
            y: fromY + (P2y > P1y ? dist : -dist)
        };
        const m = (P2y - P1y) / (P2x - P1x);
        const run = Math.sqrt(dist * dist / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const rise = m * run;
        if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) return {
            x: fromX + run,
            y: fromY + rise
        };
        const u = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
        const ix = P1x + u * (P2x - P1x);
        const iy = P1y + u * (P2y - P1y);
        const pRise = this.getLineLength(fromX, fromY, ix, iy);
        const pRun = Math.sqrt(dist * dist - pRise * pRise);
        const adjustedRun = Math.sqrt(pRun * pRun / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const adjustedRise = m * adjustedRun;
        return {
            x: ix + adjustedRun,
            y: iy + adjustedRise
        };
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        const x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        const y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        const x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        const y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        const pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    /*
     * get parsed data array from the data
     *  string.  V, v, H, h, and l data are converted to
     *  L data for the purpose of high performance Path
     *  rendering
     */ static parsePathData(data) {
        // Path Data Segment must begin with a moveTo
        //m (x y)+  Relative moveTo (subsequent points are treated as lineTo)
        //M (x y)+  Absolute moveTo (subsequent points are treated as lineTo)
        //l (x y)+  Relative lineTo
        //L (x y)+  Absolute LineTo
        //h (x)+    Relative horizontal lineTo
        //H (x)+    Absolute horizontal lineTo
        //v (y)+    Relative vertical lineTo
        //V (y)+    Absolute vertical lineTo
        //z (closepath)
        //Z (closepath)
        //c (x1 y1 x2 y2 x y)+ Relative Bezier curve
        //C (x1 y1 x2 y2 x y)+ Absolute Bezier curve
        //q (x1 y1 x y)+       Relative Quadratic Bezier
        //Q (x1 y1 x y)+       Absolute Quadratic Bezier
        //t (x y)+    Shorthand/Smooth Relative Quadratic Bezier
        //T (x y)+    Shorthand/Smooth Absolute Quadratic Bezier
        //s (x2 y2 x y)+       Shorthand/Smooth Relative Bezier curve
        //S (x2 y2 x y)+       Shorthand/Smooth Absolute Bezier curve
        //a (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+     Relative Elliptical Arc
        //A (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+  Absolute Elliptical Arc
        // return early if data is not defined
        if (!data) return [];
        // command string
        let cs = data;
        // command chars
        const cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        // convert white spaces to commas
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        // create pipes so that we can split the data
        for(let n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        // create array
        const arr = cs.split('|');
        const ca = [];
        const coords = [];
        // init context point
        let cpx = 0;
        let cpy = 0;
        // start of the current subpath: where z draws back to
        let spx = 0;
        let spy = 0;
        const re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        let match;
        for(let n = 1; n < arr.length; n++){
            let str = arr[n];
            let c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            const p = [];
            // Track param position for A/a commands: 0..6 => rx, ry, psi, fa, fs, x, y
            let arcParamIndex = c === 'A' || c === 'a' ? 0 : -1;
            for(let j = 0, jlen = coords.length; j < jlen; j++){
                let token = coords[j];
                // SVGO merges the arc flags with the number that follows them:
                // "01.5.5" is fa=0 fs=1 x=.5 y=.5
                while((arcParamIndex === 3 || arcParamIndex === 4) && token.length > 1 && (token[0] === '0' || token[0] === '1')){
                    p.push(+token[0]);
                    arcParamIndex++;
                    token = token.slice(1);
                }
                const parsed = parseFloat(token);
                p.push(isNaN(parsed) ? 0 : parsed);
                if (arcParamIndex >= 0) arcParamIndex = (arcParamIndex + 1) % 7;
            }
            let pIndex = 0;
            while(pIndex < p.length){
                // z takes no numbers, and a command with too few of them ("L20"
                // with no y) is dropped rather than parsed into a NaN segment
                if (p.length - pIndex < $d1bc11ae7d9e9a07$var$PARAM_COUNT[c.toLowerCase()] || c === 'z' || c === 'Z') break;
                let cmd = '';
                let points = [];
                const startX = cpx, startY = cpy;
                // Move var from within the switch to up here (jshint)
                let prevCmd, ctlPtx, ctlPty; // Ss, Tt
                let rx, ry, psi, fa, fs, x1, y1; // Aa
                // convert l, H, h, V, and v to L
                switch(c){
                    // Note: Keep the lineTo's above the moveTo's in this switch
                    case 'l':
                        cpx += p[pIndex++];
                        cpy += p[pIndex++];
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p[pIndex++];
                        cpy = p[pIndex++];
                        points.push(cpx, cpy);
                        break;
                    // Note: lineTo handlers need to be above this point
                    case 'm':
                        cpx += p[pIndex++];
                        cpy += p[pIndex++];
                        cmd = 'M';
                        spx = cpx;
                        spy = cpy;
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p[pIndex++];
                        cpy = p[pIndex++];
                        cmd = 'M';
                        spx = cpx;
                        spy = cpy;
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p[pIndex++];
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p[pIndex++];
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p[pIndex++];
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p[pIndex++];
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p[pIndex++], p[pIndex++], p[pIndex++], p[pIndex++]);
                        cpx = p[pIndex++];
                        cpy = p[pIndex++];
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p[pIndex++], cpy + p[pIndex++], cpx + p[pIndex++], cpy + p[pIndex++]);
                        cpx += p[pIndex++];
                        cpy += p[pIndex++];
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if ((prevCmd === null || prevCmd === void 0 ? void 0 : prevCmd.command) === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p[pIndex++], p[pIndex++]);
                        cpx = p[pIndex++];
                        cpy = p[pIndex++];
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if ((prevCmd === null || prevCmd === void 0 ? void 0 : prevCmd.command) === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p[pIndex++], cpy + p[pIndex++]);
                        cpx += p[pIndex++];
                        cpy += p[pIndex++];
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p[pIndex++], p[pIndex++]);
                        cpx = p[pIndex++];
                        cpy = p[pIndex++];
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p[pIndex++], cpy + p[pIndex++]);
                        cpx += p[pIndex++];
                        cpy += p[pIndex++];
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if ((prevCmd === null || prevCmd === void 0 ? void 0 : prevCmd.command) === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p[pIndex++];
                        cpy = p[pIndex++];
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if ((prevCmd === null || prevCmd === void 0 ? void 0 : prevCmd.command) === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p[pIndex++];
                        cpy += p[pIndex++];
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                    case 'a':
                        // per SVG, the radii are used as absolute values
                        rx = Math.abs(p[pIndex++]);
                        ry = Math.abs(p[pIndex++]);
                        psi = p[pIndex++];
                        fa = p[pIndex++];
                        fs = p[pIndex++];
                        x1 = cpx;
                        y1 = cpy;
                        if (c === 'a') {
                            cpx += p[pIndex++];
                            cpy += p[pIndex++];
                        } else {
                            cpx = p[pIndex++];
                            cpy = p[pIndex++];
                        }
                        cmd = 'A';
                        // per SVG, an arc between coincident end points is omitted
                        // and a zero radius makes it a straight line
                        if (cpx === x1 && cpy === y1) continue;
                        else if (!rx || !ry) {
                            cmd = 'L';
                            points.push(cpx, cpy);
                        } else points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') {
                // per SVG, z is a line back to the start of the subpath, which then
                // becomes the current point
                ca.push({
                    command: 'z',
                    points: [
                        spx,
                        spy
                    ],
                    start: {
                        x: cpx,
                        y: cpy
                    },
                    pathLength: this.getLineLength(cpx, cpy, spx, spy)
                });
                cpx = spx;
                cpy = spy;
            }
        }
        return ca;
    }
    /**
     * Walks an arc in one degree steps, accumulating its length. Returns the
     * angle `length` along the arc, or its end angle and total length when
     * `length` is past the end.
     */ static _walkArc(points, length) {
        const [cx, cy, rx, ry, start, dTheta] = points;
        const steps = Math.max(1, Math.ceil(Math.abs(dTheta) / (Math.PI / 180)));
        // the arc length does not depend on the x-axis rotation psi, so it is left out
        let p1 = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, start, 0);
        let prev = start;
        let len = 0;
        for(let i = 1; i <= steps; i++){
            const t = start + dTheta * i / steps;
            const p2 = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, t, 0);
            const d = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.getLineLength(p1.x, p1.y, p2.x, p2.y);
            if (len + d >= length) return {
                theta: prev + (t - prev) * ((length - len) / d),
                length: length
            };
            len += d;
            p1 = p2;
            prev = t;
        }
        return {
            theta: prev,
            length: len
        };
    }
    static calcLength(x, y, cmd, points) {
        const path = $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9;
        switch(cmd){
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                return (0, $5445f83816334314$export$303d0010d4a82673)([
                    x,
                    points[0],
                    points[2],
                    points[4]
                ], [
                    y,
                    points[1],
                    points[3],
                    points[5]
                ], 1);
            case 'Q':
                return (0, $5445f83816334314$export$80a8cfc7cba8a0a9)([
                    x,
                    points[0],
                    points[2]
                ], [
                    y,
                    points[1],
                    points[3]
                ], 1);
            case 'A':
                return path._walkArc(points, Infinity).length;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        // Derived from: http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
        const psi = psiDeg * (Math.PI / 180.0);
        const xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        const yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        const lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        const cxp = f * rx * yp / ry;
        const cyp = f * -ry * xp / rx;
        const cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        const cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        const vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        const vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        const vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        const theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        const u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        const v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        let dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.prototype.className = 'Path';
$d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    'data'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9, true);
/**
 * get/set SVG path data string.  This method
 *  also automatically parses the data string
 *  into a data array.  Currently supported SVG data:
 *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
 * @name Konva.Path#data
 * @method
 * @param {String} data svg path string
 * @returns {String}
 * @example
 * // get data
 * var data = path.data();
 *
 * // set data
 * path.data('M200,100h100v50z');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9, 'data'); /**
 * get width of the path. It is computed from the path data and cannot be set
 * @name Konva.Path#width
 * @method
 * @returns {Number}
 * @example
 * var width = path.width();
 */  /**
 * get height of the path. It is computed from the path data and cannot be set
 * @name Konva.Path#height
 * @method
 * @returns {Number}
 * @example
 * var height = path.height();
 */ 


class $ed4c5015d754ac7a$export$21b07c8f274aebd5 extends (0, $5329876ec3db1142$export$17d680238e50603e) {
    _getStrokePadding() {
        // Arrowheads have joins even when the shaft is a single straight line.
        return super._getStrokePadding(this.pointerAtBeginning() || this.pointerAtEnding() ? this.miterLimit() || 10 : undefined);
    }
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        const points = this.points();
        const n = points.length;
        if (n < 4) return;
        const length = this.pointerLength();
        const width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(this._getPointerAngle(false));
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            ctx.rotate(this._getPointerAngle(true));
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    _getPointerAngle(atBeginning) {
        const points = this.points();
        const n = points.length;
        const fromTension = this.tension() !== 0 && n > 4;
        const tp = fromTension ? this.getTensionPoints() : points;
        const ex = atBeginning ? points[0] : points[n - 2], ey = atBeginning ? points[1] : points[n - 1];
        let dx = 0, dy = 0;
        if (fromTension && atBeginning) {
            dx = ex - (tp[0] + tp[2]) / 2;
            dy = ey - (tp[1] + tp[3]) / 2;
        } else if (fromTension) {
            const x = tp[tp.length - 4], y = tp[tp.length - 3];
            const controlX = tp[tp.length - 2], controlY = tp[tp.length - 1];
            const lastLength = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).calcLength(x, y, 'Q', [
                controlX,
                controlY,
                ex,
                ey
            ]);
            const previous = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(lastLength ? Math.max(0, 1 - this.pointerLength() / lastLength) : 0, x, y, controlX, controlY, ex, ey);
            dx = ex - previous.x;
            dy = ey - previous.y;
        }
        // repeated endpoints give a zero tangent, so walk towards the other end
        // of the line until a distinct point is found
        for(let i = atBeginning ? 0 : tp.length - 2; !dx && !dy && i >= 0 && i < tp.length; i += atBeginning ? 2 : -2){
            dx = ex - tp[i];
            dy = ey - tp[i + 1];
        }
        const turn = Math.PI * 2;
        return (Math.atan2(dy, dx) + turn) % turn;
    }
    __fillStroke(ctx) {
        // here is a tricky part
        // we need to disable dash for arrow pointers
        const isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            // manually disable dash for head
            // it is better not to use setter here,
            // because it will trigger attr change event
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        // restore old value
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const points = this.points();
        if (points.length < 4) return lineRect;
        let minX = lineRect.x, minY = lineRect.y;
        let maxX = minX + lineRect.width, maxY = minY + lineRect.height;
        for (const beginning of [
            false,
            true
        ]){
            if (!(beginning ? this.pointerAtBeginning() : this.pointerAtEnding())) continue;
            const index = beginning ? 0 : points.length - 2;
            const angle = this._getPointerAngle(beginning);
            const cos = Math.cos(angle), sin = Math.sin(angle);
            const x = points[index] - this.pointerLength() * cos;
            const y = points[index + 1] - this.pointerLength() * sin;
            const dx = Math.abs(this.pointerWidth() * sin / 2);
            const dy = Math.abs(this.pointerWidth() * cos / 2);
            minX = Math.min(minX, x - dx);
            minY = Math.min(minY, y - dy);
            maxX = Math.max(maxX, x + dx);
            maxY = Math.max(maxY, y + dy);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$ed4c5015d754ac7a$export$21b07c8f274aebd5.prototype.className = 'Arrow';
$ed4c5015d754ac7a$export$21b07c8f274aebd5.prototype._attrsAffectingSize = [
    ...(0, $5329876ec3db1142$export$17d680238e50603e).prototype._attrsAffectingSize,
    'pointerLength',
    'pointerWidth',
    'pointerAtBeginning',
    'pointerAtEnding'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($ed4c5015d754ac7a$export$21b07c8f274aebd5, true);
/**
 * get/set pointerLength
 * @name Konva.Arrow#pointerLength
 * @method
 * @param {Number} Length of pointer of arrow. The default is 10.
 * @returns {Number}
 * @example
 * // get length
 * var pointerLength = line.pointerLength();
 *
 * // set length
 * line.pointerLength(15);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerLength', 10, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set pointerWidth
 * @name Konva.Arrow#pointerWidth
 * @method
 * @param {Number} Width of pointer of arrow.
 *   The default is 10.
 * @returns {Number}
 * @example
 * // get width
 * var pointerWidth = line.pointerWidth();
 *
 * // set width
 * line.pointerWidth(15);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerWidth', 10, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set pointerAtBeginning
 * @name Konva.Arrow#pointerAtBeginning
 * @method
 * @param {Boolean} pointerAtBeginning Whether to draw a pointer at the beginning of the arrow. The default is false.
 * @returns {Boolean}
 * @example
 * // get value
 * var pointerAtBeginning = line.pointerAtBeginning();
 *
 * // set value
 * line.pointerAtBeginning(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerAtBeginning', false);
/**
 * get/set pointerAtEnding
 * @name Konva.Arrow#pointerAtEnding
 * @method
 * @param {Boolean} pointerAtEnding Whether to draw a pointer at the end of the arrow. The default is true.
 * @returns {Boolean}
 * @example
 * // get value
 * var pointerAtEnding = line.pointerAtEnding();
 *
 * // set value
 * line.pointerAtEnding(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($ed4c5015d754ac7a$export$21b07c8f274aebd5, 'pointerAtEnding', true);






class $cfc8e10222484598$export$c89a927ffc67e6fa extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _getStrokePadding() {
        return super._getStrokePadding(1);
    }
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, Math.abs(this.attrs.radius || 0), 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return Math.abs(this.radius()) * 2;
    }
    getHeight() {
        return Math.abs(this.radius()) * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$cfc8e10222484598$export$c89a927ffc67e6fa.prototype._centroid = true;
$cfc8e10222484598$export$c89a927ffc67e6fa.prototype.className = 'Circle';
$cfc8e10222484598$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    'radius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($cfc8e10222484598$export$c89a927ffc67e6fa, true);
/**
 * get/set radius
 * @name Konva.Circle#radius
 * @method
 * @param {Number} radius
 * @returns {Number}
 * @example
 * // get radius
 * var radius = circle.radius();
 *
 * // set radius
 * circle.radius(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($cfc8e10222484598$export$c89a927ffc67e6fa, 'radius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());






class $a1df33efdd3b5d94$export$80b0269ab108fa11 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _getStrokePadding() {
        return super._getStrokePadding(1);
    }
    _sceneFunc(context) {
        const rx = Math.abs(this.radiusX()), ry = Math.abs(this.radiusY());
        context.beginPath();
        context.ellipse(0, 0, rx, ry, 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return Math.abs(this.radiusX()) * 2;
    }
    getHeight() {
        return Math.abs(this.radiusY()) * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$a1df33efdd3b5d94$export$80b0269ab108fa11.prototype.className = 'Ellipse';
$a1df33efdd3b5d94$export$80b0269ab108fa11.prototype._centroid = true;
$a1df33efdd3b5d94$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    'radiusX',
    'radiusY'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($a1df33efdd3b5d94$export$80b0269ab108fa11, true);
// add getters setters
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($a1df33efdd3b5d94$export$80b0269ab108fa11, 'radius', [
    'x',
    'y'
]);
/**
 * get/set radius
 * @name Konva.Ellipse#radius
 * @method
 * @param {Object} radius
 * @param {Number} radius.x
 * @param {Number} radius.y
 * @returns {Object}
 * @example
 * // get radius
 * var radius = ellipse.radius();
 *
 * // set radius
 * ellipse.radius({
 *   x: 200,
 *   y: 100
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a1df33efdd3b5d94$export$80b0269ab108fa11, 'radiusX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set radius x
 * @name Konva.Ellipse#radiusX
 * @method
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get radius x
 * var radiusX = ellipse.radiusX();
 *
 * // set radius x
 * ellipse.radiusX(200);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a1df33efdd3b5d94$export$80b0269ab108fa11, 'radiusY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)()); /**
 * get/set radius y
 * @name Konva.Ellipse#radiusY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get radius y
 * var radiusY = ellipse.radiusY();
 *
 * // set radius y
 * ellipse.radiusY(200);
 */ 







class $f0156a163f3b5062$export$3e431a229df88919 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(attrs){
        super(attrs);
        this._loadListener = ()=>{
            this._requestDraw();
        };
        this.on('imageChange.konva', (props)=>{
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        var _a;
        const image = this.image();
        // A fresh `new Image()` with no src already reports complete === true,
        // so it still needs the listener.
        if ((image === null || image === void 0 ? void 0 : image.complete) && image.src || (image === null || image === void 0 ? void 0 : image.readyState) >= 2) return;
        (_a = image === null || image === void 0 ? void 0 : image.addEventListener) === null || _a === void 0 || _a.call(image, 'videoWidth' in image ? 'loadeddata' : 'load', this._loadListener);
    }
    _removeImageLoad(image) {
        var _a;
        (_a = image === null || image === void 0 ? void 0 : image.removeEventListener) === null || _a === void 0 || _a.call(image, 'videoWidth' in image ? 'loadeddata' : 'load', this._loadListener);
    }
    destroy() {
        this._removeImageLoad(this.image());
        super.destroy();
        return this;
    }
    _useBufferCanvas(forceFill, opacity = this.getAbsoluteOpacity()) {
        if (this.attrs.perfectDrawEnabled === false) return false;
        const hasCornerRadius = !!this.cornerRadius();
        const hasShadow = this.hasShadow();
        if (hasCornerRadius && hasShadow) return true;
        return super._useBufferCanvas(true, opacity);
    }
    _getStrokePadding() {
        return super._getStrokePadding(this.strokeScaleEnabled() ? 1 : undefined);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) context.drawImage(image, this.cropX(), this.cropY(), cropWidth, cropHeight, 0, 0, width, height);
            else context.drawImage(image, 0, 0, width, height);
        }
    // If you need to draw later, you need to execute save/restore
    }
    _hitFunc(context) {
        const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b, _c;
        const image = this.image();
        return (_c = (_b = (_a = this.attrs.width) !== null && _a !== void 0 ? _a : image === null || image === void 0 ? void 0 : image.videoWidth) !== null && _b !== void 0 ? _b : image === null || image === void 0 ? void 0 : image.width) !== null && _c !== void 0 ? _c : 0;
    }
    getHeight() {
        var _a, _b, _c;
        const image = this.image();
        return (_c = (_b = (_a = this.attrs.height) !== null && _a !== void 0 ? _a : image === null || image === void 0 ? void 0 : image.videoHeight) !== null && _b !== void 0 ? _b : image === null || image === void 0 ? void 0 : image.height) !== null && _c !== void 0 ? _c : 0;
    }
    /**
     * load image from given url and create `Konva.Image` instance
     * @method
     * @memberof Konva.Image
     * @param {String} url image source
     * @param {Function} callback with Konva.Image instance as first argument
     * @param {Function} onError optional error handler
     * @example
     *  Konva.Image.fromURL(imageURL, function(image){
     *    // image is Konva.Image instance
     *    layer.add(image);
     *  });
     */ static fromURL(url, callback, onError = null) {
        const img = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = ()=>{
            img.onload = img.onerror = null;
            callback(new $f0156a163f3b5062$export$3e431a229df88919({
                image: img
            }));
        };
        img.onerror = onError;
        img.crossOrigin = 'Anonymous';
        img.src = url;
    }
}
$f0156a163f3b5062$export$3e431a229df88919.prototype.className = 'Image';
$f0156a163f3b5062$export$3e431a229df88919.prototype._attrsAffectingSize = [
    'image'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($f0156a163f3b5062$export$3e431a229df88919, true);
/**
 * get/set corner radius
 * @method
 * @name Konva.Image#cornerRadius
 * @param {Number} cornerRadius
 * @returns {Number}
 * @example
 * // get corner radius
 * var cornerRadius = image.cornerRadius();
 *
 * // set corner radius
 * image.cornerRadius(10);
 *
 * // set different corner radius values
 * // top-left, top-right, bottom-right, bottom-left
 * image.cornerRadius([0, 10, 20, 30]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));
/**
 * get/set image source. It can be image, canvas or video element
 * @name Konva.Image#image
 * @method
 * @param {Object} image source
 * @returns {Object}
 * @example
 * // get value
 * var image = shape.image();
 *
 * // set value
 * shape.image(img);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'image');
(0, $abe0ad8331aee635$export$8354032f3852ec50).addComponentsGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'crop', [
    'x',
    'y',
    'width',
    'height'
]);
/**
 * get/set crop
 * @method
 * @name Konva.Image#crop
 * @param {Object} crop
 * @param {Number} crop.x
 * @param {Number} crop.y
 * @param {Number} crop.width
 * @param {Number} crop.height
 * @returns {Object}
 * @example
 * // get crop
 * var crop = image.crop();
 *
 * // set crop
 * image.crop({
 *   x: 20,
 *   y: 20,
 *   width: 20,
 *   height: 20
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropX', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set crop x
 * @method
 * @name Konva.Image#cropX
 * @param {Number} x
 * @returns {Number}
 * @example
 * // get crop x
 * var cropX = image.cropX();
 *
 * // set crop x
 * image.cropX(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropY', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set crop y
 * @name Konva.Image#cropY
 * @method
 * @param {Number} y
 * @returns {Number}
 * @example
 * // get crop y
 * var cropY = image.cropY();
 *
 * // set crop y
 * image.cropY(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropWidth', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set crop width
 * @name Konva.Image#cropWidth
 * @method
 * @param {Number} width
 * @returns {Number}
 * @example
 * // get crop width
 * var cropWidth = image.cropWidth();
 *
 * // set crop width
 * image.cropWidth(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f0156a163f3b5062$export$3e431a229df88919, 'cropHeight', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)()); /**
 * get/set crop height
 * @name Konva.Image#cropHeight
 * @method
 * @param {Number} height
 * @returns {Number}
 * @example
 * // get crop height
 * var cropHeight = image.cropHeight();
 *
 * // set crop height
 * image.cropHeight(20);
 */ 













// grapheme segmentation: one entry per user-perceived character, so flags,
// ZWJ emoji sequences and combining marks stay together
const $8540f0f5ac9d4ade$var$segmenter = typeof Intl !== 'undefined' && Intl.Segmenter ? new Intl.Segmenter(undefined, {
    granularity: 'grapheme'
}) : null;
function $8540f0f5ac9d4ade$export$5f8bdcd5b08f26b8(fontSize) {
    return fontSize / 15;
}
function $8540f0f5ac9d4ade$export$b9ca061da17f2d30(string) {
    if (!$8540f0f5ac9d4ade$var$segmenter) // no Intl.Segmenter (Firefox < 125): flags, then a code point with its
    // combining marks, skin tone modifiers, variation selectors and ZWJ joins
    return string.match(/\p{RI}\p{RI}|\P{M}(?:\p{M}|\p{Emoji_Modifier}|\uFE0F|\u200D\P{M})*|\p{M}+/gu) || [];
    return Array.from($8540f0f5ac9d4ade$var$segmenter.segment(string), (s)=>s.segment);
}
// constants
const $8540f0f5ac9d4ade$var$AUTO = 'auto', //CANVAS = 'canvas',
$8540f0f5ac9d4ade$var$CENTER = 'center', $8540f0f5ac9d4ade$var$INHERIT = 'inherit', $8540f0f5ac9d4ade$var$JUSTIFY = 'justify', $8540f0f5ac9d4ade$var$CHANGE_KONVA = 'Change.konva', $8540f0f5ac9d4ade$var$CONTEXT_2D = '2d', $8540f0f5ac9d4ade$var$DASH = '-', $8540f0f5ac9d4ade$var$LEFT = 'left', $8540f0f5ac9d4ade$var$TEXT = 'text', $8540f0f5ac9d4ade$var$TEXT_UPPER = 'Text', $8540f0f5ac9d4ade$var$TOP = 'top', $8540f0f5ac9d4ade$var$BOTTOM = 'bottom', $8540f0f5ac9d4ade$var$MIDDLE = 'middle', $8540f0f5ac9d4ade$var$NORMAL = 'normal', $8540f0f5ac9d4ade$var$PX_SPACE = 'px ', $8540f0f5ac9d4ade$var$SPACE = ' ', $8540f0f5ac9d4ade$var$RIGHT = 'right', $8540f0f5ac9d4ade$var$RTL = 'rtl', $8540f0f5ac9d4ade$var$WORD = 'word', $8540f0f5ac9d4ade$var$CHAR = 'char', $8540f0f5ac9d4ade$var$NONE = 'none', $8540f0f5ac9d4ade$var$ELLIPSIS = "\u2026", $8540f0f5ac9d4ade$var$ATTR_CHANGE_LIST = [
    'direction',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing'
];
// Safari on macOS renders text shadow even when globalAlpha is 0.
// This feature check detects that bug so we can work around it with a buffer canvas.
// Not covered by automated tests (our CI doesn't run Safari).
// Once Safari fixes the issue this check can be removed.
let $8540f0f5ac9d4ade$var$_shadowOpacityBuggy = null;
function $8540f0f5ac9d4ade$var$hasShadowOpacityBug() {
    if ($8540f0f5ac9d4ade$var$_shadowOpacityBuggy !== null) return $8540f0f5ac9d4ade$var$_shadowOpacityBuggy;
    $8540f0f5ac9d4ade$var$_shadowOpacityBuggy = false;
    let c;
    try {
        c = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement();
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext($8540f0f5ac9d4ade$var$CONTEXT_2D);
        if (ctx) {
            ctx.globalAlpha = 0;
            ctx.shadowColor = 'black';
            ctx.shadowBlur = 5;
            ctx.shadowOffsetX = 5;
            ctx.shadowOffsetY = 5;
            ctx.fillStyle = 'black';
            ctx.font = '10px Arial';
            ctx.fillText('X', 0, 10);
            const data = ctx.getImageData(0, 0, 10, 10).data;
            for(let i = 3; i < data.length; i += 4)if (data[i] > 0) {
                $8540f0f5ac9d4ade$var$_shadowOpacityBuggy = true;
                break;
            }
        }
    } catch (e) {
    // no-op (SSR or restricted canvas)
    } finally{
        if (c) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).releaseCanvas(c);
    }
    return $8540f0f5ac9d4ade$var$_shadowOpacityBuggy;
}
function $8540f0f5ac9d4ade$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(',').map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(' ') >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(', ');
}
let $8540f0f5ac9d4ade$var$dummyContext;
function $8540f0f5ac9d4ade$export$e90f9594621df1ac() {
    if ($8540f0f5ac9d4ade$var$dummyContext) return $8540f0f5ac9d4ade$var$dummyContext;
    $8540f0f5ac9d4ade$var$dummyContext = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).createCanvasElement().getContext($8540f0f5ac9d4ade$var$CONTEXT_2D);
    return $8540f0f5ac9d4ade$var$dummyContext;
}
function $8540f0f5ac9d4ade$var$_fillFunc(context) {
    // re-apply a per-character style set by charRenderFunc (see _sceneFunc)
    if (this._partialFillStyle) context.setAttr('fillStyle', this._partialFillStyle);
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $8540f0f5ac9d4ade$var$_strokeFunc(context) {
    context.setAttr('miterLimit', 2);
    if (this._partialStrokeStyle) context.setAttr('strokeStyle', this._partialStrokeStyle);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $8540f0f5ac9d4ade$var$checkDefaultFill(config) {
    config = config || {};
    // set default color to black, without mutating the caller's config
    const hasFill = config.fill || config.fillLinearGradientColorStops || config.fillRadialGradientColorStops || config.fillPatternImage;
    return hasFill ? config : {
        ...config,
        fill: 'black'
    };
}
class $8540f0f5ac9d4ade$export$5f1af8db9871e1d6 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super($8540f0f5ac9d4ade$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        // distance from the line box center to the baseline, see _setTextData
        this._baselineShift = 0;
        this._setTextData();
    }
    _sceneFunc(context) {
        var _a, _b;
        const textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, direction = this.direction(), align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), charRenderFunc = this.charRenderFunc(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        let translateY = lineHeightPx / 2;
        let baseline = $8540f0f5ac9d4ade$var$MIDDLE;
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering) {
            const metrics = this.measureSize('M'); // Use a sample character to get the ascent
            baseline = 'alphabetic';
            const ascent = (_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.actualBoundingBoxAscent;
            const descent = (_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.actualBoundingBoxDescent;
            translateY = (ascent - descent) / 2 + lineHeightPx / 2;
        }
        if (direction !== $8540f0f5ac9d4ade$var$INHERIT) context.setAttr('direction', direction);
        else // 'inherit' resolves to the direction the canvas already has, so that
        // an inherited rtl still takes the single native run below
        direction = context.direction;
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', baseline);
        context.setAttr('textAlign', $8540f0f5ac9d4ade$var$LEFT);
        context.translate(padding, this._getTextTop());
        // Start the callback with the same fill that normal drawing would use.
        // Assigning that color again then needs no override, including black.
        if (charRenderFunc) {
            const style = context._getFillStyle(this);
            if (style !== undefined) context.fillStyle = style;
            if (this.hasStroke()) context._applyStrokeStyle(this);
        }
        // context styles entering the loop, used to detect styles set by
        // charRenderFunc; every character is drawn inside save()/restore(),
        // so the entry state is the same for each one
        const fillStyleBefore = charRenderFunc ? context.fillStyle : undefined;
        const strokeStyleBefore = charRenderFunc ? context.strokeStyle : undefined;
        // global grapheme index passed to charRenderFunc, runs across lines
        let charIndex = 0;
        // draw text lines
        for(n = 0; n < textArrLen; n++){
            let lineTranslateX = 0;
            let lineTranslateY = 0;
            const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
            // horizontal alignment
            context.save();
            if (align === $8540f0f5ac9d4ade$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $8540f0f5ac9d4ade$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                const yOffset = this._getUnderlineOffset();
                const x = lineTranslateX;
                const y = translateY + lineTranslateY + yOffset;
                context.moveTo(x, y);
                const lineWidth = align === $8540f0f5ac9d4ade$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), y);
                context.lineWidth = $8540f0f5ac9d4ade$export$5f8bdcd5b08f26b8(fontSize);
                if (context._applyDecorationStyle(this)) context.stroke();
                context.restore();
            }
            // store the starting x position for line-through which is drawn after text
            const lineThroughStartX = lineTranslateX;
            // Render graphemes separately for spacing, justification and callbacks.
            // Keep RTL text in one native run to preserve shaping.
            if (direction !== $8540f0f5ac9d4ade$var$RTL && (letterSpacing !== 0 || align === $8540f0f5ac9d4ade$var$JUSTIFY || charRenderFunc)) {
                const spacesNumber = text.split(' ').length - 1;
                const array = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(text);
                for(let li = 0; li < array.length; li++){
                    const letter = array[li];
                    // skip justify for the last line
                    if (letter === ' ' && !lastLine && align === $8540f0f5ac9d4ade$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    // the font of the shape is already set on the context
                    const letterWidth = context.measureText(letter).width;
                    if (charRenderFunc) {
                        context.save();
                        charRenderFunc({
                            char: letter,
                            index: charIndex,
                            x: lineTranslateX,
                            y: translateY + lineTranslateY,
                            lineIndex: n,
                            column: li,
                            isLastInLine: li === array.length - 1,
                            width: letterWidth,
                            context: context
                        });
                        // a style the callback set on the context wins for this character;
                        // fillStrokeShape() overwrites the context styles from the shape
                        // attributes, so stash them for _fillFunc/_strokeFunc to re-apply
                        const fillStyleAfter = context.fillStyle;
                        if (fillStyleAfter !== fillStyleBefore) this._partialFillStyle = fillStyleAfter;
                        const strokeStyleAfter = context.strokeStyle;
                        if (strokeStyleAfter !== strokeStyleBefore) this._partialStrokeStyle = strokeStyleAfter;
                    }
                    context.fillStrokeShape(this);
                    if (charRenderFunc) {
                        this._partialFillStyle = undefined;
                        this._partialStrokeStyle = undefined;
                        context.restore();
                    }
                    lineTranslateX += letterWidth + letterSpacing;
                    charIndex++;
                }
            } else {
                if (letterSpacing !== 0) context.setAttr('letterSpacing', `${letterSpacing}px`);
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            // draw line-through above the text content
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                const yOffset = !(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering ? -Math.round(fontSize / 4) : 0;
                const x = lineThroughStartX;
                context.moveTo(x, translateY + lineTranslateY + yOffset);
                const lineWidth = align === $8540f0f5ac9d4ade$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
                context.lineWidth = $8540f0f5ac9d4ade$export$5f8bdcd5b08f26b8(fontSize);
                if (context._applyDecorationStyle(this)) context.stroke();
                context.restore();
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _getTextTop() {
        const padding = this.padding(), free = this.getHeight() - this.textArr.length * this.lineHeight() * this.fontSize() - padding * 2, verticalAlign = this.verticalAlign();
        if (verticalAlign === $8540f0f5ac9d4ade$var$MIDDLE) return padding + free / 2;
        if (verticalAlign === $8540f0f5ac9d4ade$var$BOTTOM) return padding + free;
        return padding;
    }
    _getUnderlineOffset() {
        var _a;
        return (_a = this.underlineOffset()) !== null && _a !== void 0 ? _a : Math.round(this.fontSize() / (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering ? 4 : 2));
    }
    getSelfRect() {
        const rect = super.getSelfRect();
        const lines = this.textArr.length;
        if (!lines || this.textDecoration().indexOf('underline') === -1) return rect;
        // the underline of the last line is drawn below the text block
        const fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize;
        let bottom = this._getTextTop() + lines * lineHeightPx - lineHeightPx / 2;
        if (!(0, $8c8384c27430fce8$export$b9f99057a3c7692).legacyTextRendering) bottom += this._baselineShift;
        bottom += this._getUnderlineOffset() + $8540f0f5ac9d4ade$export$5f8bdcd5b08f26b8(fontSize) / 2;
        rect.height = Math.max(rect.y + rect.height, bottom) - rect.y;
        return rect;
    }
    _getSelfRectForDrawing() {
        // Lines can be wider than the box, negative spacing moves the pen back,
        // and glyph ink passes the advance box (italics, accents): up to 0.6em
        // in common fonts, so pad by 1em.
        const rect = this.getSelfRect(), fontSize = this.fontSize(), padding = this.padding(), lineHeightPx = this.lineHeight() * fontSize, available = this.getWidth() - padding * 2, align = this.align(), blockHeight = this.textArr.length * lineHeightPx, top = this._getTextTop();
        let left = rect.x, right = rect.x + rect.width;
        for (const { text: text, width: width } of this.textArr){
            const x = padding + (align === $8540f0f5ac9d4ade$var$RIGHT ? available - width : align === $8540f0f5ac9d4ade$var$CENTER ? (available - width) / 2 : 0);
            const back = Math.min(0, this.letterSpacing()) * text.length;
            left = Math.min(left, x + back);
            right = Math.max(right, x + width - back);
        }
        const underline = this.textDecoration().includes('underline');
        const y = Math.min(rect.y, top + (underline ? Math.min(0, this._getUnderlineOffset()) : 0));
        return {
            x: left - fontSize,
            y: y - fontSize,
            width: right - left + fontSize * 2,
            height: Math.max(rect.y + rect.height, top + blockHeight) - y + fontSize * 2
        };
    }
    _hitFunc(context) {
        const width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        const str = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? '' : text + '';
        this._setAttr($8540f0f5ac9d4ade$var$TEXT, str);
        return this;
    }
    getWidth() {
        const isAuto = this.attrs.width === $8540f0f5ac9d4ade$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        const isAuto = this.attrs.height === $8540f0f5ac9d4ade$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    /**
     * get pure text width without padding
     * @method
     * @name Konva.Text#getTextWidth
     * @returns {Number}
     */ getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    /**
     * measure string with the font of current text shape.
     * That method can't handle multiline text.
     * @method
     * @name Konva.Text#measureSize
     * @param {String} text text to measure
     * @returns {Object} { width , height } of measured text
     */ measureSize(text) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let _context = $8540f0f5ac9d4ade$export$e90f9594621df1ac(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        // Scale the fallback values based on the provided fontSize compared to the sample size (100 in your new case)
        const scaleFactor = fontSize / 100;
        // Note, fallback values are from chrome browser with 100px font size and font-family "Arial"
        return {
            actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
            actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
            actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
            actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
            alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
            emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
            emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
            fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
            fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
            hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
            ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $8540f0f5ac9d4ade$var$SPACE + this.fontVariant() + $8540f0f5ac9d4ade$var$SPACE + (this.fontSize() + $8540f0f5ac9d4ade$var$PX_SPACE) + // wrap font family into " so font families with spaces works ok
        $8540f0f5ac9d4ade$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $8540f0f5ac9d4ade$var$JUSTIFY) line = line.trim();
        const width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text, graphemes) {
        const letterSpacing = this.letterSpacing();
        // one spacing per grapheme, as the per-character rendering draws them
        const spacing = letterSpacing ? letterSpacing * (graphemes !== null && graphemes !== void 0 ? graphemes : $8540f0f5ac9d4ade$export$b9ca061da17f2d30(text).length) : 0;
        return $8540f0f5ac9d4ade$export$e90f9594621df1ac().measureText(text).width + spacing;
    }
    _setTextData() {
        let lines = this.text().split('\n'), fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $8540f0f5ac9d4ade$var$AUTO && width !== undefined, fixedHeight = height !== $8540f0f5ac9d4ade$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), // align = this.align(),
        shouldWrap = wrap !== $8540f0f5ac9d4ade$var$NONE, wrapAtWord = wrap !== $8540f0f5ac9d4ade$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        // measured here so getSelfRect, which runs per drag frame, needs no
        // measureText of its own
        const sample = this.measureSize('M');
        this._baselineShift = (sample.fontBoundingBoxAscent - sample.fontBoundingBoxDescent) / 2;
        this.textArr = [];
        const dummyContext = $8540f0f5ac9d4ade$export$e90f9594621df1ac();
        dummyContext.font = this._getContextFont();
        // the per-character draw path (same condition as in _sceneFunc) advances
        // by unkerned glyph widths, so measure the line the same way
        dummyContext.fontKerning = this.direction() !== $8540f0f5ac9d4ade$var$RTL && (this.letterSpacing() !== 0 || this.align() === $8540f0f5ac9d4ade$var$JUSTIFY || !!this.charRenderFunc()) ? 'none' : 'auto';
        const additionalWidth = shouldAddEllipsis ? this._getTextWidth($8540f0f5ac9d4ade$var$ELLIPSIS) : 0;
        for(let i = 0, max = lines.length; i < max; ++i){
            let line = lines[i];
            let lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) {
                /*
                 * if width is fixed and line does not fit entirely
                 * break the line into multiple fitting lines
                 */ const graphemes = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(line);
                const length = graphemes.length;
                let start = 0;
                const text = (end)=>graphemes.slice(start, end).join('');
                const isBreak = (char)=>char === $8540f0f5ac9d4ade$var$SPACE || char === $8540f0f5ac9d4ade$var$DASH;
                // graphemes per line, estimated from the average grapheme width
                const perLine = Math.max(1, Math.ceil(length * maxWidth / lineWidth));
                while(start < length){
                    // only reserve the ellipsis width on a line that may be the last
                    // visible one
                    const extraWidth = shouldAddEllipsis && fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx ? additionalWidth : 0;
                    const fits = (end)=>{
                        const width = this._getTextWidth(text(end), end - start);
                        if (width + extraWidth > maxWidth) return false;
                        return true;
                    };
                    /*
                     * find the longest prefix that fits in the specified width:
                     * grow a window from the estimate until it stops fitting, then
                     * binary search inside it. Every probe measures about one line,
                     * not the whole remaining text, so wrapping stays linear
                     */ let low = start, high = Math.min(length, start + perLine);
                    while(fits(high)){
                        low = high;
                        if (high === length) break;
                        high = Math.min(length, high + (high - start));
                    }
                    while(high - low > 1){
                        const mid = low + high >>> 1;
                        if (fits(mid)) low = mid;
                        else high = mid;
                    }
                    if (low === start) break;
                    if (low === length) {
                        // the rest of the paragraph fits on one line: kept untrimmed and
                        // without the ellipsis check, like a paragraph that never wrapped
                        this._addTextLine(text(length));
                        currentHeightPx += lineHeightPx;
                        if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx && i < max - 1) this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    if (wrapAtWord && !isBreak(graphemes[low])) {
                        // wrap at the last space or dash of the line instead
                        let wrapIndex = low - 1;
                        while(wrapIndex >= start && !isBreak(graphemes[wrapIndex]))wrapIndex--;
                        if (wrapIndex >= start) low = wrapIndex + 1;
                    }
                    this._addTextLine(text(low).trimRight());
                    currentHeightPx += lineHeightPx;
                    if (this._shouldHandleEllipsis(currentHeightPx)) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    // the next line starts after the whitespace of the break
                    start = low;
                    while(start < length && !graphemes[start].trim())start++;
                }
            } else {
                // element width is automatically adjusted to max line width
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            // if element height is fixed, abort if adding one more line would overflow
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = this.textArr.reduce((width, line)=>Math.max(width, line.width), 0);
    }
    /**
     * whether to handle ellipsis, there are two cases:
     * 1. the current line is the last line
     * 2. wrap is NONE
     * @param {Number} currentHeightPx
     * @returns {Boolean}
     */ _shouldHandleEllipsis(currentHeightPx) {
        const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $8540f0f5ac9d4ade$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $8540f0f5ac9d4ade$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        const width = this.attrs.width, fixedWidth = width !== $8540f0f5ac9d4ade$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        const lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        let text = lastLine.text + $8540f0f5ac9d4ade$var$ELLIPSIS;
        if (fixedWidth) {
            const graphemes = $8540f0f5ac9d4ade$export$b9ca061da17f2d30(lastLine.text);
            while(graphemes.length && this._getTextWidth(text) > maxWidth){
                graphemes.pop();
                text = graphemes.join('') + $8540f0f5ac9d4ade$var$ELLIPSIS;
            }
            if (this._getTextWidth(text) > maxWidth) text = '';
        }
        lastLine.text = text;
        lastLine.width = this._getTextWidth(text);
    }
    // for text we can't disable stroke scaling
    // if we do, the result will be unexpected
    getStrokeScaleEnabled() {
        return true;
    }
    _getStrokePadding() {
        // _strokeFunc uses a miter limit of two for glyph outlines.
        return super._getStrokePadding(2);
    }
    _useBufferCanvas(forceFill, opacity = this.getAbsoluteOpacity()) {
        if (this.attrs.perfectDrawEnabled === false) return false;
        const hasLine = this.textDecoration().indexOf('underline') !== -1 || this.textDecoration().indexOf('line-through') !== -1;
        const hasShadow = this.hasShadow();
        if (hasLine && hasShadow) return true;
        if (hasShadow && opacity !== 1 && $8540f0f5ac9d4ade$var$hasShadowOpacityBug()) return true;
        return super._useBufferCanvas(forceFill, opacity);
    }
}
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype._fillFunc = $8540f0f5ac9d4ade$var$_fillFunc;
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype._strokeFunc = $8540f0f5ac9d4ade$var$_strokeFunc;
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype.className = $8540f0f5ac9d4ade$var$TEXT_UPPER;
// the decoration attrs are not in ATTR_CHANGE_LIST: they change the bounds
// through getSelfRect, but need no relayout
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = $8540f0f5ac9d4ade$var$ATTR_CHANGE_LIST.filter((attr)=>attr !== 'width' && attr !== 'height').concat([
    'textDecoration',
    'underlineOffset'
]);
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, true);
// update text data for certain attr changes
$8540f0f5ac9d4ade$export$5f1af8db9871e1d6.prototype.on($8540f0f5ac9d4ade$var$ATTR_CHANGE_LIST.map((attr)=>attr + $8540f0f5ac9d4ade$var$CHANGE_KONVA).join(' '), function() {
    this._setTextData();
});
/**
 * get/set width of text area, which includes padding.
 * @name Konva.Text#width
 * @method
 * @param {Number} width
 * @returns {Number}
 * @example
 * // get width
 * var width = text.width();
 *
 * // set width
 * text.width(20);
 *
 * // set to auto
 * text.width('auto');
 * text.width() // will return calculated width, and not "auto"
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).overWriteSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'width', (0, $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404)());
/**
 * get/set the height of the text area, which takes into account multi-line text, line heights, and padding.
 * @name Konva.Text#height
 * @method
 * @param {Number} height
 * @returns {Number}
 * @example
 * // get height
 * var height = text.height();
 *
 * // set height
 * text.height(20);
 *
 * // set to auto
 * text.height('auto');
 * text.height() // will return calculated height, and not "auto"
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).overWriteSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'height', (0, $d7c0e5ae0fe3f9a6$export$3b7df2720ef33404)());
/**
 * get/set direction
 * @name Konva.Text#direction
 * @method
 * @param {String} direction
 * @returns {String}
 * @example
 * // get direction
 * var direction = text.direction();
 *
 * // set direction
 * text.direction('rtl');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'direction', $8540f0f5ac9d4ade$var$INHERIT);
/**
 * get/set font family
 * @name Konva.Text#fontFamily
 * @method
 * @param {String} fontFamily
 * @returns {String}
 * @example
 * // get font family
 * var fontFamily = text.fontFamily();
 *
 * // set font family
 * text.fontFamily('Arial');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontFamily', 'Arial');
/**
 * get/set font size in pixels
 * @name Konva.Text#fontSize
 * @method
 * @param {Number} fontSize
 * @returns {Number}
 * @example
 * // get font size
 * var fontSize = text.fontSize();
 *
 * // set font size to 22px
 * text.fontSize(22);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontSize', 12, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set font style.  Can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
 * @name Konva.Text#fontStyle
 * @method
 * @param {String} fontStyle
 * @returns {String}
 * @example
 * // get font style
 * var fontStyle = text.fontStyle();
 *
 * // set font style
 * text.fontStyle('bold');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontStyle', $8540f0f5ac9d4ade$var$NORMAL);
/**
 * get/set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
 * @name Konva.Text#fontVariant
 * @method
 * @param {String} fontVariant
 * @returns {String}
 * @example
 * // get font variant
 * var fontVariant = text.fontVariant();
 *
 * // set font variant
 * text.fontVariant('small-caps');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'fontVariant', $8540f0f5ac9d4ade$var$NORMAL);
/**
 * get/set padding
 * @name Konva.Text#padding
 * @method
 * @param {Number} padding
 * @returns {Number}
 * @example
 * // get padding
 * var padding = text.padding();
 *
 * // set padding to 10 pixels
 * text.padding(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'padding', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
 * @name Konva.Text#align
 * @method
 * @param {String} align
 * @returns {String}
 * @example
 * // get text align
 * var align = text.align();
 *
 * // center text
 * text.align('center');
 *
 * // align text to right
 * text.align('right');
 *
 * // justify text
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'align', $8540f0f5ac9d4ade$var$LEFT);
/**
 * get/set vertical align of text.  Can be 'top', 'middle', 'bottom'.
 * @name Konva.Text#verticalAlign
 * @method
 * @param {String} verticalAlign
 * @returns {String}
 * @example
 * // get text vertical align
 * var verticalAlign = text.verticalAlign();
 *
 * // center text
 * text.verticalAlign('middle');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'verticalAlign', $8540f0f5ac9d4ade$var$TOP);
/**
 * get/set line height.  The default is 1.
 * @name Konva.Text#lineHeight
 * @method
 * @param {Number} lineHeight
 * @returns {Number}
 * @example
 * // get line height
 * var lineHeight = text.lineHeight();
 *
 * // set the line height
 * text.lineHeight(2);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'lineHeight', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set wrap.  Can be "word", "char", or "none". Default is "word".
 * In "word" wrapping any word still can be wrapped if it can't be placed in the required width
 * without breaks.
 * @name Konva.Text#wrap
 * @method
 * @param {String} wrap
 * @returns {String}
 * @example
 * // get wrap
 * var wrap = text.wrap();
 *
 * // set wrap
 * text.wrap('word');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'wrap', $8540f0f5ac9d4ade$var$WORD);
/**
 * get/set ellipsis. Can be true or false. Default is false. If ellipsis is true,
 * Konva cuts the text that does not fit and ends it with "…" (one character).
 * That needs a fixed height or wrap set to "none"
 * @name Konva.Text#ellipsis
 * @method
 * @param {Boolean} ellipsis
 * @returns {Boolean}
 * @example
 * // get ellipsis param, returns true or false
 * var ellipsis = text.ellipsis();
 *
 * // set ellipsis
 * text.ellipsis(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'ellipsis', false, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * set letter spacing property. Default value is 0.
 * @name Konva.Text#letterSpacing
 * @method
 * @param {Number} letterSpacing
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'letterSpacing', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set text
 * @name Konva.Text#text
 * @method
 * @param {String} text
 * @returns {String}
 * @example
 * // get text
 * var text = text.text();
 *
 * // set text
 * text.text('Hello world!');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'text', '', (0, $d7c0e5ae0fe3f9a6$export$5837c5b6cc5b4d63)());
/**
 * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
 * @name Konva.Text#textDecoration
 * @method
 * @param {String} textDecoration
 * @returns {String}
 * @example
 * // get text decoration
 * var textDecoration = text.textDecoration();
 *
 * // underline text
 * text.textDecoration('underline');
 *
 * // strike text
 * text.textDecoration('line-through');
 *
 * // underline and strike text
 * text.textDecoration('underline line-through');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'textDecoration', '');
/**
 * get/set text underline decoration offset. Offset for underline line. Default is calculated based on font size.
 * @name Konva.Text#underlineOffset
 * @method
 * @param {Number} underlineOffset
 * @returns {Number}
 * @example
 * // get underline offset
 * var underlineOffset = text.underlineOffset();
 *
 * // set underline offset
 * text.underlineOffset(5);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'underlineOffset', undefined, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set per-character render hook. The callback is invoked for each grapheme before drawing, except for RTL text.
 * It can mutate the provided context (e.g. translate, rotate, change styles) and should return void.
 * Note: per-character rendering may disable native kerning/ligatures.
 * @name Konva.Text#charRenderFunc
 * @method
 * @param {Function} charRenderFunc
 * @returns {Function}
 * @example
 * // apply small x-translation and a custom color to every second character
 * text.charRenderFunc(function(props) {
 *   if (props.index % 2 === 1) {
 *     props.context.translate(2, 0);
 *     props.context.fillStyle = 'red';
 *   }
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($8540f0f5ac9d4ade$export$5f1af8db9871e1d6, 'charRenderFunc', undefined);


// constants
const $68b4427dcf69bf6a$var$ATTR_CHANGE_LIST = [
    ...(0, $8540f0f5ac9d4ade$export$5f1af8db9871e1d6).prototype._attrsAffectingSize,
    'width',
    'height',
    'pointerDirection',
    'pointerWidth',
    'pointerHeight'
], $68b4427dcf69bf6a$var$CHANGE_EVENTS = $68b4427dcf69bf6a$var$ATTR_CHANGE_LIST.map((attr)=>attr + 'Change.konva').join(' '), $68b4427dcf69bf6a$var$NONE = 'none', $68b4427dcf69bf6a$var$UP = 'up', $68b4427dcf69bf6a$var$RIGHT = 'right', $68b4427dcf69bf6a$var$DOWN = 'down', $68b4427dcf69bf6a$var$LEFT = 'left';
class $68b4427dcf69bf6a$export$b04be29aa201d4f5 extends (0, $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this._sync = this._sync.bind(this);
        this.on('add.konva', function(evt) {
            // re-adding the same child must not stack another listener
            evt.child.off($68b4427dcf69bf6a$var$CHANGE_EVENTS, this._sync).on($68b4427dcf69bf6a$var$CHANGE_EVENTS, this._sync);
            this._sync();
        });
    }
    /**
     * get Text shape for the label.  You need to access the Text shape in order to update
     * the text properties
     * @name Konva.Label#getText
     * @method
     * @example
     * label.getText().fill('red')
     */ getText() {
        return this.find('Text')[0];
    }
    /**
     * get Tag shape for the label.  You need to access the Tag shape in order to update
     * the pointer properties and the corner radius
     * @name Konva.Label#getTag
     * @method
     */ getTag() {
        return this.find('Tag')[0];
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $68b4427dcf69bf6a$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $68b4427dcf69bf6a$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $68b4427dcf69bf6a$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $68b4427dcf69bf6a$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$68b4427dcf69bf6a$export$b04be29aa201d4f5.prototype.className = 'Label';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($68b4427dcf69bf6a$export$b04be29aa201d4f5);
class $68b4427dcf69bf6a$export$3288d34c523a1192 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        const [topLeft, topRight, bottomRight, bottomLeft] = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._cornerRadii(cornerRadius, width, height);
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $68b4427dcf69bf6a$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $68b4427dcf69bf6a$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $68b4427dcf69bf6a$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $68b4427dcf69bf6a$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        const pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        // The pointer base is centred on its side and can be longer than it.
        if (direction === $68b4427dcf69bf6a$var$UP || direction === $68b4427dcf69bf6a$var$DOWN) return {
            x: Math.min(0, (width - pointerWidth) / 2),
            y: direction === $68b4427dcf69bf6a$var$UP ? -pointerHeight : 0,
            width: Math.max(width, pointerWidth),
            height: height + pointerHeight
        };
        if (direction === $68b4427dcf69bf6a$var$LEFT || direction === $68b4427dcf69bf6a$var$RIGHT) return {
            x: direction === $68b4427dcf69bf6a$var$LEFT ? -pointerWidth : 0,
            y: Math.min(0, (height - pointerHeight) / 2),
            width: width + pointerWidth,
            height: Math.max(height, pointerHeight)
        };
        return {
            x: 0,
            y: 0,
            width: width,
            height: height
        };
    }
}
$68b4427dcf69bf6a$export$3288d34c523a1192.prototype.className = 'Tag';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($68b4427dcf69bf6a$export$3288d34c523a1192, true);
/**
 * get/set pointer direction
 * @name Konva.Tag#pointerDirection
 * @method
 * @param {String} pointerDirection can be up, right, down, left, or none.  The default is none.
 * @returns {String}
 * @example
 * tag.pointerDirection('right');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'pointerDirection', $68b4427dcf69bf6a$var$NONE);
/**
 * get/set pointer width
 * @name Konva.Tag#pointerWidth
 * @method
 * @param {Number} pointerWidth
 * @returns {Number}
 * @example
 * tag.pointerWidth(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'pointerWidth', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set pointer height
 * @method
 * @name Konva.Tag#pointerHeight
 * @param {Number} pointerHeight
 * @returns {Number}
 * @example
 * tag.pointerHeight(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'pointerHeight', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set cornerRadius
 * @name Konva.Tag#cornerRadius
 * @method
 * @param {Number} cornerRadius
 * @returns {Number}
 * @example
 * tag.cornerRadius(20);
 *
 * // set different corner radius values
 * // top-left, top-right, bottom-right, bottom-left
 * tag.cornerRadius([0, 10, 20, 30]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($68b4427dcf69bf6a$export$3288d34c523a1192, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));









class $f22346c22f20789a$export$c79fc6492f3af13d extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _getStrokePadding() {
        return super._getStrokePadding(this.strokeScaleEnabled() ? 1 : undefined);
    }
    _sceneFunc(context) {
        const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) // simple rect - don't bother doing all that complicated maths stuff.
        context.rect(0, 0, width, height);
        else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$f22346c22f20789a$export$c79fc6492f3af13d.prototype.className = 'Rect';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($f22346c22f20789a$export$c79fc6492f3af13d, true);
/**
 * get/set corner radius
 * @method
 * @name Konva.Rect#cornerRadius
 * @param {Number} cornerRadius
 * @returns {Number}
 * @example
 * // get corner radius
 * var cornerRadius = rect.cornerRadius();
 *
 * // set corner radius
 * rect.cornerRadius(10);
 *
 * // set different corner radius values
 * // top-left, top-right, bottom-right, bottom-left
 * rect.cornerRadius([0, 10, 20, 30]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($f22346c22f20789a$export$c79fc6492f3af13d, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));







class $a02eac566278789b$export$e2ee866164812ecd extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints(), radius = this.radius(), sides = this.sides(), cornerRadius = this.cornerRadius();
        if (!points.length) return;
        context.beginPath();
        if (!cornerRadius) {
            context.moveTo(points[0].x, points[0].y);
            for(let n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        } else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).drawRoundedPolygonPath(context, points, sides, radius, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(let n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        if (!points.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        let minX = points[0].x;
        let maxX = points[0].x;
        let minY = points[0].y;
        let maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$a02eac566278789b$export$e2ee866164812ecd.prototype.className = 'RegularPolygon';
$a02eac566278789b$export$e2ee866164812ecd.prototype._centroid = true;
$a02eac566278789b$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    'radius',
    'sides'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($a02eac566278789b$export$e2ee866164812ecd, true);
/**
 * get/set radius
 * @method
 * @name Konva.RegularPolygon#radius
 * @param {Number} radius
 * @returns {Number}
 * @example
 * // get radius
 * var radius = shape.radius();
 *
 * // set radius
 * shape.radius(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a02eac566278789b$export$e2ee866164812ecd, 'radius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set sides
 * @method
 * @name Konva.RegularPolygon#sides
 * @param {Number} sides
 * @returns {Number}
 * @example
 * // get sides
 * var sides = shape.sides();
 *
 * // set sides
 * shape.sides(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a02eac566278789b$export$e2ee866164812ecd, 'sides', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set corner radius
 * @method
 * @name Konva.RegularPolygon#cornerRadius
 * @param {Number} cornerRadius
 * @returns {Number}
 * @example
 * // get corner radius
 * var cornerRadius = poly.cornerRadius();
 *
 * // set corner radius
 * poly.cornerRadius(10);
 *
 * // set different corner radius values (pentagon)
 * poly.cornerRadius([0, 10, 20, 30, 40]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($a02eac566278789b$export$e2ee866164812ecd, 'cornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$7d4ab1842c1b264b)(4));






const $e1deb4ed1ad79a18$var$PIx2 = Math.PI * 2;
class $e1deb4ed1ad79a18$export$a6e3577650b6d6d7 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _getStrokePadding() {
        return super._getStrokePadding(1);
    }
    _sceneFunc(context) {
        const innerRadius = Math.abs(this.innerRadius()), outerRadius = Math.abs(this.outerRadius());
        context.beginPath();
        context.arc(0, 0, innerRadius, 0, $e1deb4ed1ad79a18$var$PIx2, false);
        context.moveTo(outerRadius, 0);
        context.arc(0, 0, outerRadius, $e1deb4ed1ad79a18$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        const radius = Math.max(Math.abs(this.innerRadius()), Math.abs(this.outerRadius()));
        return {
            x: -radius,
            y: -radius,
            width: radius * 2,
            height: radius * 2
        };
    }
    getWidth() {
        return Math.abs(this.outerRadius()) * 2;
    }
    getHeight() {
        return Math.abs(this.outerRadius()) * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$e1deb4ed1ad79a18$export$a6e3577650b6d6d7.prototype.className = 'Ring';
$e1deb4ed1ad79a18$export$a6e3577650b6d6d7.prototype._centroid = true;
$e1deb4ed1ad79a18$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($e1deb4ed1ad79a18$export$a6e3577650b6d6d7, true);
/**
 * get/set innerRadius
 * @method
 * @name Konva.Ring#innerRadius
 * @param {Number} innerRadius
 * @returns {Number}
 * @example
 * // get inner radius
 * var innerRadius = ring.innerRadius();
 *
 * // set inner radius
 * ring.innerRadius(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($e1deb4ed1ad79a18$export$a6e3577650b6d6d7, 'innerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set outerRadius
 * @name Konva.Ring#outerRadius
 * @method
 * @param {Number} outerRadius
 * @returns {Number}
 * @example
 * // get outer radius
 * var outerRadius = ring.outerRadius();
 *
 * // set outer radius
 * ring.outerRadius(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($e1deb4ed1ad79a18$export$a6e3577650b6d6d7, 'outerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());







class $5a6b0dd32a4eac33$export$3075603db8e6204c extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $e780181a0ef0b2c4$export$c35d437ae5945fcd)(()=>{
            // if we don't need to redraw layer we should return false
            const updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on('animationChange.konva', function() {
            // reset index when animation changes
            this.frameIndex(0);
        });
        this.on('frameIndexChange.konva', function() {
            this._updated = true;
        });
        // smooth change for frameRate
        this.on('frameRateChange.konva', function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    // the current frame: its box in the sprite sheet and where it is drawn,
    // or nothing when the animation key or the frame index does not exist
    // (then nothing is drawn, like an image without an image)
    _getFrame() {
        var _a, _b;
        const anim = this.animation(), set = (_a = this.animations()) === null || _a === void 0 ? void 0 : _a[anim], index = this.frameIndex(), ix4 = index * 4;
        if (!set || !Number.isInteger(index) || ix4 < 0 || ix4 + 4 > set.length) return;
        const offset = ((_b = this.frameOffsets()) === null || _b === void 0 ? void 0 : _b[anim]) || [];
        return {
            x: set[ix4],
            y: set[ix4 + 1],
            width: set[ix4 + 2],
            height: set[ix4 + 3],
            offsetX: offset[index * 2] || 0,
            offsetY: offset[index * 2 + 1] || 0
        };
    }
    _getStrokePadding() {
        return super._getStrokePadding(this.strokeScaleEnabled() ? 1 : undefined);
    }
    _sceneFunc(context) {
        const frame = this._getFrame();
        if (!frame) return;
        const { x: x, y: y, width: width, height: height, offsetX: offsetX, offsetY: offsetY } = frame;
        const image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(offsetX, offsetY, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) context.drawImage(image, x, y, width, height, offsetX, offsetY, width, height);
    }
    _hitFunc(context) {
        const { x: x, y: y, width: width, height: height } = this.getSelfRect();
        context.beginPath();
        context.rect(x, y, width, height);
        context.closePath();
        context.fillShape(this);
    }
    getSelfRect() {
        const frame = this._getFrame();
        return frame ? {
            x: frame.offsetX,
            y: frame.offsetY,
            width: frame.width,
            height: frame.height
        } : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    _useBufferCanvas(forceFill, opacity = this.getAbsoluteOpacity()) {
        return super._useBufferCanvas(true, opacity);
    }
    _setInterval() {
        const that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    /**
     * start sprite animation
     * @method
     * @name Konva.Sprite#start
     */ start() {
        if (this.isRunning()) return;
        const layer = this.getLayer();
        // The interval advances frames; the animation callback requests a redraw
        // only when a frame has changed.
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    /**
     * stop sprite animation
     * @method
     * @name Konva.Sprite#stop
     */ stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    destroy() {
        this.stop();
        return super.destroy();
    }
    /**
     * determine if animation of sprite is running or not.  returns true or false
     * @method
     * @name Konva.Sprite#isRunning
     * @returns {Boolean}
     */ isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        var _a;
        const index = this.frameIndex(), set = (_a = this.animations()) === null || _a === void 0 ? void 0 : _a[this.animation()], len = set ? set.length / 4 : 0;
        this.frameIndex(index < len - 1 ? index + 1 : 0);
    }
}
$5a6b0dd32a4eac33$export$3075603db8e6204c.prototype.className = 'Sprite';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($5a6b0dd32a4eac33$export$3075603db8e6204c, true);
// add getters setters
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'animation');
/**
 * get/set animation key
 * @name Konva.Sprite#animation
 * @method
 * @param {String} anim animation key
 * @returns {String}
 * @example
 * // get animation key
 * var animation = sprite.animation();
 *
 * // set animation key
 * sprite.animation('kicking');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'animations');
/**
 * get/set animations map
 * @name Konva.Sprite#animations
 * @method
 * @param {Object} animations
 * @returns {Object}
 * @example
 * // get animations map
 * var animations = sprite.animations();
 *
 * // set animations map
 * sprite.animations({
 *   standing: [
 *     // x, y, width, height (6 frames)
 *     0, 0, 49, 109,
 *     52, 0, 49, 109,
 *     105, 0, 49, 109,
 *     158, 0, 49, 109,
 *     210, 0, 49, 109,
 *     262, 0, 49, 109
 *   ],
 *   kicking: [
 *     // x, y, width, height (6 frames)
 *     0, 109, 45, 98,
 *     45, 109, 45, 98,
 *     95, 109, 63, 98,
 *     156, 109, 70, 98,
 *     229, 109, 60, 98,
 *     287, 109, 41, 98
 *   ]
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'frameOffsets');
/**
 * get/set frame offsets map
 * @name Konva.Sprite#frameOffsets
 * @method
 * @param {Object} frameOffsets
 * @returns {Object}
 * @example
 * // get frame offsets map
 * var offsets = sprite.frameOffsets();
 *
 * // set frame offsets map
 * sprite.frameOffsets({
 *   standing: [
 *     // x, y (6 frames)
 *     0, 0,
 *     0, 0,
 *     5, 0,
 *     0, 0,
 *     0, 3,
 *     2, 0
 *   ],
 *   kicking: [
 *     // x, y (6 frames)
 *     0, 5,
 *     5, 0,
 *     10, 0,
 *     0, 0,
 *     2, 1,
 *     0, 0
 *   ]
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'image');
/**
 * get/set image
 * @name Konva.Sprite#image
 * @method
 * @param {Image} image
 * @returns {Image}
 * @example
 * // get image
 * var image = sprite.image();
 *
 * // set image
 * sprite.image(imageObj);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'frameIndex', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * set/set animation frame index
 * @name Konva.Sprite#frameIndex
 * @method
 * @param {Integer} frameIndex
 * @returns {Integer}
 * @example
 * // get animation frame index
 * var frameIndex = sprite.frameIndex();
 *
 * // set animation frame index
 * sprite.frameIndex(3);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($5a6b0dd32a4eac33$export$3075603db8e6204c, 'frameRate', 17, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set frame rate in frames per second.  Increase this number to make the sprite
 *  animation run faster, and decrease the number to make the sprite animation run slower
 *  The default is 17 frames per second
 * @name Konva.Sprite#frameRate
 * @method
 * @param {Integer} frameRate
 * @returns {Integer}
 * @example
 * // get frame rate
 * var frameRate = sprite.frameRate();
 *
 * // set frame rate to 2 frames per second
 * sprite.frameRate(2);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($5a6b0dd32a4eac33$export$3075603db8e6204c, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex'
});






class $4d356f0361a4a7f0$export$1644ba17714857f1 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(let n = 1; n < numPoints * 2; n++){
            const radius = n % 2 === 0 ? outerRadius : innerRadius;
            const x = radius * Math.sin(n * Math.PI / numPoints);
            const y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        const radius = Math.max(Math.abs(this.innerRadius()), Math.abs(this.outerRadius()));
        return {
            x: -radius,
            y: -radius,
            width: radius * 2,
            height: radius * 2
        };
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$4d356f0361a4a7f0$export$1644ba17714857f1.prototype.className = 'Star';
$4d356f0361a4a7f0$export$1644ba17714857f1.prototype._centroid = true;
$4d356f0361a4a7f0$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    'innerRadius',
    'outerRadius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($4d356f0361a4a7f0$export$1644ba17714857f1, true);
/**
 * get/set number of points
 * @name Konva.Star#numPoints
 * @method
 * @param {Number} numPoints
 * @returns {Number}
 * @example
 * // get inner radius
 * var numPoints = star.numPoints();
 *
 * // set inner radius
 * star.numPoints(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($4d356f0361a4a7f0$export$1644ba17714857f1, 'numPoints', 5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set innerRadius
 * @name Konva.Star#innerRadius
 * @method
 * @param {Number} innerRadius
 * @returns {Number}
 * @example
 * // get inner radius
 * var innerRadius = star.innerRadius();
 *
 * // set inner radius
 * star.innerRadius(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($4d356f0361a4a7f0$export$1644ba17714857f1, 'innerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set outerRadius
 * @name Konva.Star#outerRadius
 * @method
 * @param {Number} outerRadius
 * @returns {Number}
 * @example
 * // get inner radius
 * var outerRadius = star.outerRadius();
 *
 * // set inner radius
 * star.outerRadius(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($4d356f0361a4a7f0$export$1644ba17714857f1, 'outerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());










const $df8ddbf07e58c785$var$EMPTY_STRING = '', $df8ddbf07e58c785$var$NORMAL = 'normal';
function $df8ddbf07e58c785$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $df8ddbf07e58c785$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $df8ddbf07e58c785$export$f7e34a95cc06fac7 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    constructor(config){
        // call super constructor
        super(config);
        this.dataArray = [];
        this._readDataAttribute();
        this._setTextData();
    }
    _getTextPathLength() {
        return (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPathLength(this.dataArray);
    }
    _getPointAtLength(length, cursor) {
        // if path is not defined yet, do nothing
        if (!this.attrs.data) return null;
        const totalLength = this.pathLength;
        if (length > totalLength) return null;
        return (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getPointAtLengthOfDataArray(length, this.dataArray, cursor);
    }
    _readDataAttribute() {
        this.dataArray = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        const textDecoration = this.textDecoration();
        const fontSize = this.fontSize();
        const underlineOffset = this._getUnderlineOffset();
        const glyphInfo = this.glyphInfo;
        const hasUnderline = textDecoration.indexOf('underline') !== -1;
        const hasLineThrough = textDecoration.indexOf('line-through') !== -1;
        if (hasUnderline) context.beginPath();
        try {
            for(let i = 0; i < glyphInfo.length; i++){
                context.save();
                const p0 = glyphInfo[i].p0;
                const rotation = glyphInfo[i].rotation;
                context.translate(p0.x, p0.y);
                context.rotate(rotation);
                this.partialText = glyphInfo[i].text;
                // keep gradients and patterns in the shape's space, not the glyph's
                this._styleTransform = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)().rotate(-rotation).translate(-p0.x, -p0.y);
                context.fillStrokeShape(this);
                if (hasUnderline) {
                    if (i === 0) context.moveTo(0, underlineOffset);
                    context.lineTo(glyphInfo[i].width, underlineOffset);
                }
                context.restore();
            //// To assist with debugging visually, uncomment following
            //
            // if (i % 2) context.strokeStyle = 'cyan';
            // else context.strokeStyle = 'green';
            // var p1 = glyphInfo[i].p1;
            // context.moveTo(p0.x, p0.y);
            // context.lineTo(p1.x, p1.y);
            // context.stroke();
            }
        } finally{
            this._styleTransform = undefined;
        }
        context.lineWidth = (0, $8540f0f5ac9d4ade$export$5f8bdcd5b08f26b8)(fontSize);
        if (hasUnderline && context._applyDecorationStyle(this)) context.stroke();
        if (hasLineThrough) {
            context.beginPath();
            for(let i = 0; i < glyphInfo.length; i++){
                context.save();
                const p0 = glyphInfo[i].p0;
                context.translate(p0.x, p0.y);
                context.rotate(glyphInfo[i].rotation);
                if (i === 0) context.moveTo(0, 0);
                context.lineTo(glyphInfo[i].width, 0);
                context.restore();
            }
            if (context._applyDecorationStyle(this)) context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        const glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            const p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(let i = 0; i < glyphInfo.length; i++){
            const p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    }
    /**
     * get text width in pixels
     * @method
     * @name Konva.TextPath#getTextWidth
     */ getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    }
    setText(text) {
        return (0, $8540f0f5ac9d4ade$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $8540f0f5ac9d4ade$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        const _context = (0, $8540f0f5ac9d4ade$export$e90f9594621df1ac)();
        _context.save();
        _context.font = this._getContextFont();
        // Text leaves its own kerning mode on the shared dummy context
        _context.fontKerning = 'auto';
        const metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10)
        };
    }
    _setTextData() {
        const charArr = (0, $8540f0f5ac9d4ade$export$b9ca061da17f2d30)(this.text());
        // For RTL scripts (Hebrew, Arabic, …) the path is still walked left to
        // right by glyph index, so we lay glyphs out in reversed logical order.
        // A reader scanning the path right-to-left then sees the text in its
        // intended reading order. This does not perform full Unicode bidi or
        // Arabic cursive shaping — those need a real shaping engine — but it
        // makes pure RTL strings render in the right direction.
        if (this.direction() === 'rtl') charArr.reverse();
        const kerningFunc = this.kerningFunc();
        const chars = [];
        let width = 0;
        for(let i = 0; i < charArr.length; i++){
            let kern = 0;
            if (kerningFunc && i > 0) try {
                // kerningFunc is a user provided getter. Make sure it never breaks our logic
                kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
            } catch (e) {}
            chars.push({
                char: charArr[i],
                width: this._getTextSize(charArr[i]).width,
                kern: kern
            });
            width += chars[i].width + kern;
        }
        const { width: fullTextWidth, height: height } = this._getTextSize(this.attrs.text);
        this.textWidth = width;
        this.textHeight = height;
        this.glyphInfo = [];
        if (!this.attrs.data) return null;
        const letterSpacing = this.letterSpacing();
        const align = this.align();
        const numberOfSpaces = align === 'justify' ? this.text().split(' ').length - 1 : 0;
        // The sum of individual character widths can exceed the whole-string width
        // due to kerning (browsers place adjacent glyphs closer together than the
        // individual measurements suggest). This difference is the maximum amount
        // by which the accumulated glyph offset can legitimately overshoot the
        // path length when the path is sized to match the visually-measured text.
        const kerningAdjustment = Math.max(0, width - fullTextWidth);
        // defines the width of the text on a straight line
        const textWidth = Math.max(this.textWidth + (charArr.length - 1) * letterSpacing, 0);
        let offset = 0;
        if (align === 'center') offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
        if (align === 'right') offset = Math.max(0, this.pathLength - textWidth);
        // Algorithm for calculating glyph positions:
        // 1. Get the begging point of the glyph on the path using the offsetToGlyph,
        // 2. Get the ending point of the glyph on the path using the offsetToGlyph plus glyph width,
        // 3. Calculate the rotation, width, and midpoint of the glyph using the start and end points,
        // 4. Add glyph width to the offsetToGlyph and repeat
        let offsetToGlyph = offset;
        // Keep the original boundary selection across gaps between subpaths.
        const cursor = this.dataArray.some((segment, index)=>index > 0 && segment.command === 'M') ? undefined : {
            index: 0,
            offset: 0
        };
        for(let i = 0; i < chars.length; i++){
            offsetToGlyph += chars[i].kern;
            const charStartPoint = this._getPointAtLength(offsetToGlyph, cursor);
            if (!charStartPoint) return;
            const char = chars[i].char;
            let glyphWidth = chars[i].width + (i < chars.length - 1 ? letterSpacing : 0);
            if (char === ' ' && align === 'justify') glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            const charEndLength = offsetToGlyph + glyphWidth;
            // When the path length is sized to match the visually-measured (kerned)
            // text width, the accumulated per-glyph offset can exceed pathLength by
            // up to kerningAdjustment pixels. Clamp to pathLength in that case so
            // the last character is not silently dropped.
            const charEndPoint = this._getPointAtLength(charEndLength > this.pathLength && charEndLength - this.pathLength <= kerningAdjustment ? this.pathLength : charEndLength, cursor);
            if (!charEndPoint) return;
            const width = (0, $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9).getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
                text: charArr[i],
                rotation: rotation,
                p0: charStartPoint,
                p1: charEndPoint,
                width: width
            });
            offsetToGlyph += glyphWidth;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        const rect = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getPointsRect(points);
        const fontSize = this.fontSize();
        let x = rect.x - fontSize / 2, y = rect.y - fontSize / 2, right = rect.x + rect.width + fontSize / 2, bottom = rect.y + rect.height + fontSize / 2;
        if (this.textDecoration().indexOf('underline') !== -1) {
            // the underline is drawn below the glyphs, past the padding
            const lineWidth = (0, $8540f0f5ac9d4ade$export$5f8bdcd5b08f26b8)(fontSize), lineY = this._getUnderlineOffset() - lineWidth / 2;
            this.glyphInfo.forEach(function(info) {
                const line = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)().translate(info.p0.x, info.p0.y).rotate(info.rotation)._getTransformedRect({
                    x: 0,
                    y: lineY,
                    width: info.width,
                    height: lineWidth
                });
                x = Math.min(x, line.x);
                y = Math.min(y, line.y);
                right = Math.max(right, line.x + line.width);
                bottom = Math.max(bottom, line.y + line.height);
            });
        }
        return {
            x: x,
            y: y,
            width: right - x,
            height: bottom - y
        };
    }
    _getUnderlineOffset() {
        return this.fontSize() / 2 + 1;
    }
    // Like Text: a glyph stroke is drawn with the text, so it always scales.
    getStrokeScaleEnabled() {
        return true;
    }
    _getSelfRectForDrawing() {
        // getSelfRect() pads glyph anchors by half the font size; ascenders,
        // accents and other baselines reach further from the path.
        const rect = this.getSelfRect(), pad = this.fontSize();
        return {
            x: rect.x - pad,
            y: rect.y - pad,
            width: rect.width + pad * 2,
            height: rect.height + pad * 2
        };
    }
}
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._fillFunc = $df8ddbf07e58c785$var$_fillFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._strokeFunc = $df8ddbf07e58c785$var$_strokeFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._fillFuncHit = $df8ddbf07e58c785$var$_fillFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $df8ddbf07e58c785$var$_strokeFunc;
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype.className = 'TextPath';
const $df8ddbf07e58c785$var$ATTR_CHANGE_LIST = [
    'text',
    'fontSize',
    'align',
    'letterSpacing',
    'kerningFunc',
    'fontFamily',
    'fontStyle',
    'fontVariant',
    'direction'
];
// data relayouts in its own listener; textDecoration changes the bounds
// through getSelfRect, but needs no relayout
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = $df8ddbf07e58c785$var$ATTR_CHANGE_LIST.concat('data', 'textDecoration');
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($df8ddbf07e58c785$export$f7e34a95cc06fac7, true);
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype.on('dataChange.konva', function() {
    this._readDataAttribute();
    this._setTextData();
});
// update text data for certain attr changes
$df8ddbf07e58c785$export$f7e34a95cc06fac7.prototype.on($df8ddbf07e58c785$var$ATTR_CHANGE_LIST.map((attr)=>attr + 'Change.konva').join(' '), function() {
    this._setTextData();
});
/**
 * get/set SVG path data string.  This method
 *  also automatically parses the data string
 *  into a data array.  Currently supported SVG data:
 *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
 * @name Konva.TextPath#data
 * @method
 * @param {String} data svg path string
 * @returns {String}
 * @example
 * // get data
 * var data = shape.data();
 *
 * // set data
 * shape.data('M200,100h100v50z');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'data');
/**
 * get/set font family
 * @name Konva.TextPath#fontFamily
 * @method
 * @param {String} fontFamily
 * @returns {String}
 * @example
 * // get font family
 * var fontFamily = shape.fontFamily();
 *
 * // set font family
 * shape.fontFamily('Arial');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontFamily', 'Arial');
/**
 * get/set font size in pixels
 * @name Konva.TextPath#fontSize
 * @method
 * @param {Number} fontSize
 * @returns {Number}
 * @example
 * // get font size
 * var fontSize = shape.fontSize();
 *
 * // set font size to 22px
 * shape.fontSize(22);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontSize', 12, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set font style.  Can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
 * @name Konva.TextPath#fontStyle
 * @method
 * @param {String} fontStyle
 * @returns {String}
 * @example
 * // get font style
 * var fontStyle = shape.fontStyle();
 *
 * // set font style
 * shape.fontStyle('bold');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontStyle', $df8ddbf07e58c785$var$NORMAL);
/**
 * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
 * @name Konva.TextPath#align
 * @method
 * @param {String} align
 * @returns {String}
 * @example
 * // get text align
 * var align = text.align();
 *
 * // center text
 * text.align('center');
 *
 * // align text to right
 * text.align('right');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'align', 'left');
/**
 * get/set letter spacing.  The default is 0.
 * @name Konva.TextPath#letterSpacing
 * @method
 * @param {Number} letterSpacing
 * @returns {Number}
 * @example
 * // get letter spacing value
 * var letterSpacing = shape.letterSpacing();
 *
 * // set the letter spacing value
 * shape.letterSpacing(2);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'letterSpacing', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set text baseline.  The default is 'middle'. Can be 'top', 'bottom', 'middle', 'alphabetic', 'hanging'
 * @name Konva.TextPath#textBaseline
 * @method
 * @param {String} textBaseline
 * @returns {String}
 * @example
 * // get current text baseline
 * var textBaseline = shape.textBaseline();
 *
 * // set new text baseline
 * shape.textBaseline('top');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'textBaseline', 'middle');
/**
 * get/set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
 * @name Konva.TextPath#fontVariant
 * @method
 * @param {String} fontVariant
 * @returns {String}
 * @example
 * // get font variant
 * var fontVariant = shape.fontVariant();
 *
 * // set font variant
 * shape.fontVariant('small-caps');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'fontVariant', $df8ddbf07e58c785$var$NORMAL);
/**
 * get/set text
 * @name Konva.TextPath#getText
 * @method
 * @param {String} text
 * @returns {String}
 * @example
 * // get text
 * var text = text.text();
 *
 * // set text
 * text.text('Hello world!');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'text', $df8ddbf07e58c785$var$EMPTY_STRING);
/**
 * get/set text decoration of a text.  Can be '', 'underline', 'line-through', or a combination like 'underline line-through'.
 * @name Konva.TextPath#textDecoration
 * @method
 * @param {String} textDecoration
 * @returns {String}
 * @example
 * // get text decoration
 * var textDecoration = shape.textDecoration();
 *
 * // underline text
 * shape.textDecoration('underline');
 *
 * // line-through text
 * shape.textDecoration('line-through');
 *
 * // combine both
 * shape.textDecoration('underline line-through');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'textDecoration', '');
/**
 * get/set kerning function.
 * @name Konva.TextPath#kerningFunc
 * @method
 * @param {String} kerningFunc
 * @returns {String}
 * @example
 * // get text decoration
 * var kerningFunc = text.kerningFunc();
 *
 * // center text
 * text.kerningFunc(function(leftChar, rightChar) {
 *   return 1;
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'kerningFunc', undefined);
/**
 * get/set text direction.  Can be 'inherit', 'ltr' or 'rtl'.  Default is 'inherit'.
 *
 * Setting `'rtl'` reverses the per-glyph layout order along the path, so
 * Hebrew/Arabic strings read correctly when scanned right-to-left. This is a
 * pragmatic fix limited by canvas TextPath rendering: each glyph is still
 * drawn independently, so Arabic cursive joining and full Unicode bidi
 * reordering of mixed-direction text are not supported. For best results,
 * pair `direction: 'rtl'` with `align: 'right'` so the text starts at the
 * end of the path.
 * @name Konva.TextPath#direction
 * @method
 * @param {String} direction
 * @returns {String}
 * @example
 * // get direction
 * var direction = textpath.direction();
 *
 * // set direction
 * textpath.direction('rtl');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($df8ddbf07e58c785$export$f7e34a95cc06fac7, 'direction', 'inherit');











const $801345eab32c3d30$var$EVENTS_NAME = 'tr-konva';
const $801345eab32c3d30$var$ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateAnchorAngleChange',
    'rotateEnabledChange',
    'rotateModeChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'shouldOverdrawWholeAreaChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange',
    'anchorStyleFuncChange',
    'paddingChange'
].map((e)=>e + `.${$801345eab32c3d30$var$EVENTS_NAME}`).join(' ');
const $801345eab32c3d30$var$NODES_RECT = 'nodesRect';
const $801345eab32c3d30$var$TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange',
    'strokeChange',
    'selfRectFuncChange',
    'strokeLinearGradientColorStopsChange',
    'strokeScaleEnabledChange',
    'strokeEnabledChange',
    'draggableChange'
];
const $801345eab32c3d30$var$ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135
};
const $801345eab32c3d30$var$TOUCH_DEVICE = 'ontouchstart' in (0, $8c8384c27430fce8$export$b9f99057a3c7692)._global;
// invisible zones just outside the corners, the rotate area of rotateMode 'corners'
const $801345eab32c3d30$var$ROTATE_ZONE_NAMES = [
    'rotater-top-left',
    'rotater-top-right',
    'rotater-bottom-left',
    'rotater-bottom-right'
];
function $801345eab32c3d30$var$isRotateAnchor(anchorName) {
    return anchorName.startsWith('rotater');
}
// with Shift pressed the rotation snaps to this step
const $801345eab32c3d30$var$SHIFT_ROTATION_STEP = Math.PI / 12;
// curved double arrow drawn for the top-right corner, rotated for others
function $801345eab32c3d30$var$getRotateZoneCursor(deg, fallback) {
    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">' + `<g transform="rotate(${deg} 12 12)" stroke-linejoin="round">` + '<path d="M5 8 A11 11 0 0 1 16 19" fill="none" stroke="white" stroke-width="4"/>' + '<path d="M2 8 L6 4.5 L6 11.5 Z M16 22 L12.5 18 L19.5 18 Z" fill="black" stroke="white"/>' + '<path d="M5 8 A11 11 0 0 1 16 19" fill="none" stroke="black" stroke-width="1.5"/>' + '</g></svg>';
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}") 12 12, ${fallback}`;
}
function $801345eab32c3d30$var$getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === 'rotater') return rotateCursor;
    if ($801345eab32c3d30$var$isRotateAnchor(anchorName)) {
        const corner = anchorName.slice(8);
        const deg = Math.round((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).radToDeg(rad) + $801345eab32c3d30$var$ANGLES[corner] - 45);
        return $801345eab32c3d30$var$getRotateZoneCursor(deg, rotateCursor);
    }
    rad += (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).degToRad($801345eab32c3d30$var$ANGLES[anchorName] || 0);
    const angle = ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) // TOP
    return 'ns-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) // TOP - RIGHT
    return 'nesw-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) // RIGHT
    return 'ew-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) // BOTTOM - RIGHT
    return 'nwse-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) // BOTTOM
    return 'ns-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) // BOTTOM - LEFT
    return 'nesw-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) // RIGHT
    return 'ew-resize';
    else if ((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) // BOTTOM - RIGHT
    return 'nwse-resize';
    else {
        // how can we can there?
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
const $801345eab32c3d30$var$ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right'
];
const $801345eab32c3d30$var$MAX_SAFE_INTEGER = 100000000;
function $801345eab32c3d30$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $801345eab32c3d30$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return {
        ...shape,
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    };
}
function $801345eab32c3d30$var$rotateAroundCenter(shape, deltaRad) {
    const center = $801345eab32c3d30$var$getCenter(shape);
    return $801345eab32c3d30$var$rotateAroundPoint(shape, deltaRad, center);
}
function $801345eab32c3d30$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    let nearest = tol;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < nearest) {
            nearest = dif;
            snapped = angle;
        }
    }
    return snapped;
}
// start and end point of the rotate line, in the transformer box coordinates
function $801345eab32c3d30$var$getRotaterLine(tr, width, height) {
    const rad = (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).degToRad(tr.rotateAnchorAngle());
    // direction vector (0 degrees = up/top)
    const dirX = Math.sin(rad);
    const dirY = -Math.cos(rad);
    const cx = width / 2;
    const cy = height / 2;
    // distance from the center to the first box edge in that direction
    let t = Infinity;
    if (dirY < 0) t = Math.min(t, -cy / dirY);
    else if (dirY > 0) t = Math.min(t, (height - cy) / dirY);
    if (dirX < 0) t = Math.min(t, -cx / dirX);
    else if (dirX > 0) t = Math.min(t, (width - cx) / dirX);
    const edgeX = cx + dirX * t;
    const edgeY = cy + dirY * t;
    const offset = tr.rotateAnchorOffset() + tr.padding();
    return {
        edgeX: edgeX,
        edgeY: edgeY,
        endX: edgeX + dirX * offset,
        endY: edgeY + dirY * offset
    };
}
const $801345eab32c3d30$var$activeTransformers = new Set();
class $801345eab32c3d30$export$f993aef960936087 extends (0, $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4) {
    // the hit graph of a layer is not drawn while a transformer on it, or of
    // a node on it, is transforming (see Layer.shouldDrawHit)
    static _isLayerTransforming(layer) {
        for (const tr of $801345eab32c3d30$var$activeTransformers){
            if (tr.getLayer() === layer || tr._nodes.some((node)=>node.getLayer() === layer)) return true;
        }
        return false;
    }
    constructor(config){
        // call super constructor
        super(config);
        this._movingAnchorName = null;
        this._anchors = {};
        this._transforming = false;
        // true while _fitNodesInto writes the new attrs into the nodes
        this._fitting = false;
        // the window the transform events are listened to. The stage may be
        // rendered in another window than the one Konva was imported into
        this._transformWindow = null;
        this._elementsCreated = false;
        // the layout is stale; the next sync point runs _update() (see _syncUpdate)
        this._updatePending = false;
        this._createElements();
        // bindings
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this._syncUpdate = this._syncUpdate.bind(this);
        // update transformer data for certain attr changes
        this.on($801345eab32c3d30$var$ATTR_CHANGE_LIST, (event)=>{
            if (event.type === 'ignoreStrokeChange') this._resetTransformCache();
            this.update();
        });
        // the memoized rect bakes in our own rotation, so a manual rotation must drop it
        this.on(`rotationChange.${$801345eab32c3d30$var$EVENTS_NAME}`, ()=>this._clearCache($801345eab32c3d30$var$NODES_RECT));
        if (this.getNode()) this.update();
    }
    /**
     * alias to `tr.nodes([shape])`/ This method is deprecated and will be removed soon.
     * @method
     * @name Konva.Transformer#attachTo
     * @returns {Konva.Transformer}
     * @example
     * transformer.attachTo(shape);
     */ attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $801345eab32c3d30$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const selected = new Set(nodes);
        for (const node of selected)// check if ancestor of the transformer
        if (node.isAncestorOf(this)) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('Konva.Transformer cannot be an a child of the node you are trying to attach');
            selected.delete(node);
        }
        const filteredNodes = Array.from(selected).filter((node)=>{
            // Transform a selected subtree once, through its selected ancestor.
            for(let parent = node.getParent(); parent; parent = parent.getParent()){
                if (selected.has(parent)) return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        this._resetRotation();
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                var _a;
                // Perf: skip the changes _fitNodesInto makes itself — it does the
                // final _resetTransformCache + update, so per-attr fan-out here is
                // pure waste (was O(N*events) per resize step). A change made between
                // two pointer moves (e.g. a deferred state update) must get through.
                if (this._fitting) {
                    (_a = this._nodeRectCache) === null || _a === void 0 || _a.delete(node);
                    return;
                }
                // unlike _resetRotation, a multi-node box keeps its rotation here
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                // Cache reset stays synchronous so sync reads of tr.x() etc. are fresh.
                this._resetTransformCache(node);
                if (!this.isDragging()) // Perf: an ancestor cascade (e.g. stage drag) fires
                // absoluteTransformChange on every attached node — without batching,
                // a refresh runs once per node and each call walks all N nodes via
                // __getNodeRect, giving O(N^2) per drag frame.
                this._scheduleUpdate();
            };
            if (node._attrsAffectingSize.length) {
                const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + 'Change.' + this._getEventNamespace()).join(' ');
                node.on(additionalEvents, onChange);
            }
            node.on($801345eab32c3d30$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(' '), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            if (node instanceof (0, $f02a8e3513953b09$export$42a852a2b6b56249)) node._addSubtreeObserver(this);
            node.on(`destroy.${this._getEventNamespace()}`, ()=>{
                this._removeNode(node);
            });
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        // we may need it if we set node in initial props
        // so elements are not defined yet
        if (this._elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            // actual dragging of Transformer doesn't make sense
            // but we need to make sure it also has all drag events
            if (!this.isDragging() && node !== this._back) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    _detachNode(node) {
        node.off('.' + this._getEventNamespace());
        node._removeSubtreeObserver(this);
    }
    _resetRotation() {
        const single = this._nodes.length === 1 && this.useSingleNodeRotation();
        this.rotation(single ? this._nodes[0].getAbsoluteRotation() : 0);
    }
    // Drops one destroyed node. Re-attaching the survivors instead costs
    // O(N) listener rebinds per destroyed node, O(N^2) for a deleted selection.
    _removeNode(node) {
        this._detachNode(node);
        this._nodes = this._nodes.filter((n)=>n !== node);
        this._resetRotation();
        this._resetTransformCache(node);
        this._scheduleUpdate();
    }
    getNodes() {
        return this._nodes || [];
    }
    /**
     * return the name of current active anchor
     * @method
     * @name Konva.Transformer#getActiveAnchor
     * @returns {String | Null}
     * @example
     * transformer.getActiveAnchor();
     */ getActiveAnchor() {
        return this._movingAnchorName;
    }
    /**
     * detach transformer from an attached node
     * @method
     * @name Konva.Transformer#detach
     * @returns {Konva.Transformer}
     * @example
     * transformer.detach();
     */ detach() {
        var _a, _b;
        (_a = this._nodes) === null || _a === void 0 || _a.forEach((node)=>this._detachNode(node));
        this._nodes = [];
        this._updatePending = false;
        this._resetTransformCache();
        (_b = this.getLayer()) === null || _b === void 0 || _b.batchDraw();
    }
    /**
     * bind events to the Transformer. You can use events: `transform`, `transformstart`, `transformend`, `dragstart`, `dragmove`, `dragend`
     * @method
     * @name Konva.Transformer#on
     * @param {String} evtStr e.g. 'transform'
     * @param {Function} handler The handler function. The first argument of that function is event object. Event object has `target` as main target of the event, `currentTarget` as current node listener and `evt` as native browser event.
     * @returns {Konva.Transformer}
     * @example
     * // add click listener
     * tr.on('transformstart', function() {
     *   console.log('transform started');
     * });
     */ _resetTransformCache(changedNode) {
        var _a, _b;
        if (changedNode) (_a = this._nodeRectCache) === null || _a === void 0 || _a.delete(changedNode);
        else (_b = this._nodeRectCache) === null || _b === void 0 || _b.clear();
        this._clearCache($801345eab32c3d30$var$NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    }
    // Called for every change below an attached container. A burst of child
    // changes only drops cached values here. The new bounds are measured once,
    // before the next frame, or earlier if a draw or transform step comes first
    // (_syncUpdate).
    _onSubtreeChange(node) {
        var _a, _b;
        if (this._fitting) return;
        // nothing was measured since the last change, so nothing cached is stale
        const measured = !this._updatePending || !!this._cache[$801345eab32c3d30$var$NODES_RECT];
        if (measured) this._resetTransformCache(node);
        if ((0, $367bbc8f6a40f243$export$85c928794f8d04d4)._updateBatchDepth > 0) {
            // the batch flush lays the new bounds out, no frame needed
            this._scheduleUpdate();
            return;
        }
        if (!this._updatePending) {
            this._updatePending = true;
            // queued ahead of the draw the change requests, so that draw shows the
            // new layout. Updating inside the draw would request one more frame.
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).requestAnimFrame(this._syncUpdate, (_a = this.getStage()) === null || _a === void 0 ? void 0 : _a._getOwnerWindow());
            // the transformer can be on another layer than the changed node
            (_b = this.getLayer()) === null || _b === void 0 || _b.batchDraw();
        }
    }
    // Runs a deferred update before anything draws or measures the anchors.
    _syncUpdate() {
        // while dragging, the dragmove handler updates the layout
        if (this._updatePending && !this._fitting && !this.isDragging()) this._update();
    }
    drawScene(can, top) {
        this._syncUpdate();
        return super.drawScene(can, top);
    }
    drawHit(can, top) {
        this._syncUpdate();
        return super.drawHit(can, top);
    }
    _getNodeRect() {
        return this._getCache($801345eab32c3d30$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeRect() {
        var _a;
        const node = this.getNode();
        if (!node) return {
            x: -$801345eab32c3d30$var$MAX_SAFE_INTEGER,
            y: -$801345eab32c3d30$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const rotation = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation());
        const ignoreStroke = this.ignoreStroke();
        const tr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        tr.rotate(-rotation);
        const cache = this._nodeRectCache || (this._nodeRectCache = new Map());
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for (const node of this.nodes()){
            // Bounds may only be reused when they are a pure function of the node's
            // own size: then every change reaches us either through _setAttr or
            // through the size probe below. A shape with its own getSelfRect - Line
            // mutates its points array in place, and a user subclass or selfRectFunc
            // can measure anything at all - may change with no signal, so it is
            // measured every time. Groups depend on their descendants, and a cached
            // ancestor suppresses descendant transform-change notifications, so
            // both are measured too.
            const cacheable = node instanceof (0, $9081147451080c7d$export$6428a7f2611ef1fa) && node.getSelfRect === (0, $9081147451080c7d$export$6428a7f2611ef1fa).prototype.getSelfRect && !node.attrs.selfRectFunc && !node._hasCachedAncestor();
            // width() and height() are the only inputs of the default getSelfRect and
            // they can come from outside the attrs (an Image source that loads or
            // resizes, Text metrics), so the attr revision alone cannot key them.
            const width = cacheable ? node.width() : 0;
            const height = cacheable ? node.height() : 0;
            if (cacheable) (_a = node._attrsVersion) !== null && _a !== void 0 ? _a : node._attrsVersion = 0;
            let bounds = cacheable ? cache.get(node) : undefined;
            if (!bounds || bounds.rotation !== rotation || bounds.ignoreStroke !== ignoreStroke || bounds.version !== node._attrsVersion || bounds.width !== width || bounds.height !== height) {
                let trans = node.getAbsoluteTransform();
                const [a, b, c, d] = trans.getMatrix();
                const collapsed = a * d - b * c === 0;
                const box = node.getClientRect({
                    skipTransform: !collapsed,
                    skipShadow: true,
                    skipStroke: ignoreStroke
                });
                const points = [
                    {
                        x: box.x,
                        y: box.y
                    },
                    {
                        x: box.x + box.width,
                        y: box.y
                    },
                    {
                        x: box.x + box.width,
                        y: box.y + box.height
                    },
                    {
                        x: box.x,
                        y: box.y + box.height
                    }
                ];
                if (collapsed) trans = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
                bounds = {
                    rotation: rotation,
                    ignoreStroke: ignoreStroke,
                    width: width,
                    height: height,
                    version: node._attrsVersion || 0,
                    minX: Infinity,
                    minY: Infinity,
                    maxX: -Infinity,
                    maxY: -Infinity
                };
                for (const point of points){
                    const projected = tr.point(trans.point(point));
                    bounds.minX = Math.min(bounds.minX, projected.x);
                    bounds.minY = Math.min(bounds.minY, projected.y);
                    bounds.maxX = Math.max(bounds.maxX, projected.x);
                    bounds.maxY = Math.max(bounds.maxY, projected.y);
                }
                if (cacheable) cache.set(node, bounds);
            }
            minX = Math.min(minX, bounds.minX);
            minY = Math.min(minY, bounds.minY);
            maxX = Math.max(maxX, bounds.maxX);
            maxY = Math.max(maxY, bounds.maxY);
        }
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        // below the resize anchors, so a resize anchor wins where they overlap
        $801345eab32c3d30$var$ROTATE_ZONE_NAMES.forEach((name)=>{
            // invisible, but its fill keeps it in the hit graph
            this._createAnchor(name, '_rotate-zone').setAttrs({
                fill: 'transparent',
                strokeEnabled: false,
                visible: false
            });
        });
        $801345eab32c3d30$var$ANCHORS_NAMES.forEach((name)=>{
            this._createAnchor(name);
        });
        this._createAnchor('rotater');
        this._elementsCreated = true;
    }
    _createAnchor(name, className = '_anchor') {
        const anchor = new (0, $f22346c22f20789a$export$c79fc6492f3af13d)({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' ' + className,
            dragDistance: 0,
            // make it draggable,
            // so activating the anchor will not start drag&drop of any parent
            draggable: true,
            hitStrokeWidth: $801345eab32c3d30$var$TOUCH_DEVICE ? 10 : 'auto'
        });
        this._anchors[name] = anchor;
        const self = this;
        anchor.on('mousedown touchstart', function(e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        // add hover styling
        anchor.on('mouseenter', ()=>{
            if (this.isTransforming()) return;
            this._setAnchorCursor(name);
            this._cursorChange = true;
        });
        anchor.on('mouseout', ()=>{
            this._cursorChange = false;
            if (this.isTransforming()) return;
            anchor.getStage().content && (anchor.getStage().content.style.cursor = '');
        });
        this.add(anchor);
        return anchor;
    }
    _setAnchorCursor(name, rad = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation())) {
        var _a;
        const content = (_a = this.getStage()) === null || _a === void 0 ? void 0 : _a.content;
        if (content) content.style.cursor = $801345eab32c3d30$var$getCursor(name, rad, this.rotateAnchorCursor());
    }
    _createBack() {
        const back = new (0, $9081147451080c7d$export$6428a7f2611ef1fa)({
            name: 'back',
            width: 0,
            height: 0,
            sceneFunc (ctx, shape) {
                const tr = shape.getParent();
                if (!tr.borderEnabled()) return;
                const padding = tr.padding();
                const width = shape.width();
                const height = shape.height();
                ctx.beginPath();
                ctx.rect(-padding, -padding, width + padding * 2, height + padding * 2);
                if (tr.rotateEnabled() && tr.rotateLineVisible() && tr.rotateMode() !== 'corners') {
                    const line = $801345eab32c3d30$var$getRotaterLine(tr, width, height);
                    ctx.moveTo(line.edgeX, line.edgeY);
                    ctx.lineTo(line.endX, line.endY);
                }
                ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                const padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this._back = back;
        this.add(back);
        this._proxyDrag(back);
        // do not bubble drag from the back shape
        // because we already "drag" whole transformer
        // so we don't want to trigger drag twice on transformer
        back.on('dragstart', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragmove', (e)=>{
            e.cancelBubble = true;
        });
        back.on('dragend', (e)=>{
            e.cancelBubble = true;
        });
        // force self update when we drag with shouldOverDrawWholeArea setting
        this.on('dragmove', (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        var _a, _b;
        if (e.evt.button !== undefined && !(0, $8c8384c27430fce8$export$b9f99057a3c7692).dragButtons.includes(e.evt.button)) return;
        // do nothing if we already transforming
        // that is possible to trigger with multitouch
        if (this._transforming) return;
        this._movingAnchorName = e.target.name().split(' ')[0];
        const attrs = this._getNodeRect();
        const width = attrs.width;
        const height = attrs.height;
        const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        // the window that owns the stage is the one that gets the pointer events
        const win = (_a = this.getStage()) === null || _a === void 0 ? void 0 : _a._getOwnerWindow();
        this._transformWindow = win || null;
        if (win) {
            win.addEventListener('mousemove', this._handleMouseMove);
            win.addEventListener('touchmove', this._handleMouseMove);
            win.addEventListener('mouseup', this._handleMouseUp, true);
            win.addEventListener('touchend', this._handleMouseUp, true);
            win.addEventListener('touchcancel', this._handleMouseUp, true);
        }
        this._transforming = true;
        // the pointer that hit the anchor (a touchstart can land several fingers)
        this._pointerId = (_b = e.pointerId) !== null && _b !== void 0 ? _b : (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getFirstPointerId(e.evt);
        const ap = e.target.getAbsolutePosition();
        const pos = e.target.getStage()._getPointerById(this._pointerId);
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        if ($801345eab32c3d30$var$isRotateAnchor(this._movingAnchorName)) {
            const center = $801345eab32c3d30$var$getCenter(attrs);
            this._rotateStart = {
                pointerAngle: Math.atan2(pos.y - center.y, pos.x - center.x),
                rotation: attrs.rotation
            };
        }
        $801345eab32c3d30$var$activeTransformers.add(this);
        this._fire('transformstart', {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire('transformstart', {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        var _a;
        (_a = this.getStage()) === null || _a === void 0 || _a._batchEvents(()=>this._moveTransform(e));
    }
    _moveTransform(e) {
        // anchors must show the current bounds before they are measured against
        this._syncUpdate();
        let x, y, newHypotenuse;
        const anchorNode = this._anchors[this._movingAnchorName];
        const stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage._getPointerById(this._pointerId);
        if (!pp) return;
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        // console.log(oldAbs, newNodePos, newAbs);
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        // rotation is working very differently, so do it first
        if ($801345eab32c3d30$var$isRotateAnchor(this._movingAnchorName)) {
            const attrs = this._getNodeRect();
            const center = $801345eab32c3d30$var$getCenter(attrs);
            const start = this._rotateStart;
            // the grabbed point turns around the center by as much as the box,
            // so the box follows the pointer wherever it was grabbed
            const point = {
                x: newAbs.x + this._anchorDragOffset.x,
                y: newAbs.y + this._anchorDragOffset.y
            };
            const pointerAngle = Math.atan2(point.y - center.y, point.x - center.x);
            const newRotation = start.rotation + pointerAngle - start.pointerAngle;
            let snappedRot;
            if (e.shiftKey && this.shiftBehavior() !== 'none') snappedRot = Math.round(newRotation / $801345eab32c3d30$var$SHIFT_ROTATION_STEP) * $801345eab32c3d30$var$SHIFT_ROTATION_STEP;
            else {
                const tol = (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
                snappedRot = $801345eab32c3d30$var$getSnap(this.rotationSnaps(), newRotation, tol);
            }
            // a corner zone cursor shows the direction of the turned corner,
            // set before the transform event so its handlers can override it
            if (this._movingAnchorName !== 'rotater') this._setAnchorCursor(this._movingAnchorName, snappedRot);
            const diff = snappedRot - attrs.rotation;
            const shape = $801345eab32c3d30$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        const shiftBehavior = this.shiftBehavior();
        let keepProportion;
        if (shiftBehavior === 'inverted') keepProportion = this.keepRatio() && !e.shiftKey;
        else if (shiftBehavior === 'none') keepProportion = this.keepRatio();
        else keepProportion = this.keepRatio() || e.shiftKey;
        let centeredScaling = this.centeredScaling() || e.altKey;
        // with keepRatio, a corner anchor doesn't follow the pointer — the blocks
        // below project it onto the ratio diagonal. _doFitNodesInto must know
        // that to skip the padding flip compensation (issue #1878)
        let anchorProjected = false;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                anchorProjected = true;
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this._anchors['bottom-right'].x(),
                    y: this._anchors['bottom-right'].y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this._anchors['top-left'].x() > comparePoint.x ? -1 : 1;
                const reverseY = this._anchors['top-left'].y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this._anchors['top-left'].x(comparePoint.x - x);
                this._anchors['top-left'].y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === 'top-center') this._anchors['top-left'].y(anchorNode.y());
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                anchorProjected = true;
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this._anchors['bottom-left'].x(),
                    y: this._anchors['bottom-left'].y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this._anchors['top-right'].x() < comparePoint.x ? -1 : 1;
                const reverseY = this._anchors['top-right'].y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this._anchors['top-right'].x(comparePoint.x + x);
                this._anchors['top-right'].y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this._anchors['top-left'].y(pos.y);
            this._anchors['bottom-right'].x(pos.x);
        } else if (this._movingAnchorName === 'middle-left') this._anchors['top-left'].x(anchorNode.x());
        else if (this._movingAnchorName === 'middle-right') this._anchors['bottom-right'].x(anchorNode.x());
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                anchorProjected = true;
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this._anchors['top-right'].x(),
                    y: this._anchors['top-right'].y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this._anchors['top-left'].x(pos.x);
            this._anchors['bottom-right'].y(pos.y);
        } else if (this._movingAnchorName === 'bottom-center') this._anchors['bottom-right'].y(anchorNode.y());
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                anchorProjected = true;
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this._anchors['top-left'].x(),
                    y: this._anchors['top-left'].y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = this._anchors['bottom-right'].x() < comparePoint.x ? -1 : 1;
                const reverseY = this._anchors['bottom-right'].y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this._anchors['bottom-right'].x(comparePoint.x + x);
                this._anchors['bottom-right'].y(comparePoint.y + y);
            }
        } else console.error(new Error('Wrong position argument of selection resizer: ' + this._movingAnchorName));
        centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            const topLeft = this._anchors['top-left'];
            const bottomRight = this._anchors['bottom-right'];
            const topOffsetX = topLeft.x();
            const topOffsetY = topLeft.y();
            const bottomOffsetX = this.getWidth() - bottomRight.x();
            const bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        const absPos = this._anchors['top-left'].getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        const width = this._anchors['bottom-right'].x() - this._anchors['top-left'].x();
        const height = this._anchors['bottom-right'].y() - this._anchors['top-left'].y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e, anchorProjected);
    }
    _handleMouseUp(e) {
        // only the pointer that grabbed the anchor ends the transform
        const stage = this.getStage();
        if (stage) {
            stage.setPointersPositions(e);
            if (!stage._changedPointerPositions.some((p)=>p.id === this._pointerId)) return;
        }
        if (stage) stage._batchEvents(()=>this._removeEvents(e));
        else this._removeEvents(e);
    }
    // the transformer positions itself in absolute coordinates (see
    // _getNodeRect), whatever the transforms of its ancestors are
    getAbsoluteTransform(top) {
        const at = this.getTransform();
        return top ? top.getAbsoluteTransform().copy().invert().multiply(at) : at;
    }
    _removeEvents(e) {
        var _a, _b;
        if (this._transforming) {
            this._transforming = false;
            const content = (_a = this.getStage()) === null || _a === void 0 ? void 0 : _a.content;
            if (content && !this._cursorChange) content.style.cursor = '';
            const win = this._transformWindow;
            this._transformWindow = null;
            if (win) {
                win.removeEventListener('mousemove', this._handleMouseMove);
                win.removeEventListener('touchmove', this._handleMouseMove);
                win.removeEventListener('mouseup', this._handleMouseUp, true);
                win.removeEventListener('touchend', this._handleMouseUp, true);
                win.removeEventListener('touchcancel', this._handleMouseUp, true);
            }
            const node = this.getNode();
            $801345eab32c3d30$var$activeTransformers.delete(this);
            this._fire('transformend', {
                evt: e,
                target: node
            });
            // redraw layer to restore hit graph
            (_b = this.getLayer()) === null || _b === void 0 || _b.batchDraw();
            if (node) this._nodes.forEach((target)=>{
                var _a;
                target._fire('transformend', {
                    evt: e,
                    target: target
                });
                // redraw layer to restore hit graph
                (_a = target.getLayer()) === null || _a === void 0 || _a.batchDraw();
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt, anchorProjected = false) {
        // Defer our own bounds updates while preserving drawing in user callbacks.
        this._fitting = true;
        try {
            return this._doFitNodesInto(newAttrs, evt, anchorProjected);
        } finally{
            this._fitting = false;
        }
    }
    _doFitNodesInto(newAttrs, evt, anchorProjected = false) {
        const oldAttrs = this._getNodeRect();
        const minSize = 1;
        // a zero-size box has a singular transform, there is nothing to scale from
        if (!oldAttrs.width || !oldAttrs.height || (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize) || (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const t = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        t.rotate((0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.rotation()));
        // the ±2*padding shifts below assume the box size passed through zero
        // continuously (the anchor tied to the pointer). A projected anchor snaps
        // the box across zero instead; the shifts then leave the drag state
        // inconsistent with the real anchor position and the box flips back and
        // forth on every following move (issue #1878) — so flip only the anchor
        // name, exactly as when padding is 0.
        const flipPadding = anchorProjected ? 0 : this.padding() * 2;
        let widthFlip = null;
        let heightFlip = null;
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('left') >= 0) {
            const offset = t.point({
                x: -flipPadding,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += flipPadding;
            widthFlip = {
                axis: 'width',
                from: 'left',
                to: 'right',
                offset: offset
            };
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf('right') >= 0) {
            const offset = t.point({
                x: flipPadding,
                y: 0
            });
            newAttrs.width += flipPadding;
            widthFlip = {
                axis: 'width',
                from: 'right',
                to: 'left',
                offset: offset
            };
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('top') >= 0) {
            const offset = t.point({
                x: 0,
                y: -flipPadding
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.height += flipPadding;
            heightFlip = {
                axis: 'height',
                from: 'top',
                to: 'bottom',
                offset: offset
            };
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf('bottom') >= 0) {
            const offset = t.point({
                x: 0,
                y: flipPadding
            });
            newAttrs.height += flipPadding;
            heightFlip = {
                axis: 'height',
                from: 'bottom',
                to: 'top',
                offset: offset
            };
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
        }
        // a staged flip survived only if the bounded size is still negative on
        // its axis
        for (const flip of [
            widthFlip,
            heightFlip
        ])if (flip && newAttrs[flip.axis] < 0 && this._movingAnchorName) {
            this._movingAnchorName = this._movingAnchorName.replace(flip.from, flip.to);
            this._anchorDragOffset.x -= flip.offset.x;
            this._anchorDragOffset.y -= flip.offset.y;
        }
        // base size value doesn't really matter
        // we just need to think about bounding boxes as transforms
        // but how?
        // the idea is that we have a transformed rectangle with the size of "baseSize"
        const baseSize = 10000000;
        const oldTr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
        const newScaleX = newAttrs.width / baseSize;
        const newScaleY = newAttrs.height / baseSize;
        if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
        } else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
        }
        // now lets think we had [old transform] and n ow we have [new transform]
        // Now, the questions is: how can we transform "parent" to go from [old transform] into [new transform]
        // in equation it will be:
        // [delta transform] * [old transform] = [new transform]
        // that means that
        // [delta transform] = [new transform] * [old transform inverted]
        const delta = newTr.multiply(oldTr.invert());
        // Perf: collect unique affected layers and batchDraw each once at the end
        // (was once per node — O(N)).
        const layersToDraw = new Set();
        this._nodes.forEach((node)=>{
            // check to close this issue: https://github.com/konvajs/konva/issues/1957
            // a node can be destroyed during the transformation
            // probably a developer must remove it from transformer
            if (!node.getStage()) // do we need a helping message?
            // Util.error(
            //   'Node is not attached to the stage. This is not allowed. Please attach the node to the stage before transforming. If node was destroyed, make sure to remove it from transformer.'
            // );
            return;
            // for each node we have the same [delta transform]
            // the equations is
            // [delta transform] * [parent transform] * [old local transform] = [parent transform] * [new local transform]
            // and we need to find [new local transform]
            // [new local] = [parent inverted] * [delta] * [parent] * [old local]
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            // skip offset:
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $d4400dec7c2a8326$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            const layer = node.getLayer();
            if (layer) layersToDraw.add(layer);
        });
        this.rotation((0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        // trigger transform event AFTER we update rotation
        this._nodes.forEach((node)=>{
            this._fire('transform', {
                evt: evt,
                target: node
            });
            node._fire('transform', {
                evt: evt,
                target: node
            });
        });
        this._resetTransformCache();
        this.update();
        layersToDraw.add(this.getLayer());
        layersToDraw.forEach((layer)=>layer && layer.batchDraw());
    }
    // deferred to the batch flush when one is open, else synchronous
    _scheduleUpdate() {
        this._updatePending = true;
        (0, $367bbc8f6a40f243$export$85c928794f8d04d4)._runAfterUpdateBatch(this._syncUpdate);
    }
    /**
     * force update of Konva.Transformer.
     * The transformer follows attribute changes of attached nodes and, for an attached group, any change of its descendants.
     * Use it after a change that sets no attribute, for example a `Line` points array mutated in place
     * or a custom `getSelfRect()` that depends on outside state.
     * @method
     * @name Konva.Transformer#forceUpdate
     */ forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    update() {
        // Explicit updates and Transformer configuration changes also refresh
        // styles and layout when the selected nodes' bounds are unchanged.
        this._lastNodeRect = undefined;
        this._update();
    }
    _update() {
        var _a;
        this._updatePending = false;
        const attrs = this._getNodeRect();
        this._updateElements(attrs);
        const draggable = this.nodes().some((node)=>node.draggable());
        if (this._back.draggable() !== draggable) this._back.draggable(draggable);
        const styleFunc = this.anchorStyleFunc();
        if (styleFunc) Object.values(this._anchors).forEach((node)=>node.hasName('_anchor') && styleFunc(node));
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    _updateElements(attrs) {
        const previous = this._lastNodeRect;
        // Only element layout is cached. Drag handling, user callbacks and drawing
        // remain in _update(). Custom styling needs fresh defaults on every update.
        if (previous && !this.anchorStyleFunc() && attrs.x === previous.x && attrs.y === previous.y && attrs.width === previous.width && attrs.height === previous.height && attrs.rotation === previous.rotation) return;
        this._lastNodeRect = {
            ...attrs
        };
        const width = attrs.width;
        const height = attrs.height;
        const enabledAnchors = this.enabledAnchors();
        const resizeEnabled = this.resizeEnabled();
        const padding = this.padding();
        const anchorSize = this.anchorSize();
        const anchors = Object.values(this._anchors).filter((node)=>node.hasName('_anchor'));
        anchors.forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._anchors['top-left'].setAttrs({
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0
        });
        this._anchors['top-center'].setAttrs({
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0
        });
        this._anchors['top-right'].setAttrs({
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0
        });
        this._anchors['middle-left'].setAttrs({
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0
        });
        this._anchors['middle-right'].setAttrs({
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0
        });
        this._anchors['bottom-left'].setAttrs({
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0
        });
        this._anchors['bottom-center'].setAttrs({
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0
        });
        this._anchors['bottom-right'].setAttrs({
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0
        });
        const rotateMode = this.rotateMode();
        const rotaterLine = $801345eab32c3d30$var$getRotaterLine(this, width, height);
        this._anchors['rotater'].setAttrs({
            x: rotaterLine.endX,
            y: rotaterLine.endY,
            visible: this.rotateEnabled() && rotateMode !== 'corners'
        });
        // each zone is a square that touches its corner from the outside
        const zoneSize = anchorSize * 2;
        const zonesVisible = this.rotateEnabled() && rotateMode !== 'handle';
        const near = -padding - zoneSize;
        $801345eab32c3d30$var$ROTATE_ZONE_NAMES.forEach((name)=>{
            this._anchors[name].setAttrs({
                x: name.includes('left') ? near : width + padding,
                y: name.includes('top') ? near : height + padding,
                width: zoneSize,
                height: zoneSize,
                visible: zonesVisible
            });
        });
        this._back.setAttrs({
            width: width,
            height: height,
            visible: this.borderEnabled() || this.shouldOverdrawWholeArea(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0
        });
    }
    /**
     * determine if transformer is in active transform
     * @method
     * @name Konva.Transformer#isTransforming
     * @returns {Boolean}
     */ isTransforming() {
        return this._transforming;
    }
    /**
     * Stop active transform action
     * @method
     * @name Konva.Transformer#stopTransform
     * @returns {Boolean}
     */ stopTransform() {
        if (this._transforming) this._removeEvents();
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = '');
        (0, $644b7f3bf259f4bd$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    // Transformer manages its own internal children (anchors, back shape).
    // Adding external nodes as children can cause infinite recursion because
    // the Transformer's absoluteTransform depends on nodes' transforms.
    // Use tr.nodes([node]) to attach nodes instead.
    add(...children) {
        if (this._elementsCreated) {
            (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('You cannot add external nodes to the Transformer. Use tr.nodes([node]) instead.');
            return this;
        }
        return super.add(...children);
    }
    // do not work as a container
    // we will recreate inner nodes manually
    toObject() {
        return (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    // overwrite clone to NOT use method from Container
    clone(obj) {
        const node = (0, $367bbc8f6a40f243$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect(config) {
        this._syncUpdate();
        if (this.nodes().length > 0) return super.getClientRect(config);
        else // if we are detached return zero size
        // so it will be skipped in calculations
        return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
$801345eab32c3d30$export$f993aef960936087.isTransforming = ()=>{
    return $801345eab32c3d30$var$activeTransformers.size > 0;
};
function $801345eab32c3d30$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('enabledAnchors value should be an array');
    if (val instanceof Array) val.forEach(function(name) {
        if ($801345eab32c3d30$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Unknown anchor name: ' + name + '. Available names are: ' + $801345eab32c3d30$var$ANCHORS_NAMES.join(', '));
    });
    return val || [];
}
$801345eab32c3d30$export$f993aef960936087.prototype.className = 'Transformer';
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($801345eab32c3d30$export$f993aef960936087);
/**
 * get/set enabled handlers
 * @name Konva.Transformer#enabledAnchors
 * @method
 * @param {Array} array
 * @returns {Array}
 * @example
 * // get list of handlers
 * var enabledAnchors = transformer.enabledAnchors();
 *
 * // set handlers
 * transformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'enabledAnchors', $801345eab32c3d30$var$ANCHORS_NAMES, $801345eab32c3d30$var$validateAnchors);
/**
 * get/set flip enabled
 * @name Konva.Transformer#flipEnabled
 * @method
 * @param {Boolean} flag
 * @returns {Boolean}
 * @example
 * // get flip enabled property
 * var flipEnabled = transformer.flipEnabled();
 *
 * // set flip enabled property
 * transformer.flipEnabled(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'flipEnabled', true, (0, $d7c0e5ae0fe3f9a6$export$147fc8b6cd20fda1)());
/**
 * get/set resize ability. If false it will automatically hide resizing handlers
 * @name Konva.Transformer#resizeEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get
 * var resizeEnabled = transformer.resizeEnabled();
 *
 * // set
 * transformer.resizeEnabled(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'resizeEnabled', true);
/**
 * get/set anchor size. Default is 10
 * @name Konva.Transformer#anchorSize
 * @method
 * @param {Number} size
 * @returns {Number}
 * @example
 * // get
 * var anchorSize = transformer.anchorSize();
 *
 * // set
 * transformer.anchorSize(20)
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorSize', 10, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set ability to rotate.
 * @name Konva.Transformer#rotateEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get
 * var rotateEnabled = transformer.rotateEnabled();
 *
 * // set
 * transformer.rotateEnabled(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateEnabled', true);
/**
 * get/set visibility of a little line that connects transformer and rotate anchor.
 * @name Konva.Transformer#rotateLineVisible
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get
 * var rotateLineVisible = transformer.rotateLineVisible();
 *
 * // set
 * transformer.rotateLineVisible(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateLineVisible', true);
/**
 * get/set rotation snaps angles.
 * @name Konva.Transformer#rotationSnaps
 * @method
 * @param {Array} array
 * @returns {Array}
 * @example
 * // get
 * var rotationSnaps = transformer.rotationSnaps();
 *
 * // set
 * transformer.rotationSnaps([0, 90, 180, 270]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotationSnaps', []);
/**
 * get/set distance for rotation handler
 * @name Konva.Transformer#rotateAnchorOffset
 * @method
 * @param {Number} offset
 * @returns {Number}
 * @example
 * // get
 * var rotateAnchorOffset = transformer.rotateAnchorOffset();
 *
 * // set
 * transformer.rotateAnchorOffset(100);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateAnchorOffset', 50, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set the angle (in degrees) of the rotation anchor position around the bounding box.
 * 0 = top-center (default), 90 = middle-right, 180 = bottom-center, -90 = middle-left
 * @name Konva.Transformer#rotateAnchorAngle
 * @method
 * @param {Number} angle
 * @returns {Number}
 * @example
 * // get
 * var rotateAnchorAngle = transformer.rotateAnchorAngle();
 *
 * // set rotation anchor to the right side
 * transformer.rotateAnchorAngle(90);
 *
 * // set rotation anchor to the bottom
 * transformer.rotateAnchorAngle(180);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateAnchorAngle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set rotation anchor cursor
 * @name Konva.Transformer#rotateAnchorCursor
 * @method
 * @param {String} cursorName
 * @returns {String}
 * @example
 * // get
 * var currentRotationAnchorCursor = transformer.rotateAnchorCursor();
 *
 * // set
 * transformer.rotateAnchorCursor('grab');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateAnchorCursor', 'crosshair');
/**
 * get/set how the user rotates the nodes. 'handle' shows the rotate anchor,
 * 'corners' makes invisible zones just outside the box corners rotate,
 * 'both' enables both. Hold Shift while rotating to snap to 15 degree steps, unless shiftBehavior is 'none'.
 * While a corner zone rotates, `getActiveAnchor()` returns its name, such as 'rotater-top-left'.
 * @name Konva.Transformer#rotateMode
 * @method
 * @param {String} mode
 * @returns {String}
 * @example
 * // get
 * var rotateMode = transformer.rotateMode();
 *
 * // set
 * transformer.rotateMode('corners');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotateMode', 'handle');
/**
 * get/set distance for rotation tolerance
 * @name Konva.Transformer#rotationSnapTolerance
 * @method
 * @param {Number} tolerance
 * @returns {Number}
 * @example
 * // get
 * var rotationSnapTolerance = transformer.rotationSnapTolerance();
 *
 * // set
 * transformer.rotationSnapTolerance(100);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'rotationSnapTolerance', 5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set visibility of border
 * @name Konva.Transformer#borderEnabled
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get
 * var borderEnabled = transformer.borderEnabled();
 *
 * // set
 * transformer.borderEnabled(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderEnabled', true);
/**
 * get/set anchor stroke color
 * @name Konva.Transformer#anchorStroke
 * @method
 * @param {String} strokeColor
 * @returns {String}
 * @example
 * // get
 * var anchorStroke = transformer.anchorStroke();
 *
 * // set
 * transformer.anchorStroke('red');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorStroke', 'rgb(0, 161, 255)');
/**
 * get/set anchor stroke width
 * @name Konva.Transformer#anchorStrokeWidth
 * @method
 * @param {Number} anchorStrokeWidth
 * @returns {Number}
 * @example
 * // get
 * var anchorStrokeWidth = transformer.anchorStrokeWidth();
 *
 * // set
 * transformer.anchorStrokeWidth(3);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorStrokeWidth', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set anchor fill color
 * @name Konva.Transformer#anchorFill
 * @method
 * @param {String} anchorFill
 * @returns {String}
 * @example
 * // get
 * var anchorFill = transformer.anchorFill();
 *
 * // set
 * transformer.anchorFill('red');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorFill', 'white');
/**
 * get/set anchor corner radius
 * @name Konva.Transformer#anchorCornerRadius
 * @method
 * @param {Number} radius
 * @returns {Number}
 * @example
 * // get
 * var anchorCornerRadius = transformer.anchorCornerRadius();
 *
 * // set
 * transformer.anchorCornerRadius(3);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorCornerRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set border stroke color
 * @name Konva.Transformer#borderStroke
 * @method
 * @param {Boolean} enabled
 * @returns {Boolean}
 * @example
 * // get
 * var borderStroke = transformer.borderStroke();
 *
 * // set
 * transformer.borderStroke('red');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderStroke', 'rgb(0, 161, 255)');
/**
 * get/set border stroke width
 * @name Konva.Transformer#borderStrokeWidth
 * @method
 * @param {Number} strokeWidth
 * @returns {Number}
 * @example
 * // get
 * var borderStrokeWidth = transformer.borderStrokeWidth();
 *
 * // set
 * transformer.borderStrokeWidth(3);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderStrokeWidth', 1, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set border dash array
 * @name Konva.Transformer#borderDash
 * @method
 * @param {Array} dash array
 * @returns {Array}
 * @example
 * // get
 * var borderDash = transformer.borderDash();
 *
 * // set
 * transformer.borderDash([2, 2]);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'borderDash');
/**
 * get/set should we keep ratio while resize anchors at corners
 * @name Konva.Transformer#keepRatio
 * @method
 * @param {Boolean} keepRatio
 * @returns {Boolean}
 * @example
 * // get
 * var keepRatio = transformer.keepRatio();
 *
 * // set
 * transformer.keepRatio(false);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'keepRatio', true);
/**
 * get/set how to react on skift key while resizing anchors at corners
 * @name Konva.Transformer#shiftBehavior
 * @method
 * @param {String} shiftBehavior
 * @returns {String}
 * @example
 * // get
 * var shiftBehavior = transformer.shiftBehavior();
 *
 * // set
 * transformer.shiftBehavior('none');
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'shiftBehavior', 'default');
/**
 * get/set should we resize relative to node's center?
 * @name Konva.Transformer#centeredScaling
 * @method
 * @param {Boolean} centeredScaling
 * @returns {Boolean}
 * @example
 * // get
 * var centeredScaling = transformer.centeredScaling();
 *
 * // set
 * transformer.centeredScaling(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'centeredScaling', false);
/**
 * get/set should we think about stroke while resize? Good to use when a shape has strokeScaleEnabled = false
 * default is false
 * @name Konva.Transformer#ignoreStroke
 * @method
 * @param {Boolean} ignoreStroke
 * @returns {Boolean}
 * @example
 * // get
 * var ignoreStroke = transformer.ignoreStroke();
 *
 * // set
 * transformer.ignoreStroke(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'ignoreStroke', false);
/**
 * get/set padding
 * @name Konva.Transformer#padding
 * @method
 * @param {Number} padding
 * @returns {Number}
 * @example
 * // get
 * var padding = transformer.padding();
 *
 * // set
 * transformer.padding(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'padding', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set attached nodes of the Transformer. Transformer will adapt to their size and listen to their events
 * @method
 * @name Konva.Transformer#nodes
 * @returns {Konva.Node}
 * @example
 * // get
 * const nodes = transformer.nodes();
 *
 * // set
 * transformer.nodes([rect, circle]);
 *
 * // push new item:
 * const oldNodes = transformer.nodes();
 * const newNodes = oldNodes.concat([newShape]);
 * // it is important to set new array instance (and concat method above will create it)
 * transformer.nodes(newNodes);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'nodes');
// @ts-ignore
// deprecated
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'node');
/**
 * get/set bounding box function. **IMPORTANT!** boundBoxFunc operates in absolute coordinates.
 *  Both boxes are `{ x, y, width, height, rotation }`, with the rotation in radians.
 * @name Konva.Transformer#boundBoxFunc
 * @method
 * @param {Function} func
 * @returns {Function}
 * @example
 * // get
 * var boundBoxFunc = transformer.boundBoxFunc();
 *
 * // set
 * transformer.boundBoxFunc(function(oldBox, newBox) {
 *   // width and height of the boxes are corresponding to total absolute width and height of all nodes combined
 *   // so it includes scale of the node.
 *   if (newBox.width > 200) {
 *     return oldBox;
 *   }
 *   return newBox;
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'boundBoxFunc');
/**
 * get/set dragging func for transformer anchors
 * @name Konva.Transformer#anchorDragBoundFunc
 * @method
 * @param {Function} func
 * @returns {Function}
 * @example
 * // get
 * var anchorDragBoundFunc = transformer.anchorDragBoundFunc();
 *
 * // set
 * transformer.anchorDragBoundFunc(function(oldAbsPos, newAbsPos, event) {
 *  return {
 *   x: 0,
 *   y: newAbsolutePosition.y
 *  }
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorDragBoundFunc');
/**
 * get/set styling function for transformer anchors to overwrite default styles
 * @name Konva.Transformer#anchorStyleFunc
 * @method
 * @param {Function} func
 * @returns {Function}
 * @example
 * // get
 * var anchorStyleFunc = transformer.anchorStyleFunc();
 *
 * // set
 * transformer.anchorStyleFunc(function(anchor) {
 *  // anchor is a simple Konva.Rect instance
 *  // it will be executed AFTER all attributes are set, like 'anchorStrokeWidth' or 'anchorFill'
 *  if (anchor.hasName('rotater')) {
 *    // make rotater anchor filled black and looks like a circle
 *    anchor.fill('black');
 *    anchor.cornerRadius(anchor.width() / 2);
 *  }
 * });
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'anchorStyleFunc');
/**
 * using this setting you can drag transformer group by dragging empty space between attached nodes
 * shouldOverdrawWholeArea = true may temporary disable all events on attached nodes
 * @name Konva.Transformer#shouldOverdrawWholeArea
 * @method
 * @param {Boolean} shouldOverdrawWholeArea
 * @returns {Boolean}
 * @example
 * // get
 * var shouldOverdrawWholeArea = transformer.shouldOverdrawWholeArea();
 *
 * // set
 * transformer.shouldOverdrawWholeArea(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'shouldOverdrawWholeArea', false);
/**
 * If you have just one attached node to Transformer it will set its initial rotation to the rotation of that node.
 * In some cases you may need to set a different rotation.
 * @name Konva.Transformer#useSingleNodeRotation
 * @method
 * @param {Boolean} useSingleNodeRotation
 * @returns {Boolean}
 * @example
 * // set flag to false
 * transformer.useSingleNodeRotation(false);
 * // attach a shape
 * transformer.nodes([shape]);
 * transformer.rotation(45);
 * transformer.update();
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($801345eab32c3d30$export$f993aef960936087, 'useSingleNodeRotation', true);
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($801345eab32c3d30$export$f993aef960936087, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors'
});






class $38218507e674999c$export$28718c7785907330 extends (0, $9081147451080c7d$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, Math.abs(this.radius()), 0, (0, $8c8384c27430fce8$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return Math.abs(this.radius()) * 2;
    }
    getHeight() {
        return Math.abs(this.radius()) * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$38218507e674999c$export$28718c7785907330.prototype.className = 'Wedge';
$38218507e674999c$export$28718c7785907330.prototype._centroid = true;
$38218507e674999c$export$28718c7785907330.prototype._attrsAffectingSize = [
    'radius'
];
(0, $8c8384c27430fce8$export$f7a70d87a5e829eb)($38218507e674999c$export$28718c7785907330, true);
/**
 * get/set radius
 * @name Konva.Wedge#radius
 * @method
 * @param {Number} radius
 * @returns {Number}
 * @example
 * // get radius
 * var radius = wedge.radius();
 *
 * // set radius
 * wedge.radius(10);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($38218507e674999c$export$28718c7785907330, 'radius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set angle in degrees
 * @name Konva.Wedge#angle
 * @method
 * @param {Number} angle
 * @returns {Number}
 * @example
 * // get angle
 * var angle = wedge.angle();
 *
 * // set angle
 * wedge.angle(20);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($38218507e674999c$export$28718c7785907330, 'angle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)());
/**
 * get/set clockwise flag
 * @name Konva.Wedge#clockwise
 * @method
 * @param {Boolean} clockwise
 * @returns {Boolean}
 * @example
 * // get clockwise flag
 * var clockwise = wedge.clockwise();
 *
 * // draw wedge counter-clockwise
 * wedge.clockwise(false);
 *
 * // draw wedge clockwise
 * wedge.clockwise(true);
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter($38218507e674999c$export$28718c7785907330, 'clockwise', false);
(0, $abe0ad8331aee635$export$8354032f3852ec50).backCompat($38218507e674999c$export$28718c7785907330, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});





/*
 the Gauss filter
 master repo: https://github.com/pavelpower/kineticjsGaussFilter
*/ /*

     StackBlur - a fast almost Gaussian Blur For Canvas

     Version:   0.5
     Author:    Mario Klingemann
     Contact:   mario@quasimondo.com
     Website:   http://www.quasimondo.com/StackBlurForCanvas
     Twitter:   @quasimondo

     In case you find this class useful - especially in commercial projects -
     I am not totally unhappy for a small donation to my PayPal account
     mario@quasimondo.de

     Or support me on flattr:
     https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

     Copyright (c) 2010 Mario Klingemann

     Permission is hereby granted, free of charge, to any person
     obtaining a copy of this software and associated documentation
     files (the "Software"), to deal in the Software without
     restriction, including without limitation the rights to use,
     copy, modify, merge, publish, distribute, sublicense, and/or sell
     copies of the Software, and to permit persons to whom the
     Software is furnished to do so, subject to the following
     conditions:

     The above copyright notice and this permission notice shall be
     included in all copies or substantial portions of the Software.

     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
     OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
     HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
     WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
     FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
     OTHER DEALINGS IN THE SOFTWARE.
     * @license MIT
     */ function $115c1355c0a3c8a8$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
const $115c1355c0a3c8a8$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
const $115c1355c0a3c8a8$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
// the horizontal pass blurs premultiplied colour, otherwise transparent
// pixels bleed their colour into their neighbours; the vertical pass
// unpremultiplies again
function $115c1355c0a3c8a8$var$premultiply(channel, alpha) {
    return alpha === 255 ? channel : channel * alpha / 255;
}
// Preserve the maximum logical radius; high-DPI caches need larger kernels.
const $115c1355c0a3c8a8$var$MAX_RADIUS = 180;
function $115c1355c0a3c8a8$var$filterGaussBlurRGBA(imageData, radius) {
    const pixels = imageData.data, width = imageData.width, height = imageData.height;
    let p, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $115c1355c0a3c8a8$var$BlurStack(), // Use floating-point normalization to avoid 32-bit overflow at high DPI.
    normalization = radius <= $115c1355c0a3c8a8$var$MAX_RADIUS ? $115c1355c0a3c8a8$var$mul_table[radius] / 2 ** $115c1355c0a3c8a8$var$shg_table[radius] : 1 / (radiusPlus1 * radiusPlus1);
    let stackEnd = null, stack = stackStart, stackIn = null, stackOut = null;
    for(let i = 1; i < div; i++){
        stack = stack.next = new $115c1355c0a3c8a8$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(let y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        pa = pixels[yi + 3];
        pr = $115c1355c0a3c8a8$var$premultiply(pixels[yi], pa);
        pg = $115c1355c0a3c8a8$var$premultiply(pixels[yi + 1], pa);
        pb = $115c1355c0a3c8a8$var$premultiply(pixels[yi + 2], pa);
        r_out_sum = radiusPlus1 * pr;
        g_out_sum = radiusPlus1 * pg;
        b_out_sum = radiusPlus1 * pb;
        a_out_sum = radiusPlus1 * pa;
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(let i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            pa = pixels[p + 3];
            r_sum += (stack.r = pr = $115c1355c0a3c8a8$var$premultiply(pixels[p], pa)) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = $115c1355c0a3c8a8$var$premultiply(pixels[p + 1], pa)) * rbs;
            b_sum += (stack.b = pb = $115c1355c0a3c8a8$var$premultiply(pixels[p + 2], pa)) * rbs;
            a_sum += (stack.a = pa) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let x = 0; x < width; x++){
            pixels[yi] = Math.floor(r_sum * normalization);
            pixels[yi + 1] = Math.floor(g_sum * normalization);
            pixels[yi + 2] = Math.floor(b_sum * normalization);
            pixels[yi + 3] = Math.floor(a_sum * normalization);
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            pa = pixels[p + 3];
            r_in_sum += stackIn.r = $115c1355c0a3c8a8$var$premultiply(pixels[p], pa);
            g_in_sum += stackIn.g = $115c1355c0a3c8a8$var$premultiply(pixels[p + 1], pa);
            b_in_sum += stackIn.b = $115c1355c0a3c8a8$var$premultiply(pixels[p + 2], pa);
            a_in_sum += stackIn.a = pa;
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(let x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        // the pass primes from the second row, which a 1-pixel-tall image lacks
        let yp = Math.min(1, heightMinus1) * width;
        for(let i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = Math.floor(a_sum * normalization);
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = Math.floor(r_sum * normalization) * pa;
                pixels[p + 1] = Math.floor(g_sum * normalization) * pa;
                pixels[p + 2] = Math.floor(b_sum * normalization) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $115c1355c0a3c8a8$export$975a268f2c733e4 = function Blur(imageData, pixelRatio = 1) {
    const radius = Math.round(Math.min(this.blurRadius(), $115c1355c0a3c8a8$var$MAX_RADIUS) * pixelRatio);
    if (radius > 0) $115c1355c0a3c8a8$var$filterGaussBlurRGBA(imageData, radius);
};
// CSS blur(σ) where the 2D context has no `filter`. A stack blur of radius 2σ
// stays within about 10/255 alpha of the native Gaussian in Chromium, Firefox
// and WebKit. Like the native filter, it has no radius limit and reads the
// area beyond the image as transparent: a 1px transparent border is what the
// blur repeats past the edges.
(0, $367bbc8f6a40f243$export$2e200cc9b9e69000)('blur', (imageData, sigma, pixelRatio)=>{
    const radius = Math.round(2 * sigma * pixelRatio);
    if (radius <= 0) return;
    const { width: width, height: height, data: data } = imageData, row = width * 4, framedRow = row + 8, framed = {
        width: width + 2,
        height: height + 2,
        data: new Uint8ClampedArray(framedRow * (height + 2))
    };
    for(let y = 0; y < height; y++)framed.data.set(data.subarray(y * row, y * row + row), (y + 1) * framedRow + 4);
    $115c1355c0a3c8a8$var$filterGaussBlurRGBA(framed, radius);
    for(let y = 0; y < height; y++){
        const start = (y + 1) * framedRow + 4;
        data.set(framed.data.subarray(start, start + row), y * row);
    }
});
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'blurRadius', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set blur radius. Use with {@link Konva.Filters.Blur} filter
 * @name Konva.Node#blurRadius
 * @method
 * @param {Integer} radius
 * @returns {Integer}
 */ 





const $ced669b61682093f$export$a2d0d82739cac11f = function(imageData) {
    const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        // red
        data[i] += brightness;
        // green
        data[i + 1] += brightness;
        // blue
        data[i + 2] += brightness;
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'brightness', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set filter brightness. With {@link Konva.Filters.Brighten} it is a number between -1 and 1
 *  added to every channel: positive values brighten the pixels and negative values darken them.
 *  With {@link Konva.Filters.Brightness} it is a CSS-like multiplier: 1 is no change, 1.5 is 50% brighter.
 *  Both filters leave pixels unchanged when the attribute is unset. An explicit 0 makes Brightness black.
 * @name Konva.Node#brightness
 * @method
 * @param {Number} brightness
 * @returns {Number}
 */ 




const $d2cbac3f9294abf4$export$98835ff3df8927e5 = function(imageData) {
    $d2cbac3f9294abf4$var$brighten(imageData, this.attrs.brightness === undefined ? 1 : this.brightness());
};
// CSS brightness(v) is the same multiplier.
(0, $367bbc8f6a40f243$export$2e200cc9b9e69000)('brightness', $d2cbac3f9294abf4$var$brighten);
function $d2cbac3f9294abf4$var$brighten(imageData, brightness) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        // red
        data[i] = Math.min(255, data[i] * brightness);
        // green
        data[i + 1] = Math.min(255, data[i + 1] * brightness);
        // blue
        data[i + 2] = Math.min(255, data[i + 2] * brightness);
    }
}





const $915438a9a02e65de$export$656ae42051d0ca86 = function(imageData) {
    $915438a9a02e65de$var$applyContrast(imageData, Math.pow((this.contrast() + 100) / 100, 2));
};
// CSS contrast(v) scales the distance from mid-grey by v.
(0, $367bbc8f6a40f243$export$2e200cc9b9e69000)('contrast', $915438a9a02e65de$var$applyContrast);
function $915438a9a02e65de$var$applyContrast(imageData, adjust) {
    const data = imageData.data, nPixels = data.length;
    let red = 150, green = 150, blue = 150;
    for(let i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        //Red channel
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        //Green channel
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        //Blue channel
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
}
/**
 * get/set filter contrast.  The contrast is a number between -100 and 100.
 * Use with {@link Konva.Filters.Contrast} filter.
 * @name Konva.Node#contrast
 * @method
 * @param {Number} contrast value between -100 and 100
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'contrast', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);






const $2b42f6c4d038b489$export$3c8699b389eb838 = function(imageData) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const data = imageData.data;
    const w = imageData.width;
    const h = imageData.height;
    // Inputs from Konva node
    const strength01 = Math.min(1, Math.max(0, (_b = (_a = this.embossStrength) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : 0.5)); // [0..1]
    const whiteLevel01 = Math.min(1, Math.max(0, (_d = (_c = this.embossWhiteLevel) === null || _c === void 0 ? void 0 : _c.call(this)) !== null && _d !== void 0 ? _d : 0.5)); // [0..1]
    // Convert string direction to degrees
    const directionMap = {
        'top-left': 315,
        top: 270,
        'top-right': 225,
        right: 180,
        'bottom-right': 135,
        bottom: 90,
        'bottom-left': 45,
        left: 0
    };
    const direction = (_f = (_e = this.embossDirection) === null || _e === void 0 ? void 0 : _e.call(this)) !== null && _f !== void 0 ? _f : 'top-left';
    let directionDeg = directionMap[direction]; // degrees
    if (directionDeg === undefined) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).warn('Unknown emboss direction: "' + direction + '". Using "top-left".');
        directionDeg = directionMap['top-left'];
    }
    const blend = !!((_h = (_g = this.embossBlend) === null || _g === void 0 ? void 0 : _g.call(this)) !== null && _h !== void 0 ? _h : false);
    // Internal mapping:
    // -  "strength" was 0..10; we honor your 0..1 API and scale accordingly.
    // - Sobel directional response is roughly in [-1020..1020] for 8-bit luminance; scale to ~±128.
    const strength = strength01 * 10;
    const bias = whiteLevel01 * 255;
    const dirRad = directionDeg * Math.PI / 180;
    const cx = Math.cos(dirRad);
    // the angles above are measured with y up, but image rows go down
    const cy = -Math.sin(dirRad);
    const SCALE = 128 / 1020 * strength; // ≈0.1255 * strength
    // Precompute luminance (Rec.709)
    const lum = new Float32Array(w * h);
    for(let p = 0, i = 0; i < data.length; i += 4, p++)lum[p] = 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
    // Sobel kernels (flattened)
    const Gx = [
        -1,
        0,
        1,
        -2,
        0,
        2,
        -1,
        0,
        1
    ];
    const Gy = [
        -1,
        -2,
        -1,
        0,
        0,
        0,
        1,
        2,
        1
    ];
    const clamp8 = (v)=>v < 0 ? 0 : v > 255 ? 255 : v;
    // Extend the edge pixels so the same kernel applies at every position.
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        let sx = 0, sy = 0, k = 0;
        for(let dy = -1; dy <= 1; dy++){
            const row = Math.max(0, Math.min(h - 1, y + dy)) * w;
            for(let dx = -1; dx <= 1; dx++, k++){
                const sample = lum[row + Math.max(0, Math.min(w - 1, x + dx))];
                sx += sample * Gx[k];
                sy += sample * Gy[k];
            }
        }
        const p = y * w + x;
        const r = cx * sx + cy * sy; // directional response
        const outGray = clamp8(bias + r * SCALE); // biased, scaled, clamped
        const o = p * 4;
        if (blend) {
            // Add the emboss "relief" around chosen bias to original RGB
            const delta = outGray - bias; // symmetric around whiteLevel
            data[o] = clamp8(data[o] + delta);
            data[o + 1] = clamp8(data[o + 1] + delta);
            data[o + 2] = clamp8(data[o + 2] + delta);
        } else // Grayscale embossed output
        data[o] = data[o + 1] = data[o + 2] = outGray;
    }
    return imageData;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossStrength', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set emboss strength. Use with {@link Konva.Filters.Emboss} filter.
 * @name Konva.Node#embossStrength
 * @method
 * @param {Number} level between 0 and 1.  Default is 0.5
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossWhiteLevel', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set emboss white level. Use with {@link Konva.Filters.Emboss} filter.
 * @name Konva.Node#embossWhiteLevel
 * @method
 * @param {Number} embossWhiteLevel between 0 and 1.  Default is 0.5
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossDirection', 'top-left', undefined, (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set emboss direction. Use with {@link Konva.Filters.Emboss} filter.
 * @name Konva.Node#embossDirection
 * @method
 * @param {String} embossDirection can be top-left, top, top-right, right, bottom-right, bottom, bottom-left or left
 *   The default is top-left
 * @returns {String}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'embossBlend', false, undefined, (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set emboss blend. Use with {@link Konva.Filters.Emboss} filter.
 * @name Konva.Node#embossBlend
 * @method
 * @param {Boolean} embossBlend
 * @returns {Boolean}
 */ 





function $2ad1b73e774f59bb$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    // Compute the range of the data
    const fromRange = fromMax - fromMin, toRange = toMax - toMin;
    // If either range is 0, then the value can only be mapped to 1 value
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    // (1) untranslate, (2) unscale, (3) rescale, (4) retranslate
    let toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $2ad1b73e774f59bb$export$5cb8e8388f951d6f = function(imageData) {
    const data = imageData.data, nSubPixels = data.length;
    let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b;
    // If we are not enhancing anything - don't do any computation
    const enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    // 1st Pass - find the min and max for each channel:
    for(let i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    //a = data[i + 3];
    //if (a < aMin) { aMin = a; } else
    //if (a > aMax) { aMax = a; }
    }
    // If there is only 1 level - don't remap
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
    // If the enhancement is positive - stretch the histogram
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    // If the enhancement is negative -   compress the histogram
    } else {
        const rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        const gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        const bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    // Pass 2 - remap everything, except the alpha
    for(let i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $2ad1b73e774f59bb$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $2ad1b73e774f59bb$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $2ad1b73e774f59bb$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    //data[i + 3] = remap(data[i + 3], aMin, aMax, aGoalMin, aGoalMax);
    }
};
/**
 * get/set enhance. Use with {@link Konva.Filters.Enhance} filter. -1 to 1 values
 * @name Konva.Node#enhance
 * @method
 * @param {Float} amount
 * @returns {Float}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'enhance', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);


/**
 * Grayscale Filter
 * @function
 * @memberof Konva.Filters
 * @param {Object} imageData
 * @example
 * node.cache();
 * node.filters([Konva.Filters.Grayscale]);
 */ const $d01fff91fba4df8f$export$e2b0a794e83ca071 = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        const brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        // red
        data[i] = brightness;
        // green
        data[i + 1] = brightness;
        // blue
        data[i + 2] = brightness;
    }
};





(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'hue', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
 * @name Konva.Node#hue
 * @method
 * @param {Number} hue value between 0 and 359
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'saturation', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
 * @name Konva.Node#saturation
 * @method
 * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'luminance', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
const $4b70970df87d7d14$export$46d8b0f9bc8f87a2 = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = (this.hue() % 360 + 360) % 360, l = this.luminance() * 127;
    // Basis for the technique used:
    // http://beesbuzz.biz/code/hsv_color_transforms.php
    // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
    // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
    // H is the hue shift in degrees (0 to 360)
    // vsu = V*S*cos(H*PI/180);
    // vsw = V*S*sin(H*PI/180);
    //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
    //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
    //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
    // Precompute the values in the matrix:
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    // (result spot)(source spot)
    const rr = 0.299 * v + 0.701 * vsu + 0.168 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.292 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.588 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.203 * vsw;
    let r, g, b, a;
    for(let i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a; // alpha
    }
};





const $a9eed7ce687c1218$export$d2edaecd208aed43 = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = (this.hue() % 360 + 360) % 360;
    // Basis for the technique used:
    // http://beesbuzz.biz/code/hsv_color_transforms.php
    // V is the value multiplier (1 for none, 2 for double, 0.5 for half)
    // S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
    // H is the hue shift in degrees (0 to 360)
    // vsu = V*S*cos(H*PI/180);
    // vsw = V*S*sin(H*PI/180);
    //[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
    //[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
    //[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
    // Precompute the values in the matrix:
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    // (result spot)(source spot)
    const rr = 0.299 * v + 0.701 * vsu + 0.168 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.292 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.588 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.203 * vsw;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a; // alpha
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'hue', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
 * @name Konva.Node#hue
 * @method
 * @param {Number} hue value between 0 and 359
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'saturation', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
 * @name Konva.Node#saturation
 * @method
 * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
 * @returns {Number}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'value', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set hsv value. Use with {@link Konva.Filters.HSV} filter.
 * @name Konva.Node#value
 * @method
 * @param {Number} value 0 is no change, -1.0 halves the value, 1.0 doubles, etc..
 * @returns {Number}
 */ 


/**
 * Invert Filter
 * @function
 * @memberof Konva.Filters
 * @param {Object} imageData
 * @example
 * node.cache();
 * node.filters([Konva.Filters.Invert]);
 */ const $15eda2f50977af8f$export$1073348d81b17440 = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        // red
        data[i] = 255 - data[i];
        // green
        data[i + 1] = 255 - data[i + 1];
        // blue
        data[i + 2] = 255 - data[i + 2];
    }
};





/*
 * ToPolar Filter. Converts image data to polar coordinates. Performs
 *  w*h*4 pixel reads and w*h pixel writes. The r axis is placed along
 *  what would be the y axis and the theta axis along the x axis.
 * @function
 * @author ippo615
 * @memberof Konva.Filters
 * @param {ImageData} src, the source image data (what will be transformed)
 * @param {ImageData} dst, the destination image data (where it will be saved)
 * @param {Object} opt
 * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
 *  default is in the middle
 * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
 *  default is in the middle
 */ const $6c6b8bc9d19c96ee$var$ToPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    // Find the largest radius
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    // We'll be using y as the radius, and x as the angle (theta=t)
    const rSize = ySize, tSize = xSize;
    // We want to cover all angles (0-360) and we need to convert to
    // radians (*PI/180)
    const conversion = 360 / tSize * Math.PI / 180;
    // var x1, x2, x1i, x2i, y1, y2, y1i, y2i, scale;
    for(let theta = 0; theta < tSize; theta += 1){
        const sin = Math.sin(theta * conversion);
        const cos = Math.cos(theta * conversion);
        for(let radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            let i = (y * xSize + x) * 4;
            const r = srcPixels[i + 0];
            const g = srcPixels[i + 1];
            const b = srcPixels[i + 2];
            const a = srcPixels[i + 3];
            // Store it
            //i = (theta * xSize  +  radius) * 4;
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
/*
 * FromPolar Filter. Converts image data from polar coordinates back to rectangular.
 *  Performs w*h*4 pixel reads and w*h pixel writes.
 * @function
 * @author ippo615
 * @memberof Konva.Filters
 * @param {ImageData} src, the source image data (what will be transformed)
 * @param {ImageData} dst, the destination image data (where it will be saved)
 * @param {Object} opt
 * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
 *  default is in the middle
 * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
 *  default is in the middle
 * @param {Number} [opt.polarRotation] amount to rotate the image counterclockwis,
 *  0 is no rotation, 360 degrees is a full rotation
 */ const $6c6b8bc9d19c96ee$var$FromPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    // Find the largest radius
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    // We'll be uisng x as the radius, and y as the angle (theta=t)
    const rSize = ySize, tSize = xSize, phaseShift = opt.polarRotation || 0;
    // We need to convert to degrees and we need to make sure
    // it's between (0-360)
    // var conversion = tSize/360*180/Math.PI;
    //var conversion = tSize/360*180/Math.PI;
    let x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        const dx = x - xMid;
        const dy = y - yMid;
        const radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        let theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        let i = (y1 * xSize + x1) * 4;
        const r = srcPixels[i + 0];
        const g = srcPixels[i + 1];
        const b = srcPixels[i + 2];
        const a = srcPixels[i + 3];
        // Store it
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $6c6b8bc9d19c96ee$export$e731e8a0fd067155 = function(imageData) {
    const xSize = imageData.width, ySize = imageData.height;
    let x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    let power = Math.round(this.kaleidoscopePower());
    const angle = Math.round(this.kaleidoscopeAngle());
    const offset = Math.floor(xSize * ((angle % 360 + 360) % 360) / 360);
    if (power < 1) return;
    const scratchData = {
        width: xSize,
        height: ySize,
        data: new Uint8ClampedArray(xSize * ySize * 4)
    };
    // Convert the original to polar coordinates.
    $6c6b8bc9d19c96ee$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    // Determine how big each section will be, if it's too small
    // make it bigger
    let minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    let sectionSize = minSectionSize;
    // Copy the offset region to 0
    // Depending on the size of filter and location of the offset we may need
    // to copy the section backwards to prevent it from rewriting itself
    let xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    // Perform the actual effect
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    // Convert back from polar coordinates
    $6c6b8bc9d19c96ee$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
/**
 * get/set kaleidoscope power. Use with {@link Konva.Filters.Kaleidoscope} filter.
 * @name Konva.Node#kaleidoscopePower
 * @method
 * @param {Integer} power of kaleidoscope
 * @returns {Integer}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'kaleidoscopePower', 2, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set kaleidoscope angle. Use with {@link Konva.Filters.Kaleidoscope} filter.
 * @name Konva.Node#kaleidoscopeAngle
 * @method
 * @param {Integer} degrees
 * @returns {Integer}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'kaleidoscopeAngle', 0, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





function $c84c7cb96b5317be$var$pixelAt(idata, x, y) {
    let idx = (y * idata.width + x) * 4;
    const d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $c84c7cb96b5317be$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $c84c7cb96b5317be$var$rgbMean(pTab) {
    const m = [
        0,
        0,
        0
    ];
    for(let i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $c84c7cb96b5317be$var$backgroundMask(idata, threshold) {
    const rgbv_no = $c84c7cb96b5317be$var$pixelAt(idata, 0, 0);
    const rgbv_ne = $c84c7cb96b5317be$var$pixelAt(idata, idata.width - 1, 0);
    const rgbv_so = $c84c7cb96b5317be$var$pixelAt(idata, 0, idata.height - 1);
    const rgbv_se = $c84c7cb96b5317be$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    if ($c84c7cb96b5317be$var$rgbDistance(rgbv_no, rgbv_ne) < threshold && $c84c7cb96b5317be$var$rgbDistance(rgbv_ne, rgbv_se) < threshold && $c84c7cb96b5317be$var$rgbDistance(rgbv_se, rgbv_so) < threshold && $c84c7cb96b5317be$var$rgbDistance(rgbv_so, rgbv_no) < threshold) {
        // Mean color
        const mean = $c84c7cb96b5317be$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        // Mask based on color distance
        const mask = [];
        for(let i = 0; i < idata.width * idata.height; i++){
            const d = $c84c7cb96b5317be$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < threshold ? 0 : 255;
        }
        return mask;
    }
}
function $c84c7cb96b5317be$var$applyMask(idata, mask) {
    for(let i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $c84c7cb96b5317be$var$erodeMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $c84c7cb96b5317be$var$dilateMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $c84c7cb96b5317be$var$smoothEdgeMask(mask, sw, sh) {
    const weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $c84c7cb96b5317be$export$991dcf7284de63d = function(imageData) {
    var _a;
    // Detect pixels close to the background color
    const threshold = (_a = this.attrs.threshold) !== null && _a !== void 0 ? _a : 10;
    let mask = $c84c7cb96b5317be$var$backgroundMask(imageData, threshold);
    if (mask) {
        // Erode
        mask = $c84c7cb96b5317be$var$erodeMask(mask, imageData.width, imageData.height);
        // Dilate
        mask = $c84c7cb96b5317be$var$dilateMask(mask, imageData.width, imageData.height);
        // Gradient
        mask = $c84c7cb96b5317be$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        // Apply mask
        $c84c7cb96b5317be$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'threshold', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);





const $879e3ceba3e3a13f$export$484d33a0500a4ce1 = function(imageData) {
    const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
    for(let i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'noise', 0.2, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set noise amount.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Noise} filter.
 * @name Konva.Node#noise
 * @method
 * @param {Number} noise
 * @returns {Number}
 */ 






const $f27cf23dfb100d82$export$63396595bf5aeaa7 = function(imageData, pixelRatio = 1) {
    let pixelSize = Math.ceil(this.pixelSize() * pixelRatio), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
    if (pixelSize <= 0) {
        (0, $d4400dec7c2a8326$export$f8f26dd395d7e1bd).error('pixelSize value can not be <= 0');
        return;
    }
    for(let xBin = 0; xBin < nBinsX; xBin += 1)for(let yBin = 0; yBin < nBinsY; yBin += 1){
        // Initialize the color accumlators to 0
        let red = 0;
        let green = 0;
        let blue = 0;
        let alpha = 0;
        // Determine which pixels are included in this bin
        const xBinStart = xBin * pixelSize;
        const xBinEnd = Math.min(xBinStart + pixelSize, width);
        const yBinStart = yBin * pixelSize;
        const yBinEnd = Math.min(yBinStart + pixelSize, height);
        // Add all of the pixels to this bin!
        for(let x = xBinStart; x < xBinEnd; x += 1)for(let y = yBinStart; y < yBinEnd; y += 1){
            const i = (width * y + x) * 4;
            const a = data[i + 3];
            red += data[i + 0] * a;
            green += data[i + 1] * a;
            blue += data[i + 2] * a;
            alpha += a;
        }
        // average premultiplied colour so transparent pixels do not darken the block
        if (alpha) {
            red = red / alpha;
            green = green / alpha;
            blue = blue / alpha;
        }
        alpha = alpha / ((xBinEnd - xBinStart) * (yBinEnd - yBinStart));
        // Draw this bin
        for(let x = xBinStart; x < xBinEnd; x += 1)for(let y = yBinStart; y < yBinEnd; y += 1){
            const i = (width * y + x) * 4;
            data[i + 0] = red;
            data[i + 1] = green;
            data[i + 2] = blue;
            data[i + 3] = alpha;
        }
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'pixelSize', 8, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set pixel size. Use with {@link Konva.Filters.Pixelate} filter.
 * @name Konva.Node#pixelSize
 * @method
 * @param {Integer} pixelSize
 * @returns {Integer}
 */ 





const $25e4ed057d22ebcc$export$ccda2563bc5d1354 = function(imageData) {
    // level must be between 1 and 255
    const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
    for(let i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'levels', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set levels.  Must be a number between 0 and 1.  Use with {@link Konva.Filters.Posterize} filter.
 * @name Konva.Node#levels
 * @method
 * @param {Number} level between 0 and 1
 * @returns {Number}
 */ 





const $c44c727575bf2327$export$8f9ece5a47764b93 = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
    for(let i = 0; i < nPixels; i += 4){
        const brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red; // r
        data[i + 1] = brightness * green; // g
        data[i + 2] = brightness * blue; // b
        data[i + 3] = data[i + 3]; // alpha
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'red', 0, (0, $d7c0e5ae0fe3f9a6$export$af51e4581c640b27), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set filter red value. Use with {@link Konva.Filters.RGB} or {@link Konva.Filters.RGBA} filter.
 * @name red
 * @method
 * @memberof Konva.Node.prototype
 * @param {Integer} red value between 0 and 255
 * @returns {Integer}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'green', 0, (0, $d7c0e5ae0fe3f9a6$export$af51e4581c640b27), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter);
/**
 * get/set filter green value. Use with {@link Konva.Filters.RGB} or {@link Konva.Filters.RGBA} filter.
 * @name green
 * @method
 * @memberof Konva.Node.prototype
 * @param {Integer} green value between 0 and 255
 * @returns {Integer}
 */ (0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'blue', 0, (0, $d7c0e5ae0fe3f9a6$export$af51e4581c640b27), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set filter blue value. Use with {@link Konva.Filters.RGB} or {@link Konva.Filters.RGBA} filter.
 * @name blue
 * @method
 * @memberof Konva.Node.prototype
 * @param {Integer} blue value between 0 and 255
 * @returns {Integer}
 */ 





const $c9fcfd0e8f0cfc11$export$f50470518fe8f14a = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
    for(let i = 0; i < nPixels; i += 4){
        const ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia; // r
        data[i + 1] = green * alpha + data[i + 1] * ia; // g
        data[i + 2] = blue * alpha + data[i + 2] * ia; // b
    }
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'alpha', 1, (val)=>Math.min(1, Math.max(0, val)), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set filter alpha value. Use with {@link Konva.Filters.RGBA} filter.
 * @name alpha
 * @method
 * @memberof Konva.Node.prototype
 * @param {Float} alpha value between 0 and 1
 * @returns {Float}
 */ 


// based on https://stackoverflow.com/questions/1061093/how-is-a-sepia-tone-created
/**
 * @function
 * @name Sepia
 * @memberof Konva.Filters
 * @param {Object} imageData
 * @example
 * node.cache();
 * node.filters([Konva.Filters.Sepia]);
 */ const $5272dd5841a82d90$export$1eeb4741c69006fa = function(imageData) {
    const data = imageData.data, nPixels = data.length;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


/**
 * Solarize Filter
 * @function
 * @name Solarize
 * @memberof Konva.Filters
 * @param {Object} imageData
 * @example
 * node.cache();
 * node.filters([Konva.Filters.Solarize]);
 */ const $e65c0d23ae0ff66e$export$d60d51c3865bca60 = function(imageData) {
    const threshold = 128;
    const d = imageData.data;
    for(let i = 0; i < d.length; i += 4){
        const r = d[i], g = d[i + 1], b = d[i + 2];
        // sRGB luma
        const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        if (L >= threshold) {
            d[i] = 255 - r;
            d[i + 1] = 255 - g;
            d[i + 2] = 255 - b;
        }
    }
    return imageData;
};





const $de70fa3e5ae3f655$export$14f770b2ce0bb8ad = function(imageData) {
    const level = this.threshold() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $abe0ad8331aee635$export$8354032f3852ec50).addGetterSetter((0, $367bbc8f6a40f243$export$85c928794f8d04d4), 'threshold', 0.5, (0, $d7c0e5ae0fe3f9a6$export$6b1205b9fbe7de2c)(), (0, $abe0ad8331aee635$export$8354032f3852ec50).afterSetFilter); /**
 * get/set threshold. With {@link Konva.Filters.Threshold} it is a value between 0 and 1, default 0.5. With {@link Konva.Filters.Mask} it is the colour distance to the background, 0 to 255, default 10.
 * @name threshold
 * @method
 * @memberof Konva.Node.prototype
 * @param {Number} threshold
 * @returns {Number}
 */ 


const $7bf9b2e06b49f79d$export$b9f99057a3c7692 = (0, $184c4f87393bf8b7$export$b9f99057a3c7692).Util._assign((0, $184c4f87393bf8b7$export$b9f99057a3c7692), {
    Arc: $7e6edc1d7eb9aa8d$export$6ef80ffb606dd232,
    Arrow: $ed4c5015d754ac7a$export$21b07c8f274aebd5,
    Circle: $cfc8e10222484598$export$c89a927ffc67e6fa,
    Ellipse: $a1df33efdd3b5d94$export$80b0269ab108fa11,
    Image: $f0156a163f3b5062$export$3e431a229df88919,
    Label: $68b4427dcf69bf6a$export$b04be29aa201d4f5,
    Tag: $68b4427dcf69bf6a$export$3288d34c523a1192,
    Line: $5329876ec3db1142$export$17d680238e50603e,
    Path: $d1bc11ae7d9e9a07$export$4b2950bdac9b6ee9,
    Rect: $f22346c22f20789a$export$c79fc6492f3af13d,
    RegularPolygon: $a02eac566278789b$export$e2ee866164812ecd,
    Ring: $e1deb4ed1ad79a18$export$a6e3577650b6d6d7,
    Sprite: $5a6b0dd32a4eac33$export$3075603db8e6204c,
    Star: $4d356f0361a4a7f0$export$1644ba17714857f1,
    Text: $8540f0f5ac9d4ade$export$5f1af8db9871e1d6,
    TextPath: $df8ddbf07e58c785$export$f7e34a95cc06fac7,
    Transformer: $801345eab32c3d30$export$f993aef960936087,
    Wedge: $38218507e674999c$export$28718c7785907330,
    /**
     * @namespace Filters
     * @memberof Konva
     */ Filters: {
        Blur: $115c1355c0a3c8a8$export$975a268f2c733e4,
        Brightness: $d2cbac3f9294abf4$export$98835ff3df8927e5,
        Brighten: $ced669b61682093f$export$a2d0d82739cac11f,
        Contrast: $915438a9a02e65de$export$656ae42051d0ca86,
        Emboss: $2b42f6c4d038b489$export$3c8699b389eb838,
        Enhance: $2ad1b73e774f59bb$export$5cb8e8388f951d6f,
        Grayscale: $d01fff91fba4df8f$export$e2b0a794e83ca071,
        HSL: $4b70970df87d7d14$export$46d8b0f9bc8f87a2,
        HSV: $a9eed7ce687c1218$export$d2edaecd208aed43,
        Invert: $15eda2f50977af8f$export$1073348d81b17440,
        Kaleidoscope: $6c6b8bc9d19c96ee$export$e731e8a0fd067155,
        Mask: $c84c7cb96b5317be$export$991dcf7284de63d,
        Noise: $879e3ceba3e3a13f$export$484d33a0500a4ce1,
        Pixelate: $f27cf23dfb100d82$export$63396595bf5aeaa7,
        Posterize: $25e4ed057d22ebcc$export$ccda2563bc5d1354,
        RGB: $c44c727575bf2327$export$8f9ece5a47764b93,
        RGBA: $c9fcfd0e8f0cfc11$export$f50470518fe8f14a,
        Sepia: $5272dd5841a82d90$export$1eeb4741c69006fa,
        Solarize: $e65c0d23ae0ff66e$export$d60d51c3865bca60,
        Threshold: $de70fa3e5ae3f655$export$14f770b2ce0bb8ad
    }
});


var $544e715f9e3fd6b8$export$2e2bcd8739ae039 = (0, $7bf9b2e06b49f79d$export$b9f99057a3c7692);


/* This params can all be overriden via the params parameter from Elm or via a 
`config`-Object encoded as JSON-string (as used by the `tangram` content type).
This constant is also used as documentation so please make sure there is a default set for
every possible option.
*/ const $e66e4e13c3facbed$var$defaultParams = {
    // The location of the targets. This array has 7 elements and each is defined as
    // [targetPieceTypeId, targetX, targetY, targetRotation]
    // The big (id 0) and small (id 1) triangles each exist twice and are interchangeable
    targets: [
        [
            4,
            500,
            286,
            45
        ],
        [
            1,
            107,
            251,
            135
        ],
        [
            1,
            464,
            393,
            225
        ],
        [
            2,
            286,
            72,
            225
        ],
        [
            3,
            72,
            358,
            45
        ],
        [
            0,
            72,
            72,
            315
        ],
        [
            0,
            500,
            72,
            45
        ]
    ],
    // Is the game in editor-mode (to create the json-config string)
    editor: false,
    // An image of the outline to be shown to the user
    targetImageUrl: "/tangram/altartable.png",
    // the scale of the target image
    targetImageScale: 1.14,
    // the image to be shown after successful completion
    // optional: set to false when no image should be shown.
    winningImageUrl: "/tangram/altartable_win.png",
    // the scale of the winning image
    winningImageScale: 3,
    // the x and y offset of the winning images top left corner
    winningImageOffset: [
        -1502,
        -4033
    ],
    // A string that will be shown in a box when the tangram has been solved
    // optional: set to false when no box should be shown
    winningText: false
};
const $e66e4e13c3facbed$var$tangramPieceTypes = {
    bigTriangle: {
        id: 0,
        points: [
            0,
            200,
            200,
            0,
            400,
            200
        ],
        offsetX: 200,
        offsetY: 100,
        defaultColor: '#007f95',
        rotationMod: 360
    },
    smallTriangle: {
        id: 1,
        points: [
            0,
            100,
            100,
            0,
            200,
            100
        ],
        offsetX: 100,
        offsetY: 50,
        defaultColor: '#007f95',
        rotationMod: 360
    },
    mediumTriangle: {
        id: 2,
        points: [
            0,
            200,
            200,
            200,
            200,
            0
        ],
        offsetX: 150,
        offsetY: 150,
        defaultColor: '#007f95',
        rotationMod: 360
    },
    square: {
        id: 3,
        points: [
            0,
            100,
            100,
            0,
            200,
            100,
            100,
            200
        ],
        offsetX: 100,
        offsetY: 100,
        defaultColor: '#007f95',
        rotationMod: 90
    },
    rhomboid: {
        id: 4,
        points: [
            0,
            0,
            200,
            0,
            300,
            100,
            100,
            100
        ],
        offsetX: 150,
        offsetY: 50,
        defaultColor: '#007f95',
        rotationMod: 180
    }
};
// This has to match the ids of the tangramPieceTypes definition!
const $e66e4e13c3facbed$var$tangramPieceArray = [
    $e66e4e13c3facbed$var$tangramPieceTypes.bigTriangle,
    $e66e4e13c3facbed$var$tangramPieceTypes.smallTriangle,
    $e66e4e13c3facbed$var$tangramPieceTypes.mediumTriangle,
    $e66e4e13c3facbed$var$tangramPieceTypes.square,
    $e66e4e13c3facbed$var$tangramPieceTypes.rhomboid
];
window.customElements.define("tangram-game", class TangramGame extends HTMLElement {
    connectedCallback() {
        let config = {};
        if (this.config) try {
            config = JSON.parse(this.config);
        } catch (e) {
            // This can only be a syntax error. Print it to the console, but don't fail.
            console.error(e);
        }
        this.settings = {
            ...$e66e4e13c3facbed$var$defaultParams,
            ...config,
            ...this.params
        };
        // Prepare variables
        this.targetWidth = 0;
        this.targetHeight = 0;
        this.stageBounds = [
            -1000,
            -1000,
            1000,
            1000
        ];
        this.pieceBounds = [
            0,
            0,
            0,
            0
        ];
        this.resetPinchZoom();
        // Needed for pinchZoom
        (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).hitOnDragEnabled = true;
        // Prepare the stage
        this.stage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Stage({
            container: this,
            draggable: true
        });
        // Initialize the layers
        this.targetImageLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.stage.add(this.targetImageLayer);
        this.tangramPieceLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer();
        this.stage.add(this.tangramPieceLayer);
        this.winningImageLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer({
            opacity: 0,
            listening: false
        });
        this.stage.add(this.winningImageLayer);
        // Initialize event handlers
        this.stage.on('dragmove', ()=>this.fitToBounds(this.stage, this.stageBounds));
        this.stage.on('touchmove', (evt)=>this.pinchZoom(evt));
        this.stage.on('touchend', ()=>this.resetPinchZoom());
        this.stage.on('wheel', (evt)=>this.wheelZoom(evt));
        // Setup resizing
        this.resizeStageToParentContainer();
        window.addEventListener('resize', this.resizeStageToParentContainer);
        // Initialize resetButton
        this.resetButton = document.createElement('button');
        this.resetButton.innerText = "Tangram neu starten";
        this.resetButton.setAttribute('class', 'btn btn-primary reset-btn');
        this.resetButton.onclick = this.reset;
        this.hideResetButton();
        this.appendChild(this.resetButton);
        // Initialize winningTextButton
        if (this.settings.winningText) {
            this.winningTextButton = document.createElement('button');
            this.winningTextButton.innerText = this.settings.winningText;
            this.winningTextButton.setAttribute('class', 'btn btn-primary winning-btn');
            this.winningTextButton.onclick = this.hideWinningTextButton;
            this.hideWinningTextButton();
            this.appendChild(this.winningTextButton);
        }
        // Load targetImage and setup the game
        this.targetImageEl = new Image();
        this.targetImageEl.onload = this.setup;
        this.targetImageEl.src = this.settings.targetImageUrl;
        // Load winningImage asynchronously if set
        if (this.settings.winningImageUrl) {
            this.winningImageEl = new Image();
            this.winningImageEl.onload = ()=>this.handleLoadedWinningImage(this.winningImageEl);
            this.winningImageEl.src = this.settings.winningImageUrl;
        }
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.resizeStageToParentContainer);
        clearTimeout(this.winningAnimationTimeout);
        if (this.targetImageEl) this.targetImageEl.onload = null;
        if (this.winningImageEl) this.winningImageEl.onload = null;
        if (this.resetButton) this.resetButton.remove();
        if (this.winningTextButton) this.winningTextButton.remove();
        this.winningTextButton = null;
        if (this.stage) this.stage.destroy();
        document.body.style.cursor = 'default';
    }
    setup = ()=>{
        this.snapped = [
            false,
            false,
            false,
            false,
            false,
            false,
            false
        ];
        this.targetWidth = this.targetImageEl.naturalWidth * this.settings.targetImageScale;
        this.targetHeight = this.targetImageEl.naturalHeight * this.settings.targetImageScale;
        this.targetImage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Image({
            image: this.targetImageEl,
            scaleX: this.settings.targetImageScale,
            scaleY: this.settings.targetImageScale
        });
        this.targetImageLayer.add(this.targetImage);
        if (!this.settings.editor) this.addGamePieces();
        else this.setupEditor();
        // center stage on items
        const startX = this.targetWidth / 2;
        // tangram pieces are 400px high and have 100px padding top and 100px margin to targetImage
        const startY = (this.targetHeight + 600) / 2;
        this.stage.position(this.calculateScaledStageCenterCoordinates({
            x: startX,
            y: startY
        }));
        this.setDefaultZoom();
        this.zoom(this.defaultZoom);
    };
    addGamePieces = ()=>{
        let pieces = [
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.rhomboid,
                x: 350,
                y: 150,
                rotation: 90
            },
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.bigTriangle,
                x: 100,
                y: 200,
                rotation: 90
            },
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.bigTriangle,
                x: 200,
                y: 100,
                rotation: 180
            },
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.mediumTriangle,
                x: 350,
                y: 350
            },
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.smallTriangle,
                x: 250,
                y: 200,
                rotation: 270
            },
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.smallTriangle,
                x: 100,
                y: 350,
                rotation: 0
            },
            {
                type: $e66e4e13c3facbed$var$tangramPieceTypes.square,
                x: 200,
                y: 300,
                rotation: 0
            }
        ];
        // tangram pieces are 400px wide => their midpoint is at 200
        const baseX = this.targetWidth / 2 - 200;
        // target has 100px padding top and 100px margin to pieces
        const baseY = this.targetHeight + 200;
        pieces.forEach((pieceDef)=>{
            this.addSingleTangramPiece(pieceDef, baseX, baseY);
        });
    };
    addSingleTangramPiece = (pieceDef, baseX, baseY)=>{
        var piece = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Line({
            points: pieceDef.type.points,
            fill: pieceDef.color || pieceDef.type.defaultColor,
            stroke: 'black',
            strokeWidth: 1,
            closed: true,
            offsetX: pieceDef.type.offsetX,
            offsetY: pieceDef.type.offsetY,
            x: baseX + pieceDef.x,
            y: baseY + pieceDef.y,
            rotation: pieceDef.rotation,
            draggable: true,
            pieceTypeId: pieceDef.type.id
        });
        if (!this.settings.editor) piece.on('dragend', (evt)=>this.checkForSnap(evt.target));
        else piece.on('dragend', this.updateTargets);
        piece.on('dragstart', (evt)=>evt.target.moveToTop());
        piece.on('dragmove', (evt)=>this.fitToBounds(evt.target, this.pieceBounds));
        piece.on('click tap', (evt)=>this.rotatePiece(evt.target));
        piece.on('mouseover', ()=>document.body.style.cursor = 'pointer');
        piece.on('mouseout', ()=>document.body.style.cursor = 'default');
        this.tangramPieceLayer.add(piece);
    };
    // This function resets the tangram game.
    // Calling reset() in editor-mode will break stuff. But this is not a use-case, so it's fine.
    reset = ()=>{
        this.winningImageLayer.opacity(0);
        this.tangramPieceLayer.destroyChildren();
        this.tangramPieceLayer.opacity(1);
        this.targetImageLayer.destroyChildren();
        this.targetImageLayer.opacity(1);
        this.hideResetButton();
        this.hideWinningTextButton();
        this.setup();
    };
    showResetButton = ()=>{
        this.resetButton.style.display = 'block';
    };
    hideResetButton = ()=>{
        this.resetButton.style.display = 'none';
    };
    showWinningTextButton = ()=>{
        if (this.winningTextButton) {
            // There is a transition on opacity - that's not possible on display. 
            // On the other hand with only the opacity the button is still there and clickable.
            this.winningTextButton.style.display = 'block';
            // Set the opacity a tad later, otherwise the css animation won't be triggered.
            setTimeout(()=>{
                this.winningTextButton.style.opacity = 1;
            }, 1);
        }
    };
    hideWinningTextButton = ()=>{
        if (this.winningTextButton) {
            this.winningTextButton.style.display = 'none';
            this.winningTextButton.style.opacity = 0;
        }
    };
    handleLoadedWinningImage = (winningImageEl)=>{
        this.winningImage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Image({
            image: winningImageEl,
            scaleX: this.settings.winningImageScale,
            scaleY: this.settings.winningImageScale,
            x: this.settings.winningImageOffset[0],
            y: this.settings.winningImageOffset[1]
        });
        this.winningImageLayer.add(this.winningImage);
    };
    calculateNormalizedWinningImageCenter = ()=>{
        if (this.winningImage) {
            const scaledWinningWidth = this.winningImage.width() * this.settings.winningImageScale;
            const scaledWinningHeight = this.winningImage.height() * this.settings.winningImageScale;
            return {
                x: this.settings.winningImageOffset[0] + scaledWinningWidth / 2,
                y: this.settings.winningImageOffset[1] + scaledWinningHeight / 2
            };
        }
        return false;
    };
    calculateWinningImageStageZoom = ()=>{
        if (this.winningImage) {
            const xScale = this.stage.width() / this.winningImage.width() / this.winningImage.scaleX();
            const yScale = this.stage.height() / this.winningImage.height() / this.winningImage.scaleY();
            return Math.min(xScale, yScale) * 0.95 // Add some padding
            ;
        }
        return false;
    };
    getNormalizedStageCenterCoordinates = ()=>{
        return {
            x: (this.stage.width() / 2 - this.stage.x()) / this.stage.scaleX(),
            y: (this.stage.height() / 2 - this.stage.y()) / this.stage.scaleX()
        };
    };
    calculateScaledStageCenterCoordinates = (normalizedPosition, targetScale = null)=>{
        if (!targetScale) targetScale = this.stage.scaleX();
        return {
            x: this.stage.width() / 2 - normalizedPosition.x * targetScale,
            y: this.stage.height() / 2 - normalizedPosition.y * targetScale
        };
    };
    checkForSnap = (piece)=>{
        this.settings.targets.forEach((target, idx)=>{
            const [targetPieceTypeId, targetx, targety, targetRotation] = target;
            const distance = this.calculateDistance(piece.x(), piece.y(), targetx, targety);
            const targetDistance = 30;
            if (piece.attrs.pieceTypeId == targetPieceTypeId && piece.rotation() == targetRotation && distance < targetDistance && this.snapped[idx] == false) {
                this.snapped[idx] = true;
                piece.position({
                    x: targetx,
                    y: targety
                });
                piece.listening(false);
                const fill = piece.fill();
                piece.to({
                    fill: 'white',
                    duration: 0.25,
                    onFinish: ()=>{
                        piece.to({
                            fill: fill,
                            duration: 0.25
                        });
                    }
                });
            }
        });
        this.checkForWin();
    };
    checkForWin = ()=>{
        if (this.snapped.reduce((acc, curr)=>acc && curr, true)) // let the snap-animation play out before fading in the image
        this.winningAnimationTimeout = setTimeout(this.playWinningAnimation, 1000);
    };
    playWinningAnimation = ()=>{
        const base = {
            duration: 2,
            easing: (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Easings.EaseInOut
        };
        this.winningImageLayer.to({
            ...base,
            opacity: 1,
            onFinish: this.showResetButton
        });
        if (this.winningImage) {
            this.tangramPieceLayer.to({
                ...base,
                opacity: 0
            });
            this.targetImageLayer.to({
                ...base,
                opacity: 0
            });
            const targetScale = this.calculateWinningImageStageZoom();
            const normalizedTargetPosition = this.calculateNormalizedWinningImageCenter();
            const stageTargetPosition = this.calculateScaledStageCenterCoordinates(normalizedTargetPosition, targetScale);
            this.stage.to({
                ...base,
                x: stageTargetPosition.x,
                y: stageTargetPosition.y,
                scaleX: targetScale,
                scaleY: targetScale
            });
        }
        this.showWinningTextButton();
    };
    rotatePiece = (piece)=>{
        const rotationMod = $e66e4e13c3facbed$var$tangramPieceArray[piece.attrs.pieceTypeId].rotationMod;
        const newRotation = (piece.rotation() + 45) % rotationMod;
        piece.listening(false);
        // The animation should always be clockwise (+45) while the internal value should be
        // limited by rotationMod. Set the internal value, after the animation finishes
        piece.to({
            rotation: piece.rotation() + 45,
            duration: 0.1,
            easing: (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Easings.EaseInOut,
            onFinish: ()=>{
                piece.rotation(newRotation);
                piece.listening(true);
            }
        });
        if (this.settings.editor) this.updateTargets();
    };
    fitToBounds = (thing, bounds)=>{
        const [minX, minY, maxX, maxY] = bounds;
        if (thing.x() < minX) thing.x(minX);
        else if (thing.x() > maxX) thing.x(maxX);
        if (thing.y() < minY) thing.y(minY);
        else if (thing.y() > maxY) thing.y(maxY);
    };
    resizeStageToParentContainer = ()=>{
        this.stage.width(this.offsetWidth);
        this.stage.height(this.offsetHeight);
        this.setDefaultZoom();
        this.setBounds();
    };
    // Zoom Stuff
    zoom = (newZoom)=>{
        if (newZoom > 2 * this.defaultZoom) newZoom = 2 * this.defaultZoom;
        else if (newZoom < 0.2 * this.defaultZoom) newZoom = 0.2 * this.defaultZoom;
        const oldCenter = this.getNormalizedStageCenterCoordinates();
        this.stage.scale({
            x: newZoom,
            y: newZoom
        });
        const newCenter = this.calculateScaledStageCenterCoordinates(oldCenter);
        this.stage.position(newCenter);
        this.setBounds();
    };
    wheelZoom = (evt)=>{
        evt.evt.preventDefault();
        const zoomBy = 1.05;
        // how to scale? Zoom in? Or zoom out?
        let direction = evt.evt.deltaY > 0 ? 1 : -1;
        // when we zoom on trackpad, e.evt.ctrlKey is true
        // in that case lets revert direction
        if (evt.evt.ctrlKey) direction = -direction;
        const oldZoom = this.stage.scaleX();
        var newZoom = direction > 0 ? oldZoom * zoomBy : oldZoom / zoomBy;
        this.zoom(newZoom);
    };
    pinchZoom = (evt)=>{
        evt.evt.preventDefault();
        var touch1 = evt.evt.touches[0];
        var touch2 = evt.evt.touches[1];
        if (touch1 && touch2) {
            // if the stage was under Konva's drag&drop
            // we need to stop it, and implement our own pan logic with two pointers
            if (this.stage.isDragging()) this.stage.stopDrag();
            this.tangramPieceLayer.children.forEach((child)=>{
                if (child.isDragging()) child.stopDrag();
            });
            const dist = this.calculateDistance(touch1.clientX, touch1.clientY, touch2.clientX, touch2.clientY);
            if (!this.pinchZoomLastDist) this.pinchZoomLastDist = dist;
            const zoom = this.stage.scaleX() * (dist / this.pinchZoomLastDist);
            this.zoom(Math.min(zoom, 2));
            this.pinchZoomLastDist = dist;
        }
    };
    resetPinchZoom = ()=>{
        this.pinchZoomLastDist = 0;
    };
    setDefaultZoom = ()=>{
        // calculate defaultZoomX for either targetImageWidth or tangram-pieces and add 200px padding 
        const defaultZoomX = this.stage.width() / (Math.max(this.targetWidth, 400) + 200);
        // calculate defaultZoomY for targetHeight + tangram-pieces (400px) and add 200px padding and 100 margin inside
        const defaultZoomY = this.stage.height() / (this.targetHeight + 700);
        this.defaultZoom = Math.min(defaultZoomX, defaultZoomY);
    };
    setBounds = ()=>{
        const zoom = this.stage.scaleX();
        this.stageBounds = [
            (-this.targetWidth + 100) * zoom,
            (-this.targetHeight + 100) * zoom,
            this.stage.width() - 100 * zoom,
            this.stage.height() - 100 * zoom
        ];
        this.pieceBounds = [
            (-this.stage.width() + 100) / zoom,
            (-this.stage.height() + 100) / zoom,
            this.targetWidth + (this.stage.width() - 100) / zoom,
            this.targetHeight + (this.stage.height() - 100) / zoom
        ];
        this.fitToBounds(this.stage, this.stageBounds);
        this.tangramPieceLayer.children.forEach((piece)=>this.fitToBounds(piece, this.pieceBounds));
    };
    calculateDistance = (x1, y1, x2, y2)=>{
        // pythagoras x^2 + y^2 = dist^2
        return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
    };
    // Editor Stuff
    setupEditor = ()=>{
        // Add editor fields
        const targetScaleInput = document.createElement('input');
        targetScaleInput.setAttribute('type', 'number');
        targetScaleInput.setAttribute('step', '0.01');
        targetScaleInput.setAttribute('value', this.settings.targetImageScale);
        targetScaleInput.onchange = (evt)=>{
            const scale = evt.target.value;
            this.targetImage.scale({
                x: scale,
                y: scale
            });
            this.settings.targetImageScale = scale;
            this.printSettings();
        };
        this.appendChild(targetScaleInput);
        const winningImageVisibleInput = document.createElement('input');
        winningImageVisibleInput.setAttribute('type', 'checkbox');
        winningImageVisibleInput.onchange = (evt)=>{
            const visible = evt.target.checked;
            this.winningImageLayer.opacity(visible * 0.5);
        };
        this.appendChild(winningImageVisibleInput);
        const winningScaleInput = document.createElement('input');
        winningScaleInput.setAttribute('type', 'number');
        winningScaleInput.setAttribute('step', '0.01');
        winningScaleInput.setAttribute('value', this.settings.winningImageScale);
        winningScaleInput.onchange = (evt)=>{
            const scale = evt.target.value;
            this.winningImage.scale({
                x: scale,
                y: scale
            });
            this.settings.winningImageScale = scale;
            this.printSettings();
        };
        this.appendChild(winningScaleInput);
        const winningXOffsetInput = document.createElement('input');
        winningXOffsetInput.setAttribute('type', 'number');
        winningXOffsetInput.setAttribute('step', '1');
        winningXOffsetInput.setAttribute('value', this.settings.winningImageOffset[0]);
        winningXOffsetInput.onchange = (evt)=>{
            const x = evt.target.value;
            this.winningImage.x(x);
            this.settings.winningImageOffset[0] = x;
            this.printSettings();
        };
        this.appendChild(winningXOffsetInput);
        const winningYOffsetInput = document.createElement('input');
        winningYOffsetInput.setAttribute('type', 'number');
        winningYOffsetInput.setAttribute('step', '1');
        winningYOffsetInput.setAttribute('value', this.settings.winningImageOffset[1]);
        winningYOffsetInput.onchange = (evt)=>{
            const y = evt.target.value;
            this.winningImage.y(y);
            this.settings.winningImageOffset[1] = y;
            this.printSettings();
        };
        this.appendChild(winningYOffsetInput);
        const editorOutput = document.createElement('pre');
        this.editorOutput = editorOutput;
        this.appendChild(editorOutput);
        this.printSettings();
        this.style.marginBottom = "5rem";
        // Add tangram pieces to the target locations
        this.addTargetPieces();
    };
    addTargetPieces = ()=>{
        this.settings.targets.forEach((targetDef)=>{
            let [typeIdx, x, y, rotation] = targetDef;
            let type = $e66e4e13c3facbed$var$tangramPieceArray[typeIdx];
            this.addSingleTangramPiece({
                type: type,
                x: x,
                y: y,
                rotation: rotation
            }, 0, 0, this.updateTargets);
        });
    };
    updateTargets = ()=>{
        const targets = [];
        this.tangramPieceLayer.children.forEach((child)=>{
            child.x(Math.floor(child.x()));
            child.y(Math.floor(child.y()));
            targets.push([
                child.attrs.pieceTypeId,
                child.x(),
                child.y(),
                child.rotation()
            ]);
        });
        this.settings.targets = targets;
        this.printSettings();
    };
    printSettings = ()=>{
        this.editorOutput.innerHTML = JSON.stringify(this.settings);
    };
});



/* This params can all be overriden via the params parameter from Elm or via a 
`config`-Object encoded as JSON-string (as used by the `searching game` content type).
This constant is also used as documentation so please make sure there is a default set for
every possible option.
*/ const $941e3e7a88381141$var$defaultParams = {
    // The coordinates of the mistakes
    // targetX in percentage of the width and targetY in percentage of the height
    winningCoordinatesNew: [
        {
            x: 9.9,
            y: 55
        },
        {
            x: 43.3,
            y: 41.65
        },
        {
            x: 55.4,
            y: 28.65
        },
        {
            x: 39.75,
            y: 66
        },
        {
            x: 51.8,
            y: 66
        },
        {
            x: 95.6,
            y: 89
        }
    ],
    // Is the game in editor-mode (to create the json-config string)
    editor: false,
    // The original image without mistakes to compare to
    originalToCompareImageUrl: "/searchingGame/original.jpg",
    // The image with mistakes
    targetImageUrl: "/searchingGame/Oldenswort-Altar.jpg",
    imageAspectRatio: 2322 / 4690,
    // the image to be shown after successful completion
    // optional: set to false when no image should be shown.
    winningImageUrl: "/searchingGame/original.jpg",
    // the x and y offset of the winning images top left corner
    winningImageOffset: [
        0,
        0
    ]
};
window.customElements.define("searching-game", class SearchingGame extends HTMLElement {
    connectedCallback() {
        let config = {};
        if (this.config) try {
            config = JSON.parse(this.config);
        } catch (e) {
            // This can only be a syntax error. Print it to the console, but don't fail.
            console.error(e);
        }
        this.settings = {
            ...$941e3e7a88381141$var$defaultParams,
            ...config,
            ...this.params
        };
        this.circles = [];
        this.found = Array.from({
            length: this.settings.winningCoordinatesNew.length
        }, ()=>false);
        this.defaultWidth = this.getBoundingClientRect().width;
        this.setAttribute("style", `height:${this.defaultWidth * this.settings.imageAspectRatio * 2}px`);
        this.data = this.frameGeometry(this.defaultWidth);
        this.pinchZoomLastDist = 0;
        this.resetPinchZoom();
        // Needed for pinchZoom
        (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).hitOnDragEnabled = true;
        // add a stage
        this.stage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Stage({
            container: this,
            width: this.defaultWidth,
            height: this.defaultWidth * this.settings.imageAspectRatio * 2
        });
        // Add a layer and group to draw on
        this.layer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer({});
        this.group = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            clip: this.data.frameGroup
        });
        this.innerGroup = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            draggable: true
        });
        this.rect = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Rect(this.data.frameGroup);
        this.imageObj = new Image();
        this.originalImageToCompareLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer({});
        this.originalGroup = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            clip: this.data.frameGroupOriginal
        });
        this.originalInnerGroup = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Group({
            draggable: true
        });
        this.originalRect = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Rect(this.data.frameGroupOriginal);
        this.originalImage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Image({
            draggable: false
        });
        this.originalImageObj = new Image();
        this.winningImageLayer = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Layer({
            opacity: 0,
            listening: false
        });
        this.winningImage = undefined;
        this.image = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Image({
            draggable: false
        });
        this.currentPositionX = 0;
        this.currentPositionY = 0;
        this.movementStartX = undefined;
        this.movementStartY = undefined;
        this.resetButton = document.createElement("button");
        this.movementX = 0;
        this.movementY = 0;
        this.stage.add(this.layer);
        this.stage.add(this.winningImageLayer);
        this.stage.add(this.originalImageToCompareLayer);
        // Use the html image object to load the image and handle when laoded.
        this.imageObj.onload = ()=>this.setup();
        this.imageObj.src = this.settings.targetImageUrl;
        this.originalImageObj.onload = ()=>this.setup2();
        this.originalImageObj.src = this.settings.originalToCompareImageUrl;
        // Initialize event handlers
        this.group.on("wheel", (evt)=>this.wheelZoom(evt));
        this.originalGroup.on("wheel", (evt)=>this.wheelZoom(evt));
        this.group.on("touchmove", (evt)=>this.pinchZoom(evt, false));
        this.group.on("touchend", ()=>this.resetPinchZoom());
        this.originalGroup.on("touchmove", (evt)=>this.pinchZoom(evt, true));
        this.originalGroup.on("touchend", ()=>this.resetPinchZoom());
        this.resizeStageToParentContainer();
        window.addEventListener("resize", this.resizeStageToParentContainer);
        this.resetButton.innerText = "Suchspiel neu starten";
        this.resetButton.setAttribute("class", "btn btn-primary reset-btn");
        this.resetButton.onclick = this.reset;
        this.hideResetButton();
        this.appendChild(this.resetButton);
        // Load winningImage asynchronously if set
        if (this.settings.winningImageUrl) {
            this.winningImageEl = new Image();
            this.winningImageEl.onload = ()=>this.handleLoadedWinningImage(this.winningImageEl);
            this.winningImageEl.src = this.settings.winningImageUrl;
        }
    }
    disconnectedCallback() {
        window.removeEventListener("resize", this.resizeStageToParentContainer);
        if (this.imageObj) this.imageObj.onload = null;
        if (this.originalImageObj) this.originalImageObj.onload = null;
        if (this.winningImageEl) this.winningImageEl.onload = null;
        if (this.resetButton) this.resetButton.remove();
        if (this.stage) this.stage.destroy();
    }
    // simple function to get the x & y for the image to be centered in the frame
    getMiddlePos(pos, size, imagesize) {
        return {
            x: pos.x + (size.width - imagesize.width) / 2,
            y: pos.y + (size.height - imagesize.height) / 2
        };
    }
    handleLoadedWinningImage(winningImageEl) {
        this.winningImage = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Image({
            image: winningImageEl,
            x: this.settings.winningImageOffset[0],
            y: this.settings.winningImageOffset[1],
            width: this.stage.width(),
            height: this.stage.width() * this.settings.imageAspectRatio
        });
        this.winningImageLayer.add(this.winningImage);
    }
    setupGroupElements(layer, group, rect, innerGroup, image, imageObj, frameGroup, upperOrBottom) {
        layer.add(group);
        group.add(rect);
        group.add(innerGroup);
        image.image(imageObj); // set the Konva image content to the html image content
        rect.listening(false);
        // compute image position so that it is initially centered in the frame
        let imagePos = this.getMiddlePos(frameGroup, {
            width: this.stage.width(),
            height: this.stage.width() * this.settings.imageAspectRatio
        }, {
            width: this.stage.width(),
            height: imageObj.height * (this.stage.width() / imageObj.width)
        });
        innerGroup.setAttrs({
            x: imagePos.x,
            y: 0,
            width: imageObj.width * (this.stage.width() / imageObj.width),
            height: imageObj.height * (this.stage.width() / imageObj.width),
            // This function ensures the oversized image cannot be dragged beyond frame edges.
            // Is is firect by the drag event.
            dragBoundFunc: (pos)=>this.dragBoundFuncExter(pos, upperOrBottom)
        });
        image.setAttrs({
            x: 0,
            y: 0,
            width: imageObj.width,
            height: imageObj.height,
            scaleX: this.stage.width() / imageObj.width,
            scaleY: this.stage.width() / imageObj.width
        });
        innerGroup.add(image); // add the image to the frame group
        image.moveToBottom(); // ensure the frame rect is above the image in the z-index.
    }
    // position and size of both frames in absolute stage coordinates
    frameGeometry(width) {
        const height = width * this.settings.imageAspectRatio;
        return {
            frameGroup: {
                x: 0,
                y: 0,
                width: width,
                height: height
            },
            frameGroupOriginal: {
                x: 0,
                y: height,
                width: width,
                height: height
            }
        };
    }
    resizeStageToParentContainer = ()=>{
        const currentWidth = this.getBoundingClientRect().width;
        const currentHeight = currentWidth * this.settings.imageAspectRatio * 2;
        this.setAttribute("style", `height:${currentHeight}px`);
        this.data = this.frameGeometry(currentWidth);
        if (this.winningImage) {
            this.winningImage.height(currentWidth * this.settings.imageAspectRatio);
            this.winningImage.width(currentWidth);
        }
        this.stage.setAttrs({
            width: currentWidth,
            height: currentHeight
        });
        const middlePOS = this.getMiddlePos({
            x: 0,
            y: 0
        }, {
            width: currentWidth,
            height: this.imageObj.height * (this.stage.width() / this.imageObj.width)
        }, {
            width: this.imageObj.width * (this.stage.width() / this.imageObj.width) * this.innerGroup.scaleX(),
            height: this.imageObj.height * (this.stage.width() / this.imageObj.width) * this.innerGroup.scaleY()
        });
        this.rect.width(this.stage.width());
        this.rect.height(currentWidth * this.settings.imageAspectRatio);
        this.rect.y(0);
        this.group.setAttrs({
            width: currentWidth,
            clipWidth: currentWidth,
            height: currentWidth * this.settings.imageAspectRatio,
            clipHeight: currentWidth * this.settings.imageAspectRatio,
            y: 0,
            clipY: 0
        });
        this.layer.setAttrs({
            y: 0
        });
        this.originalRect.width(this.stage.width());
        this.originalRect.height(currentWidth * this.settings.imageAspectRatio);
        this.originalRect.y(0);
        this.originalGroup.setAttrs({
            width: currentWidth,
            clipWidth: currentWidth,
            height: currentWidth * this.settings.imageAspectRatio,
            clipHeight: currentWidth * this.settings.imageAspectRatio,
            y: 0,
            clipY: 0
        });
        this.originalImageToCompareLayer.setAttrs({
            y: currentWidth * this.settings.imageAspectRatio
        });
        this.innerGroup.setAttrs({
            x: middlePOS.x,
            y: 0,
            width: this.stage.width(),
            height: this.imageObj.height * (this.stage.width() / this.imageObj.width)
        });
        this.originalInnerGroup.setAttrs({
            x: middlePOS.x,
            y: 0,
            width: this.stage.width(),
            height: this.imageObj.height * (this.stage.width() / this.imageObj.width)
        });
        this.image.setAttrs({
            width: this.imageObj.width,
            height: this.imageObj.height,
            scaleX: this.stage.width() / this.imageObj.width,
            scaleY: this.stage.width() * this.settings.imageAspectRatio / this.imageObj.height
        });
        this.originalImage.setAttrs({
            width: this.imageObj.width,
            height: this.imageObj.height,
            scaleX: this.stage.width() / this.imageObj.width,
            scaleY: this.stage.width() * this.settings.imageAspectRatio / this.imageObj.height
        });
        this.circles.forEach((circle, index)=>{
            circle.setAttrs({
                x: this.stage.width() / 100 * this.settings.winningCoordinatesNew[index].x,
                y: this.stage.width() * this.settings.imageAspectRatio / 100 * this.settings.winningCoordinatesNew[index].y
            });
        });
    };
    dragBoundFuncExter(pos, upperOrBottom) {
        const isUpper = upperOrBottom === "upper";
        const frameGroupInternal = isUpper ? this.data.frameGroup : this.data.frameGroupOriginal;
        const innerGroupInternal = isUpper ? this.innerGroup : this.originalInnerGroup;
        const parnterInnerGroup = isUpper ? this.originalInnerGroup : this.innerGroup;
        const imagePos = innerGroupInternal.getClientRect(); // get the image dimensions.
        const maxPos = {
            // compute max x & y position allowed for image
            x: frameGroupInternal.x,
            y: frameGroupInternal.y
        };
        const minPos = {
            x: frameGroupInternal.x + (this.stage.width() - imagePos.width),
            y: frameGroupInternal.y + frameGroupInternal.height - imagePos.height
        };
        let newX = pos.x >= maxPos.x ? maxPos.x : pos.x; // ensure left edge not within frame
        let newY = pos.y >= maxPos.y ? maxPos.y : pos.y; // ensure top edge not within frame
        newX = newX < minPos.x ? minPos.x : newX; // ensure right edge not within frame
        newY = newY < minPos.y ? minPos.y : newY; // ensure top edge not within frame
        this.currentPositionX = newX;
        this.currentPositionY = newY;
        parnterInnerGroup.position({
            x: newX,
            y: upperOrBottom === "upper" ? newY : newY - this.stage.width() * this.settings.imageAspectRatio
        });
        // dragBoundFunc must return a value with x & y. Either return same value passed in
        // or modify the value.
        return {
            x: newX,
            y: newY
        };
    }
    /* ---------------------------- */ /* ------- SETUP START -------- */ /* -----------------------------*/ setHitTargets() {
        this.settings.winningCoordinatesNew.forEach((coOrd)=>{
            var circle = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
                x: this.stage.width() / 100 * coOrd.x,
                y: this.stage.width() * this.settings.imageAspectRatio / 100 * coOrd.y,
                radius: 20,
                fill: "transparent"
            });
            this.circles = this.circles.concat([
                circle
            ]);
            circle.on("click", (evt)=>{
                evt.target.stroke("#00ff00");
                evt.target.strokeWidth(3);
                evt.target.opacity(1);
                this.checkForErrorFound(evt);
            });
            circle.on("tap", (evt)=>{
                evt.target.stroke("#00ff00");
                evt.target.strokeWidth(3);
                evt.target.opacity(1);
                this.checkForErrorFound(evt);
            });
            this.innerGroup.add(circle);
        });
    }
    setup() {
        this.found = Array.from({
            length: this.settings.winningCoordinatesNew.length
        }, ()=>false);
        this.setupGroupElements(this.layer, this.group, this.rect, this.innerGroup, this.image, this.imageObj, this.data.frameGroup, "upper");
        if (this.settings.editor) this.setupEditor();
        else {
            this.setHitTargets();
            this.innerGroup.on("dragstart", (evt)=>{
                if (this.movementStartX === undefined) this.movementStartX = this.innerGroup.x();
                if (this.movementStartY === undefined) this.movementStartY = this.innerGroup.y();
            });
        }
    }
    setup2() {
        this.setupGroupElements(this.originalImageToCompareLayer, this.originalGroup, this.originalRect, this.originalInnerGroup, this.originalImage, this.originalImageObj, this.data.frameGroupOriginal, "bottom");
    }
    /* ---------------------------- */ /* -------- SETUP END --------- */ /* ---------------------------- */ /* ---------------------------- */ /* ---- RESET BUTTON START ---- */ /* ---------------------------- */ hideResetButton() {
        this.resetButton.style.display = "none";
    }
    showResetButton = ()=>{
        this.resetButton.style.display = "block";
    };
    reset = ()=>{
        this.circles = [];
        this.winningImageLayer.opacity(0);
        this.layer.removeChildren();
        this.layer.opacity(1);
        this.originalImageToCompareLayer.removeChildren();
        this.originalImageToCompareLayer.opacity(1);
        this.hideResetButton();
        this.innerGroup.scale({
            x: 1,
            y: 1
        });
        this.innerGroup.removeChildren();
        this.originalInnerGroup.scale({
            x: 1,
            y: 1
        });
        this.movementX = 0;
        this.movementY = 0;
        this.movementStartX = undefined;
        this.movementStartY = undefined;
        this.currentPositionX = 0;
        this.currentPositionY = 0;
        this.resetPinchZoom();
        this.setup();
        this.setup2();
    };
    /* ---------------------------- */ /* ----- RESET BUTTON END ----- */ /* -----------------------------*/ /* ---------------------------- */ /* ----- ZOOM STUFF START ----- */ /* ---------------------------- */ wheelZoom(evt) {
        evt.evt.preventDefault();
        const zoomBy = 1.05;
        // how to scale? Zoom in? Or zoom out?
        let direction = evt.evt.deltaY > 0 ? 1 : -1;
        // when we zoom on trackpad, e.evt.ctrlKey is true
        // in that case lets revert direction
        if (evt.evt.ctrlKey) direction = -direction;
        const oldZoom = this.innerGroup.scaleX();
        const newZoom = direction > 0 ? oldZoom * zoomBy : oldZoom / zoomBy;
        this.zoom(newZoom, this.innerGroup.scaleX());
    }
    pinchZoom(evt, isOriginal) {
        evt.evt.preventDefault();
        var touch1 = evt.evt.touches[0];
        var touch2 = evt.evt.touches[1];
        if (touch1 && touch2) {
            // if the stage was under Konva's drag&drop
            // we need to stop it, and implement our own pan logic with two pointers
            if (this.innerGroup.isDragging()) this.innerGroup.stopDrag();
            if (this.originalInnerGroup.isDragging()) this.originalInnerGroup.stopDrag();
            const dist = this.calculateDistance(touch1.clientX, touch1.clientY, touch2.clientX, touch2.clientY);
            if (!this.pinchZoomLastDist) this.pinchZoomLastDist = dist;
            const zoomFactor = isOriginal ? this.originalInnerGroup.scaleX() * (dist / this.pinchZoomLastDist) : this.innerGroup.scaleX() * (dist / this.pinchZoomLastDist);
            let calculateZOOM = Math.min(zoomFactor, 5);
            this.zoom(calculateZOOM, this.innerGroup.scaleX());
            this.pinchZoomLastDist = dist;
        }
    }
    resetPinchZoom() {
        this.pinchZoomLastDist = 0;
    }
    zoom(zoom, oldZoom) {
        let newZoom = zoom;
        if (newZoom < 1) newZoom = 1;
        if (newZoom > 5) newZoom = 5;
        let currentMovement = 0;
        let currentMovementY = 0;
        if (this.movementStartX) {
            currentMovement = (this.currentPositionX - this.movementStartX) / oldZoom;
            this.movementX = this.movementX + currentMovement;
        }
        if (this.movementStartY) {
            currentMovementY = (this.currentPositionY - this.movementStartY) / oldZoom;
            this.movementY = this.movementY + currentMovementY;
        }
        this.movementStartX = undefined;
        this.movementStartY = undefined;
        this.innerGroup.position({
            x: 0,
            y: 0
        });
        this.originalInnerGroup.position({
            x: 0,
            y: 0
        });
        this.innerGroup.scale({
            x: newZoom,
            y: newZoom
        });
        this.originalInnerGroup.scale({
            x: newZoom,
            y: newZoom
        });
        if (newZoom === 1) {
            this.movementX = 0;
            this.movementY = 0;
        }
        const imageMiddle = this.innerGroup.width() * newZoom / 2;
        const stageWidth = this.stage.width() / 2;
        const calculatedxPosUpper = stageWidth - imageMiddle + this.movementX * newZoom;
        const calculatedYPosUpper = (this.stage.width() * this.settings.imageAspectRatio - this.innerGroup.height() * newZoom) / 2 + this.movementY * newZoom;
        this.innerGroup.position({
            x: calculatedxPosUpper > 0 ? 0 : calculatedxPosUpper < this.stage.width() - this.innerGroup.width() * newZoom ? this.stage.width() - this.innerGroup.width() * newZoom : calculatedxPosUpper,
            y: calculatedYPosUpper > 0 ? 0 : calculatedYPosUpper < this.stage.width() * this.settings.imageAspectRatio - this.innerGroup.height() * newZoom ? this.stage.width() * this.settings.imageAspectRatio - this.innerGroup.height() * newZoom : calculatedYPosUpper
        });
        this.originalInnerGroup.position({
            x: calculatedxPosUpper > 0 ? 0 : calculatedxPosUpper < this.stage.width() - this.innerGroup.width() * newZoom ? this.stage.width() - this.innerGroup.width() * newZoom : calculatedxPosUpper,
            y: calculatedYPosUpper > 0 ? 0 : calculatedYPosUpper < this.stage.width() * this.settings.imageAspectRatio - this.innerGroup.height() * newZoom ? this.stage.width() * this.settings.imageAspectRatio - this.innerGroup.height() * newZoom : calculatedYPosUpper
        });
    }
    calculateDistance(x1, y1, x2, y2) {
        // pythagoras x^2 + y^2 = dist^2
        return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
    }
    /* ---------------------------- */ /* ------ ZOOM STUFF END ------ */ /* ---------------------------- */ /* ---------------------------- */ /* --------- WINNING ---------- */ /* ---------------------------- */ checkForWin() {
        if (this.found.reduce((acc, curr)=>acc && curr, true)) this.playWinningAnimation();
    }
    playWinningAnimation() {
        const base = {
            duration: 2,
            easing: (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Easings.EaseInOut
        };
        this.winningImageLayer.to({
            ...base,
            opacity: 1,
            onFinish: this.showResetButton
        });
        if (this.winningImage) {
            this.layer.to({
                ...base,
                opacity: 0
            });
            this.originalImageToCompareLayer.to({
                ...base,
                opacity: 0
            });
        }
    }
    checkForErrorFound(evt) {
        const xCoordinate = evt.target.attrs.x;
        const yCoordinate = evt.target.attrs.y;
        this.settings.winningCoordinatesNew.forEach((coOrd, index)=>{
            const transformedPercentageX = this.stage.width() / 100 * coOrd.x;
            const transfomredPercentageY = this.stage.width() * this.settings.imageAspectRatio / 100 * coOrd.y;
            if (transformedPercentageX === xCoordinate && transfomredPercentageY === yCoordinate) this.found[index] = true;
        });
        this.checkForWin();
    }
    /* ---------------------------- */ /* ------- WINNING END -------- */ /* ---------------------------- */ /* ---------------------------- */ /* ------- EDITOR START ------- */ /* ---------------------------- */ setupEditor = ()=>{
        this.settings.winningCoordinatesNew.forEach((coOrd, index)=>{
            const drawncircle = new (0, $544e715f9e3fd6b8$export$2e2bcd8739ae039).Circle({
                x: this.stage.width() / 100 * coOrd.x,
                y: this.stage.width() * this.settings.imageAspectRatio / 100 * coOrd.y,
                radius: 15,
                fill: "transparent",
                opacity: 1,
                stroke: "#ffa500",
                strokeWidth: 3
            });
            this.layer.add(drawncircle);
            const coOrdInputX = document.createElement("input");
            const coOrdInputY = document.createElement("input");
            coOrdInputX.setAttribute("type", "number");
            coOrdInputY.setAttribute("type", "number");
            coOrdInputX.setAttribute("step", "0.1");
            coOrdInputY.setAttribute("step", "0.1");
            coOrdInputX.setAttribute("value", this.settings.winningCoordinatesNew[index].x);
            coOrdInputY.setAttribute("value", this.settings.winningCoordinatesNew[index].y);
            coOrdInputX.onchange = (evt)=>{
                drawncircle.move({
                    x: Number(evt.target.value) * (this.stage.width() / 100) - this.settings.winningCoordinatesNew[index].x * (this.stage.width() / 100),
                    y: 0
                });
                this.settings.winningCoordinatesNew[index] = {
                    x: Number(evt.target.value),
                    y: this.settings.winningCoordinatesNew[index].y
                };
                this.printSettings();
            };
            coOrdInputY.onchange = (evt)=>{
                drawncircle.move({
                    x: 0,
                    y: Number(evt.target.value) * (this.stage.width() * this.settings.imageAspectRatio / 100) - this.settings.winningCoordinatesNew[index].y * (this.stage.width() * this.settings.imageAspectRatio / 100)
                });
                this.settings.winningCoordinatesNew[index] = {
                    x: this.settings.winningCoordinatesNew[index].x,
                    y: Number(evt.target.value)
                };
                this.printSettings();
            };
            this.appendChild(coOrdInputX);
            this.appendChild(coOrdInputY);
        });
        const editorOutput = document.createElement("pre");
        this.editorOutput = editorOutput;
        this.appendChild(editorOutput);
        this.printSettings();
    };
    printSettings = ()=>{
        this.editorOutput.innerHTML = JSON.stringify(this.settings);
    };
});


// 1x1px transparent gif as placeholder while loading
// Copyright 2010 William Malone (www.williammalone.com)
//
// Licensed under the Apache License, Version 2.0 (the "License")
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/*jslint browser: true */ const $f9c9258f627bb8f4$export$bd0baf43a1454731 = function(canvas, x, y, color) {
    const context = canvas.getContext('2d');
    const pixels = canvas.pixels;
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const outlineImage = canvas.outlineImage;
    var pixelStack = [
        {
            x: x,
            y: y
        }
    ];
    var linearCoords = (y * canvasWidth + x) * 4;
    var startColor = $f9c9258f627bb8f4$var$buildColor(linearCoords, pixels.data);
    if ($f9c9258f627bb8f4$var$isMatchingColor(color, startColor) || $f9c9258f627bb8f4$var$isOutlineColor(startColor)) return;
    while(pixelStack.length > 0){
        var nextPixel = pixelStack.shift();
        var x = nextPixel.x;
        var y = nextPixel.y;
        var linearCoords = (y * canvasWidth + x) * 4;
        while(y-- >= 0 && $f9c9258f627bb8f4$var$isMatchingColor($f9c9258f627bb8f4$var$buildColor(linearCoords, pixels.data), startColor))linearCoords -= canvasWidth * 4;
        linearCoords += canvasWidth * 4;
        y++;
        var reachedLeft = false;
        var reachedRight = false;
        while(y++ < canvasHeight && $f9c9258f627bb8f4$var$isMatchingColor($f9c9258f627bb8f4$var$buildColor(linearCoords, pixels.data), startColor)){
            pixels.data[linearCoords] = color.r;
            pixels.data[linearCoords + 1] = color.g;
            pixels.data[linearCoords + 2] = color.b;
            pixels.data[linearCoords + 3] = color.a;
            if (x > 0) {
                if ($f9c9258f627bb8f4$var$isMatchingColor($f9c9258f627bb8f4$var$buildColor(linearCoords - 4, pixels.data), startColor)) {
                    if (!reachedLeft) {
                        pixelStack.push({
                            x: x - 1,
                            y: y
                        });
                        reachedLeft = true;
                    }
                } else if (reachedLeft) reachedLeft = false;
            }
            if (x < canvasWidth - 1) {
                if ($f9c9258f627bb8f4$var$isMatchingColor($f9c9258f627bb8f4$var$buildColor(linearCoords + 4, pixels.data), startColor)) {
                    if (!reachedRight) {
                        pixelStack.push({
                            x: x + 1,
                            y: y
                        });
                        reachedRight = true;
                    }
                } else if (reachedRight) reachedRight = false;
            }
            linearCoords += canvasWidth * 4;
        }
    }
    context.putImageData(pixels, 0, 0);
    // Redraw outline over pixel array for better smoothness on the edges
    context.drawImage(outlineImage, 0, 0, canvasWidth, canvasHeight);
};
const $f9c9258f627bb8f4$var$isMatchingColor = function(color, startColor) {
    return color.r == startColor.r && color.g == startColor.g && color.b == startColor.b && color.a == startColor.a;
};
const $f9c9258f627bb8f4$var$isOutlineColor = function(color) {
    // Black can't be filled, even if it's transparent.
    return color.r == 0 && color.g == 0 && color.b == 0;
};
const $f9c9258f627bb8f4$var$buildColor = function(linearCoords, pixelData) {
    return {
        r: pixelData[linearCoords],
        g: pixelData[linearCoords + 1],
        b: pixelData[linearCoords + 2],
        a: pixelData[linearCoords + 3]
    };
};
const $f9c9258f627bb8f4$export$2cd8252107eb640b = function(canvas, outlineImage) {
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;
    const context = canvas.getContext("2d");
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvasWidth, canvasHeight);
    context.drawImage(outlineImage, 0, 0, canvasWidth, canvasHeight);
    let pixels;
    // Test for cross origin security error (SECURITY_ERR: DOM Exception 18)
    try {
        pixels = context.getImageData(0, 0, canvasWidth, canvasHeight);
    } catch (ex) {
        window.alert("Application cannot be run locally. Please run on a server.");
        return;
    }
    // Make internal pixels array monochromatic for nicer filling without artifacts
    // at the edges caused by anti-aliasing
    for(var linearCoords = 0; linearCoords < pixels.data.length; linearCoords++){
        if (linearCoords % 4 == 3) continue;
        if (pixels.data[linearCoords] > 75) pixels.data[linearCoords] = 255;
        else pixels.data[linearCoords] = 0;
    }
    canvas.pixels = pixels;
    canvas.outlineImage = outlineImage;
};



const $3f030a9ebb818217$var$invisibleImage = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
const $3f030a9ebb818217$var$gestureHandlingText = {
    touch: "Verschieben der Grafik mit zwei Fingern",
    scroll: "Verwende Strg+Scrollen zum Zoomen der Grafik",
    scrollMac: "Verwende \u2318+Scrollen zum Zoomen der Grafik"
};
/* This params can all be overriden via the params parameter from Elm or via a 
`config`-Object encoded as JSON-string (as used by the `tangram` content type).
This constant is also used as documentation so please make sure there is a default set for
every possible option.
*/ const $3f030a9ebb818217$var$defaultParams = {
    // The width and height of the canvas. With a bigger canvas there are less artifacts,
    // but the floodfill needs more time. Choose a good middle ground.
    canvasWidth: 1334,
    canvasHeight: 1084,
    // Url to the image of the outline.
    outlineImageUrl: "/windowcolor/schleswig.svg",
    // This coords will be flood filled with a transparent black. Those areas will look as 
    // all the others ,but won't be fillable by the user.
    // Defaults to the top-left and top-right corner of the canvas.
    unfillableCoords: null
};
window.customElements.define("window-color", class WindowColor extends HTMLElement {
    connectedCallback() {
        let config = {};
        if (this.config) try {
            config = JSON.parse(this.config);
        } catch (e) {
            // This can only be a syntax error. Print it to the console, but don't fail.
            console.error(e);
        }
        this.settings = {
            ...$3f030a9ebb818217$var$defaultParams,
            ...config,
            ...this.params
        };
        if (!this.settings.unfillableCoords) this.settings.unfillableCoords = [
            [
                0,
                0
            ],
            [
                this.settings.canvasWidth - 1,
                0
            ]
        ];
        const { canvasWidth: canvasWidth, canvasHeight: canvasHeight } = this.settings;
        const imageBounds = [
            [
                0,
                0
            ],
            [
                canvasHeight,
                canvasWidth
            ]
        ];
        // create invisible canvas for the drawing 
        const canvas = document.createElement('canvas');
        canvas.setAttribute('width', canvasWidth);
        canvas.setAttribute('height', canvasHeight);
        // create leaflet-container and init it
        const leafletEl = document.createElement('div');
        this.appendChild(leafletEl);
        this._leafletEl = leafletEl;
        const leaflet = L.map(leafletEl, {
            crs: L.CRS.Simple,
            minZoom: -5,
            zoomControl: false,
            gestureHandling: true,
            gestureHandlingText: $3f030a9ebb818217$var$gestureHandlingText,
            doubleClickZoom: false,
            attributionControl: false
        });
        this._leaflet = leaflet;
        const imageOverlay = L.imageOverlay($3f030a9ebb818217$var$invisibleImage, imageBounds).addTo(leaflet);
        L.control.zoom({
            position: "topright"
        }).addTo(leaflet);
        // setup initial view
        leaflet.fitBounds(imageBounds);
        leaflet.panTo([
            -10000,
            canvasWidth / 2
        ]);
        // max outer bounds stuff
        this.calculateOuterBounds(leaflet, imageOverlay);
        leaflet.setMaxBounds(this.outerBounds);
        this._onResize = ()=>{
            this.calculateOuterBounds(leaflet, imageOverlay);
            leaflet.setMaxBounds(this.outerBounds);
        };
        window.addEventListener("resize", this._onResize);
        leaflet.on("zoomend", ()=>{
            this.calculateOuterBounds(leaflet, imageOverlay);
            leaflet.setMaxBounds(this.outerBounds);
        });
        leaflet.on("drag", ()=>{
            leaflet.panInsideBounds(this.outerBounds, {
                animate: false
            });
        });
        // add event handler for flood filling to leaflet
        leaflet.on("click", (e)=>{
            // ignore clicks until the outline image is loaded and its pixels are available
            if (!canvas.pixels) return;
            const latlon = leaflet.mouseEventToLatLng(e.originalEvent);
            const canvasX = Math.floor(latlon.lng);
            // latitude is the reverse of y-coordinate
            const canvasY = canvasHeight - 1 - Math.floor(latlon.lat);
            // clicks can be outside of canvas where filling is not possible
            if (canvasX >= 0 && canvasX < canvasWidth && canvasY >= 0 && canvasY < canvasHeight) {
                let color = $3f030a9ebb818217$var$hexToRgba(this.dataset.color);
                $f9c9258f627bb8f4$export$bd0baf43a1454731(canvas, canvasX, canvasY, color);
                imageOverlay.setUrl(canvas.toDataURL("image/png"));
            }
        });
        // load the outline image and draw the first canvas
        const outlineImage = new Image();
        outlineImage.onload = ()=>{
            $f9c9258f627bb8f4$export$2cd8252107eb640b(canvas, outlineImage);
            if (!canvas.pixels) return;
            // init unfillable places with a transparent black
            this.settings.unfillableCoords.forEach(([x, y])=>{
                $f9c9258f627bb8f4$export$bd0baf43a1454731(canvas, x, y, {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0
                });
            });
            imageOverlay.setUrl(canvas.toDataURL("image/png"));
        };
        outlineImage.src = this.settings.outlineImageUrl;
        // add the button for downloading the image
        const downloadButton = document.createElement('button');
        downloadButton.setAttribute('class', 'btn btn-primary m-2');
        downloadButton.innerText = "Bild speichern";
        downloadButton.addEventListener('click', ()=>{
            // export image from canvas
            const url = canvas.toDataURL("image/png");
            const image = new Image();
            image.src = url;
            // trigger download
            const a = document.createElement("a");
            a.download = "Ihr pers\xf6nliches Kirchenfenster.png";
            a.href = url.replace("image/png", "image/octet-stream");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        });
        this.appendChild(downloadButton);
        this._downloadButton = downloadButton;
    }
    disconnectedCallback() {
        window.removeEventListener("resize", this._onResize);
        (0, $892d7dc6dbc410a5$export$179ddc2cadda5c47)(this._leaflet);
        if (this._leafletEl) this._leafletEl.remove();
        if (this._downloadButton) this._downloadButton.remove();
        this._onResize = this._leaflet = this._leafletEl = this._downloadButton = null;
    }
    /* this function calculates the outer bounds for leaflet
           so that the image is not centered, but can be moved around freely.
           The bounds are in coordinates and not in pixels. This makes the 
           calculation more complicated and has to be recalculated on every 
           zoom change and browser resize
        */ calculateOuterBounds(leaflet, imageOverlay) {
        const leafletWidth = leaflet.getContainer().clientWidth;
        const leafletHeight = leaflet.getContainer().clientHeight;
        const imageWidth = imageOverlay.getElement().width;
        const imageHeight = imageOverlay.getElement().height;
        const { canvasWidth: canvasWidth, canvasHeight: canvasHeight } = this.settings;
        let minWidth;
        let maxWidth = canvasWidth;
        let minHeight;
        let maxHeight = canvasHeight;
        if (imageWidth > leafletWidth) {
            minWidth = 0;
            maxWidth = canvasWidth;
        } else {
            minWidth = (imageWidth - leafletWidth) * canvasWidth / imageWidth;
            maxWidth = leafletWidth * canvasWidth / imageWidth;
        }
        if (imageHeight > leafletHeight) {
            minHeight = 0;
            maxHeight = canvasHeight;
        } else {
            minHeight = (imageHeight - leafletHeight) * canvasHeight / imageHeight;
            maxHeight = leafletHeight * canvasHeight / imageHeight;
        }
        this.outerBounds = [
            [
                minHeight,
                minWidth
            ],
            [
                maxHeight,
                maxWidth
            ]
        ];
    }
});
// hexToRgba © https://stackoverflow.com/users/80860/kennebec
const $3f030a9ebb818217$var$hexToRgba = function(hex) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        let c = hex.substring(1).split('');
        if (c.length == 3) c = [
            c[0],
            c[0],
            c[1],
            c[1],
            c[2],
            c[2]
        ];
        c = '0x' + c.join('');
        return {
            r: c >> 16 & 255,
            g: c >> 8 & 255,
            b: c & 255,
            a: 255
        };
    }
    throw new Error('Bad Hex');
};


var $0a41755690877963$var$DragDropTouch;
(function(DragDropTouch_1) {
    'use strict';
    /**
     * Object used to hold the data that is being dragged during drag and drop operations.
     *
     * It may hold one or more data items of different types. For more information about
     * drag and drop operations and data transfer objects, see
     * <a href="https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer">HTML Drag and Drop API</a>.
     *
     * This object is created automatically by the @see:DragDropTouch singleton and is
     * accessible through the @see:dataTransfer property of all drag events.
     */ var DataTransfer = function() {
        function DataTransfer() {
            this._dropEffect = 'move';
            this._effectAllowed = 'all';
            this._data = {};
        }
        Object.defineProperty(DataTransfer.prototype, 'dropEffect', {
            /**
             * Gets or sets the type of drag-and-drop operation currently selected.
             * The value must be 'none',  'copy',  'link', or 'move'.
             */ get: function() {
                return this._dropEffect;
            },
            set: function(value) {
                this._dropEffect = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DataTransfer.prototype, 'effectAllowed', {
            /**
             * Gets or sets the types of operations that are possible.
             * Must be one of 'none', 'copy', 'copyLink', 'copyMove', 'link',
             * 'linkMove', 'move', 'all' or 'uninitialized'.
             */ get: function() {
                return this._effectAllowed;
            },
            set: function(value) {
                this._effectAllowed = value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DataTransfer.prototype, 'types', {
            /**
             * Gets an array of strings giving the formats that were set in the @see:dragstart event.
             */ get: function() {
                return Object.keys(this._data);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Removes the data associated with a given type.
         *
         * The type argument is optional. If the type is empty or not specified, the data
         * associated with all types is removed. If data for the specified type does not exist,
         * or the data transfer contains no data, this method will have no effect.
         *
         * @param type Type of data to remove.
         */ DataTransfer.prototype.clearData = function(type) {
            if (type != null) delete this._data[type];
            else this._data = null;
        };
        /**
         * Retrieves the data for a given type, or an empty string if data for that type does
         * not exist or the data transfer contains no data.
         *
         * @param type Type of data to retrieve.
         */ DataTransfer.prototype.getData = function(type) {
            return this._data[type] || '';
        };
        /**
         * Set the data for a given type.
         *
         * For a list of recommended drag types, please see
         * https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Recommended_Drag_Types.
         *
         * @param type Type of data to add.
         * @param value Data to add.
         */ DataTransfer.prototype.setData = function(type, value) {
            this._data[type] = value;
        };
        /**
         * Set the image to be used for dragging if a custom one is desired.
         *
         * @param img An image element to use as the drag feedback image.
         * @param offsetX The horizontal offset within the image.
         * @param offsetY The vertical offset within the image.
         */ DataTransfer.prototype.setDragImage = function(img, offsetX, offsetY) {
            var ddt = DragDropTouch._instance;
            ddt._imgCustom = img;
            ddt._imgOffset = {
                x: offsetX,
                y: offsetY
            };
        };
        return DataTransfer;
    }();
    DragDropTouch_1.DataTransfer = DataTransfer;
    /**
     * Defines a class that adds support for touch-based HTML5 drag/drop operations.
     *
     * The @see:DragDropTouch class listens to touch events and raises the
     * appropriate HTML5 drag/drop events as if the events had been caused
     * by mouse actions.
     *
     * The purpose of this class is to enable using existing, standard HTML5
     * drag/drop code on mobile devices running IOS or Android.
     *
     * To use, include the DragDropTouch.js file on the page. The class will
     * automatically start monitoring touch events and will raise the HTML5
     * drag drop events (dragstart, dragenter, dragleave, drop, dragend) which
     * should be handled by the application.
     *
     * For details and examples on HTML drag and drop, see
     * https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Drag_operations.
     */ var DragDropTouch = function() {
        /**
         * Initializes the single instance of the @see:DragDropTouch class.
         */ function DragDropTouch() {
            this._lastClick = 0;
            // enforce singleton pattern
            if (DragDropTouch._instance) throw 'DragDropTouch instance already created.';
            // detect passive event support
            // https://github.com/Modernizr/Modernizr/issues/1894
            var supportsPassive = false;
            document.addEventListener('test', function() {}, {
                get passive () {
                    supportsPassive = true;
                    return true;
                }
            });
            // listen to touch events
            if ('ontouchstart' in document) {
                var d = document, ts = this._touchstart.bind(this), tm = this._touchmove.bind(this), te = this._touchend.bind(this), opt = supportsPassive ? {
                    passive: false,
                    capture: false
                } : false;
                d.addEventListener('touchstart', ts, opt);
                d.addEventListener('touchmove', tm, opt);
                d.addEventListener('touchend', te);
                d.addEventListener('touchcancel', te);
            }
        }
        /**
         * Gets a reference to the @see:DragDropTouch singleton.
         */ DragDropTouch.getInstance = function() {
            return DragDropTouch._instance;
        };
        // ** event handlers
        DragDropTouch.prototype._touchstart = function(e) {
            var _this = this;
            if (this._shouldHandle(e)) {
                // raise double-click and prevent zooming
                if (Date.now() - this._lastClick < DragDropTouch._DBLCLICK) {
                    if (this._dispatchEvent(e, 'dblclick', e.target)) {
                        if (e.cancelable) e.preventDefault();
                        this._reset();
                        return;
                    }
                }
                // clear all variables
                this._reset();
                // get nearest draggable element
                var src = this._closestDraggable(e.target);
                if (src) // give caller a chance to handle the hover/move events
                {
                    if (!this._dispatchEvent(e, 'mousemove', e.target) && !this._dispatchEvent(e, 'mousedown', e.target)) {
                        // get ready to start dragging
                        this._dragSource = src;
                        this._ptDown = this._getPoint(e);
                        this._lastTouch = e;
                        if (e.cancelable) e.preventDefault();
                        // show context menu if the user hasn't started dragging after a while
                        setTimeout(function() {
                            if (_this._dragSource == src && _this._img == null) {
                                if (_this._dispatchEvent(e, 'contextmenu', src)) _this._reset();
                            }
                        }, DragDropTouch._CTXMENU);
                        if (DragDropTouch._ISPRESSHOLDMODE) this._pressHoldInterval = setTimeout(function() {
                            _this._isDragEnabled = true;
                            _this._touchmove(e);
                        }, DragDropTouch._PRESSHOLDAWAIT);
                    }
                }
            }
        };
        DragDropTouch.prototype._touchmove = function(e) {
            if (this._shouldCancelPressHoldMove(e)) {
                this._reset();
                return;
            }
            if (this._shouldHandleMove(e) || this._shouldHandlePressHoldMove(e)) {
                // see if target wants to handle move
                var target = this._getTarget(e);
                if (this._dispatchEvent(e, 'mousemove', target)) {
                    this._lastTouch = e;
                    if (e.cancelable) e.preventDefault();
                    return;
                }
                // start dragging
                if (this._dragSource && !this._img && this._shouldStartDragging(e)) {
                    this._dispatchEvent(e, 'dragstart', this._dragSource);
                    this._createImage(e);
                    this._dispatchEvent(e, 'dragenter', target);
                }
                // continue dragging
                if (this._img) {
                    this._lastTouch = e;
                    if (e.cancelable) e.preventDefault(); // prevent scrolling
                    if (target != this._lastTarget) {
                        this._dispatchEvent(this._lastTouch, 'dragleave', this._lastTarget);
                        this._dispatchEvent(e, 'dragenter', target);
                        this._lastTarget = target;
                    }
                    this._moveImage(e);
                    this._isDropZone = this._dispatchEvent(e, 'dragover', target);
                }
            }
        };
        DragDropTouch.prototype._touchend = function(e) {
            if (this._shouldHandle(e)) {
                // see if target wants to handle up
                if (this._dispatchEvent(this._lastTouch, 'mouseup', e.target)) {
                    if (e.cancelable) e.preventDefault();
                    return;
                }
                // user clicked the element but didn't drag, so clear the source and simulate a click
                if (!this._img) {
                    this._dragSource = null;
                    this._dispatchEvent(this._lastTouch, 'click', e.target);
                    this._lastClick = Date.now();
                }
                // finish dragging
                this._destroyImage();
                if (this._dragSource) {
                    if (e.type.indexOf('cancel') < 0 && this._isDropZone) this._dispatchEvent(this._lastTouch, 'drop', this._lastTarget);
                    this._dispatchEvent(this._lastTouch, 'dragend', this._dragSource);
                    this._reset();
                }
            }
        };
        // ** utilities
        // ignore events that have been handled or that involve more than one touch
        DragDropTouch.prototype._shouldHandle = function(e) {
            return e && !e.defaultPrevented && e.touches && e.touches.length < 2;
        };
        // use regular condition outside of press & hold mode
        DragDropTouch.prototype._shouldHandleMove = function(e) {
            return !DragDropTouch._ISPRESSHOLDMODE && this._shouldHandle(e);
        };
        // allow to handle moves that involve many touches for press & hold
        DragDropTouch.prototype._shouldHandlePressHoldMove = function(e) {
            return DragDropTouch._ISPRESSHOLDMODE && this._isDragEnabled && e && e.touches && e.touches.length;
        };
        // reset data if user drags without pressing & holding
        DragDropTouch.prototype._shouldCancelPressHoldMove = function(e) {
            return DragDropTouch._ISPRESSHOLDMODE && !this._isDragEnabled && this._getDelta(e) > DragDropTouch._PRESSHOLDMARGIN;
        };
        // start dragging when specified delta is detected
        DragDropTouch.prototype._shouldStartDragging = function(e) {
            var delta = this._getDelta(e);
            return delta > DragDropTouch._THRESHOLD || DragDropTouch._ISPRESSHOLDMODE && delta >= DragDropTouch._PRESSHOLDTHRESHOLD;
        };
        // clear all members
        DragDropTouch.prototype._reset = function() {
            this._destroyImage();
            this._dragSource = null;
            this._lastTouch = null;
            this._lastTarget = null;
            this._ptDown = null;
            this._isDragEnabled = false;
            this._isDropZone = false;
            this._dataTransfer = new DataTransfer();
            clearInterval(this._pressHoldInterval);
        };
        // get point for a touch event
        DragDropTouch.prototype._getPoint = function(e, page) {
            if (e && e.touches) e = e.touches[0];
            return {
                x: page ? e.pageX : e.clientX,
                y: page ? e.pageY : e.clientY
            };
        };
        // get distance between the current touch event and the first one
        DragDropTouch.prototype._getDelta = function(e) {
            if (DragDropTouch._ISPRESSHOLDMODE && !this._ptDown) return 0;
            var p = this._getPoint(e);
            return Math.abs(p.x - this._ptDown.x) + Math.abs(p.y - this._ptDown.y);
        };
        // get the element at a given touch event
        DragDropTouch.prototype._getTarget = function(e) {
            var pt = this._getPoint(e), el = document.elementFromPoint(pt.x, pt.y);
            while(el && getComputedStyle(el).pointerEvents == 'none')el = el.parentElement;
            return el;
        };
        // create drag image from source element
        DragDropTouch.prototype._createImage = function(e) {
            // just in case...
            if (this._img) this._destroyImage();
            // create drag image from custom element or drag source
            var src = this._imgCustom || this._dragSource;
            this._img = src.cloneNode(true);
            this._copyStyle(src, this._img);
            this._img.style.top = this._img.style.left = '-9999px';
            // if creating from drag source, apply offset and opacity
            if (!this._imgCustom) {
                var rc = src.getBoundingClientRect(), pt = this._getPoint(e);
                this._imgOffset = {
                    x: pt.x - rc.left,
                    y: pt.y - rc.top
                };
                this._img.style.opacity = DragDropTouch._OPACITY.toString();
            }
            // add image to document
            this._moveImage(e);
            document.body.appendChild(this._img);
        };
        // dispose of drag image element
        DragDropTouch.prototype._destroyImage = function() {
            if (this._img && this._img.parentElement) this._img.parentElement.removeChild(this._img);
            this._img = null;
            this._imgCustom = null;
        };
        // move the drag image element
        DragDropTouch.prototype._moveImage = function(e) {
            var _this = this;
            requestAnimationFrame(function() {
                if (_this._img) {
                    var pt = _this._getPoint(e, true), s = _this._img.style;
                    s.position = 'absolute';
                    s.pointerEvents = 'none';
                    s.zIndex = '999999';
                    s.left = Math.round(pt.x - _this._imgOffset.x) + 'px';
                    s.top = Math.round(pt.y - _this._imgOffset.y) + 'px';
                }
            });
        };
        // copy properties from an object to another
        DragDropTouch.prototype._copyProps = function(dst, src, props) {
            for(var i = 0; i < props.length; i++){
                var p = props[i];
                dst[p] = src[p];
            }
        };
        DragDropTouch.prototype._copyStyle = function(src, dst) {
            // remove potentially troublesome attributes
            DragDropTouch._rmvAtts.forEach(function(att) {
                dst.removeAttribute(att);
            });
            // copy canvas content
            if (src instanceof HTMLCanvasElement) {
                var cSrc = src, cDst = dst;
                cDst.width = cSrc.width;
                cDst.height = cSrc.height;
                cDst.getContext('2d').drawImage(cSrc, 0, 0);
            }
            // copy style (without transitions)
            var cs = getComputedStyle(src);
            for(var i = 0; i < cs.length; i++){
                var key = cs[i];
                if (key.indexOf('transition') < 0) dst.style[key] = cs[key];
            }
            dst.style.pointerEvents = 'none';
            // and repeat for all children
            for(var i = 0; i < src.children.length; i++)this._copyStyle(src.children[i], dst.children[i]);
        };
        DragDropTouch.prototype._dispatchEvent = function(e, type, target) {
            if (e && target) {
                var evt = document.createEvent('Event'), t = e.touches ? e.touches[0] : e;
                evt.initEvent(type, true, true);
                evt.button = 0;
                evt.which = evt.buttons = 1;
                this._copyProps(evt, e, DragDropTouch._kbdProps);
                this._copyProps(evt, t, DragDropTouch._ptProps);
                evt.dataTransfer = this._dataTransfer;
                target.dispatchEvent(evt);
                return evt.defaultPrevented;
            }
            return false;
        };
        // gets an element's closest draggable ancestor
        DragDropTouch.prototype._closestDraggable = function(e) {
            for(; e; e = e.parentElement){
                if (e.hasAttribute('draggable') && e.draggable) return e;
            }
            return null;
        };
        return DragDropTouch;
    }();
    /*private*/ DragDropTouch._instance = new DragDropTouch(); // singleton
    // constants
    DragDropTouch._THRESHOLD = 5; // pixels to move before drag starts
    DragDropTouch._OPACITY = 0.5; // drag image opacity
    DragDropTouch._DBLCLICK = 500; // max ms between clicks in a double click
    DragDropTouch._CTXMENU = 900; // ms to hold before raising 'contextmenu' event
    DragDropTouch._ISPRESSHOLDMODE = false; // decides of press & hold mode presence
    DragDropTouch._PRESSHOLDAWAIT = 400; // ms to wait before press & hold is detected
    DragDropTouch._PRESSHOLDMARGIN = 25; // pixels that finger might shiver while pressing
    DragDropTouch._PRESSHOLDTHRESHOLD = 0; // pixels to move before drag starts
    // copy styles/attributes from drag source to drag image element
    DragDropTouch._rmvAtts = 'id,class,style,draggable'.split(',');
    // synthesize and dispatch an event
    // returns true if the event has been handled (e.preventDefault == true)
    DragDropTouch._kbdProps = 'altKey,ctrlKey,metaKey,shiftKey'.split(',');
    DragDropTouch._ptProps = 'pageX,pageY,clientX,clientY,screenX,screenY'.split(',');
    DragDropTouch_1.DragDropTouch = DragDropTouch;
})($0a41755690877963$var$DragDropTouch || ($0a41755690877963$var$DragDropTouch = {}));


if ($2575132a0d1b937c$export$8590d4ef0e2ee08a()) $a178acb730566997$export$234c45b355edd85b();
var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root"),
    flags: {
        showConsentBanner: $2575132a0d1b937c$export$f4d3dcfc47dd8e3a(),
        startTime: Date.now()
    }
});
document._app = $35da740d59af89ba$var$app;
$35da740d59af89ba$var$app.ports.renderAltar.subscribe((params)=>{
    requestAnimationFrame(()=>$2b6dd1db8e0472e6$export$33ddfbd0d1c07730(params));
});
$35da740d59af89ba$var$app.ports.renderTripleAltar.subscribe((params)=>{
    requestAnimationFrame(()=>$2b6dd1db8e0472e6$export$87b743d6f3254408(params));
});
$35da740d59af89ba$var$app.ports.controlAudioPlayer.subscribe((command)=>{
    requestAnimationFrame(()=>{
        // Commands: load, pause, prev, next
        let player = document.getElementById("audio-player");
        let shouldPlay = false;
        if (player) {
            // calculate shouldPlay before changing the player state
            switch(command){
                case "next":
                    shouldPlay = !player.paused || player.ended;
                    break;
                case "prev":
                    shouldPlay = !player.paused;
                    break;
            }
            player.pause();
            switch(command){
                case "load":
                case "next":
                case "prev":
                    requestAnimationFrame(()=>{
                        player.load();
                        if (shouldPlay) player.play();
                    });
                    break;
            }
        }
    });
});
$35da740d59af89ba$var$app.ports.refreshView.subscribe(()=>{
    window.scrollBy(1, 1);
    window.scrollBy(-1, -1);
});
$35da740d59af89ba$var$app.ports.saveConsent.subscribe((params)=>{
    $2575132a0d1b937c$export$24a32d9eaac5e08d(params);
});
$35da740d59af89ba$var$app.ports.reconfigureConsent.subscribe(()=>{
    $2575132a0d1b937c$export$bfd7cc394b894e30();
});
$35da740d59af89ba$var$app.ports.trackPageView.subscribe(()=>{
    $a178acb730566997$export$92ab14d0aa42e41e();
});
$35da740d59af89ba$var$app.ports.trackEvent.subscribe((params)=>{
    $a178acb730566997$export$73d0a139caca1fee(params);
});
$35da740d59af89ba$var$app.ports.renderGalleryGame.subscribe((params)=>{
    $d52aae875779adc4$export$b3890eb0ae9dca99(params);
});
$35da740d59af89ba$var$app.ports.renderTowerGame.subscribe((params)=>{
    $c4728770149235fa$export$b3890eb0ae9dca99(params);
});
$35da740d59af89ba$var$app.ports.openNavigation.subscribe((coords)=>{
    if (navigator.platform.indexOf("iPhone") != -1 || navigator.platform.indexOf("iPad") != -1 || navigator.platform.indexOf("iPod") != -1) /* the important part seems to be maps:// - not the google part */ window.open("maps://maps.google.com/maps?daddr=" + coords.latitude + "," + coords.longitude + "&ampll=");
    else /* else use Google */ window.open("https://maps.google.com/maps?daddr=" + coords.latitude + "," + coords.longitude + "&ampll=");
});
$35da740d59af89ba$var$app.ports.reload.subscribe(()=>{
    // This event is triggered after the window.history.back() has finished processing
    addEventListener('popstate', ()=>{
        window.location.reload();
    });
    // This is async, so we need to use a callback
    window.history.back();
});
$35da740d59af89ba$var$app.ports.back.subscribe(()=>{
    history.back();
});
window.addEventListener('popstate', ()=>{
    $35da740d59af89ba$var$app.ports.gotPopstatePosition.send(window.scrollY);
});
// sets vh-variable because the default vh doesn't count in collapsible browser bars
function $35da740d59af89ba$var$setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
}
window.addEventListener('resize', $35da740d59af89ba$var$setVh);
window.addEventListener('orientationchange', $35da740d59af89ba$var$setVh);
$35da740d59af89ba$var$setVh();
if ('serviceWorker' in navigator) navigator.serviceWorker.register(new URL('serviceWorker.js', location.origin));


//# sourceMappingURL=app.ac97a42f.js.map
